angular.module("cesium.translations", []).config(["$translateProvider", function($translateProvider) {
$translateProvider.translations("ca", {
  "COMMON": {
    "APP_NAME": "Cesium",
    "APP_VERSION": "v{{version}}",
    "APP_BUILD": "data: {{build}}",
    "PUBKEY": "Clau pública",
    "MEMBER": "Membre",
    "BLOCK": "Bloc",
    "BTN_OK": "OK",
    "BTN_YES": "Sí",
    "BTN_NO": "No",
    "BTN_SEND": "Envia",
    "BTN_SEND_MONEY": "Fes un pagament",
    "BTN_SEND_MONEY_SHORT": "Pagament",
    "BTN_SAVE": "Guarda",
    "BTN_YES_SAVE": "Sí, guarda",
    "BTN_YES_CONTINUE": "Sí, continua",
    "BTN_SHOW": "Mostra",
    "BTN_SHOW_PUBKEY": "Mostra la clau",
    "BTN_RELATIVE_UNIT": "Mostra els imports en DU",
    "BTN_BACK": "Anterior",
    "BTN_NEXT": "Següent",
    "BTN_IMPORT": "Importa",
    "BTN_CANCEL": "Cancel·la",
    "BTN_CLOSE": "Tanca",
    "BTN_LATER": "Després",
    "BTN_LOGIN": "Connecta't",
    "BTN_LOGOUT": "Desconnecta't",
    "BTN_ADD_ACCOUNT": "Nou compte",
    "BTN_SHARE": "Comparteix",
    "BTN_EDIT": "Modifica",
    "BTN_DELETE": "Suprimeix",
    "BTN_ADD": "Afegeix",
    "BTN_SEARCH": "Busca",
    "BTN_REFRESH": "Actualitza",
    "BTN_RETRY": "Torna-ho a provar",
    "BTN_START": "Comença",
    "BTN_CONTINUE": "Continua",
    "BTN_CREATE": "Crea",
    "BTN_UNDERSTOOD": "Entesos",
    "BTN_OPTIONS": "Opcions",
    "BTN_HELP_TOUR": "Visita guiada",
    "BTN_HELP_TOUR_SCREEN": "Explica'm aquesta pantalla",
    "BTN_DOWNLOAD": "Descarrega",
    "BTN_DOWNLOAD_ACCOUNT_STATEMENT": "Descarrega l'historial del compte",
    "BTN_MODIFY": "Modifica",
    "CHOOSE_FILE": "Arrossegui el fitxer<br/>o cliqui per seleccionar-lo",
    "DAYS": "Dies",
    "NO_ACCOUNT_QUESTION": "Encara no ets membre? Fes-te un compte!",
    "SEARCH_NO_RESULT": "No s'ha trobat res",
    "LOADING": "Esperi si us plau...",
    "LOADING_WAIT": "Esperi si us plau...<br/><small>(Cesium està interrogant el node Duniter)</small>",
    "SEARCHING": "Cerca en procés...",
    "FROM": "De",
    "TO": "A",
    "COPY": "Còpia",
    "LANGUAGE": "Idioma",
    "UNIVERSAL_DIVIDEND": "Dividend universal",
    "UD": "DU",
    "DATE_PATTERN": "DD/MM/YYYY HH:mm",
    "DATE_FILE_PATTERN": "YYYY-MM-DD",
    "DATE_SHORT_PATTERN": "DD/MM/YY",
    "DATE_MONTH_YEAR_PATTERN": "MM/YYYY",
    "EMPTY_PARENTHESIS": "(buit)",
    "UID": "Renom",
    "ENABLE": "Activat",
    "DISABLE": "Desactivat",
    "RESULTS_LIST": "Resultats:",
    "RESULTS_COUNT": "{{count}} resultats",
    "EXECUTION_TIME": "executat en {{duration|formatDurationMs}}",
    "SHOW_VALUES": "Mostra la contrasenya",
    "POPOVER_ACTIONS_TITLE": "Opcions",
    "POPOVER_FILTER_TITLE": "Filtres",
    "SHOW_MORE": "Mostra'n més",
    "SHOW_MORE_COUNT": "(límit actual {{limit}})",
    "POPOVER_SHARE": {
      "TITLE": "Compartir",
      "SHARE_ON_TWITTER": "Compartir a Twitter",
      "SHARE_ON_FACEBOOK": "Compartir a Facebook",
      "SHARE_ON_DIASPORA": "Compartir a Diaspora*",
      "SHARE_ON_GOOGLEPLUS": "Compartir a Google+"
    },
    "FILE": {
      "DATE" : "Data:",
      "TYPE" : "Tipus:",
      "SIZE": "Mida:",
      "VALIDATING": "Validant..."
    }
  },
  "SYSTEM": {
    "PICTURE_CHOOSE_TYPE": "Trieu la font:",
    "BTN_PICTURE_GALLERY": "Galeria",
    "BTN_PICTURE_CAMERA": "<b>Càmera</b>"
  },
  "MENU": {
    "HOME": "Inici",
    "WOT": "Directori",
    "CURRENCY": "Moneda",
    "ACCOUNT": "Compte",
    "WALLETS": "Moneders",
    "SETTINGS": "Ajustos",
    "NETWORK": "Xarxa",
    "TRANSACTIONS": "Moviments"
  },
  "ABOUT": {
    "BTN_OPEN_DEV_WINDOW": "Obrir la finestra de depuració",
    "TITLE": "A propòsit de",
    "LICENSE": "Programari <b>llliure</b> (llicència GNU AGPLv3).",
    "LATEST_RELEASE": "Hi ha una <b>versió més nova</b> de {{'COMMON.APP_NAME' | translate}} (<b>v{{version}}</b>)",
    "PLEASE_UPDATE": "Si us plau, actualitzeu {{'COMMON.APP_NAME' | translate}} (última versió: <b>v{{version}}</b>)",
    "CODE": "Codi font:",
    "OFFICIAL_WEB_SITE": "Web oficial:",
    "DEVELOPERS": "Desenvolupat per:",
    "FORUM": "Fòrum:",
    "PLEASE_REPORT_ISSUE": "Si trobeu errors no us ho penseu i informeu-nos",
    "REPORT_ISSUE": "Informa d'un problema"
  },
  "HOME": {
    "FEED_SOURCE": "Font",
    "READ_MORE": "Amplia",
    "SHOW_ALL_FEED": "Mostra-m'ho tot",
    "TITLE": "Cesium",
    "WELCOME": "Benvingut/da a l'aplicació Cesium!",
    "MESSAGE": "Rebeu i envieu moneda lliure {{currency|abbreviate}} fàcilment",
    "BTN_CURRENCY": "Sobre la moneda",
    "BTN_ABOUT": "A propòsit",
    "BTN_HELP": "Ajuda",
    "REPORT_ISSUE": "Informar d'un error",
    "NOT_YOUR_ACCOUNT_QUESTION": "Aquest no és el seu compte <b><i class=\"ion-key\"></i> {{pubkey|formatPubkey}}</b>?",
    "BTN_CHANGE_ACCOUNT": "Desconnecta aquest compte",
    "PEER_CONNECTION_ERROR": "Node <b>{{server}}</b> inabastable o adreça invàlida.<br/><br/>Comprobeu la vostra connexió a Internet, o node Duniter <a class=\"positive\" ng-click=\"doQuickFix('settings')\">a la configuració</a>.",
    "NETWORK_CONNECTION_ERROR": "La xarxa és inaccesible.<br/><br/>Comprova la teva connexió a Internet, o selecciona un node manualment <a class=\"positive\" ng-click=\"doQuickFix('settings')\">a la configuració</a>."
  },
  "SETTINGS": {
    "TITLE": "Configuració",
    "DISPLAY_DIVIDER": "Visualització",
    "STORAGE_DIVIDER": "Emmagatzemament",
    "NETWORK_SETTINGS": "Xarxa",
    "PEER": "Node Duniter",
    "PEER_CHANGED_TEMPORARY": "Adreça usada temporalment",
    "PEER_SELECTED_AUTOMATICALLY": "Node seleccionat automàticament a l'inici",
    "NETWORK_ANALYZE_TIMEOUT": "Temps d'espera màxim (temps d'espera)",
    "NETWORK_ANALYZE_TIMEOUT_HELP": "Temps d'espera màxim per a l'anàlisi de la xarxa",
    "NETWORK_ANALYZE_TIMEOUT_AUTO": "Auto",
    "PERSIST_CACHE": "Conserva les dades de navegació (experimental)",
    "PERSIST_CACHE_HELP": "Permet una navegació més ràpida, conservant localment les dades rebudes, per reutilitzar d'una sesió a una altra.",
    "USE_LOCAL_STORAGE": "Activa l'emmagatzemament local",
    "USE_LOCAL_STORAGE_HELP": "Permetre conservar els teus ajustos",
    "WALLETS_SETTINGS": "Els meus moneders",
    "USE_WALLETS_ENCRYPTION": "Xifrar el llistat",
    "USE_WALLETS_ENCRYPTION_HELP": "Permete protegir la llista dels teus moneders (mitjançant xifrat), exigint una autenticació per accedir-hi.",
    "ENABLE_HELPTIP": "Activa l'ajuda contextual",
    "ENABLE_UI_EFFECTS": "Activa els efectes visuals",
    "HISTORY_SETTINGS": "Transaccions del compte",
    "DISPLAY_UD_HISTORY": "Mostra els DU creats",
    "TX_HISTORY_AUTO_REFRESH": "Activa l'actualització automàtica",
    "TX_HISTORY_AUTO_REFRESH_HELP": "Actualitza el saldo i les transaccions automàticament, amb cada bloc nou.",
    "AUTHENTICATION_SETTINGS": "Autenticació",
    "KEEP_AUTH": "Caducitat de l'autenticació",
    "KEEP_AUTH_SHORT": "Caducitat",
    "KEEP_AUTH_HELP": "Defineix quan expira la teva sessió",
    "KEEP_AUTH_OPTION": {
      "NEVER": "Després de cada operació",
      "SECONDS": "Després de {{value}} segons d'inactivitat",
      "MINUTE": "Després de {{value}}mins d'inactivitat",
      "MINUTES": "Després de {{value}}mins d'inactivitat",
      "HOUR": "Després de {{value}}h d'inactivitat",
      "ALWAYS": "En finalitzar la sessió"
    },
    "KEYRING_FILE": "Arxiu de claus",
    "KEYRING_FILE_HELP": "Et permet <b>connectar-te</b> automàticament a cada inici <br/>i fins i tot <b>autenticar-te</b> (només si \"Caducitat de l'autenticació\" està configurada en mode: \"en finalitzar la sessió\").",
    "REMEMBER_ME": "Recorda'm",
    "REMEMBER_ME_HELP": "Permet mantenir-se sempre connectat (no recomanat), conservant localment la clau pública.",
    "PLUGINS_SETTINGS": "Extensions",
    "BTN_RESET": "Restaura els valors per defecte",
    "EXPERT_MODE": "Mode expert",
    "EXPERT_MODE_HELP": "Permet una visualització més detallada",
    "BLOCK_VALIDITY_WINDOW": "Temps d'incertesa dels blocs",
    "DISABLE_HELPTIP": "Desactiva l'opció d'ajuda contextual",
    "BLOCK_VALIDITY_WINDOW_SHORT": "Temps d'incertesa",
    "BLOCK_VALIDITY_WINDOW_HELP": "Temps d'espera abans de considerar una informació com a validada",
    "BLOCK_VALIDITY_OPTION": {
      "NONE": "Sense espera",
      "N": "{{time | formatDuration}} ({{count}} blocs)"
    },
    "POPUP_PEER": {
      "TITLE": "Nodo Duniter",
      "HOST": "Dirección",
      "HOST_HELP": "Dirección: servidor:puerto",
      "USE_SSL": "Conexión segura",
      "USE_SSL_HELP": "Cifrado SSL",
      "BTN_SHOW_LIST": "Lista de nodos"
    }
  },
  "BLOCKCHAIN": {
    "HASH": "Hash: {{hash}}",
    "VIEW": {
      "HEADER_TITLE": "Bloque #{{number}}-{{hash|formatHash}}",
      "TITLE_CURRENT": "Bloque actual",
      "TITLE": "Bloque #{{number|formatInteger}}",
      "COMPUTED_BY": "Calculado por el nodo de",
      "SHOW_RAW": "Ver el fichero en bruto",
      "TECHNICAL_DIVIDER": "Informaciones técnicas",
      "VERSION": "Versión del formato",
      "HASH": "Hash calculado",
      "UNIVERSAL_DIVIDEND_HELP": "Moneda co-producida por cada uno de los {{membersCount}} miembros",
      "EMPTY": "Ningún dato en este bloque",
      "POW_MIN": "Dificultad mínima",
      "POW_MIN_HELP": "Dificultad impuesta por el cálculo del hash",
      "DATA_DIVIDER": "Datos",
      "IDENTITIES_COUNT": "Nuevas identidades",
      "JOINERS_COUNT": "Nuevos miembros",
      "ACTIVES_COUNT": "Renovaciones",
      "ACTIVES_COUNT_HELP": "Miembros que han renovado sus adhesiones",
      "LEAVERS_COUNT": "Miembros salientes",
      "LEAVERS_COUNT_HELP": "Miembros salientes que ya no quieren estar certificados",
      "EXCLUDED_COUNT": "Miembros excluidos",
      "EXCLUDED_COUNT_HELP": "Antiguos miembros excluidos por no renovación o falta de certificaciones",
      "REVOKED_COUNT": "Identidades revocadas",
      "REVOKED_COUNT_HELP": "Estas cuentas no podrán ser miembros",
      "TX_COUNT": "Transacciones",
      "CERT_COUNT": "Certificaciones",
      "TX_TO_HIMSELF": "Operación de cambio",
      "TX_OUTPUT_UNLOCK_CONDITIONS": "Condiciones de desbloqueo",
      "TX_OUTPUT_OPERATOR": {
        "AND": "y",
        "OR": "o"
      },
      "TX_OUTPUT_FUNCTION": {
        "SIG": "<b>Firma</b> de ",
        "XHX": "<b>Contraseña</b>, cuyo SHA256 =",
        "CSV": "Bloqueado durante",
        "CLTV": "Bloqueado hasta"
      }
    },
    "LOOKUP": {
      "TITLE": "Bloques",
      "NO_BLOCK": "Ningún bloque",
      "LAST_BLOCKS": "Últimos bloques:",
      "BTN_COMPACT": "Compactar"
    }
  },
  "CURRENCY": {
    "VIEW": {
      "TITLE": "Moneda",
      "TAB_CURRENCY": "Moneda",
      "TAB_WOT": "Red de confianza",
      "TAB_NETWORK": "Red",
      "TAB_BLOCKS": "Bloques",
      "CURRENCY_SHORT_DESCRIPTION": "{{currency|abbreviate}} es una <b>moneda libre</b>, originada {{firstBlockTime|formatFromNow}}. Cuenta actualmente con <b>{{N}} miembros</b>, que producen y reciben un <a ng-click=\"showHelpModal('ud')\">Dividendo Universal</a> (DU) cada {{dt|formatPeriod}}.",
      "NETWORK_RULES_DIVIDER": "Reglas de la red",
      "CURRENCY_NAME": "Nombre de la moneda",
      "MEMBERS": "Cantidad de miembros",
      "MEMBERS_VARIATION": "Variación desde último DU",
      "MONEY_DIVIDER": "Moneda",
      "MASS": "Masa monetaria",
      "SHARE": "Masa media por miembro",
      "UD": "Dividendo Universal",
      "C_ACTUAL": "Crecimiento actual",
      "MEDIAN_TIME": "Hora de la cadena de bloques",
      "POW_MIN": "Nivel mínimo de dificultad de cálculo",
      "MONEY_RULES_DIVIDER": "Reglas de la moneda",
      "C_RULE": "Crecimiento teórico objetivo",
      "UD_RULE": "Cálculo del dividendo universal",
      "DT_REEVAL": "Periodo de revalorización del DU",
      "REEVAL_SYMBOL": "reval",
      "DT_REEVAL_VALUE": "Todos los <b>{{dtReeval|formatDuration}}</b> ({{dtReeval/86400}} {{'COMMON.DAYS'|translate}})",
      "UD_REEVAL_TIME0": "Fecha de la primera revalorización",
      "SIG_QTY_RULE": "Certificaciones requeridas para ser miembro",
      "SIG_STOCK": "Máximo de certificaciones emitibles por miembros",
      "SIG_PERIOD": "Espera mínima entre 2 certificaciones sucesivas emitidas por el mismo individuo",
      "SIG_WINDOW": "Límite para tener en cuenta una certificación",
      "SIG_VALIDITY": "Duración de una certificación tenida en cuenta",
      "MS_WINDOW": "Límite para aprobar una solicitud de membresía",
      "MS_VALIDITY": "Duración de una membresía aprobada",
      "STEP_MAX": "Distancia máxima entre una nueva candidatura y cada miembro referente",
      "WOT_RULES_DIVIDER": "Reglas de la red de confianza",
      "SENTRIES": "Certificaciones necesarias para ser miembro referente",
      "SENTRIES_FORMULA": "Fórmula de las certificaciones necesarias para ser miembro referente",
      "XPERCENT":"Porcentaje mínimo necesario de miembros referentes respentando la regla de distancia máxima",
      "AVG_GEN_TIME": "Tiempo medio entre dos bloques",
      "CURRENT": "actual",
      "MATH_CEILING": "TECHO",
      "DISPLAY_ALL_RULES": "¿Ver todas las reglas?",
      "BTN_SHOW_LICENSE": "Ver la licencia",
      "WOT_DIVIDER": "Red de confianza"
    },
    "LICENSE": {
      "TITLE": "Licencia de la moneda",
      "BTN_DOWNLOAD": "Descargar el fichero",
      "NO_LICENSE_FILE": "Fichero de licencia no encontrado."
    }
  },
  "NETWORK": {
    "VIEW": {
      "MEDIAN_TIME": "Hora de la cadena de bloques",
      "LOADING_PEERS": "Cargando nodos…",
      "NODE_ADDRESS": "Dirección:",
      "SOFTWARE": "Software:",
      "WARN_PRE_RELEASE": "Prelanzamiento (última versión estable: <b>{{version}}</b>)",
      "WARN_NEW_RELEASE": "Versión <b>{{version}}</b> disponible",
      "WS2PID": "ID:",
      "PRIVATE_ACCESS": "Acceso privado",
      "POW_PREFIX": "Prefijo de la prueba de trabajo:",
      "ENDPOINTS": {
        "BMAS": "Interfaz segura (SSL)",
        "BMATOR": "Interfaz red TOR",
        "WS2P": "Interfaz WS2P",
        "ES_USER_API": "Nodo de datos Cesium+"
      }
    },
    "INFO": {
      "CONNECTING_TO_NETWORK": "Connectant a la xarxa...",
      "ANALYZING_NETWORK": "Anàlisi de la xarxa {{currency|abbreviate}}...",
      "ONLY_SSL_PEERS": "La visualización de los nodos sin SSL está deteriorada porque Cesium funciona en modo HTTPS."
    }
  },
  "PEER": {
    "PEERS": "Nodos",
    "SIGNED_ON_BLOCK": "Firmado sobre el bloque",
    "MIRROR": "espejo",
    "MIRRORS": "Espejo",
    "MIRROR_PEERS": "Nodos espejo",
    "PEER_LIST": "Lista de nodos",
    "MEMBERS": "Miembro",
    "MEMBER_PEERS": "Nodos miembro",
    "ALL_PEERS": "Todos los nodos",
    "DIFFICULTY": "Dificultad",
    "API": "API",
    "CURRENT_BLOCK": "Bloque #",
    "POPOVER_FILTER_TITLE": "Filtro",
    "OFFLINE": "Fuera de línea",
    "OFFLINE_PEERS": "Nodos fuera de línea",
    "BTN_SHOW_PEER": "Ver nodo",
    "VIEW": {
      "TITLE": "Nodo",
      "OWNER": "Propiedad de",
      "SHOW_RAW_PEERING": "Ver la ficha del par",
      "SHOW_RAW_CURRENT_BLOCK": "Ver el último bloque (formato bruto)",
      "LAST_BLOCKS": "Bloques recientes",
      "KNOWN_PEERS": "Nodos conocidos:",
      "GENERAL_DIVIDER": "Información general",
      "ERROR": {
        "LOADING_TOR_NODE_ERROR": "No se pudo obtener la información del nodo usando la red TOR.",
        "LOADING_NODE_ERROR": "No se pudo obtener la información del nodo"
      }
    }
  },
  "WOT": {
    "SEARCH_HELP": "Buscar (seudónimo o llave pública)",
    "SEARCH_INIT_PHASE_WARNING": "Durante la etapa de preinscripción, el tiempo de búsqueda de las candidaturas en espera <b>puede tardar</b>. Por favor espere…",
    "REGISTERED_SINCE": "Se registró en",
    "REGISTERED_SINCE_BLOCK": "Se registró en el bloque #",
    "NO_CERTIFICATION": "Ninguna certificación validada",
    "NO_GIVEN_CERTIFICATION": "Ninguna certificación emitida",
    "NOT_MEMBER_PARENTHESIS": "(no miembro)",
    "IDENTITY_REVOKED_PARENTHESIS": "(identidad revocada)",
    "MEMBER_PENDING_REVOCATION_PARENTHESIS": "(revocación en proceso)",
    "EXPIRE_IN": "Expira",
    "NOT_WRITTEN_EXPIRE_IN": "Fecha límite<br/>de procesamiento",
    "EXPIRED": "Expirado",
    "PSEUDO": "Seudónimo",
    "SIGNED_ON_BLOCK": "Emitida en el bloque #{{block}}",
    "WRITTEN_ON_BLOCK": "Escrita en el bloque #{{block}}",
    "GENERAL_DIVIDER": "Informaciones generales",
    "NOT_MEMBER_ACCOUNT": "Cuenta no miembro",
    "NOT_MEMBER_ACCOUNT_HELP": "Se trata de un monedero simple, sin solicitud de membresía en espera",
    "TECHNICAL_DIVIDER": "Informaciones técnicas",
    "BTN_CERTIFY": "Certificar",
    "BTN_YES_CERTIFY": "Sí, certificar",
    "BTN_SELECT_AND_CERTIFY": "Nueva certificación",
    "ACCOUNT_OPERATIONS": "Transacciones de la cuenta",
    "VIEW": {
      "POPOVER_SHARE_TITLE": "Identidad {{title}}"
    },
    "LOOKUP": {
      "TITLE": "Directorio",
      "NEWCOMERS": "Nuevos miembros:",
      "NEWCOMERS_COUNT": "{{count}} miembros",
      "PENDING": "Inscripciones en espera:",
      "PENDING_COUNT": "{{count}} inscripciones en espera",
      "REGISTERED": "Se inscribió {{sigDate | formatFromNow}}",
      "MEMBER_FROM": "Miembro desde {{memberDate|medianFromNowShort}}",
      "BTN_NEWCOMERS": "Miembros recientes",
      "BTN_PENDING": "Candidaturas en espera",
      "SHOW_MORE": "Mostrar más",
      "SHOW_MORE_COUNT": "(mostrar solo {{limit}})",
      "NO_PENDING": "Ninguna candidatura en espera.",
      "NO_NEWCOMERS": "Sin miembros."
    },
    "CONTACTS": {
      "TITLE": "Contactos"
    },
    "MODAL": {
      "TITLE": "Buscar"
    },
    "CERTIFICATIONS": {
      "TITLE": "{{uid}} - Certificaciones",
      "SUMMARY": "Certificaciones recibidas",
      "LIST": "Detalle de las certificaciones recibidas",
      "PENDING_LIST": "Certificaciones en espera de tratamiento",
      "RECEIVED": "Certificaciones recibidas",
      "RECEIVED_BY": "Certificaciones recibidas por {{uid}}",
      "ERROR": "Certificaciones recibidas por error",
      "SENTRY_MEMBER": "Miembro referente"
    },
    "OPERATIONS": {
      "TITLE": "{{uid}} - Transacciones"
    },
    "GIVEN_CERTIFICATIONS": {
      "TITLE": "{{uid}} - Certificaciones emitidas",
      "SUMMARY": "Certificaciones emitidas",
      "LIST": "Detalle de las certificaciones emitidas",
      "PENDING_LIST": "Certificaciones en espera a ser procesadas",
      "SENT": "Certificaciones emitidas",
      "SENT_BY": "Certificaciones emitidas por {{uid}}",
      "ERROR": "Certificaciones emitidas por error"
    }
  },
  "LOGIN": {
    "TITLE": "<i class=\"icon ion-locked\"></i> Conexión",
    "SCRYPT_FORM_HELP": "Ingrese sus credenciales.<br>Recuerde comprobar que la llave pública pertenece a su cuenta.",
    "PUBKEY_FORM_HELP": "Por favor ingrese una llave pública de cuenta:",
    "FILE_FORM_HELP": "Elija el archivo de llaves a usar:",
    "SCAN_FORM_HELP": "Escanee el código QR de un monedero.",
    "SALT": "Frase secreta",
    "SALT_HELP": "Frase secreta",
    "SHOW_SALT": "Mostrar la frase secreta",
    "PASSWORD": "Contraseña",
    "PASSWORD_HELP": "Contraseña",
    "PUBKEY_HELP": "llave pública",
    "NO_ACCOUNT_QUESTION": "¿Aún no tiene cuenta? ",
    "HAVE_ACCOUNT_QUESTION": "¿Ya tiene cuenta?",
    "CREATE_ACCOUNT": "Crear una cuenta",
    "CREATE_FREE_ACCOUNT": "Crear una cuenta gratis",
    "FORGOTTEN_ID": "¿Olvidó su contraseña?",
    "ASSOCIATED_PUBKEY": "Llave pública del archivo de llaves:",
    "BTN_METHODS": "Otros métodos",
    "BTN_METHODS_DOTS": "Otras vías…",
    "METHOD_POPOVER_TITLE": "Métodos",
    "MEMORIZE_AUTH_FILE": "Memorizar las llaves durante la sesión de navegación",
    "SCRYPT_PARAMETERS": "Ajustes (Scrypt) :",
    "AUTO_LOGOUT": {
      "TITLE": "Información",
      "MESSAGE": "<i class=\"ion-android-time\"></i> Se ha <b>desconectado</b> de forma automática, después de un periodo de inactividad prolongada.",
      "BTN_RELOGIN": "Volver a conectarme",
      "IDLE_WARNING": "Será desconectado en… {{countdown}}"
    },
    "METHOD": {
      "SCRYPT_DEFAULT": "Estándar (por defecto)",
      "SCRYPT_ADVANCED": "Aleatoriedad avanzada",
      "FILE": "Archivo de llaves",
      "PUBKEY": "Llave pública o seudónimo",
      "SCAN": "Escanear un código QR"
    },
    "SCRYPT": {
      "SIMPLE": "Ligero",
      "DEFAULT": "Predeterminado",
      "SECURE": "Seguro",
      "HARDEST": "El más seguro",
      "EXTREME": "Extremo",
      "USER": "Personalizado",
      "N": "N (Loop):",
      "r": "r (RAM):",
      "p": "p (CPU):"
    },
    "FILE": {
      "HELP": "Formato de archivo esperado: <b>.yml</b> o <b>.dunikey</b> (tipo PubSec, WIF o EWIF)."
    }
  },
  "API": {
    "COMMON": {
      "CONNECTION_ERROR": "Nodo <b>{{server}}</b> inalcanzable o dirección inválida.<br/><br/>Verifique su conexión a Internet, o contacte con la administración del sitio.</a>.",
      "LINK_DOC": "Documentación API",
      "LINK_DOC_HELP": "Documentación para desarrolladores",
      "LINK_STANDARD_APP": "Versión clásica",
      "LINK_STANDARD_APP_HELP": "Abrir la versión clásica de {{'COMMON.APP_NAME'|translate}}"
    },
    "DOC": {
      "AVAILABLE_PARAMETERS": "Lista de parámetros disponibles :",
      "DEMO_CANCELLED": "<i class=\"icon ion-close\"></i> Cancelado por el usuario",
      "DEMO_DIVIDER": "Probar",
      "DEMO_HELP": "Para probar este servicio, haga clic en este botón. El resultado se mostrará debajo.",
      "DEMO_RESULT": "Resultado retornado por la llamada :",
      "DEMO_RESULT_PEER": "Dirección del nodo utilizado :",
      "DEMO_SUCCEED": "<i class=\"icon ion-checkmark\"></i> ¡ Éxito !",
      "DESCRIPTION_DIVIDER": "Descripción",
      "INTEGRATE_CODE": "Código :",
      "INTEGRATE_DIVIDER": "Integrar",
      "INTEGRATE_PARAMETERS": "Parámetros",
      "INTEGRATE_RESULT": "Previsualización del resultado :",
      "PARAMETERS_DIVIDER": "Parámetros",
      "TRANSFER": {
        "DESCRIPTION": "Desde una web (ej: tienda online) puede delegar el pago en moneda libre con la API de Cesium. Para eso, simplemente ponga un link a la siguiente dirección :",
        "EXAMPLE_BUTTON": "Botón HTML",
        "EXAMPLE_BUTTON_BG_COLOR": "Color de fondo",
        "EXAMPLE_BUTTON_BG_COLOR_HELP": "Ejemplo : #fbc14c, black, lightgrey, rgb(180,180,180)",
        "EXAMPLE_BUTTON_DEFAULT_STYLE": "Estilo personalizado",
        "EXAMPLE_BUTTON_DEFAULT_TEXT": "Pagar en {{currency|currencySymbol}}",
        "EXAMPLE_BUTTON_FONT_COLOR": "Color del texto",
        "EXAMPLE_BUTTON_FONT_COLOR_HELP": "Ejemplo : black, orange, rgb(180,180,180)",
        "EXAMPLE_BUTTON_ICON_CESIUM": "Logo Cesium",
        "EXAMPLE_BUTTON_ICON_DUNITER": "Logo Duniter",
        "EXAMPLE_BUTTON_ICON_G1_BLACK": "Logo Ğ1 (negro)",
        "EXAMPLE_BUTTON_ICON_G1_COLOR": "Logo Ğ1",
        "EXAMPLE_BUTTON_ICON_NONE": "Ninguno",
        "EXAMPLE_BUTTON_TEXT_HELP": "Texto del botón",
        "EXAMPLE_BUTTON_TEXT_ICON": "Icono",
        "EXAMPLE_BUTTON_TEXT_WIDTH": "Anchura",
        "EXAMPLE_BUTTON_TEXT_WIDTH_HELP": "Ejemplo : 200px, 50%",
        "EXAMPLES_HELP": "Ejemplos de integración :",
        "PARAM_AMOUNT": "Cuantía",
        "PARAM_AMOUNT_HELP": "Cuantía de la transición (obligatorio). Valores múltiples permitidos utilizando un separador (punto y coma, barra vertical o espacio).",
        "PARAM_CANCEL_URL": "Dirección web de cancelación",
        "PARAM_CANCEL_URL_HELP": "Dirección web (URL) en caso de anulación del pago por parte del usuario. Puede contener las siguientes palabras que serán remplazadas por sus valores dinámicamente en cada caso: \"{comment}\", \"{amount}\" y \"{pubkey}\".",
        "PARAM_COMMENT": "Concepto (o comentario)",
        "PARAM_COMMENT_HELP": "Concepto o comentario. Le permitirá por ejemplo identificar el pago en la cadena de bloques (blockchain).",
        "PARAM_NAME": "Nombre (del destinatario o de su sitio web)",
        "PARAM_NAME_HELP": "El nombre del destinatario, o de su sitio web. Puede ser un nombre leíble (\"Mi tienda en línea\"), o un dominio (\"Mitienda.com\").",
        "PARAM_PREFERRED_NODE": "Dirección del nodo preferido",
        "PARAM_PREFERRED_NODE_HELP": "Dirección (URL) del nodo Duniter a utilizar preferentemente (\"g1.domaine.com:443\" o \"https://g1.domaine.com\").",
        "PARAM_PUBKEY": "Llave pública del destinatario",
        "PARAM_PUBKEY_HELP": "La llave pública del destinatario (obligatoria)",
        "PARAM_REDIRECT_URL": "Dirección web de redirección",
        "PARAM_REDIRECT_URL_HELP": "Dirección web (URL) de redirección, llamada cuanda el pago ha sido enviado. Puede contener las palabras siguientes, que serán remplazadas por los valores de la transacción dinámicanente : \"{tx}\", \"{hash}\", \"{comment}\", \"{amount}\", \"{pubkey}\" y \"{node}\".",
        "TITLE": "Pagos"
      },
      "URL_DIVIDER": "Dirección de llamada"
    },
    "HOME": {
      "DOC_HEADER": "Servicios disponibles :",
      "MESSAGE": "Bienvenido/a a la <b>documentación de la API</b> {{'COMMON.APP_NAME'|translate}}.<br/>Conecte sus sitios webs a la cadena de bloques <a href=\"http://duniter.org\" target=\"_system\">Duniter</a> muy fácilmente !",
      "MESSAGE_SHORT": "Conecte sus sitios a <a href=\"http://duniter.org\" target=\"_system\">Duniter</a> muy fácilmente !",
      "TITLE": "Documentación API {{'COMMON.APP_NAME'|translate}}"
    },
    "TRANSFER": {
      "AMOUNT": "Cuantía :",
      "AMOUNTS_HELP": "Elija la cuantía :",
      "COMMENT": "Concepto/Comentario de la operación :",
      "DEMO": {
        "BAD_CREDENTIALS": "Verifique sus credenciales.<br/>En modo demostración, las credenciales son : {{'API.TRANSFER.DEMO.SALT'|translate}} / {{'API.TRANSFER.DEMO.PASSWORD'|translate}}",
        "HELP": "<b>Modo demostración</b> : Ningún pago será enviado realmente durante esta simulación.<br/>Utilice las credenciales : <b>{{'API.TRANSFER.DEMO.SALT'|translate}} / {{'API.TRANSFER.DEMO.PASSWORD'|translate}}</b>",
        "PASSWORD": "demo",
        "PUBKEY": "3G28bL6deXQBYpPBpLFuECo46d3kfYMJwst7uhdVBnD1",
        "SALT": "demo"
      },
      "ERROR": {
        "TRANSFER_FAILED": "Error en el pago"
      },
      "INFO": {
        "CANCEL_REDIRECTING": "Pago cancelado.<br/>Redirigiendo al sitio del vendedor...",
        "CANCEL_REDIRECTING_WITH_NAME": "Pago cancelado.<br/>Redirigiendo a <b>{{name}}</b>...",
        "SUCCESS_REDIRECTING": "Pago enviado.<br/>Redirigiendo al sitio del vendedor...",
        "SUCCESS_REDIRECTING_WITH_NAME": "Pago enviado.<br/>Redirigiendo a <b>{{name}}</b>..."
      },
      "NAME": "Nombre :",
      "NODE": "Dirección del nodo :",
      "PUBKEY": "Llave pública del destinatario :",
      "SUMMARY": "Resumen del pago :",
      "TITLE": "{{'COMMON.APP_NAME'|translate}} - Pago en línea",
      "TITLE_SHORT": "Pago en línea"
    }
  },
  "AUTH": {
    "TITLE": "<i class=\"icon ion-locked\"></i> Autenticación",
    "BTN_AUTH": "Autenticar",
    "GENERAL_HELP": "Por favor, autentíquese:",
    "EXPECTED_UID_HELP": "Por favor inicie sesión en la cuenta de <i class=\"ion-person\"></i> {{uid}}:",
    "EXPECTED_PUBKEY_HELP": "Por favor, autentíquese en el monedero <br class=\"visible-xs\"/><i class=\"ion-key\"></i> {{pubkey|formatPubkey}} :",
    "SCAN_FORM_HELP": "Escanee el código QR de la <b>llave privada</b> del monedero."
  },
  "ACCOUNT": {
    "TITLE": "Mi cuenta",
    "BALANCE": "Saldo",
    "LAST_TX": "Últimas transacciones validadas",
    "BALANCE_ACCOUNT": "Saldo de la cuenta",
    "NO_TX": "Ninguna transacción",
    "SHOW_MORE_TX": "Mostrar más",
    "SHOW_ALL_TX": "Mostrar todo",
    "TX_FROM_DATE": "(mostrar solo {{fromTime|medianFromNowShort}})",
    "OUT_DISTANCED": "Sus certificaciones recibidas provienen de un grupo demasiado aislado de la <a ng-click=\"showHelpModal('wot')\">Red de Confianza</a> (RdC) : la <a ng-click=\"showHelpModal('distance_rule')\">regla de distancia máxima</a> no se cumple.<br/>Deberá obtener certificaciones provinientes de otros sectores de la RdC, o esperar a que ésta estreche sus vínculos.",
    "PENDING_TX": "Transacciones pendientes",
    "VALIDATING_TX": "Transacciones validadas",
    "ERROR_TX": "Transacciones no ejecutadas",
    "ERROR_TX_SENT": "Transacciones ejecutadas fallidas",
    "PENDING_TX_RECEIVED": "Transacciones en espera de recepción",
    "EVENTS": "Eventos",
    "WAITING_MEMBERSHIP": "Solicitud de membresía emitida. En espera de aceptación.",
    "WAITING_CERTIFICATIONS": "Debe obtener {{needCertificationCount}} certificación(es) para ser miembro.",
    "WAITING_CERTIFICATIONS_HELP": "Para obtener sus certificaciones, solicitelas únicamente a miembros <b>que le conozcan bien (y físicamente)</b>, como exige <a ng-click=\"showLicenseModal()\">la licencia de la moneda</a> que usted ha aceptado.<br/>Si no conoce lo suficiente a miembros, hágalo saber en <a ng-click=\"openLink($event, $root.settings.userForumUrl)\">el foro</a> para conocerse físicamente o asistir a algún encuentro.",
    "WILL_MISSING_CERTIFICATIONS": "Pronto le van a <b>faltar certificaciones</b> (al menos {{willNeedCertificationCount}} son necesarias)",
    "WILL_NEED_RENEW_MEMBERSHIP": "Su adhesión como miembro <b>va a expirar {{membershipExpiresIn|formatDurationTo}}</b>. Piense en <a ng-click=\"doQuickFix('renew')\">renovar su adhesión</a> mientras tanto.",
    "NEED_RENEW_MEMBERSHIP": "Ya no es miembro porque su adhesión <b>ha expirado</b>. Piense en <a ng-click=\"doQuickFix('renew')\">renovar su adhesión</a>.",
    "NEED_RENEW_MEMBERSHIP_AFTER_CANCELLED": "Ya no es miembro de la moneda, <b>por falta de certificaciones</b>. Considere <a ng-click=\"doQuickFix('renew')\">renovar su adhesión</a>.",
    "NO_WAITING_MEMBERSHIP": "No hay adhesión miembro en espera. Si desea <b>convertirse en miembro</b>, por favor <a ng-click=\"doQuickFix('membership')\">envíe su adhesión como miembro</a>.",
    "CERTIFICATION_COUNT": "Certificaciones recibidas",
    "CERTIFICATION_COUNT_SHORT": "Certificaciones",
    "SIG_STOCK": "Certificaciones emitidas",
    "BTN_RECEIVE_MONEY": "Recibir",
    "BTN_SELECT_ALTERNATIVES_IDENTITIES": "Cambiar a otra identidad…",
    "BTN_FIX_MEMBERSHIP": "Volver a enviar la candidatura…",
    "BTN_MEMBERSHIP_RENEW": "Renovar la membresía",
    "BTN_MEMBERSHIP_RENEW_DOTS": "Renovar la membresía…",
    "BTN_MEMBERSHIP_OUT_DOTS": "Cancelar la membresía…",
    "BTN_SECURITY_DOTS": "Cuenta y seguridad…",
    "BTN_SHOW_DETAILS": "Publicar la información técnica",
    "LOCKED_OUTPUTS_POPOVER": {
      "TITLE": "Importe bloqueado",
      "DESCRIPTION": "Aquí están las condiciones para desbloquear este importe:",
      "DESCRIPTION_MANY": "Esta transacción esta compuesta de varias partes, cuyas condiciones de desbloqueo son:",
      "LOCKED_AMOUNT": "Condiciones del importe:"
    },
    "NEW": {
      "TITLE": "Registrarse",
      "INTRO_WARNING_TIME": "Crear una cuenta en {{name|capitalize}} es muy simple. Sin embargo, por favor tome el tiempo suficiente para hacerlo correctamente (generar y memorizar bien las credenciales, etc.)",
      "INTRO_WARNING_SECURITY": "Asegúrese de que el dispositivo actual (ordenador, tablet, teléfono) <b>es seguro y de confianza</b>.",
      "INTRO_WARNING_SECURITY_HELP": "Antivirus, cortafuegos, sesión protegida por contraseña o número PIN, etc.",
      "INTRO_HELP": "Haga clic en <b>{{'COMMON.BTN_START'|translate}}</b> para iniciar la creación de la cuenta. Se le guiará paso a paso.",
      "REGISTRATION_NODE": "Su registro será grabado a través del nodo Duniter <b>{{server}}</b>, que luego se transmitirá al resto del sistema de la moneda.",
      "REGISTRATION_NODE_HELP": "Si no confía en este nodo, <a ng-click=\"doQuickFix('settings')\">cambie los ajustes</a> de Cesium.",
      "SELECT_ACCOUNT_TYPE": "Elegir el tipo de cuenta a crear:",
      "MEMBER_ACCOUNT": "Cuenta miembro",
      "MEMBER_ACCOUNT_TITLE": "Crear una cuenta miembro",
      "MEMBER_ACCOUNT_HELP": "Si todavía no es miembro (solamente una cuenta miembro posible por ser humano).",
      "WALLET_ACCOUNT": "Simple monedero",
      "WALLET_ACCOUNT_TITLE": "Crear una cuenta simple",
      "WALLET_ACCOUNT_HELP": "Monedero simple para todos los demás casos, por ejemplo si necesita una cuenta suplementaria para un proyecto, colectivo, para hacer pruebas, etc.<br/>El Dividendo Universal no será producido para esta cuenta.",
      "SALT_WARNING": "Elija su frase secreta.<br/>Se solicitará cada vez que se conectará con esta cuenta.<br/><br/><b>Conserve bien esta frase secreta</b>.<br/>¡En caso de pérdida, nadie podrá acceder a su cuenta!",
      "PASSWORD_WARNING": "Elija su contraseña.<br/>Se solicitará cada vez que se conectará con esta cuenta.<br/><br/><b>Conserve bien esta contraseña</b>.<br/>¡En caso de pérdida, nadie podrá acceder su cuenta!",
      "PSEUDO_WARNING": "Elija un seudónimo.<br/>Sirve para que los otros miembros puedan encontrarlo más fácilmente.<br/><br/>No debe contener <b>ni espacios ni caracteres acentuados</b>.<div class='hidden-xs'><br/>Ejemplo: <span class='gray'>SophieDupond, MarcelChemin, etc.</span>",
      "PSEUDO": "Seudónimo",
      "PSEUDO_HELP": "Seudónimo",
      "SALT_CONFIRM": "Confirmación",
      "SALT_CONFIRM_HELP": "Confirmación de la frase secreta",
      "PASSWORD_CONFIRM": "Confirmación",
      "PASSWORD_CONFIRM_HELP": "Confirmación de la contraseña",
      "SLIDE_6_TITLE": "Confirmación:",
      "COMPUTING_PUBKEY": "Cálculo en proceso…",
      "LAST_SLIDE_CONGRATULATION": "<b>¡Bien!</b> Ha introducido todas los datos necesarios.<br/><b>Puede solicitar</b> la creación de su cuenta.</b><br/><br/>Para su información, la llave pública que se muestra más abajo identificará su futura cuenta.<br/>Esta podrá ser comunicada a terceros para recibir pagos.",
      "CONFIRMATION_MEMBER_ACCOUNT": "<b class=\"assertive\">Advertencia:</b> la frase secreta, la contraseña y el seudónimo no podrán ser modificados.<br/><b>¡Asegúrese siempre de recordarlos!</b><br/><br/><b>¿Desea</b> solicitar la inscripción?",
      "CONFIRMATION_WALLET_ACCOUNT": "<b class=\"assertive\">Advertencia:</b> la frase secreta y la contraseña no podrán ser modificados.<br/><b>¡Asegúrese de recordarlos siempre!</b><br/><br/><b>¿Desea</b> continuar?",
      "CHECKING_PSEUDO": "Verificando…",
      "PSEUDO_AVAILABLE": "Este nombre está disponible",
      "PSEUDO_NOT_AVAILABLE": "Este nombre de usuario no está disponible",
      "INFO_LICENSE": "Para unirse a la moneda, le pedimos leer y aceptar esta licencia.",
      "BTN_ACCEPT": "Acepto",
      "BTN_ACCEPT_LICENSE": "Acepto la licencia"
    },
    "POPUP_REGISTER": {
      "TITLE": "Elija un seudónimo",
      "HELP": "Un seudónimo es obligatorio para ser miembro."
    },
    "SELECT_IDENTITY_MODAL": {
      "TITLE": "Selección de identidad",
      "HELP": "Se han enviado varias <b>identidades diferentes</b> para la llave pública <span class=\"gray\"><i class=\"ion-key\"></i>{{pubkey | formatPubkey}}</span>.<br/>Por favor, selecciona la carpeta para usar:"
    },
    "SELECT_WALLET_MODAL": {
      "TITLE": "Selección de monedero"
    },
    "CERTIFICATION_MODAL": {
      "CHECKLIST_TITLE": "Llista de verificacions abans de la certificació",
      "INFOS": "La seguretat de la moneda Ğ1 recau sobre cada membre. Abans de certificar la identitat d'aquesta persona, cal que realitzis algunes verificacions. Si us plau, respon a les següents preguntes:",
      "BTN_ALL_CHECK": "Certificar",
      "CHECKLIST_CONDITIONS_NOT_MET": "La certificació no s'ha enviat. Les verificacions semblen insuficients. Si us plau, verifica de nou cada punt amb la persona a certificar.",
      "QUESTIONS": {
        "WELL_KNOWN": "<b>Coneixes bé</b> la persona que vols certificar, i coneixes altres persones que també la coneixen bé?",
        "REVOCATION": "Ha descarregat el seu <b>document de revocació</b> i sap on trobar-lo?",
        "CONTACT": "Has <b>contactat</b> amb aquesta persona per diversos mitjans i t'ha respost?",
        "DOUBLE_IDENTITY": "La persona ha de tenir <b>una sola identitat de membre activa</b>. En té alguna <b>altra</b>?",
        "MASTER_ACCOUNT": "Domina el seu compte i ja ha <b>enviat diners des del seu compte</b> com a mínim una vegada?",
        "LICENSE": "Ha <b>entès la llicència</b> i accepta complir-la per a la certificació d'altres membres?",
        "CREDENTIALS": "L'identificador i la contrasenya del seu compte són <b>suficientment llargs i complexos</b>? Ha entès que tant la contrasenya com la frase secreta han de romandre secret? Està segur que en recordarà o que podrà trobar-los?",
        "PUBLIC_KEY_DIFFERENT": "La <b>clau pública</b> indicada ha de ser <b>idèntica</b> a la que aquesta persona t'ha donat. Les claus són <b>diferents</b>?"
      },
      "REMINDER_TITLE": "Recordatori",
      "SHORT_LICENSE_REMINDER": "Pots recordar a la persona certificada els paràmetres de les certificacions:<br/><br/><ul><li> - Cada membre pot emetre com a màxim 100 certificacions vàlides.</li><li> - Les certificacions es registren amb un interval de 5 dies.</li><li> - Una nova identitat de membre ha de reunir com a mínim 5 certificacions en menys de dos mesos.</li><li> - Un membre ha de renovar la seva afiliació cada any.</li><li> - Les certificacions són vàlides durant dos anys.</li></ul>"
    },

    "WALLET_LIST": {
      "IMPORT_MODAL": {
        "HELP": "Para <b>importar monederos</b>, haga clic para seleccionar o arrastre en la zona de abajo el archivo con la lista de monederos.",
        "NO_NEW_WALLET": "Ningún monedero nuevo",
        "TITLE": "Importar monederos",
        "WALLET_COUNT": "<b>{{count}}</b> nuevo{{count > 1 ? 's' : ''}} monedero{{count > 1 ? 's' : ''}}"
      },
      "TITLE": "Mis monederos",
      "BTN_NEW": "Añadir un monedero",
      "BTN_DOWNLOAD": "Descargue el listado",
      "BTN_IMPORT_FILE_DOTS": "Importar desde fichero…",
      "NO_WALLET": "Sin monedero secundario",
      "BTN_DELETE": "Eliminar un monedero secundario…",
      "BTN_RENAME": "Renombrar el monedero",
      "EXPORT_FILENAME": "monederos-{{pubkey|formatPubkey}}-{{currency}}.csv",
      "TOTAL_DOTS": "Total : ",
      "EDIT_POPOVER": {
        "TITLE": "Renombrar el monedero",
        "HELP": "Escribe el nuevo nombre",
        "NAME_HELP": "Nombre del monedero"
      }
    },
    "SECURITY": {
      "KEYFILE": {
        "ERROR": {
          "BAD_CHECKSUM": "Suma de control (checksum) incorrecta",
          "BAD_PASSWORD": "Frase secreta incorrecta"
        },
        "EWIF_FORMAT": "Formato EWIF (Encrypted Wallet Import Format) - v1",
        "EWIF_FORMAT_HELP": "Este formato almacena su archivo de llaves <b>de forma cifrada</b> a partir de una frase secreta de su elección. También guarda una suma de control (checksum) para verificar la integridad del archivo.<br/><b>Atención :</b>¡ Asegúrese siempre de recordar su frase secreta !",
        "PASSWORD_POPUP": {
          "HELP": "Indique la frase secreta :",
          "PASSWORD_HELP": "Frase secreta",
          "TITLE": "Archivo de llaves cifrado"
        },
        "PUBSEC_FORMAT": "Formato PubSec",
        "PUBSEC_FORMAT_HELP": "Este formato almacena su archivo de llaves de forma simple. Es compatible con Cesium, ğannonce y Duniter.<br/><b>Atención :</b>El archivo <b>no está cifrado</b> (la llave privada aparece en claro) ; ¡ guárdelo en un lugar seguro !",
        "WIF_FORMAT": "Formato WIF (Wallet Import Format) - v1",
        "WIF_FORMAT_HELP": "Este formato almacena su archivo de llaves con una suma de control (checksum) para verificar la integridad del archivo. Es compatible con los monederos en papel (Duniter paper wallet).<br/><b>Atención :</b>El archivo <b>no está cifrado</b> (la llave privada aparece en claro) ; ¡ guárdelo en un lugar seguro !"
      },
      "ADD_QUESTION": "Añadir pregunta personalizada",
      "BTN_CLEAN": "Limpiar",
      "BTN_RESET": "Reiniciar",
      "DOWNLOAD_REVOKE": "Guardar un archivo de revocación",
      "DOWNLOAD_REVOKE_HELP" : "Tener un archivo de revocación es importante, en caso de perdida de las credenciales. Le permitirá <b>invalidar y sacar su cuenta miembro fuera de la Red de Confianza</b>, convirtíendose en un monedero simple.",
      "RECOVER_ID_SELECT_FILE": "Elija el <b>archivo para salvaguardar sus credenciales</b> a utilizar :",
      "GENERATE_KEYFILE": "Generar mi archivo de llaves…",
      "GENERATE_KEYFILE_HELP": "Genera un archivo que le permitirá atenticarse sin tener que introducir las credenciales.<br/><b>Cuidado:</b> este archivo contendrá su llave secreta; ¡Es muy importante conservarlo en un lugar seguro!",
      "KEYFILE_FILENAME": "llavero-{{pubkey|formatPubkey}}-{{currency}}-{{format}}.dunikey",
      "MEMBERSHIP_IN": "Registrarse como miembro…",
      "MEMBERSHIP_IN_HELP": "Le permite <b>transformar</b> una cuenta de monedero simple <b>en una cuenta miembro</b>, enviando una petición de membresía. Solo si todavía no tiene una cuenta miembro.",
      "SEND_IDENTITY": "Publicar identidad…",
      "SEND_IDENTITY_HELP": "Le permite asociar un seudónimo a esta cuenta, pero <b>sin pedir ser miembro</b>. La validez de este seudónimo tiene un plazo limitado.",
      "HELP_LEVEL": "Elija <strong> al menos {{nb}} preguntas:</strong>",
      "LEVEL": "Nivel de seguridad",
      "LOW_LEVEL": "Bajo <span class=\"hidden-xs\">(2 preguntas min.)</span>",
      "MEDIUM_LEVEL": "Medio <span class=\"hidden-xs\">(4 preguntas min.)</span>",
      "QUESTION_1": "¿Cómo se llamaba su mejor amigo de la adolescencia?",
      "QUESTION_2": "¿Cómo se llamaba su primer animal de compañía?",
      "QUESTION_3": "¿Cuál es el primer plato que aprendió a cocinar?",
      "QUESTION_4": "¿Cuál es la primera película que vió en un cine?",
      "QUESTION_5": "¿Cuál era el destino del primer avión que cogió?",
      "QUESTION_6": "¿Cómo se llamaba su docente favorito en la escuela primaria?",
      "QUESTION_7": "¿Cuál sería para usted el mejor oficio?",
      "QUESTION_8": "¿Cuál es su libro infantil preferido?",
      "QUESTION_9": "¿Cuál fue el modelo de su primer vehículo?",
      "QUESTION_10": "¿Cuál fue su sobrenombre durante su infancia?",
      "QUESTION_11": "¿Cuál fue su personaje o actor/actriz preferido/a cuando era estudiante?",
      "QUESTION_12": "¿Cuál fue su cantante o grupo preferido cuando era estudiante?",
      "QUESTION_13": "¿En qué ciudad sus padres se encontraron?",
      "QUESTION_14": "¿Cómo se llamaba su primer jefe/a?",
      "QUESTION_15": "¿Cómo se llama la calle donde creció?",
      "QUESTION_16": "¿Cómo se llama la primera playa donde se bañó?",
      "QUESTION_17": "¿Cuál es el primer álbum que compró?",
      "QUESTION_18": "¿Cuál es el nombre de su equipo deportivo preferido?",
      "QUESTION_19": "¿Cuál fue el oficio de su abuelo?",
      "RECOVER_ID": "Recuperar sus credenciales",
      "REVOCATION_WITH_FILE": "Revocar una identidad a partir de un fichero",
      "REVOCATION_WITH_FILE_DESCRIPTION": "Si ha perdido de forma permanente las credenciales de su cuenta miembro (o la seguridad de la cuenta se ve comprometida), puede usar <b>el archivo de revocación de la cuenta</b> para forzar la salida de la Red de Confianza.",
      "REVOCATION_WITH_FILE_HELP": "Para <b>revocar permanentemente</b> una cuenta miembro, arrastre el archivo de revocación en el cuadro siguiente o haga clic en el cuadro para seleccionar un archivo.",
      "REVOCATION_FILENAME": "revocacion-{{uid}}-{{pubkey|formatPubkey}}-{{currency}}.txt",
      "REVOCATION_WALLET": "Revocar esta identidad",
      "SAVE_ID": "Guardar mis credenciales",
      "STRONG_LEVEL": "Alto <span class=\"hidden-xs \">(6 preguntas min.)</span>",
      "TITLE": "Cuenta y seguridad",
      "RECOVER_ID_HELP": "Si dispone de un <b>archivo de recuperación de sus credenciales</b>, las puede reobtener respondiendo correctamente a las preguntas personales elegidas en su momento.",
      "REVOCATION_WALLET_HELP": "Pedir la revocación de vuestra identidad comporta la <b>salida de la red de confianza</b> (definitiva para el seudónimo y la llave pública asociada). La cuenta no producirá ya más el Dividendo Universal.<br/>Podrá seguir usándola como monedero simple.",
      "SAVE_ID_HELP": "Creación de un archivo de recuperación, para <b>reobtener su contraseña</b> (y frase secreta) en caso de olvido. El archivo se <b>cifra</b> con ayuda de las preguntas personales elegidas."
    },
    "FILE_NAME": "{{currency}}_HistorialDeCuenta_{{pubkey|formatPubkey}}_{{currentTime|formatDateForFile}}.csv",
    "HEADERS": {
      "TIME": "Fecha",
      "AMOUNT": "Cantidad",
      "COMMENT": "Comentario"
    }
  },
  "TRANSFER": {
    "TITLE": "Transferencia",
    "SUB_TITLE": "Hacer una transferencia",
    "FROM": "De",
    "TO": "A",
    "AMOUNT": "Importe",
    "AMOUNT_HELP": "Importe",
    "COMMENT": "Comentario",
    "COMMENT_HELP": "Comentario",
    "BTN_SEND": "Enviar",
    "BTN_ADD_COMMENT": "Añadir un comentario",
    "REST": "Resto de cuenta",
    "REST_TO": "a",
    "WARN_COMMENT_IS_PUBLIC": "Tenga en cuenta que los <b>comentarios son públicos</b> (sin encriptar).",
    "MODAL": {
      "TITLE": "Transferencia"
    }
  },
  "ERROR": {
    "ADD_SECONDARY_WALLET_FAILED": "Error añadiendo el monedero secundario.",
    "COULD_NOT_ADD_EXISTING_WALLET": "Monedero ya existe en la lista.",
    "COULD_NOT_ADD_MAIN_WALLET": "Este monedero <b>corresponde a la cuenta principal</b> con la que se conecta.<br/>Imposible añadirlo como monedero secundario.",
    "ISSUE_524_TX_FAILED": "Error en la transferencia.<br/><br/>Un mensaje ha sido enviado a los/as desarrolladores/as para facilitar la resolución del problema. <b>Gracias por su ayuda</b>.",
    "LOAD_WALLET_LIST_FAILED": "Error cargando los monederos secundarios.",
    "ONLY_MEMBER_OR_WAS_MEMBER_CAN_EXECUTE_THIS_ACTION": "Usted debe <b>ser miembro (o haber sido miembro)</b> para poder efectuar esta acción.",
    "RESTORE_WALLET_LIST_FAILED": "Error en la restauración de los monederos secundarios.",
    "SAVE_WALLET_LIST_FAILED": "Error al guardar los monederos secundarios.",
    "UNKNOWN_WALLET_ID": "Monedero secundario desconocido.",
    "UPDATE_WALLET_LIST_FAILED": "Error en la actualización de los monederos secundarios.",
    "UNKNOWN_URI_FORMAT": "Formato URI desconocido",
    "PUBKEY_INVALID_CHECKSUM": "Llave pública no válida (suma de comprobación incorrecta).",
    "POPUP_TITLE": "Error",
    "UNKNOWN_ERROR": "Error desconocido",
    "TIMEOUT_REACHED": "S'ha superat el temps d'espera del node ({{timeout|formatDurationMs}}).<br/><br/><small>{{url}}</small>",
    "CRYPTO_UNKNOWN_ERROR": "Su navegador parece incompatible con las funcionalidades de cryptografía.",
    "DOWNLOAD_KEYFILE_FAILED": "Error al generar el archivo de llaves.",
    "EQUALS_TO_PSEUDO": "Debe ser diferente del seudónimo.",
    "EQUALS_TO_SALT": "Debe ser diferente de la frase secreta.",
    "FIELD_REQUIRED": "Campo obligatorio.",
    "FIELD_TOO_SHORT": "Valor demasiado corta.",
    "FIELD_TOO_SHORT_WITH_LENGTH": "Valor demasiado corta ({{minLength}} carácteres mín)",
    "FIELD_TOO_LONG": "Valor demasiado largo",
    "FIELD_TOO_LONG_WITH_LENGTH": "Valor demasiado largo, ({{maxLength}} carácteres máx)",
    "FIELD_MIN": "Valor mínimo: {{min}}",
    "FIELD_MAX": "Valor máximo: {{max}}",
    "FIELD_ACCENT": "Caracteres acentuados y comas no autorizados",
    "FIELD_NOT_NUMBER": "Valor numérico esperado",
    "FIELD_NOT_INT": "Valor entero esperado",
    "FIELD_NOT_EMAIL": "Correo electrónico no válido",
    "PASSWORD_NOT_CONFIRMED": "No coincide con la contraseña anterior.",
    "SALT_NOT_CONFIRMED": "No corresponde a la frase secreta anterior.",
    "SEND_IDENTITY_FAILED": "Error de la inscripción.",
    "SEND_CERTIFICATION_FAILED": "Error de la certificación.",
    "NEED_MEMBER_ACCOUNT_TO_CERTIFY": "No se puede certificar, porque su cuenta no <b>es miembro</b>.",
    "NEED_MEMBER_ACCOUNT_TO_CERTIFY_HAS_SELF": "No se puede certificar, porque su cuenta todavía no es miembro.<br/><br/>Todavía faltan certificaciones para serlo.",
    "IDENTITY_TO_CERTIFY_HAS_NO_SELF": "Esta cuenta no se pudo certificar. No se ha solicitado la membresía, o se necesita renovarla.",
    "LOGIN_FAILED": "Error durante la autentificación.",
    "LOAD_IDENTITY_FAILED": "Error de carga de la identidad.",
    "LOAD_REQUIREMENTS_FAILED": "Error de carga de las condiciones de la identidad.",
    "SEND_MEMBERSHIP_IN_FAILED": "Error en el intento de entrada en la comunidad.",
    "SEND_MEMBERSHIP_OUT_FAILED": "Error en la interrupción de adhesión.",
    "REFRESH_WALLET_DATA": "Error en la actualización del monedero.",
    "GET_CURRENCY_PARAMETER": "Error en la recuperación de las reglas de moneda.",
    "GET_CURRENCY_FAILED": "Carga de la moneda imposible. Por favor, intente más tarde.",
    "SEND_TX_FAILED": "Error en la transferencia.",
    "ALL_SOURCES_USED": "Por favor, espera el cálculo del bloque siguiente (Todas sus fuentes de moneda fueron utilizada).",
    "NOT_ENOUGH_SOURCES": "No lo bastante cambio para mandar este importe en una sola transacción.<br/>Importe máximo: {{amount}} {{unit}}<sub>{{subUnit}}</sub>.",
    "ACCOUNT_CREATION_FAILED": "Error en la creación de la cuenta miembro.",
    "RESTORE_WALLET_DATA_ERROR": "Error en la recarga de los ajustes desde el almacenamiento local",
    "LOAD_WALLET_DATA_ERROR": "Error en la carga de los datos del monedero.",
    "COPY_CLIPBOARD_FAILED": "Copia de la valor imposible.",
    "TAKE_PICTURE_FAILED": "Error en la recuperación de la foto.",
    "SCAN_FAILED": "Error en el escán del Codigo QR",
    "SCAN_UNKNOWN_FORMAT": "Codigo no reconocido.",
    "WOT_LOOKUP_FAILED": "Error en la búsqueda",
    "LOAD_PEER_DATA_FAILED": "Lectura del nodo Duniter imposible. Por favor, intente más tarde.",
    "NEED_LOGIN_FIRST": "Por favor, conéctese en primer lugar.",
    "AMOUNT_REQUIRED": "El importe es obligatorio.",
    "AMOUNT_NEGATIVE": "Importe negativo no autorizado.",
    "NOT_ENOUGH_CREDIT": "Crédito insuficiente.",
    "INVALID_NODE_SUMMARY": "Nodo ilocalizable o dirección inválida.",
    "INVALID_USER_ID": "El seudónimo no debe contener ni espacios ni caracteres especiales o acentuado.",
    "INVALID_COMMENT": "El campo 'referencia’ no debe contener carácteres acentuados.",
    "INVALID_PUBKEY": "La llave pública no tiene el formato esperado.",
    "INVALID_PUBKEY_CHECKSUM": "Suma de comprobación inválida.",
    "IDENTITY_REVOKED": "Esta identidad <b>fue revocada</b>. No puede volver a convertirla en miembro.",
    "IDENTITY_REVOKED_WITH_TIME": "Esta identidad <b>fue revocada {{revocationTime|medianFromNow}}</b> ({{revocationTime|medianDate}}). No puede volver a convertirla en miembro.",
    "IDENTITY_PENDING_REVOCATION": "La <b>revocación de esta identidad</b> fue solicitado y esta en espera de tratamiento. Por lo que, la certificación es desactivada.",
    "IDENTITY_INVALID_BLOCK_HASH": "Esta solicitud de adhesión no es valida (porque denomina un bloque los nodos de la red han anulado): este individuo/a debe renovelar su solicitud de adhesión <b>antes que</b> estar certificada.",
    "IDENTITY_EXPIRED": "La publicación de esta identidad ha caducada: este individuo/a debe realizar una nueva solicitud de adhesión <b>antes que</b> estar certificada.",
    "IDENTITY_SANDBOX_FULL": "EL nodo Duniter utilizado por Cesium ya no puede recibir más nuevas identidades, porque la fila de espera es llena.<br/><br/>Por favor, intenta ulteriormente o cambia de nodo (vía el menú <b>Ajustes</b>).",
    "IDENTITY_NOT_FOUND": "Identidad no encontrada",
    "IDENTITY_TX_FAILED": "Error cargando las transacciones de la identidad",
    "WOT_PENDING_INVALID_BLOCK_HASH": "Adhesión no validada.",
    "WALLET_INVALID_BLOCK_HASH": "Su solicitud de adhesión ya no está validada (porque denomina un bloque los nodos de la red han anulado).<br/>Debe <a ng-click=\"doQuickFix('fixMembership')\">mandar una nueva solicitud</a> para resolver este problema.",
    "WALLET_IDENTITY_EXPIRED": "La publicación de <b>su identidad ha caducada</b>.<br/>Debe <a ng-click=\"doQuickFix('fixIdentity')\">publicar une outra vez su identidad</a> para resolver este problema.",
    "WALLET_REVOKED": "Su identidad fue <b>revocada</b>: ni su seudónimo ni su llave pública podrán estar utilizados en el futuro por una cuenta miembro.",
    "WALLET_HAS_NO_SELF": "Su identidad debe en primer lugar haber estado publicado, y no estar caducada.",
    "AUTH_REQUIRED": "Autenticación requerida.",
    "AUTH_INVALID_PUBKEY": "La llave pública no se corresponde con la cuenta conectada",
    "AUTH_INVALID_SCRYPT": "De usuario o contraseña no válidos.",
    "AUTH_INVALID_FILE": "archivo de llave no válido.",
    "AUTH_FILE_ERROR": "No se pudo abrir el archivo de llave",
    "IDENTITY_ALREADY_CERTIFY": "Ha <b>ya certificado</b> esta identidad.<br/><br/>Esta certificación todavía es valida (expiration {{expiresIn|formatDurationTo}}).",
    "IDENTITY_ALREADY_CERTIFY_PENDING": "Ha <b>ya certificado</b> esta identidad.<br/><br/>Esta certificación está en espera de tratamiento (fecha límite de tratamiento {{expiresIn|formatDurationTo}}).",
    "UNABLE_TO_CERTIFY_TITLE": "Certificación imposible",
    "LOAD_NEWCOMERS_FAILED": "No se pudo cargar las nuevas membresías.",
    "LOAD_PENDING_FAILED": "No se pudo cargar las inscripciones pendientes.",
    "ONLY_MEMBER_CAN_EXECUTE_THIS_ACTION": "Debe <b>ser miembro</b> para poder realizar esta acción.",
    "ONLY_SELF_CAN_EXECUTE_THIS_ACTION": "Debe haber <b>publicado su identidad</b> para poder realizar esta acción.",
    "GET_BLOCK_FAILED": "Error en la recuperación del bloque",
    "INVALID_BLOCK_HASH": "Bloque no encontrado (hash diferente)",
    "DOWNLOAD_REVOCATION_FAILED": "Debe seleccionar un fichero de texto",
    "REVOCATION_FAILED": "Error en la revocación.",
    "SALT_OR_PASSWORD_NOT_CONFIRMED": "Frase secreta o contraseña incorrectos",
    "RECOVER_ID_FAILED": "Error en la recuperación de las credenciales",
    "LOAD_FILE_FAILED": "Error en la carga del archivo",
    "NOT_VALID_REVOCATION_FILE": "Archivo de revocación no válido (formato de archivo erróneo)",
    "NOT_VALID_SAVE_ID_FILE": "Archivo no válido (formato de archivo erróneo)",
    "NOT_VALID_KEY_FILE": "Archivo no válido (formato de archivo erróneo)",
    "EXISTING_ACCOUNT": "Sus credenciales corresponden a una cuenta existente, la <a ng-click=\"showHelpModal('pubkey')\">llave pública</a> es:",
    "EXISTING_ACCOUNT_REQUEST": "Por favor, cambie sus credenciales para que coincida con una cuenta sin usar.",
    "GET_LICENSE_FILE_FAILED": "Error al obtener el archivo de licencia",
    "CHECK_NETWORK_CONNECTION": "No se puede conectar a ningún nodo.<br/><br/><b>Compruebe la conexión a Internet</b>.",
    "INVALID_FILE_FORMAT": "Formato de archivo inválido.",
    "SAME_TX_RECIPIENT": "El destinatario debe ser diferente del emisor."
  },
  "INFO": {
    "POPUP_TITLE": "Información",
    "CERTIFICATION_DONE": "Certificación enviada",
    "NOT_ENOUGH_CREDIT": "Crédito insuficiente",
    "TRANSFER_SENT": "Transferencia enviada",
    "COPY_TO_CLIPBOARD_DONE": "Copia realizada",
    "MEMBERSHIP_OUT_SENT": "Anulación enviada",
    "NOT_NEED_MEMBERSHIP": "Ya es miembro.",
    "IDENTITY_WILL_MISSING_CERTIFICATIONS": "Esta identidad pronto va a necesitar certificaciones (al menos {{willNeedCertificationCount}}).",
    "IDENTITY_NEED_MEMBERSHIP": "Esta identidad no ha enviado una solicitud de membresía para convertirse en miembro.",
    "HAS_ALTERNATIVE_IDENTITIES": "Hay <b>identidades múltiples</b> adjuntas a esta llave pública. <b>Antes de cualquier certificación</b>, <a ng-click=\"doQuickFix('showSelectIdentities')\">verifique otras identidades</a> para elegir la correcta o comuníquese con el propietario de la cuenta.",
    "REVOCATION_SENT": "Revocación enviada",
    "REVOCATION_SENT_WAITING_PROCESS": "La <b>revocación de esta identidad</b> fue solicitada y está en espera de ser procesada.",
    "FEATURES_NOT_IMPLEMENTED": "Esta funcionalidad todavía está en proceso de desarrollo.<br/><br/>¿Por qué no <b>contribuir a Cesium</b>, para obtenerla más rápido? ;)",
    "EMPTY_TX_HISTORY": "Ninguna operación a exportar",
    "LOADING_PENDING_TX": "Esperi si us plau...<br/><small>(Recuperant operacions pendents)</small>"
  },
  "CONFIRM": {
    "EXIT_APP": "¿ Cerrar la aplicación ?",
    "FULLSCREEN": "¿ Mostrar la aplicación en pantalla completa ?",
    "ISSUE_524_SEND_LOG": "La transacción ha sido rechazada a causa de una anomalía conocida (ticket #524) pero todavía <b>no replicable</b>.<br/><br/>Para ayudar a los/as desarrolladores/as a corregir este error, ¿ <b>acepta el envío de los logs(trazas del programa)</b> ?<br/><small>(ningún dato confidencia será enviado)</small>.",
    "POPUP_TITLE": "<b>Confirmación</b>",
    "POPUP_WARNING_TITLE": "<b>Advertencia</b>",
    "POPUP_SECURITY_WARNING_TITLE": "<i class=\"icon ion-alert-circled\"></i> <b>Advertencia de seguridad</b>",
    "CERTIFY_RULES_TITLE_UID": "Certificar {{uid}}", "CERTIFY_RULES": "<b class=\"assertive\">NO CERTIFICAR</b> una cuenta si piensa que:<br/><br/><ul><li>1.) no corresponde a un ser humano <b>físico y vivo</b>.<li>2.) su propietario/a <b>posee otra cuenta</b> ya certificada.<li>3.) su propietaria/o incumple (voluntariamente o no) la regla 1 o 2 (por ejemplo certificando cuentas fantasmas o duplicadas).</ul><br/><b>¿Desea</b> todavía certificar esta identidad?",
    "TRANSFER": "<b>Resumen de la transferencia</b>:<br/><br/><ul><li> - De: {{from}}</li><li> - A: <b>{{to}}</b></li><li> - Importe: <b>{{amount}} {{unit}}</b></li><li> - Comentario: <i>{{comment}}</i></li></ul><br/><b>Desea realizar esta transferencia?</b>",
    "TRANSFER_ALL": "<b>Resumen de la transferencia</b>:<br/><br/><ul><li> - De: {{from}}</li><li> - A: <b>{{to}}</b></li><li> - Importe: <b>{{amount}} {{unit}}</b></li><li> - Comentario: <i>{{comment}}</i></li><br/><li> - Resto: <b>{{restAmount}} {{unit}}</b> para <b>{{restTo}}</b></li></ul><br/><b>¿Desea realizar esta transferencia?</b>",
    "MEMBERSHIP_OUT": "Esta operación es <b>irreversible</b>.<br/></br/>¿Desea <b>anular su cuenta miembro</b>?",
    "MEMBERSHIP_OUT_2": "¡Esta operación es <b>irreversible</b>!<br/><br/>¿Desea <b>anular su candidatura</b> como miembro?",
    "LOGIN_UNUSED_WALLET_TITLE": "¿Error de introducción de datos?",
    "LOGIN_UNUSED_WALLET": "Las credenciales introducidas corresponden a una cuenta que parece <b>inactiva</b>.<br/></br/><b>¿Quiere sin embargo continuar con esta cuenta?</b>",
    "FIX_IDENTITY": "El seudónimo <b>{{uid}}</b> va a ser publicado de nuevo, en reemplazo del antiguo que caducó.<br/></br/><b>¿Desea</b> continuar?",
    "FIX_MEMBERSHIP": "Su solicitud de adhesión como miembro va a ser enviada de nuevo.<br/></br/><b>¿Desea</b> continuar?",
    "MEMBERSHIP": "Se enviará su solicitud de membresía como miembro.<br/></br/><b>¿Desea</b> continuar?",
    "RENEW_MEMBERSHIP": "Su adhesión como miembro va a estar renovada.<br/></br/><b>¿Desea</b> continuar?",
    "REVOKE_IDENTITY": "Va a <b>revocar definitivamente esta identidad</b>.<br/><br/>La llave pública y el seudónimo asociados <b>jamás podrán ser utilizados</b> (para una cuenta miembro). <br/><br/><b>¿Desea</b> revocar definitivamente esta cuenta?",
    "REVOKE_IDENTITY_2": "¡Esta operación es <b>irreversible</b>!<br/><br/>¿Desea <b>revocar definitivamente</b> esta cuenta?",
    "NOT_NEED_RENEW_MEMBERSHIP": "Su membresía no necesita ser renovada actualmente (caducará en {{membershipExpiresIn|formatDuration}}).<br/></br/><b>¿Confirma</b> querer renovar su membresía?",
    "SAVE_BEFORE_LEAVE": "¿Desea <b>guardar sus cambios</b> antes de abandonar la página?",
    "SAVE_BEFORE_LEAVE_TITLE": "Cambios no registrados",
    "LOGOUT": "¿Desea desconectarse?",
    "USE_FALLBACK_NODE": "Nodo <b>{{old}}</b> inalcanzable o dirección inválida.<br/><br/>¿Desea utilizar temporalmente el nodo <b>{{new}}</b>?",
    "USE_SYNC_FALLBACK_NODE": "El node <b>{{old}}</b> sembla desincronitzat.<br/><br/>Vols utilitzar temporalment el node sincronitzat <b>{{new}}</b>?",
    "ENABLE_EXPERT_MODE_TO_CHANGE_NODE": "<b class=\"assertive\">Advertència:</b> Vols <b>canviar manualment</b> el node Duniter?<br/><br/>Si continues:<ul><li> - S'activarà el <b>modo experto</b>;</li><li> - Podràs tornar a la selecció automàtica de nodes simplement <b>desactivant el modo experto</b>.</li></ul>"
  },
  "DOWNLOAD": {
    "POPUP_TITLE": "<b>Revocación del archivo</b>",
    "POPUP_REVOKE_MESSAGE": "Para proteger su cuenta, descargue el <b>documento de revocación de cuenta</b>. Le permitirá cancelar su cuenta (en caso de robo, cambio de identificadores, cuenta creada incorrectamente, etc.).<br/><br/><b>Por favor, almacénelo en un lugar seguro.</b>"
  },
  "HELP": {
    "TITLE": "Ayuda en línea",
    "JOIN": {
      "SECTION": "Inscripción",
      "SALT": "La frase secreta es muy importante. Sirve para mezclar(<span class=\"text-italic\">hash</span>) la contraseña, antes de calcular la <span class=\"text-italic\">llave pública</span> (el número de cuenta) y la <span class=\"text-italic\">llave privada</span> para acceder a esta.<br/><b>Por favor, memorícelo muy bien</b> porque no existe ninguna forma de recuperarlo en caso de pérdida.<br/>No puede ser modificado. Deberá crear una nueva cuenta si lo pierde o se olvida.<br/><br/>Una buena frase secreta debe ser suficientemente larga (al menos 8 carácteres) y lo más original posible.",
      "PASSWORD": "La contraseña es muy importante. Junto a la frase secreta, sirve para calcular la llave pública (el número de cuenta), y la llave privada para acceder a ella.<br/><b>Por favor, memorícela muy bien</b> porque no existe ninguna forma de recuperarla en caso de pérdida (excepto si se tuviese un fichero de respaldo o <span class=\"text-italic\">backup</span>.).<br/>No puede ser modificada. Deberá crear una nueva cuenta si la pierde o se olvida.<br/><br/>Una buena contraseña contiene al menos 8 carácteres, con al menos una mayúscula y un dígito.",
      "PSEUDO": "El seudónimo se utiliza solamente en caso de inscripción como <span class=\"text-italic\">miembro</span>. Siempre está asociado a un monedero (vía su <span class=\"text-italic\">llave pública</span>).<br/>Este se publica en la red para que los demás usuarios puedan identificar, certificar o enviar dinero a la cuenta.<br/>Un seudónimo debe ser único para cada miembro (actuales y antiguos)."
    },
    "LOGIN": {
      "SECTION": "Autenticación",
      "PUBKEY": "Llave pública",
      "PUBKEY_DEF": "La llave pública del archivo de llaves es generada de las credenciales introducidas (cualquiera que sean), sin estar obligatoriamente vinculadas o contrastadas con ninguna cuenta ya usada. <br/><b>Asegúrese por lo tanto de que la llave pública es la misma con la que se creó originalmente su cuenta</b>. De lo contrario, se autogenerará una cuenta vacía que probablemente nunca ha sido usada, ya que el riesgo de coincidir con las credenciales de otra cuenta ajena es muy pequeño.<br/><a href=\"https://es.wikipedia.org/wiki/Criptograf%C3%ADa_de_curva_el%C3%ADptica\" target=\"_ system\">Conozca más sobre criptografía</a> con llaves públicas.",
      "METHOD": "Métodos de autenticación",
      "METHOD_DEF": "Diversas opciones están disponibles para conectar a las cuentas: <br/> - La conexión <b>con aleatoriedad (estándar o avanzada)</b> mezcla su contraseña con su frase secreta, para limitar las posibilidades de ataque<br/> - La conexión <b>usando llave pública</b> le permite entrar sin credenciales, las cuales solo se le pedirán cuando alguna operación lo necesite.<br/> - La conexión <b>usando archivo de llaves</b> leerá las llave pública y privada de la cuenta desde un archivo sin necesitar sus credenciales. Varios formatos son posibles."
    },
    "GLOSSARY": {
      "DISTANCE_RULE": "Regla de distancia",
      "DISTANCE_RULE_DEF": "La regle de distancia de la Red de Confianza define <b>una distancia máxima a respetar</b> entre una candidatura y número mínimo miembros referentes (aquellos más conectados). Esta distancia es calculada utilizando los enlaces de certificación.",
      "WOT": "Red de Confianza (RdC)",
      "WOT_DEF": "La Red de Confianza se compone del conjunto de miembros de la moneda, y de los enlaces de certificaciones que los conectan.",
      "SECTION": "Glosario",
      "PUBKEY_DEF": "Una llave pública identifica un monedero, que puede estar asociado a un miembro o ser un monedero anónimo. En Cesium se calcula a partir de la frase secreta y la contraseña.",
      "MEMBER": "Miembro",
      "MEMBER_DEF": "Cada miembro es una ser humano físico y vivo, deseosa de participar libremente en la comunidad monetaria. Percibe un dividendo universal, de acuerdo a un periodo e importe definido en las <span class=\"text-italic\">reglas de la moneda</span>",
      "CURRENCY_RULES": "Reglas de la moneda",
      "CURRENCY_RULES_DEF": "Las reglas de la moneda se han definido una vez y para siempre. Establecen el funcionamiento de la moneda: el cálculo del dividendo universal, la cantidad de certificaciones necesarias para ser miembro, la cantidad máxima de certificaciones que cada miembro puede emitir, etc. <a href=\"#/app/currency\">Ver las reglas actuales</a>.<br/> Sus parámetros no pueden alterarse gracias a una <span class=\"text-italic\">Cadena de Bloques</span> que soporta, implementa y verifica la buena aplicación de estas reglas.",
      "BLOCKCHAIN": "Cadena de bloques (<span class=\"text-italic\">Blockchain</span>)",
      "BLOCKCHAIN_DEF": "La cadena de bloques es un sistema descentralizado, que en el caso de Duniter, sirve para mantener e implementar las <span class=\"text-italic\">reglas de la moneda</span>.<br/><a href=\"http://duniter.org\" target=\"_system\">Más información</a> acerca de Duniter y el funcionamiento de su cadena de bloques.",
      "UNIVERSAL_DIVIDEND_DEF": "El Dividendo Universal (DU) es la cantidad de moneda co-creada por cada miembro, dependiendo del periodo y del cálculo definidos en las <span class=\"text-italic\">reglas de la moneda</span>.<br/>En cada periodo, los miembros reciben en sus cuentas la misma cantidad de moneda.<br/><br/>El DU crece regularmente, para ser justo entre cada miembro (actualmente y en el futuro), y calculado en función de la esperanza de vida media, como se demuestra en la <span class=\"text-italic\">Teoría Relativa de la Moneda</span> (TRM, de Stéphane Laborde).<br/><a href=\"http://trm.creationmonetaire.info\">Más información</a> sobre la TRM y las monedas libres."
    },
    "TIP": {
      "MENU_BTN_CURRENCY": "El menú <b>{{'MENU.CURRENCY'|translate}}</b> permite consultar las <b>reglas de la moneda</b> y su estado.",
      "CURRENCY_WOT": "El <b>número de miembros</b> muestra el peso de la comunidad y permite <b>seguir su evolución</b>.",
      "CURRENCY_MASS": "Siga aquí la <b>cantidad total de moneda</b> existente y su <b>distribución media</b> por miembro.<br/><br/>Esto permite juzgar la <b>relevancia de un importe</b>, en relación con lo que <b>poseen los demás</b> en sus cuentas (de media).",
      "CURRENCY_UNIT_RELATIVE": "La unidad utilizada (&ldquo;<b>{{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub></b>&rdquo;) significa que los importes en {{currency|capitalize}} han sido divididos entre el valor del <b>Dividendo Universal</b> (DU).<br/><br/><small> Esta unidad relativa es <b>pertinente</b>, porque permanece estable, independiente de la cantidad de moneda que aumenta constantemente.</small>",
      "CURRENCY_CHANGE_UNIT": "Este botón permite <b>cambiar la unidad</b>, para visualizar los importes <b>directamente en {{currency|capitalize}}</b> (en lugar de &ldquo;<b>{{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub></b>&rdquo;).",
      "CURRENCY_CHANGE_UNIT_TO_RELATIVE": "Este botón permite <b>cambiar la unidad</b>, para visualizar los importes en &ldquo;<b>{{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub></b>&rdquo;, es decir, relativo al Dividendo Universal (el monto co-producido por cada miembro).",
      "CURRENCY_RULES": "Las <b>reglas</b> de la moneda fijan su funcionamiento <b>exacto y previsible</b>.<br/><br/>Es el propio ADN de la moneda, que hace que su código monetario sea <b>legible y transparente</b>.",
      "MENU_BTN_NETWORK": "El menú <b>{{'MENU.NETWORK'|translate}}</b> permite consultar el estado de la red.",
      "NETWORK_BLOCKCHAIN": "Todas las transacciones de la moneda están registradas dentro de un gran libro de contabilidad <b>público e infalsificable</b>, conocido como la <b>cadena de bloques</b> (<em>BlockChain</em> en inglés).",
      "NETWORK_PEERS": "Los <b>nodos</b> visibles aquí corresponden a los <b>dispositivos de miembros que actualizan y validan</b> la cadena de bloques.<br/><br/>Cuanto más nodos haya conectados, la moneda tendrá una gestión más <b>descentralizada</b> y digna de confianza.",
      "NETWORK_PEERS_BLOCK_NUMBER": "Este <b>número</b> (en verde) indica el <b>último bloque validado</b> por este nodo (última página escrita en la cadena de bloques).<br/><br/>El color verde indica que este bloque ha sido también validado por <b>la mayoría del resto de nodos</b>.",
      "NETWORK_PEERS_PARTICIPATE": "<b>Cada miembro</b>, equipado de un dispositivo conectado a Internet, <b>puede contribuir añadiendo un nodo</b>.  Necesita <b>instalar el programa Duniter</b> (libre y gratuito). <a href=\"{{installDocUrl}}\" target=\"_system\">Ver manual de uso &gt;&gt;</a>.",
      "MENU_BTN_ACCOUNT": "<b>{{'ACCOUNT.TITLE'|translate}}</b> permite acceder a la gestión y al historial de su cuenta.",
      "MENU_BTN_ACCOUNT_MEMBER": "Consulte aquí el estado de su cuenta y la información sobre sus certificaciones.",
      "WALLET_CERTIFICATIONS": "Haga clic aquí para consultar el detalle de sus certificaciones (recibidas y emitidas).",
      "WALLET_RECEIVED_CERTIFICATIONS": "Haga clic aquí para consultar el detalle de sus <b>certificaciones recibidas</b>.",
      "WALLET_GIVEN_CERTIFICATIONS": "Haga clic aquí para consultar el detalle de sus <b>certificaciones emitidas</b>.",
      "WALLET_BALANCE": "El <b>saldo</b> de su cuenta se visualiza aquí.",
      "WALLET_BALANCE_RELATIVE":
      "{{'HELP.TIP.WALLET_BALANCE'|translate}}<br/><br/>La unidad utilizada (&ldquo;<b>{{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub></b>&rdquo;) significa que el importe en {{currency|capitalize}} fue dividido entre el <b>Dividendo Universal</b> (DU) co-producido por cada miembro.<br/><br/>Actualmente un DU vale {{currentUD|formatInteger}} {{currency|capitalize}}s.",
      "WALLET_BALANCE_CHANGE_UNIT": "Podrá <b>cambiar la unidad</b> de visualización de los importes en los <b><i class=\"icon ion-android-settings\"></i>&nbsp;{{'MENU.SETTINGS'|translate}}</b>.<br/><br/>Por ejemplo, para visualizar los importes <b>directamente en {{currency|capitalize}}</b>, en lugar de unidad relativa.",
      "WALLET_PUBKEY": "Esta es la llave pública de su cuenta. Puede comunicarla a un tercero para que pueda identificar su cuenta de forma simple.",
      "WALLET_SEND": "Realizar un pago en algunos clics",
      "WALLET_SEND_NO_MONEY": "Realizar un pago en algunos clics.<br/>(Su saldo ya no lo permite)",
      "WALLET_OPTIONS": "Este botón permite acceder a las <b>acciones de adhesión</b> y de seguridad.<br/><br/>¡No olvide echar un vistazo!",
      "WALLET_RECEIVED_CERTS": "Se exhibirá aquí la lista de individuo/as que le han certificado.",
      "WALLET_CERTIFY": "El botón <b>{{'WOT.BTN_SELECT_AND_CERTIFY'|translate}}</b> permite seleccionar una identidad y certificarla.<br/><br/>Solo quienes son <b>miembros</b> pueden certificar a otros seres humanos.",
      "WALLET_CERT_STOCK": "Su stock de certificaciones (emitidas) es limitado a <b>{{sigStock}} certificaciones</b>.<br/><br/>Este stock se renueva con el tiempo, a medida que las certificaciones caducan.",
      "MENU_BTN_TX": "El menú <b>{{'MENU.TRANSACTIONS'|translate}}</b> permite consultar su saldo, el historial de transacciones y realizar nuevos pagos.",
      "MENU_BTN_WALLETS": "El menú <b>{{'MENU.WALLETS'|translate}}</b> permite añadir monederos complementarios que usted maneja.",
      "MENU_BTN_WOT": "El menú <b>{{'MENU.WOT'|translate}}</b> permite buscar <b>usuarios</b> de la moneda (miembro o no).",
      "WOT_SEARCH_TEXT_XS": "Para buscar en el directorio, escriba las <b>primeras letras de un seudónimo</b> (o de una llave pública).<br/><br/>La búsqueda se iniciará automáticamente.",
      "WOT_SEARCH_TEXT": "Para buscar en el directorio, escriba las <b>primeras letras de un seudónimo</b> (o de una llave pública). <br/><br/>Luego, pulse en la tecla <b>Intro</b> para iniciar la búsqueda.",
      "WOT_SEARCH_RESULT": "Visualice la ficha detallada <b>haciendo clic</b> sobre una fila.",
      "WOT_VIEW_CERTIFICATIONS": "La opción <b>{{'ACCOUNT.CERTIFICATION_COUNT'|translate}}</b> muestra qué miembros han validado esta identidad.<br/><br/>Estas certificaciones atestiguan que la cuenta pertenece a <b>un ser humano vivo</b> y que no posee <b>ninguna otra cuenta miembro</b>.",
      "WOT_VIEW_CERTIFICATIONS_COUNT": "Necesita al menos <b>{{sigQty}} certificaciones</b> para ser miembro y recibir el <b>Dividendo Universal</b>.",
      "WOT_VIEW_CERTIFICATIONS_CLICK": "Un clic aquí permite abrir <b>la lista de todas las certificaciones</b> de la identidad (recibidas y emitidas).",
      "WOT_VIEW_CERTIFY": "El botón <b>{{'WOT.BTN_CERTIFY'|translate}}</b> permite añadir su certificación a esta identidad.",
      "CERTIFY_RULES": "<b>Atención:</b> Certifique solamente <b>seres humanos físicos vivos</b>, que no posean ya ninguna otra cuenta miembro.<br/><br/>¡La seguridad de la red de la moneda depende del cuidado de cada individuo/a!",
      "MENU_BTN_SETTINGS": "En <b>{{'MENU.SETTINGS'|translate}}</b> podrá configurar la aplicación.",
      "HEADER_BAR_BTN_PROFILE": "Haga clic aquí para acceder a su <b>perfil</b>",
      "SETTINGS_CHANGE_UNIT": "Podrá <b>cambiar la unidad de visualización</b> de los importes haciendo clic aquí.<br/><br/>- Desactive la opción para mostrar los importes en {{currency|capitalize}}.<br/>- Actívela para importes relativos al {{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub> (las cantidades de los importes se mostrarán <b>divididos</b> entre el Dividendo Universal actual).",
      "END_LOGIN": "¡La visita guiada ha <b>terminado</b>!<br/><br/>¡Buena suerte en este nuevo mundo de la <b>economía libre</b> !",
      "END_NOT_LOGIN": "¡La visita guiada ha <b>terminado</b>!<br/><br/>Si quiere utilizar la moneda {{currency|capitalize}}, tiene que hacer un clic en <b>{{'LOGIN.CREATE_ACCOUNT'|translate}}</b> más abajo."
    }
  }
}
);

$translateProvider.translations("de-DE", {
  "COMMON": {
    "APP_NAME": "Cesium",
    "APP_VERSION": "v{{version}}",
    "APP_BUILD": "Build {{build}}",
    "PUBKEY": "Öffentlicher Schlüssel",
    "MEMBER": "Mitglied",
    "BLOCK": "Block",
    "BTN_OK": "OK",
    "BTN_YES": "Ja",
    "BTN_NO": "Nein",
    "BTN_SEND": "Schicken",
    "BTN_SEND_MONEY": "Geld überweisen",
    "BTN_SEND_MONEY_SHORT": "Überweisung",
    "BTN_SAVE": "Speichern",
    "BTN_YES_SAVE": "Ja, Speichern",
    "BTN_YES_CONTINUE": "Ja, Weiter",
    "BTN_SHOW": "Anzeigen",
    "BTN_SHOW_PUBKEY": "Schlüssel anzeigen",
    "BTN_RELATIVE_UNIT": "Relative Einheit UD gebrauchen",
    "BTN_BACK": "Zurück",
    "BTN_NEXT": "Nächste",
    "BTN_IMPORT": "Importieren",
    "BTN_CANCEL": "Abbrechen",
    "BTN_CLOSE": "Schließen",
    "BTN_LATER": "Später",
    "BTN_LOGIN": "Anmelden",
    "BTN_LOGOUT": "Abmelden",
    "BTN_ADD_ACCOUNT": "Neues Konto anlegen",
    "BTN_SHARE": "Teilen",
    "BTN_EDIT": "Bearbeiten",
    "BTN_DELETE": "Löschen",
    "BTN_ADD": "Hinzufügen",
    "BTN_SEARCH": "Suchen",
    "BTN_REFRESH": "Neu laden",
    "BTN_RETRY": "Neu versuchen",
    "BTN_START": "Start",
    "BTN_CONTINUE": "Weiter",
    "BTN_CREATE": "Erstellen",
    "BTN_UNDERSTOOD": "Ich habe es verstanden",
    "BTN_OPTIONS": "Optionen",
    "BTN_HELP_TOUR": "Cesium erkunden",
    "BTN_HELP_TOUR_SCREEN": "Tour: Erkunde diesen Bildschirm",
    "BTN_DOWNLOAD": "Download",
    "BTN_DOWNLOAD_ACCOUNT_STATEMENT": "Kontoauszug herunterladen",
    "BTN_MODIFY": "Ändern",
    "CHOOSE_FILE": "Ziehe deine Datei<br/>oder zur Auswahl drücken",
    "DAYS": "Tage",
    "NO_ACCOUNT_QUESTION": "Noch nicht Mitglied? Registriere dich jetzt!",
    "SEARCH_NO_RESULT": "Keine Ergebnisse gefunden",
    "LOADING": "Lade...",
    "LOADING_WAIT": "Lade...<br/><small>(Cesium fragt den Duniter-Knoten ab)</small>",
    "SEARCHING": "Suche...",
    "FROM": "Von",
    "TO": "An",
    "COPY": "Kopieren",
    "LANGUAGE": "Sprache",
    "UNIVERSAL_DIVIDEND": "Universelle Dividende",
    "UD": "UD",
    "DATE_PATTERN": "DD.MM.YYYY HH:mm",
    "DATE_FILE_PATTERN": "DD.MM.YYYY",
    "DATE_SHORT_PATTERN": "DD.MM.YY",
    "DATE_MONTH_YEAR_PATTERN": "MM-YYYY",
    "EMPTY_PARENTHESIS": "(leer)",
    "UID": "Pseudonym",
    "ENABLE": "aktivieren",
    "DISABLE": "deaktivieren",
    "RESULTS_LIST": "Ergebnisse:",
    "RESULTS_COUNT": "{{count}} Ergebnisse",
    "EXECUTION_TIME": "Ausgeführt in {{duration|formatDurationMs}}",
    "SHOW_VALUES": "Werte offen anzeigen?",
    "POPOVER_ACTIONS_TITLE": "Optionen",
    "POPOVER_FILTER_TITLE": "Filter",
    "SHOW_MORE": "Mehr anzeigen",
    "SHOW_MORE_COUNT": "(heutiges Limit bei: {{limit}})",
    "POPOVER_SHARE": {
      "TITLE": "Teilen",
      "SHARE_ON_TWITTER": "Teilen auf Twitter",
      "SHARE_ON_FACEBOOK": "Teilen auf Facebook",
      "SHARE_ON_DIASPORA": "Teilen auf Diaspora*",
      "SHARE_ON_GOOGLEPLUS": "Teilen auf Google+"
    },
    "FILE": {
      "DATE" : "Datum:",
      "TYPE" : "Typ:",
      "SIZE": "Größe:",
      "VALIDATING": "Validierung..."
    }
  },
  "SYSTEM": {
    "PICTURE_CHOOSE_TYPE": "Bildquelle auswählen:",
    "BTN_PICTURE_GALLERY": "Gallerie",
    "BTN_PICTURE_CAMERA": "<b>Kamera</b>"
  },
  "MENU": {
    "HOME": "Startseite",
    "WOT": "Mitgliederverzeichnis",
    "CURRENCY": "Währung",
    "ACCOUNT": "Mein Konto",
    "WALLETS": "Meine Brieftaschen",
    "SETTINGS": "Einstellungen",
    "NETWORK": "Netzwerk",
    "TRANSACTIONS": "Meine Transaktionen"
  },
  "ABOUT": {
    "TITLE": "Über",
    "LICENSE": "<b>Freie Software</b> (GNU AGPLv3 Lizenz).",
    "LATEST_RELEASE": "Es gibt eine <b>neue Version</b> von {{'COMMON.APP_NAME' | translate}} (<b>v{{version}}</b>)",
    "PLEASE_UPDATE": "Bitte aktualisiere {{'COMMON.APP_NAME' | translate}} (latest version: <b>v{{version}}</b>)",
    "CODE": "Quellcode:",
    "OFFICIAL_WEB_SITE": "Offizielle Webseite:",
    "DEVELOPERS": "Entwickler:",
    "FORUM": "Forum:",
    "DEV_WARNING": "Warnung",
    "DEV_WARNING_MESSAGE": "Diese Anwendung ist noch in der aktiven Entwicklung.<br/>Bitte melde uns jedes auftretende Problem!",
    "DEV_WARNING_MESSAGE_SHORT": "Diese App ist evtentuell noch instabil(in Entwicklung).",
    "PLEASE_REPORT_ISSUE": "Bitte melde uns jegliches Problem!",
    "REPORT_ISSUE": "Ein Problem melden",
    "BTN_OPEN_DEV_WINDOW": "Debug Fenster öffnen"
  },
  "HOME": {
    "TITLE": "Cesium",
    "WELCOME": "Willkommen in der Cesium App!",
    "WELCOME_READONLY": "Willkommen zu Cesium <span class='badge badge-balanced'>Monit</span> !",
    "MESSAGE": "Sieh dir {{currency|abbreviate}} Konten in Echtzeit an.",
    "MESSAGE_READONLY": "Echtzeitüberwachung der freien Währung {{currency|abbreviate}}",
    "BTN_REGISTRY": "Verzeichnis",
    "BTN_CURRENCY": "Währung kennenlernen {{currency|abbreviate}}",
    "BTN_ABOUT": "über",
    "BTN_HELP": "Hilfe",
    "BTN_NETWORK": "Netzwerkstatus",
    "FREE_SOFTWARE": "Freie Software",
    "FORK_ME": "Fork mich!",
    "SHOW_LICENSE": "Lizenz anzeigen",
    "REPORT_ISSUE": "Ein Problem melden",
    "NOT_YOUR_ACCOUNT_QUESTION" : "Ist dieses Konto <b><i class=\"ion-key\"></i> {{pubkey|formatPubkey}}</b> nicht von dir?",
    "BTN_CHANGE_ACCOUNT": "Von diesem Konto abmelden",
    "PEER_CONNECTION_ERROR": "Der Knoten <b>{{server}}</b> ist nicht erreichbar oder die Adresse ist falsch.<br/><br/>Kontrolliere deine Internetverbindung, oder wähle einen anderen Knoten <a class=\"positive\" ng-click=\"doQuickFix('settings')\">in deinen Einstellungen</a>.",
    "NETWORK_CONNECTION_ERROR": "Netzwerk ist nicht erreichbar.<br/><br/>Überprüfen Sie Ihre Internetverbindung, oder wählen Sie einen Knoten manuell <a class=\"positive\" ng-click=\"doQuickFix('settings')\">in den Einstellungen</a> aus.",
    "SHOW_ALL_FEED": "Alles anzeigen",
    "READ_MORE": "Mehr lesen",
    "FEED_SOURCE": "Quelle"
  },
  "SETTINGS": {
    "TITLE": "Einstellungen",
    "DISPLAY_DIVIDER": "Anzeige",
    "STORAGE_DIVIDER": "Speicher",
    "NETWORK_SETTINGS": "Netzwerk",
    "PEER": "Duniter Knoten",
    "PEER_CHANGED_TEMPORARY": "Knotenadresse wird nur temporär gebraucht",
    "PEER_SELECTED_AUTOMATICALLY": "Knoten wird beim Start automatisch ausgewählt",
    "NETWORK_ANALYZE_TIMEOUT": "Maximale Wartezeit (Timeout)",
    "NETWORK_ANALYZE_TIMEOUT_HELP": "Maximale Wartezeit für die Netzwerkanalyse",
    "NETWORK_ANALYZE_TIMEOUT_AUTO": "Auto",
    "PERSIST_CACHE": "Navigationsdaten behalten (experimental)",
    "PERSIST_CACHE_HELP": "Erlaubt schnellere Navigation, durch Zwischenspeicherung der empfangenen Daten, von einer Sitzung zur nächsten.",
    "USE_LOCAL_STORAGE": "Lokales Speichern einschalten",
    "USE_LOCAL_STORAGE_HELP": "Damit kannst du deine Einstellungen lokal abspeichern",
    "WALLETS_SETTINGS": "Meine Brieftaschen",
    "USE_WALLETS_ENCRYPTION": "Verschlüsseln der Liste",
    "USE_WALLETS_ENCRYPTION_HELP": "Ermöglicht, die Liste deiner Brieftaschen zu verschlüsseln. Der Zugriff erfordert dann Authentifizierung.",
    "ENABLE_HELPTIP": "Kontexthilfe aktivieren",
    "DISABLE_HELPTIP": "Kontexthilfe deaktivieren",
    "ENABLE_UI_EFFECTS": "Visuelle Effekte aktivieren",
    "ENABLE_UI_EFFECTS_HELP": "Wechsel zwischen Seiten, Animation der Liste",
    "HISTORY_SETTINGS": "Mein Konto",
    "DISPLAY_UD_HISTORY": "Die produzierten universellen Dividenden anzeigen?",
    "TX_HISTORY_AUTO_REFRESH": "Automatische Anzeigeaktualisierung anschalten?",
    "TX_HISTORY_AUTO_REFRESH_HELP": "Aktualisiert die Liste der Operationen mit jedem neuen Block.",
    "AUTHENTICATION_SETTINGS": "Anmeldeeinstellungen",
    "KEEP_AUTH": "Ablaufzeit der Sitzung",
    "KEEP_AUTH_SHORT": "Ablaufzeit",
    "KEEP_AUTH_HELP": "Definiere, wann die Anmeldung ihre Gültigkeit verliert.",
    "KEEP_AUTH_OPTION": {
      "NEVER": "Nach jeder Operation",
      "SECONDS": "Nach {{value}}s Inaktivität",
      "MINUTE": "Nach {{value}}min Inaktivität",
      "MINUTES": "Nach {{value}}min Inaktivität",
      "HOUR": "Nach {{value}}h Inaktivität",
      "ALWAYS": "Am Ende der Sitzung"
    },
    "KEYRING_FILE": "Schlüsselbunddatei",
    "KEYRING_FILE_HELP": "Erlaubt automatische Anmeldung beim Start und Authentifizierung während der Sitzung (nur wenn \"Ablaufzeit der Sitzung\" auf \"Am Ende der Sitzung\" steht",
    "REMEMBER_ME": "Meine Anmeldung merken",
    "REMEMBER_ME_HELP": "Dadurch kannst du immer angemeldet bleiben (nicht empfohlen).",
    "PLUGINS_SETTINGS": "Erweiterungen",
    "BTN_RESET": "Standardeinstellungen wiederherstellen",
    "EXPERT_MODE": "Expertenmodus einschalten",
    "EXPERT_MODE_HELP": "Mehr Details anzeigen",
    "BLOCK_VALIDITY_WINDOW": "Block-Unsicherheitsspanne",
    "BLOCK_VALIDITY_WINDOW_SHORT": "Unsicherheitsspanne",
    "BLOCK_VALIDITY_WINDOW_HELP": "Wartezeit, bis eine Information als validiert angesehen wird",
    "BLOCK_VALIDITY_OPTION": {
      "NONE": "Keine Verzögerung",
      "N": "{{time | formatDuration}} ({{count}} Blöcke)"
    },
    "POPUP_PEER": {
      "TITLE" : "Duniter Knoten",
      "HOST" : "Adresse",
      "HOST_HELP": "Adresse: Server:Port",
      "USE_SSL" : "Sichere Verbindung nutzen?",
      "USE_SSL_HELP" : "TLS Verschlüsselung",
      "BTN_SHOW_LIST" : "Liste der verfügbaren Knoten"
    }
  },
  "BLOCKCHAIN": {
    "HASH": "Hash: {{hash}}",
    "VIEW": {
      "HEADER_TITLE": "Block #{{number}}-{{hash|formatHash}}",
      "TITLE_CURRENT": "Aktueller Block",
      "TITLE": "Block #{{number|formatInteger}}",
      "COMPUTED_BY": "Berechnet durch den Knoten",
      "SHOW_RAW": "Rohdaten ansehen",
      "TECHNICAL_DIVIDER": "Technische Informationen",
      "VERSION": "Format Version",
      "HASH": "Berechneter Hash",
      "UNIVERSAL_DIVIDEND_HELP": "Geldmenge, die durch jedes der {{membersCount}} Mitglieder produziert wird",
      "EMPTY": "Dieser Block enthält keine Daten",
      "POW_MIN": "Minimale Schwierigkeit",
      "POW_MIN_HELP": "Auferlegte Schwierigkeit beim Berechnen des Hash-Werts",
      "DATA_DIVIDER": "Daten",
      "IDENTITIES_COUNT": "Neue Identitäten",
      "JOINERS_COUNT": "Neue Mitglieder",
      "ACTIVES_COUNT": "Verlängerungen",
      "ACTIVES_COUNT_HELP": "Mitglieder die ihre Mitgliedschaft verlängert haben",
      "LEAVERS_COUNT": "Ausgeschiedene",
      "LEAVERS_COUNT_HELP": "Mitglieder, die keine Zertifizierung mehr wünschen",
      "EXCLUDED_COUNT": "Ausgeschlossene Mitglieder",
      "EXCLUDED_COUNT_HELP": "Alt-Mitglieder, ausgeschlossen durch fehlende Verlängerung oder Mangel an Zertifizierungen",
      "REVOKED_COUNT": "Zurückgezogene Identitäten",
      "REVOKED_COUNT_HELP": "Diese Konten können keine Mitgliedskonten mehr sein",
      "TX_COUNT": "Kontobewegungen",
      "CERT_COUNT": "Zertifizierungen",
      "TX_TO_HIMSELF": "Tausch",
      "TX_OUTPUT_UNLOCK_CONDITIONS": "Voraussetzung für das Eröffnen",
      "TX_OUTPUT_OPERATOR": {
        "AND": "und",
        "OR": "oder"
      },
      "TX_OUTPUT_FUNCTION": {
        "SIG": "<b>Signatur</b> des öffentlichen Schlüssels",
        "XHX": "<b>Passwort</b>, mit SHA256 =",
        "CSV": "Blockiert während",
        "CLTV": "Blockiert bis"
      }
    },
    "LOOKUP": {
      "TITLE": "Blöcke",
      "NO_BLOCK": "Kein Block",
      "LAST_BLOCKS": "Letzte Blöcke:",
      "BTN_COMPACT": "Kompakt"
    }
  },
  "CURRENCY": {
    "SELECT": {
      "TITLE": "Währungen",
      "CURRENCIES": "Bekannte Währungen",
      "MEMBERS_COUNT": "{{membersCount}} Mitglieder"
    },
    "VIEW": {
      "TITLE": "Währung",
      "TAB_CURRENCY": "Währung",
      "TAB_WOT": "Netz des Vertrauens",
      "TAB_NETWORK": "Netzwerk",
      "TAB_BLOCKS": "Blöcke",
      "CURRENCY_SHORT_DESCRIPTION": "{{currency|capitalize}} ist eine <b>freie Währung</b>, gegründet vor {{firstBlockTime | formatFromNow}}. Sie zählt aktuell <b>{{N}} Mitglieder </b>, die eine <a ng-click=\"showHelpModal('ud')\">Universelle Dividende</a> (DU) schöpfen und erhalten, und zwar alle {{dt | formatPeriod}}.",
      "NETWORK_RULES_DIVIDER": "Netzwerk-Regeln",
      "CURRENCY_NAME": "Name der Währung",
      "MEMBERS": "Anzahl Mitglieder",
      "MEMBERS_VARIATION": "Veränderung seit {{duration|formatDuration}} (seit der letzten UD)",
      "MONEY_DIVIDER": "Geld",
      "MASS": "Geldmenge",
      "SHARE": "Anteil an der Geldmenge",
      "UD": "Universelle Dividende",
      "C_ACTUAL": "Wachstum heute",
      "MEDIAN_TIME": "Aktuelle Blockchain Zeit",
      "POW_MIN": "Minimale Schwierigkeit",
      "MONEY_RULES_DIVIDER": "Regeln für die Währung",
      "C_RULE": "Theoretisches Wachstumsziel",
      "UD_RULE": "Universelle Dividende (Berechnungsformel)",
      "DT_REEVAL": "Zeitraum zwischen zwei Neubewertungen der UD",
      "REEVAL_SYMBOL": "reeval",
      "DT_REEVAL_VALUE": "Alle <b>{{dtReeval|formatDuration}}</b> ({{dtReeval/86400}} {{'COMMON.DAYS'|translate}})",
      "UD_REEVAL_TIME0": "Datum der ersten Neubewertungen der UD",
      "SIG_QTY_RULE": "Benötigte Anzahl Zertifizierungen um Mitglied zu werden",
      "SIG_STOCK": "Maximale Anzahl erteilter (gültiger) Zertifikate pro Mitglied",
      "SIG_PERIOD": "Minimaler zeitlicher Abstand zwischen 2 Zertifizierungen, die von einer einzelnen Person erteilt wurden.",
      "SIG_WINDOW": "Maximale Zeit, nach der eine Zertifizierung verarbeitet werden muss",
      "SIG_VALIDITY": "Gültigkeitsspanne einer verarbeiteten Zertifizierung",
      "MS_WINDOW": "Maximale Verzögerung, mit der eine ausstehende Mitgliedschaft verarbeitet wird",
      "MS_VALIDITY": "Gültigkeitsspanne einer verarbeiteten Mitgliedschaft",
      "STEP_MAX": "Maximale Distanz zwischen einem Anwärter und jedem der Referenzmitglieder.",
      "WOT_RULES_DIVIDER": "Regeln für das Netz des Vertrauens - WoT",
      "SENTRIES": "Erforderliche Anzahl von Zertifizierungen (erteilt <b>und</b> erhalten), um ein Referenzmitglied zu werden",
      "SENTRIES_FORMULA": "Erforderliche Anzahl von Zertifizierungen, um ein Referenzmitglied zu werden (Formel)",
      "XPERCENT":"Prozentualer Mindestanteil von erreichbaren Referenten, um die Distanzregel einzuhalten",
      "AVG_GEN_TIME": "Durchschnittliche Zeit zwischen 2 Blöcken",
      "CURRENT": "aktuelle",
      "MATH_CEILING": "Obere Schranke",
      "DISPLAY_ALL_RULES": "Alle Regeln anzeigen?",
      "BTN_SHOW_LICENSE": "Lizenz anzeigen",
      "WOT_DIVIDER": "Netz des Vertrauens"
    },
    "LICENSE": {
      "TITLE": "Lizenz der Währung",
      "BTN_DOWNLOAD": "Datei herunterladen",
      "NO_LICENSE_FILE": "Lizenzdatei nicht gefunden."
    }
  },
  "NETWORK": {
    "VIEW": {
      "MEDIAN_TIME": "Blockchain Zeit",
      "LOADING_PEERS": "Lade Liste der Knoten...",
      "NODE_ADDRESS": "Adresse :",
      "SOFTWARE": "Software:",
      "WARN_PRE_RELEASE": "Vorabversion (letzte stabile Version: <b>{{version}}</b>)",
      "WARN_NEW_RELEASE": "Version <b>{{version}}</b> verfügbar",
      "WS2PID": "Identifier:",
      "PRIVATE_ACCESS": "Private access",
      "POW_PREFIX": "Proof of work prefix:",
      "ENDPOINTS": {
        "BMAS": "Sicherer Endknoten (TLS)",
        "BMATOR": "TOR Endknoten",
        "WS2P": "WS2P Endknoten",
        "ES_USER_API": "Cesium+ Datenknoten"
      }
    },
    "INFO": {
      "CONNECTING_TO_NETWORK": "Verbindung zum Netzwerk...",
      "ANALYZING_NETWORK": "Analyse des {{currency|abbreviate}} Netzwerks...",
      "ONLY_SSL_PEERS": "Die nicht mit SSL gesicherten Knoten haben eine reduzierte Darstellung, weil Cesium im HTTPS Modus funktioniert."
    }
  },
  "PEER": {
    "PEERS": "Nachbarknoten",
    "SIGNED_ON_BLOCK": "Signiert auf Block",
    "MIRROR": "Spiegel",
    "MIRRORS": "Spiegel",
    "MIRROR_PEERS": "Spiegelknoten",
    "PEER_LIST" : "Liste der Knoten",
    "MEMBERS" : "Mitglieder",
    "MEMBER_PEERS" : "Mitgliederknoten",
    "ALL_PEERS" : "Alle Knoten",
    "DIFFICULTY" : "Schwierigkeit",
    "API" : "API",
    "CURRENT_BLOCK": "Block Nr.",
    "POPOVER_FILTER_TITLE": "Filter",
    "OFFLINE": "Offline",
    "OFFLINE_PEERS": "Offline Knoten",
    "BTN_SHOW_PEER": "Knoten anzeigen",
    "VIEW": {
      "TITLE": "Knoten",
      "OWNER": "Besitzer: ",
      "SHOW_RAW_PEERING": "Siehe Netzwerkdokument",
      "SHOW_RAW_CURRENT_BLOCK": "Aktuellen Block anzeigen (Rohformat)",
      "LAST_BLOCKS": "Neueste Blöcke",
      "KNOWN_PEERS": "Bekannte Knoten :",
      "GENERAL_DIVIDER": "Allgemeine Information",
      "ERROR": {
        "LOADING_TOR_NODE_ERROR": "Die Daten dieses Knotens konnten nicht über das TOR Netzwerk geladen werden.",
        "LOADING_NODE_ERROR": "Knotendaten konnten nicht geladen werden."
      }
    }
  },
  "WOT": {
    "SEARCH_HELP": "Suche (Pseudonym oder öffentlicher Schlüssel)",
    "SEARCH_INIT_PHASE_WARNING": "Während der Vorregistrierungsphase kann die Suche nach ausstehenden Erstzertifizierungen<b>lange dauern</b>. Bitte warten ...",
    "REGISTERED_SINCE": "Registriert am",
    "REGISTERED_SINCE_BLOCK": "Registriert mit Block #",
    "NO_CERTIFICATION": "Keine validierte Zertifizierungen",
    "NO_GIVEN_CERTIFICATION": "Keine vergebenen Zertifizierungen",
    "NOT_MEMBER_PARENTHESIS": "(Kein Mitglied)",
    "IDENTITY_REVOKED_PARENTHESIS": "(Zurückgezogenes Konto)",
    "MEMBER_PENDING_REVOCATION_PARENTHESIS": "(wird zurückgezogen)",
    "EXPIRE_IN": "Läuft ab",
    "NOT_WRITTEN_EXPIRE_IN": "Späteste<br/>Bearbeitung",
    "EXPIRED": "Abgelaufen",
    "PSEUDO": "Pseudonym",
    "SIGNED_ON_BLOCK": "Vergeben in Block #{{block}}",
    "WRITTEN_ON_BLOCK": "Geschrieben in Block #{{block}}",
    "GENERAL_DIVIDER": "Allgemeine Information",
    "NOT_MEMBER_ACCOUNT": "Einfaches Konto (Kein Mitglied)",
    "NOT_MEMBER_ACCOUNT_HELP": "Dies ist eine einfache Brieftasche, ohne ausstehende Beantragung der Mitgliedschaft.",
    "TECHNICAL_DIVIDER": "Technische Daten",
    "BTN_CERTIFY": "Zertifizieren",
    "BTN_YES_CERTIFY": "Ja, Zertifizieren",
    "BTN_SELECT_AND_CERTIFY": "Neue Zertifizierung",
    "ACCOUNT_OPERATIONS": "Kontobewegungen",
    "VIEW": {
      "POPOVER_SHARE_TITLE": "Benutzer {{title}}"
    },
    "LOOKUP": {
      "TITLE": "Mitgliederverzeichnis",
      "NEWCOMERS": "Neue Mitglieder:",
      "NEWCOMERS_COUNT": "{{count}} Mitglieder",
      "PENDING": "Zukünftige Mitglieder:",
      "PENDING_COUNT": "{{count}} ausstehende Registrierungen",
      "REGISTERED": "Registriert {{sigDate | formatFromNow}}",
      "MEMBER_FROM": "Mitglied seit {{memberDate|medianFromNowShort}}",
      "BTN_NEWCOMERS": "Neueste Mitglieder",
      "BTN_PENDING": "Ausstehende Registrierungen",
      "SHOW_MORE": "Mehr anzeigen",
      "SHOW_MORE_COUNT": "(Limit von {{limit}})",
      "NO_PENDING": "Keine ausstehenden Registrierungen.",
      "NO_NEWCOMERS": "Keine neuen Mitglieder."
    },
    "CONTACTS": {
      "TITLE": "Kontakte"
    },
    "MODAL": {
      "TITLE": "Suchen"
    },
    "CERTIFICATIONS": {
      "TITLE": "{{uid}} - Zertifizierungen",
      "SUMMARY": "Erhaltene Zertifizierungen",
      "LIST": "Details zu erhaltenen Zertifizierungen",
      "PENDING_LIST": "Ausstehende Zertifizierungen",
      "RECEIVED": "Erhaltene Zertifizierungen",
      "RECEIVED_BY": "Zertifizerungen, die {{uid}} erhalten hat",
      "ERROR": "Irrtümlich erhaltene Zertifizierungen",
      "SENTRY_MEMBER": "Referenzmitglied"
    },
    "OPERATIONS": {
      "TITLE": "{{uid}} - Operationen"
    },
    "GIVEN_CERTIFICATIONS": {
      "TITLE": "{{uid}} - Erteilte Zertifizierungen",
      "SUMMARY": "Erteilte Zertifizierungen",
      "LIST": "Details zu erteilten Zertifizierungen",
      "PENDING_LIST": "Ausstehende Zertifizierungen",
      "SENT": "Erteilte Zertifizierungen",
      "SENT_BY": "Von {{uid}} vergebene Zertifizierungen",
      "ERROR": "Irrtümlich vergebene Zertifizierungen"
    }
  },
  "LOGIN": {
    "TITLE": "<i class=\"icon ion-locked\"></i> Anmelden",
    "SCRYPT_FORM_HELP": "Bitte gib Deine Zugangsdaten ein. <br> Überprüfe anschließend den berechneten öffentlichen Schlüssel auf Übereinstimmung mit Deinem Konto.",
    "PUBKEY_FORM_HELP": "Bitte gib den öffentlichen Schlüssel Deines Kontos ein:",
    "FILE_FORM_HELP": "Wähle die zu verwendende Schlüsselbund-Datei:",
    "SCAN_FORM_HELP": "Scanne den QR-Code einer Brieftasche.",
    "SALT": "Geheimer Benutzername",
    "SALT_HELP": "Geheimer Benutzername (nicht das Pseudonym) zum Absichern des Kontos",
    "SHOW_SALT": "Geheimen Benutzernamen anzeigen",
    "PASSWORD": "Passwort",
    "PASSWORD_HELP": "Passwort zum Absichern des Kontos",
    "PUBKEY_HELP": "Öffentlicher Schlüssel oder Pseudonym",
    "NO_ACCOUNT_QUESTION": "Noch kein Konto vorhanden?",
    "HAVE_ACCOUNT_QUESTION": "Konto bereits vorhanden?",
    "CREATE_ACCOUNT": "Ein Konto anlegen",
    "CREATE_FREE_ACCOUNT": "Ein kostenloses Konto anlegen",
    "FORGOTTEN_ID": "Password und/oder Benutzernamen vergessen?",
    "ASSOCIATED_PUBKEY": "Öffentlicher Schlüssel :",
    "BTN_METHODS": "Andere Verfahren",
    "BTN_METHODS_DOTS": "Verfahren ändern...",
    "METHOD_POPOVER_TITLE": "Verfahren",
    "MEMORIZE_AUTH_FILE": "Behalte diesen Schlüsselbund für die Dauer dieser Sitzung",
    "SCRYPT_PARAMETERS": "Parameter (Scrypt) :",
    "AUTO_LOGOUT": {
      "TITLE": "Information",
      "MESSAGE": "<i class=\"ion-android-time\"></i> Du wurdest aufgrund von Inaktivität automatisch <b>abgemeldet</ b>.",
      "BTN_RELOGIN": "Anmelden",
      "IDLE_WARNING": "Du wirst bald abgemeldet... {{countdown}}"
    },
    "METHOD": {
      "SCRYPT_DEFAULT": "Geheimer Benutzername und Passwort",
      "SCRYPT_ADVANCED": "Fortgeschrittenes Verfahren mit &quot;salt&quot;",
      "FILE": "Schlüsselbund-Datei",
      "PUBKEY": "Öffentlicher Schlüssel oder Pseudonym",
      "SCAN": "Scanne einen QR-Code"
    },
    "SCRYPT": {
      "SIMPLE": "Einfaches &quot;salt&quot;",
      "DEFAULT": "Standard &quot;salt&quot;",
      "SECURE": "Sicheres &quot;salt&quot;",
      "HARDEST": "Schweres &quot;salt&quot;",
      "EXTREME": "Extremes &quot;salt&quot;",
      "USER": "Benutzerwert",
      "N": "N (Loop):",
      "r": "r (RAM):",
      "p": "p (CPU):"
    },
    "FILE": {
      "HELP": "Erwartetes Dateiformat: <b>.dunikey</b> (Typ PubSec). Die Unterstützung weiterer Formate ist in Entwicklung (EWIF, WIF)."
    }
  },
  "AUTH": {
    "TITLE": "<i class=\"icon ion-locked\"></i> Authentifizierung",
    "BTN_AUTH": "Authentifizieren",
    "GENERAL_HELP": "Bitte  authentifiziere dich:",
    "EXPECTED_UID_HELP": "Bitte authentifiziere das Konto <i class=\"ion-person\"></i> {{uid}}:",
    "EXPECTED_PUBKEY_HELP": "Bitte  authentifiziere die Brieftasche <i class=\"ion-key\"></i> {{pubkey|formatPubkey}}:",
    "SCAN_FORM_HELP": "Scanne den <b>öffentlichen Schlüssels</b> der Brieftasche als QR-Code."
  },
  "ACCOUNT": {
    "TITLE": "Mein Konto",
    "BALANCE": "Saldo",
    "LAST_TX": "Letzte validierte Transaktionen",
    "BALANCE_ACCOUNT": "Kontosaldo",
    "NO_TX": "Keine Transaktionen vorhanden",
    "SHOW_MORE_TX": "Mehr anzeigen",
    "SHOW_ALL_TX": "Alles anzeigen",
    "TX_FROM_DATE": "(Derzeitiges Limit {{fromTime|medianFromNowShort}})",
    "PENDING_TX": "Anstehende Transaktionen",
    "VALIDATING_TX": "Transaktionen in der Validierung",
    "ERROR_TX": "Nicht ausgeführte Transaktionen",
    "ERROR_TX_SENT": "Fehlgeschlagene, gesendete Transaktionen",
    "PENDING_TX_RECEIVED": "Transaktionen bereit zum Empfang",
    "EVENTS": "Ereignisse",
    "OUT_DISTANCED": "Deine aktuellen Zertifizierungen stammen von einer Gruppe, die im <a ng-click=\"showHelpModal('wot')\"> Netz des Vertrauens</a> (WoT) zu isoliert ist: die <a ng-click=\"showHelpModal( 'distance_rule')\">Distanzregel</a> wird verletzt.<br/> Du musst Zertifizierungen von einem anderen Bereich des Netzes des Vertrauens einholen oder warten, bis es enger zusammenrückt.",
    "WAITING_MEMBERSHIP": "Mitgliedsantrag abgeschickt. Wartet auf Validierung.",
    "WAITING_CERTIFICATIONS": "Du brauchst {{needCertificationCount}} Zertifizierungen, um Mitglied zu werden und die <a ng-click=\"showHelpModal('ud')\">Universelle Dividende</a> zu schöpfen. Auf jeden Fall ist dein Konto schon einsatzfähig, um Zahlungen zu leisten oder zu empfangen.",
    "WAITING_CERTIFICATIONS_HELP": "Bitte nur Mitglieder, die <b>dich ausreichend kennen</b>, um die nötigen Zertifizierungen zu erhalten, so wie es in der <a ng-click=\"showLicenseModal()\">Lizenz zur Währung</a> steht, die du akzeptiert hast.<br/>Wenn du keine ausreichende Anzahl Mitglieder kennst, kannst du dich im <a ng-click=\"openLink($event, $root.settings.userForumUrl)\">Mitgliederforum</a> umsehen.",
    "WILL_MISSING_CERTIFICATIONS": "In Kürze werden dir <b>gültige Zertifizierungen fehlen</b>, (mindestens {{willNeedCertificationCount}} werden benötigt)",
    "WILL_NEED_RENEW_MEMBERSHIP": "Dein Mitgliedsstatus <b>verfällt am {{membershipExpiresIn|formatDurationTo}}</b>. Vergiss nicht, vor diesem Termein <a ng-click=\"doQuickFix('renew')\">deine Mitgliedschaft zu erneuern</a>.",
    "NEED_RENEW_MEMBERSHIP": "Du bist kein Mitglied mehr, weil deine Mitgliedschaft <b>abgelaufen ist</b>. Denke daran, <a ng-click=\"doQuickFix('renew')\">deine Mitgliedschaft zu erneuern</a>.",
    "NEED_RENEW_MEMBERSHIP_AFTER_CANCELLED": "Du bist kein Mitglied mehr, weil deine Mitgliedschaft wegen fehlender Zertifizierungen <b>gekündigt</b> wurde. Denke daran, <a ng-click=\"doQuickFix('renew')\">deine Mitgliedschaft zu erneuern</a>.",
    "NO_WAITING_MEMBERSHIP": "Kein Mitgliedsantrag anhängig. Wenn du <b>Mitglied werden</b> möchtest, sende bitte <a ng-click=\"doQuickFix('membership')\">den Mitgliedsantrag</a>.",
    "CERTIFICATION_COUNT": "Anzahl Zertifizierungen",
    "CERTIFICATION_COUNT_SHORT": "Zertifizierungen",
    "SIG_STOCK": "Vorrat noch zu erteilender Zertifizierungen",
    "BTN_RECEIVE_MONEY": "Erhalten",
    "BTN_SELECT_ALTERNATIVES_IDENTITIES": "Wechsle zu einer anderen Identität...",
    "BTN_FIX_MEMBERSHIP": "Mitgliedsantrag erneut absenden...",
    "BTN_MEMBERSHIP_IN_DOTS": "Mitgliedschaft beantragen...",
    "BTN_MEMBERSHIP_RENEW": "Mitgliedschaft verlängern",
    "BTN_MEMBERSHIP_RENEW_DOTS": "Mitgliedschaft verlängern ...",
    "BTN_MEMBERSHIP_OUT_DOTS": "Mitgliedschaft widerrufen ...",
    "BTN_SEND_IDENTITY_DOTS": "Pseudonym veröffentlichen ...",
    "BTN_SECURITY_DOTS": "Anmeldung und Sicherheit ...",
    "BTN_SHOW_DETAILS": "Technische Daten anzeigen",
    "BTN_REVOKE": "Diese Mitgliedschaft ist <span class='hidden-xs hidden-sm'> unwiderruflich</span> widerrufen ...",
    "LOCKED_OUTPUTS_POPOVER": {
      "TITLE": "Gesperrter Betrag",
      "DESCRIPTION": "Die Bedingungen, um diesen Betrag freizuschalten, lauten wie folgt:",
      "DESCRIPTION_MANY": "Diese Transaktion besteht aus mehreren Teilen, deren Bedingungen zur Freischaltung wie folgt lauten:",
      "LOCKED_AMOUNT": "Bedingungen für den Betrag:"
    },
    "NEW": {
      "TITLE": "Registrierung",
      "INTRO_WARNING_TIME": "Das Erstellen eines Kontos bei {{name|capitalize}} ist sehr einfach. Bitte nimm dir hierfür ausreichend Zeit (um Benutzernamen, Passwörter etc. nicht zu vergessen).",
      "INTRO_WARNING_SECURITY": "Überprüfe, ob die Hardware, die du derzeit verwendest (Computer, Tablet, Telefon), <b>sicher und vertrauenswürdig</b> ist.",
      "INTRO_WARNING_SECURITY_HELP": "Aktueller Virenschutz, Firewall aktiviert, Sitzung durch Passwort oder PIN-Code geschützt...",
      "INTRO_HELP": "Klicke auf <b>{{'COMMON.BTN_START'|translate}}</b>, um mit der Erstellung eines Kontos zu beginnen. Du wirst Schritt für Schritt angeleitet.",
      "REGISTRATION_NODE": "Ihre Registrierung wird über den Duniter-Knoten <b>{{server}}</b> durchgeführt und anschließend an den Rest des Währungsnetzwerks verteilt.",
      "REGISTRATION_NODE_HELP": "Wenn du diesem Knoten nicht vertraust, wähle bitte <a ng-click=\"doQuickFix('settings')\">in den Einstellungen</a> einen Anderen.",
      "SELECT_ACCOUNT_TYPE": "Wähle die Art des zu eröffnenden Kontos:",
      "SLIDE_1_TITLE": "Wähle eine Währung aus:",
      "SLIDE_2_TITLE": "Kontoart:",
      "MEMBER_ACCOUNT": "Persönliches Konto (Mitglied)",
      "MEMBER_ACCOUNT_TITLE": "Mitgliedskonto eröffnen",
      "MEMBER_ACCOUNT_HELP": "Wenn du noch nicht als Mensch / Person registriert bist (es ist nur ein Mitgliedskonto pro Individuum möglich).",
      "WALLET_ACCOUNT": "Einfaches Konto (Brieftasche)",
      "WALLET_ACCOUNT_TITLE": "Brieftasche eröffnen",
      "WALLET_ACCOUNT_HELP": "Wenn du für ein Unternehmen, eine Stiftung, einen Verein etc. agierst oder einfach ein weiteres Konto benötigst. Durch dieses Konto wird keine universelle Dividende geschöpft werden.",
      "SALT_WARNING": "Wähle einen sicheren Benutzernamen.<br/>Diesen brauchst du für jedes Anmelden an deinem Konto.<br/><br/><b>Stelle sicher, dass du ihn gut behalten kannst</b>.<br/>Einmal verloren gegangen, gibt es keine Möglichkeit, deine Zugangsdaten wiederherzustellen!",
      "PASSWORD_WARNING": "Wähle ein sicheres Passwort.<br/>Das brauchst für jede Anmeldung an deinem Konto.<br/><br/><b>Stelle sicher, dass du es gut behalten kannst (aufschreiben, sicher ablegen, einfach zu merken, aber trotzdem sicher ...).</b>.<br/>Einmal verloren, gibt es keinen Weg, um deine Zugangsdaten wiederherzustellen!",
      "PSEUDO_WARNING": "Wähle ein Pseudonym.<br/>Es wird benötig, damit dich andere Mitglieder einfach finden können.<br/><br/>.Die Verwendung von Leerzeichen, Kommata und Akzenten ist nicht erlaubt.<br/><div class='hidden-xs'><br/>Ein Beispiel: <span class='gray'>ErikaMustermann, Peter192, SuperMann etc.</span>",
      "PSEUDO": "Pseudonym",
      "PSEUDO_HELP": "joe123",
      "SALT_CONFIRM": "Bestätigen",
      "SALT_CONFIRM_HELP": "Bestätige deinen Benutzernamen",
      "PASSWORD_CONFIRM": "Bestätigen",
      "PASSWORD_CONFIRM_HELP": "Bestätige dein Passwort",
      "SLIDE_6_TITLE": "Bestätigung:",
      "COMPUTING_PUBKEY": "Berechnung des öffentlichen Schlüssels ...",
      "LAST_SLIDE_CONGRATULATION": "Bravo! Du hast alle benötigten Felder ausgefüllt.<br/>Jetzt kannst du deinen <b>Kontoantrag abschicken</b>.<br/><br/>Zur Information: mit dem öffentlichen Schlüssel wird in Zukunft dein Konto identifiziert.<br/>Du kannst diesen an Dritte weitergeben um Zahlungen zu erhalten. Sobald das Konto erfolgreich eingerichtet ist, findest du den öffentlichen Schlüssel unter <b>{{'ACCOUNT.TITLE'|translate}}</b>.",
      "CONFIRMATION_MEMBER_ACCOUNT": "<b class=\"assertive\">WARNUNG:</b> Deine Zugangsdaten aus Benutzernamen, Passwort und das Pseudonym können nach dem Anlegen nicht mehr verändert werden.<br/><b>Stelle sicher, dass du diese Daten gut verwahrst!</b><br/><b>Bist du dir sicher,</b> dass du dien persönliche Kontoanfrage abschicken möchtest?",
      "CONFIRMATION_WALLET_ACCOUNT": "<b class=\"assertive\">WARNUNG:</b> Deine Zugangsdaten aus Benutzername und Passwort können nach Anlegen des Kontos nicht mehr geändert werden.<br/><b>Stelle sicher, dass du sie sicher aufbewahrst / behältst!</b><br/><b>Bist du dir sicher, dass du </b> jetzt die Konotanfrage abschicken willst?",
      "CHECKING_PSEUDO": "Überprüfe...",
      "PSEUDO_AVAILABLE": "Dieses Pseudonym ist verfügbar",
      "PSEUDO_NOT_AVAILABLE": "Diesies Pseudonym ist nicht möglich",
      "INFO_LICENSE": "Wenn du dich an dieser Währung beteiligen möchtest, bitten wir dich, die Lizenz zu lesen und zu akzeptieren.",
      "BTN_ACCEPT": "Ich akzeptiere",
      "BTN_ACCEPT_LICENSE": "Ich bin mit der Lizenz einverstanden"
    },
    "POPUP_REGISTER": {
      "TITLE": "Bitte ein Pseudonym eintragen",
      "HELP": "Das Pseudonym ist nötig, damit andere dich/dein Konto finden können."
    },
    "SELECT_IDENTITY_MODAL": {
      "TITLE": "Auswahl der Identität",
      "HELP": "Mehrere <b>unterschiedliche Identitäten</b> wurden für den öffentlichen Schlüssel <span class=\"gray\"> <i class=\"ion-key\"></i> {{pubkey | formatPubkey}}</span> gesendet.<br/>Bitte wählen Sie die zu verwendende Identität aus:"
    },
    "SELECT_WALLET_MODAL": {
      "TITLE": "Auswahl der Brieftasche"
    },
    "CERTIFICATION_MODAL": {
      "CHECKLIST_TITLE": "Prüfungen vor der Zertifizierung",
      "INFOS": "Die Sicherheit der Währung Ğ1 basiert auf jedem Mitglied. Bevor Sie die Identität dieser Person zertifizieren, müssen Sie einige Überprüfungen vorgenommen haben. Bitte beantworten Sie die folgenden Fragen:",
      "BTN_ALL_CHECK": "Zertifizieren",
      "CHECKLIST_CONDITIONS_NOT_MET": "Die Zertifizierung wurde nicht gesendet. Die Überprüfungen scheinen unzureichend zu sein. Bitte überprüfen Sie jeden Punkt erneut bei der zu zertifizierenden Person.",
      "QUESTIONS": {
        "WELL_KNOWN": "Kennen Sie die Person, die Sie zertifizieren, <b>gut</b>, und kennen Sie auch andere, die sie gut kennen?",
        "REVOCATION": "Hat sie ihr <b>Widerrufsdokument</b> heruntergeladen und weiß sie, wo sie es finden kann?",
        "CONTACT": "Haben Sie diese Person auf verschiedene Weise <b>kontaktiert</b>, und hat sie Ihnen geantwortet?",
        "DOUBLE_IDENTITY": "Die Person muss <b>nur eine aktive Mitgliedsidentität</b> haben. Hat sie <b>eine andere</b>?",
        "MASTER_ACCOUNT": "Kontrolliert sie ihr Konto und hat sie mindestens <b>eine Überweisung</b> von diesem Konto getätigt?",
        "LICENSE": "Hat sie die <b>Lizenz verstanden</b>, und stimmt sie zu, sie bei der Zertifizierung anderer Mitglieder einzuhalten?",
        "CREDENTIALS": "Sind der Geheimer Benutzername und das Passwort ihres Kontos <b>lang und komplex</b> (Passphrasen)? Hat sie verstanden, dass der Benutzername auch geheim bleiben muss? Ist sie <b>sicher, sich daran zu erinnern</b> oder in der Lage, sie wiederzufinden?",
        "PUBLIC_KEY_DIFFERENT": "Der angegebene <b>öffentliche Schlüssel</b> muss <b>identisch</b> sein mit dem, den Ihnen diese Person mitgeteilt hat. Sind die Schlüssel <b>unterschiedlich</b>?"
      },
      "REMINDER_TITLE": "Erinnerung",
      "SHORT_LICENSE_REMINDER": "Sie können die zertifizierte Person an die Zertifizierungsparameter erinnern:<br/><br/><ul><li> - Jedes Mitglied kann maximal 100 gültige Zertifikate ausstellen.</li><li>- Die Zertifikate werden in Abständen von 5 Tagen aufgezeichnet.</li><li> - Eine neue Mitgliedsidentität muss in weniger als zwei Monaten mindestens 5 Zertifikate sammeln.</li><li> - Ein Mitglied muss seine Mitgliedschaft jedes Jahr erneuern.</li><li> - Zertifikate sind zwei Jahre gültig.</li></ul>"
    },
    "WALLET_LIST": {
      "TITLE": "Meine Brieftaschen",
      "BTN_NEW": "Eine Brieftasche hinzufügen",
      "BTN_DOWNLOAD": "Liste herunterladen",
      "BTN_IMPORT_FILE_DOTS": "Aus Datei importieren...",
      "NO_WALLET": "Keine sekundäre Brieftasche",
      "BTN_DELETE": "Eine sekundäre Brieftasche entfernen...",
      "BTN_RENAME": "Brieftasche umbenennen",
      "EXPORT_FILENAME": "my_wallets-{{pubkey|formatPubkey}}-{{currency}}.csv",
      "TOTAL_DOTS": "Gesamt: ",
      "EDIT_POPOVER": {
        "TITLE": "Brieftasche umbenennen",
        "HELP": "Gib den neuen Namen ein",
        "NAME_HELP": "Name der Brieftasche"
      },
      "IMPORT_MODAL": {
        "TITLE": "Sekundäre Brieftaschen importieren",
        "HELP": "Um <b>sekundäre Brieftaschen zu importieren</b>, ziehen Sie bitte die Datei in das Feld unten oder klicken Sie in das Feld, um nach einer Datei zu suchen.",
        "WALLET_COUNT": "<b>{{count}}</b> neue Brieftasche{{count > 1 ? 'n' : ''}}",
        "NO_NEW_WALLET": "Keine neue Brieftaschen"
      }
    },
    "SECURITY":{
      "ADD_QUESTION" : "Füge eine benutzerdefinierte Frage hinzu",
      "BTN_CLEAN" : "Leeren",
      "BTN_RESET" : "Zurücksetzen",
      "DOWNLOAD_REVOKE": "Speichere eine Sperrdatei",
      "DOWNLOAD_REVOKE_HELP" : "Eine Sperrdatei ist wichtig, zum Beispiel bei Verlust von Zugangsdaten. Sie ermöglicht dir, <b>dieses Konto aus dem Netz des Vertrauens herauszuholen</b> und es zu einer einfachen Brieftasche zu machen.",
      "GENERATE_KEYFILE": "Meine Schlüsselbund-Datei generieren ...",
      "GENERATE_KEYFILE_HELP": "Generiere eine Datei, mit der du dich authentifizieren kannst, ohne deine Zugangsdaten einzugeben.<br/><b>Warnung:</b> Diese Datei enthält Ihren geheimen Schlüssel. Es ist daher sehr wichtig, sie an einem sicheren Ort aufzubewahren!",
      "KEYFILE_FILENAME": "keychain-{{pubkey|formatPubkey}}-{{currency}}-{{format}}.dunikey",
      "MEMBERSHIP_IN": "Als Mitglied registrieren...",
      "MEMBERSHIP_IN_HELP": "Ermöglicht es dir, ein einfaches Brieftaschen-Konto <b>in ein Mitgliedskonto umzuwandeln</b>, indem du eine Mitgliedschaftsanfrage sendest. Nur erlaubt, wenn du noch kein anderes Mitgliedskonto hast.",
      "SEND_IDENTITY": "Pseudonym veröffentlichen...",
      "SEND_IDENTITY_HELP": "Ermöglicht es dir, diesem Konto ein Pseudonym zuzuordnen, aber <b>ohne eine Mitgliedschaft zu beantragen</b>. Dies ist nicht sehr sinnvoll, da die Gültigkeit dieser Pseudonymzuordnung zeitlich begrenzt ist.",
      "HELP_LEVEL": "Wählen Sie <strong> mindestens {{nb}} Fragen </strong>:",
      "LEVEL": "Sicherheitsstufe",
      "LOW_LEVEL": "Gering <span class=\"hidden-xs\">(2 Fragen Minimum)</span>",
      "MEDIUM_LEVEL": "Mittel <span class=\"hidden-xs\">(4 Fragen Minimum)</span>",
      "QUESTION_1": "Wie hieß dein(e) beste(r) Freund(in) als Teenager?",
      "QUESTION_2": "Wie hieß dein erstes Haustier?",
      "QUESTION_3": "Was war das erste Gericht, das du kochen konntest?",
      "QUESTION_4": "Was war der erste Film, den Du im Kino gesehen hast?",
      "QUESTION_5": "Wohin ging deine erste Flugreise?",
      "QUESTION_6": "Wie hieß dein(e) liebste(r) Grundschullehrer(in)?",
      "QUESTION_7": "Was wäre für Dich die ideale Arbeit?",
      "QUESTION_8": "Welches Kinderbuch magst du am liebsten?",
      "QUESTION_9": "Von welchem Modell war Dein erstes Auto?",
      "QUESTION_10": "Welchen Spitznamen hattest du als Kind?",
      "QUESTION_11": "Wer war dein liebster Kinoschauspieler oder Filmcharakter als du Student warst?",
      "QUESTION_12": "Wer war dein(e) liebst(er) Sänger(in) oder Band als du Student warst?",
      "QUESTION_13": "In welcher Stadt fanden sich deine Eltern?",
      "QUESTION_14": "Wie hieß dein erster Chef?",
      "QUESTION_15": "Wie hieß die Straße in der du aufgewachsen bist?",
      "QUESTION_16": "Wie hieß der erste Strand an dem du schwimmen warst?",
      "QUESTION_17": "Wie hieß das erste Album, das du gekauft hast?",
      "QUESTION_18": "Wie heißt deine liebste Sportmannschaft?",
      "QUESTION_19": "Welcher Arbeit ging dein Großvater nach?",
      "RECOVER_ID": "Mein Passwort wiederherstellen...",
      "RECOVER_ID_HELP": "Wenn du eine <b>Sicherungsdatei deiner Zugangsdaten</b> hast, kannst du diese wiederherstellen, indem du deine persönlichen Fragen richtig beantwortest.",
      "RECOVER_ID_SELECT_FILE": "Wähle die <b>Sicherungsdatei deiner Zugangsdaten</b>:",
      "REVOCATION_WITH_FILE" : "Widerrufe mein Mitgliedskonto...",
      "REVOCATION_WITH_FILE_DESCRIPTION": "Wenn du <b>deine Mitgliedskonto-Zugangsdaten dauerhaft verloren hast (oder wenn die Kontosicherheit gefährdet ist), kannst du <b>die Widerrufsdatei</b> des Kontos verwenden, <b>um das Netz des Vertrauens zu verlassen</b>.",
      "REVOCATION_WITH_FILE_HELP": "Um ein Mitgliedskonto <b>dauerhaft zu widerrufen</b>, ziehe bitte die Widerrufsdatei in das Feld unten oder klicke in das Feld, um nach einer Datei zu suchen.",
      "REVOCATION_WALLET": "Dieses Konto sofort widerrufen",
      "REVOCATION_WALLET_HELP": "Die Anforderung des Widerrufs Ihrer Identität führt dazu, dass <b>Ihre Mitgliedschaft widerrufen wird</b> (auf jeden Fall für das zugehörige Pseudonym und den öffentlichen Schlüssel). Das Konto ist dann nicht mehr in der Lage, eine Universaldividende zu produzieren.<br/>Sie können es jedoch weiterhin als einfache Brieftasche verwenden.",
      "REVOCATION_FILENAME": "revocation-{{uid}}-{{pubkey|formatPubkey}}-{{currency}}.txt",
      "SAVE_ID": "Meine Zugangsdaten speichern...",
      "SAVE_ID_HELP": "Erstellen einer Sicherungsdatei, um <b>dein Passwort</b> (und den geheimen Benutzernamen) <b>wiederzuerlangen, falls du es vergisst</b>. Die Datei ist mit personenbezogenen Fragen <b>gesichert</b> (verschlüsselt).",
      "STRONG_LEVEL": "Hoch <span class=\"hidden-xs \">(6 Fragen Minimum)</span>",
      "TITLE": "Konto and Sicherheit",
      "KEYFILE": {
        "PUBSEC_FORMAT": "PubSec Format.",
        "PUBSEC_FORMAT_HELP": "Dieses Dateiformat ist insbesondere mit Cesium und Gannonce kompatibel. Ihr Schlüsselbund wird <b>unverschlüsselt</b> gespeichert: Jeder, der eine Kopie dieser Datei besitzt, kann Ihr Konto ausräumen.",
        "WIF_FORMAT": "Wallet Import Format (WIF)",
        "WIF_FORMAT_HELP": "Dieses Format wird insbesondere von &quot;Paper Wallets&quot; verwendet. Ihr Schlüsselbund wird <b>unverschlüsselt</b> gespeichert: Jeder, der eine Kopie dieser Datei besitzt, kann Ihr Konto ausräumen.",
        "EWIF_FORMAT": "Encrypted Wallet Import Format (WIF)",
        "EWIF_FORMAT_HELP": "Dieses Format wird insbesondere von &quot;Paper Wallets&quot; verwendet. <b>Der Schlüsselbund ist jedoch verschlüsselt</b>, mit einer Passphrase deiner Wahl.",
        "PASSWORD_POPUP": {
          "TITLE": "Verschlüsselter Schlüsselbund",
          "HELP": "Bitte gib eine Passphrase ein:",
          "PASSWORD_HELP": "Passphrase"
        },
        "ERROR": {
          "BAD_PASSWORD": "Falsche Passphrase",
          "BAD_CHECKSUM": "Falsche Prüfsumme"
        }
      }
    },
    "FILE_NAME": "{{currency}} - Kontozusammenfassung {{pubkey|formatPubkey}} {{currentTime|formatDateForFile}}.csv",
    "HEADERS": {
      "TIME": "Datum",
      "AMOUNT": "Betrag",
      "COMMENT": "Kommentar"
    }
  },
  "TRANSFER": {
    "TITLE": "Überweisung",
    "SUB_TITLE": "Geld überweisen",
    "SUB_TITLE_ALL": "Das Konto leeren",
    "FROM": "Von",
    "TO": "An",
    "AMOUNT": "Betrag",
    "AMOUNT_HELP": "Betrag",
    "COMMENT": "Kommentar",
    "COMMENT_HELP": "Kommentar (optional)",
    "BTN_SEND": "Senden",
    "BTN_ADD_COMMENT": "Kommentar hinzufügen",
    "REST": "Restbetrag des Kontos",
    "REST_TO": "an",
    "WARN_COMMENT_IS_PUBLIC": "Bitte bedenke, dass <b>Kommentare öffenlich einsehbar sind </b> (nicht verschlüsselt).",
    "MODAL": {
      "TITLE": "Überweisung"
    }
  },
  "ERROR": {
    "UNKNOWN_URI_FORMAT": "Unbekanntes URI Format",
    "PUBKEY_INVALID_CHECKSUM": "Ungültiger öffentlicher Schlüssel (falsche Prüfsumme).",
    "POPUP_TITLE": "Fehler",
    "UNKNOWN_ERROR": "Unbekannter Fehler",
    "TIMEOUT_REACHED": "Zeitüberschreitung des Knotens überschritten ({{timeout|formatDurationMs}}).<br/><br/><small>{{url}}</small>",
    "CRYPTO_UNKNOWN_ERROR": "Dein Browser ist nicht kompatibel mit kryptographischen Eigenschaften.",
    "DOWNLOAD_KEYFILE_FAILED": "Die Schlüsselbunddatei konnte nicht generiert werden.",
    "EQUALS_TO_PSEUDO": "Muss sich vom Pseudonym unterscheiden",
    "EQUALS_TO_SALT": "Muss sich vom geheimen Benutzernamen unterscheiden",
    "FIELD_REQUIRED": "Das ist eine Pflichteingabe.",
    "FIELD_TOO_SHORT": "Der eingetragene Wert hat zu wenige Zeichen (min {{minLength]] characters).",
    "FIELD_TOO_SHORT_WITH_LENGTH": "Das Eingabefeld ist zu kurz.",
    "FIELD_TOO_LONG": "Die Eingabe überschreitet die maximale Länge.",
    "FIELD_TOO_LONG_WITH_LENGTH": "Der Eintrag ist zu lang (max {{maxLength}} Zeichen).",
    "FIELD_MIN": "Minimalwert: {{min}}",
    "FIELD_MAX": "Maximalwert: {{max}}",
    "FIELD_ACCENT": "Kommata, Leerzeichen und Akzente sind nicht erlaubt.",
    "FIELD_NOT_NUMBER": "Der eingetragene Wert ist keine Zahl",
    "FIELD_NOT_INT": "Der Wert ist keine ganze Zahl",
    "FIELD_NOT_EMAIL": "E-Mail-Adresse ist ungültig",
    "PASSWORD_NOT_CONFIRMED": "Deine Eingabe passt nicht zum vorhergehenden Passwort.",
    "SALT_NOT_CONFIRMED": "Die Wiederholung passt nicht zur vorhergehenden Eingabe.",
    "SEND_IDENTITY_FAILED": "Es ist ein Fehler bei der Registrierung aufgetreten.",
    "SEND_CERTIFICATION_FAILED": "Die Zertifizierung konnte nicht durchgeführt werden.",
    "NEED_MEMBER_ACCOUNT_TO_CERTIFY": "Du kannst nicht zertifizieren, weil <b>dein Konto kein Mitgliedskonsot ist</b>.",
    "NEED_MEMBER_ACCOUNT_TO_CERTIFY_HAS_SELF": "Du konntest die Zertifizierung noch nicht absenden, weil du <b>noch nicht Mitglied bist. </b><br/>Du brauchst noch selbst Zertifizierungen, um Mitglied zu werden.",
    "IDENTITY_TO_CERTIFY_HAS_NO_SELF": "Dieses Konto konnte nicht zertifiziert werden. Es wurde keine Registrierung gefunden oder es muss erneuert werden.",
    "LOGIN_FAILED": "Fehler beim Einloggen.",
    "LOAD_IDENTITY_FAILED": "Diese Identität konnte nicht geladen werden.",
    "LOAD_REQUIREMENTS_FAILED": "Es konnten keine Bedingungen geladen werden.",
    "SEND_MEMBERSHIP_IN_FAILED": "Es ist ein Fehler bei der Registrierung als Mitglied aufgetreten.",
    "SEND_MEMBERSHIP_OUT_FAILED": "Es ist ein Fehler beim Widerruf des Mitgliedsstatus aufgetreten.",
    "REFRESH_WALLET_DATA": "Das Konto konnte nicht neu geladen werden.",
    "GET_CURRENCY_PARAMETER": "Die Währungsparameter konnten nicht geladen werden.",
    "GET_CURRENCY_FAILED": "Die Währung konnte nicht geladen werden.",
    "SEND_TX_FAILED": "Die Tansaktion konnte nicht abgeschlossen werden.",
    "ALL_SOURCES_USED": "Bitte warte bis der nächste Block berechnet wird (alle Transaktionressourcen sind gerade verbraucht).",
    "NOT_ENOUGH_SOURCES": "Es ist nicht genug Geld auf dem Konto um jetzt diese Summe zu überweisen.<br/>Maximale Summe: {{amount}} {{unit}}<sub>{{subUnit}}</sub>.",
    "ACCOUNT_CREATION_FAILED": "Es gab einen Fehler beim Anlegen deines Mitgliedskontos.",
    "RESTORE_WALLET_DATA_ERROR": "Es gab einen Fehler beim Einlesen der Einstellung aus dem lokalen Speicher",
    "LOAD_WALLET_DATA_ERROR": "Es gab einen Fehler beim Laden der Kontodaten.",
    "COPY_CLIPBOARD_FAILED": "Daten konnten nicht in die Zwischenablage kopiert werden",
    "TAKE_PICTURE_FAILED": "Es konnte kein Bild geladen werden.",
    "SCAN_FAILED": "Der QR-Code konnte nicht gescannt werden.",
    "SCAN_UNKNOWN_FORMAT": "QR-Code wurde nicht erkannt.",
    "WOT_LOOKUP_FAILED": "Die Suche ist fehlgeschlagen.",
    "LOAD_PEER_DATA_FAILED": "Der gewählte Duniter-Knoten ist nicht erreichbar, versuche es später noch einmal.",
    "NEED_LOGIN_FIRST": "Bitte logge dich zuerst ein.",
    "AMOUNT_REQUIRED": "Es muss ein Betrag angegeben werden.",
    "AMOUNT_NEGATIVE": "Negative Werte sind nicht möglich.",
    "NOT_ENOUGH_CREDIT": "Du hast nicht genug Guthaben.",
    "INVALID_NODE_SUMMARY": "Der Netzknoten ist nicher erreichbar oder die Adresse existiert nicht",
    "INVALID_USER_ID": "Die Eingabe für 'Pseudonym' darf keine Leerzeichen oder Sonderzeichen enthalten.",
    "INVALID_COMMENT": "Die Eingabe für 'reference' hat das falsche Format.",
    "INVALID_PUBKEY": "Der öffentliche Schlüssel hat das falsche Format.",
    "INVALID_PUBKEY_CHECKSUM": "Ungültige Prüfsumme.",
    "IDENTITY_REVOKED": "Diese Identität wurde <b>widerrufen</b>. Sie kann nicht mehr Mitglied werden.",
    "IDENTITY_REVOKED_WITH_TIME": "Diese Identität <b>wurde widerrufen {{revocationTime|medianFromNow}}</b> ({{revocationTime|medianDate}}). Sie kann nicht mehr Mitglied werden.",
    "IDENTITY_PENDING_REVOCATION": "Der <b>Widerruf dieser Identität</b> wurde beantragt und wartet auf Bearbeitung. Zertifizierung ist daher deaktiviert.",
    "IDENTITY_INVALID_BLOCK_HASH": "Dieser Mitgliedsstatus ist nicht länger gültig (weil er sich auf einen von den Netzknoten gelöschten Block bezieht): diese Person muss seine Mitgliedschaft erneuern <b>bevor</b> sie zertifiziert werden kann.",
    "IDENTITY_EXPIRED": "Diese Identität ist abgelaufen: diese Person muss sich neu registrieren <b>bevor</b> sie zertifiziert werden kann.",
    "IDENTITY_SANDBOX_FULL": "Registrierung nicht möglich, weil die Sandbox des genutzten Knotens voll ist.<br/><br/>Versuche es später erneut oder wähle einen anderen Duniter-Knoten (in den <b>Einstellungen</b>).",
    "IDENTITY_NOT_FOUND": "Identität nicht gefunden",
    "IDENTITY_TX_FAILED": "Fehler beim Laden der Transaktion dieser Identität",
    "WOT_PENDING_INVALID_BLOCK_HASH": "Diese Mitgliedschaft ist ungültig.",
    "WALLET_INVALID_BLOCK_HASH": "Deine Mitgliedschaft ist nicht mehr gültig (sie referenziert einen gelöschten Block).<br/>Du musst <a ng-click=\"doQuickFix('renew')\">deine Mitgliedsregistrierungerneuern</a> um dieses Problem zu lösen.",
    "WALLET_IDENTITY_EXPIRED": "Die Veröffentlichung deiner Identität <b>ist abgelaufen</b>.<br/>Du musst <a ng-click=\"doQuickFix('fixIdentity')\">deine Identität neu beantragen</a> um das Problem zu lösen.",
    "WALLET_REVOKED": "Deine Identität wurde <b>widerrufen</b>: weder dein Pseudonym noch dein öffentlicher Schlüssel werden in der Zukunft für ein Mitgliedskonto benutzt werden.",
    "WALLET_HAS_NO_SELF": "Deine Identität muss erst veröffentlicht sein und darf nicht abgelaufen sein.",
    "AUTH_REQUIRED": "Authentifizierung erforderlich.",
    "AUTH_INVALID_PUBKEY": "Der öffentliche Schlüssel entspricht nicht dem verbundenen Konto.",
    "AUTH_INVALID_SCRYPT": "Ungültiger Benutzername oder Passwort.",
    "AUTH_INVALID_FILE": "Ungültige Schlüsselbunddatei.",
    "AUTH_FILE_ERROR": "Konnte Schlüsselbunddatei nicht öffnen",
    "IDENTITY_ALREADY_CERTIFY": "Du hast dieses Konto / diese Persion <b>bereits zertifiziert</b>.<br/><br/>Deine Zertifizierung ist noch gültig (und verfällt in {{expiresIn|formatDuration}}).",
    "IDENTITY_ALREADY_CERTIFY_PENDING": "Du hst dieses Konto / diese Person <b>schon zertifiziert</b>.<br/><br/>Deine Zertifizierung ist noch nicht validiert worden (Letztes Datum für die Behandlung {{expiresIn|formatDuration}}).",
    "UNABLE_TO_CERTIFY_TITLE": "Zertifizieren nicht möglich",
    "LOAD_NEWCOMERS_FAILED": "Laden neuer Mitglieder nicht möglich.",
    "LOAD_PENDING_FAILED": "Laden anstehender Mitgliedsregistrierungen nicht möglich.",
    "ONLY_MEMBER_CAN_EXECUTE_THIS_ACTION": "Du musst <b>ein Mitglied sein</b>, um diese Aktion ausführen zu können.",
    "ONLY_MEMBER_OR_WAS_MEMBER_CAN_EXECUTE_THIS_ACTION": "Du musst <b>ein Mitglied (oder ehemaliges Mitglied) sein</b>, um diese Aktion ausführen zu können.",
    "ONLY_SELF_CAN_EXECUTE_THIS_ACTION": "Du musst deine <b>Identität veröffentlicht haben</b> um diese Aktion machen zu können.",
    "GET_BLOCK_FAILED": "Fehler beim Holen eines Blocks",
    "INVALID_BLOCK_HASH": "Block nicht gefunden (falscher Hashwert)",
    "DOWNLOAD_REVOCATION_FAILED": "Fehler beim Herunterladen der Widerrufsdatei.",
    "REVOCATION_FAILED": "Fehler bei dem Versuch, die Identität zu widerrufen.",
    "SALT_OR_PASSWORD_NOT_CONFIRMED": "Falscher geheimer Benutzername oder Passwort",
    "RECOVER_ID_FAILED": "Konnte Passwort nicht wiederherstellen",
    "LOAD_FILE_FAILED" : "Kann Datei nicht laden",
    "NOT_VALID_REVOCATION_FILE": "Ungültige Widerrufsdatei (falsches Dateiformat)",
    "NOT_VALID_SAVE_ID_FILE": "Ungültige Zugangsdatensicherungsdatei (falsches Dateiformat)",
    "NOT_VALID_KEY_FILE": "Ungültige Schlüsselbunddatei (unbekanntes Format)",
    "EXISTING_ACCOUNT": "Die von dir eingegebenen Daten passen zu einem bestehenden Konto mit diesem <a ng-click=\"showHelpModal('pubkey')\">öffentlichen Schlüssel</a>:",
    "EXISTING_ACCOUNT_REQUEST": "Bitte passe deine Zugangsdaten an, um dich mit einem nicht bereits vergebenen Konto zu verbinden.",
    "GET_LICENSE_FILE_FAILED": "Kann Lizenzdatei nicht laden",
    "CHECK_NETWORK_CONNECTION": "Kein Knoten scheint erreichbar zu sein.<br/><br/>Bitte <b>überprüfe deine Internetverbindung</b>.",
    "ISSUE_524_TX_FAILED": "Übertragung fehlgeschlagen.<br/><br/>Eine Nachricht wurde an die Entwickler übermittelt, um bei der Problemlösung zu helfen.<b>Vielen Dank für deine Hilfe</b>.",
    "ADD_SECONDARY_WALLET_FAILED": "Konnte sekundäre Brieftasche nicht hinzufügen.",
    "REMOVE_SECONDARY_WALLET_FAILED": "Konnte sekundäre Brieftasche nicht entfernen.",
    "UPDATE_WALLET_LIST_FAILED": "Konnte die Liste der Brieftaschen nicht aktualisieren.",
    "LOAD_WALLET_LIST_FAILED": "Konnte die Liste der Brieftaschen nicht laden.",
    "SAVE_WALLET_LIST_FAILED": "Konnte die Liste der Brieftaschen nicht speichern.",
    "COULD_NOT_ADD_MAIN_WALLET": "Diese Brieftasche <b>ist das Hauptkonto</b> mit dem du verbunden bist. Es kann daher nicht als sekundäre Brieftasche hinzugefügt werden.",
    "COULD_NOT_ADD_EXISTING_WALLET": "Diese Brieftasche ist bereits auf der Liste.",
    "UNKNOWN_WALLET_ID": "Unbekannte sekundäre Brieftasche.",
    "RESTORE_WALLET_LIST_FAILED": "Konnte die Liste der Brieftaschen nicht wiederherstellen.",
    "INVALID_FILE_FORMAT": "Ungültiges Dateiformat.",
    "SAME_TX_RECIPIENT": "Der Empfänger muss sich vom Auftraggeber unterscheiden."
  },
  "INFO": {
    "POPUP_TITLE": "Hinweis",
    "CERTIFICATION_DONE": "Die Zertifizierung wurde erfolgreich durchgeführt",
    "NOT_ENOUGH_CREDIT": "Es ist nicht genug Kredit vorhanden",
    "TRANSFER_SENT": "Überweisung erfolgreich durchgeführt",
    "COPY_TO_CLIPBOARD_DONE": "Eine Kopie wurde in der Zwischenablage angelegt",
    "MEMBERSHIP_OUT_SENT": "Widerruf des Kontos erfolgreich abgeschickt",
    "NOT_NEED_MEMBERSHIP": "Du bist schon ein Mitglied.",
    "IDENTITY_WILL_MISSING_CERTIFICATIONS": "Dieses Mitgliedskonto hat in Kürze ungültige Zertifizierungen (mindestens {{willNeedCertificationCount}} sind erforderlich).",
    "IDENTITY_NEED_MEMBERSHIP": "Diese Identität hat (noch) keinen Mitgliedsantrag gestellt. Sie wird das tun müssen, wenn sie einen Mitgliederstatus wünscht.",
    "HAS_ALTERNATIVE_IDENTITIES": "Mit diesem öffentlichen Schlüssel sind <b>mehrere Identitäten</b> verknüpft. <b>Vor jeder Zertifizierung</b>, <a ng-click=\"doQuickFix('showSelectIdentities')\">überprüfe bitte die anderen Identitäten</a>, um die richtige auszuwählen, oder wenden Sie sich an den Eigentümer der Brieftasche.",
    "REVOCATION_SENT": "Widerruf des Kontos abgeschickt",
    "REVOCATION_SENT_WAITING_PROCESS": "Widerruf des Kontos <b>erfolgreich abgeschickt</b>. Bearbeitung steht noch aus.",
    "FEATURE_NOT_AVAILABLE_ON_DEMO": "Diese Funktion ist auf der Demo-Version nicht verfügbar.<br/>Aus <b>Sicherheitsgründen</b> empfehlen wir dir, eine Kopie der Software zu <b>installieren</b>.<br/>Besuche die Webseite <a href='https://cesium.app'>www.cesium.app</a> für Hilfe und weitere Informationen.",
    "FEATURES_NOT_IMPLEMENTED": "Diese Funktion ist noch nicht implementiert.<br/><br/>Warum nicht mitwirken, um sie schneller zu erhalten? ;)",
    "EMPTY_TX_HISTORY": "Keine Tansaktionen für den Export vorhanden.",
    "LOADING_PENDING_TX": "Lade...<br/><small>(Abrufen von ausstehenden Operationen)</small>"
  },
  "CONFIRM": {
    "CAN_CONTINUE": "<b>Bist du sicher</b>, dass du fortfahren möchtest?",
    "POPUP_TITLE": "<b>Bestätigung</b>",
    "POPUP_WARNING_TITLE": "<b>WARNUNG</b>",
    "POPUP_SECURITY_WARNING_TITLE": "<i class=\"icon ion-alert-circled\"></i> <b>Sicherheits-Hinweis</b>",
    "CERTIFY_RULES_TITLE_UID": "Zertifiziere {{uid}}",
    "CERTIFY_RULES": "<b>Sicherheitswarnung:</b><br/><br/><b class=\"assertive\">Zertifiziere ein Konto nicht</b> wenn du glaubst, dass: <ul><li>1.) der Anfragende kein echter Mensch ist.<li>2.) der Anfragende bereits ein registriertes Mitgliedskonto hat.<li>3.) der Anfragende absichtlich oder unwissendlich die Regel 1 oder 2 durch Erteilen von Zertifizierungen misachtet.</ul></small><br/>Bist du dir sicher, dass du dieses Konto zertifizieren willst?",
    "FULLSCREEN": "Anwendung im Vollbild anzeigen?",
    "EXIT_APP": "Anwendung schließen?",
    "TRANSFER": "<b>Zusammenfassung der Überweisung:</b><br/><br/><ul><li> - Von: <b>{{from}}</b></li><li> - An: <b>{{to}}</b></li><li> - Betrag: <b>{{amount}} {{unit}}</b></li><li> - Kommentar: <i>{{comment}}</i></li></ul><br/><b>Bist du dir sicher, dass du diese Überweisung ausführen willst?</b>",
    "TRANSFER_ALL": "<b>Zusammenfassung der Überweisung:</b><br/><br/><ul><li> - Von: <b>{{from}}</b></li><li> - An: <b>{{to}}</b></li><li> - Betrag: <b>{{amount}} {{unit}}</b></li><li> - Kommentar: <i>{{comment}}</i></li><br/><li> - Rest : <b>{{restAmount}} {{unit}}</b> an <b>{{restTo}}</b></li></ul><br/><b>Bist du dir sicher, dass du diese Überweisung ausführen willst?</b>",
    "MEMBERSHIP_OUT": "<b>WARNUNG</b>:<br/>Du bist gerade dabei, deine Mitgliedschaft zu beenden. Das lässt sich <b>nicht rückgängig machen</b>.<br/></br/><b>Bist du dir sicher, dass du das das Mitgliedskonto löschen möchtest?</b>",
    "MEMBERSHIP_OUT_2": "Dieser Vorgang ist <b>unumkehrbar</b>!<br/><br/>Bist du sicher, dass du <b>deine Mitgliedschaft beenden</b> möchtest?",
    "LOGIN_UNUSED_WALLET_TITLE": "Tippfehler?",
    "LOGIN_UNUSED_WALLET": "Du scheinst in ein <b>nicht aktives Konto</b> eingeloggt zu sein.<br/><br/>Wenn dieses Konto nicht deins ist, liegt die Ursache wahrscheinlich in einem <b>Tippfehler bei der Eingabe</b> der Benutzerdaten.<br/><br/><b>Willst du dennoch mit diesem Konto weitermachen?</b>",
    "FIX_IDENTITY": "Das Pseudonym <b>{{uid}}</b> wird erneut veröffentlicht, wodurch die alte Veröffentlichung ersetzt wird.<br/></br/><b>Bist du sicher, </b> dass du weitermachen willst?",
    "FIX_MEMBERSHIP": "Dein Mitgliedsantrag wird abgeschickt.<br/></br/><b>Bist du dir sicher?</b>",
    "MEMBERSHIP": "Dein Mitgliedsantrag wird verschickt. <br/></br/><b>Bist du sicher?</b>",
    "RENEW_MEMBERSHIP": "Deine Mitgliedschaft wird verlängert.<br/></br/><b>Bist du dir sicher?</b>",
    "REVOKE_IDENTITY": "<b>Sicherheitshinweis:</b><br/>Du bist gerade dabei <b>endgültig und unwiderruflich deine Identität zu widerrufen</b>.<br/><br/>Dieser öffentliche Schlüssel und dein damit verknüpftes Pseudonym kann  <b>nie wieder benutzt werden</b> (für ein Mitgliedskonto).<br/></br/><b>Bist du dir sicher</b> fortzufahren?",
    "REVOKE_IDENTITY_2": "Diese Aktion kan man <b>nicht rückgängig machen</b>!<br/><br/><b>Bist du sicher</b> das du das willst?",
    "NOT_NEED_RENEW_MEMBERSHIP": "Deine Mitgliedschaft braucht jetzt nicht verlängert werden (sie wird erst auslaufen nach {{membershipExpiresIn|formatDuration}}).<br/></br/><b>Bist du sicher</b> das du jetzt eine Verlängerung beantragen willst?",
    "SAVE_BEFORE_LEAVE": "Möchtest du deine <b>Änderungeung abspeichern</b> bevor du diese Seite verlässt?",
    "SAVE_BEFORE_LEAVE_TITLE": "Änderungen nicht speichern",
    "LOGOUT": "Sicher, dass du dich abmelden möchtest?",
    "USE_FALLBACK_NODE": "Knoten <b>{{old}}</b> ist nicht erreichbar.<br/><br/>Möchtest du temporär den Knoten <b>{{new}}</b> verwenden?",
    "USE_SYNC_FALLBACK_NODE": "Knoten <b>{{old}}</b> scheint nicht synchronisiert zu sein.<br/><br/>Möchten Sie vorübergehend den synchronisierten Knoten <b>{{new}}</b> verwenden?",
    "ISSUE_524_SEND_LOG": "Die Transaktion wurde aufgrund eines bekannten Problems (issue #524) zurückgewiesen. Die Ursache ist bisher unbekannt.<br/>Akzeptierst du <b>die Übertragung deiner Logdaten</b> als Nachricht, um den Entwicklern bei der Korrektur zu helfen?<br/><small>(Dies beinhaltet keine vertraulichen Daten)</small><br/>",
    "LICENCE": "Ich habe die die Lizenz des G1 gelesen und akzeptiert",
    "ENABLE_EXPERT_MODE_TO_CHANGE_NODE": "<b class=\"assertive\">Warnung:</b> Möchten Sie den Knoten <b>manuell ändern</b>?<br/><br/>Wenn Sie fortfahren:<ul><li> - Der <b>Expertenmodus</b> wird aktiviert;</li><li> - Sie können zur automatischen Knotenauswahl zurückkehren, indem Sie einfach den <b>Expertenmodus deaktivieren</b>.</li></ul>"
  },
  "MODE": {
    "DEMO": {
      "BADGE": "Demo",
      "MODE": "Demonstrationsmodus",
      "FEATURE_NOT_AVAILABLE": "Einige Funktionen sind auf dieser Demo-Seite <b>nicht verfügbar</b>.",
      "MODE_HELP": "Cesium arbeitet im <b>Demonstrationsmodus</b>: Einsicht in Konten ist verfügbar, jedoch können keine Vorgänge angestoßen werden.",
      "INSTALL_HELP": "Aus <b>Sicherheitsgründen</b> empfehlen wir, deine <b>eigene Kopie</b> der Software zu <b>installieren</b>.<br/> Besuche die Seite <a href='https://cesium.app'>www.cesium.app</a> für weitere Hilfe."
    },
    "READONLY": {
      "BADGE": "Monit",
      "MODE": "Überwachungsmodus",
      "MODE_HELP": "Cesium arbeitet im <b>Überwachungsmodus</b>: ausschließlich Funktionen zur Überwachung der Währung sind verfügbar.",
      "INSTALL_HELP": "Falls du <b>eine Brieftasche anlegen</b> möchtest, um Geld zu transferieren, empfehlen wir, deine <b>eigene Kopie</b> der Software zu <b>installieren</b>.<br/> Besuche die Seite <a href='https://cesium.app'>www.cesium.app</a> für weitere Hilfe."
    }
  },
  "DOWNLOAD": {
    "POPUP_TITLE": "<b>Widerrufsdatei</b>",
    "POPUP_REVOKE_MESSAGE": "Um dein Konto abzusichern, lade dir die <b>Widerrufsdaten für das Konto</b> herunter. Diese benötigst du, um dein Konto aufzulösen, wenn dein Konto gestohlen, eine Veränderung der Identität oder unberechtigt eröffnet wurde.<br/><br/><b>Verwahre die Widerrufsdatei an einem sicheren Platz auf. Es iste eine einfache Textdatei: drucke sie aus und bewahre den Ausdruck so auf, dass du ihn wiederfindest.</b>"
  },
  "HELP": {
    "TITLE": "Online Hilfe",
    "JOIN": {
      "SECTION": "Mitglied werden",
      "SALT": "Deine Benutzerkennung ist sehr wichtigt. Sie wird gebraucht, um dein Passwort zu verschlüsseln, welches wiederum gebraucht wird, um <span class=\"text-italic\">den öffentlichen Schlüssel</span> deines Kontos (quasi die Kontonummer) und den privaten Schlüssel für den Zugang zum Konto zu berechnen. <b>Merke dir die Benutzerkennung sehr gut, oder schreibe sie auf und bewahre sie an einem sicheren Ort auf</b>, es gibt keinen Weg, um deine Zugangsdaten wiederherzustellen, wenn du sie vergisst oder deine Notize dazu nicht wiederfindest. Weiter gibt es keine Möglichkeit die Zugangsdaten zu veränern, ohne ein neues Konto anzulegen.<br/><br/>Eine gute Benutzerkennung muss hinreichen lang (mindestens 8 Zeichen) sein und so originell/individuell wie möglich - also nicht dein vor- und/oder Nachname.",
      "PASSWORD": "Das Passwort ist ebenfalls sehr wichtig. Zusammen mit der Benutzerkennung wird es gebraucht, um deine Kontonummer (der öffentliche Schlüssel) und den privaten Schlüssel zu berechnen, der gebraucht wir, um auf dein Konto zuzugreifen. <b>Merke es dir sehr gut (am besten auch aufschreiben und an einem sicheren Ort verwahren)</b>. Es gibt keine Möglichkeit das Passwort wiederherzustellen, wenn du es verloren hast. Darüber hinaus kannst du deinen Kontozugang nur ändern, wenn du ein neues Konto anlegst.<br/><br/>Ein gutes Passwort besteht aus mindestens 8 Zeichen, mit Klein- und Großbuchstaben und Zahlen.",
      "PSEUDO": "Ein Pseudonym wird nur gebraucht, wenn du dich als <span class=\"text-italic\">Mitglied</span> registrieren möchtest. Es ist immer mit einem Konto verknüpft (durch den <span class=\"text-italic\">öffentlichen Schlüssel</span>). Das Pseudonym ist öffentlich und ermöglicht, das andere Nutzer das Konto finden, deine Identität zertifizieren oder dir Geld überweisen können. Ein Pseudonym kann nur einmal vergebben werden (aktuelle und auch in der Vergangenheit)."
    },
    "LOGIN": {
      "SECTION": "Anmeldung",
      "PUBKEY": "Öffentlicher Schlüssel des Kontos",
      "PUBKEY_DEF": "Der öffentliche Schlüssel des Schlüsselbunds wird aus den eingegebenen Kennungen (beliebig) generiert, entspricht aber nicht zwangsweise einem bereits verwendeten Konto.<br/><b>Stelle daher sicher, dass dein öffentlicher Schlüssel mit deinem Konto übereinstimmt</b>. Andernfalls wirst du in ein Konto eingeloggt, das wahrscheinlich nie verwendet wird, da das Risiko einer Kollision mit einem bestehenden Konto sehr gering ist.<br/><a href=\"https://en.wikipedia.org/wiki/ Elliptic_curve_cryptography\" target=\"_ system\">Erfahre mehr über Kryptografie</a> mit öffentlichen Schlüsseln.",
      "METHOD": "Anmeldeverfahren",
      "METHOD_DEF": "Unterschiedliche Verfahren stehen zur Verfügung, um sich mit einem Konto zu verbinden: <br/> - Die Verbindung <b>mit &quot;Salt&quot; (einfach oder fortgeschritten)</b> mischt Ihr Passwort mit der geheimen Kennung, um Angriffe, die auf bloßem Raten basieren, zu erschweren<br/> - Die Verbindung <b>unter Verwendung eines öffentlichen Schlüssels</b> verhindert, dass Sie Ihre Anmeldeinformationen eingeben, die Sie in Folge nur dann angeben müssen, wenn eine Operation dies erfordert.<br/> - Die Verbindung <b>unter Verwendung einer Schlüsselbunddatei</b> verwendet den öffentlichen und den privaten Schlüssel des Kontos aus einer Datei, ohne dass Anmeldeinformationen eingegeben werden müssen. Mehrere Dateiformate sind möglich."
    },
    "GLOSSARY": {
      "SECTION": "Glossar",
      "PUBKEY_DEF": "Ein öffentlicher Schlüssel ist immer mit einem Konto verbunden. Es kann auch zu einem Mitglied gehören. In Cesium wird der öffentliche Schlüssel aus der geheimen Benutzerkennung und dem Passwort berechnet.",
      "MEMBER": "Mitglied",
      "MEMBER_DEF": "Ein Mitglied ist ein realter und lebender Mensch, der freiwillig an dieser Währungs Gemeinschaft teilnehmen möchte. Ein Mitglied erhält täglich eine universelle Dividende, mit dem zeitlichen Rhytmus und in der Höhe, wie es die <span class=\"text-italic\">Parameter der Währung</span> vorgeben.",
      "CURRENCY_RULES": "Regeln für die Währung",
      "CURRENCY_RULES_DEF": "Die Währungsregeln wurden einmalig für immer festgelegt. Sie legen die Parameter fest, mit denen die Währung sich entwickeln wird: die Berechnungsder universellen Dividende, die Anzahl der füpr ein neues Mitglies nötigen Zertifizierungen, die höchste  Anzalh gültiger Zerifizierungen, die ein Mitglied vergeban kann und so weiter.<br/><br/>Diese Parameter können niemals verändert werden, weil eine  <span class=\"text-italic\">Blockchain</span> verwendet wird, die diese Regeln beinhaltet und ausführt. Sie überprüft laufend die Einhaltung der korrekten Anwendung dieser Regeln. <a href=\"#/app/currency\">Siehe hierzu die aktuellen Parameterwerte</a>.",
      "BLOCKCHAIN": "Blockchain",
      "BLOCKCHAIN_DEF": "Eine Blockchain ist ein dezentrales System, welches im Fall von Duniter dazu dient, die <span class=\"text-italic\">Währungsregeln</span> zu beinhalten und auszuführen.<br/><a href=\"http://en.duniter.org/presentation/\" target=\"_blank\">Hier gibt es mehr Information zu Duniter</a> und wie seine Blockchaine funktioniert.",
      "UNIVERSAL_DIVIDEND_DEF": "Die Universelle Dividende (UD) ist die Menge an Geld, die von jedem Mitgleid mit erschaffen wird, wie es die festgelegte Zeitspanne und die Berechnungen in den <span class=\"text-italic\">Währungsregeln</span> vorgeben.<br/>Nach jeder solchen Zeitspanne erhalten die Mitglieder eine gleiche Menge an neu geschaffenem Geld auf ihr Konto gutgeschrieben.<br/><br/>Die UD unterliegt einem ständigen Wachstum, um Fairness zwischen den Mitgliedern zu gewährleisten (jetzt und in der Zukunft), berechnet mit einer durchschnittlichen Lebenserwartung, wie sie in der Relativen Theorie des Geldes (RTM - relative theory of money) gezeigt wurde.<br/><a href=\"http://trm.creationmonetaire.info\" target=\"_system\">Hier findest du merh Informationen zur RTM</a> und dem freien Geld.",
      "WOT": "Web of Trust (WoT) - Netz des Vertrauens",
      "WOT_DEF": "Das Netz des Vertrauens bildet sich aus allen Mitgliedern der Währung und den Zertifizierungen, die sie verbinden.",
      "DISTANCE_RULE": "Distanzregel",
      "DISTANCE_RULE_DEF": "Die Distanzregel definiert <b>eine maximal erlaubte Distanz</b> zwischen einem Neumitglied und einer Minimalanzahl von Referenzmitgliedern. Die Distanz wird dabei aufgrund der Verbindungen berechnet, die durch die Zertifizierungen entstehen."
    },
    "TIP": {
      "MENU_BTN_CURRENCY": "Menü <b>{{'MENU.CURRENCY'|translate}}</b> entdecke die <b>Währungsparameter</b> und den aktuellen Stand.",
      "CURRENCY_WOT": "Die <b>Anzahl Mitglieder</b> zeigt die<b>Größe und Entwicklung der Community</b>.",
      "CURRENCY_MASS": "Hier wird die <b>gesamte Geldmenge</b> derzeit im Umlauf und die <b>durchschnittliche Verteilung</b> pro Mitglied angezeigt.<br/><br/>Damit ist die Einschätzung eines <b>Gegenwertes für jede Summe</b> möglich, unter der Berücksichtigung, über wieviel <b>andere </b> auf ihrem Konto vefügen (im MIttel).",
      "CURRENCY_UNIT_RELATIVE": "Die hier benutzte Einheit (&ldquo;<b>{{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub></b>&rdquo;) bedeutet, dass die Summe in {{currency|capitalize}} durch die  <b>Universelle Dividende</b> (UD) geteilt wurde.<br/><br/><small>Diese relative Einheit ist <b>relevant</b> weils sie stabil ist im Gegensatz zu der ständig wachsenden Geldmenge.</small>",
      "CURRENCY_CHANGE_UNIT": "Mit diesem Button kannst du <b>die Einheit wechseln</b> in der Summen angezeigt werden in <b>{{currency|capitalize}}</b>, nicht geteil durch die universelle Dividende (anstelle von &ldquo;<b>{{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub></b>&rdquo;).",
      "CURRENCY_CHANGE_UNIT_TO_RELATIVE": "Dieser Butten <b>wechselt die Einheit</b> und zeigt Summen in  &ldquo;<b>{{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub></b>&rdquo;, was zur Universellen Dividende in Beziehung steht (Die Menge Geld, mit erschaffen von jedem Mitglied).",
      "CURRENCY_RULES": "Die <b>Regeln</b> für diese Währung bedingen ihre <b>exakteudn vorhersagbare</b> Entwicklung.<br/><br/>Wie eine echte DNA der Währung machen diese Regeln die Währung <b>transparent und verständlich</b>.",
      "MENU_BTN_NETWORK": "Der Menüpunkt <b>{{'MENU.NETWORK'|translate}}</b> führt zu einer Darstellung des <b>Netzwerkzustands<b>.",
      "NETWORK_BLOCKCHAIN": "Alle Geldbewegungen werden verschlüsselt in einer <b>öffentlichen und fälschungssicheren </b> Buchführung, die im allgemeinen als <b>Blockchain</b> bezeichnet wird.",
      "NETWORK_PEERS": "Die hier angezeigten <b>Knoten</b> stehen für <b>Computer die regelmäßig die Blockchain prüfen und aktualisieren</b>.<br/><br/>Je mehr aktive Knoten es gibt, desto <b>dezentraler</b> und deshalb vertrauenswürdiger wird die Währung.",
      "NETWORK_PEERS_BLOCK_NUMBER": "Diesr <b>Wert</b> zeigt den <b>letzten bestätigten Block</b> (letzte seite in der Buchhaltung) den dieser Netzknoten berechnet hat.<br/><br/>Eine grüne Farbe zeigt an, dass dieser Block von einer <b>Mehrheit der anderen Knoten</b> bestätigt wurde.",
      "NETWORK_PEERS_PARTICIPATE": "<b>Jedes Mitglied</b> mit einem Computer, der Internetverbindung hat, <b>kann daran teilnehmen, indem es einen Knoten hinzufügt</b>, indem es einfach die <b>Duniter Software installiert</b> (freie Software, und open source). <a href=\"{{installDocUrl}}\" target=\"_system\">Hier kannst du die Installationsanleitung lesen &gt;&gt;</a>.",
      "MENU_BTN_ACCOUNT": "<b>{{'ACCOUNT.TITLE'|translate}}</b> gibt dir Zugang zu deinem Kontostand und den letzten Kontobewegungen.",
      "MENU_BTN_ACCOUNT_MEMBER": "Hier kannst du deinen Konto-Status, die letzten Geldbewegungen  und Zertifizierungen einsehen.",
      "WALLET_CERTIFICATIONS": "Hier klicken und du siehst die Details deiner Zertifizierungen (gegeben und erhalten).",
      "WALLET_RECEIVED_CERTIFICATIONS": "Hier klicken, um Details deiner <b>empfangenen Zertifizierungen</b> zu sehen.",
      "WALLET_GIVEN_CERTIFICATIONS": "Hier klicken, um Details deiner <b>vergebenen Zertifizierungen</b> zu sehen.",
      "WALLET_BALANCE": "Dein <b>Kontostand </b> steht hier.",
      "WALLET_BALANCE_RELATIVE": "{{'HELP.TIP.WALLET_BALANCE'|translate}}<br/><br/>Die verwendete Einheit (&ldquo;<b>{{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub></b>&rdquo;) bedeutet, dass die Summe in {{currency|capitalize}} durch die  <b>Universelle Dividende</b> geteilt wurde (UD) mitgeschaffen durch jedes Mitglied.<br/>Aktuell entspricht 1 UD {{currentUD}} {{currency|capitalize}}.",
      "WALLET_BALANCE_CHANGE_UNIT": "Du kannst die <b>Währungseinheit ändern</b> mit denen die Beträge angezeigt werden <b><i class=\"icon ion-android-settings\"></i>&nbsp;{{'MENU.SETTINGS'|translate}}</b>.<br/><br/>Zum Beispiel um Beträge <b>absolut anzuzeigen in  {{currency|capitalize}}</b> als in relativen Werten.",
      "WALLET_PUBKEY": "Dies ist der öffentliche Schlüssel deines Kontos. Er kann problemlos Dritten mitgeteilt werden, damit die dein Konto einfacher finden können.",
      "WALLET_SEND": "Überweise einen Betrag mit nur ein paar Klicks.",
      "WALLET_SEND_NO_MONEY": "Überweise einen Betrag mit nur ein paar Klicks.<br/>(Dein Kontostand reicht dafür noch nicht aus)",
      "WALLET_OPTIONS": "Bitte beachte, dass dieser Button Zugriff auf <b>andere, weniger genutze Funktionen</b> ermöglicht.<br/><br/>Wenn du etwas Zeit hast, schau dir das doch einmal an!",
      "WALLET_RECEIVED_CERTS": "Diese Liste enthält alle Personen, die dich zertifiziert haben.",
      "WALLET_CERTIFY": "Mit diesem Button <b>{{'WOT.BTN_SELECT_AND_CERTIFY'|translate}}</b> kannst du eine Identität/ein Mitglied auswählen und es zertifizieren.<br/><br/>Nur Benutzer, die <b>bereits Mitglied</b> sind, können andere zertifizieren.",
      "WALLET_CERT_STOCK": "Dein Vorrat an Zertifizierungen (zum vergeben) ist beschränkt auf <b>{{sigStock}} Zertifizierungen</b>.<br/><br/>Dieser Vorrat füllt sich von selbst wieder auf mit der Zeit, wenn ältere Zertifizierungen verfallen (nach 2 Jahren).",
      "MENU_BTN_WALLETS": "Der Menüpunkt <b>{{'MENU.WALLETS'|translate}}</b> erlaubt es dir, zusätzliche Brieftaschen hinzuzufügen, die du verwaltest.",
      "MENU_BTN_TX": "Der Menüpunkt <b>{{'MENU.TRANSACTIONS'|translate}}</b> gibt Zugriff auf den Verlauf von Transaktionen, sowie auf Neuaufträge zur Bezahlung.",
      "MENU_BTN_WOT": "Dieses Menü <b>{{'MENU.WOT'|translate}}</b> ermöglicht die Suche nach <b>Benutzern</b> dieser Währung (Mitglieder und nicht-Mitglieder).",
      "WOT_SEARCH_TEXT_XS": "Um im Verzeichnis zu suchen, tippe die <b>ersten Zeichen des Pseudonyms eines Mitglieds oder seines öffentlichen Schlüssels </b> ein.<br/><br/>Die Suche startet automatisch.",
      "WOT_SEARCH_TEXT": "Um im Verzeichnis zu suchen, gib die <b>ersten Zeichen eines Pseudonyms oder des öffentlichen Schlüssels </b> ein.<br/><br/>Dann drücke auf <b>Enter</b>, um die Suche zu starten.",
      "WOT_SEARCH_RESULT": "Klicke einfach auf dien Zeile mit dem Usernamen um die Details zu sehen.",
      "WOT_VIEW_CERTIFICATIONS": "Die Zeile <b>{{'ACCOUNT.CERTIFICATION_COUNT'|translate}}</b> zeigt an, wie viele Mitglieder diese Identität bestätigt haben.<br/><br/>Diese Zertifizierungen bezeugen das dieses Konto zu einem <b>lebenden Menschen</b> gehört und diese Person <b>kein anderes Mitgliedskonto besitzt</b>.",
      "WOT_VIEW_CERTIFICATIONS_COUNT": "Es werden mindestens <b>{{sigQty}} Zertifizierungen </b> benötigt um Mitglied zu werden und die tägliche<b>universelle Dividende</b> zu erhalten.",
      "WOT_VIEW_CERTIFICATIONS_CLICK": "Wenn du hier klickst erscheint <b>eine Liste mit allen Zertifizierungen</b> die dieses Mitglied erhalten und erteilt hat.",
      "WOT_VIEW_CERTIFY": "Der Button <b>{{'WOT.BTN_CERTIFY'|translate}}</b> fügt deine Zertifizierung zu diesem Mitgliedskonto hinzu.",
      "CERTIFY_RULES": "<b>Achtung:</b> Zertifiziere nur <b>echte und lebende Personen</b> die kein weiteres zertifiziertes Mitgliedskonto besitzen.<br/><br/>Das Vertrauen in diese Währung wird von der Zuverlässigkeit aller Mitglieder getragen.!",
      "MENU_BTN_SETTINGS": "Mit den  <b>{{'MENU.SETTINGS'|translate}}</b> kannst du die Cesium Anwendung einrichten.<br/><br/>Zum Beispiel kannst du einstellen, in welcher <b>Einheit</b>die Währung angezeigt wird.",
      "HEADER_BAR_BTN_PROFILE": "Hier klicken, um zu deinem <b>Profil</b> zu kommen",
      "SETTINGS_CHANGE_UNIT": "Du kannst die angezeigte Einheit der Menge ändern: <b>hier klicken</b>.<br/><br/>- Option zur Deaktivierung der Anzeige von Werten in {{currency|capitalize}}.<br/>- Activiere diese Option für relative Beträge in {{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub> (<b>Einheiten der aktuellen universellen Dividende</b>).",
      "END_LOGIN": "Diese geführte Tour ist nun zu <b>Ende</b>.<br/><br/>Herzlich willkommen im Netz bei der <b>freien Ökonomie</b>!",
      "END_NOT_LOGIN": "Diese geführte Tour ist <b>beendet</b>.<br/><br/>Wenn du dich am Währungsnetzwerk {{currency|capitalize}} beteiligen möchtest, klicke einfach<b>{{'LOGIN.CREATE_ACCOUNT'|translate}}</b> unten.",
      "END_READONLY": "Diese geführte Tour ist <b>beendet</b>.<br/><br/>{{'MODE.READONLY.INSTALL_HELP'|translate}}."
    }
  },
  "API" :{
    "COMMON": {
      "LINK_DOC": "API documentation",
      "LINK_DOC_HELP": "API documentation for developers",
      "LINK_STANDARD_APP": "Standard version",
      "LINK_STANDARD_APP_HELP": "Open standard version of {{'COMMON.APP_NAME'|translate}}",
      "CONNECTION_ERROR": "Peer <b>{{server}}</b> unreachable or invalid address.<br/><br/>Check your Internet connection, or contact the web site administrator."
    },
    "HOME": {
      "TITLE": "{{'COMMON.APP_NAME'|translate}} API Documentation",
      "MESSAGE": "Welcome to the {{'COMMON.APP_NAME'|translate}} <b>API documentation </b>.<br/>Connect your web site to <a href=\"http://duniter.org\" target=\"_system\">Duniter</a> very easily!",
      "MESSAGE_SHORT": "Connect your websites to <a href=\"http://duniter.org\" target=\"_system\">Duniter</a> very easily!",
      "DOC_HEADER": "Available services:"
    },
    "TRANSFER": {
      "TITLE": "{{'COMMON.APP_NAME'|translate}} - Online payment",
      "TITLE_SHORT": "Online payment",
      "SUMMARY": "Order summary:",
      "AMOUNT": "Amount:",
      "AMOUNTS_HELP": "Please select the amount:",
      "NAME": "Name:",
      "PUBKEY": "Public key of the recipient:",
      "COMMENT": "Order reference:",
      "NODE": "Peer address:",
      "DEMO": {
        "SALT": "demo",
        "PASSWORD": "demo",
        "PUBKEY": "3G28bL6deXQBYpPBpLFuECo46d3kfYMJwst7uhdVBnD1",
        "HELP": "<b>Demonstration mode</b>: No payment will actually be sent during this simulation.<br/>Please use credentials: <b>{{'API.TRANSFER.DEMO.SALT'|translate}} / {{'API.TRANSFER.DEMO.PASSWORD'|translate}}</b>",
        "BAD_CREDENTIALS": "Invalid credentials.<br/>In demonstration mode, credentials should be: {{'API.TRANSFER.DEMO.SALT'|translate}} / {{'API.TRANSFER.DEMO.PASSWORD'|translate}}"
      },
      "INFO": {
        "SUCCESS_REDIRECTING_WITH_NAME": "Payment sent.<br/>Redirect to <b>{{name}}</b>...",
        "SUCCESS_REDIRECTING": "Payment sent.<br/>Redirect to the seller's website...",
        "CANCEL_REDIRECTING_WITH_NAME": "Payment cancelled.<br/>Redirect to <b>{{name}}</b>...",
        "CANCEL_REDIRECTING": "Payment cancelled.<br/>Redirect to the seller's website..."
      },
      "ERROR": {
        "TRANSFER_FAILED": "Payment failed"
      }
    },
    "DOC": {
      "DESCRIPTION_DIVIDER": "Description",
      "URL_DIVIDER": "Calling address",
      "PARAMETERS_DIVIDER": "Parameters",
      "AVAILABLE_PARAMETERS": "Here is the list of al available parameters:",
      "DEMO_DIVIDER": "Try it !",
      "DEMO_HELP": "To test this service, click on this button. The result content will be display below.",
      "DEMO_RESULT": "Result returned by call:",
      "DEMO_RESULT_PEER": "Peer address used:",
      "DEMO_SUCCEED": "<i class=\"icon ion-checkmark\"></i> Success!",
      "DEMO_CANCELLED": "<i class=\"icon ion-close\"></i> Cancelled by user",
      "INTEGRATE_DIVIDER": "Website integration",
      "INTEGRATE_CODE": "Code:",
      "INTEGRATE_RESULT": "Result preview:",
      "INTEGRATE_PARAMETERS": "Parameters",
      "TRANSFER": {
        "TITLE": "Payments",
        "DESCRIPTION": "From a site (eg online marketplace) you can delegate payment in free currency to Cesium API. To do this, simply open a page at the following address:",
        "PARAM_PUBKEY": "Recipient's public key",
        "PARAM_PUBKEY_HELP": "Recipient's public key (required)",
        "PARAM_AMOUNT": "Amount",
        "PARAM_AMOUNT_HELP": "Transaction amount (required)",
        "PARAM_COMMENT": "Reference (or comment)",
        "PARAM_COMMENT_HELP": "Reference or comment. You will allow for example to identify the payment in the BlockChain.",
        "PARAM_NAME": "Name (of recipient or website)",
        "PARAM_NAME_HELP": "The name of your website. This can be a readable name (eg \"My online site\"), or a web address (eg \"www.MySite.com\").",
        "PARAM_REDIRECT_URL": "URL redirection",
        "PARAM_REDIRECT_URL_HELP": "URL redirection after sending payment, after the payment has been sent. Can contain the following strings, which will be replaced by the values of the transaction: \"{tx}\", \"{hash}\", \"{comment}\", \"{amount}\" and \"{pubkey}\".",
        "PARAM_CANCEL_URL": "URL if cancelled",
        "PARAM_CANCEL_URL_HELP": "URL in case of cancellation.  Can contain the following strings, which will be replaced: \"{comment}\", \"{amount}\" and \"{pubkey}\".",
        "PARAM_PREFERRED_NODE": "Preferred Duniter peer",
        "PARAM_PREFERRED_NODE_HELP": "Peer address (URL) to use preferably (\"g1.domain.com:443\" or \"https://g1.domain.com\")",
        "EXAMPLES_HELP": "Examples of integration:",
        "EXAMPLE_BUTTON": "HTML Button",
        "EXAMPLE_BUTTON_DEFAULT_TEXT": "Pay in {{currency|abbreviate}}",
        "EXAMPLE_BUTTON_DEFAULT_STYLE": "Custom style",
        "EXAMPLE_BUTTON_TEXT_HELP": "Button text",
        "EXAMPLE_BUTTON_BG_COLOR": "Background color",
        "EXAMPLE_BUTTON_BG_COLOR_HELP": "eg: #fbc14c, yellow, lightgrey, rgb(180,180,180)",
        "EXAMPLE_BUTTON_FONT_COLOR": "Font color",
        "EXAMPLE_BUTTON_FONT_COLOR_HELP": "eg: black, orange, rgb(180,180,180)",
        "EXAMPLE_BUTTON_TEXT_ICON": "Icon",
        "EXAMPLE_BUTTON_TEXT_WIDTH": "Width",
        "EXAMPLE_BUTTON_TEXT_WIDTH_HELP": "eg: 200px, 50%",
        "EXAMPLE_BUTTON_ICON_NONE": "No icon",
        "EXAMPLE_BUTTON_ICON_DUNITER": "Duniter logo",
        "EXAMPLE_BUTTON_ICON_CESIUM": "Cesium logo",
        "EXAMPLE_BUTTON_ICON_G1_COLOR": "Ğ1 logo",
        "EXAMPLE_BUTTON_ICON_G1_BLACK": "Ğ1 logo (outline)"
      }
    }
  }
}
);

$translateProvider.translations("en-GB", {
  "COMMON": {
    "APP_NAME": "Cesium",
    "APP_VERSION": "v{{version}}",
    "APP_BUILD": "build {{build}}",
    "PUBKEY": "Public key",
    "MEMBER": "Member",
    "BLOCK" : "Block",
    "BTN_OK": "OK",
    "BTN_YES": "Yes",
    "BTN_NO": "No",
    "BTN_SEND": "Send",
    "BTN_SEND_MONEY": "Transfer money",
    "BTN_SEND_MONEY_SHORT": "Transfer",
    "BTN_SAVE": "Save",
    "BTN_YES_SAVE": "Yes, Save",
    "BTN_YES_CONTINUE": "Yes, Continue",
    "BTN_SHOW": "Show",
    "BTN_SHOW_PUBKEY": "Show key",
    "BTN_RELATIVE_UNIT": "Display amounts in UD?",
    "BTN_BACK": "Back",
    "BTN_NEXT": "Next",
    "BTN_IMPORT": "Import",
    "BTN_CANCEL": "Cancel",
    "BTN_CLOSE": "Close",
    "BTN_LATER": "Later",
    "BTN_LOGIN": "Sign In",
    "BTN_LOGOUT": "Logout",
    "BTN_ADD_ACCOUNT": "New Account",
    "BTN_SHARE": "Share",
    "BTN_EDIT": "Edit",
    "BTN_DELETE": "Delete",
    "BTN_ADD": "Add",
    "BTN_SEARCH": "Search",
    "BTN_REFRESH": "Refresh",
    "BTN_RETRY": "Retry",
    "BTN_START": "Start",
    "BTN_CONTINUE": "Continue",
    "BTN_CREATE": "Create",
    "BTN_UNDERSTOOD": "I understand",
    "BTN_OPTIONS": "Options",
    "BTN_HELP_TOUR": "Features tour",
    "BTN_HELP_TOUR_SCREEN": "Discover this screen",
    "BTN_DOWNLOAD": "Download",
    "BTN_DOWNLOAD_ACCOUNT_STATEMENT": "Download account statement",
    "BTN_MODIFY": "Modify",
    "CHOOSE_FILE": "Drag your file<br/>or click to select",
    "DAYS": "days",
    "NO_ACCOUNT_QUESTION": "Not a member yet? Register now!",
    "SEARCH_NO_RESULT": "No result found",
    "LOADING": "Loading...",
    "LOADING_WAIT": "Loading...<br/><small>(Cesium is querying the Duniter peer)</small>",
    "SEARCHING": "Searching...",
    "FROM": "From",
    "TO": "To",
    "COPY": "Copy",
    "LANGUAGE": "Language",
    "UNIVERSAL_DIVIDEND": "Universal dividend",
    "UD": "UD",
    "DATE_PATTERN": "DD/MM/YYYY HH:mm",
    "DATE_FILE_PATTERN": "YYYY-MM-DD",
    "DATE_SHORT_PATTERN": "DD/MM/YY",
    "DATE_MONTH_YEAR_PATTERN": "MM/YYYY",
    "EMPTY_PARENTHESIS": "(empty)",
    "UID": "Pseudonym",
    "ENABLE": "Enabled",
    "DISABLE": "Disabled",
    "RESULTS_LIST": "Results:",
    "RESULTS_COUNT": "{{count}} results",
    "EXECUTION_TIME": "executed in {{duration|formatDurationMs}}",
    "SHOW_VALUES": "Display values openly?",
    "POPOVER_ACTIONS_TITLE": "Options",
    "POPOVER_FILTER_TITLE": "Filters",
    "SHOW_MORE": "Show more",
    "SHOW_MORE_COUNT": "(current limit at {{limit}})",
    "POPOVER_SHARE": {
      "TITLE": "Share",
      "SHARE_ON_TWITTER": "Share on Twitter",
      "SHARE_ON_FACEBOOK": "Share on Facebook",
      "SHARE_ON_DIASPORA": "Share on Diaspora*",
      "SHARE_ON_GOOGLEPLUS": "Share on Google+"
    },
    "FILE": {
      "DATE" : "Date:",
      "TYPE" : "Type:",
      "SIZE": "Size:",
      "VALIDATING": "Validating..."
    }
  },
  "SYSTEM": {
    "PICTURE_CHOOSE_TYPE": "Choose source:",
    "BTN_PICTURE_GALLERY": "Gallery",
    "BTN_PICTURE_CAMERA": "<b>Camera</b>"
  },
  "MENU": {
    "HOME": "Home",
    "WOT": "Registry",
    "CURRENCY": "Currency",
    "ACCOUNT": "My Account",
    "WALLETS": "My wallets",
    "SETTINGS": "Settings",
    "NETWORK": "Network",
    "TRANSACTIONS": "My transactions"
  },
  "ABOUT": {
    "TITLE": "About",
    "LICENSE": "<b>Free/libre software</b> (License GNU AGPLv3).",
    "LATEST_RELEASE": "There is a <b>newer version</ b> of {{'COMMON.APP_NAME' | translate}} (<b>v{{version}}</b>)",
    "PLEASE_UPDATE": "Please update {{'COMMON.APP_NAME' | translate}} (latest version: <b>v{{version}}</b>)",
    "CODE": "Source code:",
    "OFFICIAL_WEB_SITE": "Official web site:",
    "DEVELOPERS": "Developers:",
    "FORUM": "Forum:",
    "PLEASE_REPORT_ISSUE": "Please report any issue to us!",
    "REPORT_ISSUE": "Report an issue",
    "BTN_OPEN_DEV_WINDOW": "Open the debug window"
  },
  "HOME": {
    "TITLE": "Cesium",
    "WELCOME": "Welcome to the Cesium application!",
    "WELCOME_READONLY": "Welcome to Cesium <span class='badge badge-balanced'>Monit</span> !",
    "MESSAGE": "Receive and send libre currency {{currency|abbreviate}}",
    "MESSAGE_READONLY": "Real-time monitoring of libre currency {{currency|abbreviate}}",
    "BTN_CURRENCY": "Explore currency {{currency|abbreviate}}",
    "BTN_ABOUT": "about",
    "BTN_HELP": "Help",
    "BTN_NETWORK": "Network status",
    "FREE_SOFTWARE": "Free software",
    "FORK_ME": "Fork me!",
    "SHOW_LICENSE": "Show license",
    "REPORT_ISSUE": "Report an issue",
    "NOT_YOUR_ACCOUNT_QUESTION" : "You do not own the account <b><i class=\"ion-key\"></i> {{pubkey|formatPubkey}}</b>?",
    "BTN_CHANGE_ACCOUNT": "Disconnect this account",
    "PEER_CONNECTION_ERROR": "Node <b>{{server}}</b> is unreachable or address is invalid.<br/><br/>Check your Internet connection, or change the node <a class=\"positive\" ng-click=\"doQuickFix('settings')\">in the settings</a>.",
    "NETWORK_CONNECTION_ERROR": "Network is unreachable.<br/><br/>Check your Internet connection, or select a node manually <a class=\"positive\" ng-click=\"doQuickFix('settings')\">in the settings</a>.",
    "SHOW_ALL_FEED": "Show all",
    "READ_MORE": "Read more",
    "FEED_SOURCE": "Source"
  },
  "SETTINGS": {
    "TITLE": "Settings",
    "DISPLAY_DIVIDER": "Display",
    "STORAGE_DIVIDER": "Storage",
    "NETWORK_SETTINGS": "Network",
    "PEER": "Duniter peer",
    "PEER_CHANGED_TEMPORARY": "Address used temporarily",
    "PEER_SELECTED_AUTOMATICALLY": "Peer selected automatically at startup",
    "NETWORK_ANALYZE_TIMEOUT": "Maximum waiting time (timeout)",
    "NETWORK_ANALYZE_TIMEOUT_HELP": "Maximum waiting time for network analysis",
    "NETWORK_ANALYZE_TIMEOUT_AUTO": "Auto",
    "PERSIST_CACHE": "Keep navigation data (experimental)",
    "PERSIST_CACHE_HELP": "Allows faster navigation, locally retaining the data received, for use from one session to another.",
    "USE_LOCAL_STORAGE": "Enable local storage",
    "USE_LOCAL_STORAGE_HELP": "Allows you to save your settings",
    "WALLETS_SETTINGS": "My wallets",
    "USE_WALLETS_ENCRYPTION": "Secure the list",
    "USE_WALLETS_ENCRYPTION_HELP": "Enables you to encrypt the list of your wallets. Authentication required to access it.",
    "ENABLE_HELPTIP": "Enable contextual help tips",
    "DISABLE_HELPTIP": "Disable contextual help tips",
    "ENABLE_UI_EFFECTS": "Enable visual effects",
    "ENABLE_UI_EFFECTS_HELP": "Transition between pages, animation of list",
    "HISTORY_SETTINGS": "Account operations",
    "DISPLAY_UD_HISTORY": "Display produced dividends?",
    "TX_HISTORY_AUTO_REFRESH": "Enable automatic refresh?",
    "TX_HISTORY_AUTO_REFRESH_HELP": "Updates the list of operations to each new block.",
    "AUTHENTICATION_SETTINGS": "Authentication",
    "KEEP_AUTH": "Expiration of authentication",
    "KEEP_AUTH_SHORT": "Expiration",
    "KEEP_AUTH_HELP": "Define when authentication is cleared from memory.",
    "KEEP_AUTH_OPTION": {
      "NEVER": "After each operation",
      "SECONDS": "After {{value}}s of inactivity",
      "MINUTE": "After {{value}}min of inactivity",
      "MINUTES": "After {{value}}min of inactivity",
      "HOUR": "After {{value}}h of inactivity",
      "ALWAYS": "At the end of the session"
    },
    "KEYRING_FILE": "Keyring file",
    "KEYRING_FILE_HELP": "Allow auto-connect at startup, or to authenticate (only if \"Expiration of authentication\" is \"at the end of the session\"",
    "REMEMBER_ME": "Remember me ?",
    "REMEMBER_ME_HELP": "Allows to remain identified from one session to another, keeping the public key locally.",
    "PLUGINS_SETTINGS": "Extensions",
    "BTN_RESET": "Restore default values",
    "EXPERT_MODE": "Enable expert mode",
    "EXPERT_MODE_HELP": "Allow to see more details",
    "BLOCK_VALIDITY_WINDOW": "Block uncertainty time",
    "BLOCK_VALIDITY_WINDOW_SHORT": "Time of uncertainty",
    "BLOCK_VALIDITY_WINDOW_HELP": "Time to wait before considering an information is validated",
    "BLOCK_VALIDITY_OPTION": {
      "NONE": "No delay",
      "N": "{{time | formatDuration}} ({{count}} blocks)"
    },
    "POPUP_PEER": {
      "TITLE" : "Duniter peer",
      "HOST" : "Address",
      "HOST_HELP": "Address: server:port",
      "USE_SSL" : "Secured?",
      "USE_SSL_HELP" : "SSL Encryption",
      "BTN_SHOW_LIST" : "Peer's list"
    }
  },
  "BLOCKCHAIN": {
    "HASH": "Hash: {{hash}}",
    "VIEW": {
      "HEADER_TITLE": "Block #{{number}}-{{hash|formatHash}}",
      "TITLE_CURRENT": "Current block",
      "TITLE": "Block #{{number|formatInteger}}",
      "COMPUTED_BY": "Computed by",
      "SHOW_RAW": "Show raw data",
      "TECHNICAL_DIVIDER": "Technical informations",
      "VERSION": "Format version",
      "HASH": "Computed hash",
      "UNIVERSAL_DIVIDEND_HELP": "Money co-produced by each of the {{membersCount}} members",
      "EMPTY": "Aucune donnée dans ce bloc",
      "POW_MIN": "Minimal difficulty",
      "POW_MIN_HELP": "Difficulty imposed in calculating hash",
      "DATA_DIVIDER": "Data",
      "IDENTITIES_COUNT": "New identities",
      "JOINERS_COUNT": "Joiners",
      "ACTIVES_COUNT": "Renewals",
      "ACTIVES_COUNT_HELP": "Members having renewed their membership",
      "LEAVERS_COUNT": "Leavers",
      "LEAVERS_COUNT_HELP": "Members that now refused certification",
      "EXCLUDED_COUNT": "Excluded members",
      "EXCLUDED_COUNT_HELP": "Old members, excluded because missing membreship renewal or certifications",
      "REVOKED_COUNT": "Revoked identities",
      "REVOKED_COUNT_HELP": "These accounts may no longer be member",
      "TX_COUNT": "Transactions",
      "CERT_COUNT": "Certifications",
      "TX_TO_HIMSELF": "Change",
      "TX_OUTPUT_UNLOCK_CONDITIONS": "Unlock conditions",
      "TX_OUTPUT_OPERATOR": {
        "AND": "and",
        "OR": "or"
      },
      "TX_OUTPUT_FUNCTION": {
        "SIG": "<b>Sign</b> of the public key",
        "XHX": "<b>Password</b>, including SHA256 =",
        "CSV": "Blocked during",
        "CLTV": "Bloqué until"
      }
    },
    "LOOKUP": {
      "TITLE": "Blocks",
      "NO_BLOCK": "No bloc",
      "LAST_BLOCKS": "Last blocks:",
      "BTN_COMPACT": "Compact"
    }
  },
  "CURRENCY": {
    "VIEW": {
      "TITLE": "Currency",
      "TAB_CURRENCY": "Currency",
      "TAB_WOT": "Web of trust",
      "TAB_NETWORK": "Network",
      "TAB_BLOCKS": "Blocks",
      "CURRENCY_SHORT_DESCRIPTION": "{{currency|capitalize}} is a <b>libre money</b>, started {{firstBlockTime | formatFromNow}}. It currently counts <b>{{N}} members </b>, who produce and collect a <a ng-click=\"showHelpModal('ud')\">Universal Dividend</a> (DU), each {{dt | formatPeriod}}.",
      "NETWORK_RULES_DIVIDER": "Network rules",
      "CURRENCY_NAME": "Currency name",
      "MEMBERS": "Members count",
      "MEMBERS_VARIATION": "Variation since {{duration|formatDuration}} (since last UD)",
      "MONEY_DIVIDER": "Money",
      "MASS": "Monetary mass",
      "SHARE": "Money share",
      "UD": "Universal Dividend",
      "C_ACTUAL": "Current growth",
      "MEDIAN_TIME": "Current blockchain time",
      "POW_MIN": "Common difficulty",
      "MONEY_RULES_DIVIDER": "Rules of currency",
      "C_RULE": "Theoretical growth target",
      "UD_RULE": "Universal dividend (formula)",
      "DT_REEVAL": "Period between two re-evaluation of the UD",
      "REEVAL_SYMBOL": "reeval",
      "DT_REEVAL_VALUE": "Every <b>{{dtReeval|formatDuration}}</b> ({{dtReeval/86400}} {{'COMMON.DAYS'|translate}})",
      "UD_REEVAL_TIME0": "Date of first reevaluation of the UD",
      "SIG_QTY_RULE": "Required number of certifications to become a member",
      "SIG_STOCK": "Maximum number of certifications sent by a member",
      "SIG_PERIOD": "Minimum delay between 2 certifications sent by one and the same issuer.",
      "SIG_WINDOW": "Maximum delay before a certification will be treated",
      "SIG_VALIDITY": "Lifetime of a certification that has been treated",
      "MS_WINDOW": "Maximum delay before a pending membership will be treated",
      "MS_VALIDITY": "Lifetime of a membership that has been treated",
      "STEP_MAX": "Maximum distance between a newcomer and each referring members.",
      "WOT_RULES_DIVIDER": "Rules for web of trust",
      "SENTRIES": "Required number of certifications (given <b>and</b> received) to become a referring member",
      "SENTRIES_FORMULA": "Required number of certifications to become a referring member (formula)",
      "XPERCENT":"Minimum percent of referring member to reach to match the distance rule",
      "AVG_GEN_TIME": "The average time between 2 blocks",
      "CURRENT": "current",
      "MATH_CEILING": "CEILING",
      "DISPLAY_ALL_RULES": "Display all rules?",
      "BTN_SHOW_LICENSE": "Show license",
      "WOT_DIVIDER": "Web of trust"
    },
    "LICENSE": {
      "TITLE": "Currency license",
      "BTN_DOWNLOAD": "Download file",
      "NO_LICENSE_FILE": "License file not found."
    }
  },
  "NETWORK": {
    "VIEW": {
      "MEDIAN_TIME": "Blockchain time",
      "LOADING_PEERS": "Loading peers...",
      "NODE_ADDRESS": "Address:",
      "SOFTWARE": "Software:",
      "WARN_PRE_RELEASE": "Pre-release (latest stable: <b>{{version}}</b>)",
      "WARN_NEW_RELEASE": "Version <b>{{version}}</b> available",
      "WS2PID": "Identifier:",
      "PRIVATE_ACCESS": "Private access",
      "POW_PREFIX": "Proof of work prefix:",
      "ENDPOINTS": {
        "BMAS": "Secure endpoint (SSL)",
        "BMATOR": "TOR endpoint",
        "WS2P": "WS2P endpoint",
        "ES_USER_API": "Cesium+ data node"
      }
    },
    "INFO": {
      "CONNECTING_TO_NETWORK": "Connecting to the network...",
      "ANALYZING_NETWORK": "Analyzing the {{currency|abbreviate}} network...",
      "ONLY_SSL_PEERS": "Non-SSL nodes have a degraded display because Cesium works in HTTPS mode."
    }
  },
  "PEER": {
    "PEERS": "Peers",
    "SIGNED_ON_BLOCK": "Signed on block",
    "MIRROR": "mirror",
    "MIRRORS": "Mirrors",
    "MIRROR_PEERS": "Mirror peers",
    "PEER_LIST" : "Peer's list",
    "MEMBERS" : "Members",
    "MEMBER_PEERS" : "Member peers",
    "ALL_PEERS" : "All peers",
    "DIFFICULTY" : "Difficulty",
    "API" : "API",
    "CURRENT_BLOCK" : "Block #",
    "POPOVER_FILTER_TITLE": "Filter",
    "OFFLINE": "Offline",
    "OFFLINE_PEERS": "Offline peers",
    "BTN_SHOW_PEER": "Show peer",
    "VIEW": {
      "TITLE": "Peer",
      "OWNER": "Owned by ",
      "SHOW_RAW_PEERING": "See peering document",
      "SHOW_RAW_CURRENT_BLOCK": "See current block (raw format)",
      "LAST_BLOCKS": "Last blocks",
      "KNOWN_PEERS": "Known peers :",
      "GENERAL_DIVIDER": "General information",
      "ERROR": {
        "LOADING_TOR_NODE_ERROR": "Could not get peer data, using the TOR network.",
        "LOADING_NODE_ERROR": "Could not get peer data"
      }
    }
  },
  "WOT": {
    "SEARCH_HELP": "Search (member or public key)",
    "SEARCH_INIT_PHASE_WARNING": "During the pre-registration phase, the search for pending registrations <b>may be long</b>. Please wait ...",
    "REGISTERED_SINCE": "Registered on",
    "REGISTERED_SINCE_BLOCK": "Registered since block #",
    "NO_CERTIFICATION": "No validated certification",
    "NO_GIVEN_CERTIFICATION": "No given certification",
    "NOT_MEMBER_PARENTHESIS": "(non-member)",
    "IDENTITY_REVOKED_PARENTHESIS": "(identity revoked)",
    "MEMBER_PENDING_REVOCATION_PARENTHESIS": "(being revoked)",
    "EXPIRE_IN": "Expires",
    "NOT_WRITTEN_EXPIRE_IN": "Deadline<br/>treatment",
    "EXPIRED": "Expired",
    "PSEUDO": "Pseudonym",
    "SIGNED_ON_BLOCK": "Emitted on block #{{block}}",
    "WRITTEN_ON_BLOCK": "Written on block #{{block}}",
    "GENERAL_DIVIDER": "General information",
    "NOT_MEMBER_ACCOUNT": "Non-member account",
    "NOT_MEMBER_ACCOUNT_HELP": "This is a simple wallet, with no pending membership application.",
    "TECHNICAL_DIVIDER": "Technical data",
    "BTN_CERTIFY": "Certify",
    "BTN_YES_CERTIFY": "Yes, certify",
    "BTN_SELECT_AND_CERTIFY": "New certification",
    "ACCOUNT_OPERATIONS": "Account operations",
    "VIEW": {
      "POPOVER_SHARE_TITLE": "Identity {{title}}"
    },
    "LOOKUP": {
      "TITLE": "Registry",
      "NEWCOMERS": "New members:",
      "NEWCOMERS_COUNT": "{{count}} members",
      "PENDING": "Pending registrations:",
      "PENDING_COUNT": "{{count}} pending registrations",
      "REGISTERED": "Registered {{sigDate | formatFromNow}}",
      "MEMBER_FROM": "Member since {{memberDate|medianFromNowShort}}",
      "BTN_NEWCOMERS": "Latest members",
      "BTN_PENDING": "Pending registrations",
      "SHOW_MORE": "Show more",
      "SHOW_MORE_COUNT": "(current limit to {{limit}})",
      "NO_PENDING": "No pending registrations.",
      "NO_NEWCOMERS": "No members."
    },
    "CONTACTS": {
      "TITLE": "Contacts"
    },
    "MODAL": {
      "TITLE": "Search"
    },
    "CERTIFICATIONS": {
      "TITLE": "{{uid}} - Certifications",
      "SUMMARY": "Received certifications",
      "LIST": "Details of received certifications",
      "PENDING_LIST": "Pending certifications",
      "RECEIVED": "Received certifications",
      "RECEIVED_BY": "Certifications received by {{uid}}",
      "ERROR": "Received certifications in error",
      "SENTRY_MEMBER": "Referring member"
    },
    "OPERATIONS": {
      "TITLE": "{{uid}} - Operations"
    },
    "GIVEN_CERTIFICATIONS": {
      "TITLE": "{{uid}} - Certifications sent",
      "SUMMARY": "Sent certifications",
      "LIST": "Details of sent certifications",
      "PENDING_LIST": "Pending certifications",
      "SENT": "Sent certifications",
      "SENT_BY": "Certifications sent by {{uid}}",
      "ERROR": "Sent certifications with error"
    }
  },
  "LOGIN": {
    "TITLE": "<i class=\"icon ion-log-in\"></i> Login",
    "SCRYPT_FORM_HELP": "Please enter your credentials. <br> Remember to check the public key for your account.",
    "PUBKEY_FORM_HELP": "Please enter a public account key:",
    "FILE_FORM_HELP": "Choose the keychain file to use:",
    "SCAN_FORM_HELP": "Scan the QR code of a wallet.",
    "SALT": "Secret identifier",
    "SALT_HELP": "Secret identifier",
    "SHOW_SALT": "Display secret identifier?",
    "PASSWORD": "Password",
    "PASSWORD_HELP": "Password",
    "PUBKEY_HELP": "Public key or pseudonym",
    "NO_ACCOUNT_QUESTION": "Don't have an account yet?",
    "HAVE_ACCOUNT_QUESTION": "Already have an account ?",
    "CREATE_ACCOUNT": "Create an account",
    "CREATE_FREE_ACCOUNT": "Create a free account",
    "FORGOTTEN_ID": "Forgot password?",
    "ASSOCIATED_PUBKEY": "Public key :",
    "BTN_METHODS": "Other methods",
    "BTN_METHODS_DOTS": "Change method...",
    "METHOD_POPOVER_TITLE": "Methods",
    "MEMORIZE_AUTH_FILE": "Memorize this keychain during the navigation session",
    "SCRYPT_PARAMETERS": "Paramètres (Scrypt) :",
    "AUTO_LOGOUT": {
      "TITLE": "Information",
      "MESSAGE": "<i class=\"ion-android-time\"></i> You were <b>logout</ b> automatically, due to prolonged inactivity.",
      "BTN_RELOGIN": "Sign In",
      "IDLE_WARNING": "You will be logout... {{countdown}}"
    },
    "METHOD": {
      "SCRYPT_DEFAULT": "Secret identifier and password",
      "SCRYPT_ADVANCED": "Advanced salt",
      "FILE": "Keychain file",
      "PUBKEY": "Public key or pseudonym",
      "SCAN": "Scan a QR code"
    },
    "SCRYPT": {
      "SIMPLE": "Light salt",
      "DEFAULT": "Standard salt",
      "SECURE": "Secure salt",
      "HARDEST": "Hardest salt",
      "EXTREME": "Extreme salt",
      "USER": "Personal value",
      "N": "N (Loop):",
      "r": "r (RAM):",
      "p": "p (CPU):"
    },
    "FILE": {
      "HELP": "Expected file format: <b>.dunikey</b> (type PubSec). Other formats are under development (EWIF, WIF)."
    }
  },
  "AUTH": {
    "TITLE": "<i class=\"icon ion-locked\"></i> Authentication",
    "BTN_AUTH": "Authenticate",
    "GENERAL_HELP": "Please authenticate yourself:",
    "EXPECTED_UID_HELP": "Please authenticate to the account <i class=\"ion-person\"></i> {{uid}}:",
    "EXPECTED_PUBKEY_HELP": "Please authenticate to the wallet <i class=\"ion-key\"></i> {{pubkey|formatPubkey}}:",
    "SCAN_FORM_HELP": "Scan the QR code of the <b>private key</b> of the wallet."
  },
  "ACCOUNT": {
    "TITLE": "My Account",
    "BALANCE": "Balance",
    "LAST_TX": "Latest validated transactions",
    "BALANCE_ACCOUNT": "Account balance",
    "NO_TX": "No transaction",
    "SHOW_MORE_TX": "Show more",
    "SHOW_ALL_TX": "Show all",
    "TX_FROM_DATE": "(current limit to {{fromTime|medianFromNowShort}})",
    "PENDING_TX": "Pending transactions",
    "VALIDATING_TX": "Transactions being validated",
    "ERROR_TX": "Transaction not executed",
    "ERROR_TX_SENT": "Sent transactions",
    "PENDING_TX_RECEIVED": "Transactions awaiting receipt",
    "EVENTS": "Events",
    "OUT_DISTANCED": "Your current certifications come from a group too isolated from the <a ng-click=\"showHelpModal('wot')\"> Web of Trust</a> (WoT): the <a ng-click=\"showHelpModal('distance_rule')\">maximum distance rule</a> is violated.<br/>You must obtain certifications from another area of the Web of Trust, or wait for it to tighten.",
    "WAITING_MEMBERSHIP": "Membership application sent. Waiting validation.",
    "WAITING_CERTIFICATIONS": "You need {{needCertificationCount}} certification(s) to become a member and produce the <a ng-click=\"showHelpModal('ud')\">Universal Dividend</a>. Your account is however already operational, to receive and send payments.",
    "WAITING_CERTIFICATIONS_HELP": "To get your certifications, only request members <b>who know you enough</b>, as required by <a ng-click=\"showLicenseModal()\">the currency license</a> that you have accepted.<br/>If you do not know enough members, let them know on <a ng-click=\"openLink($event, $root.settings.userForumUrl)\">the user forum</a>.",
    "WILL_MISSING_CERTIFICATIONS": "You will <b>lack certifications</b> soon (at least {{willNeedCertificationCount}} more are needed)",
    "WILL_NEED_RENEW_MEMBERSHIP": "Your membership <b>will expire {{membershipExpiresIn|formatDurationTo}}</b>. Remember to <a ng-click=\"doQuickFix('renew')\">renew your membership</a> before then.",
    "NEED_RENEW_MEMBERSHIP": "You are no longer a member because your membership <b>has expired</b>. Remember to <a ng-click=\"doQuickFix('renew')\">renew your membership</a>.",
    "NEED_RENEW_MEMBERSHIP_AFTER_CANCELLED": "You are no longer a member because your membership <b>has been cancelled</b> for lack of certifications. Remember to <a ng-click=\"doQuickFix('renew')\">renew your membership</a>.",
    "NO_WAITING_MEMBERSHIP": "No membership application pending. If you'd like to <b>become a member</ b>, please <a ng-click=\"doQuickFix('membership')\">send the membership application</a>.",
    "CERTIFICATION_COUNT": "Received certifications",
    "CERTIFICATION_COUNT_SHORT": "Certifications",
    "SIG_STOCK": "Stock of certifications to give",
    "BTN_RECEIVE_MONEY": "Receive",
    "BTN_SELECT_ALTERNATIVES_IDENTITIES": "Switch to another identity...",
    "BTN_FIX_MEMBERSHIP": "Resubmit membership request...",
    "BTN_MEMBERSHIP_RENEW": "Renew membership",
    "BTN_MEMBERSHIP_RENEW_DOTS": "Renew membership...",
    "BTN_MEMBERSHIP_OUT_DOTS": "Revoke membership...",
    "BTN_SECURITY_DOTS": "Sign-in and security...",
    "BTN_SHOW_DETAILS": "Display technical data",
    "LOCKED_OUTPUTS_POPOVER": {
      "TITLE": "Locked amount",
      "DESCRIPTION": "Here are the conditions for unlocking this amount:",
      "DESCRIPTION_MANY": "This transaction consists of several parts, of which the unlock conditions are:",
      "LOCKED_AMOUNT": "Conditions for the amount:"
    },
    "NEW": {
      "TITLE": "Registration",
      "INTRO_WARNING_TIME": "Creating an account on {{name|capitalize}} is very simple. Please take sufficient time to do this correctly (not to forget the usernames, passwords, etc.).",
      "INTRO_WARNING_SECURITY": "Check that the hardware you are currently using (computer, tablet, phone) <b>is secure and trustworthy </b>.",
      "INTRO_WARNING_SECURITY_HELP": "Up-to-date anti-virus, firewall enabled, session protected by password or pin code...",
      "INTRO_HELP": "Click <b> {{'COMMON.BTN_START'|translate}}</b> to begin creating an account. You will be guided step by step.",
      "REGISTRATION_NODE": "Your registration will be registered via the Duniter peer <b>{{server}}</b> node, which will then be distributed to the rest of the currency network.",
      "REGISTRATION_NODE_HELP": "If you do not trust this peer, please change <a ng-click=\"doQuickFix('settings')\">in the settings</a> of Cesium.",
      "SELECT_ACCOUNT_TYPE": "Choose the type of account to create:",
      "MEMBER_ACCOUNT": "Member account",
      "MEMBER_ACCOUNT_TITLE": "Create a member account",
      "MEMBER_ACCOUNT_HELP": "You know enough about libre money and want to participate in its production?<br/>As an individual, you can create your member account (only one per individual). This works like a simple wallet account, but also allows you to co-produce the money, by <b>receiving for each {{parameters.dt|formatPeriod}} a universal dividend</b>: it's then up to you to put to good use!",
      "WALLET_ACCOUNT": "Simple wallet",
      "WALLET_ACCOUNT_TITLE": "Create a wallet",
      "WALLET_ACCOUNT_HELP": "Are you <b>new to libre money</b>? You need an additional account?<br/>This type of account will suit you. Although it does not co-produce the money (unlike a member account - see below), you will be able to receive and send payments there, as soon as registration is complete.<br/>If necessary, you can convert it into a member account later.",
      "SALT_WARNING": "Choose a secret identifier.<br/>You need it for each connection to this account.<br/><br/><b>Make sure to remember this identifier</b>.<br/>If lost, there are no means to retrieve it!",
      "PASSWORD_WARNING": "Choose a password.<br/>You need it for each connection to this account.<br/><br/><b>Make sure to remember this password</b>.<br/>If lost, there are no means to retrieve it!",
      "PSEUDO_WARNING": "Choose a pseudonym.<br/>It may be used by other people to find you more easily.<br/><br/>.Use of <b>commas, spaces and accents</b> is not allowed.<br/><div class='hidden-xs'><br/>Example: <span class='gray'>JohnDalton, JackieChan, etc.</span>",
      "PSEUDO": "Pseudonym",
      "PSEUDO_HELP": "joe123",
      "SALT_CONFIRM": "Confirm",
      "SALT_CONFIRM_HELP": "Confirm the secret identifier",
      "PASSWORD_CONFIRM": "Confirm",
      "PASSWORD_CONFIRM_HELP": "Confirm the password",
      "SLIDE_6_TITLE": "Confirmation:",
      "COMPUTING_PUBKEY": "Computing...",
      "LAST_SLIDE_CONGRATULATION": "You completed all required fields.<br/><b>You can send the account creation request</b>.<br/><br/>For information, the public key below identifies your future account.<br/>It can be communicated to third parties to receive their payment.<br/>Once your account has been approved, you can find this key under <b>{{'ACCOUNT.TITLE'|translate}}</b>.",
      "CONFIRMATION_MEMBER_ACCOUNT": "<b class=\"assertive\">Warning:</b> your secret identifier, password and pseudonym can not be changed.<br/><b>Make sure you always remember it!</b><br/><b>Are you sure</b> you want to send this account creation request?",
      "CONFIRMATION_WALLET_ACCOUNT": "<b class=\"assertive\">Warning:</b> your password and pseudonym can not be changed.<br/><b>Make sure you always remember it!</b><br/><b>Are you sure</b> you want to continue?",
      "CHECKING_PSEUDO": "Checking...",
      "PSEUDO_AVAILABLE": "This pseudonym is available",
      "PSEUDO_NOT_AVAILABLE": "This pseudonym is not available",
      "INFO_LICENSE": "To be able to adhere to the currency, we ask you to kindly read and accept this license.",
      "BTN_ACCEPT": "I accept",
      "BTN_ACCEPT_LICENSE": "I accept the license"
    },
    "POPUP_REGISTER": {
      "TITLE": "Enter a pseudonym",
      "HELP": "A pseudonym is needed to let other members find you."
    },
    "SELECT_IDENTITY_MODAL": {
      "TITLE": "Identity selection",
      "HELP": "Several <b>different identities</b> have been sent, for the public key <span class=\"gray\"> <i class=\"ion-key\"></i> {{pubkey | formatPubkey}}</span>.<br/>Please select the identity to use:"
    },
    "SELECT_WALLET_MODAL": {
      "TITLE": "Wallet selection"
    },
    "CERTIFICATION_MODAL": {
      "CHECKLIST_TITLE": "Certification check list",
      "INFOS": "Each member is responsible for the security of Ğ1 currency. Before certifying this person's identity, you should have performed few checks. Please answer following questions:",
      "BTN_ALL_CHECK": "Certify",
      "CHECKLIST_CONDITIONS_NOT_MET": "The certification has not been sent. All answers are not right. Please recheck each point with the person to be certified.",
      "QUESTIONS": {
        "WELL_KNOWN": "Do you know <b>well</b> the person you are about to certify? Do you know other people who also know this person well?",
        "REVOCATION": "Has this person downloaded their <b>revocation document</b> and do they know where to find it?",
        "CONTACT": "Have you <b>had contact</b> with this person by many means, and did they answer?",
        "DOUBLE_IDENTITY": "The person should own <b>only one active member identity</b>. Do you think they own another one?",
        "MASTER_ACCOUNT": "Does this person own their accounts secrets? Have they already <b>sent money from their account</b> at least once?",
        "LICENSE": "Has this person <b>understood the Duniter license</b>? Do they agree to comply with it for future certifications?",
        "CREDENTIALS": "Was the account created with <b>long and complex secret identifier and password</b> (ex. passphrases)? Did the person understand that both secret identifier and password must remain secret ? Are they <b>sure to remember them</b> or to be able to find them?",
        "PUBLIC_KEY_DIFFERENT": "The <b>public key</b> that is shown must be <b>identical</b> to the one the person gave you. The public keys are they <b>different</b>?"
      },
      "REMINDER_TITLE": "Reminder",
      "SHORT_LICENSE_REMINDER": "You may remind the person to certify different certification parameters:<br/><br/><ul><li> - Each member can certify 100 other identities at most.</li><li> - The certifications are saved with a 5 days interval.</li><li> - A new identity must gather at least 5 certifications in less than 2 months.</li><li>- A member must renew its membership at least once a year.</li><li> - Certifications have a lifespan of two years.</li></ul>"
    },
    "WALLET_LIST": {
      "TITLE": "My wallets",
      "BTN_NEW": "Add a wallet",
      "BTN_DOWNLOAD": "Download the list",
      "BTN_IMPORT_FILE_DOTS": "Import from a file...",
      "NO_WALLET": "No secondary wallet",
      "BTN_DELETE": "Remove a secondary wallet...",
      "BTN_RENAME": "Rename the wallet",
      "EXPORT_FILENAME": "my_wallets-{{pubkey|formatPubkey}}-{{currency}}.csv",
      "TOTAL_DOTS": "Total: ",
      "EDIT_POPOVER": {
        "TITLE": "Rename the wallet",
        "HELP": "Fill in the new name",
        "NAME_HELP": "Wallet name"
      },
      "IMPORT_MODAL": {
        "TITLE": "Import secondary wallets",
        "HELP": "To <b>import secodnary wallets</b>, please drag the file in the box below, or click in the box to search for a file.",
        "WALLET_COUNT": "<b>{{count}}</b> new wallet{{count > 1 ? 's' : ''}}",
        "NO_NEW_WALLET": "No new wallet"
      }
    },
    "SECURITY":{
      "ADD_QUESTION" : "Add custom question",
      "BTN_CLEAN" : "Clean",
      "BTN_RESET" : "Reset",
      "DOWNLOAD_REVOKE": "Save a revocation file",
      "DOWNLOAD_REVOKE_HELP" : "Having a revocation file is important, for example in case of loss of identifiers. It allows you to <b>get this account out of the Web Of Trust</b>, thus becoming a simple wallet.",
      "GENERATE_KEYFILE": "Generate my keychain file ...",
      "GENERATE_KEYFILE_HELP": "Generate a file allowing you to authenticate without entering your identifiers.<br/><b>Warning:</b> this file will contain your secret key; It is therefore very important to put it in a safe place!",
      "KEYFILE_FILENAME": "keychain-{{pubkey|formatPubkey}}-{{currency}}-{{format}}.dunikey",
      "MEMBERSHIP_IN": "Register as member...",
      "MEMBERSHIP_IN_HELP": "Allows you to <b>transform </b> a simple wallet account <b>into a member account</b>, by sending a membership request. Useful only if you do not already have another member account.",
      "SEND_IDENTITY": "Publish identity...",
      "SEND_IDENTITY_HELP": "Allows you to associate a pseudonym to this account, but <b>without applying for membership</b> to become a member. This is not very useful because the validity of this pseudonym association is limited in time.",
      "HELP_LEVEL": "Choose <strong> at least {{nb}} questions </strong> :",
      "LEVEL": "Security level",
      "LOW_LEVEL": "Low <span class=\"hidden-xs\">(2 questions minimum)</span>",
      "MEDIUM_LEVEL": "Medium <span class=\"hidden-xs\">(4 questions minimum)</span>",
      "QUESTION_1": "What was your best friend's name when you were a teen ?",
      "QUESTION_2": "What was the name of your first pet ?",
      "QUESTION_3": "What is the first meal you have learned to cook ?",
      "QUESTION_4": "What is the first movie you saw in the cinema?",
      "QUESTION_5": "Where did you go the first time you flew ?",
      "QUESTION_6": "What was your favorite elementary school teacher's name  ?",
      "QUESTION_7": "What would you consider the ideal job ?",
      "QUESTION_8": "Which children's book do you prefer?",
      "QUESTION_9": "What was the model of your first vehicle?",
      "QUESTION_10": "What was your nickname when you were a child ?",
      "QUESTION_11": "What was your favorite movie character or actor when you were a student ?",
      "QUESTION_12": "What was your favorite singer or band when you were a student ?",
      "QUESTION_13": "In which city did your parents meet ?",
      "QUESTION_14": "What was the name of your first boss ?",
      "QUESTION_15": "What is the name of the street where you grew up ?",
      "QUESTION_16": "What is the name of the first beach where you go swim ?",
      "QUESTION_17": "QWhat is the first album you bought ?",
      "QUESTION_18": "What is the name of your favorite sport team ?",
      "QUESTION_19": "What was your grand-father's job ?",
      "RECOVER_ID": "Recover my password...",
      "RECOVER_ID_HELP": "If you have a <b>backup file of your identifiers</b>, you can find them by answering your personal questions correctly.",
      "RECOVER_ID_SELECT_FILE": "Select the <b>backup file of your identifiers</b> to use:",
      "REVOCATION_WITH_FILE" : "Revoke my member account...",
      "REVOCATION_WITH_FILE_DESCRIPTION": "If you have <b>permanently lost your member account credentials (or if account security is compromised), you can use <b>the revocation file</b> of the account <b>to quit the Web Of Trust</b>.",
      "REVOCATION_WITH_FILE_HELP": "To <b>permanently revoke</ b> a member account, please drag the revocation file in the box below, or click in the box to search for a file.",
      "REVOCATION_WALLET": "Revoke this account immediately",
      "REVOCATION_WALLET_HELP": "Requesting revocation of your identity causes <b>will revoke your membership</ b> (definitely for the associated pseudonym and public key). The account will no longer be able to produce a Universal Dividend.<br/>However, you can still use it as a simple wallet.",
      "REVOCATION_FILENAME": "revocation-{{uid}}-{{pubkey|formatPubkey}}-{{currency}}.txt",
      "SAVE_ID": "Save my credentials...",
      "SAVE_ID_HELP": "Creating a backup file, to <b>retrieve your password</b> (and the secret identifier) <b> in case of forgetting</b>. The file is <b>secured</ b> (encrypted) using personal questions.",
      "STRONG_LEVEL": "Strong <span class=\"hidden-xs \">(6 questions minimum)</span>",
      "TITLE": "Account and security",
      "KEYFILE": {
        "PUBSEC_FORMAT": "PubSec format.",
        "PUBSEC_FORMAT_HELP": "This file format is compatible in particular with Cesium and Gannonce. Your keychain is stored <b>without encryption</b>: anyone with a copy of this file will be able to empty your account.",
        "WIF_FORMAT": "Wallet Import Format (WIF)",
        "WIF_FORMAT_HELP": "This format is used in particular by paper wallets. Your keychain is stored <b>without encryption</b>: anyone with a copy of this file will be able to empty your account.",
        "EWIF_FORMAT": "Encrypted Wallet Import Format (WIF)",
        "EWIF_FORMAT_HELP": "This format is used in particular by paper wallets. However, <b>the keychain is encrypted</b> from a passphrase of your choice.",
        "PASSWORD_POPUP": {
          "TITLE": "Keychain file encrypted",
          "HELP": "Please enter the passphrase:",
          "PASSWORD_HELP": "Passphrase"
        },
        "ERROR": {
          "BAD_PASSWORD": "Bad passphrase",
          "BAD_CHECKSUM": "Bad checksum"
        }
      }
    },
    "FILE_NAME": "{{currency}} - Account statement {{pubkey|formatPubkey}} to {{currentTime|formatDateForFile}}.csv",
    "HEADERS": {
      "TIME": "Date",
      "AMOUNT": "Amount",
      "COMMENT": "Comment"
    }
  },
  "TRANSFER": {
    "TITLE": "Transfer",
    "SUB_TITLE": "Transfer money",
    "SUB_TITLE_ALL": "Empty the account",
    "FROM": "From",
    "TO": "To",
    "AMOUNT": "Amount",
    "AMOUNT_HELP": "Amount",
    "COMMENT": "Comment",
    "COMMENT_HELP": "Comment (optional)",
    "BTN_SEND": "Send",
    "BTN_ADD_COMMENT": "Add a comment",
    "REST": "Rest of account",
    "REST_TO": "to",
    "WARN_COMMENT_IS_PUBLIC": "Please note that <b>comments are public</b> (not encrypted).",
    "MODAL": {
      "TITLE": "Transfer"
    }
  },
  "ERROR": {
    "UNKNOWN_URI_FORMAT": "Unknown URI format",
    "PUBKEY_INVALID_CHECKSUM": "Invalid public key (bad checksum).",
    "POPUP_TITLE": "Error",
    "UNKNOWN_ERROR": "Unknown error",
    "TIMEOUT_REACHED": "Peer timeout exceeded ({{timeout|formatDurationMs}}).<br/><br/><small>{{url}}</small>",
    "CRYPTO_UNKNOWN_ERROR": "Your browser is not compatible with cryptographic features.",
    "DOWNLOAD_KEYFILE_FAILED": "Failed to generate the keychain file.",
    "EQUALS_TO_PSEUDO": "Must be different from pseudonym",
    "EQUALS_TO_SALT": "Must be different from secret identifier",
    "FIELD_REQUIRED": "This field is required.",
    "FIELD_TOO_SHORT": "This field value is too short.",
    "FIELD_TOO_SHORT_WITH_LENGTH": "Value is too short (min {{minLength]] characters).",
    "FIELD_TOO_LONG": "Value is exceeding max length.",
    "FIELD_TOO_LONG_WITH_LENGTH": "Value is too long (max {{maxLength}} characters).",
    "FIELD_MIN": "Minimum value: {{min}}",
    "FIELD_MAX": "Maximal value: {{max}}",
    "FIELD_ACCENT": "Commas and accent characters not allowed",
    "FIELD_NOT_NUMBER": "Value is not a number",
    "FIELD_NOT_INT": "Value is not an integer",
    "FIELD_NOT_EMAIL": "Email adress not valid",
    "PASSWORD_NOT_CONFIRMED": "Must match previous password.",
    "SALT_NOT_CONFIRMED": "Must match previous identifier.",
    "SEND_IDENTITY_FAILED": "Error while trying to register.",
    "SEND_CERTIFICATION_FAILED": "Could not certify identity.",
    "NEED_MEMBER_ACCOUNT_TO_CERTIFY": "You could not send certification, because your account is <b>not a member account</b>.",
    "NEED_MEMBER_ACCOUNT_TO_CERTIFY_HAS_SELF": "You could not send certification now, because your are <b>not a member</b> yet.<br/><br/>You still need certification to become a member.",
    "IDENTITY_TO_CERTIFY_HAS_NO_SELF": "This account could not be certified. No registration found, or need to renew.",
    "LOGIN_FAILED": "Error while sign in.",
    "LOAD_IDENTITY_FAILED": "Could not load identity.",
    "LOAD_REQUIREMENTS_FAILED": "Could not load identity requirements.",
    "SEND_MEMBERSHIP_IN_FAILED": "Error while sending registration as member.",
    "SEND_MEMBERSHIP_OUT_FAILED": "Error while sending membership revocation.",
    "REFRESH_WALLET_DATA": "Could not refresh wallet.",
    "GET_CURRENCY_PARAMETER": "Could not get currency parameters.",
    "GET_CURRENCY_FAILED": "Could not load currency. Please retry later.",
    "SEND_TX_FAILED": "Could not send transaction.",
    "ALL_SOURCES_USED": "Please wait the next block computation (All transaction sources has been used).",
    "NOT_ENOUGH_SOURCES": "Not enough changes to send this amount in one time.<br/>Maximum amount: {{amount}} {{unit}}<sub>{{subUnit}}</sub>.",
    "ACCOUNT_CREATION_FAILED": "Error while creating your member account.",
    "RESTORE_WALLET_DATA_ERROR": "Error while reloading settings from local storage",
    "LOAD_WALLET_DATA_ERROR": "Error while loading wallet data.",
    "COPY_CLIPBOARD_FAILED": "Could not copy to clipboard",
    "TAKE_PICTURE_FAILED": "Could not get picture.",
    "SCAN_FAILED": "Could not scan QR code.",
    "SCAN_UNKNOWN_FORMAT": "Code not recognized.",
    "WOT_LOOKUP_FAILED": "Search failed.",
    "LOAD_PEER_DATA_FAILED": "Duniter peer not accessible. Please retry later.",
    "NEED_LOGIN_FIRST": "Please sign in first.",
    "AMOUNT_REQUIRED": "Amount is required.",
    "AMOUNT_NEGATIVE": "Negative amount not allowed.",
    "NOT_ENOUGH_CREDIT": "Not enough credit.",
    "INVALID_NODE_SUMMARY": "Unreachable peer or invalid address",
    "INVALID_USER_ID": "Field 'pseudonym' must not contains spaces or special characters.",
    "INVALID_COMMENT": "Field 'reference' has a bad format.",
    "INVALID_PUBKEY": "Public key has a bad format.",
    "INVALID_PUBKEY_CHECKSUM": "Invalid checksum.",
    "IDENTITY_REVOKED": "This identity <b>has been revoked</b>. It can no longer become a member.",
    "IDENTITY_REVOKED_WITH_TIME": "This identity <b>has been revoked {{revocationTime|medianFromNow}}</b> ({{revocationTime|medianDate}}). It can no longer become a member.",
    "IDENTITY_PENDING_REVOCATION": "The <b>revocation of this identity</b> has been requested and is awaiting processing. Certification is therefore disabled.",
    "IDENTITY_INVALID_BLOCK_HASH": "This membership application is no longer valid (because it references a block that network peers are cancelled): the person must renew its application for membership <b>before</b> being certified.",
    "IDENTITY_EXPIRED": "This identity has expired: this person must re-apply <b>before</b> being certified.",
    "IDENTITY_SANDBOX_FULL": "Could not register, because peer's sandbox is full.<br/><br/>Please retry later or choose another Duniter peer (in <b>Settings</b>).",
    "IDENTITY_NOT_FOUND": "Identity not found",
    "IDENTITY_TX_FAILED": "Error while getting identity's transactions",
    "WOT_PENDING_INVALID_BLOCK_HASH": "Membership not valid.",
    "WALLET_INVALID_BLOCK_HASH": "Your membership application is no longer valid (because it references a block that network peers are cancelled).<br/>You must <a ng-click=\"doQuickFix('renew')\">renew your application for membership</a> to fix this issue.",
    "WALLET_IDENTITY_EXPIRED": "The publication of your identity <b>has expired</b>.<br/>You must <a ng-click=\"doQuickFix('fixIdentity')\">re-issue your identity</a> to resolve this issue.",
    "WALLET_REVOKED": "Your identity has been <b>revoked</b>: neither your pseudonym nor your public key will be used in the future for a member account.",
    "WALLET_HAS_NO_SELF": "Your identity must first have been published, and not expired.",
    "AUTH_REQUIRED": "Authentication required.",
    "AUTH_INVALID_PUBKEY": "The public key does not match the connected account.",
    "AUTH_INVALID_SCRYPT": "Invalid username or password.",
    "AUTH_INVALID_FILE": "Invalid keychain file.",
    "AUTH_FILE_ERROR": "Failed to open keychain file",
    "IDENTITY_ALREADY_CERTIFY": "You have <b>already certified</b> that identity.<br/><br/>Your certificate is still valid (expires {{expiresIn|formatDuration}}).",
    "IDENTITY_ALREADY_CERTIFY_PENDING": "You have <b>already certified</b> that identity.<br/><br/>Your certification is still pending (Deadline for treatment {{expiresIn|formatDuration}}).",
    "UNABLE_TO_CERTIFY_TITLE": "Unable to certify",
    "LOAD_NEWCOMERS_FAILED": "Unable to load new members.",
    "LOAD_PENDING_FAILED": "Unable to load pending registrations.",
    "ONLY_MEMBER_CAN_EXECUTE_THIS_ACTION": "You must <b>be a member</b> in order to perform this action.",
    "ONLY_MEMBER_OR_WAS_MEMBER_CAN_EXECUTE_THIS_ACTION": "You must <b>be a member (or old member)</b> in order to perform this action.",
    "ONLY_SELF_CAN_EXECUTE_THIS_ACTION": "You must have <b>published your identity</b> in order to perform this action.",
    "GET_BLOCK_FAILED": "Error while getting block",
    "INVALID_BLOCK_HASH": "Block not found (incorrect hash)",
    "DOWNLOAD_REVOCATION_FAILED": "Error while downloading revocation file.",
    "REVOCATION_FAILED": "Error while trying to revoke the identity.",
    "SALT_OR_PASSWORD_NOT_CONFIRMED": "Wrong secret identifier or password ",
    "RECOVER_ID_FAILED": "Could not recover password",
    "LOAD_FILE_FAILED" : "Unable to load file",
    "NOT_VALID_REVOCATION_FILE": "Invalid revocation file (wrong file format)",
    "NOT_VALID_SAVE_ID_FILE": "Invalid credentials backup file (wrong file format)",
    "NOT_VALID_KEY_FILE": "Invalid keychain file (unrecognized format)",
    "EXISTING_ACCOUNT": "Your identifiers correspond to an already existing account, whose <a ng-click=\"showHelpModal('pubkey')\">public key</a> is:",
    "EXISTING_ACCOUNT_REQUEST": "Please modify your credentials so that they correspond to an unused account.",
    "GET_LICENSE_FILE_FAILED": "Unable to get license file",
    "CHECK_NETWORK_CONNECTION": "No peer appears to be accessible.<br/><br/>Please <b>check your Internet connection</b>.",
    "ISSUE_524_TX_FAILED": "Failed to transfer.<br/><br/>A message has been sent to developers to help solve the problem.<b>Thank you for your help</b>.",
    "ADD_SECONDARY_WALLET_FAILED": "Unable to add secondary wallet.",
    "REMOVE_SECONDARY_WALLET_FAILED": "Unable to remove secondary wallet.",
    "UPDATE_WALLET_LIST_FAILED": "Unable to refresh the list of wallets.",
    "LOAD_WALLET_LIST_FAILED": "Unable to load the list of wallets.",
    "SAVE_WALLET_LIST_FAILED": "Unable to save the list of wallets.",
    "COULD_NOT_ADD_MAIN_WALLET": "This wallet <b>is the main account</b> with which you are connected. Unable to add it as a secondary wallet.",
    "COULD_NOT_ADD_EXISTING_WALLET": "Wallet already existing in the list.",
    "UNKNOWN_WALLET_ID": "Unknown secondary wallet.",
    "RESTORE_WALLET_LIST_FAILED": "Unable to restore the list of wallets.",
    "INVALID_FILE_FORMAT": "Invalid file format.",
    "SAME_TX_RECIPIENT": "The recipient must be different from the issuer."
  },
  "INFO": {
    "POPUP_TITLE": "Information",
    "CERTIFICATION_DONE": "Identity successfully signed",
    "NOT_ENOUGH_CREDIT": "Not enough credit",
    "TRANSFER_SENT": "Transfer request successfully sent",
    "COPY_TO_CLIPBOARD_DONE": "Copy succeeded",
    "MEMBERSHIP_OUT_SENT": "Membership revocation sent",
    "NOT_NEED_MEMBERSHIP": "Already a member.",
    "IDENTITY_WILL_MISSING_CERTIFICATIONS": "This identity will soon lack certification (at least {{willNeedCertificationCount}}).",
    "IDENTITY_NEED_MEMBERSHIP": "This identity did not send a membership request. She will have to if she wishes to become a member.",
    "HAS_ALTERNATIVE_IDENTITIES": "There are <b>multiple identities</b> attached to this public key. <b>Before any certification</b>, please <a ng-click=\"doQuickFix('showSelectIdentities')\">check other identities</a> to choose the correct one, or contact the wallet owner.",
    "REVOCATION_SENT": "Revocation sent successfully",
    "REVOCATION_SENT_WAITING_PROCESS": "Revocation <b>has been sent successfully</b>. It is awaiting processing.",
    "FEATURES_NOT_IMPLEMENTED": "This features is not implemented yet.<br/><br/>Why not to contribute to get it faster? ;)",
    "EMPTY_TX_HISTORY": "No operations to export",
    "LOADING_PENDING_TX": "Please wait...<br/><small>(Retrieving pending operations)</small>"
  },
  "CONFIRM": {
    "CAN_CONTINUE": "<b>Are you sure</b> you want to continue?",
    "POPUP_TITLE": "<b>Confirmation</b>",
    "POPUP_WARNING_TITLE": "<b>Warning</b>",
    "POPUP_SECURITY_WARNING_TITLE": "<i class=\"icon ion-alert-circled\"></i> <b>Security warning</b>",
    "CERTIFY_RULES_TITLE_UID": "Certify {{uid}}",
    "CERTIFY_RULES": "<b class=\"assertive\">Don't certify an account</b> if you believe that: <ul><li>1.) the issuers identity might be faked.<li>2.) the issuer already has another certified account.<li>3.) the issuer purposely or carelessly violates rule 1 or 2 (he certifies faked or double accounts).</ul></small><br/>Are you sure you want to certify this identity?",
    "FULLSCREEN": "View the application in full screen?",
    "EXIT_APP": "Close the application ?",
    "TRANSFER": "<b>Transfer summary:</b><br/><br/><ul><li> - From: <b>{{from}}</b></li><li> - To: <b>{{to}}</b></li><li> - Amount: <b>{{amount}} {{unit}}</b></li><li> - Comment: <i>{{comment}}</i></li></ul><br/><b>Are-you sure you want to do this transfer?</b>",
    "TRANSFER_ALL": "<b>Transfer summary:</b><br/><br/><ul><li> - From: <b>{{from}}</b></li><li> - To: <b>{{to}}</b></li><li> - Amount: <b>{{amount}} {{unit}}</b></li><li> - Comment: <i>{{comment}}</i></li><br/><li> - Rest : <b>{{restAmount}} {{unit}}</b> to <b>{{restTo}}</b></li></ul><br/><b>Are-you sure you want to do this transfer?</b>",
    "MEMBERSHIP_OUT": "This operation is <b>irreversible</b>.<br/></br/><b>Are you sure you want to terminate your membership?</b>",
    "MEMBERSHIP_OUT_2": "This operation is <b>irreversible</b>!<br/><br/>Are you sure you want to <b>terminate your membership</b>?",
    "LOGIN_UNUSED_WALLET_TITLE": "Typing error?",
    "LOGIN_UNUSED_WALLET": "The account seems to be <b>inactive</b>.<br/><br/>It's probably a <b>typing error</b> when sign in. Please try again, checking that <b>public key is yours<b/>.",
    "FIX_IDENTITY": "The pseudonym <b>{{uid}}</b> will be published again, replacing the old publication that has expired.<br/></br/><b>Are you sure</b> you want to continue?",
    "FIX_MEMBERSHIP": "Your application for membership will be sent.<br/></br/><b>Are you sure?</b>",
    "MEMBERSHIP": "Your membership request will be sent. <br/></br/><b>Are you sure?</b>",
    "RENEW_MEMBERSHIP": "Your membership will be renewed.<br/></br/><b>Are you sure?</b>",
    "REVOKE_IDENTITY": "You will <b>definitely revoke this identity</b>.<br/><br/>The public key and the associated pseudonym <b>will never be used again</b> (for a member account).<br/></br/><b>Are you sure</b> you want to revoke this identity?",
    "REVOKE_IDENTITY_2": "This operation is <b>irreversible</b>!<br/><br/>Are you sure you want to <b>revoke this identity</b>?",
    "NOT_NEED_RENEW_MEMBERSHIP": "Your membership does not need to be renewed (it will only expire in {{membershipExpiresIn|formatDuration}}).<br/></br/><b>Are you sure you</b> want to renew your membership?",
    "SAVE_BEFORE_LEAVE": "Do you want to <b>save your changes</b> before leaving the page?",
    "SAVE_BEFORE_LEAVE_TITLE": "Changes not saved",
    "LOGOUT": "Are you sure you want to logout?",
    "USE_FALLBACK_NODE": "Peer <b>{{old}}</b> unreachable or invalid address.<br/><br/>Do you want to temporarily use the <b>{{new}}</b> node?",
    "USE_SYNC_FALLBACK_NODE": "Node <b>{{old}}</b> seems to be out of sync.<br/><br/>Do you want to temporarily use the synchronised node <b>{{new}}</b>?",
    "ISSUE_524_SEND_LOG": "The transaction was rejected because of a known problem (issue #524) but not reproduced.<br/><br/>To help developers correct this error, do you accept <b>the transmission of your logs</b> per message?<br/><small>(No confidential data is sent)</small>",
    "ENABLE_EXPERT_MODE_TO_CHANGE_NODE": "<b class=\"assertive\">Warning:</b> Do you want to <b>manually change</b> the Duniter node?<br/><br/>If you proceed:<ul><li> - <b>Expert mode</b> will be activated;</li><li> - You can return to automatic node selection by simply <b>deactivating expert mode</b>.</li></ul>"
  },
  "MODE": {
    "DEMO": {
      "BADGE": "Demo",
      "MODE": "Demonstration mode",
      "FEATURE_NOT_AVAILABLE": "Functionality <b>not available</b> on this demonstration site.",
      "MODE_HELP": "Cesium works in <b>demonstration mode</b>: consultation on account is available, but no operation can be performed.",
      "INSTALL_HELP": "For <b>security reasons</b> we recommend <b>installing</b> your copy of the software.<br/> Visit the site <a href='https://cesium.app'>www.cesium.app</a> for help."
    },
    "READONLY": {
      "BADGE": "Monit",
      "MODE": "Monitoring mode",
      "MODE_HELP": "Cesium works in <b>monitoring mode</b>: only currency monitoring features are available.",
      "INSTALL_HELP": "If you want to <b>create a wallet account</b> to send or received money, we recommend <b>installing</b> your copy of the software.<br/> Visit the site <a href='https://cesium.app'>www.cesium.app</a> for help."
    }
  },
  "DOWNLOAD": {
    "POPUP_TITLE": "<b>Revocation file</b>",
    "POPUP_REVOKE_MESSAGE": "To safeguard your account, please download the <b>account revocation document</b>. It will allow you to cancel your account (in case of account theft, ID, an incorrectly created account, etc.).<br/><br/><b>Please store it in a safe place.</b>"
  },
  "HELP": {
    "TITLE": "Online help",
    "JOIN": {
      "SECTION": "Join",
      "SALT": "The secret identifier is very important. It is used to hash you password, which in turn is used to calculate your <span class=\"text-italic\">public account key</span> (its number) and the private key to access it.<br/><b>Please remeber this identifier well</b>, because there is no way to recover it when lost.<br/>Furthermore, it cannot be changed without having to create a new account.<br/><br/>A good secret identifier must be sufficiently long (8 characters at the very least) and as original as possible.",
      "PASSWORD": "The password is very important. Together with the secret identifier, it is use to calculate your account number (pblic key) and the private key to access it.<br/><b>Please remember it well</b>, because there is no way to recover it when lost.<br/>Furthermore, it cannot be changed without having to create a new account.<br/><br/>A good password is made (ideally) of at least 8 characters, with at least one capital and one number.",
      "PSEUDO": "A pseudonym is used only when joining as <span class=\"text-italic\">member</span>. It is always associated with a wallet (by its <span class=\"text-italic\">public key</span>).<br/>It is published on the network so that other users may identify it, certify or send money to the account.<br/>A pseudonym must be unique among all members (current and past)."
    },
    "LOGIN": {
      "SECTION": "Log in",
      "PUBKEY": "Account public key",
      "PUBKEY_DEF": "The public key of the keychain is generated from the entered identifiers (any), but does not correspond to an account already used.<br/><b>Make sure your public key is the same as your account</b>. Otherwise, you will be logged into an account that is probably never used, as the risk of collision with an existing account is very small.<br/><a href=\"https://en.wikipedia.org/wiki/Elliptic_curve_cryptography\" target=\"_ system\">Learn more about cryptography</a> by public key.",
      "METHOD": "Connection methods",
      "METHOD_DEF": "Several options are available to connect to a portfolios: <br/> - The connection <b>with salt (simple or advanced)</b> mixes your password with the secret identifier, to limit the attempts of piracy<br/> - The connection <b>using public key</b> prevents you from entering your credentials, which you will be asked only when an operation need it.<br/> - The connection <b>using keychain file</b> will read the public and private keys of the account from a file without the need to enter credentials. Several file formats are possible."
    },
    "GLOSSARY": {
      "SECTION": "Glossary",
      "PUBKEY_DEF": "A public key always identifies a wallet. It may identify a member. In Cesium it is calculated using the secret identifier and the password.",
      "MEMBER": "Member",
      "MEMBER_DEF": "A member is a real and living human, wishing to participate freely to the monitary community. The member will receive universal dividend, according to the period and amount as defined in the <span class=\"text-italic\">currency parameters</span>.",
      "CURRENCY_RULES": "Currency rules",
      "CURRENCY_RULES_DEF": "The currency rules are defined only once, and for all. They set the parameters under which the currency will perform: universal dividend calculation, the amount of certifications needed to become a member, the maximum amount of certifications a member can send, etc.<br/><br/>The parameters cannot be modified because of the use of a <span class=\"text-italic\">Blockchain</span> which carries and executes these rules, and constantly verifies their correct application. <a href=\"#/app/currency\">See current parameters</a>.",
      "BLOCKCHAIN": "Blockchain",
      "BLOCKCHAIN_DEF": "The Blockchain is a decentralised system which, in case of Duniter, serves to carry and execute the <span class=\"text-italic\">currency rules</span>.<br/><a href=\"http://en.duniter.org/presentation/\" target=\"_blank\">Read more about Duniter</a> and the working of its blockchain.",
      "UNIVERSAL_DIVIDEND_DEF": "The Universal Dividend (UD) is the quantity of money co-created by each member, according to the period and the calculation defined in the <span class=\"text-italic\">currency rules</span>.<br/>Every term, the members receive an equal amount of new money on their account.<br/><br/>The UD undergoes a steady growth, to remain fair under its members (current and future), calculated by an average life expectancy, as demonstrated in the Relative Theory of Money (RTM).<br/><a href=\"http://trm.creationmonetaire.info\" target=\"_system\">Read more about RTM</a> and open money.",
      "WOT": "Web of Trust (WoT)",
      "WOT_DEF": "The Web of Trust is made up of all the members of the currency, and the links of certification which connect them.",
      "DISTANCE_RULE": "Distance rule",
      "DISTANCE_RULE_DEF": "The rule of distance defines <b>a maximum distance to meet</b> between an applicant and a minimum number of referring member. This distance is calculated using the certification links."
    },
    "TIP": {
      "MENU_BTN_CURRENCY": "Menu <b>{{'MENU.CURRENCY'|translate}}</b> allows discovery of <b>currency parameters</b> and its state.",
      "CURRENCY_WOT": "The <b>member count</b> shows the <b>community's weight and evolution</b>.",
      "CURRENCY_MASS": "Shown here is the <b>total amount</b> currently in circulation and its <b>average distribution</b> per member.<br/><br/>This allows to estimate the <b>worth of any amount</b>, in respect to what <b>others own</b> on their account (on average).",
      "CURRENCY_UNIT_RELATIVE": "The unit used here (&ldquo;<b>{{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub></b>&rdquo;) signifies that the amounts in {{currency|capitalize}} have been devided by the <b>Universal Dividend</b> (UD).<br/><br/><small>This relative unit is <b>relevant</b> because it is stable in contrast to the permanently growing monitary mass.</small>",
      "CURRENCY_CHANGE_UNIT": "The option <b>{{'COMMON.BTN_RELATIVE_UNIT'|translate}}</b> allows to <b>switch the unit</b> to show amounts in <b>{{currency|capitalize}}</b>, undevided by the Universal Dividend (instead of in &ldquo;<b>{{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub></b>&rdquo;).",
      "CURRENCY_CHANGE_UNIT_TO_RELATIVE": "The option <b>{{'COMMON.BTN_RELATIVE_UNIT'|translate}}</b> allows to <b>switch the unit</b> to show amounts in &ldquo;<b>{{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub></b>&rdquo;, which is relative to the Universal Dividend (the amount co-produced by each member).",
      "CURRENCY_RULES": "The <b>rules</b> of the currency determine its <b>exact and predictible</b> performance.<br/><br/>As a true DNA of the currency these rules make the monetary code <b>transparent and understandable</b>.",
      "MENU_BTN_NETWORK": "Menu <b>{{'MENU.NETWORK'|translate}}</b> allows discovery of <b>network's state<b>.",
      "NETWORK_BLOCKCHAIN": "All monetary transactions are recoded in a <b>public and tamper proof</b> ledger, generally referred to as the <b>blockchain</b>.",
      "NETWORK_PEERS": "The <b>peers</b> shown here correspond to <b>computers that update and check</b> the blockchain.<br/><br/>The more active peers there are, the more <b>decentralised</b> and therefore trustworhty the currency becomes.",
      "NETWORK_PEERS_BLOCK_NUMBER": "This <b>number</b> (in green) indicates the peer's <b>latest validated block</b> (last page written in the ledger).<br/><br/>Green indicates that the block was equally validated by the <b>majority of other peers</b>.",
      "NETWORK_PEERS_PARTICIPATE": "<b>Each member</b>, equiped with a computer with Internet, <b>can participate, adding a peer</b> simply by <b>installing the Duniter software</b> (free/libre). <a target=\"_new\" href=\"{{installDocUrl}}\" target=\"_system\">Read the installation manual &gt;&gt;</a>.",
      "MENU_BTN_ACCOUNT": "<b>{{'ACCOUNT.TITLE'|translate}}</b> allows access to your account balance and transaction history.",
      "MENU_BTN_ACCOUNT_MEMBER": "Here you can consult your account status, transaction history and your certifications.",
      "WALLET_CERTIFICATIONS": "Click here to reveiw the details of your certifications (given and received).",
      "WALLET_RECEIVED_CERTIFICATIONS": "Click here to review the details of your <b>received certifications</b>.",
      "WALLET_GIVEN_CERTIFICATIONS": "Click here to review the details of your <b>given certifications</b>.",
      "WALLET_BALANCE": "Your account <b>balance</b> is shown here.",
      "WALLET_BALANCE_RELATIVE": "{{'HELP.TIP.WALLET_BALANCE'|translate}}<br/><br/>The used unit (&ldquo;<b>{{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub></b>&rdquo;) signifies that the amount in {{currency|capitalize}} has been divided by the <b>Universal Dividend</b> (UD) co-created by each member.<br/>At this moment, 1 UD equals {{currentUD}} {{currency|capitalize}}.",
      "WALLET_BALANCE_CHANGE_UNIT": "You can <b>change the unit</b> in which amounts are shown in <b><i class=\"icon ion-android-settings\"></i>&nbsp;{{'MENU.SETTINGS'|translate}}</b>.<br/><br/>For example, to display amounts <b>directly in {{currency|capitalize}}</b> instead of relative amounts.",
      "WALLET_PUBKEY": "This is your account public key. You can communicate it to a third party so that it more easily identifies your account.",
      "WALLET_SEND": "Issue a payment in just a few clicks.",
      "WALLET_SEND_NO_MONEY": "Issue a payment in just a few clicks.<br/>(Your balance does not allow this yet)",
      "WALLET_OPTIONS": "Please note that this button allows access to <b>other, less used actions</b>.<br/><br/>Don't forget to take a quick look, when you have a moment!",
      "WALLET_RECEIVED_CERTS": "This shows the list of persons that certified you.",
      "WALLET_CERTIFY": "The button <b>{{'WOT.BTN_SELECT_AND_CERTIFY'|translate}}</b> allows selecting an identity and certifying it.<br/><br/>Only users that are <b>already member</b> may certify others.",
      "WALLET_CERT_STOCK": "Your supply of certifications (to send) is limited to <b>{{sigStock}} certifications</b>.<br/><br/>This supply will replete itself over time, as and when earlier certifications expire.",
      "MENU_BTN_WALLETS": "The menu <b>{{'MENU.WALLETS'|translate}}</b> allows you to add additional wallets that you manage.",
      "MENU_BTN_TX": "The menu <b>{{'MENU.TRANSACTIONS'|translate}}</b> allow access to transactions history, and send new payments.",
      "MENU_BTN_WOT": "The menu <b>{{'MENU.WOT'|translate}}</b> allows searching <b>users</b> of the currency (member or not).",
      "WOT_SEARCH_TEXT_XS": "To search in the registry, type the <b>first letters of a users pseudonym or public key</b>.<br/><br/>The search will start automatically.",
      "WOT_SEARCH_TEXT": "To search in the registry, type the <b>first letters of a users pseudonym or public key</b>.<br/><br/>Then hit <b>Enter</b> to start the search.",
      "WOT_SEARCH_RESULT": "Simply click a user row to view the details sheet.",
      "WOT_VIEW_CERTIFICATIONS": "The row <b>{{'ACCOUNT.CERTIFICATION_COUNT'|translate}}</b> shows how many members members validated this identity.<br/><br/>These certifications testify that the account belongs to <b>a living human</b> and this person has <b>no other member account</b>.",
      "WOT_VIEW_CERTIFICATIONS_COUNT": "There are at least <b>{{sigQty}} certifications</b> needed to become a member and receive the <b>Universal Dividend</b>.",
      "WOT_VIEW_CERTIFICATIONS_CLICK": "Click here to open <b>a list of all certifications</b> given to and by this identity.",
      "WOT_VIEW_CERTIFY": "The button <b>{{'WOT.BTN_CERTIFY'|translate}}</b> allows to add your certification to this identity.",
      "CERTIFY_RULES": "<b>Attention:</b> Only certify <b>real and living persons</b> that do not own any other certified account.<br/><br/>The trust carried by the currency depends on each member's vigilance!",
      "MENU_BTN_SETTINGS": "The <b>{{'MENU.SETTINGS'|translate}}</b> allow you to configure the Cesium application.<br/><br/>For example, you can <b>change the unit</b> in which the currency will be shown.",
      "HEADER_BAR_BTN_PROFILE": "Click here to access your <b>user profile</b>",
      "SETTINGS_CHANGE_UNIT": "You can <b>change the display unit</b> of amounts by clicking here.<br/><br/>- Deactivate the option to show amounts in {{currency|capitalize}}.<br/>- Activate the option for relative amounts in {{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub> (<b>divided</b> by the current Universal Dividend).",
      "END_LOGIN": "This guided visit has <b>ended</b>.<br/><br/>Welcome to the <b>free economy</b>!",
      "END_NOT_LOGIN": "This guided visit has <b>ended</b>.<br/><br/>If you wish to join the currency {{currency|capitalize}}, simply click <b>{{'LOGIN.CREATE_FREE_ACCOUNT'|translate}}</b> below.",
      "END_READONLY": "This guided visit has <b>ended</b>.<br/><br/>{{'MODE.READONLY.INSTALL_HELP'|translate}}."
    }
  },
  "API" :{
    "COMMON": {
      "LINK_DOC": "API documentation",
      "LINK_DOC_HELP": "API documentation for developers",
      "LINK_STANDARD_APP": "Standard version",
      "LINK_STANDARD_APP_HELP": "Open standard version of {{'COMMON.APP_NAME'|translate}}",
      "CONNECTION_ERROR": "Peer <b>{{server}}</b> unreachable or invalid address.<br/><br/>Check your Internet connection, or contact the web site administrator."
    },
    "HOME": {
      "TITLE": "{{'COMMON.APP_NAME'|translate}} API Documentation",
      "MESSAGE": "Welcome to the {{'COMMON.APP_NAME'|translate}} <b>API documentation </b>.<br/>Connect your web site to <a href=\"http://duniter.org\" target=\"_system\">Duniter</a> very easily!",
      "MESSAGE_SHORT": "Connect your websites to <a href=\"http://duniter.org\" target=\"_system\">Duniter</a> very easily!",
      "DOC_HEADER": "Available services:"
    },
    "TRANSFER": {
      "TITLE": "{{'COMMON.APP_NAME'|translate}} - Online payment",
      "TITLE_SHORT": "Online payment",
      "SUMMARY": "Order summary:",
      "AMOUNT": "Amount:",
      "AMOUNTS_HELP": "Please select the amount:",
      "NAME": "Name:",
      "PUBKEY": "Public key of the recipient:",
      "COMMENT": "Order reference:",
      "NODE": "Peer address:",
      "DEMO": {
        "SALT": "demo",
        "PASSWORD": "demo",
        "PUBKEY": "3G28bL6deXQBYpPBpLFuECo46d3kfYMJwst7uhdVBnD1",
        "HELP": "<b>Demonstration mode</b>: No payment will actually be sent during this simulation.<br/>Please use credentials: <b>{{'API.TRANSFER.DEMO.SALT'|translate}} / {{'API.TRANSFER.DEMO.PASSWORD'|translate}}</b>",
        "BAD_CREDENTIALS": "Invalid credentials.<br/>In demonstration mode, credentials should be: {{'API.TRANSFER.DEMO.SALT'|translate}} / {{'API.TRANSFER.DEMO.PASSWORD'|translate}}"
      },
      "INFO": {
        "SUCCESS_REDIRECTING_WITH_NAME": "Payment sent.<br/>Redirect to <b>{{name}}</b>...",
        "SUCCESS_REDIRECTING": "Payment sent.<br/>Redirect to the seller's website...",
        "CANCEL_REDIRECTING_WITH_NAME": "Payment cancelled.<br/>Redirect to <b>{{name}}</b>...",
        "CANCEL_REDIRECTING": "Payment cancelled.<br/>Redirect to the seller's website..."
      },
      "ERROR": {
        "TRANSFER_FAILED": "Payment failed"
      }
    },
    "DOC": {
      "DESCRIPTION_DIVIDER": "Description",
      "URL_DIVIDER": "Calling address",
      "PARAMETERS_DIVIDER": "Parameters",
      "AVAILABLE_PARAMETERS": "Here is the list of al available parameters:",
      "DEMO_DIVIDER": "Try it !",
      "DEMO_HELP": "To test this service, click on this button. The result content will be display below.",
      "DEMO_RESULT": "Result returned by call:",
      "DEMO_RESULT_PEER": "Peer address used:",
      "DEMO_SUCCEED": "<i class=\"icon ion-checkmark\"></i> Success!",
      "DEMO_CANCELLED": "<i class=\"icon ion-close\"></i> Cancelled by user",
      "INTEGRATE_DIVIDER": "Website integration",
      "INTEGRATE_CODE": "Code:",
      "INTEGRATE_RESULT": "Result preview:",
      "INTEGRATE_PARAMETERS": "Parameters",
      "TRANSFER": {
        "TITLE": "Payments",
        "DESCRIPTION": "From a site (eg online marketplace) you can delegate payment in free currency to Cesium API. To do this, simply open a page at the following address:",
        "PARAM_PUBKEY": "Recipient's public key",
        "PARAM_PUBKEY_HELP": "Recipient's public key (required)",
        "PARAM_AMOUNT": "Amount",
        "PARAM_AMOUNT_HELP": "Transaction amount (required)",
        "PARAM_COMMENT": "Reference (or comment)",
        "PARAM_COMMENT_HELP": "Reference or comment. You will allow for example to identify the payment in the BlockChain.",
        "PARAM_NAME": "Name (of recipient or website)",
        "PARAM_NAME_HELP": "The name of your website. This can be a readable name (eg \"My online site\"), or a web address (eg \"www.MySite.com\").",
        "PARAM_REDIRECT_URL": "URL redirection",
        "PARAM_REDIRECT_URL_HELP": "URL redirection after sending payment, after the payment has been sent. Can contain the following strings, which will be replaced by the values of the transaction: \"{tx}\", \"{hash}\", \"{comment}\", \"{amount}\" and \"{pubkey}\".",
        "PARAM_CANCEL_URL": "URL if cancelled",
        "PARAM_CANCEL_URL_HELP": "URL in case of cancellation.  Can contain the following strings, which will be replaced: \"{comment}\", \"{amount}\" and \"{pubkey}\".",
        "PARAM_PREFERRED_NODE": "Preferred Duniter peer",
        "PARAM_PREFERRED_NODE_HELP": "Peer address (URL) to use preferably (\"g1.domain.com:443\" or \"https://g1.domain.com\")",
        "EXAMPLES_HELP": "Examples of integration:",
        "EXAMPLE_BUTTON": "HTML Button",
        "EXAMPLE_BUTTON_DEFAULT_TEXT": "Pay in {{currency|abbreviate}}",
        "EXAMPLE_BUTTON_DEFAULT_STYLE": "Custom style",
        "EXAMPLE_BUTTON_TEXT_HELP": "Button text",
        "EXAMPLE_BUTTON_BG_COLOR": "Background color",
        "EXAMPLE_BUTTON_BG_COLOR_HELP": "eg: #fbc14c, yellow, lightgrey, rgb(180,180,180)",
        "EXAMPLE_BUTTON_FONT_COLOR": "Font color",
        "EXAMPLE_BUTTON_FONT_COLOR_HELP": "eg: black, orange, rgb(180,180,180)",
        "EXAMPLE_BUTTON_TEXT_ICON": "Icon",
        "EXAMPLE_BUTTON_TEXT_WIDTH": "Width",
        "EXAMPLE_BUTTON_TEXT_WIDTH_HELP": "eg: 200px, 50%",
        "EXAMPLE_BUTTON_ICON_NONE": "No icon",
        "EXAMPLE_BUTTON_ICON_DUNITER": "Duniter logo",
        "EXAMPLE_BUTTON_ICON_CESIUM": "Cesium logo",
        "EXAMPLE_BUTTON_ICON_G1_COLOR": "Ğ1 logo",
        "EXAMPLE_BUTTON_ICON_G1_BLACK": "Ğ1 logo (outline)"
      }
    }
  }
}
);

$translateProvider.translations("en", {
  "COMMON": {
    "APP_NAME": "Cesium",
    "APP_VERSION": "v{{version}}",
    "APP_BUILD": "build {{build}}",
    "PUBKEY": "Public key",
    "MEMBER": "Member",
    "BLOCK" : "Block",
    "BTN_OK": "OK",
    "BTN_YES": "Yes",
    "BTN_NO": "No",
    "BTN_SEND": "Send",
    "BTN_SEND_MONEY": "Transfer money",
    "BTN_SEND_MONEY_SHORT": "Transfer",
    "BTN_SAVE": "Save",
    "BTN_YES_SAVE": "Yes, Save",
    "BTN_YES_CONTINUE": "Yes, Continue",
    "BTN_SHOW": "Show",
    "BTN_SHOW_PUBKEY": "Show key",
    "BTN_RELATIVE_UNIT": "Display amounts in UD?",
    "BTN_BACK": "Back",
    "BTN_NEXT": "Next",
    "BTN_IMPORT": "Import",
    "BTN_CANCEL": "Cancel",
    "BTN_CLOSE": "Close",
    "BTN_LATER": "Later",
    "BTN_LOGIN": "Sign In",
    "BTN_LOGOUT": "Logout",
    "BTN_ADD_ACCOUNT": "New Account",
    "BTN_SHARE": "Share",
    "BTN_EDIT": "Edit",
    "BTN_DELETE": "Delete",
    "BTN_ADD": "Add",
    "BTN_SEARCH": "Search",
    "BTN_REFRESH": "Refresh",
    "BTN_RETRY": "Retry",
    "BTN_START": "Start",
    "BTN_CONTINUE": "Continue",
    "BTN_CREATE": "Create",
    "BTN_UNDERSTOOD": "I understand",
    "BTN_OPTIONS": "Options",
    "BTN_HELP_TOUR": "Features tour",
    "BTN_HELP_TOUR_SCREEN": "Discover this screen",
    "BTN_DOWNLOAD": "Download",
    "BTN_DOWNLOAD_ACCOUNT_STATEMENT": "Download account statement",
    "BTN_MODIFY": "Modify",
    "CHOOSE_FILE": "Drag your file<br/>or click to select",
    "DAYS": "days",
    "NO_ACCOUNT_QUESTION": "Not a member yet? Register now!",
    "SEARCH_NO_RESULT": "No result found",
    "LOADING": "Loading...",
    "LOADING_WAIT": "Loading...<br/><small>(Cesium is querying the Duniter peer)</small>",
    "SEARCHING": "Searching...",
    "FROM": "From",
    "TO": "To",
    "COPY": "Copy",
    "LANGUAGE": "Language",
    "UNIVERSAL_DIVIDEND": "Universal dividend",
    "UD": "UD",
    "DATE_PATTERN": "MM/DD/YYYY HH:mm",
    "DATE_FILE_PATTERN": "YYYY-MM-DD",
    "DATE_SHORT_PATTERN": "MM/DD/YY",
    "DATE_MONTH_YEAR_PATTERN": "MM/YYYY",
    "EMPTY_PARENTHESIS": "(empty)",
    "UID": "Pseudonym",
    "ENABLE": "Enabled",
    "DISABLE": "Disabled",
    "RESULTS_LIST": "Results:",
    "RESULTS_COUNT": "{{count}} results",
    "EXECUTION_TIME": "executed in {{duration|formatDurationMs}}",
    "SHOW_VALUES": "Display values openly?",
    "POPOVER_ACTIONS_TITLE": "Options",
    "POPOVER_FILTER_TITLE": "Filters",
    "SHOW_MORE": "Show more",
    "SHOW_MORE_COUNT": "(current limit at {{limit}})",
    "POPOVER_SHARE": {
      "TITLE": "Share",
      "SHARE_ON_TWITTER": "Share on Twitter",
      "SHARE_ON_FACEBOOK": "Share on Facebook",
      "SHARE_ON_DIASPORA": "Share on Diaspora*",
      "SHARE_ON_GOOGLEPLUS": "Share on Google+"
    },
    "FILE": {
      "DATE" : "Date:",
      "TYPE" : "Type:",
      "SIZE": "Size:",
      "VALIDATING": "Validating..."
    }
  },
  "SYSTEM": {
    "PICTURE_CHOOSE_TYPE": "Choose source:",
    "BTN_PICTURE_GALLERY": "Gallery",
    "BTN_PICTURE_CAMERA": "<b>Camera</b>"
  },
  "MENU": {
    "HOME": "Home",
    "WOT": "Registry",
    "CURRENCY": "Currency",
    "ACCOUNT": "My Account",
    "WALLETS": "My wallets",
    "SETTINGS": "Settings",
    "NETWORK": "Network",
    "TRANSACTIONS": "My transactions"
  },
  "ABOUT": {
    "TITLE": "About",
    "LICENSE": "<b>Free/libre software</b> (License GNU AGPLv3).",
    "LATEST_RELEASE": "There is a <b>newer version</ b> of {{'COMMON.APP_NAME' | translate}} (<b>v{{version}}</b>)",
    "PLEASE_UPDATE": "Please update {{'COMMON.APP_NAME' | translate}} (latest version: <b>v{{version}}</b>)",
    "CODE": "Source code:",
    "OFFICIAL_WEB_SITE": "Official web site:",
    "DEVELOPERS": "Developers:",
    "FORUM": "Forum:",
    "PLEASE_REPORT_ISSUE": "Please report any issue to us!",
    "REPORT_ISSUE": "Report an issue",
    "BTN_OPEN_DEV_WINDOW": "Open the debug window"
  },
  "HOME": {
    "TITLE": "Cesium",
    "WELCOME": "Welcome to the Cesium application!",
    "WELCOME_READONLY": "Welcome to Cesium <span class='badge badge-balanced'>Monit</span> !",
    "MESSAGE": "Receive and send libre currency {{currency|abbreviate}}",
    "MESSAGE_READONLY": "Real-time monitoring of libre currency {{currency|abbreviate}}",
    "BTN_CURRENCY": "Explore currency {{currency|abbreviate}}",
    "BTN_ABOUT": "about",
    "BTN_HELP": "Help",
    "BTN_NETWORK": "Network status",
    "FREE_SOFTWARE": "Free software",
    "FORK_ME": "Fork me!",
    "SHOW_LICENSE": "Show license",
    "REPORT_ISSUE": "Report an issue",
    "NOT_YOUR_ACCOUNT_QUESTION" : "You do not own the account <b><i class=\"ion-key\"></i> {{pubkey|formatPubkey}}</b>?",
    "BTN_CHANGE_ACCOUNT": "Disconnect this account",
    "PEER_CONNECTION_ERROR": "Node <b>{{server}}</b> is unreachable or address is invalid.<br/><br/>Check your Internet connection, or change the node <a class=\"positive\" ng-click=\"doQuickFix('settings')\">in the settings</a>.",
    "NETWORK_CONNECTION_ERROR": "Network is unreachable.<br/><br/>Check your Internet connection, or select a node manually <a class=\"positive\" ng-click=\"doQuickFix('settings')\">in the settings</a>.",
    "SHOW_ALL_FEED": "Show all",
    "READ_MORE": "Read more",
    "FEED_SOURCE": "Source"
  },
  "SETTINGS": {
    "TITLE": "Settings",
    "DISPLAY_DIVIDER": "Display",
    "STORAGE_DIVIDER": "Storage",
    "NETWORK_SETTINGS": "Network",
    "PEER": "Duniter peer",
    "PEER_CHANGED_TEMPORARY": "Address used temporarily",
    "PEER_SELECTED_AUTOMATICALLY": "Peer selected automatically at startup",
    "NETWORK_ANALYZE_TIMEOUT": "Maximum waiting time (timeout)",
    "NETWORK_ANALYZE_TIMEOUT_HELP": "Maximum waiting time for network analysis",
    "NETWORK_ANALYZE_TIMEOUT_AUTO": "Auto",
    "PERSIST_CACHE": "Keep navigation data (experimental)",
    "PERSIST_CACHE_HELP": "Allows faster navigation, locally retaining the data received, for use from one session to another.",
    "USE_LOCAL_STORAGE": "Enable local storage",
    "USE_LOCAL_STORAGE_HELP": "Allows you to save your settings",
    "WALLETS_SETTINGS": "My wallets",
    "USE_WALLETS_ENCRYPTION": "Secure the list",
    "USE_WALLETS_ENCRYPTION_HELP": "Enables you to encrypt the list of your wallets. Authentication required to access it.",
    "ENABLE_HELPTIP": "Enable contextual help tips",
    "DISABLE_HELPTIP": "Disable contextual help tips",
    "ENABLE_UI_EFFECTS": "Enable visual effects",
    "ENABLE_UI_EFFECTS_HELP": "Transition between pages, animation of list",
    "HISTORY_SETTINGS": "Account operations",
    "DISPLAY_UD_HISTORY": "Display produced dividends?",
    "TX_HISTORY_AUTO_REFRESH": "Enable automatic refresh?",
    "TX_HISTORY_AUTO_REFRESH_HELP": "Updates the list of operations to each new block.",
    "AUTHENTICATION_SETTINGS": "Authentication",
    "KEEP_AUTH": "Expiration of authentication",
    "KEEP_AUTH_SHORT": "Expiration",
    "KEEP_AUTH_HELP": "Define when authentication is cleared from memory.",
    "KEEP_AUTH_OPTION": {
      "NEVER": "After each operation",
      "SECONDS": "After {{value}}s of inactivity",
      "MINUTE": "After {{value}}min of inactivity",
      "MINUTES": "After {{value}}min of inactivity",
      "HOUR": "After {{value}}h of inactivity",
      "ALWAYS": "At the end of the session"
    },
    "KEYRING_FILE": "Keyring file",
    "KEYRING_FILE_HELP": "Allow auto-connect at startup, or to authenticate (only if \"Expiration of authentication\" is \"at the end of the session\"",
    "REMEMBER_ME": "Remember me ?",
    "REMEMBER_ME_HELP": "Allows to remain identified from one session to another, keeping the public key locally.",
    "PLUGINS_SETTINGS": "Extensions",
    "BTN_RESET": "Restore default values",
    "EXPERT_MODE": "Enable expert mode",
    "EXPERT_MODE_HELP": "Allow to see more details",
    "BLOCK_VALIDITY_WINDOW": "Block uncertainty time",
    "BLOCK_VALIDITY_WINDOW_SHORT": "Time of uncertainty",
    "BLOCK_VALIDITY_WINDOW_HELP": "Time to wait before considering an information is validated",
    "BLOCK_VALIDITY_OPTION": {
      "NONE": "No delay",
      "N": "{{time | formatDuration}} ({{count}} blocks)"
    },
    "POPUP_PEER": {
      "TITLE" : "Duniter peer",
      "HOST" : "Address",
      "HOST_HELP": "Address: server:port",
      "USE_SSL" : "Secured?",
      "USE_SSL_HELP" : "SSL Encryption",
      "BTN_SHOW_LIST" : "Peer's list"
    }
  },
  "BLOCKCHAIN": {
    "HASH": "Hash: {{hash}}",
    "VIEW": {
      "HEADER_TITLE": "Block #{{number}}-{{hash|formatHash}}",
      "TITLE_CURRENT": "Current block",
      "TITLE": "Block #{{number|formatInteger}}",
      "COMPUTED_BY": "Computed by",
      "SHOW_RAW": "Show raw data",
      "TECHNICAL_DIVIDER": "Technical informations",
      "VERSION": "Format version",
      "HASH": "Computed hash",
      "UNIVERSAL_DIVIDEND_HELP": "Money co-produced by each of the {{membersCount}} members",
      "EMPTY": "Aucune donnée dans ce bloc",
      "POW_MIN": "Minimal difficulty",
      "POW_MIN_HELP": "Difficulty imposed in calculating hash",
      "DATA_DIVIDER": "Data",
      "IDENTITIES_COUNT": "New identities",
      "JOINERS_COUNT": "Joiners",
      "ACTIVES_COUNT": "Renewals",
      "ACTIVES_COUNT_HELP": "Members having renewed their membership",
      "LEAVERS_COUNT": "Leavers",
      "LEAVERS_COUNT_HELP": "Members that now refused certification",
      "EXCLUDED_COUNT": "Excluded members",
      "EXCLUDED_COUNT_HELP": "Old members, excluded because missing membreship renewal or certifications",
      "REVOKED_COUNT": "Revoked identities",
      "REVOKED_COUNT_HELP": "These accounts may no longer be member",
      "TX_COUNT": "Transactions",
      "CERT_COUNT": "Certifications",
      "TX_TO_HIMSELF": "Change",
      "TX_OUTPUT_UNLOCK_CONDITIONS": "Unlock conditions",
      "TX_OUTPUT_OPERATOR": {
        "AND": "and",
        "OR": "or"
      },
      "TX_OUTPUT_FUNCTION": {
        "SIG": "<b>Sign</b> of the public key",
        "XHX": "<b>Password</b>, including SHA256 =",
        "CSV": "Blocked during",
        "CLTV": "Bloqué until"
      }
    },
    "LOOKUP": {
      "TITLE": "Blocks",
      "NO_BLOCK": "No bloc",
      "LAST_BLOCKS": "Last blocks:",
      "BTN_COMPACT": "Compact"
    }
  },
  "CURRENCY": {
    "VIEW": {
      "TITLE": "Currency",
      "TAB_CURRENCY": "Currency",
      "TAB_WOT": "Web of trust",
      "TAB_NETWORK": "Network",
      "TAB_BLOCKS": "Blocks",
      "CURRENCY_SHORT_DESCRIPTION": "{{currency|capitalize}} is a <b>libre money</b>, started {{firstBlockTime | formatFromNow}}. It currently counts <b>{{N}} members </b>, who produce and collect a <a ng-click=\"showHelpModal('ud')\">Universal Dividend</a> (DU), each {{dt | formatPeriod}}.",
      "NETWORK_RULES_DIVIDER": "Network rules",
      "CURRENCY_NAME": "Currency name",
      "MEMBERS": "Members count",
      "MEMBERS_VARIATION": "Variation since {{duration|formatDuration}} (since last UD)",
      "MONEY_DIVIDER": "Money",
      "MASS": "Monetary mass",
      "SHARE": "Money share",
      "UD": "Universal Dividend",
      "C_ACTUAL": "Current growth",
      "MEDIAN_TIME": "Current blockchain time",
      "POW_MIN": "Common difficulty",
      "MONEY_RULES_DIVIDER": "Rules of currency",
      "C_RULE": "Theoretical growth target",
      "UD_RULE": "Universal dividend (formula)",
      "DT_REEVAL": "Period between two re-evaluation of the UD",
      "REEVAL_SYMBOL": "reeval",
      "DT_REEVAL_VALUE": "Every <b>{{dtReeval|formatDuration}}</b> ({{dtReeval/86400}} {{'COMMON.DAYS'|translate}})",
      "UD_REEVAL_TIME0": "Date of first reevaluation of the UD",
      "SIG_QTY_RULE": "Required number of certifications to become a member",
      "SIG_STOCK": "Maximum number of certifications sent by a member",
      "SIG_PERIOD": "Minimum delay between 2 certifications sent by one and the same issuer.",
      "SIG_WINDOW": "Maximum delay before a certification will be treated",
      "SIG_VALIDITY": "Lifetime of a certification that has been treated",
      "MS_WINDOW": "Maximum delay before a pending membership will be treated",
      "MS_VALIDITY": "Lifetime of a membership that has been treated",
      "STEP_MAX": "Maximum distance between a newcomer and each referring members.",
      "WOT_RULES_DIVIDER": "Rules for web of trust",
      "SENTRIES": "Required number of certifications (given <b>and</b> received) to become a referring member",
      "SENTRIES_FORMULA": "Required number of certifications to become a referring member (formula)",
      "XPERCENT":"Minimum percent of referring member to reach to match the distance rule",
      "AVG_GEN_TIME": "The average time between 2 blocks",
      "CURRENT": "current",
      "MATH_CEILING": "CEILING",
      "DISPLAY_ALL_RULES": "Display all rules?",
      "BTN_SHOW_LICENSE": "Show license",
      "WOT_DIVIDER": "Web of trust"
    },
    "LICENSE": {
      "TITLE": "Currency license",
      "BTN_DOWNLOAD": "Download file",
      "NO_LICENSE_FILE": "License file not found."
    }
  },
  "NETWORK": {
    "VIEW": {
      "MEDIAN_TIME": "Blockchain time",
      "LOADING_PEERS": "Loading peers...",
      "NODE_ADDRESS": "Address:",
      "SOFTWARE": "Software:",
      "WARN_PRE_RELEASE": "Pre-release (latest stable: <b>{{version}}</b>)",
      "WARN_NEW_RELEASE": "Version <b>{{version}}</b> available",
      "WS2PID": "Identifier:",
      "PRIVATE_ACCESS": "Private access",
      "POW_PREFIX": "Proof of work prefix:",
      "ENDPOINTS": {
        "BMAS": "Secure endpoint (SSL)",
        "BMATOR": "TOR endpoint",
        "WS2P": "WS2P endpoint",
        "ES_USER_API": "Cesium+ data node"
      }
    },
    "INFO": {
      "CONNECTING_TO_NETWORK": "Connecting to the network...",
      "ANALYZING_NETWORK": "Analyzing the {{currency|abbreviate}} network...",
      "ONLY_SSL_PEERS": "Non-SSL nodes have a degraded display because Cesium works in HTTPS mode."
    }
  },
  "PEER": {
    "PEERS": "Peers",
    "SIGNED_ON_BLOCK": "Signed on block",
    "MIRROR": "mirror",
    "MIRRORS": "Mirrors",
    "MIRROR_PEERS": "Mirror peers",
    "PEER_LIST" : "Peer's list",
    "MEMBERS" : "Members",
    "MEMBER_PEERS" : "Member peers",
    "ALL_PEERS" : "All peers",
    "DIFFICULTY" : "Difficulty",
    "API" : "API",
    "CURRENT_BLOCK" : "Block #",
    "POPOVER_FILTER_TITLE": "Filter",
    "OFFLINE": "Offline",
    "OFFLINE_PEERS": "Offline peers",
    "BTN_SHOW_PEER": "Show peer",
    "VIEW": {
      "TITLE": "Peer",
      "OWNER": "Owned by ",
      "SHOW_RAW_PEERING": "See peering document",
      "SHOW_RAW_CURRENT_BLOCK": "See current block (raw format)",
      "LAST_BLOCKS": "Last blocks",
      "KNOWN_PEERS": "Known peers :",
      "GENERAL_DIVIDER": "General information",
      "ERROR": {
        "LOADING_TOR_NODE_ERROR": "Could not get peer data, using the TOR network.",
        "LOADING_NODE_ERROR": "Could not get peer data"
      }
    }
  },
  "WOT": {
    "SEARCH_HELP": "Search (member or public key)",
    "SEARCH_INIT_PHASE_WARNING": "During the pre-registration phase, the search for pending registrations <b>may be long</b>. Please wait ...",
    "REGISTERED_SINCE": "Registered on",
    "REGISTERED_SINCE_BLOCK": "Registered since block #",
    "NO_CERTIFICATION": "No validated certification",
    "NO_GIVEN_CERTIFICATION": "No given certification",
    "NOT_MEMBER_PARENTHESIS": "(non-member)",
    "IDENTITY_REVOKED_PARENTHESIS": "(identity revoked)",
    "MEMBER_PENDING_REVOCATION_PARENTHESIS": "(being revoked)",
    "EXPIRE_IN": "Expires",
    "NOT_WRITTEN_EXPIRE_IN": "Deadline<br/>treatment",
    "EXPIRED": "Expired",
    "PSEUDO": "Pseudonym",
    "SIGNED_ON_BLOCK": "Emitted on block #{{block}}",
    "WRITTEN_ON_BLOCK": "Written on block #{{block}}",
    "GENERAL_DIVIDER": "General information",
    "NOT_MEMBER_ACCOUNT": "Non-member account",
    "NOT_MEMBER_ACCOUNT_HELP": "This is a simple wallet, with no pending membership application.",
    "TECHNICAL_DIVIDER": "Technical data",
    "BTN_CERTIFY": "Certify",
    "BTN_YES_CERTIFY": "Yes, certify",
    "BTN_SELECT_AND_CERTIFY": "New certification",
    "ACCOUNT_OPERATIONS": "Account operations",
    "VIEW": {
      "POPOVER_SHARE_TITLE": "Identity {{title}}"
    },
    "LOOKUP": {
      "TITLE": "Registry",
      "NEWCOMERS": "New members:",
      "NEWCOMERS_COUNT": "{{count}} members",
      "PENDING": "Pending registrations:",
      "PENDING_COUNT": "{{count}} pending registrations",
      "REGISTERED": "Registered {{sigDate | formatFromNow}}",
      "MEMBER_FROM": "Member since {{memberDate|medianFromNowShort}}",
      "BTN_NEWCOMERS": "Latest members",
      "BTN_PENDING": "Pending registrations",
      "SHOW_MORE": "Show more",
      "SHOW_MORE_COUNT": "(current limit to {{limit}})",
      "NO_PENDING": "No pending registrations.",
      "NO_NEWCOMERS": "No members."
    },
    "CONTACTS": {
      "TITLE": "Contacts"
    },
    "MODAL": {
      "TITLE": "Search"
    },
    "CERTIFICATIONS": {
      "TITLE": "{{uid}} - Certifications",
      "SUMMARY": "Received certifications",
      "LIST": "Details of received certifications",
      "PENDING_LIST": "Pending certifications",
      "RECEIVED": "Received certifications",
      "RECEIVED_BY": "Certifications received by {{uid}}",
      "ERROR": "Received certifications in error",
      "SENTRY_MEMBER": "Referring member"
    },
    "OPERATIONS": {
      "TITLE": "{{uid}} - Operations"
    },
    "GIVEN_CERTIFICATIONS": {
      "TITLE": "{{uid}} - Certifications sent",
      "SUMMARY": "Sent certifications",
      "LIST": "Details of sent certifications",
      "PENDING_LIST": "Pending certifications",
      "SENT": "Sent certifications",
      "SENT_BY": "Certifications sent by {{uid}}",
      "ERROR": "Sent certifications with error"
    }
  },
  "LOGIN": {
    "TITLE": "<i class=\"icon ion-log-in\"></i> Login",
    "SCRYPT_FORM_HELP": "Please enter your credentials. <br> Remember to check the public key for your account.",
    "PUBKEY_FORM_HELP": "Please enter a public account key:",
    "FILE_FORM_HELP": "Choose the keychain file to use:",
    "SCAN_FORM_HELP": "Scan the QR code of a wallet.",
    "SALT": "Secret identifier",
    "SALT_HELP": "Secret identifier",
    "SHOW_SALT": "Display secret identifier?",
    "PASSWORD": "Password",
    "PASSWORD_HELP": "Password",
    "PUBKEY_HELP": "Public key or pseudonym",
    "NO_ACCOUNT_QUESTION": "Don't have an account yet?",
    "HAVE_ACCOUNT_QUESTION": "Already have an account ?",
    "CREATE_ACCOUNT": "Create an account",
    "CREATE_FREE_ACCOUNT": "Create a free account",
    "FORGOTTEN_ID": "Forgot password?",
    "ASSOCIATED_PUBKEY": "Public key :",
    "BTN_METHODS": "Other methods",
    "BTN_METHODS_DOTS": "Change method...",
    "METHOD_POPOVER_TITLE": "Methods",
    "MEMORIZE_AUTH_FILE": "Memorize this keychain during the navigation session",
    "SCRYPT_PARAMETERS": "Paramètres (Scrypt) :",
    "AUTO_LOGOUT": {
      "TITLE": "Information",
      "MESSAGE": "<i class=\"ion-android-time\"></i> You were <b>logout</ b> automatically, due to prolonged inactivity.",
      "BTN_RELOGIN": "Sign In",
      "IDLE_WARNING": "You will be logout... {{countdown}}"
    },
    "METHOD": {
      "SCRYPT_DEFAULT": "Secret identifier and password",
      "SCRYPT_ADVANCED": "Advanced salt",
      "FILE": "Keychain file",
      "PUBKEY": "Public key or pseudonym",
      "SCAN": "Scan a QR code"
    },
    "SCRYPT": {
      "SIMPLE": "Light salt",
      "DEFAULT": "Standard salt",
      "SECURE": "Secure salt",
      "HARDEST": "Hardest salt",
      "EXTREME": "Extreme salt",
      "USER": "Personal value",
      "N": "N (Loop):",
      "r": "r (RAM):",
      "p": "p (CPU):"
    },
    "FILE": {
      "HELP": "Expected file format: <b>.dunikey</b> (type PubSec). Other formats are under development (EWIF, WIF)."
    }
  },
  "AUTH": {
    "TITLE": "<i class=\"icon ion-locked\"></i> Authentication",
    "BTN_AUTH": "Authenticate",
    "GENERAL_HELP": "Please authenticate yourself:",
    "EXPECTED_UID_HELP": "Please authenticate to the account <i class=\"ion-person\"></i> {{uid}}:",
    "EXPECTED_PUBKEY_HELP": "Please authenticate to the wallet <i class=\"ion-key\"></i> {{pubkey|formatPubkey}}:",
    "SCAN_FORM_HELP": "Scan the QR code of the <b>private key</b> of the wallet."
  },
  "ACCOUNT": {
    "TITLE": "My Account",
    "BALANCE": "Balance",
    "LAST_TX": "Latest validated transactions",
    "BALANCE_ACCOUNT": "Account balance",
    "NO_TX": "No transaction",
    "SHOW_MORE_TX": "Show more",
    "SHOW_ALL_TX": "Show all",
    "TX_FROM_DATE": "(current limit to {{fromTime|medianFromNowShort}})",
    "PENDING_TX": "Pending transactions",
    "VALIDATING_TX": "Transactions being validated",
    "ERROR_TX": "Transaction not executed",
    "ERROR_TX_SENT": "Sent transactions",
    "PENDING_TX_RECEIVED": "Transactions awaiting receipt",
    "EVENTS": "Events",
    "OUT_DISTANCED": "Your current certifications come from a group too isolated from the <a ng-click=\"showHelpModal('wot')\"> Web of Trust</a> (WoT): the <a ng-click=\"showHelpModal('distance_rule')\">maximum distance rule</a> is violated.<br/>You must obtain certifications from another area of the Web of Trust, or wait for it to tighten.",
    "WAITING_MEMBERSHIP": "Membership application sent. Waiting validation.",
    "WAITING_CERTIFICATIONS": "You need {{needCertificationCount}} certification(s) to become a member and produce the <a ng-click=\"showHelpModal('ud')\">Universal Dividend</a>. Your account is however already operational, to receive and send payments.",
    "WAITING_CERTIFICATIONS_HELP": "To get your certifications, only request members <b>who know you enough</b>, as required by <a ng-click=\"showLicenseModal()\">the currency license</a> that you have accepted.<br/>If you do not know enough members, let them know on <a ng-click=\"openLink($event, $root.settings.userForumUrl)\">the user forum</a>.",
    "WILL_MISSING_CERTIFICATIONS": "You will <b>lack certifications</b> soon (at least {{willNeedCertificationCount}} more are needed)",
    "WILL_NEED_RENEW_MEMBERSHIP": "Your membership <b>will expire {{membershipExpiresIn|formatDurationTo}}</b>. Remember to <a ng-click=\"doQuickFix('renew')\">renew your membership</a> before then.",
    "NEED_RENEW_MEMBERSHIP": "You are no longer a member because your membership <b>has expired</b>. Remember to <a ng-click=\"doQuickFix('renew')\">renew your membership</a>.",
    "NEED_RENEW_MEMBERSHIP_AFTER_CANCELLED": "You are no longer a member because your membership <b>has been canceled</b> for lack of certifications. Remember to <a ng-click=\"doQuickFix('renew')\">renew your membership</a>.",
    "NO_WAITING_MEMBERSHIP": "No membership application pending. If you'd like to <b>become a member</ b>, please <a ng-click=\"doQuickFix('membership')\">send the membership application</a>.",
    "CERTIFICATION_COUNT": "Received certifications",
    "CERTIFICATION_COUNT_SHORT": "Certifications",
    "SIG_STOCK": "Stock of certifications to give",
    "BTN_RECEIVE_MONEY": "Receive",
    "BTN_SELECT_ALTERNATIVES_IDENTITIES": "Switch to another identity...",
    "BTN_FIX_MEMBERSHIP": "Resubmit membership request...",
    "BTN_MEMBERSHIP_RENEW": "Renew membership",
    "BTN_MEMBERSHIP_RENEW_DOTS": "Renew membership...",
    "BTN_MEMBERSHIP_OUT_DOTS": "Revoke membership...",
    "BTN_SECURITY_DOTS": "Sign-in and security...",
    "BTN_SHOW_DETAILS": "Display technical data",
    "LOCKED_OUTPUTS_POPOVER": {
      "TITLE": "Locked amount",
      "DESCRIPTION": "Here are the conditions for unlocking this amount:",
      "DESCRIPTION_MANY": "This transaction consists of several parts, of which the unlock conditions are:",
      "LOCKED_AMOUNT": "Conditions for the amount:"
    },
    "NEW": {
      "TITLE": "Registration",
      "INTRO_WARNING_TIME": "Creating an account on {{name|capitalize}} is very simple. Please take sufficient time to do this correctly (not to forget the usernames, passwords, etc.).",
      "INTRO_WARNING_SECURITY": "Check that the hardware you are currently using (computer, tablet, phone) <b>is secure and trustworthy </b>.",
      "INTRO_WARNING_SECURITY_HELP": "Up-to-date anti-virus, firewall enabled, session protected by password or pin code...",
      "INTRO_HELP": "Click <b> {{'COMMON.BTN_START'|translate}}</b> to begin creating an account. You will be guided step by step.",
      "REGISTRATION_NODE": "Your registration will be registered via the Duniter peer <b>{{server}}</b> node, which will then be distributed to the rest of the currency network.",
      "REGISTRATION_NODE_HELP": "If you do not trust this peer, please change <a ng-click=\"doQuickFix('settings')\">in the settings</a> of Cesium.",
      "SELECT_ACCOUNT_TYPE": "Choose the type of account to create:",
      "MEMBER_ACCOUNT": "Member account",
      "MEMBER_ACCOUNT_TITLE": "Create a member account",
      "MEMBER_ACCOUNT_HELP": "You know enough about libre money and want to participate in its production?<br/>As an individual, you can create your member account (only one per individual). This works like a simple wallet account, but also allows you to co-produce the money, by <b>receiving for each {{parameters.dt|formatPeriod}} a universal dividend</b>: it's then up to you to put to good use!",
      "WALLET_ACCOUNT": "Simple wallet",
      "WALLET_ACCOUNT_TITLE": "Create a wallet",
      "WALLET_ACCOUNT_HELP": "Are you <b>new to libre money</b>? You need an additional account?<br/>This type of account will suit you. Although it does not co-produce the money (unlike a member account - see below), you will be able to receive and send payments there, as soon as registration is complete.<br/>If necessary, you can convert it into a member account later.",
      "SALT_WARNING": "Choose a secret identifier.<br/>You need it for each connection to this account.<br/><br/><b>Make sure to remember this identifier</b>.<br/>If lost, there are no means to retrieve it!",
      "PASSWORD_WARNING": "Choose a password.<br/>You need it for each connection to this account.<br/><br/><b>Make sure to remember this password</b>.<br/>If lost, there are no means to retrieve it!",
      "PSEUDO_WARNING": "Choose a pseudonym.<br/>It may be used by other people to find you more easily.<br/><br/>.Use of <b>commas, spaces and accents</b> is not allowed.<br/><div class='hidden-xs'><br/>Example: <span class='gray'>JohnDalton, JackieChan, etc.</span>",
      "PSEUDO": "Pseudonym",
      "PSEUDO_HELP": "joe123",
      "SALT_CONFIRM": "Confirm",
      "SALT_CONFIRM_HELP": "Confirm the secret identifier",
      "PASSWORD_CONFIRM": "Confirm",
      "PASSWORD_CONFIRM_HELP": "Confirm the password",
      "SLIDE_6_TITLE": "Confirmation:",
      "COMPUTING_PUBKEY": "Computing...",
      "LAST_SLIDE_CONGRATULATION": "You completed all required fields.<br/><b>You can send the account creation request</b>.<br/><br/>For information, the public key below identifies your future account.<br/>It can be communicated to third parties to receive their payment.<br/>Once your account has been approved, you can find this key under <b>{{'ACCOUNT.TITLE'|translate}}</b>.",
      "CONFIRMATION_MEMBER_ACCOUNT": "<b class=\"assertive\">Warning:</b> your secret identifier, password and pseudonym can not be changed.<br/><b>Make sure you always remember it!</b><br/><b>Are you sure</b> you want to send this account creation request?",
      "CONFIRMATION_WALLET_ACCOUNT": "<b class=\"assertive\">Warning:</b> your password and pseudonym can not be changed.<br/><b>Make sure you always remember it!</b><br/><b>Are you sure</b> you want to continue?",
      "CHECKING_PSEUDO": "Checking...",
      "PSEUDO_AVAILABLE": "This pseudonym is available",
      "PSEUDO_NOT_AVAILABLE": "This pseudonym is not available",
      "INFO_LICENSE": "To be able to adhere to the currency, we ask you to kindly read and accept this license.",
      "BTN_ACCEPT": "I accept",
      "BTN_ACCEPT_LICENSE": "I accept the license"
    },
    "POPUP_REGISTER": {
      "TITLE": "Enter a pseudonym",
      "HELP": "A pseudonym is needed to let other members find you."
    },
    "SELECT_IDENTITY_MODAL": {
      "TITLE": "Identity selection",
      "HELP": "Several <b>different identities</b> have been sent, for the public key <span class=\"gray\"> <i class=\"ion-key\"></i> {{pubkey | formatPubkey}}</span>.<br/>Please select the identity to use:"
    },
    "SELECT_WALLET_MODAL": {
      "TITLE": "Wallet selection"
    },
    "CERTIFICATION_MODAL": {
      "CHECKLIST_TITLE": "Certification check list",
      "INFOS": "Each member is responsible for the security of Ğ1 currency. Before certifying this person's identity, you should have performed few checks. Please answer following questions:",
      "BTN_ALL_CHECK": "Certify",
      "CHECKLIST_CONDITIONS_NOT_MET": "The certification has not been sent. All answers are not right. Please recheck each point with the person to be certified.",
      "QUESTIONS": {
        "WELL_KNOWN": "Do you know <b>well</b> the person you are about to certify? Do you know other people who also know this person well?",
        "REVOCATION": "Has this person downloaded their <b>revocation document</b> and do they know where to find it?",
        "CONTACT": "Have you <b>had contact</b> with this person by many means, and did they answer?",
        "DOUBLE_IDENTITY": "The person should own <b>only one active member identity</b>. Do you think they own another one?",
        "MASTER_ACCOUNT": "Does this person own their accounts secrets? Have they already <b>sent money from their account</b> at least once?",
        "LICENSE": "Has this person <b>understood the Duniter license</b>? Do they agree to comply with it for future certifications?",
        "CREDENTIALS": "Was the account created with <b>long and complex secret identifier and password</b> (ex. passphrases)? Did the person understand that both secret identifier and password must remain secret ? Are they <b>sure to remember them</b> or to be able to find them?",
        "PUBLIC_KEY_DIFFERENT": "The <b>public key</b> that is shown must be <b>identical</b> to the one the person gave you. The public keys are they <b>different</b> ?"
      },
      "REMINDER_TITLE": "Reminder",
      "SHORT_LICENSE_REMINDER": "You may remind the person to certify different certification parameters:<br/><br/><ul><li> - Each member can certify 100 other identities at most.</li><li> - The certifications are saved with a 5 days interval.</li><li> - A new identity must gather at least 5 certifications in less than 2 months.</li><li> - A member must renew its membership at least once a year.</li><li> - Certifications have a lifespan of two years.</li></ul>"
    },
    "WALLET_LIST": {
      "TITLE": "My wallets",
      "BTN_NEW": "Add a wallet",
      "BTN_DOWNLOAD": "Download the list",
      "BTN_IMPORT_FILE_DOTS": "Import from a file...",
      "NO_WALLET": "No secondary wallet",
      "BTN_DELETE": "Remove a secondary wallet...",
      "BTN_RENAME": "Rename the wallet",
      "EXPORT_FILENAME": "my_wallets-{{pubkey|formatPubkey}}-{{currency}}.csv",
      "TOTAL_DOTS": "Total: ",
      "EDIT_POPOVER": {
        "TITLE": "Rename the wallet",
        "HELP": "Fill in the new name",
        "NAME_HELP": "Wallet name"
      },
      "IMPORT_MODAL": {
        "TITLE": "Import secondary wallets",
        "HELP": "To <b>import secodnary wallets</b>, please drag the file in the box below, or click in the box to search for a file.",
        "WALLET_COUNT": "<b>{{count}}</b> new wallet{{count > 1 ? 's' : ''}}",
        "NO_NEW_WALLET": "No new wallet"
      }
    },
    "SECURITY":{
      "ADD_QUESTION" : "Add custom question",
      "BTN_CLEAN" : "Clean",
      "BTN_RESET" : "Reset",
      "DOWNLOAD_REVOKE": "Save a revocation file",
      "DOWNLOAD_REVOKE_HELP" : "Having a revocation file is important, for example in case of loss of identifiers. It allows you to <b>get this account out of the Web Of Trust</b>, thus becoming a simple wallet.",
      "GENERATE_KEYFILE": "Generate my keychain file ...",
      "GENERATE_KEYFILE_HELP": "Generate a file allowing you to authenticate without entering your identifiers.<br/><b>Warning:</b> this file will contain your secret key; It is therefore very important to put it in a safe place!",
      "KEYFILE_FILENAME": "keychain-{{pubkey|formatPubkey}}-{{currency}}-{{format}}.dunikey",
      "MEMBERSHIP_IN": "Register as member...",
      "MEMBERSHIP_IN_HELP": "Allows you to <b>transform </b> a simple wallet account <b>into a member account</b>, by sending a membership request. Useful only if you do not already have another member account.",
      "SEND_IDENTITY": "Publish identity...",
      "SEND_IDENTITY_HELP": "Allows you to associate a pseudonym to this account, but <b>without applying for membership</b> to become a member. This is not very useful because the validity of this pseudonym association is limited in time.",
      "HELP_LEVEL": "Choose <strong> at least {{nb}} questions </strong> :",
      "LEVEL": "Security level",
      "LOW_LEVEL": "Low <span class=\"hidden-xs\">(2 questions minimum)</span>",
      "MEDIUM_LEVEL": "Medium <span class=\"hidden-xs\">(4 questions minimum)</span>",
      "QUESTION_1": "What was your best friend's name when you were a teen ?",
      "QUESTION_2": "What was the name of your first pet ?",
      "QUESTION_3": "What is the first meal you have learned to cook ?",
      "QUESTION_4": "What is the first movie you saw in the cinema?",
      "QUESTION_5": "Where did you go the first time you flew ?",
      "QUESTION_6": "What was your favorite elementary school teacher's name  ?",
      "QUESTION_7": "What would you consider the ideal job ?",
      "QUESTION_8": "Which children's book do you prefer?",
      "QUESTION_9": "What was the model of your first vehicle?",
      "QUESTION_10": "What was your nickname when you were a child ?",
      "QUESTION_11": "What was your favorite movie character or actor when you were a student ?",
      "QUESTION_12": "What was your favorite singer or band when you were a student ?",
      "QUESTION_13": "In which city did your parents meet ?",
      "QUESTION_14": "What was the name of your first boss ?",
      "QUESTION_15": "What is the name of the street where you grew up ?",
      "QUESTION_16": "What is the name of the first beach where you go swim ?",
      "QUESTION_17": "QWhat is the first album you bought ?",
      "QUESTION_18": "What is the name of your favorite sport team ?",
      "QUESTION_19": "What was your grand-father's job ?",
      "RECOVER_ID": "Recover my password...",
      "RECOVER_ID_HELP": "If you have a <b>backup file of your identifiers</b>, you can find them by answering your personal questions correctly.",
      "RECOVER_ID_SELECT_FILE": "Select the <b>backup file of your identifiers</b> to use:",
      "REVOCATION_WITH_FILE" : "Revoke my member account...",
      "REVOCATION_WITH_FILE_DESCRIPTION": "If you have <b>permanently lost your member account credentials (or if account security is compromised), you can use <b>the revocation file</b> of the account <b>to quit the Web Of Trust</b>.",
      "REVOCATION_WITH_FILE_HELP": "To <b>permanently revoke</ b> a member account, please drag the revocation file in the box below, or click in the box to search for a file.",
      "REVOCATION_WALLET": "Revoke this account immediately",
      "REVOCATION_WALLET_HELP": "Requesting revocation of your identity causes <b>will revoke your membership</ b> (definitely for the associated pseudonym and public key). The account will no longer be able to produce a Universal Dividend.<br/>However, you can still use it as a simple wallet.",
      "REVOCATION_FILENAME": "revocation-{{uid}}-{{pubkey|formatPubkey}}-{{currency}}.txt",
      "SAVE_ID": "Save my credentials...",
      "SAVE_ID_HELP": "Creating a backup file, to <b>retrieve your password</b> (and the secret identifier) <b> in case of forgetting</b>. The file is <b>secured</ b> (encrypted) using personal questions.",
      "STRONG_LEVEL": "Strong <span class=\"hidden-xs \">(6 questions minimum)</span>",
      "TITLE": "Account and security",
      "KEYFILE": {
        "PUBSEC_FORMAT": "PubSec format.",
        "PUBSEC_FORMAT_HELP": "This file format is compatible in particular with Cesium and Gannonce. Your keychain is stored <b>without encryption</b>: anyone with a copy of this file will be able to empty your account.",
        "WIF_FORMAT": "Wallet Import Format (WIF)",
        "WIF_FORMAT_HELP": "This format is used in particular by paper wallets. Your keychain is stored <b>without encryption</b>: anyone with a copy of this file will be able to empty your account.",
        "EWIF_FORMAT": "Encrypted Wallet Import Format (WIF)",
        "EWIF_FORMAT_HELP": "This format is used in particular by paper wallets. However, <b>the keychain is encrypted</b> from a passphrase of your choice.",
        "PASSWORD_POPUP": {
          "TITLE": "Keychain file encrypted",
          "HELP": "Please enter the passphrase:",
          "PASSWORD_HELP": "Passphrase"
        },
        "ERROR": {
          "BAD_PASSWORD": "Bad passphrase",
          "BAD_CHECKSUM": "Bad checksum"
        }
      }
    },
    "FILE_NAME": "{{currency}} - Account statement {{pubkey|formatPubkey}} to {{currentTime|formatDateForFile}}.csv",
    "HEADERS": {
      "TIME": "Date",
      "AMOUNT": "Amount",
      "COMMENT": "Comment"
    }
  },
  "TRANSFER": {
    "TITLE": "Transfer",
    "SUB_TITLE": "Transfer money",
    "SUB_TITLE_ALL": "Empty the account",
    "FROM": "From",
    "TO": "To",
    "AMOUNT": "Amount",
    "AMOUNT_HELP": "Amount",
    "COMMENT": "Comment",
    "COMMENT_HELP": "Comment (optional)",
    "BTN_SEND": "Send",
    "BTN_ADD_COMMENT": "Add a comment",
    "REST": "Rest of account",
    "REST_TO": "to",
    "WARN_COMMENT_IS_PUBLIC": "Please note that <b>comments are public</b> (not encrypted).",
    "MODAL": {
      "TITLE": "Transfer"
    }
  },
  "ERROR": {
    "UNKNOWN_URI_FORMAT": "Unknown URI format",
    "PUBKEY_INVALID_CHECKSUM": "Invalid public key (bad checksum).",
    "POPUP_TITLE": "Error",
    "UNKNOWN_ERROR": "Unknown error",
    "TIMEOUT_REACHED": "Peer timeout exceeded ({{timeout|formatDurationMs}}).<br/><br/><small>{{url}}</small>",
    "CRYPTO_UNKNOWN_ERROR": "Your browser is not compatible with cryptographic features.",
    "DOWNLOAD_KEYFILE_FAILED": "Failed to generate the keychain file.",
    "EQUALS_TO_PSEUDO": "Must be different from pseudonym",
    "EQUALS_TO_SALT": "Must be different from secret identifier",
    "FIELD_REQUIRED": "This field is required.",
    "FIELD_TOO_SHORT": "This field value is too short.",
    "FIELD_TOO_SHORT_WITH_LENGTH": "Value is too short (min {{minLength]] characters).",
    "FIELD_TOO_LONG": "Value is exceeding max length.",
    "FIELD_TOO_LONG_WITH_LENGTH": "Value is too long (max {{maxLength}} characters).",
    "FIELD_MIN": "Minimum value: {{min}}",
    "FIELD_MAX": "Maximal value: {{max}}",
    "FIELD_ACCENT": "Commas and accent characters not allowed",
    "FIELD_NOT_NUMBER": "Value is not a number",
    "FIELD_NOT_INT": "Value is not an integer",
    "FIELD_NOT_EMAIL": "Email adress not valid",
    "PASSWORD_NOT_CONFIRMED": "Must match previous password.",
    "SALT_NOT_CONFIRMED": "Must match previous identifier.",
    "SEND_IDENTITY_FAILED": "Error while trying to register.",
    "SEND_CERTIFICATION_FAILED": "Could not certify identity.",
    "NEED_MEMBER_ACCOUNT_TO_CERTIFY": "You could not send certification, because your account is <b>not a member account</b>.",
    "NEED_MEMBER_ACCOUNT_TO_CERTIFY_HAS_SELF": "You could not send certification now, because your are <b>not a member</b> yet.<br/><br/>You still need certification to become a member.",
    "IDENTITY_TO_CERTIFY_HAS_NO_SELF": "This account could not be certified. No registration found, or need to renew.",
    "LOGIN_FAILED": "Error while sign in.",
    "LOAD_IDENTITY_FAILED": "Could not load identity.",
    "LOAD_REQUIREMENTS_FAILED": "Could not load identity requirements.",
    "SEND_MEMBERSHIP_IN_FAILED": "Error while sending registration as member.",
    "SEND_MEMBERSHIP_OUT_FAILED": "Error while sending membership revocation.",
    "REFRESH_WALLET_DATA": "Could not refresh wallet.",
    "GET_CURRENCY_PARAMETER": "Could not get currency parameters.",
    "GET_CURRENCY_FAILED": "Could not load currency. Please retry later.",
    "SEND_TX_FAILED": "Could not send transaction.",
    "ALL_SOURCES_USED": "Please wait the next block computation (All transaction sources has been used).",
    "NOT_ENOUGH_SOURCES": "Not enough changes to send this amount in one time.<br/>Maximum amount: {{amount}} {{unit}}<sub>{{subUnit}}</sub>.",
    "ACCOUNT_CREATION_FAILED": "Error while creating your member account.",
    "RESTORE_WALLET_DATA_ERROR": "Error while reloading settings from local storage",
    "LOAD_WALLET_DATA_ERROR": "Error while loading wallet data.",
    "COPY_CLIPBOARD_FAILED": "Could not copy to clipboard",
    "TAKE_PICTURE_FAILED": "Could not get picture.",
    "SCAN_FAILED": "Could not scan QR code.",
    "SCAN_UNKNOWN_FORMAT": "Code not recognized.",
    "WOT_LOOKUP_FAILED": "Search failed.",
    "LOAD_PEER_DATA_FAILED": "Duniter peer not accessible. Please retry later.",
    "NEED_LOGIN_FIRST": "Please sign in first.",
    "AMOUNT_REQUIRED": "Amount is required.",
    "AMOUNT_NEGATIVE": "Negative amount not allowed.",
    "NOT_ENOUGH_CREDIT": "Not enough credit.",
    "INVALID_NODE_SUMMARY": "Unreachable peer or invalid address",
    "INVALID_USER_ID": "Field 'pseudonym' must not contains spaces or special characters.",
    "INVALID_COMMENT": "Field 'reference' has a bad format.",
    "INVALID_PUBKEY": "Public key has a bad format.",
    "INVALID_PUBKEY_CHECKSUM": "Invalid checksum.",
    "IDENTITY_REVOKED": "This identity <b>has been revoked</b>. It can no longer become a member.",
    "IDENTITY_REVOKED_WITH_TIME": "This identity <b>has been revoked {{revocationTime|medianFromNow}}</b> ({{revocationTime|medianDate}}). It can no longer become a member.",
    "IDENTITY_PENDING_REVOCATION": "The <b>revocation of this identity</b> has been requested and is awaiting processing. Certification is therefore disabled.",
    "IDENTITY_INVALID_BLOCK_HASH": "This membership application is no longer valid (because it references a block that network peers are cancelled): the person must renew its application for membership <b>before</b> being certified.",
    "IDENTITY_EXPIRED": "This identity has expired: this person must re-apply <b>before</b> being certified.",
    "IDENTITY_SANDBOX_FULL": "Could not register, because peer's sandbox is full.<br/><br/>Please retry later or choose another Duniter peer (in <b>Settings</b>).",
    "IDENTITY_NOT_FOUND": "Identity not found",
    "IDENTITY_TX_FAILED": "Error while getting identity's transactions",
    "WOT_PENDING_INVALID_BLOCK_HASH": "Membership not valid.",
    "WALLET_INVALID_BLOCK_HASH": "Your membership application is no longer valid (because it references a block that network peers are cancelled).<br/>You must <a ng-click=\"doQuickFix('renew')\">renew your application for membership</a> to fix this issue.",
    "WALLET_IDENTITY_EXPIRED": "The publication of your identity <b>has expired</b>.<br/>You must <a ng-click=\"doQuickFix('fixIdentity')\">re-issue your identity</a> to resolve this issue.",
    "WALLET_REVOKED": "Your identity has been <b>revoked</b>: neither your pseudonym nor your public key will be used in the future for a member account.",
    "WALLET_HAS_NO_SELF": "Your identity must first have been published, and not expired.",
    "AUTH_REQUIRED": "Authentication required.",
    "AUTH_INVALID_PUBKEY": "The public key does not match the connected account.",
    "AUTH_INVALID_SCRYPT": "Invalid username or password.",
    "AUTH_INVALID_FILE": "Invalid keychain file.",
    "AUTH_FILE_ERROR": "Failed to open keychain file",
    "IDENTITY_ALREADY_CERTIFY": "You have <b>already certified</b> that identity.<br/><br/>Your certificate is still valid (expires {{expiresIn|formatDuration}}).",
    "IDENTITY_ALREADY_CERTIFY_PENDING": "You have <b>already certified</b> that identity.<br/><br/>Your certification is still pending (Deadline for treatment {{expiresIn|formatDuration}}).",
    "UNABLE_TO_CERTIFY_TITLE": "Unable to certify",
    "LOAD_NEWCOMERS_FAILED": "Unable to load new members.",
    "LOAD_PENDING_FAILED": "Unable to load pending registrations.",
    "ONLY_MEMBER_CAN_EXECUTE_THIS_ACTION": "You must <b>be a member</b> in order to perform this action.",
    "ONLY_MEMBER_OR_WAS_MEMBER_CAN_EXECUTE_THIS_ACTION": "You must <b>be a member (or old member)</b> in order to perform this action.",
    "ONLY_SELF_CAN_EXECUTE_THIS_ACTION": "You must have <b>published your identity</b> in order to perform this action.",
    "GET_BLOCK_FAILED": "Error while getting block",
    "INVALID_BLOCK_HASH": "Block not found (incorrect hash)",
    "DOWNLOAD_REVOCATION_FAILED": "Error while downloading revocation file.",
    "REVOCATION_FAILED": "Error while trying to revoke the identity.",
    "SALT_OR_PASSWORD_NOT_CONFIRMED": "Wrong secret identifier or password ",
    "RECOVER_ID_FAILED": "Could not recover password",
    "LOAD_FILE_FAILED" : "Unable to load file",
    "NOT_VALID_REVOCATION_FILE": "Invalid revocation file (wrong file format)",
    "NOT_VALID_SAVE_ID_FILE": "Invalid credentials backup file (wrong file format)",
    "NOT_VALID_KEY_FILE": "Invalid keychain file (unrecognized format)",
    "EXISTING_ACCOUNT": "Your identifiers correspond to an already existing account, whose <a ng-click=\"showHelpModal('pubkey')\">public key</a> is:",
    "EXISTING_ACCOUNT_REQUEST": "Please modify your credentials so that they correspond to an unused account.",
    "GET_LICENSE_FILE_FAILED": "Unable to get license file",
    "CHECK_NETWORK_CONNECTION": "No peer appears to be accessible.<br/><br/>Please <b>check your Internet connection</b>.",
    "ISSUE_524_TX_FAILED": "Failed to transfer.<br/><br/>A message has been sent to developers to help solve the problem.<b>Thank you for your help</b>.",
    "ADD_SECONDARY_WALLET_FAILED": "Unable to add secondary wallet.",
    "REMOVE_SECONDARY_WALLET_FAILED": "Unable to remove secondary wallet.",
    "UPDATE_WALLET_LIST_FAILED": "Unable to refresh the list of wallets.",
    "LOAD_WALLET_LIST_FAILED": "Unable to load the list of wallets.",
    "SAVE_WALLET_LIST_FAILED": "Unable to save the list of wallets.",
    "COULD_NOT_ADD_MAIN_WALLET": "This wallet <b>is the main account</b> with which you are connected. Unable to add it as a secondary wallet.",
    "COULD_NOT_ADD_EXISTING_WALLET": "Wallet already existing in the list.",
    "UNKNOWN_WALLET_ID": "Unknown secondary wallet.",
    "RESTORE_WALLET_LIST_FAILED": "Unable to restore the list of wallets.",
    "INVALID_FILE_FORMAT": "Invalid file format.",
    "SAME_TX_RECIPIENT": "The recipient must be different from the issuer."
  },
  "INFO": {
    "POPUP_TITLE": "Information",
    "CERTIFICATION_DONE": "Identity successfully signed",
    "NOT_ENOUGH_CREDIT": "Not enough credit",
    "TRANSFER_SENT": "Transfer request successfully sent",
    "COPY_TO_CLIPBOARD_DONE": "Copy succeeded",
    "MEMBERSHIP_OUT_SENT": "Membership revocation sent",
    "NOT_NEED_MEMBERSHIP": "Already a member.",
    "IDENTITY_WILL_MISSING_CERTIFICATIONS": "This identity will soon lack certification (at least {{willNeedCertificationCount}}).",
    "IDENTITY_NEED_MEMBERSHIP": "This identity did not send a membership request. She will have to if she wishes to become a member.",
    "HAS_ALTERNATIVE_IDENTITIES": "There are <b>multiple identities</b> attached to this public key. <b>Before any certification</b>, please <a ng-click=\"doQuickFix('showSelectIdentities')\">check other identities</a> to choose the correct one, or contact the wallet owner.",
    "REVOCATION_SENT": "Revocation sent successfully",
    "REVOCATION_SENT_WAITING_PROCESS": "Revocation <b>has been sent successfully</b>. It is awaiting processing.",
    "FEATURES_NOT_IMPLEMENTED": "This features is not implemented yet.<br/><br/>Why not to contribute to get it faster? ;)",
    "EMPTY_TX_HISTORY": "No operations to export",
    "LOADING_PENDING_TX": "Please wait...<br/><small>(Retrieving pending operations)</small>"
  },
  "CONFIRM": {
    "CAN_CONTINUE": "<b>Are you sure</b> you want to continue?",
    "POPUP_TITLE": "<b>Confirmation</b>",
    "POPUP_WARNING_TITLE": "<b>Warning</b>",
    "POPUP_SECURITY_WARNING_TITLE": "<i class=\"icon ion-alert-circled\"></i> <b>Security warning</b>",
    "CERTIFY_RULES_TITLE_UID": "Certify {{uid}}",
    "CERTIFY_RULES": "<b class=\"assertive\">Don't certify an account</b> if you believe that: <ul><li>1.) the issuers identity might be faked.<li>2.) the issuer already has another certified account.<li>3.) the issuer purposely or carelessly violates rule 1 or 2 (he certifies faked or double accounts).</ul></small><br/>Are you sure you want to certify this identity?",
    "FULLSCREEN": "View the application in full screen?",
    "EXIT_APP": "Close the application ?",
    "TRANSFER": "<b>Transfer summary:</b><br/><br/><ul><li> - From: <b>{{from}}</b></li><li> - To: <b>{{to}}</b></li><li> - Amount: <b>{{amount}} {{unit}}</b></li><li> - Comment: <i>{{comment}}</i></li></ul><br/><b>Are-you sure you want to do this transfer?</b>",
    "TRANSFER_ALL": "<b>Transfer summary:</b><br/><br/><ul><li> - From: <b>{{from}}</b></li><li> - To: <b>{{to}}</b></li><li> - Amount: <b>{{amount}} {{unit}}</b></li><li> - Comment: <i>{{comment}}</i></li><br/><li> - Rest : <b>{{restAmount}} {{unit}}</b> to <b>{{restTo}}</b></li></ul><br/><b>Are-you sure you want to do this transfer?</b>",
    "MEMBERSHIP_OUT": "This operation is <b>irreversible</b>.<br/></br/><b>Are you sure you want to terminate your membership?</b>",
    "MEMBERSHIP_OUT_2": "This operation is <b>irreversible</b>!<br/><br/>Are you sure you want to <b>terminate your membership</b>?",
    "LOGIN_UNUSED_WALLET_TITLE": "Typing error?",
    "LOGIN_UNUSED_WALLET": "The account seems to be <b>inactive</b>.<br/><br/>It's probably a <b>typing error</b> when sign in. Please try again, checking that <b>public key is yours<b/>.",
    "FIX_IDENTITY": "The pseudonym <b>{{uid}}</b> will be published again, replacing the old publication that has expired.<br/></br/><b>Are you sure</b> you want to continue?",
    "FIX_MEMBERSHIP": "Your application for membership will be sent.<br/></br/><b>Are you sure?</b>",
    "MEMBERSHIP": "Your membership request will be sent. <br/></br/><b>Are you sure?</b>",
    "RENEW_MEMBERSHIP": "Your membership will be renewed.<br/></br/><b>Are you sure?</b>",
    "REVOKE_IDENTITY": "You will <b>definitely revoke this identity</b>.<br/><br/>The public key and the associated pseudonym <b>will never be used again</b> (for a member account).<br/></br/><b>Are you sure</b> you want to revoke this identity?",
    "REVOKE_IDENTITY_2": "This operation is <b>irreversible</b>!<br/><br/>Are you sure you want to <b>revoke this identity</b>?",
    "NOT_NEED_RENEW_MEMBERSHIP": "Your membership does not need to be renewed (it will only expire in {{membershipExpiresIn|formatDuration}}).<br/></br/><b>Are you sure you</b> want to renew your membership?",
    "SAVE_BEFORE_LEAVE": "Do you want to <b>save your changes</b> before leaving the page?",
    "SAVE_BEFORE_LEAVE_TITLE": "Changes not saved",
    "LOGOUT": "Are you sure you want to logout?",
    "USE_FALLBACK_NODE": "Peer <b>{{old}}</b> unreachable or invalid address.<br/><br/>Do you want to temporarily use the <b>{{new}}</b> node?",
    "USE_SYNC_FALLBACK_NODE": "Node <b>{{old}}</b> seems to be out of sync.<br/><br/>Do you want to temporarily use the synchronized node <b>{{new}}</b>?",
    "ISSUE_524_SEND_LOG": "The transaction was rejected because of a known problem (issue #524) but not reproduced.<br/><br/>To help developers correct this error, do you accept <b>the transmission of your logs</b> per message?<br/><small>(No confidential data is sent)</small>",
    "ENABLE_EXPERT_MODE_TO_CHANGE_NODE": "<b class=\"assertive\">Warning:</b> Do you want to <b>manually change</b> the Duniter node?<br/><br/>If you continue:<ul><li> - <b>Expert mode</b> will be activated;</li><li> - You can return to automatic node selection by simply <b>deactivating expert mode</b>.</li></ul>"
  },
  "MODE": {
    "DEMO": {
      "BADGE": "Demo",
      "MODE": "Demonstration mode",
      "FEATURE_NOT_AVAILABLE": "Functionality <b>not available</b> on this demonstration site.",
      "MODE_HELP": "Cesium works in <b>demonstration mode</b>: consultation on account is available, but no operation can be performed.",
      "INSTALL_HELP": "For <b>security reasons</b> we recommend <b>installing</b> your copy of the software.<br/> Visit the site <a href='https://cesium.app'>www.cesium.app</a> for help."
    },
    "READONLY": {
      "BADGE": "Monit",
      "MODE": "Monitoring mode",
      "MODE_HELP": "Cesium works in <b>monitoring mode</b>: only currency monitoring features are available.",
      "INSTALL_HELP": "If you want to <b>create a wallet account</b> to send or received money, we recommend <b>installing</b> your copy of the software.<br/> Visit the site <a href='https://cesium.app'>www.cesium.app</a> for help."
    }
  },
  "DOWNLOAD": {
    "POPUP_TITLE": "<b>Revocation file</b>",
    "POPUP_REVOKE_MESSAGE": "To safeguard your account, please download the <b>account revocation document</b>. It will allow you to cancel your account (in case of account theft, ID, an incorrectly created account, etc.).<br/><br/><b>Please store it in a safe place.</b>"
  },
  "HELP": {
    "TITLE": "Online help",
    "JOIN": {
      "SECTION": "Join",
      "SALT": "The secret identifier is very important. It is used to hash you password, which in turn is used to calculate your <span class=\"text-italic\">public account key</span> (its number) and the private key to access it.<br/><b>Please remeber this identifier well</b>, because there is no way to recover it when lost.<br/>Furthermore, it cannot be changed without having to create a new account.<br/><br/>A good secret identifier must be sufficiently long (8 characters at the very least) and as original as possible.",
      "PASSWORD": "The password is very important. Together with the secret identifier, it is use to calculate your account number (pblic key) and the private key to access it.<br/><b>Please remember it well</b>, because there is no way to recover it when lost.<br/>Furthermore, it cannot be changed without having to create a new account.<br/><br/>A good password is made (ideally) of at least 8 characters, with at least one capital and one number.",
      "PSEUDO": "A pseudonym is used only when joining as <span class=\"text-italic\">member</span>. It is always associated with a wallet (by its <span class=\"text-italic\">public key</span>).<br/>It is published on the network so that other users may identify it, certify or send money to the account.<br/>A pseudonym must be unique among all members (current and past)."
    },
    "LOGIN": {
      "SECTION": "Log in",
      "PUBKEY": "Account public key",
      "PUBKEY_DEF": "The public key of the keychain is generated from the entered identifiers (any), but does not correspond to an account already used.<br/><b>Make sure your public key is the same as your account</b>. Otherwise, you will be logged into an account that is probably never used, as the risk of collision with an existing account is very small.<br/><a href=\"https://en.wikipedia.org/wiki/Elliptic_curve_cryptography\" target=\"_ system\">Learn more about cryptography</a> by public key.",
      "METHOD": "Connection methods",
      "METHOD_DEF": "Several options are available to connect to a portfolios: <br/> - The connection <b>with salt (simple or advanced)</b> mixes your password with the secret identifier, to limit the attempts of piracy<br/> - The connection <b>using public key</b> prevents you from entering your credentials, which you will be asked only when an operation need it.<br/> - The connection <b>using keychain file</b> will read the public and private keys of the account from a file without the need to enter credentials. Several file formats are possible."
    },
    "GLOSSARY": {
      "SECTION": "Glossary",
      "PUBKEY_DEF": "A public key always identifies a wallet. It may identify a member. In Cesium it is calculated using the secret identifier and the password.",
      "MEMBER": "Member",
      "MEMBER_DEF": "A member is a real and living human, wishing to participate freely to the monitary community. The member will receive universal dividend, according to the period and amount as defined in the <span class=\"text-italic\">currency parameters</span>.",
      "CURRENCY_RULES": "Currency rules",
      "CURRENCY_RULES_DEF": "The currency rules are defined only once, and for all. They set the parameters under which the currency will perform: universal dividend calculation, the amount of certifications needed to become a member, the maximum amount of certifications a member can send, etc.<br/><br/>The parameters cannot be modified because of the use of a <span class=\"text-italic\">Blockchain</span> which carries and executes these rules, and constantly verifies their correct application. <a href=\"#/app/currency\">See current parameters</a>.",
      "BLOCKCHAIN": "Blockchain",
      "BLOCKCHAIN_DEF": "The Blockchain is a decentralised system which, in case of Duniter, serves to carry and execute the <span class=\"text-italic\">currency rules</span>.<br/><a href=\"http://en.duniter.org/presentation/\" target=\"_blank\">Read more about Duniter</a> and the working of its blockchain.",
      "UNIVERSAL_DIVIDEND_DEF": "The Universal Dividend (UD) is the quantity of money co-created by each member, according to the period and the calculation defined in the <span class=\"text-italic\">currency rules</span>.<br/>Every term, the members receive an equal amount of new money on their account.<br/><br/>The UD undergoes a steady growth, to remain fair under its members (current and future), calculated by an average life expectancy, as demonstrated in the Relative Theory of Money (RTM).<br/><a href=\"http://trm.creationmonetaire.info\" target=\"_system\">Read more about RTM</a> and open money.",
      "WOT": "Web of Trust (WoT)",
      "WOT_DEF": "The Web of Trust is made up of all the members of the currency, and the links of certification which connect them.",
      "DISTANCE_RULE": "Distance rule",
      "DISTANCE_RULE_DEF": "The rule of distance defines <b>a maximum distance to meet</b> between an applicant and a minimum number of referring member. This distance is calculated using the certification links."
    },
    "TIP": {
      "MENU_BTN_CURRENCY": "Menu <b>{{'MENU.CURRENCY'|translate}}</b> allows discovery of <b>currency parameters</b> and its state.",
      "CURRENCY_WOT": "The <b>member count</b> shows the <b>community's weight and evolution</b>.",
      "CURRENCY_MASS": "Shown here is the <b>total amount</b> currently in circulation and its <b>average distribution</b> per member.<br/><br/>This allows to estimate the <b>worth of any amount</b>, in respect to what <b>others own</b> on their account (on average).",
      "CURRENCY_UNIT_RELATIVE": "The unit used here (&ldquo;<b>{{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub></b>&rdquo;) signifies that the amounts in {{currency|capitalize}} have been devided by the <b>Universal Dividend</b> (UD).<br/><br/><small>This relative unit is <b>relevant</b> because it is stable in contrast to the permanently growing monitary mass.</small>",
      "CURRENCY_CHANGE_UNIT": "The option <b>{{'COMMON.BTN_RELATIVE_UNIT'|translate}}</b> allows to <b>switch the unit</b> to show amounts in <b>{{currency|capitalize}}</b>, undevided by the Universal Dividend (instead of in &ldquo;<b>{{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub></b>&rdquo;).",
      "CURRENCY_CHANGE_UNIT_TO_RELATIVE": "The option <b>{{'COMMON.BTN_RELATIVE_UNIT'|translate}}</b> allows to <b>switch the unit</b> to show amounts in &ldquo;<b>{{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub></b>&rdquo;, which is relative to the Universal Dividend (the amount co-produced by each member).",
      "CURRENCY_RULES": "The <b>rules</b> of the currency determine its <b>exact and predictible</b> performance.<br/><br/>As a true DNA of the currency these rules make the monetary code <b>transparent and understandable</b>.",
      "MENU_BTN_NETWORK": "Menu <b>{{'MENU.NETWORK'|translate}}</b> allows discovery of <b>network's state<b>.",
      "NETWORK_BLOCKCHAIN": "All monetary transactions are recoded in a <b>public and tamper proof</b> ledger, generally referred to as the <b>blockchain</b>.",
      "NETWORK_PEERS": "The <b>peers</b> shown here correspond to <b>computers that update and check</b> the blockchain.<br/><br/>The more active peers there are, the more <b>decentralised</b> and therefore trustworhty the currency becomes.",
      "NETWORK_PEERS_BLOCK_NUMBER": "This <b>number</b> (in green) indicates the peer's <b>latest validated block</b> (last page written in the ledger).<br/><br/>Green indicates that the block was equally validated by the <b>majority of other peers</b>.",
      "NETWORK_PEERS_PARTICIPATE": "<b>Each member</b>, equiped with a computer with Internet, <b>can participate, adding a peer</b> simply by <b>installing the Duniter software</b> (free/libre). <a target=\"_new\" href=\"{{installDocUrl}}\" target=\"_system\">Read the installation manual &gt;&gt;</a>.",
      "MENU_BTN_ACCOUNT": "<b>{{'ACCOUNT.TITLE'|translate}}</b> allows access to your account balance and transaction history.",
      "MENU_BTN_ACCOUNT_MEMBER": "Here you can consult your account status, transaction history and your certifications.",
      "WALLET_CERTIFICATIONS": "Click here to reveiw the details of your certifications (given and received).",
      "WALLET_RECEIVED_CERTIFICATIONS": "Click here to review the details of your <b>received certifications</b>.",
      "WALLET_GIVEN_CERTIFICATIONS": "Click here to review the details of your <b>given certifications</b>.",
      "WALLET_BALANCE": "Your account <b>balance</b> is shown here.",
      "WALLET_BALANCE_RELATIVE": "{{'HELP.TIP.WALLET_BALANCE'|translate}}<br/><br/>The used unit (&ldquo;<b>{{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub></b>&rdquo;) signifies that the amount in {{currency|capitalize}} has been divided by the <b>Universal Dividend</b> (UD) co-created by each member.<br/>At this moment, 1 UD equals {{currentUD}} {{currency|capitalize}}.",
      "WALLET_BALANCE_CHANGE_UNIT": "You can <b>change the unit</b> in which amounts are shown in <b><i class=\"icon ion-android-settings\"></i>&nbsp;{{'MENU.SETTINGS'|translate}}</b>.<br/><br/>For example, to display amounts <b>directly in {{currency|capitalize}}</b> instead of relative amounts.",
      "WALLET_PUBKEY": "This is your account public key. You can communicate it to a third party so that it more easily identifies your account.",
      "WALLET_SEND": "Issue a payment in just a few clicks.",
      "WALLET_SEND_NO_MONEY": "Issue a payment in just a few clicks.<br/>(Your balance does not allow this yet)",
      "WALLET_OPTIONS": "Please note that this button allows access to <b>other, less used actions</b>.<br/><br/>Don't forget to take a quick look, when you have a moment!",
      "WALLET_RECEIVED_CERTS": "This shows the list of persons that certified you.",
      "WALLET_CERTIFY": "The button <b>{{'WOT.BTN_SELECT_AND_CERTIFY'|translate}}</b> allows selecting an identity and certifying it.<br/><br/>Only users that are <b>already member</b> may certify others.",
      "WALLET_CERT_STOCK": "Your supply of certifications (to send) is limited to <b>{{sigStock}} certifications</b>.<br/><br/>This supply will replete itself over time, as and when earlier certifications expire.",
      "MENU_BTN_WALLETS": "The menu <b>{{'MENU.WALLETS'|translate}}</b> allows you to add additional wallets that you manage.",
      "MENU_BTN_TX": "The menu <b>{{'MENU.TRANSACTIONS'|translate}}</b> allow access to transactions history, and send new payments.",
      "MENU_BTN_WOT": "The menu <b>{{'MENU.WOT'|translate}}</b> allows searching <b>users</b> of the currency (member or not).",
      "WOT_SEARCH_TEXT_XS": "To search in the registry, type the <b>first letters of a users pseudonym or public key</b>.<br/><br/>The search will start automatically.",
      "WOT_SEARCH_TEXT": "To search in the registry, type the <b>first letters of a users pseudonym or public key</b>.<br/><br/>Then hit <b>Enter</b> to start the search.",
      "WOT_SEARCH_RESULT": "Simply click a user row to view the details sheet.",
      "WOT_VIEW_CERTIFICATIONS": "The row <b>{{'ACCOUNT.CERTIFICATION_COUNT'|translate}}</b> shows how many members members validated this identity.<br/><br/>These certifications testify that the account belongs to <b>a living human</b> and this person has <b>no other member account</b>.",
      "WOT_VIEW_CERTIFICATIONS_COUNT": "There are at least <b>{{sigQty}} certifications</b> needed to become a member and receive the <b>Universal Dividend</b>.",
      "WOT_VIEW_CERTIFICATIONS_CLICK": "Click here to open <b>a list of all certifications</b> given to and by this identity.",
      "WOT_VIEW_CERTIFY": "The button <b>{{'WOT.BTN_CERTIFY'|translate}}</b> allows to add your certification to this identity.",
      "CERTIFY_RULES": "<b>Attention:</b> Only certify <b>real and living persons</b> that do not own any other certified account.<br/><br/>The trust carried by the currency depends on each member's vigilance!",
      "MENU_BTN_SETTINGS": "The <b>{{'MENU.SETTINGS'|translate}}</b> allow you to configure the Cesium application.<br/><br/>For example, you can <b>change the unit</b> in which the currency will be shown.",
      "HEADER_BAR_BTN_PROFILE": "Click here to access your <b>user profile</b>",
      "SETTINGS_CHANGE_UNIT": "You can <b>change the display unit</b> of amounts by clicking here.<br/><br/>- Deactivate the option to show amounts in {{currency|capitalize}}.<br/>- Activate the option for relative amounts in {{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub> (<b>divided</b> by the current Universal Dividend).",
      "END_LOGIN": "This guided visit has <b>ended</b>.<br/><br/>Welcome to the <b>free economy</b>!",
      "END_NOT_LOGIN": "This guided visit has <b>ended</b>.<br/><br/>If you wish to join the currency {{currency|capitalize}}, simply click <b>{{'LOGIN.CREATE_FREE_ACCOUNT'|translate}}</b> below.",
      "END_READONLY": "This guided visit has <b>ended</b>.<br/><br/>{{'MODE.READONLY.INSTALL_HELP'|translate}}."
    }
  },
  "API" :{
    "COMMON": {
      "LINK_DOC": "API documentation",
      "LINK_DOC_HELP": "API documentation for developers",
      "LINK_STANDARD_APP": "Standard version",
      "LINK_STANDARD_APP_HELP": "Open standard version of {{'COMMON.APP_NAME'|translate}}",
      "CONNECTION_ERROR": "Peer <b>{{server}}</b> unreachable or invalid address.<br/><br/>Check your Internet connection, or contact the web site administrator."
    },
    "HOME": {
      "TITLE": "{{'COMMON.APP_NAME'|translate}} API Documentation",
      "MESSAGE": "Welcome to the {{'COMMON.APP_NAME'|translate}} <b>API documentation </b>.<br/>Connect your web site to <a href=\"http://duniter.org\" target=\"_system\">Duniter</a> very easily!",
      "MESSAGE_SHORT": "Connect your websites to <a href=\"http://duniter.org\" target=\"_system\">Duniter</a> very easily!",
      "DOC_HEADER": "Available services:"
    },
    "TRANSFER": {
      "TITLE": "{{'COMMON.APP_NAME'|translate}} - Online payment",
      "TITLE_SHORT": "Online payment",
      "SUMMARY": "Order summary:",
      "AMOUNT": "Amount:",
      "AMOUNTS_HELP": "Please select the amount:",
      "NAME": "Name:",
      "PUBKEY": "Public key of the recipient:",
      "COMMENT": "Order reference:",
      "NODE": "Peer address:",
      "DEMO": {
        "SALT": "demo",
        "PASSWORD": "demo",
        "PUBKEY": "3G28bL6deXQBYpPBpLFuECo46d3kfYMJwst7uhdVBnD1",
        "HELP": "<b>Demonstration mode</b>: No payment will actually be sent during this simulation.<br/>Please use credentials: <b>{{'API.TRANSFER.DEMO.SALT'|translate}} / {{'API.TRANSFER.DEMO.PASSWORD'|translate}}</b>",
        "BAD_CREDENTIALS": "Invalid credentials.<br/>In demonstration mode, credentials should be: {{'API.TRANSFER.DEMO.SALT'|translate}} / {{'API.TRANSFER.DEMO.PASSWORD'|translate}}"
      },
      "INFO": {
        "SUCCESS_REDIRECTING_WITH_NAME": "Payment sent.<br/>Redirect to <b>{{name}}</b>...",
        "SUCCESS_REDIRECTING": "Payment sent.<br/>Redirect to the seller's website...",
        "CANCEL_REDIRECTING_WITH_NAME": "Payment cancelled.<br/>Redirect to <b>{{name}}</b>...",
        "CANCEL_REDIRECTING": "Payment cancelled.<br/>Redirect to the seller's website..."
      },
      "ERROR": {
        "TRANSFER_FAILED": "Payment failed"
      }
    },
    "DOC": {
      "DESCRIPTION_DIVIDER": "Description",
      "URL_DIVIDER": "Calling address",
      "PARAMETERS_DIVIDER": "Parameters",
      "AVAILABLE_PARAMETERS": "Here is the list of al available parameters:",
      "DEMO_DIVIDER": "Try it !",
      "DEMO_HELP": "To test this service, click on this button. The result content will be display below.",
      "DEMO_RESULT": "Result returned by call:",
      "DEMO_RESULT_PEER": "Peer address used:",
      "DEMO_SUCCEED": "<i class=\"icon ion-checkmark\"></i> Success!",
      "DEMO_CANCELLED": "<i class=\"icon ion-close\"></i> Canceled by user",
      "INTEGRATE_DIVIDER": "Website integration",
      "INTEGRATE_CODE": "Code:",
      "INTEGRATE_RESULT": "Result preview:",
      "INTEGRATE_PARAMETERS": "Parameters",
      "TRANSFER": {
        "TITLE": "Payments",
        "DESCRIPTION": "From a site (eg online marketplace) you can delegate payment in free currency to Cesium API. To do this, simply open a page at the following address:",
        "PARAM_PUBKEY": "Recipient's public key",
        "PARAM_PUBKEY_HELP": "Recipient's public key (required)",
        "PARAM_AMOUNT": "Amount",
        "PARAM_AMOUNT_HELP": "Transaction amount (required)",
        "PARAM_COMMENT": "Reference (or comment)",
        "PARAM_COMMENT_HELP": "Reference or comment. You will allow for example to identify the payment in the BlockChain.",
        "PARAM_NAME": "Name (of recipient or website)",
        "PARAM_NAME_HELP": "The name of your website. This can be a readable name (eg \"My online site\"), or a web address (eg \"www.MySite.com\").",
        "PARAM_REDIRECT_URL": "URL redirection",
        "PARAM_REDIRECT_URL_HELP": "URL redirection after sending payment, after the payment has been sent. Can contain the following strings, which will be replaced by the values of the transaction: \"{tx}\", \"{hash}\", \"{comment}\", \"{amount}\" and \"{pubkey}\".",
        "PARAM_CANCEL_URL": "URL if cancelled",
        "PARAM_CANCEL_URL_HELP": "URL in case of cancellation.  Can contain the following strings, which will be replaced: \"{comment}\", \"{amount}\" and \"{pubkey}\".",
        "PARAM_PREFERRED_NODE": "Preferred Duniter peer",
        "PARAM_PREFERRED_NODE_HELP": "Peer address (URL) to use preferably (\"g1.domain.com:443\" or \"https://g1.domain.com\")",
        "EXAMPLES_HELP": "Examples of integration:",
        "EXAMPLE_BUTTON": "HTML Button",
        "EXAMPLE_BUTTON_DEFAULT_TEXT": "Pay in {{currency|abbreviate}}",
        "EXAMPLE_BUTTON_DEFAULT_STYLE": "Custom style",
        "EXAMPLE_BUTTON_TEXT_HELP": "Button text",
        "EXAMPLE_BUTTON_BG_COLOR": "Background color",
        "EXAMPLE_BUTTON_BG_COLOR_HELP": "eg: #fbc14c, yellow, lightgrey, rgb(180,180,180)",
        "EXAMPLE_BUTTON_FONT_COLOR": "Font color",
        "EXAMPLE_BUTTON_FONT_COLOR_HELP": "eg: black, orange, rgb(180,180,180)",
        "EXAMPLE_BUTTON_TEXT_ICON": "Icon",
        "EXAMPLE_BUTTON_TEXT_WIDTH": "Width",
        "EXAMPLE_BUTTON_TEXT_WIDTH_HELP": "eg: 200px, 50%",
        "EXAMPLE_BUTTON_ICON_NONE": "No icon",
        "EXAMPLE_BUTTON_ICON_DUNITER": "Duniter logo",
        "EXAMPLE_BUTTON_ICON_CESIUM": "Cesium logo",
        "EXAMPLE_BUTTON_ICON_G1_COLOR": "Ğ1 logo",
        "EXAMPLE_BUTTON_ICON_G1_BLACK": "Ğ1 logo (outline)"
      }
    }
  }
}
);

$translateProvider.translations("eo-EO", {
  "COMMON": {
    "APP_NAME": "Cesium",
    "APP_VERSION": "v{{version}}",
    "APP_BUILD": "date : {{build}}",
    "PUBKEY": "Publika ŝlosilo",
    "MEMBER": "Membro",
    "BLOCK" : "Bloko",
    "BTN_OK": "OK",
    "BTN_YES": "Jes",
    "BTN_NO": "Ne",
    "BTN_SEND": "Sendi",
    "BTN_SEND_MONEY": "Fari elspezon",
    "BTN_SEND_MONEY_SHORT": "Elspezo",
    "BTN_SAVE": "Konservi",
    "BTN_YES_SAVE": "Jes, Konservi",
    "BTN_YES_CONTINUE": "Jes, Daŭrigi",
    "BTN_SHOW": "Vidi",
    "BTN_SHOW_PUBKEY": "Afiŝi la publikan ŝlosilon",
    "BTN_RELATIVE_UNIT": "Afiŝi la sumojn en UD?",
    "BTN_BACK": "Reiro",
    "BTN_NEXT": "Sekva",
    "BTN_IMPORT": "Enporti",
    "BTN_CANCEL": "Nuligi",
    "BTN_CLOSE": "Fermi",
    "BTN_LATER": "Poste",
    "BTN_LOGIN": "Konektiĝi",
    "BTN_LOGOUT": "Malkonektiĝo",
    "BTN_ADD_ACCOUNT": "Nova konto",
    "BTN_SHARE": "Diskonigi",
    "BTN_EDIT": "Modifi",
    "BTN_DELETE": "Forigi",
    "BTN_ADD": "Aldoni",
    "BTN_SEARCH": "Serĉi",
    "BTN_REFRESH": "Aktualigi",
    "BTN_RETRY": "Rekomenci",
    "BTN_START": "Komenci",
    "BTN_CONTINUE": "Daŭrigi",
    "BTN_CREATE": "Krei",
    "BTN_UNDERSTOOD": "Mi komprenis",
    "BTN_OPTIONS": "Kromeblecoj",
    "BTN_HELP_TOUR": "Gvidata vizito",
    "BTN_HELP_TOUR_SCREEN": "Malkovri tiun ĉi paĝon",
    "BTN_DOWNLOAD": "Elŝuti",
    "BTN_DOWNLOAD_ACCOUNT_STATEMENT": "Elŝuti la konto-tabelon",
    "BTN_MODIFY": "Modifi",
    "CHOOSE_FILE": "Almetu vian dosieron <br/>aŭ klaku por elekti ĝin",
    "DAYS": "tagoj",
    "NO_ACCOUNT_QUESTION": "Ankoraŭ sen konto? Kreu ĝin senpage!",
    "SEARCH_NO_RESULT": "Neniu rezulto trovita",
    "LOADING": "Bonvolu pacienci...",
    "LOADING_WAIT": "Bonvolu pacienci...<br/><small>(Cesium demandas la Duniter-nodon)</small>",
    "SEARCHING": "Serĉanta...",
    "FROM": "De",
    "TO": "Al",
    "COPY": "Kopii",
    "LANGUAGE": "Lingvo",
    "UNIVERSAL_DIVIDEND": "Universala dividendo",
    "UD": "UD",
    "DATE_PATTERN": "DD/MM/YY HH:mm",
    "DATE_FILE_PATTERN": "YYYY-MM-DD",
    "DATE_SHORT_PATTERN": "DD/MM/YY",
    "DATE_MONTH_YEAR_PATTERN": "MM/YYYY",
    "EMPTY_PARENTHESIS": "(malplena)",
    "UID": "Pseŭdonimo",
    "ENABLE": "Aktiva",
    "DISABLE": "Malaktiva",
    "RESULTS_LIST": "Rezultoj",
    "RESULTS_COUNT": "{{count}} rezultoj",
    "EXECUTION_TIME": "Plenumita en {{duration|formatDurationMs}}",
    "SHOW_VALUES": "Afiŝi la signojn klare?",
    "POPOVER_ACTIONS_TITLE": "Kromeblecoj",
    "POPOVER_FILTER_TITLE": "Filtriloj",
    "SHOW_MORE": "Afiŝi pli",
    "SHOW_MORE_COUNT": "(nuna limo je {{limit}})",
    "POPOVER_SHARE": {
      "TITLE": "Diskonigi",
      "SHARE_ON_TWITTER": "Diskonigi ĉe Twitter",
      "SHARE_ON_FACEBOOK": "Diskonigi ĉe Facebook",
      "SHARE_ON_DIASPORA": "Diskonigi ĉe Diaspora*",
      "SHARE_ON_GOOGLEPLUS": "Diskonigi ĉe Google+"
    },
    "FILE": {
      "DATE": "Dato:",
      "TYPE": "Tipo:",
      "SIZE": "Pezo:",
      "VALIDATING": "Validiĝanta..."
    }
  },
  "SYSTEM": {
    "PICTURE_CHOOSE_TYPE": "Elekti la fonton:",
    "BTN_PICTURE_GALLERY": "Bildaro",
    "BTN_PICTURE_CAMERA": "<b>Kamerao</b>"
  },
  "MENU": {
    "HOME": "Hejmpaĝo",
    "WOT": "Kontaro",
    "CURRENCY": "Mono",
    "ACCOUNT": "Mia konto",
    "WALLETS": "Miaj monujoj",
    "SETTINGS": "Parametroj",
    "NETWORK": "Reto",
    "TRANSACTIONS": "Miaj spezoj"
  },
  "ABOUT": {
    "TITLE": "Prie",
    "LICENSE": "Programo <b>libera</b> (Licenco GNU AGPLv3).",
    "LATEST_RELEASE": "Ekzistas <b>pli freŝdata versio</b> de {{'COMMON.APP_NAME'|translate}} (<b>v{{version}}</b>)",
    "PLEASE_UPDATE": "Bonvolu ĝisdatigi {{'COMMON.APP_NAME'|translate}} (lasta versio: <b>v{{version}}</b>)",
    "CODE": "Fonto-kodo:",
    "OFFICIAL_WEB_SITE": "Oficiala retejo:",
    "DEVELOPERS": "Programita de:",
    "FORUM": "Forumo:",
    "PLEASE_REPORT_ISSUE": "Ne hezitu sciigi al ni la renkontitajn fuŝaĵojn",
    "REPORT_ISSUE": "Sciigi problemon",
    "BTN_OPEN_DEV_WINDOW": "Malfermi la fenestron pri malfuŝigado"
  },
  "HOME": {
    "TITLE": "Cesium",
    "WELCOME": "Bonvenon ĉe la programo Cesium!",
    "WELCOME_READONLY": "Bonvenon ĉe Cesium <span class='badge badge-balanced'>Observo</span>!",
    "MESSAGE": "Ricevu kaj sendu liberan monon {{currency|abbreviate}}",
    "MESSAGE_READONLY": "Sekvu la staton de la libera mono {{currency|abbreviate}} en tuja tempo.",
    "BTN_CURRENCY": "Esploru la monon {{currency|abbreviate}}",
    "BTN_ABOUT": "prie",
    "BTN_HELP": "Reta helpo",
    "BTN_NETWORK": "Stato de la reto",
    "FREE_SOFTWARE": "Libera programo",
    "FORK_ME": "Duobligu min!",
    "SHOW_LICENSE": "Vidi la licencon de la programo",
    "REPORT_ISSUE": "fuŝaĵo",
    "NOT_YOUR_ACCOUNT_QUESTION" : "Vi ne posedas la konton <b class=\"ion-key\"> {{pubkey|formatPubkey}}</b>&nbsp;?",
    "BTN_CHANGE_ACCOUNT": "Malkonektu tiun ĉi konton",
    "PEER_CONNECTION_ERROR": "Nodo <b>{{server}}</b> neatingebla aŭ adreso nevalida.<br/><br/>Kontrolu vian retkonekton, aŭ elektu alian nodon <a class=\"positive\" ng-click=\"doQuickFix('settings')\">ĉe la parametroj</a>.",
    "NETWORK_CONNECTION_ERROR": "Reto neatingeblas.<br/><br/>Kontrolu vian interreta konekto, aŭ selektu nodon permane <a class=\"positive\" ng-click=\"doQuickFix('settings')\">en la agordoj</a>.",
    "SHOW_ALL_FEED": "Vidi ĉion",
    "READ_MORE": "Legi la sekvon",
    "FEED_SOURCE": "Fonto"
  },
  "SETTINGS": {
    "TITLE": "Parametroj",
    "DISPLAY_DIVIDER": "Afiŝado",
    "STORAGE_DIVIDER": "Stokado",
    "NETWORK_SETTINGS": "Reto",
    "PEER": "Nodo Duniter",
    "PEER_CHANGED_TEMPORARY": "Adreso provizore uzata",
    "PEER_SELECTED_AUTOMATICALLY": "Nodo aŭtomate elektita ĉe starto",
    "NETWORK_ANALYZE_TIMEOUT": "Maksimuma atendotempo (eltempigo)",
    "NETWORK_ANALYZE_TIMEOUT_HELP": "Maksimuma atendotempo por reto analizo",
    "NETWORK_ANALYZE_TIMEOUT_AUTO": "Auto",
    "PERSIST_CACHE": "Konservi la datenojn pri retumado (provaĵo)",
    "PERSIST_CACHE_HELP": "Ebligas pli rapidan retumadon, loke konservante la ricevitajn datenojn, por uzi ilin de seanco al alia.",
    "USE_LOCAL_STORAGE": "Aktivigi lokan stokadon",
    "USE_LOCAL_STORAGE_HELP": "Ebligas konservi viajn parametrojn",
    "WALLETS_SETTINGS": "Miaj monujoj",
    "USE_WALLETS_ENCRYPTION": "Sekurigi la liston?",
    "USE_WALLETS_ENCRYPTION_HELP": "Ebligas sekurigi la liston de viaj monujoj (per ĉifrado), postulante aŭtentigado por aliri ilin.",
    "ENABLE_HELPTIP": "Aktivigi la rilatigajn help-vezikojn",
    "DISABLE_HELPTIP": "Malaktivigi la rilatigajn help-vezikojn",
    "ENABLE_UI_EFFECTS": "Aktivigi la vid-efikojn",
    "HISTORY_SETTINGS": "Miaj spezoj",
    "DISPLAY_UD_HISTORY": "Afiŝi la produktitajn dividendojn?",
    "TX_HISTORY_AUTO_REFRESH": "Aktualigi aŭtomate",
    "TX_HISTORY_AUTO_REFRESH_HELP": "Aktualigas la saldon kaj la spezojn aŭtomate, por ĉiu nova bloko de la reto.",
    "AUTHENTICATION_SETTINGS": "Aŭtentigado",
    "KEEP_AUTH": "Aŭtomata malaŭtentigado",
    "KEEP_AUTH_SHORT": "Malaŭtentigado",
    "KEEP_AUTH_HELP": "Difinas la momenton, kiam la aŭtentigado estas forviŝita de la memoro.",
    "KEEP_AUTH_OPTION": {
      "NEVER": "Post ĉiu ago",
      "SECONDS": "Post {{value}}s de neatktiveco",
      "MINUTE": "Post {{value}}min de neatktiveco",
      "MINUTES": "Post {{value}}min de neatktiveco",
      "HOUR": "Post {{value}}h de neatktiveco",
      "ALWAYS": "Fine de la seanco"
    },
    "KEYRING_FILE": "Dosiero pri ŝlosilaro",
    "KEYRING_FILE_HELP": "Ebligas <b>konektiĝi</b> aŭtomate por ĉiu ekuzo<br/>kaj eĉ <b>aŭtentiĝi</b> (nur se \"Finiĝo de la aŭtentiĝo\" estas agordita kiel \"fine de la seanco\").",
    "REMEMBER_ME": "Memori min?",
    "REMEMBER_ME_HELP": "Ebligas resti identigita de seanco al alia, loke konservante la publikan ŝlosilon.",
    "PLUGINS_SETTINGS": "Krom-programoj",
    "BTN_RESET": "Restarigi la originajn valorojn",
    "EXPERT_MODE": "Aktivigi la spertan moduson",
    "EXPERT_MODE_HELP": "Ebligas pli detalan afiŝadon.",
    "BLOCK_VALIDITY_WINDOW": "Limtempo pri necerteco de la blokoj",
    "BLOCK_VALIDITY_WINDOW_SHORT": "Limtempo pri necerteco",
    "BLOCK_VALIDITY_WINDOW_HELP": "Limtempo antaŭ ol taksi, ke iu informo estas validigita",
    "BLOCK_VALIDITY_OPTION": {
      "NONE": "Neniu limtempo",
      "N": "{{time | formatDuration}} ({{count}} blokoj)"
    },
    "POPUP_PEER": {
      "TITLE": "Nodo Duniter",
      "HOST": "Adreso",
      "HOST_HELP": "Adreso: servilo: konektujo",
      "USE_SSL": "Sekurigita?",
      "USE_SSL_HELP": "SSL-ĉifrado",
      "BTN_SHOW_LIST": "Listo de la nodoj"
    }
  },
  "BLOCKCHAIN": {
    "HASH": "Haketo: {{hash}}",
    "VIEW": {
      "HEADER_TITLE": "Bloko #{{number}}-{{hash|formatHash}}",
      "TITLE_CURRENT": "Nuna bloko",
      "TITLE": "Bloko #{{number|formatInteger}}",
      "COMPUTED_BY": "Kalkulita de la nodo de",
      "SHOW_RAW": "Vidi la kompletan dosieron",
      "TECHNICAL_DIVIDER": "Teknikaj informoj",
      "VERSION": "Versio de la daten-strukturo",
      "HASH": "Kalkulita haketo",
      "UNIVERSAL_DIVIDEND_HELP": "Mono kunproduktita de ĉiu el la {{membersCount}} membroj",
      "EMPTY": "Neniu dateno en tiu ĉi bloko",
      "POW_MIN": "Minimuma malfacileco",
      "POW_MIN_HELP": "Malfacileco trudita por la haket-kalkulo",
      "DATA_DIVIDER": "Datenoj",
      "IDENTITIES_COUNT": "Novaj identecoj",
      "JOINERS_COUNT": "Novaj membroj",
      "ACTIVES_COUNT": "Revalidigoj",
      "ACTIVES_COUNT_HELP": "Membroj revalidigintaj sian membrecon",
      "LEAVERS_COUNT": "Membroj elirintaj",
      "LEAVERS_COUNT_HELP": "Membroj ne plu dezirantaj atestaĵon",
      "EXCLUDED_COUNT": "Membroj eksigitaj",
      "EXCLUDED_COUNT_HELP": "Malnovaj membroj eksigitaj pro nerevalidiĝo aŭ manko de atestaĵoj",
      "REVOKED_COUNT": "Nuligitaj identecoj",
      "REVOKED_COUNT_HELP": "Tiuj kontoj ne plu povos esti membroj",
      "TX_COUNT": "Spezoj",
      "CERT_COUNT": "Atestaĵoj",
      "TX_TO_HIMSELF": "Operacio pri monŝanĝo",
      "TX_OUTPUT_UNLOCK_CONDITIONS": "Kondiĉoj por malblokado",
      "TX_OUTPUT_OPERATOR": {
        "AND": "kaj",
        "OR": "aŭ"
      },
      "TX_OUTPUT_FUNCTION": {
        "SIG": "<b>Subskribo</b> de ",
        "XHX": "<b>Pasvorto</b>, el kiu SHA256 =",
        "CSV": "Blokita dum",
        "CLTV": "Blokita ĝis"
      }
    },
    "LOOKUP": {
      "TITLE": "Blokoj",
      "NO_BLOCK": "Neniu bloko",
      "LAST_BLOCKS": "Lastaj blokoj:",
      "BTN_COMPACT": "Densigi"
    }
  },
  "CURRENCY": {
    "VIEW": {
      "TITLE": "Mono",
      "TAB_CURRENCY": "Mono",
      "TAB_WOT": "Reto de fido",
      "TAB_NETWORK": "Reto",
      "TAB_BLOCKS": "Blokoj",
      "CURRENCY_SHORT_DESCRIPTION": "{{currency|abbreviate}} estas <b>libera mono</b>, kiu ekis {{firstBlockTime|formatFromNow}}. Ĝi nombras nun <b>{{N}} membrojn</b>, kiuj produktas kaj ricevas <a ng-click=\"showHelpModal('ud')\">Universalan Dividendon</a> (UD), ĉiun {{dt|formatPeriod}}n.",
      "NETWORK_RULES_DIVIDER": "Reguloj de la reto",
      "CURRENCY_NAME": "Nomo de la mono",
      "MEMBERS": "Nombro de membroj",
      "MEMBERS_VARIATION": "Variado depost la lasta UD",
      "MONEY_DIVIDER": "Mono",
      "MASS": "Mona maso",
      "SHARE": "Monkvanto por ĉiu membro",
      "UD": "Universala Dividendo",
      "C_ACTUAL": "Nuna kreskado",
      "MEDIAN_TIME": "Horo de la blokĉeno",
      "POW_MIN": "Minimuma nivelo pri malfacileco de kalkulo",
      "MONEY_RULES_DIVIDER": "Reguloj de la mono",
      "C_RULE": "Teoria kreskado celata",
      "UD_RULE": "Kalkulo de la universala dividendo",
      "DT_REEVAL": "Periodo de revalorigo de la UD",
      "REEVAL_SYMBOL": "reval",
      "DT_REEVAL_VALUE": "Ĉiuj <b>{{dtReeval|formatDuration}}</b> ({{dtReeval/86400}} {{'COMMON.DAYS'|translate}})",
      "UD_REEVAL_TIME0": "Dato de la unua revalorigo",
      "SIG_QTY_RULE": "Nombro de necesaj atestaĵoj por fariĝi membro",
      "SIG_STOCK": "Maksimuma nombro da senditaj atestaĵoj por membro",
      "SIG_PERIOD": "Minimuma daŭro de atendado inter 2 sinsekvaj atestaĵoj senditaj de sama persono",
      "SIG_WINDOW": "Limdaŭro por akcepti atestaĵon",
      "SIG_VALIDITY": "Vivdaŭro de atestaĵo, kiu estis akceptita",
      "MS_WINDOW": "Limdaŭro por la akcepto de aliĝ-peto",
      "MS_VALIDITY": "Vivdaŭro de aliĝo, kiu estis akceptita",
      "STEP_MAX": "Maksimuma distanco, per la atestaĵoj, inter nova eniranto kaj la referencaj membroj",
      "WOT_RULES_DIVIDER": "Reguloj de la reto de fido",
      "SENTRIES": "Nombro de atestaĵoj (senditaj <b>kaj</b> ricevitaj) por fariĝi referenca membro",
      "SENTRIES_FORMULA": "Nombro de atestaĵoj (senditaj <b>kaj</b> ricevitaj) por fariĝi referenca membro (formulo)",
      "XPERCENT":"Minimuma procento da referencaj membroj atingenda por konformiĝi al la regulo pri distanco",
      "AVG_GEN_TIME": "Meza daŭro inter du blokoj",
      "CURRENT": "nuna",
      "MATH_CEILING": "PLAFONO",
      "DISPLAY_ALL_RULES": "Afiŝi ĉiujn regulojn?",
      "BTN_SHOW_LICENSE": "Vidi la licencon",
      "WOT_DIVIDER": "Reto de fido"
    },
    "LICENSE": {
      "TITLE": "Licenco de la mono",
      "BTN_DOWNLOAD": "Elŝuti la dosieron",
      "NO_LICENSE_FILE": "Dosiero pri licenco ne trovita."
    }
  },
  "NETWORK": {
    "VIEW": {
      "MEDIAN_TIME": "Horo de la blokĉeno",
      "LOADING_PEERS": "Nodoj ŝarĝiĝantaj...",
      "NODE_ADDRESS": "Adreso:",
      "SOFTWARE": "Programo",
      "WARN_PRE_RELEASE": "Antaŭ-versio (lasta stabila versio: <b>{{version}}</b>)",
      "WARN_NEW_RELEASE": "Versio <b>{{version}}</b> disponebla",
      "WS2PID": "Identigilo:",
      "PRIVATE_ACCESS": "Privata aliro",
      "POW_PREFIX": "Prefikso pri labor-pruvo:",
      "ENDPOINTS": {
        "BMAS": "Sekurigita interfaco (SSL)",
        "BMATOR": "Reta interfaco TOR",
        "WS2P": "Interfaco WS2P",
        "ES_USER_API": "Nodo de datenoj Cesium+"
      }
    },
    "INFO": {
      "CONNECTING_TO_NETWORK": "Konektiĝo al la reto...",
      "ANALYZING_NETWORK": "Analizo de la {{currency|abbreviate}} reto...",
      "ONLY_SSL_PEERS": "La nodoj ne-SSL estas mis-afiŝitaj, ĉar Cesium funkcias laŭ moduso HTTPS."
    }
  },
  "PEER": {
    "PEERS": "Nodoj",
    "SIGNED_ON_BLOCK": "Skribita en la bloko",
    "MIRROR": "spegulo",
    "MIRRORS": "Speguloj",
    "MIRROR_PEERS": "Spegul-nodoj",
    "PEER_LIST" : "Listo de la nodoj",
    "MEMBERS" : "Membroj",
    "MEMBER_PEERS" : "Membro-nodoj",
    "ALL_PEERS" : "Ĉiuj nodoj",
    "DIFFICULTY" : "Malfacileco",
    "API" : "API",
    "CURRENT_BLOCK" : "Bloko #",
    "POPOVER_FILTER_TITLE": "Filtrilo",
    "OFFLINE": "Nekonektita",
    "OFFLINE_PEERS": "Nekonektitaj nodoj",
    "BTN_SHOW_PEER": "Vidi la nodon",
    "VIEW": {
      "TITLE": "Nodo",
      "OWNER": "Apartenas al",
      "SHOW_RAW_PEERING": "Vidi la samrangan dokumenton",
      "SHOW_RAW_CURRENT_BLOCK": "Vidi la lastan blokon (kompleta strukturo)",
      "LAST_BLOCKS": "Lastaj blokoj konataj",
      "KNOWN_PEERS": "Konataj nodoj:",
      "GENERAL_DIVIDER": "Ĝeneralaj informoj",
      "ERROR": {
        "LOADING_TOR_NODE_ERROR": "Neeblas ricevi la informojn de la nodo. La limdaŭro de atendado estas transpasita.",
        "LOADING_NODE_ERROR": "Neeblas ricevi la informojn de la nodo"
      }
    }
  },
  "WOT": {
    "SEARCH_HELP": "Traserĉado (pseŭdo aŭ publika ŝlosilo)",
    "SEARCH_INIT_PHASE_WARNING": "Dum la periodo de antaŭ-aliĝo, la traserĉado de la atendantaj aliĝoj <b>povas esti longa</b>. Bonvolu pacienci...",
    "REGISTERED_SINCE": "Enskribita la",
    "REGISTERED_SINCE_BLOCK": "Enskribita en la bloko #",
    "NO_CERTIFICATION": "Neniu atestaĵo validigita",
    "NO_GIVEN_CERTIFICATION": "Neniu atestaĵo sendita",
    "NOT_MEMBER_PARENTHESIS": "(ne membro)",
    "IDENTITY_REVOKED_PARENTHESIS": "(identeco nuligita)",
    "MEMBER_PENDING_REVOCATION_PARENTHESIS": "(nuliĝanta)",
    "EXPIRE_IN": "Finiĝo",
    "NOT_WRITTEN_EXPIRE_IN": "Limdato<br/>de traktado",
    "EXPIRED": "Finiĝinta",
    "PSEUDO": "Pseŭdonimo",
    "SIGNED_ON_BLOCK": "Sendita en la bloko #{{block}}",
    "WRITTEN_ON_BLOCK": "Enskribita en la bloko #{{block}}",
    "GENERAL_DIVIDER": "Ĝeneralaj informoj",
    "NOT_MEMBER_ACCOUNT": "Simpla konto (ne membro)",
    "NOT_MEMBER_ACCOUNT_HELP": "Temas pri simpla monujo, sen aliĝ-peto atendanta.",
    "TECHNICAL_DIVIDER": "Teknikaj informoj",
    "BTN_CERTIFY": "Atesti",
    "BTN_YES_CERTIFY": "Jes, atesti",
    "BTN_SELECT_AND_CERTIFY": "Nova atestaĵo",
    "ACCOUNT_OPERATIONS": "Spezoj en la konto",
    "VIEW": {
      "POPOVER_SHARE_TITLE": "Identeco {{title}}"
    },
    "LOOKUP": {
      "TITLE": "Reto de fido",
      "NEWCOMERS": "Novaj membroj",
      "NEWCOMERS_COUNT": "{{count}} membroj",
      "PENDING": "Atendantaj enskribiĝoj",
      "PENDING_COUNT": "{{count}} atendantaj enskribiĝoj",
      "REGISTERED": "Enskribita {{sigDate | formatFromNow}}",
      "MEMBER_FROM": "Membro depost {{memberDate|medianFromNowShort}}",
      "BTN_NEWCOMERS": "Novaj membroj",
      "BTN_PENDING": "Atendantaj enskribiĝoj",
      "SHOW_MORE": "Afiŝi pli",
      "SHOW_MORE_COUNT": "(nuna limo je {{limit}})",
      "NO_PENDING": "Neniu enskribiĝo atendanta.",
      "NO_NEWCOMERS": "Neniu membro."
    },
    "CONTACTS": {
      "TITLE": "Kontaktoj"
    },
    "MODAL": {
      "TITLE": "Traserĉado"
    },
    "CERTIFICATIONS": {
      "TITLE": "{{uid}} - Atestaĵoj",
      "SUMMARY": "Ricevitaj atestaĵoj",
      "LIST": "Detalo pri la ricevitaj atestaĵoj",
      "PENDING_LIST": "Atestaĵoj atendantaj traktadon",
      "RECEIVED": "Ricevitaj atestaĵoj",
      "RECEIVED_BY": "Atestaĵoj ricevitaj de {{uid}}",
      "ERROR": "Atestaĵoj erare ricevitaj",
      "SENTRY_MEMBER": "Referenca membro"
    },
    "OPERATIONS": {
      "TITLE": "{{uid}} - Spezoj"
    },
    "GIVEN_CERTIFICATIONS": {
      "TITLE": "{{uid}} - Senditaj atestaĵoj",
      "SUMMARY": "Senditaj atestaĵoj",
      "LIST": "Detalo pri la senditaj atestaĵoj",
      "PENDING_LIST": "Atestaĵoj atendantaj traktadon",
      "SENT": "Senditaj atestaĵoj",
      "SENT_BY": "Atestaĵoj senditaj de {{uid}}",
      "ERROR": "Atestaĵoj erare senditaj"
    }
  },
  "LOGIN": {
    "TITLE": "<i class=\"icon ion-log-in\"></i> Konektiĝo",
    "SCRYPT_FORM_HELP": "Bonvolu tajpi viajn identigilojn.<br>Pensu kontroli, ke la publika ŝlosilo estas tiu de via konto.",
    "PUBKEY_FORM_HELP": "Bonvolu tajpi publikan ŝlosilon de konto:",
    "FILE_FORM_HELP": "Elektu la ŝlosilaro-dosieron uzotan:",
    "SCAN_FORM_HELP": "Skani la QR-kodon de monujo.",
    "SALT": "Sekreta identigilo",
    "SALT_HELP": "Sekreta identigilo",
    "SHOW_SALT": "Afiŝi la sekretan identigilon?",
    "PASSWORD": "Pasvorto",
    "PASSWORD_HELP": "Pasvorto",
    "PUBKEY_HELP": "Publika ŝlosilo aŭ pseŭdonimo",
    "NO_ACCOUNT_QUESTION": "Vi ankoraŭ ne havas konton?",
    "HAVE_ACCOUNT_QUESTION": "Vi jam havas konton?",
    "CREATE_ACCOUNT": "Krei konton...",
    "CREATE_FREE_ACCOUNT": "Krei konton senpage",
    "FORGOTTEN_ID": "Pasvorto forgesita?",
    "ASSOCIATED_PUBKEY": "Publika ŝlosilo de la ŝlosilaro:",
    "BTN_METHODS": "Aliaj metodoj",
    "BTN_METHODS_DOTS": "Ŝanĝi metodon...",
    "METHOD_POPOVER_TITLE": "Metodoj",
    "MEMORIZE_AUTH_FILE": "Memorigi tiun ŝlosilaron por la daŭro de la retum-seanco",
    "SCRYPT_PARAMETERS": "Parametroj (Skripto):",
    "AUTO_LOGOUT": {
      "TITLE": "Informo",
      "MESSAGE": "<i class=\"ion-android-time\"></i> Vi estis <b>malkonektita</b> aŭtomate, pro tro longa senaktiveco.",
      "BTN_RELOGIN": "Rekonektiĝi",
      "IDLE_WARNING": "Vi estos malkonektita... {{countdown}}"
    },
    "METHOD": {
      "SCRYPT_DEFAULT": "Sekreta identigilo kaj pasvorto",
      "SCRYPT_ADVANCED": "Sperta salumado",
      "FILE": "Dosiero pri ŝlosilaro",
      "PUBKEY": "Publika ŝlosilo aŭ pseŭdonimo",
      "SCAN": "Skani QR-kodon"
    },
    "SCRYPT": {
      "SIMPLE": "Malpeza salumado",
      "DEFAULT": "Kutima salumado",
      "SECURE": "Sekura salumado",
      "HARDEST": "Plej sekura salumado",
      "EXTREME": "Ekstrema salumado",
      "USER": "Personigita salumado",
      "N": "N (Loop):",
      "r": "r (RAM):",
      "p": "p (CPU):"
    },
    "FILE": {
      "HELP": "Atendita strukturo de dosiero: <b>.yml</b> aŭ <b>.dunikey</b> (tipo PubSec, WIF aŭ EWIF)."
    }
  },
  "AUTH": {
    "TITLE": "<i class=\"icon ion-locked\"></i> Aŭtentigado",
    "BTN_AUTH": "Aŭtentiĝi",
    "GENERAL_HELP": "Bonvolu aŭtentiĝi:",
    "EXPECTED_UID_HELP": "Bonvolu aŭtentiĝi ĉe la konto <i class=\"ion-person\"></i> {{uid}} :",
    "EXPECTED_PUBKEY_HELP": "Bonvolu aŭtentiĝi ĉe la monujo <br class=\"visible-xs\"/><i class=\"ion-key\"></i> {{pubkey|formatPubkey}} :",
    "SCAN_FORM_HELP": "Skani la QR-kodon de la <b>privata ŝlosilo</b> de la monujo."
  },
  "ACCOUNT": {
    "TITLE": "Mia konto",
    "BALANCE": "Saldo",
    "LAST_TX": "Lastaj spezoj validigitaj",
    "BALANCE_ACCOUNT": "Konto-saldo",
    "NO_TX": "Neniu spezo",
    "SHOW_MORE_TX": "Afiŝi pli",
    "SHOW_ALL_TX": "Afiŝi ĉion",
    "TX_FROM_DATE": "(nuna limo je {{fromTime|medianFromNowShort}})",
    "PENDING_TX": "Spezoj atendantaj traktadon",
    "VALIDATING_TX": "Spezoj traktitaj, ne validigitaj",
    "ERROR_TX": "Spezoj ne realigitaj",
    "ERROR_TX_SENT": "Spezoj malsukcesintaj",
    "PENDING_TX_RECEIVED": "Spezoj atendantaj ricevon",
    "EVENTS": "Okazaĵoj",
    "OUT_DISTANCED": "Viaj nunaj atestaĵoj venas de tro izolita grupo de la <a ng-click=\"showHelpModal('wot')\">Reto de Fido</a> (RdF): al la <a ng-click=\"showHelpModal('distance_rule')\">regulo de maksimuma distanco</a> vi ne konformiĝas.<br/>Vi devas akiri atestaĵojn venantajn de aliaj lokoj de la RdF, aŭ atendi ke tiu ĉi densiĝos.",
    "WAITING_MEMBERSHIP": "Aliĝo-peto sendita. Atendanta akcepton.",
    "WAITING_CERTIFICATIONS": "Vi devas <b>akiri {{needCertificationCount}} atestaĵo(j)n</b> por fariĝi membro kaj produkti la <a ng-click=\"showHelpModal('ud')\">Universalan Dividendon</a>. Via konto tamen estas jam funkcianta, por ricevi kaj efektivigi pagojn.",
    "WAITING_CERTIFICATIONS_HELP": "Por akiri viajn atestaĵojn, petu nur membrojn <b>kiuj sufiĉe konas vin</b>, kiel postulas <a ng-click=\"showLicenseModal()\">la licenco de la mono</a>, kiun vi akceptis.<br/>Se vi ne konas sufiĉe da membroj, sciigu tion ĉe <a ng-click=\"openLink($event, $root.settings.userForumUrl)\">la forumo por uzantoj</a>.",
    "WILL_MISSING_CERTIFICATIONS": "Baldaŭ <b>mankos al vi atestaĵoj</b> (almenaŭ {{willNeedCertificationCount}} estas necesaj)",
    "WILL_NEED_RENEW_MEMBERSHIP": "Via aliĝo kiel membro <b>estas finiĝonta {{membershipExpiresIn|formatDurationTo}}</b>. Pensu <a ng-click=\"doQuickFix('renew')\">revalidigi vian aliĝon</a> ĝis tiam.",
    "NEED_RENEW_MEMBERSHIP": "Vi ne plu estas membro de la mono, ĉar <b>via aliĝo finiĝis</b>. Pensu <a ng-click=\"doQuickFix('renew')\">revalidigi vian aliĝon</a>.",
    "NEED_RENEW_MEMBERSHIP_AFTER_CANCELLED": "Vi ne plu estas membro de la mono, <b>pro manko da atestaĵoj</b>. Pensu <a ng-click=\"doQuickFix('renew')\">revalidigi vian aliĝon</a>.",
    "NO_WAITING_MEMBERSHIP": "Neniu aliĝo-peto atendanta. Se vi deziras <b>fariĝi membro</b>, pensu <a ng-click=\"doQuickFix('membership')\">sendi la aliĝo-peton</a>.",
    "CERTIFICATION_COUNT": "Ricevitaj atestaĵoj",
    "CERTIFICATION_COUNT_SHORT": "Atestaĵoj",
    "SIG_STOCK": "Senditaj atestaĵoj",
    "BTN_RECEIVE_MONEY": "Enkasigi",
    "BTN_SELECT_ALTERNATIVES_IDENTITIES": "Aliri alian identecon...",
    "BTN_FIX_MEMBERSHIP": "Resendi la aliĝo-peton...",
    "BTN_MEMBERSHIP_RENEW": "Revalidigi la aliĝon",
    "BTN_MEMBERSHIP_RENEW_DOTS": "Revalidigi la aliĝon...",
    "BTN_MEMBERSHIP_OUT_DOTS": "Ĉesigi la aliĝon...",
    "BTN_SECURITY_DOTS": "Konto kaj sekureco...",
    "BTN_SHOW_DETAILS": "Afiŝi la teknikajn informojn",
    "LOCKED_OUTPUTS_POPOVER": {
      "TITLE": "Sumo blokita",
      "DESCRIPTION": "Jen la kondiĉoj de malblokado de tiu sumo:",
      "DESCRIPTION_MANY": "Tiu spezo entenas plurajn partojn, pri kiuj la kondiĉoj de malblokado estas:",
      "LOCKED_AMOUNT": "Kondiĉoj por la sumo:"
    },
    "NEW": {
      "TITLE": "Kreado de konto",
      "INTRO_WARNING_TIME": "La kreado de konto ĉe {{name|capitalize}} estas tre simpla. Bonvolu tamen dediĉi sufiĉe da tempo por ĝuste efektivigi tiun proceduron (por ne forgesi la identigilojn, pasvortojn, ktp.).",
      "INTRO_WARNING_SECURITY": "Kontrolu ke la aparatoj, kiujn vi nun uzas (komputilo, tabuleto, telefono), <b>estas sekurigitaj kaj fidindaj</b>.",
      "INTRO_WARNING_SECURITY_HELP": "Senvirusigilo ĝisdata, fajroŝirmilo aktivigita, seanco protektita per pasvorto aŭ PIN-kodo, ktp.",
      "INTRO_HELP": "Alklaku <b>{{'COMMON.BTN_START'|translate}}</b> por ekigi la kreadon de konto. Vi estos gvidata paŝon post paŝo.",
      "REGISTRATION_NODE": "Via aliĝo estos registrita tra la nodo Duniter <b>{{server}}</b>, kiu dissendos ĝin poste al la cetero de la mon-reto.",
      "REGISTRATION_NODE_HELP": "Se vi ne fidas tiun nodon, bonvolu ŝanĝi ĝin <a ng-click=\"doQuickFix('settings')\">en la parametroj</a> de Cesium.",
      "SELECT_ACCOUNT_TYPE": "Elektu la tipon de konto kreota:",
      "MEMBER_ACCOUNT": "Membro-konto",
      "MEMBER_ACCOUNT_TITLE": "Kreado de membro-konto",
      "MEMBER_ACCOUNT_HELP": "Se vi ankoraŭ ne enskribiĝis kiel individuo (nur unu konto eblas por unu individuo). Tia konto ebligas kunprodukti la monon, ricevante <b> universalan dividendon</b> ĉiun {{parameters.dt|formatPeriod}}n.",
      "WALLET_ACCOUNT": "Simpla monujo",
      "WALLET_ACCOUNT_TITLE": "Kreado de monujo",
      "WALLET_ACCOUNT_HELP": "Por ĉiuj aliaj kazoj, ekzemple se vi bezonas plian konton.<br/>Neniu universala dividendo estos kreita per tia konto.",
      "SALT_WARNING": "Elektu vian sekretan identigilon.<br/>Oni petos ĝin de vi ĉiufoje, kiam vi konektiĝos al tiu konto.<br/><br/><b>Bone memorigu ĝin</b>: kaze de perdo, neniu alia povos aliri vian konton!",
      "PASSWORD_WARNING": "Elektu pasvorton.<br/>Oni petos ĝin de vi ĉiufoje, kiam vi konektiĝos al tiu konto.<br/><br/><b>Bone memorigu tiun pasvorton</b: kaze de perdo, neniu alia povos aliri vian konton!",
      "PSEUDO_WARNING": "Elektu pseŭdonimon.<br/>Ĝi utilas al la aliaj membroj, por identigi vin pli facile.<div class='hidden-xs'><br/>Ĝi <b>ne povos esti modifita</b>, sen rekrei konton.</div><br/><br/>Ĝi entenu <b>nek spacon, nek diakritan literon (kun supersigno, ktp.)</b>.<div class='hidden-xs'><br/>Ekzemple: <span class='gray'>NataljaBelulino, JohanoStelaro, ktp.</span>",
      "PSEUDO": "Pseŭdonimo",
      "PSEUDO_HELP": "Pseŭdonimo",
      "SALT_CONFIRM": "Konfirmo",
      "SALT_CONFIRM_HELP": "Konfirmo de la sekreta identigilo",
      "PASSWORD_CONFIRM": "Konfirmo",
      "PASSWORD_CONFIRM_HELP": "Konfirmo de la pasvorto",
      "SLIDE_6_TITLE": "Konfirmo:",
      "COMPUTING_PUBKEY": "Kalkulanta...",
      "LAST_SLIDE_CONGRATULATION": "Vi tajpis ĉiujn necesajn informojn: Gratulon!<br/>Vi nun povas <b>sendi la peton por kreado</b> de la konto.</b><br/><br/>Por informo, la publika ŝlosilo ĉi-sube identigos vian estontan konton.<br/>Ĝi povos estis sciigita al aliuloj por ricevi iliajn pagojn.<br/><b>Ne estas devige</b> noti ĝin nun, vi ankaŭ povos fari tion poste.",
      "CONFIRMATION_MEMBER_ACCOUNT": "<b class=\"assertive\">Averto:</b> la sekreta identigilo, la pasvorto kaj la pseŭdonimo ne plu povos esti modifitaj.<br/><br/><b>Certiĝu, ke vi ĉiam rememorigos ĝin!</b><br/><br/><b>Ĉu vi certas</b>, ke vi deziras sendi tiun ĉi aliĝo-peton?",
      "CONFIRMATION_WALLET_ACCOUNT": "<b class=\"assertive\">Averto:</b> la sekreta identigilo kaj la pasvorto ne plu povos esti modifitaj.<br/><br/><b>Certiĝu, ke vi ĉiam rememorigos ĝin!</b><br/><br/><b>Ĉu vi certas</b>, ke vi deziras daŭrigi per tiuj ĉi identigiloj?",
      "CHECKING_PSEUDO": "Kontrolo...",
      "PSEUDO_AVAILABLE": "Pseŭdonimo disponebla",
      "PSEUDO_NOT_AVAILABLE": "Pseŭdonimo ne disponebla",
      "INFO_LICENSE": "Antaŭ ol krei membro-konton, <b>bonvolu legi kaj akcepti la licencon</b> pri uzado de la mono:",
      "BTN_ACCEPT": "Mi akceptas",
      "BTN_ACCEPT_LICENSE": "Mi akceptas la licencon"
    },
    "POPUP_REGISTER": {
      "TITLE": "Elektu pseŭdonimon",
      "HELP": "Pseŭdonimo estas deviga por fariĝi membro."
    },
    "SELECT_IDENTITY_MODAL": {
      "TITLE": "Elekto de la identeco",
      "HELP": "Pluraj <b>malsamaj identecoj</b> estis senditaj, por la publika ŝlosilo <span class=\"gray\"><i class=\"ion-key\"></i> {{pubkey|formatPubkey}}</span>.<br/>Bonvolu elekti la dosierujon uzotan:"
    },
    "SELECT_WALLET_MODAL": {
      "TITLE": "Elekto de la monujo"
    },
    "CERTIFICATION_MODAL": {
      "CHECKLIST_TITLE": "Kontrolisto antaŭ atesto",
      "INFOS": "La sekureco de la monero Ğ1 dependas de ĉiu membro. Antaŭ atesti la identon de tiu ĉi persono, vi devus fari kelkajn kontroladetojn. Bonvolu respondi la jenajn demandojn:",
      "BTN_ALL_CHECK": "Atesti",
      "CHECKLIST_CONDITIONS_NOT_MET": "La atesto ne estis sendita. La kontrolado ŝajnas nesufiĉa. Bonvolu rekontroli ĉiun punkton kun la persono, kiun vi volas atesti.",
      "QUESTIONS": {
        "WELL_KNOWN": "<b>Ĉu vi bone konas</b> la personon, kiun vi volas atesti, kaj ĉu vi konas aliajn homojn, kiuj ankaŭ bone konas tiun personon?",
        "REVOCATION": "Ĉu tiu ĉi persono elŝutis sian <b>malkonfirmadon dokumenton</b> kaj ĉu ŝi scias, kie trovi ĝin?",
        "CONTACT": "Ĉu vi <b>kontaktis</b> kun tiu ĉi persono per diversaj metodoj, kaj ĉu ŝi respondis?",
        "DOUBLE_IDENTITY": "La persono devus havi <b>nur unu aktivan membro-identon</b>. Ĉu vi pensas, ke ŝi posedas alian?",
        "MASTER_ACCOUNT": "Ĉu tiu ĉi persono posedas siajn kontosekretojn? Ĉu ŝi jam <b>sendis monon de sia konto</b> almenaŭ unufoje?",
        "LICENSE": "Ĉu tiu ĉi persono <b>komprenis la permesilon</b> de Duniter, kaj ĉu ŝi konsentas konformiĝi al ĝi por estontaj atestoj?",
        "CREDENTIALS": "Ĉu la konto estis kreita kun <b>longa kaj kompleksa identigilo/pasvorto</b> (ekz. pasfrazoj)? Ĉu la persono komprenis, ke ambaŭ la identigilo kaj la pasvorto devas resti sekretaj? Ĉu ŝi estas <b>certa, ke ŝi memoros ilin</b> aŭ povos retrovi ilin?",
        "PUBLIC_KEY_DIFFERENT": "La montrata <b>publika ŝlosilo</b> devas esti <b>identa</b> al tiu, kiun la persono donis al vi. Ĉu la publika ŝlosiloj estas <b>malsamaj</b>?"
      },
      "REMINDER_TITLE": "Memorigo",
      "SHORT_LICENSE_REMINDER": "Vi povas rememorigi al la atestota persono diversajn parametrojn pri atestoj:<br/><br/><ul><li> - Ĉiu membro povas atesti maksimume 100 aliajn identecojn.</li><li> - La atestoj estas konservataj kun intervolo de 5 tagoj.</li><li> - Nova membro devas kolekti minimume 5 atestojn en malpli ol 2 monatoj.</li><li> - Membro devas renovigi sian membrecon minimume unufoje jare.</li><li> - Atestoj estas validaj dum du jaroj.</li></ul>"
    },
    "WALLET_LIST": {
      "TITLE": "Miaj monujoj",
      "BTN_NEW": "Aldoni monujon",
      "BTN_DOWNLOAD": "Elŝuti la liston",
      "BTN_IMPORT_FILE_DOTS": "Enporti el dosiero...",
      "NO_WALLET": "Neniu kroma monujo",
      "BTN_DELETE": "Forigi kroman monujon...",
      "BTN_RENAME": "Renomi la monujon",
      "EXPORT_FILENAME": "miaj_monujoj-{{pubkey|formatPubkey}}-{{currency}}.csv",
      "TOTAL_DOTS": "Sumo: ",
      "EDIT_POPOVER": {
        "TITLE": "Renomi la monujon",
        "HELP": "Sciigu la novan nomon",
        "NAME_HELP": "Nomo de la monujo"
      },
      "IMPORT_MODAL": {
        "TITLE": "Enporti monujojn",
        "HELP": "Por <b>enporti monujojn</b>, bonvolu glitigi en la ĉi-suban zonon la dosieron pri la listo de monujoj, aŭ alklaki la zonon por serĉadi dosieron.",
        "WALLET_COUNT": "<b>{{count}}</b> nova{{count > 1 ? 'j' : ''}} monujo{{count > 1 ? 'j' : ''}}",
        "NO_NEW_WALLET": "Neniu nova monujo"
      }
    },
    "SECURITY": {
      "ADD_QUESTION": "Aldoni personigitan demandon",
      "BTN_CLEAN": "Malplenigi",
      "BTN_RESET": "Restartigi",
      "DOWNLOAD_REVOKE": "Konservi mian dosieron pri nuligo",
      "DOWNLOAD_REVOKE_HELP": "Disponi dosieron pri nuligo estas grave, ekzemple kaze de perdo de viaj identigiloj. Ĝi ebligas al vi <b>elirigi tiun konton el la reto de fido</b>, tiel ke ĝi refariĝu simpla monujo.",
      "GENERATE_KEYFILE": "Krei mian dosieron pri ŝlosilaro...",
      "GENERATE_KEYFILE_HELP": "Kreas dosieron, kiu ebligas al vi aŭtentiĝi sen tajpi viajn identigilojn.<br/><b>Atenton:</b> tiu dosiero entenos vian konto-ŝlosilaron (publikan kaj sekretan ŝlosilojn); do tre gravas meti ĝin en sekuran lokon!",
      "KEYFILE_FILENAME": "ŝlosilaro-{{pubkey|formatPubkey}}-{{currency}}-{{format}}.dunikey",
      "MEMBERSHIP_IN": "Transformi en membro-konton...",
      "MEMBERSHIP_IN_HELP": "Ebligas <b>transformi</b> simplan monujo-konton <b>en membro-konton</b>, sendante aliĝo-peton. Utilas nur se vi ne havas jam alian membro-konton.",
      "SEND_IDENTITY": "Publikigi sian identecon...",
      "SEND_IDENTITY_HELP": "Ebligas kunligi pseŭdonimon kun tiu ĉi konto, sed <b>sen fari aliĝo-peton</b> por iĝi membro. Tiu kunligo kutime ne utilas, ĉar la valideco de tiu kunligo de pseŭdonimo estas limigita en la tempo.",
      "HELP_LEVEL": "Por krei konserv-dosieron pri viaj identigiloj, elektu <strong> almenaŭ {{nb}} demandojn:</strong>",
      "LEVEL": "Nivelo de sekureco",
      "LOW_LEVEL": "Malforta <span class=\"hidden-xs\">(2 demandoj minimume)</span>",
      "MEDIUM_LEVEL": "Meza <span class=\"hidden-xs\">(4 demandoj minimume)</span>",
      "QUESTION_1": "Kiel nomiĝis via plej bona amik.in.o, kiam vi estis adoleskant.in.o?",
      "QUESTION_2": "Kiel nomiĝis via unua hejm-besto?",
      "QUESTION_3": "Kiun pladon vi unue lernis kuiradi?",
      "QUESTION_4": "Kiun filmon vi unue spektis en kinejo?",
      "QUESTION_5": "Kien vi iris la unuan fojon, kiam vi vojaĝis per aviadilo?",
      "QUESTION_6": "Kiel nomiĝis via preferata instruist.i.no en bazlernejo?",
      "QUESTION_7": "Kio estus laŭ vi la ideala profesio?",
      "QUESTION_8": "Kiun libron por infanoj vi preferas?",
      "QUESTION_9": "Kio estis la marko de via unua veturilo?",
      "QUESTION_10": "Kio estis via kromnomo, kiam vi estis infano?",
      "QUESTION_11": "Kiun rolant.in.on aŭ aktor.in.on vi preferis en kino, kiam vi estis student.in.o?",
      "QUESTION_12": "Kiun kanzonist.ino.n aŭ muzikgrupon vi preferis, kiam vi estis student.in.o?",
      "QUESTION_13": "En kiu urbo renkontiĝis viaj gepatroj?",
      "QUESTION_14": "Kiel nomiĝis via unua ĉefo?",
      "QUESTION_15": "Kiel nomiĝas la strato, kie vi kreskis?",
      "QUESTION_16": "Kiel nomiĝas la marbordo, kie vi unuafoje baniĝis?",
      "QUESTION_17": "Kiun muzik-albumon vi unuafoje aĉetis?",
      "QUESTION_18": "Kiel nomiĝas via preferata sporto-teamo?",
      "QUESTION_19": "Kio estis la profesio de via avo?",
      "RECOVER_ID": "Retrovi mian pasvorton...",
      "RECOVER_ID_HELP": "Se vi disponas <b>konserv-dosieron pri viaj identigiloj</b>, vi povas retrovi ilin respondante ĝuste viajn personajn demandojn.",
      "RECOVER_ID_SELECT_FILE": "Elektu la uzotan <b>konserv-dosieron pri viaj identigiloj</b>:",
      "REVOCATION_WITH_FILE": "Nuligi mian membro-konton...",
      "REVOCATION_WITH_FILE_DESCRIPTION": "Se vi <b>definitive perdis viajn identigilojn</b> pri via membro-konto (aŭ ke la sekureco de la konto estas endanĝerigita), vi povas uzi <b>la dosieron pri nuligo</b> de la konto por <b>trudi ties definitivan eliradon el la reto de fido</b>.",
      "REVOCATION_WITH_FILE_HELP": "Por <b>definitive nuligi</b> membro-konton, bonvolu glitigi en la ĉi-suban zonon vian dosieron pri nuligo, aŭ alklaki la zonon por serĉadi dosieron.",
      "REVOCATION_WALLET": "Nuligi tiun ĉi konton tuj",
      "REVOCATION_WALLET_HELP": "Peti la nuligon de via identeco estigas la <b>eliradon el la reto de fido</b> (definitivan por la pseŭdonimo kaj la publika ŝlosilo kunligitaj). La konto ne plu povos produkti Universalan Dividendon.<br/>Vi tamen daŭre povos konektiĝi al ĝi, kiel al simpla monujo.",
      "REVOCATION_FILENAME": "nuligo-{{uid}}-{{pubkey|formatPubkey}}-{{currency}}.txt",
      "SAVE_ID": "Konservi miajn identigilojn...",
      "SAVE_ID_HELP": "Kreado de konserv-dosiero, por <b>retrovi vian pasvorton</b> (kaj la sekretan identigilon) <b>kaze de forgeso</b>. La dosiero estas <b>sekurigita</b> (ĉifrita) dank'al personaj demandoj.",
      "STRONG_LEVEL": "Forta <span class=\"hidden-xs \">(6 demandoj minimume)</span>",
      "TITLE": "Konto kaj sekureco",
      "KEYFILE": {
        "PUBSEC_FORMAT": "Strukturo PubSec.",
        "PUBSEC_FORMAT_HELP": "Tiu strukturo stokas vian ŝlosilaron laŭ tre simpla maniero. Ĝi kongruas aparte kun Cesium, ğannonce kaj Duniter.<br/><b>Atenton:</b>La dosiero <b>ne estas ĉifrita</b> (la sekreta ŝlosilo klare aperas en ĝi); bonvolu do stoki ĝin en sekura loko!",
        "WIF_FORMAT": "Strukturo WIF (Wallet Import Format) - v1",
        "WIF_FORMAT_HELP": "Tiu strukturo stokas vian ŝlosilaron inkluzivante en ĝin kontrol-sumon por kontroli la sendifektecon de la dosiero. Ĝi kongruas aparte kun la paper-monujoj (Duniter paper wallet).<br/><b>Atenton:</b>La dosiero <b>ne estas ĉifrita</b> (la sekreta ŝlosilo klare aperas en ĝi); bonvolu do stoki ĝin en sekura loko!",
        "EWIF_FORMAT": "Strukturo EWIF (Encrypted Wallet Import Format) - v1",
        "EWIF_FORMAT_HELP": "Tiu strukturo stokas vian ŝlosilaron <b>laŭ ĉifrita maniero</b> dank'al sekreta frazo elektita de vi. Ĝi ankaŭ inkluzivas kontrol-sumon por kontroli la sendifektecon de la dosiero.<br/><b>Atenton:</b> Zorgu, ke vi ĉiam rememoru vian sekretan frazon!",
	      "PASSWORD_POPUP": {
          "TITLE": "Ĉifrita dosiero pri ŝlosilaro",
          "HELP": "Bonvolu indiki la la sekretan frazon:",
          "PASSWORD_HELP": "Sekreta frazo"
        },
        "ERROR": {
          "BAD_PASSWORD": "Sekreta frazo malĝusta",
          "BAD_CHECKSUM": "Kontrol-sumo malĝusta"
        }
      }
    },
    "FILE_NAME": "{{currency}} - Konto-tabelo {{pubkey|formatPubkey}} je {{currentTime|formatDateForFile}}.csv",
    "HEADERS": {
      "TIME": "Dato",
      "AMOUNT": "Sumo",
      "COMMENT": "Komento"
    }
  },
  "TRANSFER": {
    "TITLE": "Elspezo",
    "SUB_TITLE": "Fari elspezon",
    "SUB_TITLE_ALL": "Malplenigi la konton",
    "FROM": "De",
    "TO": "Al",
    "AMOUNT": "Sumo",
    "AMOUNT_HELP": "Sumo",
    "COMMENT": "Komento",
    "COMMENT_HELP": "Komento",
    "BTN_SEND": "Sendi",
    "BTN_ADD_COMMENT": "Aldoni komenton",
    "REST": "Resto de la konto",
    "REST_TO": "al",
    "WARN_COMMENT_IS_PUBLIC": "Bonvolu noti, ke <b>la komentoj estas publikaj</b> (ne ĉifritaj).",
    "MODAL": {
      "TITLE": "Elspezo"
    }
  },
  "ERROR": {
    "UNKNOWN_URI_FORMAT": "URI-strukturo nekonata",
    "PUBKEY_INVALID_CHECKSUM": "Publika ŝlosilo nevalida (bad checksum).",
    "POPUP_TITLE": "Eraro",
    "UNKNOWN_ERROR": "Eraro nekonata",
    "TIMEOUT_REACHED": "La atendo de la nodo superis la tempon ({{timeout|formatDurationMs}}).<br/><br/><small>{{url}}</small>",
    "CRYPTO_UNKNOWN_ERROR": "Via retumilo ŝajnas ne kongrua kun la kriptografiaj funkcioj.",
    "DOWNLOAD_KEYFILE_FAILED": "Malsukceso por la kreado de la dosiero pri ŝlosilaro.",
    "EQUALS_TO_PSEUDO": "Devas esti malsama ol la pseŭdonimo",
    "EQUALS_TO_SALT": "Devas esti malsama ol la sekreta identigilo",
    "FIELD_REQUIRED": "Deviga kampo",
    "FIELD_TOO_SHORT": "Signaro tro mallonga",
    "FIELD_TOO_SHORT_WITH_LENGTH": "Signaro tro mallonga ({{minLength}} signoj minimume)",
    "FIELD_TOO_LONG": "Signaro tro longa",
    "FIELD_TOO_LONG_WITH_LENGTH": "Signaro tro longa ({{maxLength}} signoj maksimume)",
    "FIELD_MIN": "Minimuma longeco: {{min}}",
    "FIELD_MAX": "Maksimuma longeco: {{max}}",
    "FIELD_ACCENT": "Diakritaj literoj kaj komoj ne permesataj",
    "FIELD_NOT_NUMBER": "Nombra valoro atendata",
    "FIELD_NOT_INT": "Entjera nombro atendata",
    "FIELD_NOT_EMAIL": "Retadreso nevalida",
    "PASSWORD_NOT_CONFIRMED": "Ne kongruas kun la pasvorto",
    "SALT_NOT_CONFIRMED": "Ne kongruas kun la sekreta identigilo",
    "SEND_IDENTITY_FAILED": "Aliĝo malsukcesa",
    "SEND_CERTIFICATION_FAILED": "Atestado malsukcesa",
    "NEED_MEMBER_ACCOUNT_TO_CERTIFY": "Vi ne povas efektivigi atestadon, ĉar via konto <b>ne estas membro</b>.",
    "NEED_MEMBER_ACCOUNT_TO_CERTIFY_HAS_SELF": "Vi ne povas efektivigi atestadon, ĉar via konto ankoraŭ ne estas membro.<br/><br/>Ankoraŭ mankas al vi atestaĵoj, aŭ tiuj ĉi ankoraŭ ne estis validigitaj.",
    "IDENTITY_TO_CERTIFY_HAS_NO_SELF": "Konto ne atestebla. Neniu aliĝo-peto estis farita, aŭ la aliĝo ne estis revalidigita.",
    "LOGIN_FAILED": "Eraro dum konektiĝo.",
    "LOAD_IDENTITY_FAILED": "Eraro por ŝarĝi la identecon.",
    "LOAD_REQUIREMENTS_FAILED": "Eraro por ŝarĝi la antaŭ-necesaĵoj de la identeco.",
    "SEND_MEMBERSHIP_IN_FAILED": "Malsukceso pri la provado eniri la komunumon.",
    "SEND_MEMBERSHIP_OUT_FAILED": "Malsukceso pri la ĉesigo de la aliĝo.",
    "REFRESH_WALLET_DATA": "Malsukceso pri la ĝisdatigo de la monujo.",
    "GET_CURRENCY_PARAMETER": "Malsukceso por ricevi la regulojn de la mono.",
    "GET_CURRENCY_FAILED": "Ne eblis ŝarĝi la monon. Bonvolu reprovi pli poste.",
    "SEND_TX_FAILED": "Elspezado malsukcesa.",
    "ALL_SOURCES_USED": "Bonvolu atendi la kalkulon de la venonta bloko (ĉiuj viaj monfontoj estis uzitaj).",
    "NOT_ENOUGH_SOURCES": "Ne sufiĉe da mono por sendi tiun ĉi sumon per ununura spezo.<br/>Maksimuma sumo: {{amount}} {{unit}}<sub>{{subUnit}}</sub>.",
    "ACCOUNT_CREATION_FAILED": "Malsukceso por krei la membro-konton.",
    "RESTORE_WALLET_DATA_ERROR": "Malsukceso por reŝarĝi la parametrojn de la loka stokaĵo",
    "LOAD_WALLET_DATA_ERROR": "Malsukceso por ŝarĝi la datenojn de la monujo.",
    "COPY_CLIPBOARD_FAILED": "Ne eblis kopii la valoron.",
    "TAKE_PICTURE_FAILED": "Malsukceso por ricevi la foton.",
    "SCAN_FAILED": "Malsukceso por skani la QR-kodon.",
    "SCAN_UNKNOWN_FORMAT": "Kodo nerekonata.",
    "WOT_LOOKUP_FAILED": "Serĉado malsukcesa.",
    "LOAD_PEER_DATA_FAILED": "Ne eblis legi la nodon Duniter. Bonvolu reprovi poste.",
    "NEED_LOGIN_FIRST": "Bonvolu unue konektiĝi.",
    "AMOUNT_REQUIRED": "La monsumo estas deviga.",
    "AMOUNT_NEGATIVE": "Negativa sumo nepermesata.",
    "NOT_ENOUGH_CREDIT": "Saldo nesufiĉa.",
    "INVALID_NODE_SUMMARY": "Nodo neatingebla aŭ adreso nevalida.",
    "INVALID_USER_ID": "La pseŭdonimo devas enteni nek spacon nek signon specialan aŭ kun supersigno.",
    "INVALID_COMMENT": "La kampo 'referenco' ne devas enteni literojn kun supersigno.",
    "INVALID_PUBKEY": "La publika ŝlosilo ne havas la atenditan strukturon.",
    "INVALID_PUBKEY_CHECKSUM": "Kontrol-sumo nevalida.",
    "IDENTITY_REVOKED": "Tiu ĉi identeco <b>estis nuligita</b>. Ĝi ne plu povas fariĝi membro.",
    "IDENTITY_REVOKED_WITH_TIME": "Tiu ĉi identeco <b>estis nuligita {{revocationTime|medianFromNow}}</b> ({{revocationTime|medianDate}}). Ĝi ne plu povas fariĝi membro.",
    "IDENTITY_PENDING_REVOCATION": "La <b>nuligo de tiu ĉi identeco</b> estis petita kaj atendas traktadon. La atestado estas do malaktivigita.",
    "IDENTITY_INVALID_BLOCK_HASH": "Tiu ĉi aliĝo-peto ne plu validas (ĉar ĝi rilatas al bloko, kiun nuligis la nodoj de la reto): tiu persono devas refari sian aliĝo-peton <b>antaŭ ol</b> esti atestita.",
    "IDENTITY_EXPIRED": "La publikigo de tiu ĉi identeco finiĝis: tiu persono devas fari novan aliĝo-peton <b>antaŭ ol</b> esti atestita.",
    "IDENTITY_SANDBOX_FULL": "La nodo Duniter uzata de Cesium ne plu povas ricevi novajn identecojn, ĉar ĝia atendo-vico estas plena.<br/><br/>Bonvolu reprovi poste aŭ ŝanĝi la nodon (per la menuo <b>Parametroj</b>).",
    "IDENTITY_NOT_FOUND": "Identeco ne trovita.",
    "IDENTITY_TX_FAILED": "Malsukceso por ŝarĝi la spezojn.",
    "WOT_PENDING_INVALID_BLOCK_HASH": "Aliĝo ne valida.",
    "WALLET_INVALID_BLOCK_HASH": "Via aliĝo-peto ne plu validas (ĉar ĝi rilatas al bloko, kiun nuligis la nodoj de la reto).<br/>Vi devas <a ng-click=\"doQuickFix('fixMembership')\">sendi novan peton</a> por solvi tiun ĉi problemon.",
    "WALLET_IDENTITY_EXPIRED": "La publikigo de <b>via identeco finiĝis</b>.<br/>Vi devas <a ng-click=\"doQuickFix('fixIdentity')\">publikigi denove vian identecon</a> por solvi tiun ĉi problemon.",
    "WALLET_REVOKED": "Via identeco estis <b>nuligita</b>: nek via pseŭdonimo nek via publika ŝlosilo povos esti uzata en la estonteco por membro-konto.",
    "WALLET_HAS_NO_SELF": "Via identeco devas unue esti publikigita, kaj ne esti finiĝinta.",
    "AUTH_REQUIRED": "Aŭtentigado necesa.",
    "AUTH_INVALID_PUBKEY": "La atendata ŝlosilo estas <i class=\"ion-key\"></i> {{pubkey|formatPubkey}}...",
    "AUTH_INVALID_SCRYPT": "Identigilo aŭ pasvorto nevalida.",
    "AUTH_INVALID_FILE": "Dosiero pri ŝlosilaro nevalida.",
    "AUTH_FILE_ERROR": "Malsukceso por malfermi la dosieron pri ŝlosilaro.",
    "IDENTITY_ALREADY_CERTIFY": "Vi <b>jam atestis</b> tiun identecon.<br/><br/>Tiu atestado daŭre validas (finiĝo {{expiresIn|formatDurationTo}}).",
    "IDENTITY_ALREADY_CERTIFY_PENDING": "Vi <b>jam atestis</b> tiun identecon.<br/><br/>Tiu atestado atendas traktadon (limdato de traktado {{expiresIn|formatDurationTo}}).",
    "UNABLE_TO_CERTIFY_TITLE": "Atestado neebla",
    "LOAD_NEWCOMERS_FAILED": "Malsukceso por ŝarĝi la novajn membrojn.",
    "LOAD_PENDING_FAILED": "Malsukceso por ŝarĝi la atendantajn aliĝojn.",
    "ONLY_MEMBER_CAN_EXECUTE_THIS_ACTION": "Vi devas <b>esti membro</b> por rajti efektivigi tiun ĉi agon.",
    "ONLY_MEMBER_OR_WAS_MEMBER_CAN_EXECUTE_THIS_ACTION": "Vi devas <b>esti membro (aŭ eksa membro)</b> por rajti efektivigi tiun ĉi agon.",
    "ONLY_SELF_CAN_EXECUTE_THIS_ACTION": "Via identeco devas <b>jam esti publikigita</b>, por ke vi rajtu efektivigi tiun ĉi agon.",
    "GET_BLOCK_FAILED": "Malsukceso por ricevi la blokon.",
    "INVALID_BLOCK_HASH": "Bloko ne trovita (haketo malsama)",
    "DOWNLOAD_REVOCATION_FAILED": "Malsukceso por elŝuti la dosieron pri nuligo.",
    "REVOCATION_FAILED": "Malsukceso pri nuligo.",
    "SALT_OR_PASSWORD_NOT_CONFIRMED": "Sekreta identigilo aŭ pasvorto malĝusta.",
    "RECOVER_ID_FAILED": "Malsukceso por ricevi la identigilojn",
    "LOAD_FILE_FAILED" : "Malsukceso por ŝarĝi la dosieron",
    "NOT_VALID_REVOCATION_FILE": "Dosiero pri nuligo ne valida (malĝusta strukturo de dosiero)",
    "NOT_VALID_SAVE_ID_FILE": "Dosiero pri konservado ne valida (malĝusta strukturo de dosiero)",
    "NOT_VALID_KEY_FILE": "Dosiero pri ŝlosilaro ne valida (strukturo ne rekonata)",
    "EXISTING_ACCOUNT": "Viaj identigiloj rilatas al jam ekzistanta konto, kies <a ng-click=\"showHelpModal('pubkey')\">publika ŝlosilo</a> estas:",
    "EXISTING_ACCOUNT_REQUEST": "Bonvolu modifi viajn identigilojn, por ke ili rilatu al ne uzata konto.",
    "GET_LICENSE_FILE_FAILED": "La ricevo de la dosiero pri licenco ne eblis.",
    "CHECK_NETWORK_CONNECTION": "Neniu nodo ŝajnas atingebla.<br/><br/>Bonvolu <b>kontroli vian retkonekton</b>.",
    "ISSUE_524_TX_FAILED": "Malsukcesa elspezo.<br/><br/>Mesaĝo estis sendita al la programistoj por faciligi la solvadon de la problemo. <b>Dankon pro via helpo</b>.",
    "ADD_SECONDARY_WALLET_FAILED": "Malsukceso por aldoni kroman monujon.",
    "REMOVE_SECONDARY_WALLET_FAILED": "Malsukceso por forigi la kroman monujon.",
    "UPDATE_WALLET_LIST_FAILED": "Malsukceso por ĝisdatigi la kromajn monujojn.",
    "LOAD_WALLET_LIST_FAILED": "Malsukceso por ŝarĝi la kromajn monujojn.",
    "SAVE_WALLET_LIST_FAILED": "Malsukceso por konservi la kromajn monujojn.",
    "COULD_NOT_ADD_MAIN_WALLET": "Tiu ĉi monujo <b>rilatas al la ĉefa konto</b>, kun kiu vi estas konektita.<br/>Ne eblas aldoni ĝin kiel kroman monujon.",
    "COULD_NOT_ADD_EXISTING_WALLET": "Monujo jam ekzistanta en la listo.",
    "UNKNOWN_WALLET_ID": "Kroma monujo nekonata.",
    "RESTORE_WALLET_LIST_FAILED": "Malsukceso por restarigi la kromajn monujojn.",
    "INVALID_FILE_FORMAT": "Strukturo de dosiero nevalida.",
    "SAME_TX_RECIPIENT": "La adresito devas malsami ol la sendanto."
  },
  "INFO": {
    "POPUP_TITLE": "Informo",
    "CERTIFICATION_DONE": "Atestaĵo sendita",
    "NOT_ENOUGH_CREDIT": "Saldo nesufiĉa",
    "TRANSFER_SENT": "Elspezo sendita",
    "COPY_TO_CLIPBOARD_DONE": "Kopiita en la memoreto",
    "MEMBERSHIP_OUT_SENT": "Eksiĝo sendita",
    "NOT_NEED_MEMBERSHIP": "Vi jam estas membro.",
    "IDENTITY_WILL_MISSING_CERTIFICATIONS": "Al tiu ĉi identeco baldaŭ mankos atestaĵoj (almenaŭ {{willNeedCertificationCount}}).",
    "IDENTITY_NEED_MEMBERSHIP": "Tiu ĉi identeco ne sendis aliĝo-peton. Tion ĝi devos fari, se ĝi deziras fariĝi membro.",
    "HAS_ALTERNATIVE_IDENTITIES": "Ekzistas <b>pluraj identecoj</b> ligitaj kun tiu ĉi publika ŝlosilo. <b>Antaŭ ĉia atestado</b>, pensu <a ng-click=\"doQuickFix('showSelectIdentities')\">trarigardi la aliajn identecojn</a> por elekti la ĝustan, aŭ kontaktu la posedanton de la konto.",
    "REVOCATION_SENT": "Nuligo sendita",
    "REVOCATION_SENT_WAITING_PROCESS": "La <b>nuligo de tiu ĉi identeco</b> estis petita kaj atendas traktadon.",
    "FEATURES_NOT_IMPLEMENTED": "Tiu ĉi funkciaro ankoraŭ estas programiĝanta.<br/>Kial ne <b>kontribui al Cesium</b>, por ekhavi ĝin pli rapide? ;)",
    "EMPTY_TX_HISTORY": "Neniu spezo elportota",
    "LOADING_PENDING_TX": "Bonvolu pacienci...<br/><small>(Prenado de pendaj operacioj)</small>"
  },
  "CONFIRM": {
    "CAN_CONTINUE": "<b>Ĉu vi certas</b>, ke vi volas daŭrigi?",
    "POPUP_TITLE": "<b>Konfirmo</b>",
    "POPUP_WARNING_TITLE": "<b>Averto</b>",
    "POPUP_SECURITY_WARNING_TITLE": "<i class=\"icon ion-alert-circled\"></i> <b>Averto pri sekureco</b>",
    "CERTIFY_RULES_TITLE_UID": "Atesti {{uid}}",
    "CERTIFY_RULES": "<b class=\"assertive\">NE atestu</b> konton, se vi pensas ke:<br/><br/><ul><li>1.) ĝi ne rilatas al persono <b>fizika kaj vivanta</b>.<li>2.) ĝia posedanto <b>havas alian konton</b> jam atestitan.<li>3.) ĝia posedanto malobservas (vole aŭ ne) la regulon 1 aŭ 2 (ekzemple atestante falsajn kontojn aŭ duoblajn).</ul><br/><b>Ĉu vi certas,</b> ke vi tamen volas atesti tiun ĉi identecon?",
    "FULLSCREEN": "Afiŝi la programon plen-ekrane?",
    "EXIT_APP": "Fermi la programon?",
    "TRANSFER": "<b>Resumo de la elspezo</b> :<br/><br/><ul><li> - De: {{from}}</li><li> - Al: <b>{{to}}</b></li><li> - Sumo: <b>{{amount}} {{unit}}</b></li><li> - Komento: <i>{{comment}}</i></li></ul><br/><b>Ĉu vi certas, ke vi volas efektivigi tiun ĉi elspezon?</b>",
    "TRANSFER_ALL": "<b>Resumo de la elspezo</b>:<br/><br/><ul><li> - De : {{from}}</li><li> - Al : <b>{{to}}</b></li><li> - Sumo: <b>{{amount}} {{unit}}</b></li><li> - Komento: <i>{{comment}}</i></li><br/><li> - Resto: <b>{{restAmount}} {{unit}}</b> al <b>{{restTo}}</b></li></ul><br/><b>Ĉu vi certas, ke vi volas efektivigi tiun ĉi elspezon?</b>",
    "MEMBERSHIP_OUT": "Tiu ĉi ago estas <b>neinversigebla</b>.<br/></br/>Ĉu vi certas, ke vi volas <b>nuligi vian membro-konton</b>?",
    "MEMBERSHIP_OUT_2": "Tiu ĉi ago estas <b>neinversigebla</b> !<br/><br/>Ĉu vi vere certas, ke vi volas <b>nuligi vian aliĝon</b> kiel membron?",
    "LOGIN_UNUSED_WALLET_TITLE": "Tajperaro?",
    "LOGIN_UNUSED_WALLET": "La konektita konto ŝajnas <b>neaktiva</b>.<br/><br/>Temas probable pri <b>tajperaro</b> en viaj konekto-identigiloj. Bonvolu rekomenci, kontrolante ke <b>la publika ŝlosilo estas tiu de via konto</b>.",
    "FIX_IDENTITY": "La pseŭdonimo <b>{{uid}}</b> estos denove publikigita, anstataŭigante la malnovan publikigon, kiu finiĝis.<br/></br/><b>Ĉu vi certas</b>, ke vi volas daŭrigi?",
    "FIX_MEMBERSHIP": "Via aliĝo-peto kiel membro tuj estos resendita.<br/></br/><b>Ĉu vi certas</b>, ke vi volas daŭrigi?",
    "MEMBERSHIP": "Via aliĝo-peto kiel membro tuj estos sendita.<br/></br/><b>Ĉu vi certas</b>, ke vi volas daŭrigi?",
    "RENEW_MEMBERSHIP": "Via aliĝo kiel membro tuj estos revalidigita.<br/></br/><b>Ĉu vi certas</b>, ke vi volas daŭrigi?",
    "REVOKE_IDENTITY": "Vi estas <b>nuligonta definitive tiun ĉi identecon</b>.<br/><br/>La publika ŝlosilo kaj la ligita pseŭdonimo <b>neniam plu povos esti uzataj</b> (por membro-konto). <br/></br/><b>Ĉu vi certas</b>, ke vi volas definitive nuligi tiun ĉi konton?",
    "REVOKE_IDENTITY_2": "Tiu ĉi ago estas <b>neinversigebla</b>!<br/><br/>Ĉu vi vere certas, ke vi volas <b>definitive nuligi</b> tiun ĉi konton?",
    "NOT_NEED_RENEW_MEMBERSHIP": "Via aliĝo ne bezonas esti revalidigita (ĝi finiĝos nur post {{membershipExpiresIn|formatDuration}}).<br/></br/><b>Ĉu vi certas</b>, ke vi volas revalidigi vian aliĝon?",
    "SAVE_BEFORE_LEAVE": "Ĉu vi volas <b>konservi viajn modifojn</b> antaŭ ol eliri el la paĝo?",
    "SAVE_BEFORE_LEAVE_TITLE": "Modifoj ne registritaj",
    "LOGOUT": "Ĉu vi certas, ke vi volas malkonektiĝi?",
    "USE_FALLBACK_NODE": "Nodo <b>{{old}}</b> neatingebla aŭ adreso nevalida.<br/><br/>Ĉu vi volas provizore uzi la nodon <b>{{new}}</b> ?",
    "USE_SYNC_FALLBACK_NODE": "Ŝajnas, ke nodo <b>{{old}}</b> ne estas sinkronigita.<br/><br/>Ĉu vi volas provizore uzi la sinkronigitan nodon <b>{{new}}</b>?",
    "ISSUE_524_SEND_LOG": "La spezo estis forĵetita, pro konata anomalio (petslipo #524) sed <b>ne ripetita</b>.<br/><br/>Por helpi la programistojn korekti tiun eraron, <b>ĉu vi akceptas la sendadon de viaj protokolaj dosieroj</b> per mesaĝo?<br/><small>(neniu konfidenca dateno estas sendita)</small>.",
    "ENABLE_EXPERT_MODE_TO_CHANGE_NODE": "<b class=\"assertive\">Averto:</b> Ĉu vi volas <b>mane ŝanĝi</b> la nodon?<br/><br/>Se vi daŭrigas:<ul><li> - La <b>eksperta reĝimo</b> estos aktivigita;</li><li> - Vi povos reveni al aŭtomata nodo-selekto simple <b>malaktivigante la ekspertan reĝimon</b>.</li></ul>"
  },
  "MODE": {
    "DEMO": {
      "BADGE": "Provo",
      "MODE": "Provmontra moduso",
      "FEATURE_NOT_AVAILABLE": "Funkcio <b>ne disponebla</b> en tiu ĉi provmontra retejo.",
      "MODE_HELP": "Cesium funkcias en <b>provmontra moduso</b>: Konsultado de konto eblas, sed neniu operacio povos esti registrita.",
      "INSTALL_HELP": "Pro <b>sekurecaj kialoj</b> ni rekomendas al vi <b>instali</b> vian kopion de la programo Cesium. Vizitu la retejon <a href='https://cesium.app'>www.cesium.app</a> por ricevi helpon."
    },
    "READONLY": {
      "BADGE": "Observo",
      "MODE": "Observada moduso",
      "MODE_HELP": "Cesium funkcias en <b>observada moduso</b>: disponeblas nur la funkciaro pri observado de la valuto.",
      "INSTALL_HELP": "Se vi deziras <b>krei monuj-konton</b> por sendi aŭ ricevi monon, ni rekomendas al vi <b>instali vian kopion</b> de la programo Cesium. Vizitu la retejon <a href='https://cesium.app'>www.cesium.app</a> por ricevi helpon."
    }
  },
  "DOWNLOAD": {
    "POPUP_TITLE": "<b>Dosiero pri nuligo</b>",
    "POPUP_REVOKE_MESSAGE": "Por sekurigi vian konton, bonvolu elŝuti la <b>dokumenton pri konto-nuligo</b>. Ĝi ebligos al vi eventuale nuligi vian konton (kaze de konto-ŝtelo, ŝanĝo de identigilo, konto erare kreita, ktp.).<br/><br/><b>Bonvolu stoki ĝin en sekura loko.</b>"
  },
  "HELP": {
    "TITLE": "Ret-helpo",
    "JOIN": {
      "SECTION": "Enskribiĝo",
      "SALT": "La sekreta identigilo estas tre grava. Ĝi utilas por miksi la pasvorton, antaŭ ol ĝi servos por kalkuli la <span class=\"text-italic\">publikan ŝlosilon</span> de via konto (ties numeron) kaj la sekretan ŝlosilon por aliri ĝin.<br/><b>Zorgu pri ĝia bona memorigado</b>, ĉar neniu rimedo estas nuntempe planita por retrovi ĝin kaze de perdo.<br/>Krom tio, ĝi ne povas esti modifita sen devige krei novan konton.<br/><br/>Bona sekreta identigilo devas esti sufiĉe longa (kun almenaŭ 8 signoj) kaj kiel eble plej originala.",
      "PASSWORD": "La pasvorto estas tre grava. Kun la sekreta identigilo, ĝi servas por kalkuli la numeron (la publikan ŝlosilon) de via konto, kaj la sekretan ŝlosilon por aliri ĝin.<br/><b>Zorgu pri ĝia bona memorigado</b>, ĉar neniu rimedo estas planita por retrovi ĝin kaze de perdo (krom se oni generas konserv-dosieron).<br/>Krom tio, ĝi ne povas esti modifita sen devige krei novan konton.<br/><br/>Bona pasvorto entenas (ideale) almenaŭ 8 signojn, inter kiuj estas almenaŭ unu majusklo kaj unu cifero.",
      "PSEUDO": "La pseŭdonimo estas utila nur kaze de enskribiĝo kiel <span class=\"text-italic\">membro</span>. Ĝi ĉiam estas ligita kun monujo (tra ĝia <span class=\"text-italic\">publika ŝlosilo</span>).<br/>Ĝi estas publikigita en la reto, tiel ke la aliaj uzantoj povu identigi ĝin, atesti ĝin aŭ sendi monon al ĝia konto.<br/>Pseŭdonimo devas esti unika ene de la membroj (<u>nunaj</u> kaj eksaj)."
    },
    "LOGIN": {
      "SECTION": "Konekto",
      "PUBKEY": "Publika ŝlosilo de la ŝlosilaro",
      "PUBKEY_DEF": "La publika ŝlosilo de la ŝlosilaro estas kreita per la tajpitaj identigiloj (iuj ajn), sen ke ili necese rilatu al konto jam uzata.<br/><b>Atente kontrolu, ke la publika ŝlosilo estas tiu de via konto</b>. Alikaze, vi estos konektita al konto probable neniam uzita, la risko de kolizio kun ekzistanta konto estante tre eta.<br/><a href=\"https://fr.wikipedia.org/wiki/Cryptographie_asym%C3%A9trique\" target=\"_system\">Scii pli pri kriptografio</a> per publika ŝlosilo.",
      "METHOD": "Konekto-metodoj",
      "METHOD_DEF": "Pluraj eblecoj disponeblas por konekti vin al monujo:<br/> - La konekto <b>per salumado (simpla aŭ sperta)</b> miksas vian pasvorton dank'al la sekreta identigilo, por limigi la provojn de <a href=\"https://fr.wikipedia.org/wiki/Attaque_par_force_brute\" target=\"_system\">kodrompado per kruda forto</a> (ekzemple per konataj vortoj.<br/> - La konekto <b>per publika ŝlosilo</b> evitigas tajpi viajn identigilojn, kiuj estos petataj de vi, nur kiam venos la momento dum operacio ĉe la konto.<br/> - La konekto <b>per dosiero pri ŝlosilaro</b> legas la ŝlosilojn (publikan kaj privatan) de la konto, per dosiero, sen la bezono tajpi identigilojn. Pluraj strukturoj de dosiero eblas."
    },
    "GLOSSARY": {
      "SECTION": "Glosaro",
      "PUBKEY_DEF": "Publika ŝlosilo identigas monujon, kiu povas identigi membron aŭ rilati al anonima monujo. Ĉe Cesium la publika ŝlosilo estas kalkulita (implicite) dank'al la sekreta identigilo kaj la pasvorto.<br/><a href=\"https://fr.wikipedia.org/wiki/Cryptographie_asym%C3%A9trique\" target=\"_system\">Scii pli pri kriptografio</a> per publika ŝlosilo.",
      "MEMBER": "Membro",
      "MEMBER_DEF": "Membro estas homa persono fizika kaj vivanta, kiu deziras libere partopreni en la mona komunumo. Li/ŝi kunproduktas universalan dividendon, laŭ periodo kaj sumo tiel difinitaj kiel en la <span class=\"text-italic\">reguloj de la mono</span>",
      "CURRENCY_RULES": "Reguloj de la mono",
      "CURRENCY_RULES_DEF": "La reguloj de la mono estas difinitaj definitive. Ili fiksas la funkciadon de la mono: la kalkulon de la universala dividendo, la nombron de necesaj atestaĵoj por esti membro, la maksimuman nombron da atestaĵoj, kiujn povas doni unu membro, ktp. <a href=\"#/app/currency\">Vidi la nuntempajn regulojn</a>.<br/>La nemodifo de la reguloj tra la tempo eblas per uzado de <span class=\"text-italic\">Blokĉeno</span>, kiu entenas kaj plenumas tiujn regulojn, kaj konstante kontrolas ties ĝustan aplikadon.",
      "BLOCKCHAIN": "Ĉeno de blokoj (<span class=\"text-italic\">Blokchain/Blokĉeno</span>)",
      "BLOCKCHAIN_DEF": "La Blokĉeno estas malcentrigita sistemo, kiu, kaze de Duniter, servas por enteni kaj plenumi la <span class=\"text-italic\">regulojn de la mono</span>.<br/><a href=\"https://duniter.org/fr/comprendre/\" target=\"_system\">Scii pli pri Duniter</a> kaj la funkciado de ties blokĉeno.",
      "UNIVERSAL_DIVIDEND_DEF": "La Universala Dividendo (UD) estas la kvanto de mono kunkreita de ĉiu membro, laŭ la periodo kaj kalkulo difinitaj en la <span class=\"text-italic\">reguloj de la mono</span>.<br/>Por ĉiu perioda dato, la membroj ricevas en sian konton la saman kvanton da nova mono.<br/><br/>La UD spertas regulan kreskon, por resti justa inter la membroj (nunaj kaj venontaj), kalkulitan depende de la meza vivespero, kiel estas demonstrite en la Teorio Relativa pri la Mono (TRM).<br/><a href=\"http://trm.creationmonetaire.info\" target=\"_system\">Scii pli pri la TRM</a> kaj la liberaj monoj.",
      "WOT": "Reto de Fido (RdF)",
      "WOT_DEF": "La Reto de Fido konsistas el la tuto de la membroj de la mono, kaj el la atesto-ligoj, kiuj kunligas ilin.",
      "DISTANCE_RULE": "Regulo pri distanco",
      "DISTANCE_RULE_DEF": "La regulo pri distanco de la Reto de Fido difinas <b>maksimuman distancon nepran</b> inter petanto kaj minimuma nombro da referencaj membroj (aŭ centraj membroj). Tiu distanco estas kalkulita uzante la ligojn inter atestaĵoj."
    },
    "TIP": {
      "MENU_BTN_CURRENCY": "La menuo <b>{{'MENU.CURRENCY'|translate}}</b> ebligas konsulti la <b>regulojn de la mono</b> kaj ties staton.",
      "CURRENCY_WOT": "La <b>nombro de membroj</b> montras la gravecon de la komunumo kaj ebligas <b>sekvi ties evoluon</b>.",
      "CURRENCY_MASS": "Sekvu ĉi tie la <b>ĉioman kvanton da mono</b> ekzistanta kaj ties <b>mezan distribuon</b> por membro.<br/><br/>Tio ĉi ebligas taksi la <b>gravecon de iu sumo</b>, kompare kun tio, kion <b>posedas la aliuloj</b> en sia konto (mezume).",
      "CURRENCY_UNIT_RELATIVE": "La unuo uzata (&ldquo;<b>{{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub></b>&rdquo;) signifas, ke la sumoj en {{currency|capitalize}} estis dividitaj per la <b> Universala Dividendo</b> (UD).<br/><br/><small>Tiu relativa unuo estas <b>trafa</b>, ĉar stabila malgraŭ la kvanto de mono, kiu kreskas seninterrompe.</small>",
      "CURRENCY_CHANGE_UNIT": "La kromaĵo <b>{{'COMMON.BTN_RELATIVE_UNIT'|translate}}</b> ebligas <b>ŝanĝi la unuon</b>, por vidigi la sumojn <b>rekte en {{currency|capitalize}}</b> (prefere ol en &ldquo;<b>{{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub></b>&rdquo;).",
      "CURRENCY_CHANGE_UNIT_TO_RELATIVE": "La kromaĵo <b>{{'COMMON.BTN_RELATIVE_UNIT'|translate}}</b> ebligas <b>ŝanĝi la unuon</b>, por vidigi la sumojn en &ldquo;<b>{{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub></b>&rdquo;, tio estas rilate al la Universala Dividendo (la sumo kunproduktita de ĉiu membro).",
      "CURRENCY_RULES": "La <b>reguloj</b> de la mono fiksas ties funkciadon <b>ĝustan kaj antaŭvideblan</b>.<br/><br/>Vera DNA de la mono, ili igas sian monan kodon <b>legebla kaj travidebla</b>.",
      "MENU_BTN_NETWORK": "La menuo <b>{{'MENU.NETWORK'|translate}}</b> ebligas konsulti la staton de la reto.",
      "NETWORK_BLOCKCHAIN": "Ĉiuj operacioj pri la mono estas registritaj en granda konto-libro <b>publika kaj nefalsigebla</b>, ankaŭ nomata <b>blokĉeno</b> (<em>BlockChain</em> en la angla).",
      "NETWORK_PEERS": "La <b>nodoj</b> videblaj ĉi tie rilatas al la <b>komputiloj, kiuj ĝisdatigas kaj kontrolas</b> la blokĉenon.<br/><br/>Ju pli estas nodoj, des pli la mono havas administradon <b>malcentrigitan</b> kaj fidindan.",
      "NETWORK_PEERS_BLOCK_NUMBER": "Tiu ĉi <b>numero</b> (verda) indikas la <b>lastan blokon validigitan</b> por tiu ĉi nodo (lasta paĝo skribita en la granda konto-libro).<br/><br/>La verda koloro indikas, ke tiu ĉi bloko estas validigita ankaŭ de <b>la plej multaj el la aliaj nodoj</b>.",
      "NETWORK_PEERS_PARTICIPATE": "<b>Ĉiu membro</b>, ekipita per komputilo kun interreto, <b>povas partopreni aldonante nodon</b>. Sufiĉas <b>instali la programon Duniter</b> (libera kaj senpaga). <a href=\"{{installDocUrl}}\" target=\"_system\">Vidi la gvidilon pri instalado &gt;&gt;</a>.",
      "MENU_BTN_ACCOUNT": "La menuo <b>{{'MENU.ACCOUNT'|translate}}</b> ebligas aliri la administradon de via konto.",
      "MENU_BTN_ACCOUNT_MEMBER": "Konsultu ĉi tie la staton de via konto kaj la informojn pri viaj atestaĵoj.",
      "WALLET_CERTIFICATIONS": "Alklaku ĉi tien por konsulti la detalon pri viaj atestaĵoj (ricevitaj kaj senditaj).",
      "WALLET_RECEIVED_CERTIFICATIONS": "Alklaku ĉi tien por konsulti la detalon pri viaj <b>ricevitaj atestaĵoj</b>.",
      "WALLET_GIVEN_CERTIFICATIONS": "Alklaku ĉi tien por konsulti la detalon pri viaj <b>senditaj atestaĵoj</b>.",
      "WALLET_BALANCE": "La <b>saldo</b> de via konto afiŝiĝas tie ĉi.",
      "WALLET_BALANCE_RELATIVE": "{{'HELP.TIP.WALLET_BALANCE'|translate}}<br/><br/>La uzata unuo (&ldquo;<b>{{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub></b>&rdquo;) signifas, ke la sumo en {{currency|capitalize}} estis dividita per la <b>Universala Dividendo</b> (UD) kunkreita de ĉiu membro.<br/><br/>Nuntempe 1 UD valoras {{currentUD|formatInteger}} {{currency|capitalize}}j.",
      "WALLET_BALANCE_CHANGE_UNIT": "Vi povos <b>ŝanĝi la unuon</b> afiŝitan por la sumoj en la <b><i class=\"icon ion-android-settings\"></i>&nbsp;{{'MENU.SETTINGS'|translate}}</b>.<br/><br/>Ekzemple por vidigi la sumojn <b>rekte en {{currency|capitalize}}</b>, prefere ol en relativa unuo.",
      "WALLET_PUBKEY": "Jen la publika ŝlosilo de via konto. Vi povas sciigi ĝin al aliulo, por ke li identigu pli simple vian konton.",
      "WALLET_SEND": "Efektivigi pagon per kelkaj klakoj.",
      "WALLET_SEND_NO_MONEY": "Efektivigi pagon per kelkaj klakoj.<br/>(Via saldo ankoraŭ ne permesas tion)",
      "WALLET_OPTIONS": "Tiu ĉi butono ebligas aliri la <b>agojn pri aliĝo</b> kaj sekureco.<br/><br/>Ne forgesu okulumi al ĝi!",
      "WALLET_RECEIVED_CERTS": "Afiŝiĝos ĉi tie la listo de la personoj, kiuj atestis vin.",
      "WALLET_CERTIFY": "La butono <b>{{'WOT.BTN_SELECT_AND_CERTIFY'|translate}}</b> ebligas elekti identecon kaj atesti ĝin.<br/><br/>Nur uzantoj <b>jam membroj</b> povas atesti aliajn.",
      "WALLET_CERT_STOCK": "Via stoko da atestaĵoj (senditaj) estas limigita je <b>{{sigStock}} atestaĵoj</b>.<br/><br/>Tiu stoko plu evoluas laŭ la tempo, samtempe kiam la atestaĵoj malvalidiĝas.",
      "MENU_BTN_WALLETS": "La menuo <b>{{'MENU.WALLETS'|translate}}</b> ebligas aldoni kromajn monujojn, kiujn vi mastrumas.",
      "MENU_BTN_TX": "La menuo <b>{{'MENU.TRANSACTIONS'|translate}}</b> ebligas konsulti vian saldon, la histori-liston de viaj spezoj, kaj sendi pagon.",
      "MENU_BTN_WOT": "La menuo <b>{{'MENU.WOT'|translate}}</b> ebligas traserĉi inter la <b>uzantoj</b> de la mono (membroj aŭ ne).",
      "WOT_SEARCH_TEXT_XS": "Por traserĉi en la kontaro, tajpu la <b>unuajn literojn de pseŭdonimo</b> (aŭ de publika ŝlosilo).<br/><br/>La serĉado ekos aŭtomate.",
      "WOT_SEARCH_TEXT": "Por traserĉi en la kontaro, tajpu la <b>unuajn literojn de de pseŭdonimo</b> (aŭ de publika ŝlosilo). <br/><br/>Premu poste sur la klavon <b>Enigi</b> por ekigi la serĉadon.",
      "WOT_SEARCH_RESULT": "Vidigu la detalan slipon simple <b>alklakante</b> linion.",
      "WOT_VIEW_CERTIFICATIONS": "La linio <b>{{'ACCOUNT.CERTIFICATION_COUNT'|translate}}</b> montras kiom da membroj validigis tiun ĉi identecon.<br/><br/>Tiuj atestaĵoj pruvas, ke la konto apartenas al <b>persono homa kaj vivanta</b>, havanta <b>neniun alian membro-konton</b>.",
      "WOT_VIEW_CERTIFICATIONS_COUNT": "Necesas almenaŭ <b>{{sigQty}} atestaĵoj</b> por fariĝi membro kaj ricevi la <b>Universalan Dividendon</b>.",
      "WOT_VIEW_CERTIFICATIONS_CLICK": "Alklaki ĉi tien ebligas malfermi <b>la liston de ĉiuj atestaĵoj</b> de la identeco (ricevitaj kaj senditaj).",
      "WOT_VIEW_CERTIFY": "La butono <b>{{'WOT.BTN_CERTIFY'|translate}}</b> ebligas aldoni vian atestaĵon al tiu identeco.",
      "CERTIFY_RULES": "<b>Atenton:</b> Atestu nur <b>personojn fizikajn vivantajn</b>, posedantajn neniun alian membro-konton.<br/><br/>La sekureco de la mono dependas de ĉies atentego!",
      "MENU_BTN_SETTINGS": "La <b>{{'MENU.SETTINGS'|translate}}</b> ebligos al vi agordi la programon.",
      "HEADER_BAR_BTN_PROFILE": "Alklaku ĉi tien por aliri vian <b>uzanto-profilon.</b>",
      "SETTINGS_CHANGE_UNIT": "Vi povos <b>ŝanĝi la afiŝ-unuon</b> de la sumoj alklakante ĉi-supren.<br/><br/>- Malaktivigu la kromaĵon por afiŝi sumojn en {{currency|capitalize}}.<br/>- Aktivigu la kromaĵon por relativa afiŝado en {{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub> (ĉiuj sumoj estos <b>dividitaj</b> per la Universala Dividendo aktuala).",
      "END_LOGIN": "Tiu ĉi gvidata vizito <b>finiĝis</b>!<br/><br/>Bonan daŭrigon al vi, en la nova mondo de la<b>libera ekonomio</b>!",
      "END_NOT_LOGIN": "Tiu ĉi gvidata vizito <b>finiĝis</b>!<br/><br/>Se vi deziras partopreni en la mono {{currency|capitalize}}, sufiĉos al vi alklaki <b>{{'LOGIN.CREATE_FREE_ACCOUNT'|translate}}</b> ĉi-sube.",
      "END_READONLY": "Tiu ĉi gvidata vizito <b>finiĝis</b>.<br/><br/>{{'MODE.READONLY.INSTALL_HELP'|translate}}."
    }
  },
  "API" :{
    "COMMON": {
      "LINK_DOC": "Dokumentaro API",
      "LINK_DOC_HELP": "Dokumentaro por la programistoj",
      "LINK_STANDARD_APP": "Klasika versio",
      "LINK_STANDARD_APP_HELP": "Malfermi la klasikan version de {{'COMMON.APP_NAME'|translate}}",
      "CONNECTION_ERROR": "Nodo <b>{{server}}</b> neatingebla aŭ adreso nevalida.<br/><br/>Kontrolu vian interretan konekton, aŭ kontaktu la administranton de la retejo</a>."
    },
    "HOME": {
      "TITLE": "Dokumentaro API {{'COMMON.APP_NAME'|translate}}",
      "MESSAGE": "Bonvenon en la <b>dokumentaro de la API</b> {{'COMMON.APP_NAME'|translate}}.<br/>Konektu viajn retejojn al <a href=\"http://duniter.org\" target=\"_system\">Duniter</a> tre simple!",
      "MESSAGE_SHORT": "Konektu viajn retejojn al <a href=\"http://duniter.org\" target=\"_system\">Duniter</a> tre simple!",
      "DOC_HEADER": "Servoj disponeblaj:"
    },
    "TRANSFER": {
      "TITLE": "{{'COMMON.APP_NAME'|translate}} - Reta pago",
      "TITLE_SHORT": "Reta pago",
      "SUMMARY": "Resumo de la pago:",
      "AMOUNT": "Sumo:",
      "AMOUNTS_HELP": "Bonvolu elekti la sumon:",
      "NAME": "Nomo:",
      "PUBKEY": "Publika ŝlosilo de la ricevonto:",
      "COMMENT": "Referenco de la spezo:",
      "NODE": "Adreso de la nodo:",
      "DEMO": {
        "SALT": "demo",
        "PASSWORD": "demo",
        "PUBKEY": "3G28bL6deXQBYpPBpLFuECo46d3kfYMJwst7uhdVBnD1",
        "HELP": "<b>Demonstra moduso</b>: Neniu pago reale estos sendita dum tiu simulado.<br/>Bonvolu uzi la identigilojn: <b>{{'API.TRANSFER.DEMO.SALT'|translate}} / {{'API.TRANSFER.DEMO.PASSWORD'|translate}}</b>",
        "BAD_CREDENTIALS": "Kontrolu vian tajpaĵon.<br/>En demonstra moduso, la identigiloj estas: {{'API.TRANSFER.DEMO.SALT'|translate}} / {{'API.TRANSFER.DEMO.PASSWORD'|translate}}"
      },
      "INFO": {
        "SUCCESS_REDIRECTING_WITH_NAME": "Pago sendita.<br/>Redirektiĝo al <b>{{name}}</b>...",
        "SUCCESS_REDIRECTING": "Pago sendita.<br/>Redirektiĝo al la retejo de la vendanto...",
        "CANCEL_REDIRECTING_WITH_NAME": "Pago nuligita.<br/>Redirektiĝo al <b>{{name}}</b>...",
        "CANCEL_REDIRECTING": "Pago nuligita.<br/>Redirektiĝo al la retejo de la vendanto..."
      },
      "ERROR": {
        "TRANSFER_FAILED": "Pago malsukcesa"
      }
    },
    "DOC": {
      "DESCRIPTION_DIVIDER": "Priskribo",
      "URL_DIVIDER": "Adreso alvokita",
      "PARAMETERS_DIVIDER": "Parametroj",
      "AVAILABLE_PARAMETERS": "Jen la listo de la eblaj parametroj:",
      "DEMO_DIVIDER": "Testi",
      "DEMO_HELP": "Por testi tiun servon, alklaku la butonon ĉi-apude. La rezulto afiŝiĝos sube.",
      "DEMO_RESULT": "Rezulto sendita de la alvoko:",
      "DEMO_RESULT_PEER": "Adreso de la uzata nodo:",
      "DEMO_SUCCEED": "<i class=\"icon ion-checkmark\"></i> Sukceso!",
      "DEMO_CANCELLED": "<i class=\"icon ion-close\"></i> Nuligita de la uzanto",
      "INTEGRATE_DIVIDER": "Integri",
      "INTEGRATE_CODE": "Kodo:",
      "INTEGRATE_RESULT": "Antaŭvidigo de la rezulto:",
      "INTEGRATE_PARAMETERS": "Parametroj",
      "TRANSFER": {
        "TITLE": "Pagoj",
        "DESCRIPTION": "De retejo (ekz.: ret-vendado) vi povas komisii la pagon en libera mono al Cesium API. Por tio, sufiĉas al vi ekigi la malfermon de paĝo ĉe la sekvanta adreso:",
        "PARAM_PUBKEY": "Publika ŝlosilo de la ricevonto",
        "PARAM_PUBKEY_HELP": "Publika ŝlosilo de la ricevonto (devige)",
        "PARAM_AMOUNT": "Sumo",
        "PARAM_AMOUNT_HELP": "Sumo de la spezo (devige). Pluraj valoroj permesataj, uzante apartigilon (punkto-komo, vertikala streko aŭ spaco).",
        "PARAM_COMMENT": "Referenco (aŭ komento)",
        "PARAM_COMMENT_HELP": "Referenco aŭ komento. Tio ekzemple ebligos al vi identigi la pagon en la blokĉeno.",
        "PARAM_NAME": "Nomo (de la ricevonto aŭ de la retejo)",
        "PARAM_NAME_HELP": "La nomo de la ricevonto, aŭ de la retejo alvokanta. Tio povas estis legebla nomo (\"Mia retejo\"), aŭ alie pseŭdo-retadreso (\"MiaRetejo.com\").",
        "PARAM_REDIRECT_URL": "Retadreso por redirektiĝo",
        "PARAM_REDIRECT_URL_HELP": "Retadreso (URL) por redirektiĝo, alvokita kiam la pago estis sendita. Ĝi povas enteni la sekvantajn signojn, kiuj estos anstataŭigitaj per la valoroj de la spezo: \"{tx}\", \"{hash}\", \"{comment}\", \"{amount}\", \"{pubkey}\" kaj \"{node}\".",
        "PARAM_CANCEL_URL": "Retadreso por nuligo",
        "PARAM_CANCEL_URL_HELP": "Retadreso (URL) kaze de nuligo de la pago, fare de la uzanto. Ĝi povas enteni la sekvantajn signojn, kiuj estos anstataŭigitaj lastmomente: \"{comment}\", \"{amount}\" kaj \"{pubkey}\".",
        "PARAM_PREFERRED_NODE": "Adreso de la preferata nodo",
        "PARAM_PREFERRED_NODE_HELP": "Adreso (URL) de la nodo Duniter preferinde uzota (\"g1.domaine.com:443\" aŭ \"https://g1.domaine.com\").",
        "EXAMPLES_HELP": "Jen ekzemploj pri integrado:",
        "EXAMPLE_BUTTON": "Butono HTML",
        "EXAMPLE_BUTTON_DEFAULT_TEXT": "Pagi en {{currency|currencySymbol}}",
        "EXAMPLE_BUTTON_DEFAULT_STYLE": "Personigita stilo",
        "EXAMPLE_BUTTON_TEXT_HELP": "Buton-teksto",
        "EXAMPLE_BUTTON_BG_COLOR": "Fon-koloro",
        "EXAMPLE_BUTTON_BG_COLOR_HELP": "Ekzemplo: #fbc14c, nigra, helgriza, rgb(180,180,180)",
        "EXAMPLE_BUTTON_FONT_COLOR": "Teksto-koloro",
        "EXAMPLE_BUTTON_FONT_COLOR_HELP": "Ekzemplo: nigra, oranĝa, rgb(180,180,180)",
        "EXAMPLE_BUTTON_TEXT_ICON": "Ikono",
        "EXAMPLE_BUTTON_TEXT_WIDTH": "Larĝeco",
        "EXAMPLE_BUTTON_TEXT_WIDTH_HELP": "Ekzemplo: 200px, 50%",
        "EXAMPLE_BUTTON_ICON_NONE": "Neniu",
        "EXAMPLE_BUTTON_ICON_DUNITER": "Insigno Duniter",
        "EXAMPLE_BUTTON_ICON_CESIUM": "Insigno Cesium",
        "EXAMPLE_BUTTON_ICON_G1_COLOR": "Insigno Ğ1",
        "EXAMPLE_BUTTON_ICON_G1_BLACK": "Insigno Ğ1 (nigra)"
      }
    }
  }
}
);

$translateProvider.translations("es-ES", {
  "COMMON": {
    "APP_NAME": "Cesium",
    "APP_VERSION": "v{{version}}",
    "APP_BUILD": "fecha: {{build}}",
    "PUBKEY": "Llave pública",
    "MEMBER": "Miembro",
    "BLOCK": "Bloque",
    "BTN_OK": "OK",
    "BTN_YES": "Sí",
    "BTN_NO": "No",
    "BTN_SEND": "Enviar",
    "BTN_SEND_MONEY": "Hacer un pago",
    "BTN_SEND_MONEY_SHORT": "Pago",
    "BTN_SAVE": "Guardar",
    "BTN_YES_SAVE": "Sí, guardar",
    "BTN_YES_CONTINUE": "Sí, continuar",
    "BTN_SHOW": "Ver",
    "BTN_SHOW_PUBKEY": "Ver la llave",
    "BTN_RELATIVE_UNIT": "Mostrar importes en DU",
    "BTN_BACK": "Anterior",
    "BTN_NEXT": "Siguiente",
    "BTN_IMPORT": "Importar",
    "BTN_CANCEL": "Cancelar",
    "BTN_CLOSE": "Cerrar",
    "BTN_LATER": "Más tarde",
    "BTN_LOGIN": "Conectarse",
    "BTN_LOGOUT": "Desconexión",
    "BTN_ADD_ACCOUNT": "Nueva cuenta",
    "BTN_SHARE": "Compartir",
    "BTN_EDIT": "Modificar",
    "BTN_DELETE": "Suprimir",
    "BTN_ADD": "Añadir",
    "BTN_SEARCH": "Buscar",
    "BTN_REFRESH": "Actualizar",
    "BTN_RETRY": "Empezar de nuevo",
    "BTN_START": "Empezar",
    "BTN_CONTINUE": "Continuar",
    "BTN_CREATE": "Crear",
    "BTN_UNDERSTOOD": "Entendido",
    "BTN_OPTIONS": "Opciones",
    "BTN_HELP_TOUR": "Visita guiada",
    "BTN_HELP_TOUR_SCREEN": "Explicar esta pantalla",
    "BTN_DOWNLOAD": "Descargar",
    "BTN_DOWNLOAD_ACCOUNT_STATEMENT": "Descargar historial de cuenta",
    "BTN_MODIFY": "Modificar",
    "CHOOSE_FILE": "Arrastre el archivo<br/>o haga clic para seleccionarlo",
    "DAYS": "Días",
    "NO_ACCOUNT_QUESTION": "¿Todavía no es miembro? ¡Crear una cuenta!",
    "SEARCH_NO_RESULT": "Ningún resultado encontrado",
    "LOADING": "Espere por favor...",
    "LOADING_WAIT": "Espere por favor...<br/><small>(Cesium está consultando al nodo Duniter)</small>",
    "SEARCHING": "Búsqueda en proceso…",
    "FROM": "De",
    "TO": "A",
    "COPY": "Copiar",
    "LANGUAGE": "Idioma",
    "UNIVERSAL_DIVIDEND": "Dividendo universal",
    "UD": "DU",
    "DATE_PATTERN": "DD/MM/YYYY HH:mm",
    "DATE_FILE_PATTERN": "YYYY-MM-DD",
    "DATE_SHORT_PATTERN": "DD/MM/YY",
    "DATE_MONTH_YEAR_PATTERN": "MM/YYYY",
    "EMPTY_PARENTHESIS": "(vacío)",
    "UID": "Seudónimo",
    "ENABLE": "Activado",
    "DISABLE": "Desactivado",
    "RESULTS_LIST": "Resultados:",
    "RESULTS_COUNT": "{{count}} resultados",
    "EXECUTION_TIME": "ejecutado en {{duration|formatDurationMs}}",
    "SHOW_VALUES": "Revelar contraseñas",
    "POPOVER_ACTIONS_TITLE": "Opciones",
    "POPOVER_FILTER_TITLE": "Filtros",
    "SHOW_MORE": "Mostrar más",
    "SHOW_MORE_COUNT": "(límite actual {{limit}})",
    "POPOVER_SHARE": {
      "TITLE": "Compartir",
      "SHARE_ON_TWITTER": "Compartir en Twitter",
      "SHARE_ON_FACEBOOK": "Compartir en Facebook",
      "SHARE_ON_DIASPORA": "Compartir en Diaspora*",
      "SHARE_ON_GOOGLEPLUS": "Compartir en Google+"
    },
    "FILE": {
      "DATE" : "Fecha:",
      "TYPE" : "Tipo:",
      "SIZE": "Tamaño:",
      "VALIDATING": "Validando…"
    }
  },
  "SYSTEM": {
    "PICTURE_CHOOSE_TYPE": "Elegir la fuente:",
    "BTN_PICTURE_GALLERY": "Galería",
    "BTN_PICTURE_CAMERA": "<b>Cámara</b>"
  },
  "MENU": {
    "HOME": "Inicio",
    "WOT": "Directorio",
    "CURRENCY": "Moneda",
    "ACCOUNT": "Mi cuenta",
    "WALLETS": "Mis monederos",
    "SETTINGS": "Ajustes",
    "NETWORK": "Red",
    "TRANSACTIONS": "Mis transacciones"
  },
  "ABOUT": {
    "BTN_OPEN_DEV_WINDOW": "Abrir ventana de depuración",
    "TITLE": "Acerca de",
    "LICENSE": "Software <b>libre</b> (licencia GNU AGPLv3).",
    "LATEST_RELEASE": "Existe una <b>versión más nueva</b> de {{'COMMON.APP_NAME' | translate}} (<b>v{{version}}</b>)",
    "PLEASE_UPDATE": "Por favor actualice {{'COMMON.APP_NAME' | translate}} (última versión: <b>v{{version}}</b>)",
    "CODE": "Código fuente:",
    "OFFICIAL_WEB_SITE": "Web oficial:",
    "DEVELOPERS": "Desarrollado por:",
    "FORUM": "Foro:",
    "PLEASE_REPORT_ISSUE": "No dude en informarnos de anomalías encontradas",
    "REPORT_ISSUE": "Reportar un problema"
  },
  "HOME": {
    "FEED_SOURCE": "Fuente",
    "READ_MORE": "Leer más",
    "SHOW_ALL_FEED": "Ver todo",
    "TITLE": "Cesium",
    "WELCOME": "¡Bienvenida/o a la aplicación Cesium!",
    "MESSAGE": "Reciba y envíe moneda libre {{currency|abbreviate}} fácilmente",
    "BTN_CURRENCY": "Explorar la moneda",
    "BTN_ABOUT": "Acerca de",
    "BTN_HELP": "Ayuda en línea",
    "REPORT_ISSUE": "Reportar anomalía",
    "NOT_YOUR_ACCOUNT_QUESTION": "¿No es suya la cuenta <b><i class=\"ion-key\"></i> {{pubkey|formatPubkey}}</b>?",
    "BTN_CHANGE_ACCOUNT": "Desconectar esta cuenta",
    "PEER_CONNECTION_ERROR": "Nodo <b>{{server}}</b> inalcanzable o dirección inválida.<br/><br/>Compruebe su conexión a Internet, o nodo Duniter <a class=\"positive\" ng-click=\"doQuickFix('settings')\">en los ajustes</a>.",
    "NETWORK_CONNECTION_ERROR": "No se puede alcanzar la red.<br/><br/>Comprueba tu conexión a Internet, o selecciona un nodo manualmente <a class=\"positive\" ng-click=\"doQuickFix('settings')\">en los ajustes</a>."
  },
  "SETTINGS": {
    "TITLE": "Ajustes",
    "DISPLAY_DIVIDER": "Visualización",
    "STORAGE_DIVIDER": "Almacenamiento",
    "NETWORK_SETTINGS": "Red",
    "PEER": "Nodo Duniter",
    "PEER_CHANGED_TEMPORARY": "Dirección utilizada temporalmente",
    "PEER_SELECTED_AUTOMATICALLY": "Nodo seleccionado automáticamente al inicio",
    "NETWORK_ANALYZE_TIMEOUT": "Temps d'espera màxim (timeout)",
    "NETWORK_ANALYZE_TIMEOUT_HELP": "Tiempo de espera máximo para el análisis de la red",
    "NETWORK_ANALYZE_TIMEOUT_AUTO": "Auto",
    "PERSIST_CACHE": "Conservar los datos de navegación (experimental)",
    "PERSIST_CACHE_HELP": "Permite una navegación más rápida, conservando localmente los datos recibidos, para usar de una sesión a otra.",
    "USE_LOCAL_STORAGE": "Activar el almacenamiento local",
    "USE_LOCAL_STORAGE_HELP": "Permitir conservar sus ajustes",
    "WALLETS_SETTINGS": "Mis monederos",
    "USE_WALLETS_ENCRYPTION": "Cifrar el listado",
    "USE_WALLETS_ENCRYPTION_HELP": "Permite proteger la lista de sus monederos (mediante cifrado), exigiendo una autenticación para acceder.",
    "ENABLE_HELPTIP": "Activar la ayuda contextual",
    "ENABLE_UI_EFFECTS": "Activar los efectos visuales",
    "HISTORY_SETTINGS": "Transacciones de la cuenta",
    "DISPLAY_UD_HISTORY": "Mostrar los DU creados",
    "TX_HISTORY_AUTO_REFRESH": "Activar actualización automática",
    "TX_HISTORY_AUTO_REFRESH_HELP": "Actualizar el saldo y las transacciones automáticamente, con cada nuevo bloque.",
    "AUTHENTICATION_SETTINGS": "Autenticación",
    "KEEP_AUTH": "Caducidad de la autenticación",
    "KEEP_AUTH_SHORT": "Caducidad",
    "KEEP_AUTH_HELP": "Defina cuándo expira su sesión",
    "KEEP_AUTH_OPTION": {
      "NEVER": "Después de cada operación",
      "SECONDS": "Después de {{value}} segundos de inactividad",
      "MINUTE": "Después de {{value}}min de inactividad",
      "MINUTES": "Después de {{value}}mins de inactividad",
      "HOUR": "Después de {{value}}h de inactividad",
      "ALWAYS": "Al finalizar la sesión"
    },
    "KEYRING_FILE": "Archivo de llaves",
    "KEYRING_FILE_HELP": "Le permite <b>conectarse</b> automáticamente en cada inicio <br/>e incluso de <b>autenticarse</b> (solo si \"Caducidad de la autenticación\" está configurada en modo: \"al finalizar la sesión\").",
    "REMEMBER_ME": "Recordarme",
    "REMEMBER_ME_HELP": "Permite mantenerse siempre conectado (no recomendado), conservando localmente la llave pública.",
    "PLUGINS_SETTINGS": "Extensiones",
    "BTN_RESET": "Restaurar los valores por defecto",
    "EXPERT_MODE": "Modo experto",
    "EXPERT_MODE_HELP": "Permite una visualización más detallada",
    "BLOCK_VALIDITY_WINDOW": "Tiempo de incertitud de los bloques",
    "DISABLE_HELPTIP": "Desactivar la opción de ayuda contextual",
    "BLOCK_VALIDITY_WINDOW_SHORT": "Tiempo de incertitud",
    "BLOCK_VALIDITY_WINDOW_HELP": "Tiempo de espera antes de considerar una información como validada",
    "BLOCK_VALIDITY_OPTION": {
      "NONE": "Sin espera",
      "N": "{{time | formatDuration}} ({{count}} bloques)"
    },
    "POPUP_PEER": {
      "TITLE": "Nodo Duniter",
      "HOST": "Dirección",
      "HOST_HELP": "Dirección: servidor:puerto",
      "USE_SSL": "Conexión segura",
      "USE_SSL_HELP": "Cifrado SSL",
      "BTN_SHOW_LIST": "Lista de nodos"
    }
  },
  "BLOCKCHAIN": {
    "HASH": "Hash: {{hash}}",
    "VIEW": {
      "HEADER_TITLE": "Bloque #{{number}}-{{hash|formatHash}}",
      "TITLE_CURRENT": "Bloque actual",
      "TITLE": "Bloque #{{number|formatInteger}}",
      "COMPUTED_BY": "Calculado por el nodo de",
      "SHOW_RAW": "Ver el fichero en bruto",
      "TECHNICAL_DIVIDER": "Informaciones técnicas",
      "VERSION": "Versión del formato",
      "HASH": "Hash calculado",
      "UNIVERSAL_DIVIDEND_HELP": "Moneda co-producida por cada uno de los {{membersCount}} miembros",
      "EMPTY": "Ningún dato en este bloque",
      "POW_MIN": "Dificultad mínima",
      "POW_MIN_HELP": "Dificultad impuesta por el cálculo del hash",
      "DATA_DIVIDER": "Datos",
      "IDENTITIES_COUNT": "Nuevas identidades",
      "JOINERS_COUNT": "Nuevos miembros",
      "ACTIVES_COUNT": "Renovaciones",
      "ACTIVES_COUNT_HELP": "Miembros que han renovado sus adhesiones",
      "LEAVERS_COUNT": "Miembros salientes",
      "LEAVERS_COUNT_HELP": "Miembros salientes que ya no quieren estar certificados",
      "EXCLUDED_COUNT": "Miembros excluidos",
      "EXCLUDED_COUNT_HELP": "Antiguos miembros excluidos por no renovación o falta de certificaciones",
      "REVOKED_COUNT": "Identidades revocadas",
      "REVOKED_COUNT_HELP": "Estas cuentas no podrán ser miembros",
      "TX_COUNT": "Transacciones",
      "CERT_COUNT": "Certificaciones",
      "TX_TO_HIMSELF": "Operación de cambio",
      "TX_OUTPUT_UNLOCK_CONDITIONS": "Condiciones de desbloqueo",
      "TX_OUTPUT_OPERATOR": {
        "AND": "y",
        "OR": "o"
      },
      "TX_OUTPUT_FUNCTION": {
        "SIG": "<b>Firma</b> de ",
        "XHX": "<b>Contraseña</b>, cuyo SHA256 =",
        "CSV": "Bloqueado durante",
        "CLTV": "Bloqueado hasta"
      }
    },
    "LOOKUP": {
      "TITLE": "Bloques",
      "NO_BLOCK": "Ningún bloque",
      "LAST_BLOCKS": "Últimos bloques:",
      "BTN_COMPACT": "Compactar"
    }
  },
  "CURRENCY": {
    "VIEW": {
      "TITLE": "Moneda",
      "TAB_CURRENCY": "Moneda",
      "TAB_WOT": "Red de confianza",
      "TAB_NETWORK": "Red",
      "TAB_BLOCKS": "Bloques",
      "CURRENCY_SHORT_DESCRIPTION": "{{currency|abbreviate}} es una <b>moneda libre</b>, originada {{firstBlockTime|formatFromNow}}. Cuenta actualmente con <b>{{N}} miembros</b>, que producen y reciben un <a ng-click=\"showHelpModal('ud')\">Dividendo Universal</a> (DU) cada {{dt|formatPeriod}}.",
      "NETWORK_RULES_DIVIDER": "Reglas de la red",
      "CURRENCY_NAME": "Nombre de la moneda",
      "MEMBERS": "Cantidad de miembros",
      "MEMBERS_VARIATION": "Variación desde último DU",
      "MONEY_DIVIDER": "Moneda",
      "MASS": "Masa monetaria",
      "SHARE": "Masa media por miembro",
      "UD": "Dividendo Universal",
      "C_ACTUAL": "Crecimiento actual",
      "MEDIAN_TIME": "Hora de la cadena de bloques",
      "POW_MIN": "Nivel mínimo de dificultad de cálculo",
      "MONEY_RULES_DIVIDER": "Reglas de la moneda",
      "C_RULE": "Crecimiento teórico objetivo",
      "UD_RULE": "Cálculo del dividendo universal",
      "DT_REEVAL": "Periodo de revalorización del DU",
      "REEVAL_SYMBOL": "reval",
      "DT_REEVAL_VALUE": "Todos los <b>{{dtReeval|formatDuration}}</b> ({{dtReeval/86400}} {{'COMMON.DAYS'|translate}})",
      "UD_REEVAL_TIME0": "Fecha de la primera revalorización",
      "SIG_QTY_RULE": "Certificaciones requeridas para ser miembro",
      "SIG_STOCK": "Máximo de certificaciones emitibles por miembros",
      "SIG_PERIOD": "Espera mínima entre 2 certificaciones sucesivas emitidas por el mismo individuo",
      "SIG_WINDOW": "Límite para tener en cuenta una certificación",
      "SIG_VALIDITY": "Duración de una certificación tenida en cuenta",
      "MS_WINDOW": "Límite para aprobar una solicitud de membresía",
      "MS_VALIDITY": "Duración de una membresía aprobada",
      "STEP_MAX": "Distancia máxima entre una nueva candidatura y cada miembro referente",
      "WOT_RULES_DIVIDER": "Reglas de la red de confianza",
      "SENTRIES": "Certificaciones necesarias para ser miembro referente",
      "SENTRIES_FORMULA": "Fórmula de las certificaciones necesarias para ser miembro referente",
      "XPERCENT":"Porcentaje mínimo necesario de miembros referentes respetando la regla de distancia máxima",
      "AVG_GEN_TIME": "Tiempo medio entre dos bloques",
      "CURRENT": "actual",
      "MATH_CEILING": "TECHO",
      "DISPLAY_ALL_RULES": "¿Ver todas las reglas?",
      "BTN_SHOW_LICENSE": "Ver la licencia",
      "WOT_DIVIDER": "Red de confianza"
    },
    "LICENSE": {
      "TITLE": "Licencia de la moneda",
      "BTN_DOWNLOAD": "Descargar el fichero",
      "NO_LICENSE_FILE": "Fichero de licencia no encontrado."
    }
  },
  "NETWORK": {
    "VIEW": {
      "MEDIAN_TIME": "Hora de la cadena de bloques",
      "LOADING_PEERS": "Cargando nodos…",
      "NODE_ADDRESS": "Dirección:",
      "SOFTWARE": "Software:",
      "WARN_PRE_RELEASE": "Prelanzamiento (última versión estable: <b>{{version}}</b>)",
      "WARN_NEW_RELEASE": "Versión <b>{{version}}</b> disponible",
      "WS2PID": "ID:",
      "PRIVATE_ACCESS": "Acceso privado",
      "POW_PREFIX": "Prefijo de la prueba de trabajo:",
      "ENDPOINTS": {
        "BMAS": "Interfaz segura (SSL)",
        "BMATOR": "Interfaz red TOR",
        "WS2P": "Interfaz WS2P",
        "ES_USER_API": "Nodo de datos Cesium+"
      }
    },
    "INFO": {
      "CONNECTING_TO_NETWORK": "Conectando a la red...",
      "ANALYZING_NETWORK": "Analizando la red {{currency|abbreviate}}...",
      "ONLY_SSL_PEERS": "La visualización de los nodos sin SSL está deteriorada porque Cesium funciona en modo HTTPS."
    }
  },
  "PEER": {
    "PEERS": "Nodos",
    "SIGNED_ON_BLOCK": "Firmado sobre el bloque",
    "MIRROR": "espejo",
    "MIRRORS": "Espejo",
    "MIRROR_PEERS": "Nodos espejo",
    "PEER_LIST": "Lista de nodos",
    "MEMBERS": "Miembro",
    "MEMBER_PEERS": "Nodos miembro",
    "ALL_PEERS": "Todos los nodos",
    "DIFFICULTY": "Dificultad",
    "API": "API",
    "CURRENT_BLOCK": "Bloque #",
    "POPOVER_FILTER_TITLE": "Filtro",
    "OFFLINE": "Fuera de línea",
    "OFFLINE_PEERS": "Nodos fuera de línea",
    "BTN_SHOW_PEER": "Ver nodo",
    "VIEW": {
      "TITLE": "Nodo",
      "OWNER": "Propiedad de",
      "SHOW_RAW_PEERING": "Ver la ficha del par",
      "SHOW_RAW_CURRENT_BLOCK": "Ver el último bloque (formato bruto)",
      "LAST_BLOCKS": "Bloques recientes",
      "KNOWN_PEERS": "Nodos conocidos:",
      "GENERAL_DIVIDER": "Información general",
      "ERROR": {
        "LOADING_TOR_NODE_ERROR": "No se pudo obtener la información del nodo usando la red TOR.",
        "LOADING_NODE_ERROR": "No se pudo obtener la información del nodo"
      }
    }
  },
  "WOT": {
    "SEARCH_HELP": "Buscar (seudónimo o llave pública)",
    "SEARCH_INIT_PHASE_WARNING": "Durante la etapa de preinscripción, el tiempo de búsqueda de las candidaturas en espera <b>puede tardar</b>. Por favor espere…",
    "REGISTERED_SINCE": "Se registró en",
    "REGISTERED_SINCE_BLOCK": "Se registró en el bloque #",
    "NO_CERTIFICATION": "Ninguna certificación validada",
    "NO_GIVEN_CERTIFICATION": "Ninguna certificación emitida",
    "NOT_MEMBER_PARENTHESIS": "(monedero simple)",
    "IDENTITY_REVOKED_PARENTHESIS": "(identidad revocada)",
    "MEMBER_PENDING_REVOCATION_PARENTHESIS": "(revocación en proceso)",
    "EXPIRE_IN": "Expira",
    "NOT_WRITTEN_EXPIRE_IN": "Fecha límite<br/>de procesamiento",
    "EXPIRED": "Expirado",
    "PSEUDO": "Seudónimo",
    "SIGNED_ON_BLOCK": "Emitida en el bloque #{{block}}",
    "WRITTEN_ON_BLOCK": "Escrita en el bloque #{{block}}",
    "GENERAL_DIVIDER": "Informaciones generales",
    "NOT_MEMBER_ACCOUNT": "Cuenta monedero simple",
    "NOT_MEMBER_ACCOUNT_HELP": "Se trata de un monedero simple, sin solicitud de membresía en espera",
    "TECHNICAL_DIVIDER": "Informaciones técnicas",
    "BTN_CERTIFY": "Certificar",
    "BTN_YES_CERTIFY": "Sí, certificar",
    "BTN_SELECT_AND_CERTIFY": "Nueva certificación",
    "ACCOUNT_OPERATIONS": "Transacciones de la cuenta",
    "VIEW": {
      "POPOVER_SHARE_TITLE": "Identidad {{title}}"
    },
    "LOOKUP": {
      "TITLE": "Directorio",
      "NEWCOMERS": "Nuevos miembros:",
      "NEWCOMERS_COUNT": "{{count}} miembros",
      "PENDING": "Inscripciones en espera:",
      "PENDING_COUNT": "{{count}} inscripciones en espera",
      "REGISTERED": "Se inscribió {{sigDate | formatFromNow}}",
      "MEMBER_FROM": "Miembro desde hace {{memberDate|medianFromNowShort}}",
      "BTN_NEWCOMERS": "Miembros recientes",
      "BTN_PENDING": "Candidaturas en espera",
      "SHOW_MORE": "Mostrar más",
      "SHOW_MORE_COUNT": "(mostrar solo {{limit}})",
      "NO_PENDING": "Ninguna candidatura en espera.",
      "NO_NEWCOMERS": "Sin miembros."
    },
    "CONTACTS": {
      "TITLE": "Contactos"
    },
    "MODAL": {
      "TITLE": "Buscar"
    },
    "CERTIFICATIONS": {
      "TITLE": "{{uid}} - Certificaciones",
      "SUMMARY": "Certificaciones recibidas",
      "LIST": "Detalle de las certificaciones recibidas",
      "PENDING_LIST": "Certificaciones en espera de tratamiento",
      "RECEIVED": "Certificaciones recibidas",
      "RECEIVED_BY": "Certificaciones recibidas por {{uid}}",
      "ERROR": "Certificaciones recibidas por error",
      "SENTRY_MEMBER": "Miembro referente"
    },
    "OPERATIONS": {
      "TITLE": "{{uid}} - Transacciones"
    },
    "GIVEN_CERTIFICATIONS": {
      "TITLE": "{{uid}} - Certificaciones emitidas",
      "SUMMARY": "Certificaciones emitidas",
      "LIST": "Detalle de las certificaciones emitidas",
      "PENDING_LIST": "Certificaciones en espera a ser procesadas",
      "SENT": "Certificaciones emitidas",
      "SENT_BY": "Certificaciones emitidas por {{uid}}",
      "ERROR": "Certificaciones emitidas por error"
    }
  },
  "LOGIN": {
    "TITLE": "<i class=\"icon ion-locked\"></i> Conexión",
    "SCRYPT_FORM_HELP": "Ingrese sus credenciales.<br>Recuerde comprobar que la llave pública pertenece a su cuenta.",
    "PUBKEY_FORM_HELP": "Por favor ingrese una llave pública de cuenta:",
    "FILE_FORM_HELP": "Elija el archivo de llaves a usar:",
    "SCAN_FORM_HELP": "Escanee el código QR de un monedero.",
    "SALT": "Frase secreta",
    "SALT_HELP": "Frase secreta",
    "SHOW_SALT": "Mostrar la frase secreta",
    "PASSWORD": "Contraseña",
    "PASSWORD_HELP": "Contraseña",
    "PUBKEY_HELP": "llave pública",
    "NO_ACCOUNT_QUESTION": "¿Aún no tiene cuenta? ",
    "HAVE_ACCOUNT_QUESTION": "¿Ya tiene cuenta?",
    "CREATE_ACCOUNT": "Crear nueva cuenta",
    "CREATE_FREE_ACCOUNT": "Crear nueva cuenta",
    "FORGOTTEN_ID": "¿Olvidó su contraseña?",
    "ASSOCIATED_PUBKEY": "Llave pública del archivo de llaves:",
    "BTN_METHODS": "Otros métodos",
    "BTN_METHODS_DOTS": "Otras vías…",
    "METHOD_POPOVER_TITLE": "Métodos",
    "MEMORIZE_AUTH_FILE": "Memorizar las llaves durante la sesión de navegación",
    "SCRYPT_PARAMETERS": "Ajustes (Scrypt) :",
    "AUTO_LOGOUT": {
      "TITLE": "Información",
      "MESSAGE": "<i class=\"ion-android-time\"></i> Se ha <b>desconectado</b> de forma automática, después de un periodo de inactividad prolongada.",
      "BTN_RELOGIN": "Volver a conectarme",
      "IDLE_WARNING": "Será desconectado en… {{countdown}}"
    },
    "METHOD": {
      "SCRYPT_DEFAULT": "Estándar (por defecto)",
      "SCRYPT_ADVANCED": "Aleatoriedad avanzada",
      "FILE": "Archivo de llaves",
      "PUBKEY": "Llave pública o seudónimo",
      "SCAN": "Escanear un código QR"
    },
    "SCRYPT": {
      "SIMPLE": "Ligero",
      "DEFAULT": "Predeterminado",
      "SECURE": "Seguro",
      "HARDEST": "El más seguro",
      "EXTREME": "Extremo",
      "USER": "Personalizado",
      "N": "N (Loop):",
      "r": "r (RAM):",
      "p": "p (CPU):"
    },
    "FILE": {
      "HELP": "Formato de archivo esperado: <b>.yml</b> o <b>.dunikey</b> (tipo PubSec, WIF o EWIF)."
    }
  },
  "API": {
    "COMMON": {
        "CONNECTION_ERROR": "Nodo <b>{{server}}</b> inalcanzable o dirección inválida.<br/><br/>Verifique su conexión a Internet, o contacte con la administración del sitio.</a>.",
        "LINK_DOC": "Documentación API",
        "LINK_DOC_HELP": "Documentación para desarrolladores",
        "LINK_STANDARD_APP": "Versión clásica",
        "LINK_STANDARD_APP_HELP": "Abrir la versión clásica de {{'COMMON.APP_NAME'|translate}}"
    },
    "DOC": {
        "AVAILABLE_PARAMETERS": "Lista de parámetros disponibles :",
        "DEMO_CANCELLED": "<i class=\"icon ion-close\"></i> Cancelado por el usuario",
        "DEMO_DIVIDER": "Probar",
        "DEMO_HELP": "Para probar este servicio, haga clic en este botón. El resultado se mostrará debajo.",
        "DEMO_RESULT": "Resultado retornado por la llamada :",
        "DEMO_RESULT_PEER": "Dirección del nodo utilizado :",
        "DEMO_SUCCEED": "<i class=\"icon ion-checkmark\"></i> ¡ Éxito !",
        "DESCRIPTION_DIVIDER": "Descripción",
        "INTEGRATE_CODE": "Código :",
        "INTEGRATE_DIVIDER": "Integrar",
        "INTEGRATE_PARAMETERS": "Parámetros",
        "INTEGRATE_RESULT": "Previsualización del resultado :",
        "PARAMETERS_DIVIDER": "Parámetros",
        "TRANSFER": {
            "DESCRIPTION": "Desde una web (ej: tienda online) puede delegar el pago en moneda libre con la API de Cesium. Para eso, simplemente ponga un link a la siguiente dirección :",
            "EXAMPLE_BUTTON": "Botón HTML",
            "EXAMPLE_BUTTON_BG_COLOR": "Color de fondo",
            "EXAMPLE_BUTTON_BG_COLOR_HELP": "Ejemplo : #fbc14c, black, lightgrey, rgb(180,180,180)",
            "EXAMPLE_BUTTON_DEFAULT_STYLE": "Estilo personalizado",
            "EXAMPLE_BUTTON_DEFAULT_TEXT": "Pagar en {{currency|currencySymbol}}",
            "EXAMPLE_BUTTON_FONT_COLOR": "Color del texto",
            "EXAMPLE_BUTTON_FONT_COLOR_HELP": "Ejemplo : black, orange, rgb(180,180,180)",
            "EXAMPLE_BUTTON_ICON_CESIUM": "Logo Cesium",
            "EXAMPLE_BUTTON_ICON_DUNITER": "Logo Duniter",
            "EXAMPLE_BUTTON_ICON_G1_BLACK": "Logo Ğ1 (negro)",
            "EXAMPLE_BUTTON_ICON_G1_COLOR": "Logo Ğ1",
            "EXAMPLE_BUTTON_ICON_NONE": "Ninguno",
            "EXAMPLE_BUTTON_TEXT_HELP": "Texto del botón",
            "EXAMPLE_BUTTON_TEXT_ICON": "Icono",
            "EXAMPLE_BUTTON_TEXT_WIDTH": "Anchura",
            "EXAMPLE_BUTTON_TEXT_WIDTH_HELP": "Ejemplo : 200px, 50%",
            "EXAMPLES_HELP": "Ejemplos de integración :",
            "PARAM_AMOUNT": "Cuantía",
            "PARAM_AMOUNT_HELP": "Cuantía de la transición (obligatorio). Valores múltiples permitidos utilizando un separador (punto y coma, barra vertical o espacio).",
            "PARAM_CANCEL_URL": "Dirección web de cancelación",
            "PARAM_CANCEL_URL_HELP": "Dirección web (URL) en caso de anulación del pago por parte del usuario. Puede contener las siguientes palabras que serán remplazadas por sus valores dinámicamente en cada caso: \"{comment}\", \"{amount}\" y \"{pubkey}\".",
            "PARAM_COMMENT": "Concepto (o comentario)",
            "PARAM_COMMENT_HELP": "Concepto o comentario. Le permitirá por ejemplo identificar el pago en la cadena de bloques (blockchain).",
            "PARAM_NAME": "Nombre (del destinatario o de su sitio web)",
            "PARAM_NAME_HELP": "El nombre del destinatario, o de su sitio web. Puede ser un nombre leíble (\"Mi tienda en línea\"), o un dominio (\"Mitienda.com\").",
            "PARAM_PREFERRED_NODE": "Dirección del nodo preferido",
            "PARAM_PREFERRED_NODE_HELP": "Dirección (URL) del nodo Duniter a utilizar preferentemente (\"g1.domaine.com:443\" o \"https://g1.domaine.com\").",
            "PARAM_PUBKEY": "Llave pública del destinatario",
            "PARAM_PUBKEY_HELP": "La llave pública del destinatario (obligatoria)",
            "PARAM_REDIRECT_URL": "Dirección web de redirección",
            "PARAM_REDIRECT_URL_HELP": "Dirección web (URL) de redirección, llamada cuanda el pago ha sido enviado. Puede contener las palabras siguientes, que serán remplazadas por los valores de la transacción dinámicanente : \"{tx}\", \"{hash}\", \"{comment}\", \"{amount}\", \"{pubkey}\" y \"{node}\".",
            "TITLE": "Pagos"
        },
        "URL_DIVIDER": "Dirección de llamada"
    },
    "HOME": {
        "DOC_HEADER": "Servicios disponibles :",
        "MESSAGE": "Bienvenido/a a la <b>documentación de la API</b> {{'COMMON.APP_NAME'|translate}}.<br/>Conecte sus sitios webs a la cadena de bloques <a href=\"http://duniter.org\" target=\"_system\">Duniter</a> muy fácilmente !",
        "MESSAGE_SHORT": "Conecte sus sitios a <a href=\"http://duniter.org\" target=\"_system\">Duniter</a> muy fácilmente !",
        "TITLE": "Documentación API {{'COMMON.APP_NAME'|translate}}"
    },
    "TRANSFER": {
        "AMOUNT": "Cuantía :",
        "AMOUNTS_HELP": "Elija la cuantía :",
        "COMMENT": "Concepto/Comentario de la operación :",
        "DEMO": {
            "BAD_CREDENTIALS": "Verifique sus credenciales.<br/>En modo demostración, las credenciales son : {{'API.TRANSFER.DEMO.SALT'|translate}} / {{'API.TRANSFER.DEMO.PASSWORD'|translate}}",
            "HELP": "<b>Modo demostración</b> : Ningún pago será enviado realmente durante esta simulación.<br/>Utilice las credenciales : <b>{{'API.TRANSFER.DEMO.SALT'|translate}} / {{'API.TRANSFER.DEMO.PASSWORD'|translate}}</b>",
            "PASSWORD": "demo",
            "PUBKEY": "3G28bL6deXQBYpPBpLFuECo46d3kfYMJwst7uhdVBnD1",
            "SALT": "demo"
        },
        "ERROR": {
            "TRANSFER_FAILED": "Error en el pago"
        },
        "INFO": {
            "CANCEL_REDIRECTING": "Pago cancelado.<br/>Redirigiendo al sitio del vendedor...",
            "CANCEL_REDIRECTING_WITH_NAME": "Pago cancelado.<br/>Redirigiendo a <b>{{name}}</b>...",
            "SUCCESS_REDIRECTING": "Pago enviado.<br/>Redirigiendo al sitio del vendedor...",
            "SUCCESS_REDIRECTING_WITH_NAME": "Pago enviado.<br/>Redirigiendo a <b>{{name}}</b>..."
        },
        "NAME": "Nombre :",
        "NODE": "Dirección del nodo :",
        "PUBKEY": "Llave pública del destinatario :",
        "SUMMARY": "Resumen del pago :",
        "TITLE": "{{'COMMON.APP_NAME'|translate}} - Pago en línea",
        "TITLE_SHORT": "Pago en línea"
    }
  },
  "AUTH": {
    "TITLE": "<i class=\"icon ion-locked\"></i> Autenticación",
    "BTN_AUTH": "Autenticar",
    "GENERAL_HELP": "Por favor, autentíquese:",
    "EXPECTED_UID_HELP": "Por favor inicie sesión en la cuenta de <i class=\"ion-person\"></i> {{uid}}:",
    "EXPECTED_PUBKEY_HELP": "Por favor, autentíquese en el monedero <br class=\"visible-xs\"/><i class=\"ion-key\"></i> {{pubkey|formatPubkey}} :",
    "SCAN_FORM_HELP": "Escanee el código QR de la <b>llave privada</b> del monedero."
  },
  "ACCOUNT": {
    "TITLE": "Mi cuenta",
    "BALANCE": "Saldo",
    "LAST_TX": "Últimas transacciones validadas",
    "BALANCE_ACCOUNT": "Saldo de la cuenta",
    "NO_TX": "Ninguna transacción",
    "SHOW_MORE_TX": "Mostrar más",
    "SHOW_ALL_TX": "Mostrar todo",
    "TX_FROM_DATE": "(mostrar solo {{fromTime|medianFromNowShort}})",
    "OUT_DISTANCED": "Sus certificaciones recibidas provienen de un grupo demasiado aislado de la <a ng-click=\"showHelpModal('wot')\">Red de Confianza</a> (RdC) : la <a ng-click=\"showHelpModal('distance_rule')\">regla de distancia máxima</a> no se cumple.<br/>Deberá obtener certificaciones provinientes de otros sectores de la RdC, o esperar a que ésta estreche sus vínculos.",
    "PENDING_TX": "Transacciones pendientes",
    "VALIDATING_TX": "Transacciones validadas",
    "ERROR_TX": "Transacciones no validadas",
    "ERROR_TX_SENT": "Transacciones ejecutadas no validadas",
    "PENDING_TX_RECEIVED": "Transacciones en espera de recepción",
    "EVENTS": "Eventos",
    "WAITING_MEMBERSHIP": "Solicitud de membresía emitida. En espera de aceptación.",
    "WAITING_CERTIFICATIONS": "Debe obtener {{needCertificationCount}} certificación(es) para ser miembro.",
    "WAITING_CERTIFICATIONS_HELP": "Para obtener sus certificaciones, solicítelas únicamente a miembros <b>que le conozcan bien</b>, como exige <a ng-click=\"showLicenseModal()\">la licencia de la moneda</a> que usted ha aceptado.<br/>Si no conoce lo suficiente a miembros, hágalo saber en el foro para asistir u organizar algún encuentro sobre la moneda libre.",
    "WILL_MISSING_CERTIFICATIONS": "Pronto le van a <b>faltar certificaciones</b> (al menos {{willNeedCertificationCount}} son necesarias)",
    "WILL_NEED_RENEW_MEMBERSHIP": "Su adhesión como miembro <b>va a expirar {{membershipExpiresIn|formatDurationTo}}</b>. Piense en <a ng-click=\"doQuickFix('renew')\">renovar su adhesión</a> mientras tanto.",
    "NEED_RENEW_MEMBERSHIP": "Ya no es miembro porque su adhesión <b>ha expirado</b>. Piense en <a ng-click=\"doQuickFix('renew')\">renovar su adhesión</a>.",
    "NEED_RENEW_MEMBERSHIP_AFTER_CANCELLED": "Ya no es miembro de la moneda, <b>por falta de certificaciones</b>. Considere <a ng-click=\"doQuickFix('renew')\">renovar su adhesión</a>.",
    "NO_WAITING_MEMBERSHIP": "No hay adhesión miembro en espera. Si desea <b>convertirse en miembro</b>, por favor <a ng-click=\"doQuickFix('membership')\">envíe su adhesión como miembro</a>.",
    "CERTIFICATION_COUNT": "Certificaciones recibidas",
    "CERTIFICATION_COUNT_SHORT": "Certificaciones",
    "SIG_STOCK": "Certificaciones emitidas",
    "BTN_RECEIVE_MONEY": "Recibir",
    "BTN_SELECT_ALTERNATIVES_IDENTITIES": "Cambiar a otra identidad…",
    "BTN_FIX_MEMBERSHIP": "Volver a enviar la candidatura…",
    "BTN_MEMBERSHIP_RENEW": "Renovar la membresía",
    "BTN_MEMBERSHIP_RENEW_DOTS": "Renovar la membresía…",
    "BTN_MEMBERSHIP_OUT_DOTS": "Cancelar la membresía…",
    "BTN_SECURITY_DOTS": "Cuenta y seguridad…",
    "BTN_SHOW_DETAILS": "Publicar la información técnica",
    "LOCKED_OUTPUTS_POPOVER": {
      "TITLE": "Importe bloqueado",
      "DESCRIPTION": "Aquí están las condiciones para desbloquear este importe:",
      "DESCRIPTION_MANY": "Esta transacción esta compuesta de varias partes, cuyas condiciones de desbloqueo son:",
      "LOCKED_AMOUNT": "Condiciones del importe:"
    },
    "NEW": {
      "TITLE": "Registrarse",
      "INTRO_WARNING_TIME": "Crear una cuenta en {{name|capitalize}} es muy simple. Sin embargo, por favor tome el tiempo suficiente para hacerlo correctamente (generar y memorizar bien las credenciales, etc.)",
      "INTRO_WARNING_SECURITY": "Asegúrese de que el dispositivo actual (ordenador, tablet, teléfono) <b>es seguro y de confianza</b>.",
      "INTRO_WARNING_SECURITY_HELP": "Antivirus, cortafuegos, sesión protegida por contraseña o número PIN, etc.",
      "INTRO_HELP": "Haga clic en <b>{{'COMMON.BTN_START'|translate}}</b> para iniciar la creación de la cuenta. Se le guiará paso a paso.",
      "REGISTRATION_NODE": "Su registro será grabado a través del nodo Duniter <b>{{server}}</b>, que luego se transmitirá al resto del sistema de la moneda.",
      "REGISTRATION_NODE_HELP": "Si no confía en este nodo, <a ng-click=\"doQuickFix('settings')\">cambie los ajustes</a> de Cesium.",
      "SELECT_ACCOUNT_TYPE": "Elegir el tipo de cuenta a crear:",
      "MEMBER_ACCOUNT": "Cuenta candidata miembro (si tiene experiencia)",
      "MEMBER_ACCOUNT_TITLE": "Crear una cuenta candidata miembro (si tiene experiencia)",
      "MEMBER_ACCOUNT_HELP": "Si ya tienes experiencia en la moneda y la comunidad le conoce bien. La candidatura caduca a los dos meses si no cumple los requisitos.",
      "WALLET_ACCOUNT": "Cuenta monedero simple (recomendada al inicio)",
      "WALLET_ACCOUNT_TITLE": "Crear una cuenta simple",
      "WALLET_ACCOUNT_HELP": "Si es su primera vez, empiece con un monedero simple. También para cuentas de grupos, proyectos, para hacer pruebas, etc.",
      "SALT_WARNING": "Elija su frase secreta.<br/>Se solicitará cada vez que se conectará con esta cuenta.<br/><br/><b>Conserve bien esta frase secreta</b>.<br/>¡En caso de pérdida, nadie podrá acceder a su cuenta!",
      "PASSWORD_WARNING": "Elija su contraseña.<br/>Se solicitará cada vez que se conectará con esta cuenta.<br/><br/><b>Conserve bien esta contraseña</b>.<br/>¡En caso de pérdida, nadie podrá acceder su cuenta!",
      "PSEUDO_WARNING": "Elija un seudónimo.<br/>Sirve para que los otros usuarios de la moneda puedan encontrarlo más fácilmente.<br/><br/>No debe contener <b>ni espacios ni caracteres acentuados</b>.<div class='hidden-xs'><br/>Ejemplo: <span class='gray'>SophieDupond, MarcelChemin, etc.</span>",
      "PSEUDO": "Seudónimo",
      "PSEUDO_HELP": "Seudónimo",
      "SALT_CONFIRM": "Confirmación",
      "SALT_CONFIRM_HELP": "Confirmación de la frase secreta",
      "PASSWORD_CONFIRM": "Confirmación",
      "PASSWORD_CONFIRM_HELP": "Confirmación de la contraseña",
      "SLIDE_6_TITLE": "Confirmación:",
      "COMPUTING_PUBKEY": "Cálculo en proceso…",
      "LAST_SLIDE_CONGRATULATION": "<b>¡Bien!</b> Ha introducido todas los datos necesarios.<br/><b>Puede solicitar</b> la creación de su cuenta.</b><br/><br/>Para su información, la llave pública que se muestra más abajo identificará su futura cuenta.<br/>Esta podrá ser comunicada a terceros para recibir pagos.",
      "CONFIRMATION_MEMBER_ACCOUNT": "<b class=\"assertive\">Advertencia:</b> la frase secreta, la contraseña y el seudónimo no podrán ser modificados.<br/><b>¡Asegúrese siempre de recordarlos!</b><br/><br/>¿Desea solicitar la inscripción?",
      "CONFIRMATION_WALLET_ACCOUNT": "<b class=\"assertive\">Advertencia:</b> la frase secreta y la contraseña no podrán ser modificados.<br/><b>¡Asegúrese de recordarlos siempre!</b><br/><br/>¿Desea continuar?",
      "CHECKING_PSEUDO": "Verificando…",
      "PSEUDO_AVAILABLE": "Este nombre está disponible",
      "PSEUDO_NOT_AVAILABLE": "Este nombre de usuario no está disponible",
      "INFO_LICENSE": "Para unirse a la moneda, le pedimos leer y aceptar esta licencia.",
      "BTN_ACCEPT": "Acepto",
      "BTN_ACCEPT_LICENSE": "Acepto la licencia"
    },
    "POPUP_REGISTER": {
      "TITLE": "Elija un seudónimo",
      "HELP": "Un seudónimo es obligatorio para ser miembro."
    },
    "SELECT_IDENTITY_MODAL": {
      "TITLE": "Selección de identidad",
      "HELP": "Se han enviado varias <b>identidades diferentes</b> para la llave pública <span class=\"gray\"><i class=\"ion-key\"></i>{{pubkey | formatPubkey}}</span>.<br/>Por favor, selecciona la carpeta para usar:"
    },
    "SELECT_WALLET_MODAL": {
      "TITLE": "Selección de monedero"
    },
    "CERTIFICATION_MODAL": {
      "CHECKLIST_TITLE": "Lista de verificación antes de certificar",
      "INFOS": "La seguridad de la moneda Ğ1 depende de cada miembro. Antes de certificar la identidad de este ser humano, debes realizar algunas verificaciones. Por favor, responde a las siguientes preguntas:",
      "BTN_ALL_CHECK": "Certificar",
      "CHECKLIST_CONDITIONS_NOT_MET": "La certificación no se ha enviado. Las verificaciones parecen insuficientes. Por favor, verifica nuevamente cada punto con la persona a certificar.",
      "QUESTIONS": {
        "WELL_KNOWN": "<b>¿Conoces bien</b> al ser humano que vas a certificar y conoces a otras personas que también lo conocen bien?",
        "REVOCATION": "¿Ha descargado su <b>documento de revocación</b> y sabe dónde encontrarlo?",
        "CONTACT": "¿Has <b>contactado</b> a esta persona por varios medios y te ha respondido?",
        "DOUBLE_IDENTITY": "La persona debe tener <b>una sola identidad de miembro activa</b>. ¿Tiene alguna <b>otra</b>?",
        "MASTER_ACCOUNT": "¿Controla bien su cuenta y ha realizado al menos <b>una transferencia</b> desde su cuenta?",
        "LICENSE": "¿Ha <b>entendido la licencia</b> y está dispuesta a cumplirla para certificar a otros miembros?",
        "CREDENTIALS": "¿Las credenciales de su cuenta, como el identificador y la contraseña, son suficientemente <b>largas y complejas</b>? ¿Ha comprendido que tanto la frase secreta como la contraseña deben mantenerse en secreto? ¿Está segura de recordarlos o de poder encontrarlos?",
        "PUBLIC_KEY_DIFFERENT": "La <b>clave pública</b> indicada debe ser <b>idéntica</b> a la que esta persona te ha proporcionado. ¿Son <b>diferentes</b> las claves?"
      },
      "REMINDER_TITLE": "Recordatorio",
      "SHORT_LICENSE_REMINDER": "Puedes recordarle a la persona certificada los parámetros de las certificaciones:<br/><br/><ul><li> - Cada miembro puede emitir un máximo de 100 certificaciones válidas.</li><li> - Las certificaciones se registran con un intervalo de 5 días.</li><li> - Una nueva identidad de miembro debe reunir al menos 5 certificaciones en menos de dos meses.</li><li> - Un miembro debe renovar su membresía cada año.</li><li> - Las certificaciones son válidas durante dos años.</li></ul>"
    },
    "WALLET_LIST": {
      "IMPORT_MODAL": {
        "HELP": "Para <b>importar monederos</b>, haga clic para seleccionar o arrastre en la zona de abajo el archivo con la lista de monederos.",
        "NO_NEW_WALLET": "Ningún monedero nuevo",
        "TITLE": "Importar monederos",
        "WALLET_COUNT": "<b>{{count}}</b> nuevo{{count > 1 ? 's' : ''}} monedero{{count > 1 ? 's' : ''}}"
      },
      "TITLE": "Mis monederos",
      "BTN_NEW": "Añadir un monedero",
      "BTN_DOWNLOAD": "Descargue el listado",
      "BTN_IMPORT_FILE_DOTS": "Importar desde fichero…",
      "NO_WALLET": "Sin monedero secundario",
      "BTN_DELETE": "Eliminar un monedero secundario…",
      "BTN_RENAME": "Renombrar el monedero",
      "EXPORT_FILENAME": "monederos-{{pubkey|formatPubkey}}-{{currency}}.csv",
      "TOTAL_DOTS": "Total : ",
      "EDIT_POPOVER": {
        "TITLE": "Renombrar el monedero",
        "HELP": "Escribe el nuevo nombre",
        "NAME_HELP": "Nombre del monedero"
      }
    },
    "SECURITY": {
      "KEYFILE": {
        "ERROR": {
            "BAD_CHECKSUM": "Suma de control (checksum) incorrecta",
            "BAD_PASSWORD": "Frase secreta incorrecta"
        },
        "EWIF_FORMAT": "Formato EWIF (Encrypted Wallet Import Format) - v1",
        "EWIF_FORMAT_HELP": "Este formato almacena su archivo de llaves <b>de forma cifrada</b> a partir de una frase secreta de su elección. También guarda una suma de control (checksum) para verificar la integridad del archivo.<br/><b>Atención :</b>¡ Asegúrese siempre de recordar su frase secreta !",
        "PASSWORD_POPUP": {
            "HELP": "Indique la frase secreta :",
            "PASSWORD_HELP": "Frase secreta",
            "TITLE": "Archivo de llaves cifrado"
        },
        "PUBSEC_FORMAT": "Formato PubSec",
        "PUBSEC_FORMAT_HELP": "Este formato almacena su archivo de llaves de forma simple. Es compatible con Cesium, ğannonce y Duniter.<br/><b>Atención :</b>El archivo <b>no está cifrado</b> (la llave privada aparece en claro) ; ¡ guárdelo en un lugar seguro !",
        "WIF_FORMAT": "Formato WIF (Wallet Import Format) - v1",
        "WIF_FORMAT_HELP": "Este formato almacena su archivo de llaves con una suma de control (checksum) para verificar la integridad del archivo. Es compatible con los monederos en papel (Duniter paper wallet).<br/><b>Atención :</b>El archivo <b>no está cifrado</b> (la llave privada aparece en claro) ; ¡ guárdelo en un lugar seguro !"
      },
      "ADD_QUESTION": "Añadir pregunta personalizada",
      "BTN_CLEAN": "Limpiar",
      "BTN_RESET": "Reiniciar",
      "DOWNLOAD_REVOKE": "Guardar un archivo de revocación",
      "DOWNLOAD_REVOKE_HELP" : "Tener un archivo de revocación es importante, en caso de perdida de las credenciales. Le permitirá <b>invalidar y sacar su cuenta miembro fuera de la Red de Confianza</b>, convirtíendose en un monedero simple.",
      "RECOVER_ID_SELECT_FILE": "Elija el <b>archivo para salvaguardar sus credenciales</b> a utilizar :",
      "GENERATE_KEYFILE": "Generar mi archivo de llaves…",
      "GENERATE_KEYFILE_HELP": "Genera un archivo que le permitirá atenticarse sin tener que introducir las credenciales.<br/><b>Cuidado:</b> este archivo contendrá su llave secreta; ¡Es muy importante conservarlo en un lugar seguro!",
      "KEYFILE_FILENAME": "llavero-{{pubkey|formatPubkey}}-{{currency}}-{{format}}.dunikey",
      "MEMBERSHIP_IN": "Registrarse como miembro…",
      "MEMBERSHIP_IN_HELP": "Le permite <b>transformar</b> una cuenta de monedero simple <b>en una cuenta miembro</b>, enviando una petición de membresía. Solo si todavía no tiene una cuenta miembro.",
      "SEND_IDENTITY": "Publicar seudónimo/identidad…",
      "SEND_IDENTITY_HELP": "Le permite asociar un seudónimo a esta cuenta, pero <b>sin pedir ser miembro</b>. La validez de este seudónimo tiene un plazo limitado.",
      "HELP_LEVEL": "Elija <strong> al menos {{nb}} preguntas:</strong>",
      "LEVEL": "Nivel de seguridad",
      "LOW_LEVEL": "Bajo <span class=\"hidden-xs\">(2 preguntas min.)</span>",
      "MEDIUM_LEVEL": "Medio <span class=\"hidden-xs\">(4 preguntas min.)</span>",
      "QUESTION_1": "¿Cómo se llamaba su mejor amigo de la adolescencia?",
      "QUESTION_2": "¿Cómo se llamaba su primer animal de compañía?",
      "QUESTION_3": "¿Cuál es el primer plato que aprendió a cocinar?",
      "QUESTION_4": "¿Cuál es la primera película que vió en un cine?",
      "QUESTION_5": "¿Cuál era el destino del primer avión que cogió?",
      "QUESTION_6": "¿Cómo se llamaba su docente favorito en la escuela primaria?",
      "QUESTION_7": "¿Cuál sería para usted el mejor oficio?",
      "QUESTION_8": "¿Cuál es su libro infantil preferido?",
      "QUESTION_9": "¿Cuál fue el modelo de su primer vehículo?",
      "QUESTION_10": "¿Cuál fue su sobrenombre durante su infancia?",
      "QUESTION_11": "¿Cuál fue su personaje o actor/actriz preferido/a cuando era estudiante?",
      "QUESTION_12": "¿Cuál fue su cantante o grupo preferido cuando era estudiante?",
      "QUESTION_13": "¿En qué ciudad sus padres se encontraron?",
      "QUESTION_14": "¿Cómo se llamaba su primer jefe/a?",
      "QUESTION_15": "¿Cómo se llama la calle donde creció?",
      "QUESTION_16": "¿Cómo se llama la primera playa donde se bañó?",
      "QUESTION_17": "¿Cuál es el primer álbum que compró?",
      "QUESTION_18": "¿Cuál es el nombre de su equipo deportivo preferido?",
      "QUESTION_19": "¿Cuál fue el oficio de su abuelo?",
      "RECOVER_ID": "Recuperar sus credenciales",
      "REVOCATION_WITH_FILE": "Revocar una identidad a partir de un fichero",
      "REVOCATION_WITH_FILE_DESCRIPTION": "Si ha perdido de forma permanente las credenciales de su cuenta miembro (o la seguridad de la cuenta se ve comprometida), puede usar <b>el archivo de revocación de la cuenta</b> para forzar la salida de la Red de Confianza.",
      "REVOCATION_WITH_FILE_HELP": "Para <b>revocar permanentemente</b> una cuenta miembro, arrastre el archivo de revocación en el cuadro siguiente o haga clic en el cuadro para seleccionar un archivo.",
      "REVOCATION_FILENAME": "revocacion-{{uid}}-{{pubkey|formatPubkey}}-{{currency}}.txt",
      "REVOCATION_WALLET": "Revocar esta identidad",
      "SAVE_ID": "Guardar mis credenciales",
      "STRONG_LEVEL": "Alto <span class=\"hidden-xs \">(6 preguntas min.)</span>",
      "TITLE": "Cuenta y seguridad",
      "RECOVER_ID_HELP": "Si dispone de un <b>archivo de recuperación de sus credenciales</b>, las puede reobtener respondiendo correctamente a las preguntas personales elegidas en su momento.",
      "REVOCATION_WALLET_HELP": "Pedir la revocación de vuestra identidad comporta la <b>salida de la red de confianza</b> (definitiva para el seudónimo y la llave pública asociada). La cuenta no producirá ya más el Dividendo Universal.<br/>Podrá seguir usándola como monedero simple.",
      "SAVE_ID_HELP": "Creación de un archivo de recuperación, para <b>reobtener su contraseña</b> (y frase secreta) en caso de olvido. El archivo se <b>cifra</b> con ayuda de las preguntas personales elegidas."
    },
    "FILE_NAME": "{{currency}}_HistorialDeCuenta_{{pubkey|formatPubkey}}_{{currentTime|formatDateForFile}}.csv",
    "HEADERS": {
      "TIME": "Fecha",
      "AMOUNT": "Cantidad",
      "COMMENT": "Comentario"
    }
  },
  "TRANSFER": {
    "TITLE": "Transferencia",
    "SUB_TITLE": "Hacer una transferencia",
    "FROM": "De",
    "TO": "A",
    "AMOUNT": "Importe",
    "AMOUNT_HELP": "Importe",
    "COMMENT": "Comentario",
    "COMMENT_HELP": "Comentario",
    "BTN_SEND": "Enviar",
    "BTN_ADD_COMMENT": "Añadir un comentario",
    "REST": "Resto de cuenta",
    "REST_TO": "a",
    "WARN_COMMENT_IS_PUBLIC": "Tenga en cuenta que los <b>comentarios son públicos</b> (sin encriptar).",
    "MODAL": {
      "TITLE": "Transferencia"
    }
  },
  "ERROR": {
    "ADD_SECONDARY_WALLET_FAILED": "Error añadiendo el monedero secundario.",
    "COULD_NOT_ADD_EXISTING_WALLET": "Monedero ya existe en la lista.",
    "COULD_NOT_ADD_MAIN_WALLET": "Este monedero <b>corresponde a la cuenta principal</b> con la que se conecta.<br/>Imposible añadirlo como monedero secundario.",
    "ISSUE_524_TX_FAILED": "Error en la transferencia.<br/><br/>Un mensaje ha sido enviado a los/as desarrolladores/as para facilitar la resolución del problema. <b>Gracias por su ayuda</b>.",
    "LOAD_WALLET_LIST_FAILED": "Error cargando los monederos secundarios.",
    "ONLY_MEMBER_OR_WAS_MEMBER_CAN_EXECUTE_THIS_ACTION": "Usted debe <b>ser miembro (o haber sido miembro)</b> para poder efectuar esta acción.",
    "RESTORE_WALLET_LIST_FAILED": "Error en la restauración de los monederos secundarios.",
    "SAVE_WALLET_LIST_FAILED": "Error al guardar los monederos secundarios.",
    "UNKNOWN_WALLET_ID": "Monedero secundario desconocido.",
    "UPDATE_WALLET_LIST_FAILED": "Error en la actualización de los monederos secundarios.",
    "UNKNOWN_URI_FORMAT": "Formato URI desconocido",
    "PUBKEY_INVALID_CHECKSUM": "Llave pública no válida (suma de comprobación incorrecta).",
    "POPUP_TITLE": "Error",
    "UNKNOWN_ERROR": "Error desconocido",
    "TIMEOUT_REACHED": "Se ha excedido el tiempo de espera del nodo ({{timeout|formatDurationMs}}).<br/><br/><small>{{url}}</small>",
    "CRYPTO_UNKNOWN_ERROR": "Su navegador parece incompatible con las funcionalidades de cryptografía.",
    "DOWNLOAD_KEYFILE_FAILED": "Error al generar el archivo de llaves.",
    "EQUALS_TO_PSEUDO": "Debe ser diferente del seudónimo.",
    "EQUALS_TO_SALT": "Debe ser diferente de la frase secreta.",
    "FIELD_REQUIRED": "Campo obligatorio.",
    "FIELD_TOO_SHORT": "Valor demasiado corta.",
    "FIELD_TOO_SHORT_WITH_LENGTH": "Valor demasiado corta ({{minLength}} carácteres mín)",
    "FIELD_TOO_LONG": "Valor demasiado largo",
    "FIELD_TOO_LONG_WITH_LENGTH": "Valor demasiado largo, ({{maxLength}} carácteres máx)",
    "FIELD_MIN": "Valor mínimo: {{min}}",
    "FIELD_MAX": "Valor máximo: {{max}}",
    "FIELD_ACCENT": "Caracteres acentuados y comas no autorizados",
    "FIELD_NOT_NUMBER": "Valor numérico esperado",
    "FIELD_NOT_INT": "Valor entero esperado",
    "FIELD_NOT_EMAIL": "Correo electrónico no válido",
    "PASSWORD_NOT_CONFIRMED": "No coincide con la contraseña anterior.",
    "SALT_NOT_CONFIRMED": "No corresponde a la frase secreta anterior.",
    "SEND_IDENTITY_FAILED": "Error de la inscripción.",
    "SEND_CERTIFICATION_FAILED": "Error de la certificación.",
    "NEED_MEMBER_ACCOUNT_TO_CERTIFY": "No se puede certificar, porque su cuenta no <b>es miembro</b>.",
    "NEED_MEMBER_ACCOUNT_TO_CERTIFY_HAS_SELF": "No se puede certificar, porque su cuenta todavía no es miembro.<br/><br/>Todavía faltan certificaciones para serlo.",
    "IDENTITY_TO_CERTIFY_HAS_NO_SELF": "Esta cuenta no se pudo certificar. No se ha solicitado la membresía, o se necesita renovarla.",
    "LOGIN_FAILED": "Error durante la autentificación.",
    "LOAD_IDENTITY_FAILED": "Error de carga de la identidad.",
    "LOAD_REQUIREMENTS_FAILED": "Error de carga de las condiciones de la identidad.",
    "SEND_MEMBERSHIP_IN_FAILED": "Error en el intento de entrada en la comunidad.",
    "SEND_MEMBERSHIP_OUT_FAILED": "Error en la interrupción de adhesión.",
    "REFRESH_WALLET_DATA": "Error en la actualización del monedero.",
    "GET_CURRENCY_PARAMETER": "Error en la recuperación de las reglas de moneda.",
    "GET_CURRENCY_FAILED": "Carga de la moneda imposible. Por favor, intente más tarde.",
    "SEND_TX_FAILED": "Error en la transferencia.",
    "ALL_SOURCES_USED": "Por favor, espera el cálculo del bloque siguiente (Todas sus fuentes de moneda fueron utilizada).",
    "NOT_ENOUGH_SOURCES": "No lo bastante cambio para mandar este importe en una sola transacción.<br/>Importe máximo: {{amount}} {{unit}}<sub>{{subUnit}}</sub>.",
    "ACCOUNT_CREATION_FAILED": "Error en la creación de la cuenta miembro.",
    "RESTORE_WALLET_DATA_ERROR": "Error en la recarga de los ajustes desde el almacenamiento local",
    "LOAD_WALLET_DATA_ERROR": "Error en la carga de los datos del monedero.",
    "COPY_CLIPBOARD_FAILED": "Copia de la valor imposible.",
    "TAKE_PICTURE_FAILED": "Error en la recuperación de la foto.",
    "SCAN_FAILED": "Error en el escán del Codigo QR",
    "SCAN_UNKNOWN_FORMAT": "Codigo no reconocido.",
    "WOT_LOOKUP_FAILED": "Error en la búsqueda",
    "LOAD_PEER_DATA_FAILED": "Lectura del nodo Duniter imposible. Por favor, intente más tarde.",
    "NEED_LOGIN_FIRST": "Por favor, conéctese en primer lugar.",
    "AMOUNT_REQUIRED": "El importe es obligatorio.",
    "AMOUNT_NEGATIVE": "Importe negativo no autorizado.",
    "NOT_ENOUGH_CREDIT": "Crédito insuficiente.",
    "INVALID_NODE_SUMMARY": "Nodo ilocalizable o dirección inválida.",
    "INVALID_USER_ID": "El seudónimo no debe contener ni espacios ni caracteres especiales o acentuado.",
    "INVALID_COMMENT": "El campo 'referencia’ no debe contener carácteres acentuados.",
    "INVALID_PUBKEY": "La llave pública no tiene el formato esperado.",
    "INVALID_PUBKEY_CHECKSUM": "Suma de comprobación inválida.",
    "IDENTITY_REVOKED": "Esta identidad <b>fue revocada</b>. No puede volver a convertirla en miembro.",
    "IDENTITY_REVOKED_WITH_TIME": "Esta identidad <b>fue revocada {{revocationTime|medianFromNow}}</b> ({{revocationTime|medianDate}}). No puede volver a convertirla en miembro.",
    "IDENTITY_PENDING_REVOCATION": "La <b>revocación de esta identidad</b> fue solicitado y esta en espera de tratamiento. Por lo que, la certificación es desactivada.",
    "IDENTITY_INVALID_BLOCK_HASH": "Esta solicitud de adhesión no es valida (porque denomina un bloque los nodos de la red han anulado): este individuo/a debe renovelar su solicitud de adhesión <b>antes que</b> estar certificada.",
    "IDENTITY_EXPIRED": "La publicación de esta identidad ha caducada: este individuo/a debe realizar una nueva solicitud de adhesión <b>antes que</b> estar certificada.",
    "IDENTITY_SANDBOX_FULL": "EL nodo Duniter utilizado por Cesium ya no puede recibir más nuevas identidades, porque la fila de espera es llena.<br/><br/>Por favor, intenta ulteriormente o cambia de nodo (vía el menú <b>Ajustes</b>).",
    "IDENTITY_NOT_FOUND": "Identidad no encontrada",
    "IDENTITY_TX_FAILED": "Error cargando las transacciones de la identidad",
    "WOT_PENDING_INVALID_BLOCK_HASH": "Adhesión no validada.",
    "WALLET_INVALID_BLOCK_HASH": "Su solicitud de adhesión ya no está validada (porque denomina un bloque los nodos de la red han anulado).<br/>Debe <a ng-click=\"doQuickFix('fixMembership')\">mandar una nueva solicitud</a> para resolver este problema.",
    "WALLET_IDENTITY_EXPIRED": "La publicación de <b>su identidad ha caducada</b>.<br/>Debe <a ng-click=\"doQuickFix('fixIdentity')\">publicar une outra vez su identidad</a> para resolver este problema.",
    "WALLET_REVOKED": "Su identidad fue <b>revocada</b>: ni su seudónimo ni su llave pública podrán estar utilizados en el futuro por una cuenta miembro.",
    "WALLET_HAS_NO_SELF": "Su identidad debe en primer lugar haber estado publicado, y no estar caducada.",
    "AUTH_REQUIRED": "Autenticación requerida.",
    "AUTH_INVALID_PUBKEY": "La llave pública no se corresponde con la cuenta conectada",
    "AUTH_INVALID_SCRYPT": "De usuario o contraseña no válidos.",
    "AUTH_INVALID_FILE": "archivo de llave no válido.",
    "AUTH_FILE_ERROR": "No se pudo abrir el archivo de llave",
    "IDENTITY_ALREADY_CERTIFY": "Ha <b>ya certificado</b> esta identidad.<br/><br/>Esta certificación todavía es valida (expiration {{expiresIn|formatDurationTo}}).",
    "IDENTITY_ALREADY_CERTIFY_PENDING": "Ha <b>ya certificado</b> esta identidad.<br/><br/>Esta certificación está en espera de tratamiento (fecha límite de tratamiento {{expiresIn|formatDurationTo}}).",
    "UNABLE_TO_CERTIFY_TITLE": "Certificación imposible",
    "LOAD_NEWCOMERS_FAILED": "No se pudo cargar las nuevas membresías.",
    "LOAD_PENDING_FAILED": "No se pudo cargar las inscripciones pendientes.",
    "ONLY_MEMBER_CAN_EXECUTE_THIS_ACTION": "Debe <b>ser miembro</b> para poder realizar esta acción.",
    "ONLY_SELF_CAN_EXECUTE_THIS_ACTION": "Debe haber <b>publicado su identidad</b> para poder realizar esta acción.",
    "GET_BLOCK_FAILED": "Error en la recuperación del bloque",
    "INVALID_BLOCK_HASH": "Bloque no encontrado (hash diferente)",
    "DOWNLOAD_REVOCATION_FAILED": "Debe seleccionar un fichero de texto",
    "REVOCATION_FAILED": "Error en la revocación.",
    "SALT_OR_PASSWORD_NOT_CONFIRMED": "Frase secreta o contraseña incorrectos",
    "RECOVER_ID_FAILED": "Error en la recuperación de las credenciales",
    "LOAD_FILE_FAILED": "Error en la carga del archivo",
    "NOT_VALID_REVOCATION_FILE": "Archivo de revocación no válido (formato de archivo erróneo)",
    "NOT_VALID_SAVE_ID_FILE": "Archivo no válido (formato de archivo erróneo)",
    "NOT_VALID_KEY_FILE": "Archivo no válido (formato de archivo erróneo)",
    "EXISTING_ACCOUNT": "Sus credenciales corresponden a una cuenta existente, la <a ng-click=\"showHelpModal('pubkey')\">llave pública</a> es:",
    "EXISTING_ACCOUNT_REQUEST": "Por favor, cambie sus credenciales para que coincida con una cuenta sin usar.",
    "GET_LICENSE_FILE_FAILED": "Error al obtener el archivo de licencia",
    "CHECK_NETWORK_CONNECTION": "No se puede conectar a ningún nodo.<br/><br/><b>Compruebe la conexión a Internet</b>.",
    "INVALID_FILE_FORMAT": "Formato de archivo inválido.",
    "SAME_TX_RECIPIENT": "El destinatario debe ser diferente del emisor."
  },
  "INFO": {
    "POPUP_TITLE": "Información",
    "CERTIFICATION_DONE": "Certificación enviada",
    "NOT_ENOUGH_CREDIT": "Crédito insuficiente",
    "TRANSFER_SENT": "Transferencia enviada",
    "COPY_TO_CLIPBOARD_DONE": "Copia realizada",
    "MEMBERSHIP_OUT_SENT": "Anulación enviada",
    "NOT_NEED_MEMBERSHIP": "Ya es miembro.",
    "IDENTITY_WILL_MISSING_CERTIFICATIONS": "Esta identidad pronto va a necesitar certificaciones (al menos {{willNeedCertificationCount}}).",
    "IDENTITY_NEED_MEMBERSHIP": "Esta identidad no ha enviado una solicitud de membresía para convertirse en miembro.",
    "HAS_ALTERNATIVE_IDENTITIES": "Hay <b>identidades múltiples</b> adjuntas a esta llave pública. <b>Antes de cualquier certificación</b>, <a ng-click=\"doQuickFix('showSelectIdentities')\">verifique otras identidades</a> para elegir la correcta o comuníquese con el propietario de la cuenta.",
    "REVOCATION_SENT": "Revocación enviada",
    "REVOCATION_SENT_WAITING_PROCESS": "La <b>revocación de esta identidad</b> fue solicitada y está en espera de ser procesada.",
    "FEATURES_NOT_IMPLEMENTED": "Esta funcionalidad todavía está en proceso de desarrollo.<br/><br/>¿Por qué no <b>contribuir a Cesium</b>, para obtenerla más rápido? ;)",
    "EMPTY_TX_HISTORY": "Ninguna operación a exportar",
    "LOADING_PENDING_TX": "Espere por favor...<br/><small>(Recuperando operaciones pendientes)</small>"
  },
  "CONFIRM": {
    "CAN_CONTINUE": "¿Desea continuar?",
    "EXIT_APP": "¿ Cerrar la aplicación ?",
    "FULLSCREEN": "¿ Mostrar la aplicación en pantalla completa ?",
    "ISSUE_524_SEND_LOG": "La transacción ha sido rechazada a causa de una anomalía conocida (ticket #524) pero todavía <b>no replicable</b>.<br/><br/>Para ayudar a los/as desarrolladores/as a corregir este error, ¿ <b>acepta el envío de los logs(trazas del programa)</b> ?<br/><small>(ningún dato confidencia será enviado)</small>.",
    "POPUP_TITLE": "<b>Confirmación</b>",
    "POPUP_WARNING_TITLE": "<b>Advertencia</b>",
    "POPUP_SECURITY_WARNING_TITLE": "<i class=\"icon ion-alert-circled\"></i> <b>Advertencia de seguridad</b>",
    "CERTIFY_RULES_TITLE_UID": "Certificar {{uid}}",
    "CERTIFY_RULES": "<b class=\"assertive\">SOLO CERTIFICAR</b> una cuenta si tiene la seguridad de que:<br/><br/><ul><li>1.) Corresponde a un ser humano <b>físico y vivo</b>.</li><li>2.) Su propietario/a <b>NO posee YA otra cuenta</b> ya certificada (pregunta a su entorno si tiene dudas).</li><li>3.) Su propietaria/o cumple y está de acuerdo con la licencia (y certifica a gente del mismo modo)</li><li>4.) Conoce bien al menos a otro de sus certificadores.</li></ul><br/>¿Desea todavía certificar esta identidad?",
    "TRANSFER": "<b>Resumen de la transferencia</b>:<br/><br/><ul><li> - De: {{from}}</li><li> - A: <b>{{to}}</b></li><li> - Importe: <b>{{amount}} {{unit}}</b></li><li> - Comentario: <i>{{comment}}</i></li></ul><br/><b>¿Desea realizar esta transferencia?</b>",
    "TRANSFER_ALL": "<b>Resumen de la transferencia</b>:<br/><br/><ul><li> - De: {{from}}</li><li> - A: <b>{{to}}</b></li><li> - Importe: <b>{{amount}} {{unit}}</b></li><li> - Comentario: <i>{{comment}}</i></li><br/><li> - Resto: <b>{{restAmount}} {{unit}}</b> para <b>{{restTo}}</b></li></ul><br/><b>¿Desea realizar esta transferencia?</b>",
    "MEMBERSHIP_OUT": "Esta operación es <b>irreversible</b>.<br/></br/>¿Desea <b>anular su cuenta miembro</b>?",
    "MEMBERSHIP_OUT_2": "¡Esta operación es <b>irreversible</b>!<br/><br/>¿Desea <b>anular su candidatura</b> como miembro?",
    "LOGIN_UNUSED_WALLET_TITLE": "¿Error de introducción de datos?",
    "LOGIN_UNUSED_WALLET": "Las credenciales introducidas corresponden a una cuenta que parece <b>inactiva</b>.<br/></br/><b>¿Quiere sin embargo continuar con esta cuenta?</b>",
    "FIX_IDENTITY": "El seudónimo <b>{{uid}}</b> va a ser publicado de nuevo, en reemplazo del antiguo que caducó.<br/></br/>¿Desea continuar?",
    "FIX_MEMBERSHIP": "Su solicitud de adhesión como miembro va a ser enviada de nuevo.<br/></br/>¿Desea continuar?",
    "MEMBERSHIP": "Se enviará su solicitud de membresía como miembro.<br/></br/>¿Desea continuar?",
    "RENEW_MEMBERSHIP": "Su adhesión como miembro va a estar renovada.<br/></br/>¿Desea continuar?",
    "REVOKE_IDENTITY": "Va a <b>revocar definitivamente esta identidad</b>.<br/><br/>La llave pública y el seudónimo asociados <b>jamás podrán ser utilizados</b> (para una cuenta miembro). <br/><br/>¿Desea revocar definitivamente esta cuenta?",
    "REVOKE_IDENTITY_2": "¡Esta operación es <b>irreversible</b>!<br/><br/>¿Desea <b>revocar definitivamente</b> esta cuenta?",
    "NOT_NEED_RENEW_MEMBERSHIP": "Su membresía no necesita ser renovada actualmente (caducará en {{membershipExpiresIn|formatDuration}}).<br/></br/><b>¿Confirma</b> querer renovar su membresía?",
    "SAVE_BEFORE_LEAVE": "¿Desea <b>guardar sus cambios</b> antes de abandonar la página?",
    "SAVE_BEFORE_LEAVE_TITLE": "Cambios no registrados",
    "LOGOUT": "¿Desea desconectarse?",
    "USE_FALLBACK_NODE": "Nodo <b>{{old}}</b> inalcanzable o dirección inválida.<br/><br/>¿Desea utilizar temporalmente el nodo <b>{{new}}</b>?",
    "USE_SYNC_FALLBACK_NODE": "El nodo <b>{{old}}</b> parece estar desincronizado.<br/><br/>¿Quieres utilizar temporalmente el nodo sincronizado <b>{{new}}</b>?",
    "ENABLE_EXPERT_MODE_TO_CHANGE_NODE": "<b class=\"assertive\">Advertencia:</b> ¿Quieres <b>cambiar manualmente</b> el nodo?<br/><br/>Si continúas:<ul><li> - Se activará el <b>modo experto</b>;</li><li> - Podrás volver a la selección automática de nodos simplemente <b>desactivando el modo experto</b>.</li></ul>"
  },
  "DOWNLOAD": {
    "POPUP_TITLE": "<b>Revocación del archivo</b>",
    "POPUP_REVOKE_MESSAGE": "Para proteger su cuenta, descargue el <b>documento de revocación de cuenta</b>. Le permitirá cancelar su cuenta (en caso de robo, cambio de identificadores, cuenta creada incorrectamente, etc.).<br/><br/><b>Por favor, almacénelo en un lugar seguro.</b>"
  },
  "HELP": {
    "TITLE": "Ayuda en línea",
    "JOIN": {
      "SECTION": "Inscripción",
      "SALT": "La frase secreta es muy importante. Sirve para mezclar(<span class=\"text-italic\">hash</span>) la contraseña, antes de calcular la <span class=\"text-italic\">llave pública</span> (el número de cuenta) y la <span class=\"text-italic\">llave privada</span> para acceder a esta.<br/><b>Por favor, memorícelo muy bien</b> porque no existe ninguna forma de recuperarlo en caso de pérdida.<br/>No puede ser modificado. Deberá crear una nueva cuenta si lo pierde o se olvida.<br/><br/>Una buena frase secreta debe ser suficientemente larga (al menos 8 carácteres) y lo más original posible.",
      "PASSWORD": "La contraseña es muy importante. Junto a la frase secreta, sirve para calcular la llave pública (el número de cuenta), y la llave privada para acceder a ella.<br/><b>Por favor, memorícela muy bien</b> porque no existe ninguna forma de recuperarla en caso de pérdida (excepto si se tuviese un fichero de respaldo o <span class=\"text-italic\">backup</span>.).<br/>No puede ser modificada. Deberá crear una nueva cuenta si la pierde o se olvida.<br/><br/>Una buena contraseña contiene al menos 8 carácteres, con al menos una mayúscula y un dígito.",
      "PSEUDO": "El seudónimo se utiliza solamente en caso de inscripción como <span class=\"text-italic\">miembro</span>. Siempre está asociado a un monedero (vía su <span class=\"text-italic\">llave pública</span>).<br/>Este se publica en la red para que los demás usuarios puedan identificar, certificar o enviar dinero a la cuenta.<br/>Un seudónimo debe ser único para cada miembro (actuales y antiguos)."
    },
    "LOGIN": {
      "SECTION": "Autenticación",
      "PUBKEY": "Llave pública",
      "PUBKEY_DEF": "La llave pública del archivo de llaves es generada de las credenciales introducidas (cualquiera que sean), sin estar obligatoriamente vinculadas o contrastadas con ninguna cuenta ya usada. <br/><b>Asegúrese por lo tanto de que la llave pública es la misma con la que se creó originalmente su cuenta</b>. De lo contrario, se autogenerará una cuenta vacía que probablemente nunca ha sido usada, ya que el riesgo de coincidir con las credenciales de otra cuenta ajena es muy pequeño.<br/><a href=\"https://es.wikipedia.org/wiki/Criptograf%C3%ADa_de_curva_el%C3%ADptica\" target=\"_ system\">Conozca más sobre criptografía</a> con llaves públicas.",
      "METHOD": "Métodos de autenticación",
      "METHOD_DEF": "Diversas opciones están disponibles para conectar a las cuentas: <br/> - La conexión <b>con aleatoriedad (estándar o avanzada)</b> mezcla su contraseña con su frase secreta, para limitar las posibilidades de ataque<br/> - La conexión <b>usando llave pública</b> le permite entrar sin credenciales, las cuales solo se le pedirán cuando alguna operación lo necesite.<br/> - La conexión <b>usando archivo de llaves</b> leerá las llave pública y privada de la cuenta desde un archivo sin necesitar sus credenciales. Varios formatos son posibles."
    },
    "GLOSSARY": {
      "DISTANCE_RULE": "Regla de distancia",
      "DISTANCE_RULE_DEF": "La regle de distancia de la Red de Confianza define <b>una distancia máxima a respetar</b> entre una candidatura y número mínimo miembros referentes (aquellos más conectados). Esta distancia es calculada utilizando los enlaces de certificación.",
      "WOT": "Red de Confianza (RdC)",
      "WOT_DEF": "La Red de Confianza se compone del conjunto de miembros de la moneda, y de los enlaces de certificaciones que los conectan.",
      "SECTION": "Glosario",
      "PUBKEY_DEF": "Una llave pública identifica un monedero, que puede estar asociado a un miembro o ser un monedero anónimo. En Cesium se calcula a partir de la frase secreta y la contraseña.",
      "MEMBER": "Miembro",
      "MEMBER_DEF": "Cada miembro es una ser humano físico y vivo, deseosa de participar libremente en la comunidad monetaria. Percibe un dividendo universal, de acuerdo a un periodo e importe definido en las <span class=\"text-italic\">reglas de la moneda</span>",
      "CURRENCY_RULES": "Reglas de la moneda",
      "CURRENCY_RULES_DEF": "Las reglas de la moneda se han definido una vez y para siempre. Establecen el funcionamiento de la moneda: el cálculo del dividendo universal, la cantidad de certificaciones necesarias para ser miembro, la cantidad máxima de certificaciones que cada miembro puede emitir, etc. <a href=\"#/app/currency\">Ver las reglas actuales</a>.<br/> Sus parámetros no pueden alterarse gracias a una <span class=\"text-italic\">Cadena de Bloques</span> que soporta, implementa y verifica la buena aplicación de estas reglas.",
      "BLOCKCHAIN": "Cadena de bloques (<span class=\"text-italic\">Blockchain</span>)",
      "BLOCKCHAIN_DEF": "La cadena de bloques es un sistema descentralizado, que en el caso de Duniter, sirve para mantener e implementar las <span class=\"text-italic\">reglas de la moneda</span>.<br/><a href=\"http://duniter.org\" target=\"_system\">Más información</a> acerca de Duniter y el funcionamiento de su cadena de bloques.",
      "UNIVERSAL_DIVIDEND_DEF": "El Dividendo Universal (DU) es la cantidad de moneda co-creada por cada miembro, dependiendo del periodo y del cálculo definidos en las <span class=\"text-italic\">reglas de la moneda</span>.<br/>En cada periodo, los miembros reciben en sus cuentas la misma cantidad de moneda.<br/><br/>El DU crece regularmente, para ser justo entre cada miembro (actualmente y en el futuro), y calculado en función de la esperanza de vida media, como se demuestra en la <span class=\"text-italic\">Teoría Relativa de la Moneda</span> (TRM, de Stéphane Laborde).<br/><a href=\"http://trm.creationmonetaire.info\">Más información</a> sobre la TRM y las monedas libres."
    },
    "TIP": {
      "MENU_BTN_CURRENCY": "El menú <b>{{'MENU.CURRENCY'|translate}}</b> permite consultar las <b>reglas de la moneda</b> y su estado.",
      "CURRENCY_WOT": "El <b>número de miembros</b> muestra el peso de la comunidad y permite <b>seguir su evolución</b>.",
      "CURRENCY_MASS": "Siga aquí la <b>cantidad total de moneda</b> existente y su <b>distribución media</b> por miembro.<br/><br/>Esto permite juzgar la <b>relevancia de un importe</b>, en relación con lo que <b>poseen los demás</b> en sus cuentas (de media).",
      "CURRENCY_UNIT_RELATIVE": "La unidad utilizada (&ldquo;<b>{{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub></b>&rdquo;) significa que los importes en {{currency|capitalize}} han sido divididos entre el valor del <b>Dividendo Universal</b> (DU).<br/><br/><small> Esta unidad relativa es <b>pertinente</b>, porque permanece estable, independiente de la cantidad de moneda que aumenta constantemente.</small>",
      "CURRENCY_CHANGE_UNIT": "Este botón permite <b>cambiar la unidad</b>, para visualizar los importes <b>directamente en {{currency|capitalize}}</b> (en lugar de &ldquo;<b>{{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub></b>&rdquo;).",
      "CURRENCY_CHANGE_UNIT_TO_RELATIVE": "Este botón permite <b>cambiar la unidad</b>, para visualizar los importes en &ldquo;<b>{{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub></b>&rdquo;, es decir, relativo al Dividendo Universal (el monto co-producido por cada miembro).",
      "CURRENCY_RULES": "Las <b>reglas</b> de la moneda fijan su funcionamiento <b>exacto y previsible</b>.<br/><br/>Es el propio ADN de la moneda, que hace que su código monetario sea <b>legible y transparente</b>.",
      "MENU_BTN_NETWORK": "El menú <b>{{'MENU.NETWORK'|translate}}</b> permite consultar el estado de la red.",
      "NETWORK_BLOCKCHAIN": "Todas las transacciones de la moneda están registradas dentro de un gran libro de contabilidad <b>público e infalsificable</b>, conocido como la <b>cadena de bloques</b> (<em>BlockChain</em> en inglés).",
      "NETWORK_PEERS": "Los <b>nodos</b> visibles aquí corresponden a los <b>dispositivos de miembros que actualizan y validan</b> la cadena de bloques.<br/><br/>Cuanto más nodos haya conectados, la moneda tendrá una gestión más <b>descentralizada</b> y digna de confianza.",
      "NETWORK_PEERS_BLOCK_NUMBER": "Este <b>número</b> (en verde) indica el <b>último bloque validado</b> por este nodo (última página escrita en la cadena de bloques).<br/><br/>El color verde indica que este bloque ha sido también validado por <b>la mayoría del resto de nodos</b>.",
      "NETWORK_PEERS_PARTICIPATE": "<b>Cada miembro</b>, equipado de un dispositivo conectado a Internet, <b>puede contribuir añadiendo un nodo</b>.  Necesita <b>instalar el programa Duniter</b> (libre y gratuito). <a href=\"{{installDocUrl}}\" target=\"_system\">Ver manual de uso &gt;&gt;</a>.",
      "MENU_BTN_ACCOUNT": "<b>{{'ACCOUNT.TITLE'|translate}}</b> permite acceder a la gestión y al historial de su cuenta.",
      "MENU_BTN_ACCOUNT_MEMBER": "Consulte aquí el estado de su cuenta y la información sobre sus certificaciones.",
      "WALLET_CERTIFICATIONS": "Haga clic aquí para consultar el detalle de sus certificaciones (recibidas y emitidas).",
      "WALLET_RECEIVED_CERTIFICATIONS": "Haga clic aquí para consultar el detalle de sus <b>certificaciones recibidas</b>.",
      "WALLET_GIVEN_CERTIFICATIONS": "Haga clic aquí para consultar el detalle de sus <b>certificaciones emitidas</b>.",
      "WALLET_BALANCE": "El <b>saldo</b> de su cuenta se visualiza aquí.",
      "WALLET_BALANCE_RELATIVE":
      "{{'HELP.TIP.WALLET_BALANCE'|translate}}<br/><br/>La unidad utilizada (&ldquo;<b>{{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub></b>&rdquo;) significa que el importe en {{currency|capitalize}} fue dividido entre el <b>Dividendo Universal</b> (DU) co-producido por cada miembro.<br/><br/>Actualmente un DU vale {{currentUD|formatInteger}} {{currency|capitalize}}s.",
      "WALLET_BALANCE_CHANGE_UNIT": "Podrá <b>cambiar la unidad</b> de visualización de los importes en los <b><i class=\"icon ion-android-settings\"></i>&nbsp;{{'MENU.SETTINGS'|translate}}</b>.<br/><br/>Por ejemplo, para visualizar los importes <b>directamente en {{currency|capitalize}}</b>, en lugar de unidad relativa.",
      "WALLET_PUBKEY": "Esta es la llave pública de su cuenta. Puede comunicarla a un tercero para que pueda identificar su cuenta de forma simple.",
      "WALLET_SEND": "Realizar un pago en algunos clics",
      "WALLET_SEND_NO_MONEY": "Realizar un pago en algunos clics.<br/>(Su saldo ya no lo permite)",
      "WALLET_OPTIONS": "Este botón permite acceder a las <b>acciones de adhesión</b> y de seguridad.<br/><br/>¡No olvide echar un vistazo!",
      "WALLET_RECEIVED_CERTS": "Se exhibirá aquí la lista de individuo/as que le han certificado.",
      "WALLET_CERTIFY": "El botón <b>{{'WOT.BTN_SELECT_AND_CERTIFY'|translate}}</b> permite seleccionar una identidad y certificarla.<br/><br/>Solo quienes son <b>miembros</b> pueden certificar a otros seres humanos.",
      "WALLET_CERT_STOCK": "Su stock de certificaciones (emitidas) es limitado a <b>{{sigStock}} certificaciones</b>.<br/><br/>Este stock se renueva con el tiempo, a medida que las certificaciones caducan.",
      "MENU_BTN_TX": "El menú <b>{{'MENU.TRANSACTIONS'|translate}}</b> permite consultar su saldo, el historial de transacciones y realizar nuevos pagos.",
      "MENU_BTN_WALLETS": "El menú <b>{{'MENU.WALLETS'|translate}}</b> permite añadir monederos complementarios que usted maneja.",
      "MENU_BTN_WOT": "El menú <b>{{'MENU.WOT'|translate}}</b> permite buscar <b>usuarios</b> de la moneda (miembro o no).",
      "WOT_SEARCH_TEXT_XS": "Para buscar en el directorio, escriba las <b>primeras letras de un seudónimo</b> (o de una llave pública).<br/><br/>La búsqueda se iniciará automáticamente.",
      "WOT_SEARCH_TEXT": "Para buscar en el directorio, escriba las <b>primeras letras de un seudónimo</b> (o de una llave pública). <br/><br/>Luego, pulse en la tecla <b>Intro</b> para iniciar la búsqueda.",
      "WOT_SEARCH_RESULT": "Visualice la ficha detallada <b>haciendo clic</b> sobre una fila.",
      "WOT_VIEW_CERTIFICATIONS": "La opción <b>{{'ACCOUNT.CERTIFICATION_COUNT'|translate}}</b> muestra qué miembros han validado esta identidad.<br/><br/>Estas certificaciones atestiguan que la cuenta pertenece a <b>un ser humano vivo</b> y que no posee <b>ninguna otra cuenta miembro</b>.",
      "WOT_VIEW_CERTIFICATIONS_COUNT": "Necesita al menos <b>{{sigQty}} certificaciones</b> para ser miembro y recibir el <b>Dividendo Universal</b>.",
      "WOT_VIEW_CERTIFICATIONS_CLICK": "Un clic aquí permite abrir <b>la lista de todas las certificaciones</b> de la identidad (recibidas y emitidas).",
      "WOT_VIEW_CERTIFY": "El botón <b>{{'WOT.BTN_CERTIFY'|translate}}</b> permite añadir su certificación a esta identidad.",
      "CERTIFY_RULES": "<b>Atención:</b> Certifique solamente <b>seres humanos físicos vivos</b>, que no posean ya ninguna otra cuenta miembro.<br/><br/>¡La seguridad de la red de la moneda depende del cuidado de cada individuo/a!",
      "MENU_BTN_SETTINGS": "En <b>{{'MENU.SETTINGS'|translate}}</b> podrá configurar la aplicación.",
      "HEADER_BAR_BTN_PROFILE": "Haga clic aquí para acceder a su <b>perfil</b>",
      "SETTINGS_CHANGE_UNIT": "Podrá <b>cambiar la unidad de visualización</b> de los importes haciendo clic aquí.<br/><br/>- Desactive la opción para mostrar los importes en {{currency|capitalize}}.<br/>- Actívela para importes relativos al {{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub> (las cantidades de los importes se mostrarán <b>divididos</b> entre el Dividendo Universal actual).",
      "END_LOGIN": "¡La visita guiada ha <b>terminado</b>!<br/><br/>¡Buena suerte en este nuevo mundo de la <b>economía libre</b> !",
      "END_NOT_LOGIN": "¡La visita guiada ha <b>terminado</b>!<br/><br/>Si quiere utilizar la moneda {{currency|capitalize}}, tiene que hacer un clic en <b>{{'LOGIN.CREATE_ACCOUNT'|translate}}</b> más abajo."
    }
  }
}
);

$translateProvider.translations("fr-FR", {
  "COMMON": {
    "APP_NAME": "Cesium",
    "APP_VERSION": "v{{version}}",
    "APP_BUILD": "date : {{build}}",
    "PUBKEY": "Clé publique",
    "MEMBER": "Membre",
    "BLOCK" : "Bloc",
    "BTN_OK": "OK",
    "BTN_YES": "Oui",
    "BTN_NO": "Non",
    "BTN_SEND": "Envoyer",
    "BTN_SEND_MONEY": "Faire un virement",
    "BTN_SEND_MONEY_SHORT": "Virement",
    "BTN_SAVE": "Enregistrer",
    "BTN_YES_SAVE": "Oui, Enregistrer",
    "BTN_YES_CONTINUE": "Oui, Continuer",
    "BTN_SHOW": "Voir",
    "BTN_SHOW_PUBKEY": "Afficher la clé publique",
    "BTN_RELATIVE_UNIT": "Afficher les montants en DU ?",
    "BTN_BACK": "Retour",
    "BTN_NEXT": "Suivant",
    "BTN_IMPORT": "Importer",
    "BTN_CANCEL": "Annuler",
    "BTN_CLOSE": "Fermer",
    "BTN_LATER": "Plus tard",
    "BTN_LOGIN": "Se connecter",
    "BTN_LOGOUT": "Déconnexion",
    "BTN_ADD_ACCOUNT": "Nouveau compte",
    "BTN_SHARE": "Partager",
    "BTN_EDIT": "Modifier",
    "BTN_DELETE": "Supprimer",
    "BTN_ADD": "Ajouter",
    "BTN_SEARCH": "Rechercher",
    "BTN_REFRESH": "Actualiser",
    "BTN_RETRY": "Recommencer",
    "BTN_START": "Commencer",
    "BTN_CONTINUE": "Continuer",
    "BTN_CREATE": "Créer",
    "BTN_UNDERSTOOD": "J'ai compris",
    "BTN_OPTIONS": "Options",
    "BTN_HELP_TOUR": "Visite guidée",
    "BTN_HELP_TOUR_SCREEN": "Découvrir cet écran",
    "BTN_DOWNLOAD": "Télécharger",
    "BTN_DOWNLOAD_ACCOUNT_STATEMENT": "Télécharger le relevé du compte",
    "BTN_MODIFY": "Modifier",
    "CHOOSE_FILE": "Déposez votre fichier <br/>ou cliquez pour le sélectionner",
    "DAYS": "jours",
    "NO_ACCOUNT_QUESTION": "Pas encore de compte ? Créez-en un gratuitement !",
    "SEARCH_NO_RESULT": "Aucun résultat trouvé",
    "LOADING": "Veuillez patienter...",
    "LOADING_WAIT": "Veuillez patienter...<br/><small>(Cesium interroge le nœud Duniter)</small>",
    "SEARCHING": "Recherche en cours...",
    "FROM": "De",
    "TO": "À",
    "COPY": "Copier",
    "LANGUAGE": "Langue",
    "UNIVERSAL_DIVIDEND": "Dividende universel",
    "UD": "DU",
    "DATE_PATTERN": "DD/MM/YY HH:mm",
    "DATE_FILE_PATTERN": "YYYY-MM-DD",
    "DATE_SHORT_PATTERN": "DD/MM/YY",
    "DATE_MONTH_YEAR_PATTERN": "MM/YYYY",
    "EMPTY_PARENTHESIS": "(vide)",
    "UID": "Pseudonyme",
    "ENABLE": "Activé",
    "DISABLE": "Désactivé",
    "RESULTS_LIST": "Résultats",
    "RESULTS_COUNT": "{{count}} résultats",
    "EXECUTION_TIME": "exécuté en {{duration|formatDurationMs}}",
    "SHOW_VALUES": "Afficher les valeurs en clair ?",
    "POPOVER_ACTIONS_TITLE": "Options",
    "POPOVER_FILTER_TITLE": "Filtres",
    "SHOW_MORE": "Afficher plus",
    "SHOW_MORE_COUNT": "(limite actuelle à {{limit}})",
    "POPOVER_SHARE": {
      "TITLE": "Partager",
      "SHARE_ON_TWITTER": "Partager sur Twitter",
      "SHARE_ON_FACEBOOK": "Partager sur Facebook",
      "SHARE_ON_DIASPORA": "Partager sur Diaspora*",
      "SHARE_ON_GOOGLEPLUS": "Partager sur Google+"
    },
    "FILE": {
      "DATE": "Date :",
      "TYPE": "Type :",
      "SIZE": "Taille :",
      "VALIDATING": "Validation en cours..."
    }
  },
  "SYSTEM": {
    "PICTURE_CHOOSE_TYPE": "Choisir la source :",
    "BTN_PICTURE_GALLERY": "Galerie",
    "BTN_PICTURE_CAMERA": "<b>Caméra</b>"
  },
  "MENU": {
    "HOME": "Accueil",
    "WOT": "Annuaire",
    "CURRENCY": "Monnaie",
    "ACCOUNT": "Mon compte",
    "WALLETS": "Mes portefeuilles",
    "SETTINGS": "Paramètres",
    "NETWORK": "Réseau",
    "TRANSACTIONS": "Mes opérations"
  },
  "ABOUT": {
    "TITLE": "À propos",
    "LICENSE": "Application <b>libre</b> (Licence GNU AGPLv3).",
    "LATEST_RELEASE": "Il existe une <b>version plus récente</b> de {{'COMMON.APP_NAME'|translate}} (<b>v{{version}}</b>)",
    "PLEASE_UPDATE": "Veuillez mettre à jour {{'COMMON.APP_NAME'|translate}} (dernière version : <b>v{{version}}</b>)",
    "CODE": "Code source :",
    "OFFICIAL_WEB_SITE": "Site web officiel :",
    "DEVELOPERS": "Développé par :",
    "FORUM": "Forum :",
    "PLEASE_REPORT_ISSUE": "N'hésitez pas à nous remonter les anomalies rencontrées",
    "REPORT_ISSUE": "Remonter un problème",
    "BTN_OPEN_DEV_WINDOW": "Ouvrir la fenêtre de debuggage"
  },
  "HOME": {
    "TITLE": "Cesium",
    "WELCOME": "Bienvenue dans l'application Cesium !",
    "WELCOME_READONLY": "Bienvenue dans Cesium <span class='badge badge-balanced'>Monit</span> !",
    "MESSAGE": "Recevez et envoyez de la monnaie libre {{currency|abbreviate}}",
    "MESSAGE_READONLY": "Suivez l'état de la monnaie libre {{currency|abbreviate}} en temps réel.",
    "BTN_CURRENCY": "Explorer la monnaie {{currency|abbreviate}}",
    "BTN_ABOUT": "à propos",
    "BTN_HELP": "Aide en ligne",
    "BTN_NETWORK": "État du réseau",
    "FREE_SOFTWARE": "Logiciel libre",
    "FORK_ME": "Clonez-moi !",
    "SHOW_LICENSE": "Voir la license de l'application",
    "REPORT_ISSUE": "anomalie",
    "NOT_YOUR_ACCOUNT_QUESTION" : "Vous n'êtes pas propriétaire du compte <b class=\"ion-key\"> {{pubkey|formatPubkey}}</b>&nbsp;?",
    "BTN_CHANGE_ACCOUNT": "Déconnecter ce compte",
    "PEER_CONNECTION_ERROR": "Nœud <b>{{server}}</b> injoignable ou adresse invalide.<br/><br/>Vérifiez votre connexion Internet, ou changer de nœud <a class=\"positive\" ng-click=\"doQuickFix('settings')\">dans les paramètres</a>.",
    "NETWORK_CONNECTION_ERROR": "Réseau injoignable.<br/><br/>Vérifiez votre connexion Internet, ou sélectionnez un nœud manuellement <a class=\"positive\" ng-click=\"doQuickFix('settings')\">dans les paramètres</a>.",
    "SHOW_ALL_FEED": "Voir tout",
    "READ_MORE": "Lire la suite",
    "FEED_SOURCE": "Source"
  },
  "SETTINGS": {
    "TITLE": "Paramètres",
    "DISPLAY_DIVIDER": "Affichage",
    "STORAGE_DIVIDER": "Stockage",
    "NETWORK_SETTINGS": "Réseau",
    "PEER": "Nœud Duniter",
    "PEER_CHANGED_TEMPORARY": "Adresse utilisée temporairement",
    "PEER_SELECTED_AUTOMATICALLY": "Sélection automatiquement du nœud au démarrage",
    "NETWORK_ANALYZE_TIMEOUT": "Délai d'attente maximal (timeout)",
    "NETWORK_ANALYZE_TIMEOUT_HELP": "Délai d'attente maximal pour l'analyse du réseau",
    "NETWORK_ANALYZE_TIMEOUT_AUTO": "Auto",
    "PERSIST_CACHE": "Conserver les données de navigation (expérimental)",
    "PERSIST_CACHE_HELP": "Permet une navigation plus rapide, en conservant localement les données reçues, pour les utiliser d'une session à l'autre.",
    "USE_LOCAL_STORAGE": "Activer le stockage local",
    "USE_LOCAL_STORAGE_HELP": "Permet de sauvegarder vos paramètres",
    "WALLETS_SETTINGS": "Mes portefeuilles",
    "USE_WALLETS_ENCRYPTION": "Sécuriser la liste ?",
    "USE_WALLETS_ENCRYPTION_HELP": "Permet de sécuriser la liste de vos portefeuilles (par chiffrement), en exigeant une authentification pour y accéder.",
    "ENABLE_HELPTIP": "Activer les bulles d'aide contextuelles ?",
    "DISABLE_HELPTIP": "Désactiver les bulles d'aide contextuelles",
    "ENABLE_UI_EFFECTS": "Activer les effets visuels ?",
    "ENABLE_UI_EFFECTS_HELP": "Transition entre les pages, animation des listes, etc.",
    "HISTORY_SETTINGS": "Mes opérations",
    "DISPLAY_UD_HISTORY": "Afficher les dividendes produits ?",
    "TX_HISTORY_AUTO_REFRESH": "Rafraîchir automatiquement",
    "TX_HISTORY_AUTO_REFRESH_HELP": "Rafraîchit le solde et les opérations automatiquement, à chaque nouveau bloc du réseau.",
    "AUTHENTICATION_SETTINGS": "Authentification",
    "KEEP_AUTH": "Désauthentification automatique",
    "KEEP_AUTH_SHORT": "Désauthentification",
    "KEEP_AUTH_HELP": "Définit le moment où l'authentification est nettoyée de la mémoire.",
    "KEEP_AUTH_OPTION": {
      "NEVER": "Après chaque opération",
      "SECONDS": "Après {{value}}s d'inactivité",
      "MINUTE": "Après {{value}}min d'inactivité",
      "MINUTES": "Après {{value}}min d'inactivité",
      "HOUR": "Après {{value}}h d'inactivité",
      "ALWAYS": "A la fin de la session"
    },
    "KEYRING_FILE": "Fichier de trousseau",
    "KEYRING_FILE_HELP": "Permet de vous <b>connecter</b> automatiquement à chaque lancement<br/>et même de vous <b>authentifier</b> (seulement si \"Expiration de l'authentification\" est configurée \"à la fin de la session\").",
    "REMEMBER_ME": "Se souvenir de moi ?",
    "REMEMBER_ME_HELP": "Permet de rester identifié d'une session à l'autre, en conservant localement la clé publique.",
    "PLUGINS_SETTINGS": "Extensions",
    "BTN_RESET": "Restaurer les valeurs par défaut",
    "EXPERT_MODE": "Activer le mode expert",
    "EXPERT_MODE_HELP": "Permet un affichage plus détaillé.",
    "BLOCK_VALIDITY_WINDOW": "Délai d'incertitude des blocs",
    "BLOCK_VALIDITY_WINDOW_SHORT": "Délai d'incertitude",
    "BLOCK_VALIDITY_WINDOW_HELP": "Délai avant de considérer qu'une information est validée",
    "BLOCK_VALIDITY_OPTION": {
      "NONE": "Aucun délai",
      "N": "{{time | formatDuration}} ({{count}} blocs)"
    },
    "POPUP_PEER": {
      "TITLE": "Nœud Duniter",
      "HOST": "Adresse",
      "HOST_HELP": "Adresse : serveur:port",
      "USE_SSL": "Sécurisé ?",
      "USE_SSL_HELP": "Chiffrement SSL",
      "BTN_SHOW_LIST": "Liste des noeuds"
    }
  },
  "BLOCKCHAIN": {
    "HASH": "Hash : {{hash}}",
    "VIEW": {
      "HEADER_TITLE": "Bloc #{{number}}-{{hash|formatHash}}",
      "TITLE_CURRENT": "Bloc courant",
      "TITLE": "Bloc #{{number|formatInteger}}",
      "COMPUTED_BY": "Calculé par le nœud de",
      "SHOW_RAW": "Voir le fichier brut",
      "TECHNICAL_DIVIDER": "Informations techniques",
      "VERSION": "Version du format",
      "HASH": "Hash calculé",
      "UNIVERSAL_DIVIDEND_HELP": "Monnaie co-produite par chacun des {{membersCount}} membres",
      "EMPTY": "Aucune donnée dans ce bloc",
      "POW_MIN": "Difficulté minimale",
      "POW_MIN_HELP": "Difficulté imposée pour le calcul du hash",
      "DATA_DIVIDER": "Données",
      "IDENTITIES_COUNT": "Nouvelles identités",
      "JOINERS_COUNT": "Nouveaux membres",
      "ACTIVES_COUNT": "Renouvellements",
      "ACTIVES_COUNT_HELP": "Membres ayant renouvelé leur adhésion",
      "LEAVERS_COUNT": "Membres sortants",
      "LEAVERS_COUNT_HELP": "Membres ne souhaitant plus de certification",
      "EXCLUDED_COUNT": "Membres exclus",
      "EXCLUDED_COUNT_HELP": "Anciens membres exclus par non renouvellement ou manque de certifications",
      "REVOKED_COUNT": "Identités révoquées",
      "REVOKED_COUNT_HELP": "Ces comptes ne pourront plus être membres",
      "TX_COUNT": "Transactions",
      "CERT_COUNT": "Certifications",
      "TX_TO_HIMSELF": "Opération de change",
      "TX_OUTPUT_UNLOCK_CONDITIONS": "Conditions de déblocage",
      "TX_OUTPUT_OPERATOR": {
        "AND": "et",
        "OR": "ou"
      },
      "TX_OUTPUT_FUNCTION": {
        "SIG": "<b>Signature</b> de ",
        "XHX": "<b>Mot de passe</b>, dont SHA256 =",
        "CSV": "Bloqué pendant",
        "CLTV": "Bloqué jusqu'à"
      }
    },
    "LOOKUP": {
      "TITLE": "Blocs",
      "NO_BLOCK": "Aucun bloc",
      "LAST_BLOCKS": "Derniers blocs :",
      "BTN_COMPACT": "Compacter"
    }
  },
  "CURRENCY": {
    "VIEW": {
      "TITLE": "Monnaie",
      "TAB_CURRENCY": "Monnaie",
      "TAB_WOT": "Toile de confiance",
      "TAB_NETWORK": "Réseau",
      "TAB_BLOCKS": "Blocs",
      "CURRENCY_SHORT_DESCRIPTION": "{{currency|abbreviate}} est une <b>monnaie libre</b>, démarrée {{firstBlockTime|formatFromNow}}. Elle compte actuellement <b>{{N}} membres</b>, qui produisent et perçoivent un <a ng-click=\"showHelpModal('ud')\">Dividende Universel</a> (DU), chaque {{dt|formatPeriod}}.",
      "NETWORK_RULES_DIVIDER": "Règles du réseau",
      "CURRENCY_NAME": "Nom de la monnaie",
      "MEMBERS": "Nombre de membres",
      "MEMBERS_VARIATION": "Variation depuis le dernier DU",
      "MONEY_DIVIDER": "Monnaie",
      "MASS": "Masse monétaire",
      "SHARE": "Masse par membre",
      "UD": "Dividende universel",
      "C_ACTUAL": "Croissance actuelle",
      "MEDIAN_TIME": "Heure de la blockchain",
      "POW_MIN": "Niveau minimal de difficulté de calcul",
      "MONEY_RULES_DIVIDER": "Règles de la monnaie",
      "C_RULE": "Croissance théorique cible",
      "UD_RULE": "Calcul du dividende universel",
      "DT_REEVAL": "Période de revalorisation du DU",
      "REEVAL_SYMBOL": "reval",
      "DT_REEVAL_VALUE": "Tous les <b>{{dtReeval|formatDuration}}</b> ({{dtReeval/86400}} {{'COMMON.DAYS'|translate}})",
      "UD_REEVAL_TIME0": "Date de la 1ère revalorisation",
      "SIG_QTY_RULE": "Nombre de certifications requises pour devenir membre",
      "SIG_STOCK": "Nombre maximal de certifications émises par membre",
      "SIG_PERIOD": "Délai minimal d'attente entre 2 certifications successives émises par une même personne",
      "SIG_WINDOW": "Délai limite de prise en compte d'une certification",
      "SIG_VALIDITY": "Durée de vie d'une certification qui a été prise en compte",
      "MS_WINDOW": "Délai limite de prise en compte d'une demande d'adhésion comme membre",
      "MS_VALIDITY": "Durée de vie d'une adhésion qui a été prise en compte",
      "STEP_MAX": "Distance maximale, par les certifications, entre un nouvel entrant et les membres référents",
      "WOT_RULES_DIVIDER": "Règles de la toile de confiance",
      "SENTRIES": "Nombre de certifications (émises <b>et</b> reçues) pour devenir membre référent",
      "SENTRIES_FORMULA": "Nombre de certifications (émises <b>et</b> reçues) pour devenir membre référent (formule)",
      "XPERCENT":"Pourcentage minimum de membres référents à atteindre pour respecter la règle de distance",
      "AVG_GEN_TIME": "Temps moyen entre deux blocs",
      "CURRENT": "actuel",
      "MATH_CEILING": "PLAFOND",
      "DISPLAY_ALL_RULES": "Afficher toutes les règles ?",
      "BTN_SHOW_LICENSE": "Voir la licence",
      "WOT_DIVIDER": "Toile de confiance"
    },
    "LICENSE": {
      "TITLE": "Licence de la monnaie",
      "BTN_DOWNLOAD": "Télécharger le fichier",
      "NO_LICENSE_FILE": "Fichier de licence non trouvé."
    }
  },
  "NETWORK": {
    "VIEW": {
      "MEDIAN_TIME": "Heure de la blockchain",
      "NODE_ADDRESS": "Adresse :",
      "SOFTWARE": "Logiciel",
      "WARN_PRE_RELEASE": "Pré-version (dernière version stable : <b>{{version}}</b>)",
      "WARN_NEW_RELEASE": "Version <b>{{version}}</b> disponible",
      "WS2PID": "Identifiant :",
      "PRIVATE_ACCESS": "Accès privé",
      "POW_PREFIX": "Préfixe de preuve de travail :",
      "ENDPOINTS": {
        "BMAS": "Interface sécurisée (SSL)",
        "BMATOR": "Interface réseau TOR",
        "WS2P": "Interface WS2P",
        "GVA": "Interface GVA",
        "ES_USER_API": "Nœud de données Cesium+"
      }
    },
    "INFO": {
      "CONNECTING_TO_NETWORK": "Connexion au réseau...",
      "ANALYZING_NETWORK": "Analyse du réseau {{currency|abbreviate}}...",
      "ONLY_SSL_PEERS": "Les nœuds non SSL ont un affichage dégradé, car Cesium fonctionne en mode HTTPS."
    }
  },
  "PEER": {
    "PEERS": "Nœuds",
    "SIGNED_ON_BLOCK": "Signé sur le bloc",
    "MIRROR": "miroir",
    "MIRRORS": "Miroirs",
    "MIRROR_PEERS": "Nœuds miroirs",
    "PEER_LIST" : "Liste des nœuds",
    "MEMBERS" : "Membres",
    "MEMBER_PEERS" : "Nœuds membres",
    "ALL_PEERS" : "Tous les nœuds",
    "DIFFICULTY" : "Difficulté",
    "API" : "API",
    "CURRENT_BLOCK" : "Bloc #",
    "POPOVER_FILTER_TITLE": "Filtre",
    "OFFLINE": "Hors ligne",
    "OFFLINE_PEERS": "Nœuds hors ligne",
    "BTN_SHOW_PEER": "Voir le nœud",
    "VIEW": {
      "TITLE": "Nœud",
      "OWNER": "Appartient à",
      "SHOW_RAW_PEERING": "Voir la fiche de pair",
      "SHOW_RAW_CURRENT_BLOCK": "Voir le dernier bloc (format brut)",
      "LAST_BLOCKS": "Derniers blocs connus",
      "KNOWN_PEERS": "Nœuds connus :",
      "GENERAL_DIVIDER": "Informations générales",
      "ERROR": {
        "LOADING_TOR_NODE_ERROR": "Récupération des informations du nœud impossible. Le délai d'attente est dépassé.",
        "LOADING_NODE_ERROR": "Récupération des informations du nœud impossible"
      }
    }
  },
  "WOT": {
    "SEARCH_HELP": "Recherche (pseudo ou clé publique)",
    "SEARCH_INIT_PHASE_WARNING": "Durant la phase de pré-inscription, la recherche des inscriptions en attente <b>peut être longue</b>. Merci de patienter...",
    "REGISTERED_SINCE": "Inscrit le",
    "REGISTERED_SINCE_BLOCK": "Inscrit au bloc #",
    "NO_CERTIFICATION": "Aucune certification validée",
    "NO_GIVEN_CERTIFICATION": "Aucune certification émise",
    "NOT_MEMBER_PARENTHESIS": "(non membre)",
    "IDENTITY_REVOKED_PARENTHESIS": "(identité révoquée)",
    "MEMBER_PENDING_REVOCATION_PARENTHESIS": "(en cours de révocation)",
    "EXPIRE_IN": "Expiration",
    "NOT_WRITTEN_EXPIRE_IN": "Date limite<br/>de traitement",
    "EXPIRED": "Expiré",
    "PSEUDO": "Pseudonyme",
    "SIGNED_ON_BLOCK": "Emise au bloc #{{block}}",
    "WRITTEN_ON_BLOCK": "Ecrite au bloc #{{block}}",
    "GENERAL_DIVIDER": "Informations générales",
    "NOT_MEMBER_ACCOUNT": "Compte simple (non membre)",
    "NOT_MEMBER_ACCOUNT_HELP": "Il s'agit d'un simple portefeuille, sans demande d'adhésion en attente.",
    "TECHNICAL_DIVIDER": "Informations techniques",
    "BTN_CERTIFY": "Certifier",
    "BTN_YES_CERTIFY": "Oui, certifier",
    "BTN_SELECT_AND_CERTIFY": "Nouvelle certification",
    "ACCOUNT_OPERATIONS": "Opérations sur le compte",
    "VIEW": {
      "POPOVER_SHARE_TITLE": "Identité {{title}}"
    },
    "LOOKUP": {
      "TITLE": "Toile de confiance",
      "NEWCOMERS": "Nouveaux membres",
      "NEWCOMERS_COUNT": "{{count}} membres",
      "PENDING": "Inscriptions en attente",
      "PENDING_COUNT": "{{count}} inscriptions en attente",
      "REGISTERED": "Inscrit {{sigDate | formatFromNow}}",
      "MEMBER_FROM": "Membre depuis {{memberDate|medianFromNowShort}}",
      "BTN_NEWCOMERS": "Nouveaux membres",
      "BTN_PENDING": "Inscriptions en attente",
      "SHOW_MORE": "Afficher plus",
      "SHOW_MORE_COUNT": "(limite actuelle à {{limit}})",
      "NO_PENDING": "Aucune inscription en attente.",
      "NO_NEWCOMERS": "Aucun membre."
    },
    "CONTACTS": {
      "TITLE": "Contacts"
    },
    "MODAL": {
      "TITLE": "Recherche"
    },
    "CERTIFICATIONS": {
      "TITLE": "{{uid}} - Certifications",
      "SUMMARY": "Certifications reçues",
      "LIST": "Détail des certifications reçues",
      "PENDING_LIST": "Certifications en attente de traitement",
      "RECEIVED": "Certifications reçues",
      "RECEIVED_BY": "Certifications reçues par {{uid}}",
      "ERROR": "Certifications reçues en erreur",
      "SENTRY_MEMBER": "Membre référent"
    },
    "OPERATIONS": {
      "TITLE": "{{uid}} - Opérations"
    },
    "GIVEN_CERTIFICATIONS": {
      "TITLE": "{{uid}} - Certifications émises",
      "SUMMARY": "Certifications émises",
      "LIST": "Détail des certifications émises",
      "PENDING_LIST": "Certifications en attente de traitement",
      "SENT": "Certifications émises",
      "SENT_BY": "Certifications émises par {{uid}}",
      "ERROR": "Certifications émises en erreur"
    }
  },
  "LOGIN": {
    "TITLE": "<i class=\"icon ion-log-in\"></i> Connexion",
    "SCRYPT_FORM_HELP": "Veuillez saisir vos identifiants.<br>Pensez à vérifier que la clé publique est celle de votre compte.",
    "PUBKEY_FORM_HELP": "Veuillez saisir une clé publique de compte :",
    "FILE_FORM_HELP": "Choisissez le fichier de trousseau à utiliser :",
    "SCAN_FORM_HELP": "Scanner le QR code d'un portefeuille.",
    "SALT": "Identifiant secret",
    "SALT_HELP": "Identifiant secret",
    "SHOW_SALT": "Afficher l'identifiant secret ?",
    "PASSWORD": "Mot de passe",
    "PASSWORD_HELP": "Mot de passe",
    "PUBKEY_HELP": "Clé publique ou pseudonyme",
    "NO_ACCOUNT_QUESTION": "Vous n'avez pas encore de compte ?",
    "HAVE_ACCOUNT_QUESTION": "Vous avez déjà un compte ?",
    "CREATE_ACCOUNT": "Créer un compte...",
    "CREATE_FREE_ACCOUNT": "Créer un compte gratuitement",
    "FORGOTTEN_ID": "Mot de passe oublié ?",
    "ASSOCIATED_PUBKEY": "Clé publique du trousseau :",
    "BTN_METHODS": "Autres méthodes",
    "BTN_METHODS_DOTS": "Changer de méthode...",
    "METHOD_POPOVER_TITLE": "Méthodes",
    "MEMORIZE_AUTH_FILE": "Mémoriser ce trousseau le temps de la session de navigation",
    "SCRYPT_PARAMETERS": "Paramètres (Scrypt) :",
    "AUTO_LOGOUT": {
      "TITLE": "Information",
      "MESSAGE": "<i class=\"ion-android-time\"></i> Vous avez été <b>déconnecté</b> automatiquement, suite à une inactivité prolongée.",
      "BTN_RELOGIN": "Me reconnecter",
      "IDLE_WARNING": "Vous allez être déconnecté... {{countdown}}"
    },
    "METHOD": {
      "SCRYPT_DEFAULT": "Identifiant secret et mot de passe",
      "SCRYPT_ADVANCED": "Salage avancé",
      "FILE": "Fichier de trousseau",
      "PUBKEY": "Clé publique ou pseudonyme",
      "SCAN": "Scanner un QR code"
    },
    "SCRYPT": {
      "SIMPLE": "Salage léger",
      "DEFAULT": "Salage standard",
      "SECURE": "Salage sûr",
      "HARDEST": "Salage le plus sûr",
      "EXTREME": "Salage extrême",
      "USER": "Salage personnalisé",
      "N": "N (Loop):",
      "r": "r (RAM):",
      "p": "p (CPU):"
    },
    "FILE": {
      "HELP": "Format de fichier attendu : <b>.yml</b> ou <b>.dunikey</b> (type PubSec, WIF ou EWIF)."
    }
  },
  "AUTH": {
    "TITLE": "<i class=\"icon ion-locked\"></i> Authentification",
    "BTN_AUTH": "S'authentifier",
    "GENERAL_HELP": "Veuillez vous authentifier :",
    "EXPECTED_UID_HELP": "Veuillez vous authentifier sur le compte <i class=\"ion-person\"></i> {{uid}} :",
    "EXPECTED_PUBKEY_HELP": "Veuillez vous authentifier sur le portefeuille <br class=\"visible-xs\"/><i class=\"ion-key\"></i> {{pubkey|formatPubkey}} :",
    "SCAN_FORM_HELP": "Scanner le QR code de la <b>clef privée</b> du portefeuille."
  },
  "ACCOUNT": {
    "TITLE": "Mon compte",
    "BALANCE": "Solde",
    "LAST_TX": "Dernières transactions validées",
    "BALANCE_ACCOUNT": "Solde du compte",
    "NO_TX": "Aucune transaction",
    "SHOW_MORE_TX": "Afficher plus",
    "SHOW_ALL_TX": "Afficher tout",
    "TX_FROM_DATE": "(limite actuelle à {{fromTime|medianFromNowShort}})",
    "PENDING_TX": "Transactions en attente de traitement",
    "VALIDATING_TX": "Transactions traitées, non validées",
    "ERROR_TX": "Transactions non exécutées",
    "ERROR_TX_SENT": "Transactions envoyées en échec",
    "PENDING_TX_RECEIVED": "Transactions en attente de réception",
    "EVENTS": "Evénements",
    "OUT_DISTANCED": "Vos certifications actuelles proviennent d'un groupe trop isolé de la <a ng-click=\"showHelpModal('wot')\">Toile de Confiance</a> (TdC) : la <a ng-click=\"showHelpModal('distance_rule')\">règle de distance maximale</a> n'est pas respectée.<br/>Vous devez obtenir des certifications provenant d'autres secteurs de la TdC, ou bien attendre que celle-ci se resserre.",
    "WAITING_MEMBERSHIP": "Demande d'adhésion envoyée. En attente d'acceptation.",
    "WAITING_CERTIFICATIONS": "Vous devez <b>obtenir {{needCertificationCount}} certification(s)</b> pour devenir membre et produire le <a ng-click=\"showHelpModal('ud')\">Dividende Universel</a>. Votre compte est cependant déjà opérationnel, pour recevoir et effectuer des paiements.",
    "WAITING_CERTIFICATIONS_HELP": "Pour obtenir vos certifications, sollicitez uniquement des membres <b>qui vous connaissent suffisamment</b>, comme l'exige <a ng-click=\"showLicenseModal()\">la licence de la monnaie</a> que vous avez acceptée.<br/>Si vous ne connaissez pas (encore) suffisamment de membres, allez aux rencontres ou proposez en sur <a ng-click=\"openLink($event, $root.settings.userForumUrl)\">le forum utilisateur</a>.",
    "WILL_MISSING_CERTIFICATIONS": "Vous allez bientôt <b>manquer de certifications</b> (au moins {{willNeedCertificationCount}} sont requises)",
    "WILL_NEED_RENEW_MEMBERSHIP": "Votre adhésion comme membre <b>va expirer {{membershipExpiresIn|formatDurationTo}}</b>. Pensez à <a ng-click=\"doQuickFix('renew')\">renouveler votre adhésion</a> d'ici là.",
    "NEED_RENEW_MEMBERSHIP": "Vous n'êtes plus membre de la monnaie, car <b>votre adhésion a expiré</b>. Pensez à <a ng-click=\"doQuickFix('renew')\">renouveler votre adhésion</a>.",
    "NEED_RENEW_MEMBERSHIP_AFTER_CANCELLED": "Vous n'êtes plus membre de la monnaie, <b>pour manque de certifications</b>. Pensez à <a ng-click=\"doQuickFix('renew')\">renouveler votre adhésion</a>.",
    "NO_WAITING_MEMBERSHIP": "Aucune demande d'adhésion en attente. Si vous souhaitez <b>devenir membre</b>, pensez à <a ng-click=\"doQuickFix('membership')\">envoyer la demande d'adhésion</a>.",
    "CERTIFICATION_COUNT": "Certifications reçues",
    "CERTIFICATION_COUNT_SHORT": "Certifications",
    "SIG_STOCK": "Certifications envoyées",
    "BTN_RECEIVE_MONEY": "Encaisser",
    "BTN_SELECT_ALTERNATIVES_IDENTITIES": "Basculer vers une autre identité...",
    "BTN_FIX_MEMBERSHIP": "Renvoyer la demande d'adhésion...",
    "BTN_MEMBERSHIP_RENEW": "Renouveler l'adhésion",
    "BTN_MEMBERSHIP_RENEW_DOTS": "Renouveler l'adhésion...",
    "BTN_MEMBERSHIP_OUT_DOTS": "Arrêter l'adhésion...",
    "BTN_SECURITY_DOTS": "Compte et sécurité...",
    "BTN_SHOW_DETAILS": "Afficher les infos techniques",
    "LOCKED_OUTPUTS_POPOVER": {
      "TITLE": "Montant verrouillé",
      "DESCRIPTION": "Voici les conditions de déverrouillage de ce montant :",
      "DESCRIPTION_MANY": "Cette transaction est composé de plusieurs parties, dont voici les conditions de déverrouillage :",
      "LOCKED_AMOUNT": "Conditions pour le montant :"
    },
    "NEW": {
      "TITLE": "Création de compte",
      "INTRO_WARNING_TIME": "La création d'un compte sur {{name|capitalize}} est très simple. Veuillez néanmoins prendre suffisament de temps pour faire correctement cette formalité (pour ne pas oublier les identifiants, mots de passe, etc.).",
      "INTRO_WARNING_SECURITY": "Vérifiez que le matériel que vous utilisez actuellement (ordinateur, tablette, téléphone) <b>est sécurisé et digne de confiance</b>.",
      "INTRO_WARNING_SECURITY_HELP": "Anti-virus à jour, pare-feu activé, session protégée par mot de passe ou code pin, etc.",
      "INTRO_HELP": "Cliquez sur <b>{{'COMMON.BTN_START'|translate}}</b> pour débuter la création de compte. Vous serez guidé étape par étape.",
      "REGISTRATION_NODE": "Votre inscription sera enregistrée via le nœud Duniter <b>{{server}}</b>, qui le diffusera ensuite au reste du réseau de la monnaie.",
      "REGISTRATION_NODE_HELP": "Si vous ne faites pas confiance en ce nœud, veuillez en changer <a ng-click=\"doQuickFix('settings')\">dans les paramètres</a> de Cesium.",
      "SELECT_ACCOUNT_TYPE": "Choisissez le type de compte à créer :",
      "MEMBER_ACCOUNT": "Compte membre",
      "MEMBER_ACCOUNT_TITLE": "Création d'un compte membre",
      "MEMBER_ACCOUNT_HELP": "Vous connaissez suffisamment la monnaie libre et vous voulez participer à sa co-création ?<br/>En tant qu'individu, vous pouvez créer votre compte membre (un seul par individu). Celui-ci fonctionne comme un compte simple portefeuille, mais permet en plus de co-produire la monnaie, en <b>recevant chaque {{parameters.dt|formatPeriod}} un dividende universel</b> : à vous ensuite d'en faire bon usage !",
      "WALLET_ACCOUNT": "Compte simple portefeuille",
      "WALLET_ACCOUNT_TITLE": "Création d'un portefeuille",
      "WALLET_ACCOUNT_HELP": "Vous <b>découvrez la monnaie libre</b> ? Vous avez besoin d'un compte supplémentaire ?<br/>Ce type de compte vous conviendra. Bien qu'il ne co-produise la monnaie (contrairement à un compte membre - voir ci-dessous), vous pourrez y recevoir et envoyer des paiements, dès la fin de l'inscription.<br/>Si besoin, vous pourrez le transformer en compte membre ultérieurement.",
      "SALT_WARNING": "Choisissez votre identifiant secret.<br/>Il vous sera demandé à chaque connexion sur ce compte.<br/><br/><b>Retenez le bien</b> : en cas de perte, plus personne ne pourra accéder à votre compte !",
      "PASSWORD_WARNING": "Choisissez un mot de passe.<br/>Il vous sera demandé à chaque connexion sur ce compte.<br/><br/><b>Retenez bien ce mot de passe</b : en cas de perte, plus personne ne pourra accéder à votre compte !",
      "PSEUDO_WARNING": "Choisissez un pseudonyme.<br/>Il sert aux autres membres, pour vous identifier plus facilement.<div class='hidden-xs'><br/>Il <b>ne pourra pas être modifié</b>, sans refaire un compte.</div><br/><br/>Il ne doit contenir <b>ni espace, ni de caractère accentué</b>.<div class='hidden-xs'><br/>Exemple : <span class='gray'>SophieDupond, MarcelChemin, etc.</span>",
      "PSEUDO": "Pseudonyme",
      "PSEUDO_HELP": "Pseudonyme",
      "SALT_CONFIRM": "Confirmation",
      "SALT_CONFIRM_HELP": "Confirmation de l'identifiant secret",
      "PASSWORD_CONFIRM": "Confirmation",
      "PASSWORD_CONFIRM_HELP": "Confirmation du mot de passe",
      "SLIDE_6_TITLE": "Confirmation :",
      "COMPUTING_PUBKEY": "Calcul en cours...",
      "LAST_SLIDE_CONGRATULATION": "Vous avez saisi toutes les informations nécessaires : Bravo !<br/>Vous pouvez maintenant <b>envoyer la demande de création</b> de compte.</b><br/><br/>Pour information, la clé publique ci-dessous identifiera votre futur compte.<br/>Elle pourra être communiquée à des tiers pour recevoir leurs paiements.<br/><b>Il n'est pas obligatoire</b> de la noter ici, vous pourrez également le faire plus tard.",
      "CONFIRMATION_MEMBER_ACCOUNT": "<b class=\"assertive\">Avertissement :</b> l'identifiant secret, le mot de passe et le pseudonyme ne pourront plus être modifiés.<br/><br/><b>Assurez-vous de toujours vous en rappeler !</b><br/><br/><b>Êtes-vous sûr</b> de vouloir envoyer cette demande d'inscription ?",
      "CONFIRMATION_WALLET_ACCOUNT": "<b class=\"assertive\">Avertissement :</b> l'identifiant secret et le mot de passe ne pourront plus être modifiés.<br/><br/><b>Assurez-vous de toujours vous en rappeler !</b><br/><br/><b>Êtes-vous sûr</b> de vouloir continuer avec ces identifiants ?",
      "CHECKING_PSEUDO": "Vérification...",
      "PSEUDO_AVAILABLE": "Pseudonyme disponible",
      "PSEUDO_NOT_AVAILABLE": "Pseudonyme non disponible",
      "INFO_LICENSE": "Avant de créer un compte membre, <b>veuillez lire et accepter la licence</b> d'usage de la monnaie :",
      "BTN_ACCEPT": "J'accepte",
      "BTN_ACCEPT_LICENSE": "J'accepte la licence"
    },
    "POPUP_REGISTER": {
      "TITLE": "Choisissez un pseudonyme",
      "HELP": "Un pseudonyme est obligatoire pour devenir membre."
    },
    "SELECT_IDENTITY_MODAL": {
      "TITLE": "Sélection de l'identité",
      "HELP": "Plusieurs <b>identités différentes</b> ont été envoyées, pour la clé publique <span class=\"gray\"><i class=\"ion-key\"></i> {{pubkey|formatPubkey}}</span>.<br/>Veuillez sélectionner le dossier à utiliser :"
    },
    "SELECT_WALLET_MODAL": {
      "TITLE": "Sélection du portefeuille"
    },
    "CERTIFICATION_MODAL": {
      "CHECKLIST_TITLE": "Vérifications avant certification",
      "INFOS": "La sécurité de la monnaie Ğ1 repose sur chaque membre. Avant de certifier l'identité de cette personne, vous devez avoir fait quelques vérifications à son propos. Veuillez répondre aux questions suivantes :",
      "BTN_ALL_CHECK": "Certifier",
      "CHECKLIST_CONDITIONS_NOT_MET": "La certification n'a pas été envoyée. Les vérifications semblent insuffisantes. Veuillez vérifier de nouveau chaque point auprès de la personne à certifier.",
      "QUESTIONS": {
        "WELL_KNOWN": "<b>Connaissez-vous bien</b> la personne que vous certifiez, et connaissez-vous des gens qui la connaissent bien également ?",
        "REVOCATION": "A-t-elle téléchargé son <b>document de révocation</b> et sait-elle où le retrouver ?",
        "CONTACT": "Avez-vous <b>contacté</b> cette personne par plusieurs moyens et vous a-t-elle répondu ?",
        "DOUBLE_IDENTITY": "La personne doit posséder <b>une seule identité membre active</b>. En possède-t-elle une <b>autre</b> ?",
        "MASTER_ACCOUNT": "Maîtrise-t-elle son compte et a-t-elle déjà <b>effectué au moins un virement</b> depuis son compte ?",
        "LICENSE": "A-t-elle <b>compris la licence</b> et accepte-t-elle de s'y conformer pour la certification d'autres membres ?",
        "CREDENTIALS": "L’identifiant secret et le mot de passe de son compte sont-ils <b>longs et complexes</b> (phrases de passe) ? A-t-elle compris que l’identifiant doit également rester secret ? Est-elle <b>certaine de s’en souvenir</b> ou de pouvoir les retrouver ?",
        "PUBLIC_KEY_DIFFERENT": "La <b>clef publique</b> indiquée doit être <b>identique</b> à celle que vous a communiqué cette personne. Les clefs sont-elles <b>différentes</b> ?"
      },
      "REMINDER_TITLE": "Rappel",
      "SHORT_LICENSE_REMINDER": "Vous pouvez rappeler à la personne certifiée les paramètres des certifications :<br/><br/><ul><li> - Chaque membre peut avoir émis 100 certifications valides au maximum.</li><li> - Les certifications sont enregistrées à un intervalle de 5 jours.</li><li> - Une nouvelle identité membre doit réunir au minimum 5 certifications en moins de deux mois.</li><li> - Un membre doit renouveler son adhésion chaque année.</li><li> - Les certifications sont valides durant deux ans.</li></ul>"
    },
    "WALLET_LIST": {
      "TITLE": "Mes portefeuilles",
      "BTN_NEW": "Ajouter un portefeuille",
      "BTN_DOWNLOAD": "Télécharger la liste",
      "BTN_IMPORT_FILE_DOTS": "Importer depuis un fichier...",
      "NO_WALLET": "Aucun portefeuille secondaire",
      "BTN_DELETE": "Retirer un portefeuille secondaire...",
      "BTN_RENAME": "Renommer le portefeuille",
      "EXPORT_FILENAME": "mes_portefeuilles-{{pubkey|formatPubkey}}-{{currency}}.csv",
      "TOTAL_DOTS": "Total : ",
      "EDIT_POPOVER": {
        "TITLE": "Renommer le portefeuille",
        "HELP": "Renseignez le nouveau nom",
        "NAME_HELP": "Nom du portefeuille"
      },
      "IMPORT_MODAL": {
        "TITLE": "Importer des portefeuilles",
        "HELP": "Pour <b>importer des porftefeuilles</b>, veuillez glisser dans la zone ci-dessous le fichier de la liste des portefeuilles, ou bien cliquer dans la zone pour rechercher un fichier.",
        "WALLET_COUNT": "<b>{{count}}</b> nouveau{{count > 1 ? 'x' : ''}} portefeuille{{count > 1 ? 's' : ''}}",
        "NO_NEW_WALLET": "Aucun nouveau portefeuille"
      }
    },
    "SECURITY": {
      "ADD_QUESTION": "Ajouter une question personnalisée",
      "BTN_CLEAN": "Vider",
      "BTN_RESET": "Réinitialiser",
      "DOWNLOAD_REVOKE": "Sauvegarder mon fichier de révocation (uniquement sur ordinateur)",
      "DOWNLOAD_REVOKE_HELP": "Disposer d'un fichier de révocation est important, par exemple en cas de perte de vos identifiants. Il vous permet de <b>sortir ce compte de la toile de confiance</b>, en redevenant ainsi un simple portefeuille. Ne fonctionne pas sur smartphone.",
      "GENERATE_KEYFILE": "Générer mon fichier de trousseau...",
      "GENERATE_KEYFILE_HELP": "Génère un fichier permettant de vous authentifier sans saisir vos identifiants.<br/><b>Attention :</b> ce fichier contiendra votre trousseau de compte (clefs publique et secrète) ; il est donc très important de le mettre en lieu sûr !",
      "KEYFILE_FILENAME": "trousseau-{{pubkey|formatPubkey}}-{{currency}}-{{format}}.dunikey",
      "MEMBERSHIP_IN": "Transformer en compte membre...",
      "MEMBERSHIP_IN_HELP": "Permet de <b>transformer</b> un compte simple portefeuille <b>en compte membre</b>, en envoyant une demande d'adhésion. Utile uniquement si vous n'avez pas déjà un autre compte membre.",
      "SEND_IDENTITY": "Publier son identité...",
      "SEND_IDENTITY_HELP": "Permet d'associer un pseudonyme à ce compte, mais <b>sans faire de demande d'adhésion</b> pour devenir membre. Cette association n'est généralement pas utile, car la validité de cette association de pseudonyme est limitée dans le temps.",
      "HELP_LEVEL": "Pour générer un fichier de sauvegarde de vos identifiants, choisissez <strong> au moins {{nb}} questions :</strong>",
      "LEVEL": "Niveau de sécurité",
      "LOW_LEVEL": "Faible <span class=\"hidden-xs\">(2 questions minimum)</span>",
      "MEDIUM_LEVEL": "Moyen <span class=\"hidden-xs\">(4 questions minimum)</span>",
      "QUESTION_1": "Comment s'appelait votre meilleur ami lorsque vous étiez adolescent ?",
      "QUESTION_2": "Comment s'appelait votre premier animal de compagnie ?",
      "QUESTION_3": "Quel est le premier plat que vous avez appris à cuisiner ?",
      "QUESTION_4": "Quel est le premier film que vous avez vu au cinéma ?",
      "QUESTION_5": "Où êtes-vous allé la première fois que vous avez pris l'avion ?",
      "QUESTION_6": "Comment s'appelait votre instituteur préféré à l'école primaire ?",
      "QUESTION_7": "Quel serait selon vous le métier idéal ?",
      "QUESTION_8": "Quel est le livre pour enfants que vous préférez ?",
      "QUESTION_9": "Quel était le modèle de votre premier véhicule ?",
      "QUESTION_10": "Quel était votre surnom lorsque vous étiez enfant ?",
      "QUESTION_11": "Quel était votre personnage ou acteur de cinéma préféré lorsque vous étiez étudiant ?",
      "QUESTION_12": "Quel était votre chanteur ou groupe préféré lorsque vous étiez étudiant ?",
      "QUESTION_13": "Dans quelle ville vos parents se sont-ils rencontrés ?",
      "QUESTION_14": "Comment s'appelait votre premier patron ?",
      "QUESTION_15": "Quel est le nom de la rue où vous avez grandi ?",
      "QUESTION_16": "Quel est le nom de la première plage où vous vous êtes baigné ?",
      "QUESTION_17": "Quel est le premier album que vous avez acheté ?",
      "QUESTION_18": "Quel est le nom de votre équipe de sport préférée ?",
      "QUESTION_19": "Quel était le métier de votre grand-père ?",
      "RECOVER_ID": "Retrouver mon mot de passe...",
      "RECOVER_ID_HELP": "Si vous disposez d'un <b>fichier de sauvegarde de vos identifiants</b>, vous pouvez les retrouver en répondant correctement à vos questions personnelles.",
      "RECOVER_ID_SELECT_FILE": "Choisissez le <b>fichier de sauvegarde de vos identifiants</b> à utiliser :",
      "REVOCATION_WITH_FILE": "Révoquer mon compte membre...",
      "REVOCATION_WITH_FILE_DESCRIPTION": "Si vous avez <b>définitivement perdus vos identifiants</b> de compte membre (ou que la sécurité du compte est compromise), vous pouvez utiliser <b>le fichier de révocation</b> du compte pour <b>forcer sa sortie définitive de la toile de confiance</b>.",
      "REVOCATION_WITH_FILE_HELP": "Pour <b>révoquer définitivement</b> un compte membre, veuillez glisser dans la zone ci-dessous votre fichier de révocation, ou bien cliquer dans la zone pour rechercher un fichier.",
      "REVOCATION_WALLET": "Révoquer immédiatement ce compte",
      "REVOCATION_WALLET_HELP": "Demander la révocation de votre identité entraîne la <b>sortie de la toile de confiance</b> (définitive pour le pseudonyme et la clé publique associés). Le compte ne pourra plus produire de Dividende Universel.<br/>Vous pourrez toutefois encore vous y connecter, comme à un simple portefeuille.",
      "REVOCATION_FILENAME": "revocation-{{uid}}-{{pubkey|formatPubkey}}-{{currency}}.txt",
      "SAVE_ID": "Sauvegarder mes identifiants...",
      "SAVE_ID_HELP": "Création d'un fichier de sauvegarde, pour <b>retrouver votre mot de passe</b> (et l'identifiant secret) <b>en cas de d'oubli</b>. Le fichier est <b>sécurisé</b> (chiffré) à l'aide de questions personnelles.",
      "STRONG_LEVEL": "Fort <span class=\"hidden-xs \">(6 questions minimum)</span>",
      "TITLE": "Compte et sécurité",
      "KEYFILE": {
        "PUBSEC_FORMAT": "Format PubSec.",
        "PUBSEC_FORMAT_HELP": "Ce format stocke votre trousseau de manière très simple. Il est compatible notamment avec Cesium, ğannonce et Duniter.<br/><b>Attention :</b>Le fichier <b>n'est pas chiffré</b> (la clef secrète y apparaît en clair) ; veuillez donc le stocker en lieu sûr !",
        "WIF_FORMAT": "Format WIF (Wallet Import Format) - v1",
        "WIF_FORMAT_HELP": "Ce format stocke votre trousseau en y intégrant une somme de contrôle pour vérifier l'intégrité du fichier. Il est compatible notamment avec les portefeuilles papier (Duniter paper wallet).<br/><b>Attention :</b>Le fichier <b>n'est pas chiffré</b> (la clef secrète y apparaît en clair) ; veuillez donc le stocker en lieu sûr !",
        "EWIF_FORMAT": "Format EWIF (Encrypted Wallet Import Format) - v1",
        "EWIF_FORMAT_HELP": "Ce format stocke votre trousseau <b>de manière chiffrée</b> à partir d'une phrase secrète de votre choix. Il intègre aussi une somme de contrôle pour vérifier l'intégrité du fichier.<br/><b>Attention :</b> Veillez à toujours vous souvenir de votre phrase secrète !",
        "PASSWORD_POPUP": {
          "TITLE": "Fichier de trousseau chiffré",
          "HELP": "Veuillez indiquer la phrase secrète :",
          "PASSWORD_HELP": "Phrase secrète"
        },
        "ERROR": {
          "BAD_PASSWORD": "Phrase secrète incorrecte",
          "BAD_CHECKSUM": "Somme de contrôle incorrecte"
        }
      }
    },
    "FILE_NAME": "{{currency}} - Relevé du compte {{pubkey|formatPubkey}} au {{currentTime|formatDateForFile}}.csv",
    "HEADERS": {
      "TIME": "Date",
      "AMOUNT": "Montant",
      "COMMENT": "Commentaire"
    }
  },
  "TRANSFER": {
    "TITLE": "Virement",
    "SUB_TITLE": "Faire un virement",
    "SUB_TITLE_ALL": "Vider le compte",
    "FROM": "De",
    "TO": "À",
    "AMOUNT": "Montant",
    "AMOUNT_HELP": "Montant",
    "COMMENT": "Commentaire",
    "COMMENT_HELP": "Commentaire",
    "BTN_SEND": "Envoyer",
    "BTN_ADD_COMMENT": "Ajouter un commentaire",
    "REST": "Reste du compte",
    "REST_TO": "à",
    "WARN_COMMENT_IS_PUBLIC": "Veuillez noter que <b>les commentaires sont publics</b> (non chiffrés).",
    "MODAL": {
      "TITLE": "Virement"
    }
  },
  "ERROR": {
    "UNKNOWN_URI_FORMAT": "Format d'URI inconnu",
    "PUBKEY_INVALID_CHECKSUM": "Clé publique invalide (bad checksum).",
    "POPUP_TITLE": "Erreur",
    "TIMEOUT_REACHED": "Délai d'attente du nœud dépassé ({{timeout|formatDurationMs}}).<br/><br/><small>{{url}}</small>",
    "UNKNOWN_ERROR": "Erreur inconnue",
    "CRYPTO_UNKNOWN_ERROR": "Votre navigateur ne semble pas compatible avec les fonctionnalités de cryptographie.",
    "DOWNLOAD_KEYFILE_FAILED": "Échec de la génération du fichier de trousseau.",
    "EQUALS_TO_PSEUDO": "Doit être différent du pseudonyme",
    "EQUALS_TO_SALT": "Doit être différent de l'identifiant secret",
    "FIELD_REQUIRED": "Champ obligatoire",
    "FIELD_TOO_SHORT": "Valeur trop courte",
    "FIELD_TOO_SHORT_WITH_LENGTH": "Valeur trop courte ({{minLength}} caractères min)",
    "FIELD_TOO_LONG": "Valeur trop longue",
    "FIELD_TOO_LONG_WITH_LENGTH": "Valeur trop longue ({{maxLength}} caractères max)",
    "FIELD_MIN": "Valeur minimale : {{min}}",
    "FIELD_MAX": "Valeur maximale : {{max}}",
    "FIELD_ACCENT": "Caractères accentués et virgules non autorisés",
    "FIELD_NOT_NUMBER": "Valeur numérique attendue",
    "FIELD_NOT_INT": "Valeur entière attendue",
    "FIELD_NOT_EMAIL": "Adresse email non valide",
    "PASSWORD_NOT_CONFIRMED": "Ne correspond pas au mot de passe",
    "SALT_NOT_CONFIRMED": "Ne correspond pas à l'identifiant secret",
    "SEND_IDENTITY_FAILED": "Échec de l'inscription",
    "SEND_CERTIFICATION_FAILED": "Échec de la certification",
    "NEED_MEMBER_ACCOUNT_TO_CERTIFY": "Vous ne pouvez pas effectuer de certification, car ce compte n'est <b>pas membre</b>.",
    "NEED_MEMBER_ACCOUNT_TO_CERTIFY_HAS_SELF": "Vous ne pouvez pas effectuer de certification, car ce compte n'est pas encore membre.<br/><br/>Il vous manque encore des certifications, ou bien celles-ci n'ont pas encore été validées.",
    "IDENTITY_TO_CERTIFY_HAS_NO_SELF": "Compte non certifiable. Aucune demande d'adhésion n'a été faite, ou bien elle n'a pas été renouvelée.",
    "LOGIN_FAILED": "Erreur lors de la connexion.",
    "LOAD_IDENTITY_FAILED": "Erreur de chargement de l'identité.",
    "LOAD_REQUIREMENTS_FAILED": "Erreur de chargement des prérequis de l'identité.",
    "SEND_MEMBERSHIP_IN_FAILED": "Échec de la tentative d'entrée dans la communauté.",
    "SEND_MEMBERSHIP_OUT_FAILED": "Échec de l'arrêt de l'adhésion.",
    "REFRESH_WALLET_DATA": "Échec du rafraîchissement du portefeuille.",
    "GET_CURRENCY_PARAMETER": "Échec de la récupération des règles de la monnaie.",
    "GET_CURRENCY_FAILED": "Chargement de la monnaie impossible. Veuillez réessayer plus tard.",
    "SEND_TX_FAILED": "Échec du virement.",
    "ALL_SOURCES_USED": "Veuillez attendre le calcul du prochain bloc (toutes vos sources de monnaie ont été utilisées).",
    "NOT_ENOUGH_SOURCES": "Pas assez de change pour envoyer ce montant en une seule transaction.<br/>Montant maximum : {{amount}} {{unit}}<sub>{{subUnit}}</sub>.",
    "ACCOUNT_CREATION_FAILED": "Échec de la création du compte membre.",
    "RESTORE_WALLET_DATA_ERROR": "Échec du rechargement des paramètres depuis le stockage local",
    "LOAD_WALLET_DATA_ERROR": "Échec du chargement des données du portefeuille.",
    "COPY_CLIPBOARD_FAILED": "Copie de la valeur impossible.",
    "TAKE_PICTURE_FAILED": "Échec de la récupération de la photo.",
    "SCAN_FAILED": "Échec du scan de QR-code.",
    "SCAN_UNKNOWN_FORMAT": "Code non reconnu.",
    "WOT_LOOKUP_FAILED": "Échec de la recherche.",
    "LOAD_PEER_DATA_FAILED": "Lecture du nœud Duniter impossible. Veuillez réessayer ultérieurement.",
    "NEED_LOGIN_FIRST": "Veuillez d'abord vous connecter.",
    "AMOUNT_REQUIRED": "Le montant est obligatoire.",
    "AMOUNT_NEGATIVE": "Montant négatif non autorisé.",
    "NOT_ENOUGH_CREDIT": "Crédit insuffisant.",
    "INVALID_NODE_SUMMARY": "Nœud injoignable ou adresse invalide.",
    "INVALID_USER_ID": "Le pseudonyme ne doit contenir ni espace ni caractère spécial ou accentué.",
    "INVALID_COMMENT": "Le champ 'référence' ne doit pas contenir de caractères accentués.",
    "INVALID_PUBKEY": "La clé publique n'a pas le format attendu.",
    "INVALID_PUBKEY_CHECKSUM": "Somme de contrôle invalide.",
    "IDENTITY_REVOKED": "Cette identité <b>a été révoquée</b>. Elle ne peut plus devenir membre.",
    "IDENTITY_REVOKED_WITH_TIME": "Cette identité <b>a été révoquée {{revocationTime|medianFromNow}}</b> ({{revocationTime|medianDate}}). Elle ne peut plus devenir membre.",
    "IDENTITY_PENDING_REVOCATION": "La <b>révocation de cette identité</b> a été demandée et est en attente de traitement. La certification est donc désactivée.",
    "IDENTITY_INVALID_BLOCK_HASH": "Cette demande d'adhésion n'est plus valide (car elle référence un bloc que les nœuds du réseau ont annulé) : cette personne doit renouveler sa demande d'adhésion <b>avant</b> d'être certifiée.",
    "IDENTITY_EXPIRED": "La publication de cette identité a expiré : cette personne doit effectuer une nouvelle demande d'adhésion <b>avant</b> d'être certifiée.",
    "IDENTITY_SANDBOX_FULL": "Le nœud Duniter utilisé par Cesium ne peut plus recevoir de nouvelles identités, car sa file d'attente est pleine.<br/><br/>Veuillez réessayer ultérieurement ou changer de nœud (via le menu <b>Paramètres</b>).",
    "IDENTITY_NOT_FOUND": "Identité non trouvée.",
    "IDENTITY_TX_FAILED": "Échec du chargement des opérations.",
    "WOT_PENDING_INVALID_BLOCK_HASH": "Adhésion non valide.",
    "WALLET_INVALID_BLOCK_HASH": "Votre demande d'adhésion n'est plus valide (car elle référence un bloc que les nœuds du réseau ont annulé).<br/>Vous devez <a ng-click=\"doQuickFix('fixMembership')\">envoyer une nouvelle demande</a> pour résoudre ce problème.",
    "WALLET_IDENTITY_EXPIRED": "La publication de <b>votre identité a expirée</b>.<br/>Vous devez <a ng-click=\"doQuickFix('fixIdentity')\">publier à nouveau votre identité</a> pour résoudre ce problème.",
    "WALLET_REVOKED": "Votre identité a été <b>révoquée</b> : ni votre pseudonyme ni votre clef publique ne pourra être utilisé à l'avenir pour un compte membre.",
    "WALLET_HAS_NO_SELF": "Votre identité doit d'abord avoir été publiée, et ne pas être expirée.",
    "AUTH_REQUIRED": "Authentification requise.",
    "AUTH_INVALID_PUBKEY": "La clef attendue est <i class=\"ion-key\"></i> {{pubkey|formatPubkey}}...",
    "AUTH_INVALID_SCRYPT": "Identifiant ou mot de passe invalide.",
    "AUTH_INVALID_FILE": "Fichier de trousseau invalide.",
    "AUTH_FILE_ERROR": "Échec de l'ouverture du fichier de trousseau.",
    "IDENTITY_ALREADY_CERTIFY": "Vous avez <b>déjà certifié</b> cette identité.<br/><br/>Cette certification est encore valide (expiration {{expiresIn|formatDurationTo}}).",
    "IDENTITY_ALREADY_CERTIFY_PENDING": "Vous avez <b>déjà certifié</b> cette identité.<br/><br/>Cette certification est en attente de traitement (date limite de traitement {{expiresIn|formatDurationTo}}).",
    "UNABLE_TO_CERTIFY_TITLE": "Certification impossible",
    "LOAD_NEWCOMERS_FAILED": "Échec du chargement des nouveaux membres.",
    "LOAD_PENDING_FAILED": "Échec du chargement des inscriptions en attente.",
    "ONLY_MEMBER_CAN_EXECUTE_THIS_ACTION": "Vous devez <b>être membre</b> pour pouvoir effectuer cette action.",
    "ONLY_MEMBER_OR_WAS_MEMBER_CAN_EXECUTE_THIS_ACTION": "Vous devez <b>être membre (ou ancien membre)</b> pour pouvoir effectuer cette action.",
    "ONLY_SELF_CAN_EXECUTE_THIS_ACTION": "Vous devez avoir <b>publié votre identité</b> pour pouvoir effectuer cette action.",
    "GET_BLOCK_FAILED": "Échec de la récupération du bloc.",
    "INVALID_BLOCK_HASH": "Bloc non trouvé (hash différent).",
    "DOWNLOAD_REVOCATION_FAILED": "Échec du téléchargement du fichier de révocation.",
    "REVOCATION_FAILED": "Échec de la révocation.",
    "SALT_OR_PASSWORD_NOT_CONFIRMED": "Identifiant secret ou mot de passe incorrect.",
    "RECOVER_ID_FAILED": "Échec de la récupération des identifiants",
    "LOAD_FILE_FAILED" : "Échec du chargement du fichier",
    "NOT_VALID_REVOCATION_FILE": "Fichier de révocation non valide (mauvais format de fichier)",
    "NOT_VALID_SAVE_ID_FILE": "Fichier de récupération non valide (mauvais format de fichier)",
    "NOT_VALID_KEY_FILE": "Fichier de trousseau non valide (format non reconnu)",
    "EXISTING_ACCOUNT": "Vos identifiants correspondent à un compte déjà existant, dont la <a ng-click=\"showHelpModal('pubkey')\">clef publique</a> est :",
    "EXISTING_ACCOUNT_REQUEST": "Veuillez modifier vos identifiants afin qu'ils correspondent à un compte non utilisé.",
    "GET_LICENSE_FILE_FAILED": "Récupération du fichier de licence impossible.",
    "CHECK_NETWORK_CONNECTION": "Aucun nœud ne semble accessible.<br/><br/>Veuillez <b>vérifier votre connexion Internet</b>.",
    "ISSUE_524_TX_FAILED": "Échec du virement.<br/><br/>Un message a été envoyé aux développeurs pour faciliter la résolution du problème. <b>Merci de votre aide</b>.",
    "ADD_SECONDARY_WALLET_FAILED": "Échec de l'ajout du portefeuille secondaire.",
    "REMOVE_SECONDARY_WALLET_FAILED": "Échec de la suppression du portefeuille secondaire.",
    "UPDATE_WALLET_LIST_FAILED": "Échec du rafraîchissement des portefeuilles secondaires.",
    "LOAD_WALLET_LIST_FAILED": "Échec du chargement des portefeuilles secondaires.",
    "SAVE_WALLET_LIST_FAILED": "Échec de la sauvegarde des portefeuilles secondaires.",
    "COULD_NOT_ADD_MAIN_WALLET": "Ce portefeuille <b>correspond au compte principal</b> avec lequel vous êtes connecté.<br/>Impossible de l'ajouter comme portefeuille secondaire.",
    "COULD_NOT_ADD_EXISTING_WALLET": "Portefeuille déjà existant dans la liste.",
    "UNKNOWN_WALLET_ID": "Portefeuille secondaire inconnu.",
    "RESTORE_WALLET_LIST_FAILED": "Échec de la restauration des portefeuilles secondaires.",
    "INVALID_FILE_FORMAT": "Format de fichier invalide.",
    "SAME_TX_RECIPIENT": "Le destinataire doit être différent de l'émetteur.",
    "SELF_CERTIFICATION": "Vous ne pouvez pas certifier votre propre identité."
  },
  "INFO": {
    "POPUP_TITLE": "Information",
    "CERTIFICATION_DONE": "Certification envoyée",
    "NOT_ENOUGH_CREDIT": "Crédit insuffisant",
    "TRANSFER_SENT": "Virement envoyé",
    "COPY_TO_CLIPBOARD_DONE": "Copié dans le presse-papier",
    "MEMBERSHIP_OUT_SENT": "Résiliation envoyée",
    "NOT_NEED_MEMBERSHIP": "Vous êtes déjà membre.",
    "IDENTITY_WILL_MISSING_CERTIFICATIONS": "Cette identité va bientôt manquer de certifications (au moins {{willNeedCertificationCount}}).",
    "IDENTITY_NEED_MEMBERSHIP": "Cette identité n'a pas envoyée de demande d'adhésion. Elle le devra si elle souhaite devenir membre.",
    "HAS_ALTERNATIVE_IDENTITIES": "Il existe <b>plusieurs identités</b> rattachées à cette clé publique. <b>Avant toute certification</b>, pensez à <a ng-click=\"doQuickFix('showSelectIdentities')\">consulter les autres identités</a> pour choisir la bonne, ou bien contacter le propriétaire du compte.",
    "REVOCATION_SENT": "Révocation envoyée",
    "REVOCATION_SENT_WAITING_PROCESS": "La <b>révocation de cette identité</b> a été demandée et est en attente de traitement.",
    "FEATURES_NOT_IMPLEMENTED": "Cette fonctionnalité est encore en cours de développement.<br/>Pourquoi ne pas <b>contribuer à Cesium</b>, pour l'obtenir plus rapidement ? ;)",
    "EMPTY_TX_HISTORY": "Aucune opération à exporter",
    "LOADING_PENDING_TX": "Veuillez patienter...<br/><small>(Récupération des opérations en attente)</small>"
  },
  "CONFIRM": {
    "CAN_CONTINUE": "<b>Êtes-vous sûr</b> de vouloir continuer ?",
    "POPUP_TITLE": "<b>Confirmation</b>",
    "POPUP_WARNING_TITLE": "<b>Avertissement</b>",
    "POPUP_SECURITY_WARNING_TITLE": "<i class=\"icon ion-alert-circled\"></i> <b>Avertissement de sécurité</b>",
    "CERTIFY_RULES_TITLE_UID": "Certifier {{uid}}",
    "CERTIFY_RULES": "<b class=\"assertive\">Ne PAS certifier</b> un compte si vous pensez que :<br/><br/><ul><li>1.) il ne correspond pas à une personne <b>physique et vivante</b>.<li>2.) son propriétaire <b>possède un autre compte</b> déjà certifié.<li>3.) son propriétaire viole (volontairement ou non) la règle 1 ou 2 (par exemple en certifiant des comptes factices ou en double).</ul><br/><b>Êtes-vous sûr</b> de vouloir néanmoins certifier cette identité ?",
    "FULLSCREEN": "Afficher l'application en plein écran ?",
    "EXIT_APP": "Fermer l'application ?",
    "TRANSFER": "<b>Récapitulatif du virement</b> :<br/><br/><ul><li> - De : {{from}}</li><li> - A : <b>{{to}}</b></li><li> - Montant : <b>{{amount}} {{unit}}</b></li><li> - Commentaire : <i>{{comment}}</i></li></ul><br/><b>Êtes-vous sûr de vouloir effectuer ce virement ?</b>",
    "TRANSFER_ALL": "<b>Récapitulatif du virement</b> :<br/><br/><ul><li> - De : {{from}}</li><li> - A : <b>{{to}}</b></li><li> - Montant : <b>{{amount}} {{unit}}</b></li><li> - Commentaire : <i>{{comment}}</i></li><br/><li> - Reste : <b>{{restAmount}} {{unit}}</b> à <b>{{restTo}}</b></li></ul><br/><b>Êtes-vous sûr de vouloir effectuer ce virement ?</b>",
    "MEMBERSHIP_OUT": "Cette opération est <b>irréversible</b>.<br/></br/>Êtes-vous sûr de vouloir <b>résilier votre compte membre</b> ?",
    "MEMBERSHIP_OUT_2": "Cette opération est <b>irreversible</b> !<br/><br/>Êtes-vous vraiment sûr de vouloir <b>résilier votre adhésion</b> comme membre ?",
    "LOGIN_UNUSED_WALLET_TITLE": "Erreur de saisie ?",
    "LOGIN_UNUSED_WALLET": "Le compte connecté semble <b>inactif</b>.<br/><br/>Il s'agit probablement d'une <b>erreur de saisie</b> dans vos identifiants de connexion. Veuillez recommencer, en vérifiant que <b>la clé publique est celle de votre compte</b>.",
    "FIX_IDENTITY": "Le pseudonyme <b>{{uid}}</b> va être publiée à nouveau, en remplacement de l'ancienne publication qui a expirée.<br/></br/><b>Êtes-vous sûr</b> de vouloir continuer ?",
    "FIX_MEMBERSHIP": "Votre demande d'adhésion comme membre va être renvoyée.<br/></br/><b>Êtes-vous sûr</b> de vouloir continuer ?",
    "MEMBERSHIP": "Votre demande d'adhésion comme membre va être envoyée.<br/></br/><b>Êtes-vous sûr</b> de vouloir continuer ?",
    "RENEW_MEMBERSHIP": "Votre adhésion comme membre va être renouvelée.<br/></br/><b>Êtes-vous sûr</b> de vouloir continuer ?",
    "REVOKE_IDENTITY": "Vous allez <b>revoquer définitivement cette identité</b>.<br/><br/>La clé publique et le pseudonyme associés <b>ne pourront plus jamais être utilisés</b> (pour un compte membre). <br/></br/><b>Êtes-vous sûr</b> de vouloir révoquer définitivement ce compte ?",
    "REVOKE_IDENTITY_2": "Cette opération est <b>irreversible</b> !<br/><br/>Êtes-vous vraiment sûr de vouloir <b>révoquer définitivement</b> ce compte ?",
    "NOT_NEED_RENEW_MEMBERSHIP": "Votre adhésion n'a pas besoin d'être renouvelée (elle n'expirera que dans {{membershipExpiresIn|formatDuration}}).<br/></br/><b>Êtes-vous sûr</b> de vouloir renouveler votre adhésion ?",
    "SAVE_BEFORE_LEAVE": "Voulez-vous <b>sauvegarder vos modifications</b> avant de quitter la page ?",
    "SAVE_BEFORE_LEAVE_TITLE": "Modifications non enregistrées",
    "LOGOUT": "Êtes-vous sûr de vouloir vous déconnecter ?",
    "USE_FALLBACK_NODE": "Nœud <b>{{old}}</b> injoignable ou adresse invalide.<br/><br/>Voulez-vous temporairement utiliser le nœud <b>{{new}}</b> ?",
    "USE_SYNC_FALLBACK_NODE": "Nœud <b>{{old}}</b> semble désynchronisé.<br/><br/>Voulez-vous temporairement utiliser le nœud <b>{{new}}</b> ?",
    "ISSUE_524_SEND_LOG": "La transaction a été rejetée, à cause d'une anomalie connue (ticket #524) mais <b>non reproduite</b>.<br/><br/>Pour aider les développeurs à corriger cette erreur, <b>acceptez-vous la transmission de vos logs</b> par message ?<br/><small>(aucune donnée confidentielle n'est envoyée)</small>.",
    "ENABLE_EXPERT_MODE_TO_CHANGE_NODE": "<b class=\"assertive\">Avertissement :</b> Voulez-vous <b>changer manuellement</b> le nœud ?<br/><br/>Si vous continuez :<ul><li> - Le <b>mode expert</b> sera activé;</li><li> - Vous pourrez revenir à la sélection automatique du nœud, simplement <b>en désactivant le mode expert</b>.</li></ul>"
  },
  "MODE": {
    "DEMO": {
      "BADGE": "Démo",
      "MODE": "Mode démonstration",
      "FEATURE_NOT_AVAILABLE": "Fonctionnalité <b>non disponible</b> sur ce site de démonstration.",
      "MODE_HELP": "Cesium fonctionne en <b>mode démonstration</b> : la consultation de compte est possible, mais aucune opération ne pourra être réalisée.",
      "INSTALL_HELP": "Pour des <b>raisons de sécurité</b> nous vous recommandons <b>d'installer</b> votre copie de l'application Cesium. Visitez le site <a href='https://cesium.app'>www.cesium.app</a> pour obtenir de l'aide."
    },
    "READONLY": {
      "BADGE": "Monit",
      "MODE": "Mode monitoring",
      "MODE_HELP": "Cesium fonctionne en <b>mode monitoring</b> : ne sont disponibles que les fonctionnalités de supervision de la monnaie.",
      "INSTALL_HELP": "Si vous souhaitez <b>créer un compte portefeuille</b> pour envoyer ou recevoir de la monnaie, nous vous recommandons <b>d'installer votre copie</b> de l'application Cesium. Visitez le site <a href='https://cesium.app'>www.cesium.app</a> pour obtenir de l'aide."
    }
  },
  "DOWNLOAD": {
    "POPUP_TITLE": "<b>Fichier de révocation</b>",
    "POPUP_REVOKE_MESSAGE": "Pour sécuriser votre compte, veuillez télécharger le <b>document de révocation de compte</b>. Il vous permettra le cas échéant d'annuler votre compte (en cas d'un vol de compte, d'un changement d'identifiant, d'un compte créé à tort, etc.).<br/><br/><b>Veuillez le stocker en lieu sûr.</b>"
  },
  "HELP": {
    "TITLE": "Aide en ligne",
    "JOIN": {
      "SECTION": "Inscription",
      "SALT": "L'identifiant secret est très important. Il sert à mélanger le mot de passe, avant qu'il ne serve à calculer la <span class=\"text-italic\">clé publique</span> de votre compte (son numéro) et la clé secrète pour y accéder.<br/><b>Veillez à bien la mémoriser</b>, car aucun moyen n'est actuellement prévu pour la retrouver en cas de perte.<br/>Par ailleurs, il ne peut pas être modifié sans devoir créer un nouveau compte.<br/><br/>Un bon identifiant secret doit être suffisamment long (au moins 8 caractères) et le plus original possible.",
      "PASSWORD": "Le mot de passe est très important. Avec l'identifiant secret, il sert à calculer le numéro (la clé publique) de votre compte, et la clé secrète pour y accéder.<br/><b>Veillez à bien le mémoriser</b>, car aucun moyen n'est prévu de le retrouver en cas de perte (sauf à générer un fichier de sauvegarde).<br/>Par ailleurs, il ne peut pas être modifié sans devoir créer un nouveau compte.<br/><br/>Un bon mot de passe contient (idéalement) au moins 8 caractères, dont au moins une majuscule et un chiffre.",
      "PSEUDO": "Le pseudonyme est utilisé uniquement dans le cas d'inscription comme <span class=\"text-italic\">membre</span>. Il est toujours associé à un portefeuille (via sa <span class=\"text-italic\">clé publique</span>).<br/>Il est publié sur le réseau, afin que les autres utilisateurs puisse l'identifier, le certifier ou envoyer de la monnaie sur le compte.<br/>Un pseudonyme doit être unique au sein des membres (<u>actuels</u> et anciens)."
    },
    "LOGIN": {
      "SECTION": "Connexion",
      "PUBKEY": "Clé publique du trousseau",
      "PUBKEY_DEF": "La clef publique du trousseau est générée à partir des identifiants saisis (n'importe lesquels), sans pour autant qu'ils correspondent à un compte déjà utilisé.<br/><b>Vérifiez attentivement que la clé publique est celle de votre compte</b>. Dans le cas contraire, vous serez connecté à un compte probablement jamais utilisé, le risque de collision avec un compte existant étant infime.<br/><a href=\"https://fr.wikipedia.org/wiki/Cryptographie_asym%C3%A9trique\" target=\"_system\">En savoir plus sur la cryptographie</a> par clé publique.",
      "METHOD": "Méthodes de connexion",
      "METHOD_DEF": "Plusieurs options sont disponibles pour vous connecter à un portefeuille :<br/> - La connexion <b>par salage (simple ou avancé)</b> mélange votre mot de passe grâce à l'identifiant secret, pour limiter les tentatives de <a href=\"https://fr.wikipedia.org/wiki/Attaque_par_force_brute\" target=\"_system\">piratage par force brute</a> (par exemple à partir de mots connus).<br/> - La connexion <b>par clé publique</b> évite de saisir vos identifiants, qui vous seront demandé seulement le moment venu lors d'une opération sur le compte.<br/> - La connexion <b>par fichier de trousseau</b> va lire les clés (publique et privée) du compte, depuis un fichier, sans besoin de saisir d'identifiants. Plusieurs formats de fichier sont possibles."
    },
    "GLOSSARY": {
      "SECTION": "Glossaire",
      "PUBKEY_DEF": "Une clé publique identifie un portefeuille de monnaie, qui peut identifier un membre ou correspondre à un portefeuille anonyme. Dans Cesium la clé publique est calculée (par défaut) grâce à l'identifiant secret et au mot de passe.<br/><a href=\"https://fr.wikipedia.org/wiki/Cryptographie_asym%C3%A9trique\" target=\"_system\">En savoir plus sur la cryptographie</a> par clé publique.",
      "MEMBER": "Membre",
      "MEMBER_DEF": "Un membre est une personne humaine physique et vivante, désireuse de participer librement à la communauté monétaire. Elle co-produit un dividende universel, suivant une période et un montant tels que définis dans les <span class=\"text-italic\">règles de la monnaie</span>",
      "CURRENCY_RULES": "Règles de la monnaie",
      "CURRENCY_RULES_DEF": "Les règles de la monnaie sont définies une fois pour toutes. Elle fixe le fonctionnement de la monnaie : le calcul du dividende universel, le nombre de certifications nécessaire pour être membre, le nombre de certification maximum qu'un membre peut donner, etc. <a href=\"#/app/currency\">Voir les règles actuelles</a>.<br/>La non modification des règles dans le temps est possible par l'utilisation d'une <span class=\"text-italic\">BlockChain</span> qui porte et exécute ces règles, et en vérifie constamment la bonne application.",
      "BLOCKCHAIN": "Chaîne de blocs (<span class=\"text-italic\">Blockchain</span>)",
      "BLOCKCHAIN_DEF": "La BlockChain est un système décentralisé, qui, dans le cas de Duniter, sert à porter et exécuter les <span class=\"text-italic\">règles de la monnaie</span>.<br/><a href=\"https://duniter.org/fr/comprendre/\" target=\"_system\">En savoir plus sur Duniter</a> et le fonctionnement de sa blockchain.",
      "UNIVERSAL_DIVIDEND_DEF": "Le Dividende Universel (DU) est la quantité de monnaie co-créée par chaque membre, suivant la période et le calcul définis dans les <span class=\"text-italic\">règles de la monnaie</span>.<br/>A chaque échéance, les membres reçoivent sur leur compte la même quantité de nouvelle monnaie.<br/><br/>Le DU subit une croissance régulière, pour rester juste entre les membres (actuels et à venir), calculée en fonction de l'espérance de vie moyenne, telle que démontré dans la Théorie Relative de la Monnaie (TRM).<br/><a href=\"http://trm.creationmonetaire.info\" target=\"_system\">En savoir plus sur la TRM</a> et les monnaies libres.",
      "WOT": "Toile de Confiance (TdC)",
      "WOT_DEF": "La Toile de Confiance est constituée de l'ensemble des membres de la monnaie, et des liens de certification qui les relient.",
      "DISTANCE_RULE": "Règle de distance",
      "DISTANCE_RULE_DEF": "La règle de distance de la Toile de Confiance définie <b>une distance maximale à respecter</b> entre un postulant et un nombre minimum de membres référents (ou membres centraux). Cette distance est calculée en utilisant les liens de certification."
    },
    "TIP": {
      "MENU_BTN_CURRENCY": "Le menu <b>{{'MENU.CURRENCY'|translate}}</b> permet la consultation des <b>règles de la monnaie</b> et de son état.",
      "CURRENCY_WOT": "Le <b>nombre de membres</b> montre l'importance de la communauté et permet de <b>suivre son évolution</b>.",
      "CURRENCY_MASS": "Suivez ici la <b>quantité totale de monnaie</b> existante et sa <b>répartition moyenne</b> par membre.<br/><br/>Ceci permet de juger de l'<b>importance d'un montant</b>, vis à vis de ce que <b>possède les autres</b> sur leur compte (en moyenne).",
      "CURRENCY_UNIT_RELATIVE": "L'unité utilisée (&ldquo;<b>{{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub></b>&rdquo;) signifie que les montants en {{currency|capitalize}} ont été divisés par le <b>Dividende Universel</b> (DU).<br/><br/><small>Cette unité relative est <b>pertinente</b>, car stable malgré la quantitié de monnaie qui augmente en permanence.</small>",
      "CURRENCY_CHANGE_UNIT": "L'option <b>{{'COMMON.BTN_RELATIVE_UNIT'|translate}}</b> permet de <b>changer d'unité</b>, pour visualiser les montants <b>directement en {{currency|capitalize}}</b> (plutôt qu'en &ldquo;<b>{{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub></b>&rdquo;).",
      "CURRENCY_CHANGE_UNIT_TO_RELATIVE": "L'option <b>{{'COMMON.BTN_RELATIVE_UNIT'|translate}}</b> permet de <b>changer d'unité</b>, pour visualiser les montants en &ldquo;<b>{{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub></b>&rdquo;, c'est-à-dire relativement au Dividende Universel (le montant co-produit par chaque membre).",
      "CURRENCY_RULES": "Les <b>règles</b> de la monnaie fixent son fonctionnement <b>exact et prévisible</b>.<br/><br/>Véritable ADN de la monnaie, elles rendent son code monétaire <b>lisible et transparent</b>.",
      "MENU_BTN_NETWORK": "Le menu <b>{{'MENU.NETWORK'|translate}}</b> permet la consultation de l'état du réseau.",
      "NETWORK_BLOCKCHAIN": "Toutes les opérations de la monnaie sont enregistrées dans un grand livre de compte <b>public et infalsifiable</b>, appelé aussi <b>chaine de blocs</b> (<em>BlockChain</em> en anglais).",
      "NETWORK_PEERS": "Les <b>nœuds</b> visibles ici correspondent aux <b>ordinateurs qui actualisent et contrôlent</b> la chaine de blocs.<br/><br/>Plus il y a de nœuds, plus la monnaie a une gestion <b>décentralisée</b> et digne de confiance.",
      "NETWORK_PEERS_BLOCK_NUMBER": "Ce <b>numéro</b> (en vert) indique le <b>dernier bloc validé</b> pour ce nœud (dernière page écrite dans le grand livre de comptes).<br/><br/>La couleur verte indique que ce bloc est également validé par <b>la plupart des autres nœuds</b>.",
      "NETWORK_PEERS_PARTICIPATE": "<b>Chaque membre</b>, équipé d'un ordinateur avec Internet, <b>peut participer en ajoutant un nœud</b>. Il suffit d'<b>installer le logiciel Duniter</b> (libre et gratuit). <a href=\"{{installDocUrl}}\" target=\"_system\">Voir le manuel d'installation &gt;&gt;</a>.",
      "MENU_BTN_ACCOUNT": "Le menu <b>{{'MENU.ACCOUNT'|translate}}</b> permet d'accéder à la gestion de votre compte.",
      "MENU_BTN_ACCOUNT_MEMBER": "Consultez ici l'état de votre compte et les informations sur vos certifications.",
      "WALLET_CERTIFICATIONS": "Cliquez ici pour consulter le détail de vos certifications (reçues et émises).",
      "WALLET_RECEIVED_CERTIFICATIONS": "Cliquez ici pour consulter le détail de vos <b>certifications reçues</b>.",
      "WALLET_GIVEN_CERTIFICATIONS": "Cliquez ici pour consulter le détail de vos <b>certifications émises</b>.",
      "WALLET_BALANCE": "Le <b>solde</b> de votre compte s'affiche ici.",
      "WALLET_BALANCE_RELATIVE": "{{'HELP.TIP.WALLET_BALANCE'|translate}}<br/><br/>L'unité utilisée (&ldquo;<b>{{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub></b>&rdquo;) signifie que le montant en {{currency|capitalize}} a été divisé par le <b>Dividende Universel</b> (DU) co-créé par chaque membre.<br/><br/>Actuellement 1 DU vaut {{currentUD|formatInteger}} {{currency|capitalize}}s.",
      "WALLET_BALANCE_CHANGE_UNIT": "Vous pourrez <b>changer l'unité</b> d'affichage des montants dans les <b><i class=\"icon ion-android-settings\"></i>&nbsp;{{'MENU.SETTINGS'|translate}}</b>.<br/><br/>Par exemple pour visualiser les montants <b>directement en {{currency|capitalize}}</b>, plutôt qu'en unité relative.",
      "WALLET_PUBKEY": "Voici la clé publique de votre compte. Vous pouvez la communiquer à un tiers afin qu'il identifie plus simplement votre compte.",
      "WALLET_SEND": "Effectuer un paiement en quelques clics.",
      "WALLET_SEND_NO_MONEY": "Effectuer un paiement en quelques clics.<br/>(Votre solde ne le permet pas encore)",
      "WALLET_OPTIONS": "Ce bouton permet l'accès aux <b>actions d'adhésion</b> et de sécurité.<br/><br/>N'oubliez pas d'y jeter un oeil !",
      "WALLET_RECEIVED_CERTS": "S'affichera ici la liste des personnes qui vous ont certifié.",
      "WALLET_CERTIFY": "Le bouton <b>{{'WOT.BTN_SELECT_AND_CERTIFY'|translate}}</b> permet de sélectionner une identité et de la certifier.<br/><br/>Seuls des utilisateurs <b>déjà membres</b> peuvent en certifier d'autres.",
      "WALLET_CERT_STOCK": "Votre stock de certifications (émises) est limité à <b>{{sigStock}} certifications</b>.<br/><br/>Ce stock se renouvelle avec le temps, au fur et à mesure que les certifications s'invalident.",
      "MENU_BTN_WALLETS": "Le menu <b>{{'MENU.WALLETS'|translate}}</b> permet d'ajouter des portefeuilles supplémentaires que vous gérez.",
      "MENU_BTN_TX": "Le menu <b>{{'MENU.TRANSACTIONS'|translate}}</b> permet de consulter votre solde, l'historique vos transactions et d'envoyer un paiement.",
      "MENU_BTN_WOT": "Le menu <b>{{'MENU.WOT'|translate}}</b> permet de rechercher parmi les <b>utilisateurs</b> de la monnaie (membres ou non).",
      "WOT_SEARCH_TEXT_XS": "Pour rechercher dans l'annuaire, tapez les <b>premières lettres d'un pseudonyme</b> (ou d'une clé publique).<br/><br/>La recherche se lancera automatiquement.",
      "WOT_SEARCH_TEXT": "Pour rechercher dans l'annuaire, tapez les <b>premières lettres d'un pseudonyme</b> (ou d'une clé publique). <br/><br/>Appuyer ensuite sur <b>Entrée</b> pour lancer la recherche.",
      "WOT_SEARCH_RESULT": "Visualisez la fiche détaillée simplement en <b>cliquant</b> sur une ligne.",
      "WOT_VIEW_CERTIFICATIONS": "La ligne <b>{{'ACCOUNT.CERTIFICATION_COUNT'|translate}}</b> montre combien de membres ont validé cette identité.<br/><br/>Ces certifications attestent que le compte appartient à <b>une personne humaine vivante</b> n'ayant <b>aucun autre compte membre</b>.",
      "WOT_VIEW_CERTIFICATIONS_COUNT": "Il faut au moins <b>{{sigQty}} certifications</b> pour devenir membre et recevoir le <b>Dividende Universel</b>.",
      "WOT_VIEW_CERTIFICATIONS_CLICK": "Un clic ici permet d'ouvrir <b>la liste de toutes les certifications</b> de l'identité (reçues et émises).",
      "WOT_VIEW_CERTIFY": "Le bouton <b>{{'WOT.BTN_CERTIFY'|translate}}</b> permet d'ajouter votre certification à cette identité.",
      "CERTIFY_RULES": "<b>Attention :</b> Ne certifiez que des <b>personnes physiques vivantes</b>, ne possédant aucun autre compte membre.<br/><br/>La sécurité de la monnaie dépend de la vigilance de chacun !",
      "MENU_BTN_SETTINGS": "Les <b>{{'MENU.SETTINGS'|translate}}</b> vous permettront de configurer l'application.",
      "HEADER_BAR_BTN_PROFILE": "Cliquez ici pour accéder à votre <b>profil utilisateur.</b>",
      "SETTINGS_CHANGE_UNIT": "Vous pourrez <b>changer d'unité d'affichage</b> des montants en cliquant ci-dessus.<br/><br/>- Désactivez l'option pour un affichage des montants en {{currency|capitalize}}.<br/>- Activez l'option pour un affichage relatif en {{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub> (tous les montants seront <b>divisés</b> par le Dividende Universel courant).",
      "END_LOGIN": "Cette visite guidée est <b>terminée</b> !<br/><br/>Bonne continuation à vous, dans le nouveau monde de l'<b>économie libre</b> !",
      "END_NOT_LOGIN": "Cette visite guidée est <b>terminée</b> !<br/><br/>Si vous souhaitez rejoindre la monnaie {{currency|capitalize}}, il vous suffira de cliquer sur <b>{{'LOGIN.CREATE_FREE_ACCOUNT'|translate}}</b> ci-dessous.",
      "END_READONLY": "Cette visite guidée est <b>terminée</b>.<br/><br/>{{'MODE.READONLY.INSTALL_HELP'|translate}}."
    }
  },
  "API" :{
    "COMMON": {
      "LINK_DOC": "Documentation API",
      "LINK_DOC_HELP": "Documentation pour les développeurs",
      "LINK_STANDARD_APP": "Version classique",
      "LINK_STANDARD_APP_HELP": "Ouvrir la version classique de {{'COMMON.APP_NAME'|translate}}",
      "CONNECTION_ERROR": "Nœud <b>{{server}}</b> injoignable ou adresse invalide.<br/><br/>Vérifiez votre connexion Internet, ou contactez l'administrateur du site."
    },
    "HOME": {
      "TITLE": "Documentation API {{'COMMON.APP_NAME'|translate}}",
      "MESSAGE": "Bienvenue dans la <b>documentation de l'API</b> {{'COMMON.APP_NAME'|translate}}.<br/>Connectez vos sites web à <a href=\"http://duniter.org\" target=\"_system\">Duniter</a> très simplement !",
      "MESSAGE_SHORT": "Connectez vos sites à <a href=\"http://duniter.org\" target=\"_system\">Duniter</a> très simplement !",
      "DOC_HEADER": "Services disponibles :"
    },
    "TRANSFER": {
      "TITLE": "{{'COMMON.APP_NAME'|translate}} - Paiement en ligne",
      "TITLE_SHORT": "Paiement en ligne",
      "SUMMARY": "Récapitulatif du paiement :",
      "AMOUNT": "Montant :",
      "AMOUNTS_HELP": "Veuillez choisir le montant :",
      "NAME": "Nom :",
      "PUBKEY": "Clé publique du destinataire :",
      "COMMENT": "Référence de l'opération :",
      "NODE": "Adresse du nœud :",
      "DEMO": {
        "SALT": "demo",
        "PASSWORD": "demo",
        "PUBKEY": "3G28bL6deXQBYpPBpLFuECo46d3kfYMJwst7uhdVBnD1",
        "HELP": "<b>Mode démonstration</b> : Aucun paiement ne sera réellement envoyé pendant cette simulation.<br/>Veuillez utiliser les identifiants : <b>{{'API.TRANSFER.DEMO.SALT'|translate}} / {{'API.TRANSFER.DEMO.PASSWORD'|translate}}</b>",
        "BAD_CREDENTIALS": "Vérifiez votre saisie.<br/>En mode démonstration, les identifiants sont : {{'API.TRANSFER.DEMO.SALT'|translate}} / {{'API.TRANSFER.DEMO.PASSWORD'|translate}}"
      },
      "INFO": {
        "SUCCESS_REDIRECTING_WITH_NAME": "Paiement envoyé.<br/>Redirection vers <b>{{name}}</b>...",
        "SUCCESS_REDIRECTING": "Paiement envoyé.<br/>Redirection vers le site du vendeur...",
        "CANCEL_REDIRECTING_WITH_NAME": "Paiement annulé.<br/>Redirection vers <b>{{name}}</b>...",
        "CANCEL_REDIRECTING": "Paiement annulé.<br/>Redirection vers le site du vendeur..."
      },
      "ERROR": {
        "TRANSFER_FAILED": "Échec du paiement"
      }
    },
    "DOC": {
      "DESCRIPTION_DIVIDER": "Description",
      "URL_DIVIDER": "Adresse d'appel",
      "PARAMETERS_DIVIDER": "Paramètres",
      "AVAILABLE_PARAMETERS": "Voici la liste des paramètres possibles :",
      "DEMO_DIVIDER": "Tester",
      "DEMO_HELP": "Pour tester ce service, cliquez sur le bouton ci-contre. Le résultat s'affichera en dessous.",
      "DEMO_RESULT": "Résultat retourné par l'appel :",
      "DEMO_RESULT_PEER": "Adresse du nœud utilisé :",
      "DEMO_SUCCEED": "<i class=\"icon ion-checkmark\"></i> Succès !",
      "DEMO_CANCELLED": "<i class=\"icon ion-close\"></i> Annulé par l'utilisateur",
      "INTEGRATE_DIVIDER": "Intégrer",
      "INTEGRATE_CODE": "Code :",
      "INTEGRATE_RESULT": "Prévisualisation du résultat :",
      "INTEGRATE_PARAMETERS": "Paramètres",
      "TRANSFER": {
        "TITLE": "Paiements",
        "DESCRIPTION": "Depuis un site (ex: vente en ligne) vous pouvez déléguer le paiement en monnaie libre à Cesium API. Pour cela, il vous suffit de déclencher l'ouverture d'une page sur l'adresse suivante :",
        "PARAM_PUBKEY": "Clé publique du destinataire",
        "PARAM_PUBKEY_HELP": "Clé publique du destinataire (obligatoire)",
        "PARAM_AMOUNT": "Montant",
        "PARAM_AMOUNT_HELP": "Montant de la transaction (obligatoire). Valeurs multiples autorisées, en utilisant un séparateur (point-virgule, barre verticale ou espace).",
        "PARAM_COMMENT": "Référence (ou commentaire)",
        "PARAM_COMMENT_HELP": "Référence ou commentaire. Vous permettra par exemple d'identifier le paiement dans la BlockChain.",
        "PARAM_NAME": "Nom (du destinataire ou du site web)",
        "PARAM_NAME_HELP": "Le nom du destinataire, ou du site web appelant. Cela peut être un nom lisible (\"Mon site en ligne\"), ou encore une pseudo-adresse web (\"MonSite.com\").",
        "PARAM_REDIRECT_URL": "Adresse web de redirection",
        "PARAM_REDIRECT_URL_HELP": "Adresse web (URL) de redirection, appelé quand le paiement a été envoyé. Peut contenir les chaînes suivantes, qui seront remplacées par les valeurs de la transaction : \"{tx}\", \"{hash}\", \"{comment}\", \"{amount}\", \"{pubkey}\" et \"{node}\".",
        "PARAM_CANCEL_URL": "Adresse web d'annulation",
        "PARAM_CANCEL_URL_HELP": "Adresse web (URL) en cas d'annulation du paiement, par l'utilisateur. Peut contenir les chaînes suivantes, qui seront remplacées dynamiquement : \"{comment}\", \"{amount}\" et \"{pubkey}\".",
        "PARAM_PREFERRED_NODE": "Adresse du nœud préféré",
        "PARAM_PREFERRED_NODE_HELP": "Adresse (URL) du nœud Duniter à utiliser de préférence (\"g1.domaine.com:443\" ou \"https://g1.domaine.com\").",
        "EXAMPLES_HELP": "Voici des exemples d'intégration :",
        "EXAMPLE_BUTTON": "Bouton HTML",
        "EXAMPLE_BUTTON_DEFAULT_TEXT": "Payer en {{currency|currencySymbol}}",
        "EXAMPLE_BUTTON_DEFAULT_STYLE": "Style personnalisé",
        "EXAMPLE_BUTTON_TEXT_HELP": "Texte du bouton",
        "EXAMPLE_BUTTON_BG_COLOR": "Couleur du fond",
        "EXAMPLE_BUTTON_BG_COLOR_HELP": "Exemple : #fbc14c, black, lightgrey, rgb(180,180,180)",
        "EXAMPLE_BUTTON_FONT_COLOR": "Couleur du texte",
        "EXAMPLE_BUTTON_FONT_COLOR_HELP": "Exemple : black, orange, rgb(180,180,180)",
        "EXAMPLE_BUTTON_TEXT_ICON": "Icône",
        "EXAMPLE_BUTTON_TEXT_WIDTH": "Largeur",
        "EXAMPLE_BUTTON_TEXT_WIDTH_HELP": "Exemple : 200px, 50%",
        "EXAMPLE_BUTTON_ICON_NONE": "Aucune",
        "EXAMPLE_BUTTON_ICON_DUNITER": "Logo Duniter",
        "EXAMPLE_BUTTON_ICON_CESIUM": "Logo Cesium",
        "EXAMPLE_BUTTON_ICON_G1_COLOR": "Logo Ğ1",
        "EXAMPLE_BUTTON_ICON_G1_BLACK": "Logo Ğ1 (noir)"
      }
    }
  }
}
);

$translateProvider.translations("it-IT", {
  "COMMON": {
    "APP_NAME": "Cesium",
    "APP_VERSION": "v{{version}}",
    "APP_BUILD": "build {{build}}",
    "PUBKEY": "Chiave pubblica",
    "MEMBER": "Membro",
    "BLOCK" : "Blocco",
    "BTN_OK": "Ok",
    "BTN_YES": "Sì",
    "BTN_NO": "No",
    "BTN_SEND": "Inviare",
    "BTN_SEND_MONEY": "Pagare",
    "BTN_SEND_MONEY_SHORT": "Pagare",
    "BTN_SAVE": "Salvare",
    "BTN_YES_SAVE": "Sì, salvare",
    "BTN_YES_CONTINUE": "Sì, continuare",
    "BTN_SHOW": "Mostrare",
    "BTN_SHOW_PUBKEY": "Mostrare chiave pubblica",
    "BTN_RELATIVE_UNIT": "Mostra importi in DU?",
    "BTN_BACK": "Indietro",
    "BTN_NEXT": "Avanti",
    "BTN_IMPORT": "Importare",
    "BTN_CANCEL": "Cancellare",
    "BTN_CLOSE": "Chiudere",
    "BTN_LATER": "Più tardi",
    "BTN_LOGIN": "Accedi",
    "BTN_LOGOUT": "Esci",
    "BTN_ADD_ACCOUNT": "Nuovo conto",
    "BTN_SHARE": "Condividere",
    "BTN_EDIT": "Modificare",
    "BTN_DELETE": "Eliminare",
    "BTN_ADD": "Aggiungere",
    "BTN_SEARCH": "Cercare",
    "BTN_REFRESH": "Aggiornare",
    "BTN_RETRY": "Riprovare",
    "BTN_START": "Iniziare",
    "BTN_CONTINUE": "Continuare",
    "BTN_CREATE": "Creare",
    "BTN_UNDERSTOOD": "Ho capito",
    "BTN_OPTIONS": "Opzioni",
    "BTN_HELP_TOUR": "Mostrami le funzionalità",
    "BTN_HELP_TOUR_SCREEN": "Scoprire questa schermata",
    "BTN_DOWNLOAD": "Scaricare",
    "BTN_DOWNLOAD_ACCOUNT_STATEMENT": "Scaricare estratto conto",
    "BTN_MODIFY": "Modificare",
    "CHOOSE_FILE": "Trascina un file <br/>o clicca per selezionare",
    "DAYS": "Giorni",
    "NO_ACCOUNT_QUESTION": "Non sei ancora membro? Registrati subito!",
    "SEARCH_NO_RESULT": "Nessun risultato trovato",
    "LOADING": "Caricando...",
    "LOADING_WAIT": "Caricando...<br/><small>(Cesium interroga il nodo nodo Duniter)</small>",
    "SEARCHING": "Cercando...",
    "FROM": "Da",
    "TO": "A",
    "COPY": "Copiare",
    "LANGUAGE": "Lingua",
    "UNIVERSAL_DIVIDEND": "Dividendo Universale",
    "UD": "DU",
    "DATE_PATTERN": "DD/MM/YYYY HH:mm",
    "DATE_FILE_PATTERN": "YYYY-MM-DD",
    "DATE_SHORT_PATTERN": "DD/MM/YY",
    "DATE_MONTH_YEAR_PATTERN": "MM/YYYY",
    "EMPTY_PARENTHESIS": "(empty)",
    "UID": "Pseudonimo",
    "ENABLE": "Attivato",
    "DISABLE": "Disattivato",
    "RESULTS_LIST": "Risultati:",
    "RESULTS_COUNT": "{{count}} risultati",
    "EXECUTION_TIME": "Eseguito in {{duration|formatDurationMs}}",
    "SHOW_VALUES": "Mostrare valori in modo trasparente?",
    "POPOVER_ACTIONS_TITLE": "Opzioni",
    "POPOVER_FILTER_TITLE": "Filtri",
    "SHOW_MORE": "Mostrare di più",
    "SHOW_MORE_COUNT": "(limite attuale di {{limit}})",
    "POPOVER_SHARE": {
      "TITLE": "Condividere",
      "SHARE_ON_TWITTER": "Condividere su Twitter",
      "SHARE_ON_FACEBOOK": "Condividere su Facebook",
      "SHARE_ON_DIASPORA": "Condividere su Diaspora*",
      "SHARE_ON_GOOGLEPLUS":"Condividere su Google+"
    },
    "FILE": {
      "DATE" : "Data:",
      "TYPE" : "Tipo:",
      "SIZE": "Dimensioni del file:",
      "VALIDATING": "Validazione in corso..."
    }
  },
  "SYSTEM": {
    "PICTURE_CHOOSE_TYPE": "Scegliere un file:",
    "BTN_PICTURE_GALLERY": "Galleria",
    "BTN_PICTURE_CAMERA": "<b>Camera</b>"
  },
  "MENU": {
    "HOME": "Inizio",
    "WOT": "Rubrica",
    "CURRENCY": "Moneta",
    "ACCOUNT": "Il mio conto",
    "WALLETS": "I miei portafogli",
    "SETTINGS": "Impostazioni",
    "NETWORK": "Rete",
    "TRANSACTIONS": "I miei pagamenti"
  },
    "ABOUT": {
    "TITLE": "A proposito",
    "LICENSE": "<b>Software Libre</b> (License GNU AGPLv3).",
    "LATEST_RELEASE": "È disponibile una  <b>nuova versione</ b> di {{'COMMON.APP_NAME' | translate}} (<b>v{{version}}</b>)",
    "PLEASE_UPDATE": "Per favore aggiorna il {{'COMMON.APP_NAME' | translate}} (latest version: <b>v{{version}}</b>)",
    "CODE": "Codice sorgente:",
    "OFFICIAL_WEB_SITE": "Pagina web ufficiale:",
    "DEVELOPERS": "Sviluppatori:",
    "FORUM": "Forum:",
    "PLEASE_REPORT_ISSUE": "Per favore comunicaci qualunque problema!",
    "REPORT_ISSUE": "Comunica un problema",
    "BTN_OPEN_DEV_WINDOW": "Apri la finestra di debug"
  },
  "HOME": {
    "TITLE": "Cesium",
    "WELCOME": "Benvenuti all' App Cesium!",
    "WELCOME_READONLY": "Benvenuti nel Cesium <span class='badge badge-balanced'>Monit</span>!",
    "MESSAGE": "Scambiate in moneta libera {{currency|abbreviate}}",
    "MESSAGE_READONLY": "Monitoraggio in tempo reale della moneta libera {{currency|abbreviate}}",
    "BTN_CURRENCY": "Esplorare la moneta {{currency|abbreviate}}",
    "BTN_ABOUT": "A proposito",
    "BTN_HELP": "Aiuto",
    "BTN_NETWORK": "Stato della rete",
    "FREE_SOFTWARE": "Software Libre",
    "FORK_ME": "Fork me!",
    "SHOW_LICENSE": "Mostra licenza",
    "REPORT_ISSUE": "Segnalare un bug",
    "NOT_YOUR_ACCOUNT_QUESTION" : "Non sei proprietario del conto <b><i class=\"ion-key\"></i> {{pubkey|formatPubkey}}</b>?",
    "BTN_CHANGE_ACCOUNT": "Disconettere questo conto",
    "PEER_CONNECTION_ERROR": "Nodo <b>{{server}}</b> irraggiungibile o indirizzo non valido. <br/><br/> Verifica la tua connessione o cambia nodo. <a class=\"positive\" ng-click=\"doQuickFix('settings')\">nelle impostazioni</a>.",
    "NETWORK_CONNECTION_ERROR": "Rete non raggiungibile.<br/><br/>Controlla la tua connessione Internet, o seleziona un nodo manualmente <a class=\"positive\" ng-click=\"doQuickFix('settings')\">nelle impostazioni</a>.",
    "SHOW_ALL_FEED": "Mostra tutto",
    "READ_MORE": "Leggi di più",
    "FEED_SOURCE": "Fonte"
  },
  "SETTINGS": {
    "TITLE": "Impostazioni",
    "DISPLAY_DIVIDER": "Schermo",
    "STORAGE_DIVIDER": "Memoria",
    "NETWORK_SETTINGS": "Rete",
    "PEER": "Nodo Duniter",
    "PEER_CHANGED_TEMPORARY": "Indirizzo usato temporaneamente",
    "PEER_SELECTED_AUTOMATICALLY": "Nodo selezionato automaticamente all'avvio",
    "NETWORK_ANALYZE_TIMEOUT": "Tempo di attesa massimo (timeout)",
    "NETWORK_ANALYZE_TIMEOUT_HELP": "Tempo di attesa massimo per l'analisi della rete",
    "NETWORK_ANALYZE_TIMEOUT_AUTO": "Auto",
    "PERSIST_CACHE": "Mantenere i dati di navigazione (sperimentale)",
    "PERSIST_CACHE_HELP": "per la fruizione da una sessione all'altra., Consente una navigazione più veloce, conservando localmente i dati ricevuti, per un utilizzo da una sessione all'altra.",
    "USE_LOCAL_STORAGE": "Permetti salvataggio locale",
    "USE_LOCAL_STORAGE_HELP": "Permette di salvare le tue impostazioni",
    "WALLETS_SETTINGS": "I miei portafogli",
    "USE_WALLETS_ENCRYPTION": "Metti in sicurezza la lista",
    "USE_WALLETS_ENCRYPTION_HELP": "Ti permette di cifrare la lista dei tuou portafogli. È necessario autenticarsi per accedervi.",
    "ENABLE_HELPTIP": "Consenti aiuto contestuale",
    "DISABLE_HELPTIP": "Disabilita aiuto contestuale",
    "ENABLE_UI_EFFECTS": "Abilita effetti visuali",
    "ENABLE_UI_EFFECTS_HELP": "Transizione tra pagine, animazione della lista",
    "HISTORY_SETTINGS": "Operazioni del conto",
    "DISPLAY_UD_HISTORY": "Mostra i DU cocreati?",
    "TX_HISTORY_AUTO_REFRESH": "Abilita l'aggiornamento automatico?",
    "TX_HISTORY_AUTO_REFRESH_HELP": "Aggiorna la lista delle operazioni ad ogni nuovo blocco.",
    "AUTHENTICATION_SETTINGS": "Autenticazione",
    "KEEP_AUTH": "Scadenza dell'autenticazione",
    "KEEP_AUTH_SHORT": "Scadenza",
    "KEEP_AUTH_HELP": "Definisci quando l'autenticazione è rimossa dalla memoria.",
    "KEEP_AUTH_OPTION": {
      "NEVER": "Dopo ogni operazione",
      "SECONDS": "Dopo {{value}}s di inattività",
      "MINUTE": "Dopo {{value}}min di inattività",
      "MINUTES": "Dopo {{value}}min di inattività",
      "HOUR": "Dopo {{value}}h di inattività",
      "ALWAYS": "Alla fine della sessione"
    },
    "KEYRING_FILE": "Archivio portachiavi",
    "KEYRING_FILE_HELP": "Permetti la connessione automatica all'inizio, o di autenticarsi (solo se \"la scadenza dell'autenticazione\" è \"alla fine della sessione\"",
    "REMEMBER_ME": "Ricordarsi di me?",
    "REMEMBER_ME_HELP": "Rimanere identificato da una sessione all'altra, conservando la chiave localmente.",
    "PLUGINS_SETTINGS": "Estensioni",
    "BTN_RESET": "Ripristina valori predefiniti",
    "EXPERT_MODE": "Abilitare modalità esperto",
    "EXPERT_MODE_HELP": "Permette di vedere più dettagli",
    "BLOCK_VALIDITY_WINDOW": "Tempo di incertezza del blocco",
    "BLOCK_VALIDITY_WINDOW_SHORT": "Tempo di incertezza",
    "BLOCK_VALIDITY_WINDOW_HELP": "Tempo di attesa prima di considerare un'informazione convalidata",
    "BLOCK_VALIDITY_OPTION": {
      "NONE": "Nessuna attesa",
      "N": "{{time | formatDuration}} ({{count}} blocks)"
    },
    "POPUP_PEER": {
      "TITLE" : "Nodo Duniter",
      "HOST" : "Indirizzo",
      "HOST_HELP": "Indirizzo: server:port",
      "USE_SSL" : "Cifrato?",
      "USE_SSL_HELP" : "Cifratura SSL",
      "BTN_SHOW_LIST" : "Lista dei nodi"
    }
  },
  "BLOCKCHAIN": {
    "HASH": "Hash: {{hash}}",
    "VIEW": {
      "HEADER_TITLE": "Blocco #{{number}}-{{hash|formatHash}}",
      "TITLE_CURRENT": "Blocco attuale",
      "TITLE": "Blocco #{{number|formatInteger}}",
      "COMPUTED_BY": "Calcolato da",
      "SHOW_RAW": "Mostrare dati grezzi",
      "TECHNICAL_DIVIDER": "Informazioni tecniche",
      "VERSION": "Versione del formato",
      "HASH": "Hash calcolato",
      "UNIVERSAL_DIVIDEND_HELP": "Moneta cocreata da ciascuno dei {{membersCount}} membri",
      "EMPTY": "Nessun dato in questo blocco",
      "POW_MIN": "Difficoltà minima",
      "POW_MIN_HELP": "Difficoltà imposta nel calcolo del hash",
      "DATA_DIVIDER": "Dati",
      "IDENTITIES_COUNT": "Nuove identità",
      "JOINERS_COUNT": "Nuovi membri",
      "ACTIVES_COUNT": "Rinnovi",
      "ACTIVES_COUNT_HELP": "Membri che hanno rinnovato la loro adesione alla RdF",
      "LEAVERS_COUNT": "Abbandoni",
      "LEAVERS_COUNT_HELP": "Membri che hanno abbandonato la rete",
      "EXCLUDED_COUNT": "Membri esclusi",
      "EXCLUDED_COUNT_HELP": "Vecchi membri, esclusi per certificazione non rinnovata o soglia di certificazioni non raggiunta.",
      "REVOKED_COUNT": "Identità revocate",
      "REVOKED_COUNT_HELP": "Può essere che queste identità non siano più membri",
      "TX_COUNT": "Transazioni",
      "CERT_COUNT": "Certificazioni",
      "TX_TO_HIMSELF": "Cambio",
      "TX_OUTPUT_UNLOCK_CONDITIONS": "Sbloccare condizioni",
      "TX_OUTPUT_OPERATOR": {
        "AND": "e",
        "OR": "o"
      },
      "TX_OUTPUT_FUNCTION": {
        "SIG": "<b>Firma</b> della chive pubblica",
        "XHX": "<b>Password</b>, incluso SHA256 =",
        "CSV": "Bloccato per",
        "CLTV": "Bloccato fino a"
      }
    },
    "LOOKUP": {
      "TITLE": "Blocchi",
      "NO_BLOCK": "Nessun blocco",
      "LAST_BLOCKS": "Ultimi blocchi:",
      "BTN_COMPACT": "Compact"
    }
  },
  "CURRENCY": {
    "VIEW": {
      "TITLE": "Moneta",
      "TAB_CURRENCY": "Moneta",
      "TAB_WOT": "Rete di Fiducia",
      "TAB_NETWORK": "Rete",
      "TAB_BLOCKS": "Blocchi",
      "CURRENCY_SHORT_DESCRIPTION": "{{currency|capitalize}} è <b>una moneta libera</b>, {{firstBlockTime | formatFromNow}}. La rete comprende <b>{{N}} membri </b>, che producono e ricevono un <a ng-click=\"showHelpModal('ud')\">Dividendo Universale</a> (DU), ogni {{dt | formatPeriod}}.",
      "NETWORK_RULES_DIVIDER": "Regole della rete",
      "CURRENCY_NAME": "Nome della moneta",
      "MEMBERS": "Numero di membri",
      "MEMBERS_VARIATION": "Variazione da {{duration|formatDuration}} (dall' ultimo DU)",
      "MONEY_DIVIDER": "Moneta",
      "MASS": "Massa monetaria",
      "SHARE": "Quantità pro capite",
      "UD": "Dividendo universale",
      "C_ACTUAL": "Crescita attuale",
      "MEDIAN_TIME": "Tempo attuale della blockchain",
      "POW_MIN": "Difficoltà comune",
      "MONEY_RULES_DIVIDER": "Regole della moneta",
      "C_RULE": "Obiettivo teorico di crescità",
      "UD_RULE": "Dividendo universale (formula)",
      "DT_REEVAL": "Periodo tra due rivalutazioni del DU",
      "REEVAL_SYMBOL": "rival",
      "DT_REEVAL_VALUE": "Ogni <b>{{dtReeval|formatDuration}}</b> ({{dtReeval/86400}} {{'COMMON.DAYS'|translate}})",
      "UD_REEVAL_TIME0": "Data della prima rivalutazione del DU",
      "SIG_QTY_RULE": "Numero di certificazioni richieste per diventare membro",
      "SIG_STOCK": "Numero massimo di certificazioni inviate da un membro",
      "SIG_PERIOD": "Tempo minimo tra 2 certificazioni inviate da un unico membro.",
      "SIG_WINDOW": "Periodo massimo prima che una candidatura a membro venga studiata",
      "SIG_VALIDITY": "Durata di vita di una certificazione convalidata",
      "MS_WINDOW": "Periodo massimo prima che una certificazione in attesa sia convalidata",
      "MS_VALIDITY": "Durata di vita di un'adesione convalidata",
      "STEP_MAX": "Distanza massima tra un nuovo membro e ogni membro referente.",
      "WOT_RULES_DIVIDER": "Regole della Rete di Fiducia",
      "SENTRIES": "Numero di certificazioni (date <b>e</b> ricevute) per diventare membro referente ",
      "SENTRIES_FORMULA": "Numero di certificazioni necessarie per diventare membro (formula)",
      "XPERCENT":"Percentuale minima di membri referenti per rispettare la regola di distanza tra i membri",
      "AVG_GEN_TIME": "Tempo medio tra due blocchi",
      "CURRENT": "attuale",
      "MATH_CEILING": "TETTO",
      "DISPLAY_ALL_RULES": "Mostrare tutte le regole?",
      "BTN_SHOW_LICENSE": "Mostrare licenza",
      "WOT_DIVIDER": "Rete di Fiducia"
    },
    "LICENSE": {
      "TITLE": "Licenza attuale",
      "BTN_DOWNLOAD": "Scaricare il file",
      "NO_LICENSE_FILE": "File di licenza non trovato."
    }
  },
  "NETWORK": {
    "VIEW": {
      "MEDIAN_TIME": "Blockchain tempo",
      "LOADING_PEERS": "Caricando la lista dei nodi...",
      "NODE_ADDRESS": "Indirizzo del nodo",
      "SOFTWARE": "Software",
      "WARN_PRE_RELEASE": "Pre-versione (ultima versione stabile: <b>{{version}}</b>)",
      "WARN_NEW_RELEASE": "Versione <b>{{version}}</b> disponibile",
      "WS2PID": "Identificativo:",
      "PRIVATE_ACCESS": "Accesso privato",
      "POW_PREFIX": "Prefisso Prova di Lavoro:",
      "ENDPOINTS": {
        "BMAS": "Endpoint sicuro (SSL)",
        "BMATOR": "Interfaccia rete TOR",
        "WS2P": "Interfaccia WS2P",
        "ES_USER_API": "Cesium+ data node"
      }
    },
    "INFO": {
      "CONNECTING_TO_NETWORK": "Connessione alla rete...",
      "ANALYZING_NETWORK": "Analisi della rete {{currency|abbreviate}}...",
      "ONLY_SSL_PEERS": "I nodi non-SSL hanno un display semplificato perche Cesium funziona in modalità HTTPS."
    }
  },
  "PEER": {
    "PEERS": "Nodi",
    "SIGNED_ON_BLOCK": "Firmato nel blocco",
    "MIRROR": "Specchio",
    "MIRRORS": "Specchi",
    "MIRROR_PEERS": "Nodi specchio",
    "PEER_LIST" : "Lista dei nodi",
    "MEMBERS" : "Membri",
    "MEMBER_PEERS" : "Nodi membri",
    "ALL_PEERS" : "Tutti i nodi",
    "DIFFICULTY" : "Difficoltà",
    "API" : "API",
    "CURRENT_BLOCK" : "Blocco #",
    "POPOVER_FILTER_TITLE": "Filtro",
    "OFFLINE": "Sconessi",
    "OFFLINE_PEERS": "Nodi sconessi",
    "BTN_SHOW_PEER": "Mostrare Nodo",
    "VIEW": {
      "TITLE": "Nodo",
      "OWNER": "Proprietà di",
      "SHOW_RAW_PEERING": "Vedere il documento di peering",
     "SHOW_RAW_CURRENT_BLOCK": "Vedere l'utimo blocco (formatto grezzo)",
      "LAST_BLOCKS": "Ultimi blocchi",
      "KNOWN_PEERS": "Nodi conosciuti:",
      "GENERAL_DIVIDER": "Informazioni generali",
      "ERROR": {
        "LOADING_TOR_NODE_ERROR": "Impossibile ottenere i dati del nodo, tempo di attesa scaduto.",
        "LOADING_NODE_ERROR": "Impossibile ottenere i dati del nodo"
      }
    }
  },
  "WOT": {
    "SEARCH_HELP": "Cercare (membro o chiave pubblica)",
    "SEARCH_INIT_PHASE_WARNING": "La ricerca per le certificazioni in attesa <b>può essere lunga</b> durante la fase di pre-certificazione. La preghiamo di attendere...",
    "REGISTERED_SINCE": "Certificato dal",
    "REGISTERED_SINCE_BLOCK": "Certificato dal blocco #",
    "NO_CERTIFICATION": "Nessuna certificazione valida",
    "NO_GIVEN_CERTIFICATION": "Nessuna certificazione data",
    "NOT_MEMBER_PARENTHESIS": "(non-membro)",
    "IDENTITY_REVOKED_PARENTHESIS": "(identità revocata)",
    "MEMBER_PENDING_REVOCATION_PARENTHESIS": "(Cancellazione dell'identità in corso)",
    "EXPIRE_IN": "Scade",
    "NOT_WRITTEN_EXPIRE_IN": "Scadenza <br/> ",
    "EXPIRED": "Scaduto",
    "PSEUDO": "Pseudonimo",
    "SIGNED_ON_BLOCK": "Emessa nel blocco #{{block}}",
    "WRITTEN_ON_BLOCK": "Scritta nel blocco #{{block}}",
    "GENERAL_DIVIDER": "Informazioni generali",
    "NOT_MEMBER_ACCOUNT": "Conto non-membro",
    "NOT_MEMBER_ACCOUNT_HELP": "Questo è un portafoglio semplice, senza richiesta di certificazione emessa.",
    "TECHNICAL_DIVIDER": "Dati tecnici",
    "BTN_CERTIFY": "Certificare",
    "BTN_YES_CERTIFY": "Si, certificare",
    "BTN_SELECT_AND_CERTIFY": "Nuova certificazione",
    "ACCOUNT_OPERATIONS": "Operazioni sul conto",
    "VIEW": {
      "POPOVER_SHARE_TITLE": "Identità {{title}}"
    },
    "LOOKUP": {
      "TITLE": "Annuario",
      "NEWCOMERS": "Nuovi membri:",
      "NEWCOMERS_COUNT": "{{count}} membri",
      "PENDING": "Registrazioni in attesa",
      "PENDING_COUNT": "{{count}} inscrizioni in attesa",
      "REGISTERED": "Registrato {{sigDate | formatFromNow}}",
      "MEMBER_FROM": "Membro dal {{memberDate|medianFromNowShort}}",
      "BTN_NEWCOMERS": "Ultimi membri",
      "BTN_PENDING": "Registrazioni in attesa",
      "SHOW_MORE": "Vedere di più",
      "SHOW_MORE_COUNT": "(limite attuale di {{limit}})",
      "NO_PENDING": "Nessuna certificazione in attesa.",
      "NO_NEWCOMERS": "Nessun membro."
    },
    "CONTACTS": {
     "TITLE": "Contatti"
   },
    "MODAL": {
      "TITLE": "Ricerca"
    },
    "CERTIFICATIONS": {
      "TITLE": "{{uid}} - Certificazioni",
      "SUMMARY": "Certificazioni ricevute",
      "LIST": "Dettagli delle certificazioni ricevute",
      "PENDING_LIST": "Certificazioni in attesa",
      "RECEIVED": "Certificazioni ricevute",
      "RECEIVED_BY": "Certifications ricevute da {{uid}}",
      "ERROR": "Certificazioni ricevute per errore",
      "SENTRY_MEMBER": "Membro referente"
    },
    "OPERATIONS": {
      "TITLE": "{{uid}} - Operazioni"
    },
    "GIVEN_CERTIFICATIONS": {
      "TITLE": "{{uid}} - Certificazioni inviate",
      "SUMMARY": "Certificazioni inviate",
      "LIST": "Dettagli delle certificazioni inviate",
      "PENDING_LIST": "Certificazioni ",
      "SENT": "Certificazioni inviate",
      "SENT_BY": "Certificazioni inviate da {{uid}}",
      "ERROR": "Certificazioni inviate per errore"
    }
  },
  "LOGIN": {
    "TITLE": "<i class=\"icon ion-log-in\"></i> Accedi",
    "SCRYPT_FORM_HELP": "Accedi con tuoi dati <br> Ricordati di verificare che stai utilizzando la chiave del tuo conto.",
    "PUBKEY_FORM_HELP": "Scrivi qui la tua chiave pubblica:",
    "FILE_FORM_HELP": "Scegliere un portachiavi da utilizzare:",
    "SCAN_FORM_HELP": "Scansiona il codice QR di un portafoglio.",
    "SALT": "Identificativo segreto",
    "SALT_HELP": "Identificativo segreto",
    "SHOW_SALT": "Mostrare identificativo segreto?",
    "PASSWORD": "Password",
    "PASSWORD_HELP": "Password",
    "PUBKEY_HELP": "Chiave pubblica, pseudonimo",
    "NO_ACCOUNT_QUESTION": "Non hai ancora un conto?",
    "HAVE_ACCOUNT_QUESTION": "Hai già un conto?",
    "CREATE_ACCOUNT": "Creare un conto",
    "CREATE_FREE_ACCOUNT": "Crea un conto gratuito",
    "FORGOTTEN_ID": "Non ricordi la password?",
    "ASSOCIATED_PUBKEY": "Chiave pubblica:",
    "BTN_METHODS": "Altri metodi",
    "BTN_METHODS_DOTS": "Cambiare metodo...",
    "METHOD_POPOVER_TITLE": "Metodi",
    "MEMORIZE_AUTH_FILE": "Memorizzare questo portachiavi per la durata di questa sessione",
    "SCRYPT_PARAMETERS": "Parametri (Scrypt) :",
    "AUTO_LOGOUT": {
      "TITLE": "Informazioni",
      "MESSAGE": "<i class=\"ion-android-time\"></i> Sei stato <b>sconesso/ b> automaticamente, per un periodo di inattività prolongata",
      "BTN_RELOGIN": "Accedi",
      "IDLE_WARNING": "Sarai disconesso in... {{countdown}}"
    },
    "METHOD": {
      "SCRYPT_DEFAULT": "Accesso standard (imp. predefinita)",
      "SCRYPT_ADVANCED": "Accesso avanzato",
      "FILE": "File del portachiavi",
      "PUBKEY": "Chiave pubblica soltanto",
      "SCAN": "Scansiona un codice QR"
    },
    "SCRYPT": {
      "SIMPLE": "Accesso rapido",
      "DEFAULT": "Accesso standard",
      "SECURE": "Accesso sicuro",
      "HARDEST": "Accesso più sicuro",
      "EXTREME": "Accesso estremo",
      "USER": "Accesso personalizzato",
      "N": "N (Loop):",
      "r": "r (RAM):",
      "p": "p (CPU):"
    },
    "FILE": {
      "HELP": "Formato del file atteso: <b>.dunikey</b> (type PubSec). Altri formati in sviluppo (EWIF, WIF)."
    }
  },
  "AUTH": {
    "TITLE": "<i class=\"icon ion-locked\"></i> Autenticazione",
    "BTN_AUTH": "Autenticarsi",
    "GENERAL_HELP": "Autenticati :",
    "EXPECTED_UID_HELP": "Effettua il login nel conto <i class=\"ion-person\"></i> {{uid}}:",
    "EXPECTED_PUBKEY_HELP": "Si prega di autenticarsi nel portafoglio <i class=\"ion-key\"></i> {{pubkey|formatPubkey}}:",
    "SCAN_FORM_HELP": "Scansiona il codice QR della <b>chiave pubblica</b> del portafoglio."
  },
  "ACCOUNT": {
    "TITLE": "Il mio conto",
    "BALANCE": "Saldo",
    "LAST_TX": "Ultime transazioni",
    "BALANCE_ACCOUNT": "Saldo del conto",
    "NO_TX": "Nessuna transazione",
    "SHOW_MORE_TX": "Mostrare di più",
    "SHOW_ALL_TX": "Mostrare tutte",
    "TX_FROM_DATE": "(limite attuale del {{fromTime|medianFromNowShort}})",
    "PENDING_TX": "Transazioni in attesa",
    "VALIDATING_TX": "Transazioni in corso di convalida",
    "ERROR_TX": "Transazioni non eseguite",
    "ERROR_TX_SENT": "Transazioni inviate",
    "PENDING_TX_RECEIVED": "Transazioni in attesa di recezione",
    "EVENTS": "Eventi",
    "OUT_DISTANCED": "Le tue certificazioni attuali provengono da un gruppo troppo isolato dalla <a ng-click=\"showHelpModal('wot')\">Rete di Fiducia</a> (WoT): la <a ng-click=\"showHelpModal('distance_rule')\">la regola della distanza</a> massima non è rispettata.<br/>Devi ottenere una certificazione da un'altra zona della RdF, o aspettare che si rinforzi.",
    "WAITING_MEMBERSHIP": "Richiesta di certificazione inviata. In attesa di validazione.",
    "WAITING_CERTIFICATIONS": "Hai bisogno di {{needCertificationCount}} certificazione(i) per diventare membro.",
     "WAITING_CERTIFICATIONS_HELP": "Per ottenere le certificazioni necessarie, richiedile solo ai membri <b>che già conosci a sufficienza</b>, come richiesto dalla <a ng-click=\"showLicenseModal()\">licenza della moneta libera</a> che hai accettato.<br/>Se non conosci abbastanza membri, fatti conoscere <a ng-click=\"openLink($event, $root.settings.userForumUrl)\">nel forum</a>.",
    "WILL_MISSING_CERTIFICATIONS": "Ti serviranno a breve <b>delle certificazioni</b> (occorrono almeno altre{{willNeedCertificationCount}} certificazioni)",
    "WILL_NEED_RENEW_MEMBERSHIP": "La tua certificazione <b>scadrà{{membershipExpiresIn|formatDurationTo}}</b>. Ricordati di <a ng-click=\"doQuickFix('renew')\">rinnovarla</a> prima.",
    "NEED_RENEW_MEMBERSHIP": "Non sei più un membro perchè la tua adesione <b>è scaduta</b>. Ricordati di <a ng-click=\"doQuickFix('renew')\">rinnovare la tua adesione</a>.",
    "NEED_RENEW_MEMBERSHIP_AFTER_CANCELLED": "Non sei più membro perchè la tua adesione  <b>è stata cancellata</b> per mancanza di certificazioni. Ricordati di <a ng-click=\"doQuickFix('renew')\">rinnovare la tua adesione alla RdF</a>.",
    "NO_WAITING_MEMBERSHIP": "Nessuna domanda di adesione in attesa. Se desideri <b>diventare membro</b>, ricordati di <a ng-click=\"doQuickFix('membership')\">inviare tua domanda di adesione</a>.",
    "CERTIFICATION_COUNT": "Certificazioni ricevute",
    "CERTIFICATION_COUNT_SHORT": "Certificazioni",
    "SIG_STOCK": "Stock di certificazioni da inviare",
    "BTN_RECEIVE_MONEY": "Ricevere",
    "BTN_SELECT_ALTERNATIVES_IDENTITIES": "Usare un'altra identità..",
    "BTN_FIX_MEMBERSHIP": "Invia nuovamente una richiesta di adesione...",
    "BTN_MEMBERSHIP_RENEW": "Rinnovare adesione",
    "BTN_MEMBERSHIP_RENEW_DOTS": "Rinnovare adesione ...",
    "BTN_MEMBERSHIP_OUT_DOTS": "Revocare adesione...",
    "BTN_SECURITY_DOTS": "Accesso e securità...",
    "BTN_SHOW_DETAILS": "Visualizza dati tecnici",
    "LOCKED_OUTPUTS_POPOVER": {
      "TITLE": "Importo bloccato",
      "DESCRIPTION": "Ecco le condizioni per sbloccare questo importo:",
      "DESCRIPTION_MANY": "Questa transazione è fatta da diverse parti, queste sono le condizioni di sblocco:",
      "LOCKED_AMOUNT": "Importo bloccato:"
    },
    "NEW": {
      "TITLE": "Registrazione",
      "INTRO_WARNING_TIME": "Crearsi un conto su {{name|capitalize}} è molto semplice. È consigliato prendere il giusto tempo per farlo correttamente (per evitare di dimenticare passwords, pseudonimi etc.).",
      "INTRO_WARNING_SECURITY": "Occorre verificare che l'hardware che stai utilizzando (computer, tablet, cellulare) <b>è sicuro e affidabile</b>.",
      "INTRO_WARNING_SECURITY_HELP": "Anti-virus aggiornato, firewall abilitato, sessione protteta da una password o codice PIN...",
      "INTRO_HELP": "Cliccare <b> {{'COMMON.BTN_START'|translate}}</b> per avviare la creazione del conto. Ti accompagniamo passo a passo.",
      "REGISTRATION_NODE": "La tua iscrizione verrà salvata dal nodo Duniter <b>{{server}}</b>, è verrà poi condivisa nella rete della moneta.",
      "REGISTRATION_NODE_HELP": "Se non ti fidi di questo nodo, per favore cambialo <a ng-click=\"doQuickFix('settings')\">nelle impostazioni/a> di Cesium.",
      "SELECT_ACCOUNT_TYPE": "Scegliere un tipo di conto:",
      "MEMBER_ACCOUNT": "Conto membro",
      "MEMBER_ACCOUNT_TITLE": "Creare un conto membro",
      "MEMBER_ACCOUNT_HELP": "Se non sei ancora registrato come individuo (un conto per persona soltanto).",
      "WALLET_ACCOUNT": "Portafoglio semplice",
      "WALLET_ACCOUNT_TITLE": "Creare un portafoglio",
      "WALLET_ACCOUNT_HELP": "Se rappresenti un'azienda, associazione, altro ente o hai necessita di un altro portafoglio. Nessun Dividendo Universale sarà prodotto da questo conto.",
      "SALT_WARNING": "Scegliere un identificativo segreto.<br/>È necessario per ogni connessione a questo conto.<br/><br/><b>Accertati di ricordarlo!</b>.<br/>Se lo dimentichi non ti potrà aiutare nessuno!",
      "PASSWORD_WARNING": "Scegliere una password.<br/>È necessaria per ogni connessione a questo conto.<br/><br/><b>Accertati di ricordarla!</b>.<br/>Se la dimentichi non ti potrà aiutare nessuno!",
      "PSEUDO_WARNING": "Segliere uno pseudonimo.<br/>Puo essere utile per chi ti cerca nella rete.<br/><br/>.L'utilizzo delle<b>virgole, spazi e accenti</b> è vietato.<br/><div class='hidden-xs'><br/>Esempio: <span class='gray'>JohnDalton, JackieChan, etc.</span>",
      "PSEUDO": "Pseudonimo",
      "PSEUDO_HELP": "joe123",
      "SALT_CONFIRM": "Confermare",
      "SALT_CONFIRM_HELP": "Confermare l'identificativo segreto",
      "PASSWORD_CONFIRM": "Confermare",
      "PASSWORD_CONFIRM_HELP": "Confermare la password",
      "SLIDE_6_TITLE": "Conferma:",
      "COMPUTING_PUBKEY": "Calcolando...",
      "LAST_SLIDE_CONGRATULATION": "Hai riempito tutti i campi richiesti.<br/><b>Puoi inviare la richiesta di creazione del conto</b>.<br/><br/>Per tua informazione, la chiave pubblica qui sotto identifica il tuo futuro conto.<br/>Puo essere comunicata a chi ti deve pagare.<br/>Quando il tuo conto verrà approvato potrai trovare la chiave qui <b>{{'ACCOUNT.TITLE'|translate}}</b>.",
      "CONFIRMATION_MEMBER_ACCOUNT": "<b class=\"assertive\">Warning:</b>Il tuo identificatore segreto, la tua password e il tuo pseudonimo non si possono cambiare.<br/><b>Ricordali per sempre!</b><br/><b>Sei sicuro/a</b>di voler inviare questa richiesta di creazione di conto?",
      "CONFIRMATION_WALLET_ACCOUNT": "<b class=\"assertive\">Warning:</b>Il tuo identificatore segreto, la tua password e tuo pseudonimo non si possono cambiare..<br/><b>Ricordali per sempre!</b><br/><b>Sei sicuro/a</b> di voler continuare?",
      "CHECKING_PSEUDO": "Verificazione in corso...",
      "PSEUDO_AVAILABLE": "Pseudonimo disponibile",
      "PSEUDO_NOT_AVAILABLE": "Pseudonimo indisponibile",
      "INFO_LICENSE": "Per aderire alla moneta, ti chiediamo di leggere e accetare le condizioni della licenza.",
      "BTN_ACCEPT": "Accetto",
      "BTN_ACCEPT_LICENSE": "Accetto la licenza"
    },
    "POPUP_REGISTER": {
      "TITLE": "Pseudonimo",
      "HELP": "Uno pseudonimo è necessario affinchè gli altri ti possino trovare."
    },
    "SELECT_IDENTITY_MODAL": {
     "TITLE": "Selezionare una identità",
     "HELP": "Più <b>identità diverse</b> sono state inviate per la chiave pubblica <span class=\"gray\"><i class=\"ion-key\"></i> {{pubkey|formatPubkey}}</span>.<br/>Seleziona un dossier da usare :"
   },
    "SELECT_WALLET_MODAL": {
      "TITLE": "Selezione del portafoglio"
    },
    "CERTIFICATION_MODAL": {
      "CHECKLIST_TITLE": "Lista di controllo prima della certificazione",
      "INFOS": "La sicurezza della valuta Ğ1 dipende da ogni membro. Prima di certificare l'identità di questa persona, è necessario effettuare alcuni controlli. Si prega di rispondere alle seguenti domande:",
      "BTN_ALL_CHECK": "Certifica",
      "CHECKLIST_CONDITIONS_NOT_MET": "La certificazione non è stata inviata. I controlli sembrano insufficienti. Si prega di verificare nuovamente ogni punto con la persona che si desidera certificare.",
      "QUESTIONS": {
        "WELL_KNOWN": "<b>Conosci bene</b> la persona che stai per certificare e conosci altre persone che la conoscono bene?",
        "REVOCATION": "Ha scaricato il suo <b>documento di revoca</b> e sa dove trovarlo?",
        "CONTACT": "Hai <b>contattato</b> questa persona in vari modi e ti ha risposto?",
        "DOUBLE_IDENTITY": "La persona dovrebbe possedere <b>solo un'identità di membro attiva</b>. Ne possiede un'altra?",
        "MASTER_ACCOUNT": "Ha il controllo del suo account e ha già <b>effettuato almeno un trasferimento</b> dal suo account?",
        "LICENSE": "Ha <b>compreso la licenza</b> di Duniter e accetta di conformarsi ad essa per le future certificazioni?",
        "CREDENTIALS": "L'account è stato creato con un <b>ID/password lungo e complesso</b> (frasi segrete)? La persona ha compreso che sia l'ID che la password devono rimanere segreti? È sicura di ricordarli o di poterli recuperare?",
        "PUBLIC_KEY_DIFFERENT": "La <b>chiave pubblica</b> mostrata deve essere <b>identica</b> a quella che la persona ti ha comunicato. Le chiavi pubbliche sono <b>diverse</b>?"
      },
      "REMINDER_TITLE": "Promemoria",
      "SHORT_LICENSE_REMINDER": "Puoi ricordare alla persona da certificare i parametri delle certificazioni:<br/><br/><ul><li> - Ogni membro può certificare al massimo 100 identità.</li><li> - Le certificazioni vengono registrate con un intervallo di 5 giorni.</li><li> - Una nuova identità deve raccogliere almeno 5 certificazioni in meno di 2 mesi.</li><li> - Un membro deve rinnovare la sua adesione almeno una volta all'anno.</li><li> - Le certificazioni sono valide per due anni.</li></ul>"
    },
    "WALLET_LIST": {
      "TITLE": "Portafoglio secondario",
      "BTN_NEW": "Aggiungi un portafoglio",
      "BTN_DOWNLOAD": "Scarica la lista",
      "BTN_IMPORT_FILE_DOTS": "Importa da un file...",
      "NO_WALLET": "Nessun portafoglio secondario",
      "BTN_DELETE": "Rimuovi un portafoglio secondario ...",
      "BTN_RENAME": "Rinominare il portafoglio",
      "EXPORT_FILENAME": "my_wallets-{{pubkey|formatPubkey}}-{{currency}}.csv",
      "TOTAL_DOTS": "Totale: ",
      "EDIT_POPOVER": {
        "TITLE": "Rinominare il portafoglio",
        "HELP": "Compila il nuovo nome",
        "NAME_HELP": "Nome del portafoglio"
      },
      "IMPORT_MODAL": {
        "TITLE": "Importare un portafoglio secondario",
        "HELP": "Per <b>importare un portafoglio secondario</b>,per favore trascina il file nella casella sottostante, o fai click nella casella per cercare un file.",
        "WALLET_COUNT": "<b>{{count}}</b> Nuovo portafoglio{{count > 1 ? 's' : ''}}",
        "NO_NEW_WALLET": "Nessun nuovo portafoglio"
      }
    },
    "SECURITY":{
      "ADD_QUESTION" : "Aggiungere domanda personalizzata",
      "BTN_CLEAN" : "Svuotare",
      "BTN_RESET" : "Reset",
      "DOWNLOAD_REVOKE": "Salvare un file di revoca",
      "DOWNLOAD_REVOKE_HELP" : "Avere une file di revoca è necessario in caso di smarrimento delle tue credenziali. Ti permette <b> di rimuovere tuo conto dalla Rete di Fiducia</b>, per farlo tornare ad essere un semplice portafoglio.",
      "GENERATE_KEYFILE": "Genera il mio file portachiavi ...",
      "GENERATE_KEYFILE_HELP": "Genera un file che ti permette di autenticarti senza digitare le tue credenziali.<br/><b>Attenzione:</b> questo file contiene la tua chiave segreta: è perciò oltremodo importante salvarlo in un posto sicuro!",
      "KEYFILE_FILENAME": "portachiavi-{{pubkey|formatPubkey}}-{{currency}}-{{format}}.dunikey",
      "MEMBERSHIP_IN": "Iscriviti come membro...",
      "MEMBERSHIP_IN_HELP": "Ti permette <b>convertire </b> un conto semplice <b>in un conto membro</b>, inviando una richiesta di adesione alla RdF. Utile solo se non sei già in possesso di un conto membro.",
      "SEND_IDENTITY": "Pubblica identità...",
      "SEND_IDENTITY_HELP": "Ti permette associare uno pseudonimo a questo conto, ma <b>ma senza richiedere l'adesione</b> per diventare membro. Questa funzione non è ancora molto utile perchè la validità di questo pseudonimo è limitata nel tempo.",
      "HELP_LEVEL": "Scegliere <strong> almeno{{nb}} domande </strong> :",
      "LEVEL": "Livello di sicurezza",
      "LOW_LEVEL": "Basso <span class=\"hidden-xs\">(minimo di 2 domande)</span>",
      "MEDIUM_LEVEL": "Medio <span class=\"hidden-xs\">(minimo di 4 domande)</span>",
      "QUESTION_1": "Qual'era il nome del tuo miglior amico quando eri adolescente?",
      "QUESTION_2": "Qual'era il nome del tuo primo animale domestico?",
      "QUESTION_3": "Qual'è il primo piatto che imparasti a cucinare?",
      "QUESTION_4": "Qual'è il primo film che hai visto al cinema?",
      "QUESTION_5": "Qual'era la destinazione del tuo primo volo?",
      "QUESTION_6": "Qual'era il nome del tuo professore preferito a scuola?",
      "QUESTION_7": "Quale sarebbe il tuo lavoro preferito?",
      "QUESTION_8": "Qual'è il tuo libro per bimbi preferito?",
      "QUESTION_9": "Qual'era il marchio della tua prima macchina?",
      "QUESTION_10": "Qual'era il tuo nomignolo da ragazzino/a?",
      "QUESTION_11": "Qual'era il tuo personaggio di film o attore preferito quand eri studente?",
      "QUESTION_12": "Qual'era il tuo musicista/cantante/grupo preferito quando eri studente?",
      "QUESTION_13": "In che città si sono conosciuti i tuoi genitori?",
      "QUESTION_14": "Qual'era il nome del tuo primo capo?",
      "QUESTION_15": "Qual'è il nome della strada dove sei cresciuto/a?",
      "QUESTION_16": "Qual'è il nome della tua spiaggia preferita?",
      "QUESTION_17": "Qual'è il primo album che ti sei comprato?",
      "QUESTION_18": "Qual'è il nome della squadra di sport preferita?",
      "QUESTION_19": "Cosa faceva il tuo nonno?",
      "RECOVER_ID": "Recuperare la mia password...",
      "RECOVER_ID_HELP": "Se hai un<b<file di backup delle tue credenziali</b>, lo puoi trovare rispondendo correttamente alle tue domande personalizzate.",
      "REVOCATION_WITH_FILE" : "Revocare il mio conto membro...",
      "RECOVER_ID_SELECT_FILE": "Seleziona il <b>file di backup dei tuoi identificatori</b> da usare:",
      "REVOCATION_WITH_FILE_DESCRIPTION": "Se pensi di aver perso <b>definitivamente le tue credenziali</b> di conto membro (o che la sicurezza del tuo conto sia compromessa), puoi usare <b>il file di revoca</b> del conto <b>per forzare la sua uscita permanente dalla Rete di Fiducia</b>.",
      "REVOCATION_WITH_FILE_HELP": "Se hai <b>definitivamente perso le tue credenziali (o se la sicurezza del tuo conto è compromessa), puoi usare <b>il file di revoca</b> del conto <b>per uscire dalla Rete di Fiducia</b>.",
      "REVOCATION_WALLET": "Revocare immediatamente questo conto",
      "REVOCATION_WALLET_HELP": "Richiedere la cancellazione dell'identità <b>revocherà la tua adesione alla Rete di Fiducia</ b> (definitivamente per lo pseudonimo e per la chiave pubblica associata). Il conto non potrà più produrre il Dividendo Universale.<br/>Nonostante ciò, puoi ancora usare il conto come semplice portafoglio.",
      "REVOCATION_FILENAME": "revocation-{{uid}}-{{pubkey|formatPubkey}}-{{currency}}.txt",
      "SAVE_ID": "Salvare le mie credenziali...",
      "SAVE_ID_HELP": "Creare un file di backup, per <b>recuperare la tua password</b> (e l'identificativo segreto) <b> in caso di smarrimento</b>. Il file è <b>sicuro</ b> (cifrato) utilizzando le domande personalizzate.",
      "STRONG_LEVEL": "Alto <span class=\"hidden-xs \">(minimo di 6 domande)</span>",
      "TITLE": "Conto e sicurezza",
        "KEYFILE": {
        "PUBSEC_FORMAT": "PubSec format.",
        "PUBSEC_FORMAT_HELP": "Questo formato di file è compatibile in particolare con Cesium e Gannounce. Il tuo portachiavi è conservato <b>senza cifratura</b>: chiunque con una copia di questo file sarà in grado di svuotare il tuo conto.",
        "WIF_FORMAT": "Wallet Import Format (WIF)",
        "WIF_FORMAT_HELP": "Questo formato è usato in particolare dai portafogli cartacei. Il tuo portachiavi è conservato <b>senza cifratura</b>: chiunque con una copia di questo file sará in grado di svuotare il tuo conto.",
        "EWIF_FORMAT": "Encrypted Wallet Import Format (WIF)",
        "EWIF_FORMAT_HELP": "Questo formato è usato in particolare dai portafogli cartacei. Tuttavia, <b>il portachiavi è cifrato</b> con una passphrase di tua scelta.",
        "PASSWORD_POPUP": {
          "TITLE": "File del portachiavi cifrato",
          "HELP": "Per favore introduci la passphrase:",
          "PASSWORD_HELP": "Passphrase"
        },
        "ERROR": {
          "BAD_PASSWORD": "Passphrase errata",
          "BAD_CHECKSUM": "Checksum errato"
        }
      }
    },
    "FILE_NAME": "{{currency}} - Account statement {{pubkey|formatPubkey}} to {{currentTime|formatDateForFile}}.csv",
    "HEADERS": {
      "TIME": "Data",
      "AMOUNT": "Importo",
      "COMMENT": "Commento"
    }
  },
  "TRANSFER": {
    "TITLE": "Bonifico",
    "SUB_TITLE": "Fare un bonifico",
    "SUB_TITLE_ALL": "Svuota il conto",
    "FROM": "Da",
    "TO": "A",
    "AMOUNT": "Importo",
    "AMOUNT_HELP": "Importo",
    "COMMENT": "Commenti",
    "COMMENT_HELP": "Commenti",
    "BTN_SEND": "Inviare",
    "BTN_ADD_COMMENT": "Scrivere un commento?",
    "REST": "Resto del conto",
    "REST_TO": "a",
    "WARN_COMMENT_IS_PUBLIC": "Ti avvertiamo <b>che i commenti sono pubblici</b> (non cifrati).",
    "MODAL": {
      "TITLE": "Bonifico"
    }
  },
  "ERROR": {
    "UNKNOWN_URI_FORMAT": "Formato URI sconosciuto",
    "PUBKEY_INVALID_CHECKSUM": "Chiave pubblica non valida (checksum errato).",
    "POPUP_TITLE": "Errore",
    "UNKNOWN_ERROR": "Errore",
    "TIMEOUT_REACHED": "Tempo di attesa del nodo superato ({{timeout|formatDurationMs}}).<br/><br/><small>{{url}}</small>",
    "CRYPTO_UNKNOWN_ERROR": "Il tuo navigatore non sembra compatibile con le funzionalità di cryptografia.",
    "DOWNLOAD_KEYFILE_FAILED": "Errore nel generare il file del portachiavi",
    "EQUALS_TO_PSEUDO": "Deve essere diverso dallo pseudonimo",
    "EQUALS_TO_SALT": "Deve essere diverso dall'identificativo segreto",
    "FIELD_REQUIRED": "Campo obbligatorio.",
    "FIELD_TOO_SHORT": "Valore troppo corto.",
    "FIELD_TOO_SHORT_WITH_LENGTH": "Valore troppo corto ({{minLength}} caratteri min)",
    "FIELD_TOO_LONG": "Valore troppo lungo",
    "FIELD_TOO_LONG_WITH_LENGTH": "Valore troppo lungo ({{maxLength}} caractteri max)",
    "FIELD_MIN": "Valore minimo : {{min}}",
    "FIELD_MAX": "Valore massimo : {{max}}",
    "FIELD_ACCENT": "Virgole e caratteri accentati vietati",
    "FIELD_NOT_NUMBER": "Valore numerico atteso",
    "FIELD_NOT_INT": "Valore intero atteso",
    "FIELD_NOT_EMAIL": "Indirizzo mail non valido",
    "PASSWORD_NOT_CONFIRMED": "Non corrisponde alla password.",
    "SALT_NOT_CONFIRMED": "Non corrisponde all'identificativo segreto.",
    "SEND_IDENTITY_FAILED": "Iscrizione fallita.",
    "SEND_CERTIFICATION_FAILED": "Certificazione fallita.",
    "NEED_MEMBER_ACCOUNT_TO_CERTIFY": "Non puoi inviare certificazioni perchè il tuo conto <b>non è ancora un conto membro</b>.",
    "NEED_MEMBER_ACCOUNT_TO_CERTIFY_HAS_SELF": "Non puoi inviare certificazioni adesso perchè <b>non sei ancora membro</b>.<br/><br/>Devi ancora entrare nella Rete di Fiducia.",
    "IDENTITY_TO_CERTIFY_HAS_NO_SELF": "Impossibile certificare questo conto. Nessuna richiesta di certificazione trovata o bisogna rinnovarla.",
    "LOGIN_FAILED": "Errore di login.",
    "LOAD_IDENTITY_FAILED": "Impossibile caricare la tua identità.",
    "LOAD_REQUIREMENTS_FAILED": "Impossibile caricare i prerequisiti dell'identità.",
    "SEND_MEMBERSHIP_IN_FAILED": "Ingresso nella RdF fallito.",
    "SEND_MEMBERSHIP_OUT_FAILED": "Errore nell'invio della revocazione.",
    "REFRESH_WALLET_DATA": "Impossibile aggiornare il portafoglio.",
    "GET_CURRENCY_PARAMETER": "Impossibile recuperare i parametri della moneta.",
    "GET_CURRENCY_FAILED": "Impossibile caricare la moneta. Riprovare più tardi.",
    "SEND_TX_FAILED": "Impossibile eseguire la transazione.",
    "ALL_SOURCES_USED": "Per favore aspetta il calcolo del prossimo blocco (Tutte le tue fonti di moneta sono state utilizzate).",
    "NOT_ENOUGH_SOURCES": "Non hai abbastanza fondi per inviare questo importo in una sola transazione.<br/>Importo massimo: {{amount}} {{unit}}<sub>{{subUnit}}</sub>.",
    "ACCOUNT_CREATION_FAILED": "Errore nella creazione del tuo conto membro.",
    "RESTORE_WALLET_DATA_ERROR": "Errore nell'aggiornamento delle impostazioni definite in local storage.",
    "LOAD_WALLET_DATA_ERROR": "Errore nel caricamento dei dati del portafoglio.",
    "COPY_CLIPBOARD_FAILED": "Impossibile copiare al clipboard",
    "TAKE_PICTURE_FAILED": "Impossibile recuperare foto.",
    "SCAN_FAILED": "Impossibile scansionare il codice QR.",
    "SCAN_UNKNOWN_FORMAT": "Codice non riconosciuto.",
    "WOT_LOOKUP_FAILED": "Ricerca fallita.",
    "LOAD_PEER_DATA_FAILED": "Nodo Duniter non accessibile. Riprovare più tardi.",
    "NEED_LOGIN_FIRST": "Accedi prima al tuo conto.",
    "AMOUNT_REQUIRED": "Importo necessario.",
    "AMOUNT_NEGATIVE": "Importo negativo non consentito.",
    "NOT_ENOUGH_CREDIT": "Saldo insufficiente",
    "INVALID_NODE_SUMMARY": "Impossibile comunicare col nodo o indirizzo non valido",
    "INVALID_USER_ID": "Il campo dello 'pseudonimo' non deve avere spazi vuoti o caratteri speciali.",
    "INVALID_COMMENT": "Il formato del campo 'reference' è errato.",
    "INVALID_PUBKEY": "If formato della chiave pubblica è errato.",
    "INVALID_PUBKEY_CHECKSUM": "Checksum non valido.",
    "IDENTITY_REVOKED": "Questa identità <b>è stata revocata</b>. Non puo più diventare membro.",
    "IDENTITY_REVOKED_WITH_TIME": "Questa identità <b>è stata revocata {{revocationTime|medianFromNow}}</b> ({{revocationTime|medianDate}}). Non puo più diventare membro.",
    "IDENTITY_PENDING_REVOCATION": "L'<b>annulamento di questa identità</b> è stata richiesta ed è in corso di valutazione. Capacità ad inviare certificazioni disabilitata",
    "IDENTITY_INVALID_BLOCK_HASH": "Questa richiesta di certificazione non è più valida (perche si riferisce ad un blocco che è stato eliminato dai nodi): la persona deve rinnovare la sua domanda di certificazione <b>prima</b> di essere certificata.",
    "IDENTITY_EXPIRED": "Questa identità è scaduta: la persona deve fare una nuova domanda di certificazione <b>prima di</b> essere certificata.",
    "IDENTITY_SANDBOX_FULL": "Il nodo Duniter utilizzato dal Cesium non può ricevere altre domande di certificazione per ora, la lista d'attesa è piena.<br/><br/>Riprova più tardi o scegli un'altro nodo Duniter (nelle <b>Impostazioni</b>).",
    "IDENTITY_NOT_FOUND": "Identità non trovata",
    "IDENTITY_TX_FAILED": "Impossibile caricare le operazioni",
    "WOT_PENDING_INVALID_BLOCK_HASH": "Adesione non valida.",
    "WALLET_INVALID_BLOCK_HASH": "La tua domanda di certificazione non è più valida (perché si riferisce ad un blocco che è stato eliminato dai nodi).<br/>Devi <a ng-click=\"doQuickFix('renew')\">rinnovare la tua richiesta di adesione alla RdF</a> per risolvere il problema.",
    "WALLET_IDENTITY_EXPIRED": "La pubblicazione della tua identità <b>è scaduta</b>.<br/>Devi <a ng-click=\"doQuickFix('fixIdentity')\">ripubblicare la tua identità</a> per risolvere il problema.",
    "WALLET_REVOKED": "La tua identità è stata <b>revocata</b>: né il tuo pseudonimo né la tua chiave pubblica sarano utilizzati in futuro.",
    "WALLET_HAS_NO_SELF": "La tua identità deve prima essere stata pubblicata e non essere ancora scaduta.",
    "AUTH_REQUIRED": "Autenticazione necessaria.",
    "AUTH_INVALID_PUBKEY": "La chiave pubblica non corrisponde al conto conesso.",
    "AUTH_INVALID_SCRYPT": "Password o nome di utente non valido.",
    "AUTH_INVALID_FILE": "File di portachiavi non valido.",
    "AUTH_FILE_ERROR": "Impossibile aprire il file di portachiavi",
    "IDENTITY_ALREADY_CERTIFY": "Hai <b>già certificato</b> questa identità.<br/><br/>Il tuo certificato è ancora valido (scade {{expiresIn|formatDuration}}).",
    "IDENTITY_ALREADY_CERTIFY_PENDING": "Hai <b>già certificato</b> questa identità.<br/><br/>La tua certificazione è ancora pendente (Scadenza del periodo di trattamento {{expiresIn|formatDuration}}).",
    "UNABLE_TO_CERTIFY_TITLE": "Impossibile certificare",
    "LOAD_NEWCOMERS_FAILED": "Impossibile caricare i nuovi membri.",
    "LOAD_PENDING_FAILED": "Impossibile caricare le certificazioni pendenti.",
    "ONLY_MEMBER_CAN_EXECUTE_THIS_ACTION": "Devi <b>essere membro</b> per poter fare questo.",
    "ONLY_MEMBER_OR_WAS_MEMBER_CAN_EXECUTE_THIS_ACTION": "Devi <b>essere membro</b> (o un ex-membro) per poter fare questo.",
    "ONLY_SELF_CAN_EXECUTE_THIS_ACTION": "Devi aver <b>pubblicato la tua identità</b> per poter fare questo.",
    "GET_BLOCK_FAILED": "Impossibile caricare il blocco",
    "INVALID_BLOCK_HASH": "Blocco non trovato (hash errato)",
    "DOWNLOAD_REVOCATION_FAILED": "Errore avvenuto nel download del file di cancellazione d'identità.",
    "REVOCATION_FAILED": "Errore avvenuto durante la richiesta di cancellazione dell'identità.",
    "SALT_OR_PASSWORD_NOT_CONFIRMED": "Identificativo segreto o password sbagliati",
    "RECOVER_ID_FAILED": "Impossibile recuperare la password",
    "LOAD_FILE_FAILED" : "Impossibile caricare il file",
    "NOT_VALID_REVOCATION_FILE": "File di cancellazione dell'identità errato (formato di file incorreto)",
    "NOT_VALID_SAVE_ID_FILE": "File di backup delle credenziali errato (formato di file incorreto)",
    "NOT_VALID_KEY_FILE": "File del portachiavi non valido (formato non riconosciuto)",
    "EXISTING_ACCOUNT": "Le tue credenziali corrispondono a quelli di un conto già esistente,di cui <a ng-click=\"showHelpModal('pubkey')\">la chiave pubblica</a> è:",
    "EXISTING_ACCOUNT_REQUEST": "Per favore cambia le tue credenziali in modo che corrispondino ad un conto non utilizzato.",
    "GET_LICENSE_FILE_FAILED": "Impossibile caricare il file della licenza",
    "CHECK_NETWORK_CONNECTION": "Nessun nodo sembra disponibile.<br/><br/>Per favore <b>verifica la tua connessione Internet</b>.",
    "ISSUE_524_TX_FAILED": "Bonifico .<br/><br/>Un messaggio è stato inviato agli sviluppatori per aiutare a risolvere il problema. <b>Grazie per il tuo aiuto</b>.",
    "ADD_SECONDARY_WALLET_FAILED": "Impossibile aggiungere un portafoglio secondario.",
    "REMOVE_SECONDARY_WALLET_FAILED": "Impossibile rimuovere un portafoglio secondario.",
    "UPDATE_WALLET_LIST_FAILED": "Impossibile aggiornare la lista dei portafogli.",
    "LOAD_WALLET_LIST_FAILED": "Impossibile caricare la lista dei portafogli.",
    "SAVE_WALLET_LIST_FAILED": "Impossibile salvare la lista dei portafogli.",
    "COULD_NOT_ADD_MAIN_WALLET": "Questo portafoglio <b>è il conto principale</b> con il quale sei connesso. Impossibile aggiungerlo come un portafoglio secondario.",
    "COULD_NOT_ADD_EXISTING_WALLET": "Portafoglio già presente nella lista.",
    "UNKNOWN_WALLET_ID": "Portafoglio secondario sconosciuto.",
    "RESTORE_WALLET_LIST_FAILED": "Impossibile recuperare la lista dei portafogli.",
    "INVALID_FILE_FORMAT": "Formato file invalido.",
    "SAME_TX_RECIPIENT": "Il destinatario deve essere diverso dall'emittente."
   },
  "INFO": {
    "POPUP_TITLE": "Informazioni",
    "CERTIFICATION_DONE": "Identità firmata con successo",
    "NOT_ENOUGH_CREDIT": "Saldo insufficiente",
    "TRANSFER_SENT": "Transazione inviata con successo",
    "COPY_TO_CLIPBOARD_DONE": "Copiato con successo",
    "MEMBERSHIP_OUT_SENT": "Revoca dell'identità inviata",
    "NOT_NEED_MEMBERSHIP": "Già membro.",
    "IDENTITY_WILL_MISSING_CERTIFICATIONS": "A questa identità mancheranno a breve certificazioni (almeno {{willNeedCertificationCount}}).",
    "IDENTITY_NEED_MEMBERSHIP": "Questa identità non ha ancora spedito una richiesta di adesione alla RdF. Dovrà farlo se desidera diventare membro.",
    "HAS_ALTERNATIVE_IDENTITIES": "Ci sono <b>più identità</b> associate a questa chiave pubblica. <b>Prima di qualsiasi certificazione</b>, <a ng-click=\"doQuickFix('showSelectIdentities')\">controlla altre identità</a> per scegliere quella corretta oppure contatta il proprietario del portafoglio.",
    "REVOCATION_SENT": "Revoca dell'identità inviata",
    "REVOCATION_SENT_WAITING_PROCESS": "Cancellazione dell'identità <b>inviata con successo</b>. In attesa di validazione.",
    "FEATURES_NOT_IMPLEMENTED": "Questa funzionalità non è ancora disponibile.<br/><br/>Vuoi contribuire per velocizzarne la disponibilità? ;)",
    "EMPTY_TX_HISTORY": "Nessuna operazione da esportare",
    "LOADING_PENDING_TX": "Caricando...<br/><small>(Recupero delle operazioni in sospeso)</small>"
  },
  "CONFIRM": {
    "CAN_CONTINUE": "<b>Sei sicuro/a</b> di voler procedere?",
     "POPUP_TITLE": "<b>Conferma</b>",
    "POPUP_WARNING_TITLE": "<b>Avviso</b>",
    "POPUP_SECURITY_WARNING_TITLE": "<i class=\"icon ion-alert-circled\"></i> <b>Avvertimento di sicurezza</b>",
    "CERTIFY_RULES_TITLE_UID": "Certificare {{uid}}",
    "CERTIFY_RULES": "<b class=\"assertive\">Non certificare un conto</b> se credi che: <ul><li>1.) L'identità della persona potrebbe essere finta.<li>2.) La persona ha già un conto certicato.<li>3.) La persona trasgredisce la regola 1 o 2 o entrambe. (Certifica conti finti o gemelli).</ul></small><br/>Sei sicuro di voler certificare questa identità?",
    "FULLSCREEN": "Aprire l'applicazione a schermo intero?",
    "EXIT_APP": "Chiudere l'applicazione?",
    "TRANSFER": "<b>Resoconto del bonifico:</b><br/><br/><ul><li> - Inviato da: <b>{{from}}</b></li><li> - A: <b>{{to}}</b></li><li> - Importo: <b>{{amount}} {{unit}}</b></li><li> - Comemnto: <i>{{comment}}</i></li></ul><br/><b>Sei sicuro di voler procedere con questo bonifico?</b>",
    "TRANSFER_ALL": "<b>Riepilogo del bonifico:</b><br/><br/><ul><li> - Da: <b>{{from}}</b></li><li> - A: <b>{{to}}</b></li><li> - Importo: <b>{{amount}} {{unit}}</b></li><li> - Commento: <i>{{comment}}</i></li><br/><li> - Resto : <b>{{restAmount}} {{unit}}</b> a <b>{{restTo}}</b></li></ul><br/><b>Sicuro di voler fare questo bonifico?</b>",
    "MEMBERSHIP_OUT": "Questa operazione è <b>irreversibile</b>.<br/></br/><b>Sei sicuro di voler cancellare la tua presenza nella RdF?</b>",
    "MEMBERSHIP_OUT_2": "Questa operazione è <b>irreversibile</b>!<br/><br/>Sei sicuro <b>di voler revocare la tua identità</b>?",
    "LOGIN_UNUSED_WALLET_TITLE": "Errore di battitura?",
    "LOGIN_UNUSED_WALLET": "Il conto sembra <b>inattivo</b>.<br/><br/>Probabilmente è un<b>errore di battitura</b> delle tue credenziali. Per favore riprova, verificando che la <b>chiave pubblica sia la tua<b/>.",
    "FIX_IDENTITY": "Lo pseudonimo <b>{{uid}}</b> verrà pubblicato nuovamente. Si sostituirà alla precedente pubblicazione che è scaduta.<br/></br/><b>Sei sicuro</b> di voler procedere?",
    "FIX_MEMBERSHIP": "La tua domanda di certificazione sarà inviata alla rete.<br/></br/><b>Sei sicuro?</b>",
    "MEMBERSHIP": "La tua domanda per diventare membro sta per essere inviata alla rete.<br/></br/><b>Sei sicuro</b> di voler continuare ?",
    "RENEW_MEMBERSHIP": "La tua adesione verrà rinnovata.<br/></br/><b>Sei sicuro?</b>",
    "REVOKE_IDENTITY": "Stai per <b>revocare definitivamente questa identità</b>.<br/><br/>La chiave pubblica e lo pseudonimo associato <b>non saranno mai più utilizzati</b> (da un conto membro).<br/></br/><b>Sei sicuro</b> di voler revocare questa identità?",
    "REVOKE_IDENTITY_2": "Questa operazione è <b>irreversibile</b>!<br/><br/>Sei sicuro di voler <b>revocare questa identità</b>?",
    "NOT_NEED_RENEW_MEMBERSHIP": "La tua adesione nella rete non deve ancora essere rinnovata (scadrà tra {{membershipExpiresIn|formatDuration}}).<br/></br/><b>Sei sicuro</b> di voler rinnovare la tua adesione?",
    "SAVE_BEFORE_LEAVE": "Vuoi <b>salvare le tue modifiche</b> prima di uscira dalla pagina?",
    "SAVE_BEFORE_LEAVE_TITLE": "Modifiche non salvate",
    "LOGOUT": "Sei sicuro di voler chiudere la sessione?",
    "USE_FALLBACK_NODE": "Nodo <b>{{old}}</b> indisponibile o indirizzo errato.<br/><br/>Vuoi utilizzare temporanemante il <b>{{new}}</b> nodo?",
    "USE_SYNC_FALLBACK_NODE": "Il nodo <b>{{old}}</b> sembra non essere sincronizzato.<br/><br/>Vuoi usare temporaneamente il nodo sincronizzato <b>{{new}}</b>?",
    "ISSUE_524_SEND_LOG": "La transazione è stata annullata a causa di un errore conosciuto (issue #524) ma non riprodotto. <br/><br/>Per aiutare gli sviluppatori a risolvere questo errore, acconsenti all'<b>invio dei tuoi logs</b> per messaggio?<br/><small>(Non viene inviato nessun dato confidenziale)</small>",
    "ENABLE_EXPERT_MODE_TO_CHANGE_NODE": "<b class=\"assertive\">Avviso:</b> Vuoi <b>cambiare manualmente</b> il nodo?<br/><br/>Se continui:<ul><li> - Verrà attivata la <b>modalità esperto</b>;</li><li> - Potrai tornare alla selezione automatica del nodo semplicemente <b>disattivando la modalità esperto</b>.</li></ul>"
  },
 "MODE": {
   "DEMO": {
     "BADGE": "Demo",
     "MODE": "Modalità dimostrativa",
     "FEATURE_NOT_AVAILABLE": "Funzionalità <b>non disponibile</b> su questo sito dimostrativo.",
     "MODE_HELP": "Il Cesium funziona in <b>modalità dimostrativa</b>: è disponibile la consultazione del conto, ma non è possibile eseguire alcuna operazione.",
     "INSTALL_HELP": "Per <b>motivi di sicurezza</b> ti consigliamo di <b>installare</b> la tua copia del software.<br/>Visita il sito <a href='https://cesium.app'>www.cesium.app</a> per assistenza."
   },
   "READONLY": {
     "BADGE": "Monit",
     "MODE": "Modalità di monitoraggio",
     "MODE_HELP": "Il Cesium funziona in <b>modalità monitoraggio</b>: sono disponibili solo le funzionalità di monitoraggio della valuta.",
     "INSTALL_HELP": "Se desidera <b>creare un account di portafoglio</b> per inviare o ricevere valuta, ti consigliamo di <b>installare</b> la tua copia del software.<br/>Visita il sito <a href='https://cesium.app'>www.cesium.app</a> per assistenza."
   }
 },
  "DOWNLOAD": {
    "POPUP_TITLE": "<b>File di revoca dell'identità/b>",
    "POPUP_REVOKE_MESSAGE": "Per migliorare la sicurezza del tuo conto, scarica <b>il documento di revoca del conto</b>. Ti consentirà di revocare il tuo conto (nel caso di violazione del conto, della tua identità, conto creato con errori, etc.).<br/><br/><b>Hai salvato questo documento in un luogo sicuro.</b>"
  },
  "HELP": {
    "TITLE": "Aiuto online",
    "JOIN": {
      "SECTION": "Entrare nella rete",
      "SALT": "Il tuo identificativo segreto è molto importante. È utilizzato per cifrare la tua password che permette poi di calcolare la tua <span class=\"text-italic\">chiave pubblica</span> (suo numero) e la chiave privata per consentire l'accesso.<br/><b>Ricordati bene di questo identificativo</b>, perche non ti potrà aiutare nessuno se lo perdi.<br/>Tra l'altro, non può essere cambiato senza dover creare un conto nuovo.<br/><br/>Raccomandiamo che sia abbastanza lungo (8 caratteri almeno) è il più originale possibile (buona entropia).",
      "PASSWORD": "La password è molto importante, è utilizzata per calcolare il tuo numero di conto (la tua chiave pubblica) e la chiave privata per consentire l'accesso.<br/><b>Ricordatela bene</b>, perché non ti potrà aiutare nessuno se la perdi.<br/>Tra l'altro, non puo essere cambiata senza dover creare un conto nuovo.<br/><br/>Una buona password (preferibilmente) è composta da almeno 8 caratteri, con almeno una maiuscola e un numero.",
      "PSEUDO": "Un pseudonimo è utilizzato quando ti iscrivi come <span class=\"text-italic\">membro</span>. E sempre associato ad un portafoglio (con la sua <span class=\"text-italic\">chiave pubblica</span>).<br/>È pubblicato sulla rete perche gli altri membri possano identificarla, certificarla o invarle moneta. <br/> Lo pseudonimo deve essere unico nella rete (tra quelli utilizzati adesso e in passato)."
    },
    "LOGIN": {
      "SECTION": "Accedi",
      "PUBKEY": "Chiave pubblica del conto",
      "PUBKEY_DEF": "La chiave pubblica del portachiavi è generata dalle credenziali, ma non corrispode ad un conto già utilizzato.<br/><b>Accertati che tua chiave pubblica corrisponda al tuo conto</b>. Nel caso contrario, sarai conesso/a ad un conto probabilmente mai usato, datto che il rischio di collisione con un conto esistente è molto ridotto.<br/><a href=\"https://en.wikipedia.org/wiki/Elliptic_curve_cryptography\" target=\"_ system\">Saperne di più sulla cryptografia </a> con chiave pubblica.",
      "METHOD": "Metodi di connessione",
      "METHOD_DEF": "Hai diverse opzioni per accedere ad un portafoglio:<br/> - Accedendo con <b>cifratura (leggera o sicura)</b> tua password sarà cifrata dal tuo identificativo segreto per scoraggiare tentativi di attacchi di 'brute force' (per esempio con passwords conosciute).<br/> - Accedendo con la <b>chiave pubblica</b> ti evita di dover digitare le tue credenziali che ti saranno chieste solo quando vorrai fare una operazione sul conto.<br/> - Accedendo <b>con un portachiavi</b> che leggerà le tue chiavi pubblica e privata da un file esterno, senza che tu li debba introdurre."
    },
    "GLOSSARY": {
      "SECTION": "Glossario",
      "PUBKEY_DEF": "Una chiave pubblica permette di identificare un portafoglio. Puo anche identificare un membro. Nel Cesium  è calcolata con la password e lo pseudonimo.",
      "MEMBER": "Membro",
      "MEMBER_DEF": "Un membro è una persona reale e viva, che desidera participare liberamente alla communità monetaria. Questo membro riceverà un Dividendo Universale, a secondo delle regole definite <span class=\"text-italic\">nei parametri della moneta</span>.",
      "CURRENCY_RULES": "Regole della moneta",
      "CURRENCY_RULES_DEF": "I parametri delle moneta sono state definite per sempre e per tutti. I parametri con i quali la moneta si comporta: il calcolo del Dividendo Universale, il numero di certificazioni necessarie per diventare membro, il numero massimo di certificazioni che un membro può inviare, etc.<br/><br/>I parametri non possono essere modificati perche c'è una<span class=\"text-italic\">Blockchain</span> che implementa ed esegue queste regole e verifica costantemente la loro applicazione. <a href=\"#/app/currency\">Vedere i parametri </a>.",
      "BLOCKCHAIN": "Blockchain",
      "BLOCKCHAIN_DEF": "La Blockchain è un sistema decentralizzato che, nel caso di Duniter, permette di rispettare e implementare <span class=\"text-italic\">le regole della moneta</span>.<br/><a href=\"http://en.duniter.org/presentation/\" target=\"_blank\">Saperne di più su Duniter</a> e il funzionamento della blockchain.",
      "UNIVERSAL_DIVIDEND_DEF": "Il Dividendo Universale (DU) è la quantità di moneta cocreata da ogni membro, seguendo le formule matematiche definite nelle <span class=\"text-italic\">regole della moneta</span>.<br/>All'inizio di ogni periodo, il conto di ogni membro riceve una quantità uguale della nuova moneta creata. <br/><br/>Il DU prevede una crescita costante per rimanere equo nei confronti dei membri (attuali e passati). Viene calcolato tenendo in conto la speranza di vita media, cosi come dimostrato nella Teoria Relativa della Moneta (TRM).<br/><a href=\"http://trm.creationmonetaire.info\" target=\"_system\">Peraperne di più sulla TRM</a> e la moneta libera.",
      "WOT": "Web of Trust (WoT)",
      "WOT_DEF": "La Rete di Fiducia è costituita da tutti i membri della moneta libera, ed i collegamenti delle certificazioni che li collegano.",
      "DISTANCE_RULE": "Regola della distanza",
      "DISTANCE_RULE_DEF": "La regola della distanza definisce la <b>distanza massima da trovare</b> tra un candidato membro e un numero minimo di mebri referenti. Questa distanza è calcolata usando i collegamenti delle certificazioni."
      },
    "TIP": {
      "MENU_BTN_CURRENCY": "Menu che <b>{{'MENU.CURRENCY'|translate}}</b> permette la scoperta dei <b>parametri della moneta</b> e la sua condizione presente.",
      "CURRENCY_WOT": "Il <b>numero di membri</b> mostra <b>le dimensioni della RdF e la sua evoluzione </b>.",
      "CURRENCY_MASS": "In evidenza qui è <b>l'importo totale</b> attualmente in circolazione e la sua <b> ripartizione media </b> pro capite. <br/><br/>Questa cifra permette di avere un'idea <b>del valore di qualsiasi importo</b>, in base a quello che <b>hanno gli altri</b> sul loro conto (in media).",
      "CURRENCY_UNIT_RELATIVE": "L'unità usata qui (&ldquo;<b>{{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub></b>&rdquo;) significa che gli importi in {{currency|capitalize}} sono stati divisi dal <b>Dividendo Universale</b> (DU).<br/><br/><small>Questa unità relativa <b>ha senso</b> perche è stabile in contrasto con la massa monetaria che cresce costantemente.</small>",
      "CURRENCY_CHANGE_UNIT": "Questa opzione <b>{{'COMMON.BTN_RELATIVE_UNIT'|translate}}</b> permette di <b>permutare unità</b> per vedere gli importi in <b>{{currency|capitalize}}</b>, non divisi dal Dividendo Universale (piuttosto che in &ldquo;<b>{{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub></b>&rdquo;).",
      "CURRENCY_CHANGE_UNIT_TO_RELATIVE": "Questa opzione <b>{{'COMMON.BTN_RELATIVE_UNIT'|translate}}</b> permette <b>di permutare unità</b> per vedere gli importi in &ldquo;<b>{{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub></b>&rdquo;, che è relativo al Dividendo Universale (l'importo co-prodotto da ogni membro).",
      "CURRENCY_RULES": "Le<b>regole</b> della moneta determinano il suo <b>esatto e previdibile</b> comportamento.<br/><br/> Considerate come il proprio DNA della moneta, queste regole rendono il codice monetario <b>trasparente e comprensibile</b>.",
      "MENU_BTN_NETWORK": "Menu che<b>{{'MENU.NETWORK'|translate}}</b> permette la scopertà dello <b>stato della rete<b>.",
      "NETWORK_BLOCKCHAIN": "Tutte le transazioni monetarie sono registrate in un <b>registro sicuro e a prova di manomissione</b>, spesso chiamato <b>blockchain</b>.",
      "NETWORK_PEERS": "I <b>nodi</b> mostrati qui corrispondono a <b>dei computers che aggiornano e monitorano</b> la blockchain.<br/><br/>Più nodi ci sono, più <b>decentralizzata</b> e più affidabile diventa la moneta.",
      "NETWORK_PEERS_BLOCK_NUMBER": "Questo <b>numero</b> (in verde) indica <b>l'ultimo blocco validato</b> dal nodo (ultima pagina scritta nel regitro).<br/><br/>Il verde indica che il blocco è stato validato anche dalla <b>maggioranza degli altri nodi</b>.",
      "NETWORK_PEERS_PARTICIPATE": "<b>Ogni membro</b>, che dispone di un computer connesso a Internet <b>puo partecipare, aggiungendosi come nodo installando il software Duniter</b> (free/libre). <a target=\"_new\" href=\"{{installDocUrl}}\" target=\"_system\">Leggi il manuale d'installazione &gt;&gt;</a>.",
      "MENU_BTN_ACCOUNT": "<b>{{'ACCOUNT.TITLE'|translate}}</b> permette l'accesso al saldo del conto e la cronologia delle transazioni.",
      "MENU_BTN_ACCOUNT_MEMBER": "Qui puoi consultare lo stato del tuo conto, la cronologia delle transazioni e le tue certificazioni.",
      "WALLET_CERTIFICATIONS": "Clicca qui per vedere i dettagli delle tue certificazioni (date o ricevute).",
      "WALLET_RECEIVED_CERTIFICATIONS": "Clicca qui per vedere i dettagli delle <b>certificazioni che hai ricevuto</b>.",
      "WALLET_GIVEN_CERTIFICATIONS": "Clicca qui per vedere i dettagli delle <b>certificazioni che hai dato</b>.",
      "WALLET_BALANCE": "Il <b>saldo</b> del tuo conto è visibile qui.",
      "WALLET_BALANCE_RELATIVE": "{{'HELP.TIP.WALLET_BALANCE'|translate}}<br/><br/>L'unità utilizzata (&ldquo;<b>{{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub></b>&rdquo;) significa che questo importo in {{currency|capitalize}} è stato diviso dal <b>Dividendo Universale</b> (DU) co-creato da ogni membro.<br/>Ad oggi, 1 DU equivale a {{currentUD}} {{currency|capitalize}}.",
      "WALLET_BALANCE_CHANGE_UNIT": "Puoi <b>cambiare l'unità</b> in cui sono mostrati gli importi in <b><i class=\"icon ion-android-settings\"></i>&nbsp;{{'MENU.SETTINGS'|translate}}</b>.<br/><br/>Per esempio, per mostrare gli importi <b>direttamente in {{currency|capitalize}}</b> piuttosto che in unità relativa.",
      "WALLET_PUBKEY": "Questa è la chiave pubblica del tuo conto. La puoi dare ad un terzo perché possa identificare tuo conto.",
      "WALLET_SEND": "Paghi in pochi clics.",
      "WALLET_SEND_NO_MONEY": "Paghi in pochi clics.<br/>(Il tuo saldo ancora non lo permette)",
      "WALLET_OPTIONS": "Questo bottone permette di fare <b>altre, meno frequenti azioni</b>.<br/><br/> Non dimenticarti di fare il tour guidato del Cesium quando hai un attimo!",
      "WALLET_RECEIVED_CERTS": "Questo mostra l'elenco delle persone che ti hanno fatto entrare nella RdF.",
      "WALLET_CERTIFY": "Questo bottone <b>{{'WOT.BTN_SELECT_AND_CERTIFY'|translate}}</b> permette di selezionare e certificare una identità.<br/><br/>Solo gli utenti <b>che sono già membri</b> possono certificare gli altri.",
      "WALLET_CERT_STOCK": "Il tuo stock di certificazioni da dare è limitato a <b>{{sigStock}} certificazioni</b>.<br/><br/>Questo stock si rifornisce con il tempo, man mano che le certificazioni inviate scadono.",
      "MENU_BTN_WALLETS": "Il menu <b>{{'MENU.WALLETS'|translate}}</b> ti permette aggiungere portafogli addizionali che amministri.",
      "MENU_BTN_TX": "<b>{{'MENU.TRANSACTIONS'|translate}}</b> permette l'accesso alla cronologia delle transazioni, e permette di fare nuovi bonifici.",
      "MENU_BTN_WOT": "Il menu<b>{{'MENU.WOT'|translate}}</b> permette di cercare <b>utenti</b> della moneta (membri o non).",
      "WOT_SEARCH_TEXT_XS": "Per fare una ricerca nella rubrica, digita <b>le prime lettere dello pseudonimo o della chiave pubblica di un utente</b>.<br/><br/>La ricerca inizierà automaticamente.",
      "WOT_SEARCH_TEXT": "Per cercare nella rubrica, digita <b>le prime lettere dello pseudonimo o della chiave pubblica di un utente</b>.<br/><br/>Dopodichè premi <b>Invio</b> per avviare la ricerca.",
      "WOT_SEARCH_RESULT": "Visualizza la scheda dettagliata di un utente con un semplice click sulla linea.",
      "WOT_VIEW_CERTIFICATIONS": "La linea <b>{{'ACCOUNT.CERTIFICATION_COUNT'|translate}}</b> mostra quanti membri hanno certificato questa identità.<br/><br/>Queste certificazioni dimostrano che il conto appartiene ad <b>una persona viva</b> e che questa persona non ha <b>nessun altro conto membro</b>.",
      "WOT_VIEW_CERTIFICATIONS_COUNT": "Ci vogliono almeno <b>{{sigQty}} certificazioni</b> per diventare membro e cocreare il <b>Dividendo Universale</b>.",
      "WOT_VIEW_CERTIFICATIONS_CLICK": "Clicca qui per aprire <b>una lista di tutte le certificazioni</b> ricevute e date da questa identità.",
      "WOT_VIEW_CERTIFY": "Il bottone <b>{{'WOT.BTN_CERTIFY'|translate}}</b> permette di aggiungere la tua certificazione a questa identità.",
      "CERTIFY_RULES": "<b>Attenzione:</b> Certifica <b>solo persone reali e vive</b> che non hanno nessun altro conto membro.<br/><br/>L'affidabilità della moneta dipende della vigilanza di ciascuno.",
      "MENU_BTN_SETTINGS": "Le <b>{{'MENU.SETTINGS'|translate}}</b> ti permettono di configurare il Cesium.<br/><br/>Per esempio, puoi <b>cambiare l'unità</b> in cui visualizzi la moneta.",
      "HEADER_BAR_BTN_PROFILE": "Clicca qui per entrare nel <b>tuo profilo utente</b>",
      "SETTINGS_CHANGE_UNIT": "Puoi cambiare <b>l'unità</b> della moneta cliccando qui.<br/><br/>- Disabilita questa opzione per vedere gli importi in {{currency|capitalize}}.<br/>- Abilita l'opzione per importi relativi in {{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub> (<b>divisi</b> dal attuale Dividendo Universale).",
      "END_LOGIN": "Il tour guidato <b>è finito</b>.<br/><br/>Benvenuto nel <b>economia libera</b>!",
      "END_NOT_LOGIN": "Il tour guidato <b>è finito</b>.<br/><br/>Se desideri entrare nella Rete di Fiducia {{currency|capitalize}}, basta cliccare <b>{{'LOGIN.CREATE_ACCOUNT'|translate}}</b> qui sotto.",
      "END_READONLY": "Il tour guidato <b>è finito</b>.<br/><br/>{{'MODE.READONLY.INSTALL_HELP'|translate}}."
    }
  },
 "API" :{
   "COMMON": {
     "LINK_DOC": "documentazione API",
     "LINK_DOC_HELP": "Documentazione dello sviluppatore",
     "LINK_STANDARD_APP": "versione classica",
     "LINK_STANDARD_APP_HELP": "Apri la versione classica di {{'COMMON.APP_NAME'|translate}}",
     "CONNECTION_ERROR": "Nodo <b>{{server}}</b>irraggiungibile o indirizzo invalido.<br/><br/>Controlla la tua connessione a Internet, o contatta con l'amministratore della pàgina web."
   },
   "HOME": {
     "TITLE": "Documentazione API {{'COMMON.APP_NAME'|translate}}",
     "MESSAGE": "Benvenuto alla <b>documentazione dell'API</b> {{'COMMON.APP_NAME'|translate}}.<br/>Connettiti alla pagina web <a href=\"http://duniter.org\" target=\"_system\">Duniter</a> molto facilmente!",
     "MESSAGE_SHORT": "Connettiti alla pagina web <a href=\"http://duniter.org\" target=\"_system\">Duniter</a> molto facilmente!",
     "DOC_HEADER": "Servizi disponibili:"
   },
   "TRANSFER": {
     "TITLE": "{{'COMMON.APP_NAME'|translate}} - Pagamento online",
     "TITLE_SHORT": "Pagamento online",
     "SUMMARY": "Riepilogo dell'ordine:",
     "AMOUNT": "Importo:",
     "AMOUNTS_HELP": "Per favore selezioni l'importo:",
     "NAME": "Nome :",
     "PUBKEY": "Chiave pubblica del destinatario:",
     "COMMENT": "Riferimento dell'ordine:",
     "NODE": "Indirizzo del nodo",
     "DEMO": {
       "SALT": "demo",
       "PASSWORD": "demo",
       "PUBKEY": "3G28bL6deXQBYpPBpLFuECo46d3kfYMJwst7uhdVBnD1",
       "HELP": "<b>Modo dimostrativo</b>: Nessun pagamento sarà realmente inviato con questa simulazione.<br/>Per favore usa le credenziali: <b>{{'API.TRANSFER.DEMO.SALT'|translate}} / {{'API.TRANSFER.DEMO.PASSWORD'|translate}}</b>",
       "BAD_CREDENTIALS": "Credenziali non valide.<br/>In modalità demo, le credenziali sono: {{'API.TRANSFER.DEMO.SALT'|translate}} / {{'API.TRANSFER.DEMO.PASSWORD'|translate}}"
     },
     "INFO": {
       "SUCCESS_REDIRECTING_WITH_NAME": "Pagamento inviato.<br/>Ridirigendo a <b>{{name}}</b>...",
       "SUCCESS_REDIRECTING": "Pagamento inviato.<br/>Ridirigendo al sito del venditore...",
       "CANCEL_REDIRECTING_WITH_NAME": "Pagamento annullato.<br/>Ridirigendo a<b>{{name}}</b>...",
       "CANCEL_REDIRECTING": "Pagamento annullato.<br/>Ridirigendo al sito del venditore..."
     },
     "ERROR": {
       "TRANSFER_FAILED": "Mancato pagamento"
     }
   },
   "DOC": {
     "DESCRIPTION_DIVIDER": "Descrizione",
     "URL_DIVIDER": "Indirizzo chiamata",
     "PARAMETERS_DIVIDER": "Impostazioni",
     "AVAILABLE_PARAMETERS": "Ecco l'elenco dei parametri disponibili :",
     "DEMO_DIVIDER": "Provare",
     "DEMO_HELP": "Per provare questo servizio, clicca sul bottone qui a fianco. Il risultato apparirà qui sotto .",
     "DEMO_RESULT": "Risultato della chiamata:",
     "DEMO_RESULT_PEER": "Indirizzo del nodo usato:",
     "DEMO_SUCCEED": "<i class=\"icon ion-checkmark\"></i> Successo!",
     "DEMO_CANCELLED": "<i class=\"icon ion-close\"></i> Annulato dall'utente",
     "INTEGRATE_DIVIDER": "Integrare",
     "INTEGRATE_CODE": "Codice:",
     "INTEGRATE_RESULT": "Previsualizzare il risultato:",
     "INTEGRATE_PARAMETERS": "Parametri",
     "TRANSFER": {
       "TITLE": "Pagamenti",
       "DESCRIPTION": "Da un sito (per es.: un sito di e-commerce) si può delegare il pagamento in moneta libera a Cesium API. Per invocare l'API, basta innescare l'apertura di una pagina con questo indirizzo:",
       "PARAM_PUBKEY": "Chiave pubblica del destinatario",
       "PARAM_PUBKEY_HELP": "Chiave pubblica del destinatario (obbligatoria)",
       "PARAM_AMOUNT": "Importo",
       "PARAM_AMOUNT_HELP": "Importo della transazione (obbligatorio)",
       "PARAM_COMMENT": "Riferimento (o commento)",
       "PARAM_COMMENT_HELP": "Riferimento o commento. Ti può aiutare per esempio a trovare tuo pagamento nella blockchain.",
       "PARAM_NAME": "Nome (del destinatario o del sito web)",
       "PARAM_NAME_HELP": "Nome del sito web o del destinatario chiamando l'API. Può essere un nome leggibile (\"Mio sito\"), oppure l'indirizzo http del sito (\"MioSito.com\").",
       "PARAM_REDIRECT_URL": "Indirizzo web di ridirezione",
       "PARAM_REDIRECT_URL_HELP": "Indirizzo web (URL) di ridirezione, chiamato dopo aver inviato il pagamento. Può includere le seguenti stringe, che saranno sostituite con i valori della transazione : \"{tx}\", \"{hash}\", \"{comment}\", \"{amount}\" e {pubkey}.",
       "PARAM_CANCEL_URL": "Indirizzo web della cancellazione",
       "PARAM_CANCEL_URL_HELP": "Indirizzo web (URL) in caso dell'annullamento del pagamento dall'utente. Può includere le seguenti stringe, che saranno sostituite dinamicamente : \"{comment}\", \"{amount}\" e {pubkey}.",
       "PARAM_PREFERRED_NODE": "Nodo Duniter preferito",
       "PARAM_PREFERRED_NODE_HELP": "Indirizzo del nodo (URL) da usare preferibilmente (\"g1.domain.com:443\" or \"https://g1.domain.com\")",
       "EXAMPLES_HELP": "Alcuni esempi di integrazione :",
       "EXAMPLE_BUTTON": "Bottone HTML",
       "EXAMPLE_BUTTON_DEFAULT_TEXT": "Pagare in {{currency|currencySymbol}}",
       "EXAMPLE_BUTTON_DEFAULT_STYLE": "Stile personalizzato",
       "EXAMPLE_BUTTON_TEXT_HELP": "Testo del bottone",
       "EXAMPLE_BUTTON_BG_COLOR": "Colore del fondo",
       "EXAMPLE_BUTTON_BG_COLOR_HELP": "Per esempio: #fbc14c, black, lightgrey, rgb(180,180,180)",
       "EXAMPLE_BUTTON_FONT_COLOR": "Colore del testo",
       "EXAMPLE_BUTTON_FONT_COLOR_HELP": "Esempio: black, orange, rgb(180,180,180)",
       "EXAMPLE_BUTTON_TEXT_ICON": "Icona",
       "EXAMPLE_BUTTON_TEXT_WIDTH": "Larghezza",
       "EXAMPLE_BUTTON_TEXT_WIDTH_HELP": "Esempio: 200px, 50%",
       "EXAMPLE_BUTTON_ICON_NONE": "Nessuna",
       "EXAMPLE_BUTTON_ICON_DUNITER": "Logo Duniter",
       "EXAMPLE_BUTTON_ICON_CESIUM": "Logo Cesium",
       "EXAMPLE_BUTTON_ICON_G1_COLOR": "Logo Ğ1",
       "EXAMPLE_BUTTON_ICON_G1_BLACK": "Logo Ğ1 (nero)"
     }
   }
 }
}
);

$translateProvider.translations("nl-NL", {
  "COMMON": {
    "APP_NAME": "Cesium",
    "APP_VERSION": "v{{version}}",
    "APP_BUILD": "build {{build}}",
    "PUBKEY": "Publieke sleutel",
    "MEMBER": "Lid",
    "BLOCK": "Blok",
    "BTN_OK": "OK",
    "BTN_YES": "Ja",
    "BTN_NO": "Nee",
    "BTN_SEND": "Verzenden",
    "BTN_SEND_MONEY": "Verstuur geld",
    "BTN_SEND_MONEY_SHORT": "Versturen",
    "BTN_SAVE": "Opslaan",
    "BTN_YES_SAVE": "Ja, opslaan",
    "BTN_YES_CONTINUE": "Ja, doorgaan",
    "BTN_SHOW": "Tonen",
    "BTN_SHOW_PUBKEY": "Toon sleutel",
    "BTN_RELATIVE_UNIT": "Gebruik relatieve eenheid",
    "BTN_BACK": "Terug",
    "BTN_NEXT": "Volgende",
    "BTN_IMPORT": "Importeren",
    "BTN_CANCEL": "Annuleer",
    "BTN_CLOSE": "Sluit",
    "BTN_LATER": "Later",
    "BTN_LOGIN": "Aanmelden",
    "BTN_LOGOUT": "Uitloggen",
    "BTN_ADD_ACCOUNT": "Nieuwe Rekening",
    "BTN_SHARE": "Delen",
    "BTN_EDIT": "Bewerken",
    "BTN_DELETE": "Wissen",
    "BTN_ADD": "Toevoegen",
    "BTN_SEARCH": "Zoeken",
    "BTN_REFRESH": "Verwezenlijken",
    "BTN_RETRY": "Opnieuw proberen",
    "BTN_START": "Beginnen",
    "BTN_CONTINUE": "Doorgaan",
    "BTN_CREATE": "Creëren",
    "BTN_UNDERSTOOD": "Ik heb het begrepen",
    "BTN_OPTIONS": "Opties",
    "BTN_HELP_TOUR": "Rondleiding",
    "BTN_HELP_TOUR_SCREEN": "Ontdek dit scherm",
    "BTN_DOWNLOAD": "Downloaden",
    "BTN_DOWNLOAD_ACCOUNT_STATEMENT": "Downloaden het rekeningoverzicht",
    "BTN_MODIFY": "Bewerken",
    "CHOOSE_FILE": "Sleep uw bestand hier <br/>of klik om het te selecteren",
    "DAYS": "dagen",
    "NO_ACCOUNT_QUESTION": "Nog geen lid? Registreer nu!",
    "SEARCH_NO_RESULT": "Geen resultaten",
    "LOADING": "Even geduld...",
    "LOADING_WAIT": "Even geduld...<br/><small>(Cesium vraagt de Duniter-node op)</small>",
    "SEARCHING": "Zoeken...",
    "FROM": "Van",
    "TO": "Aan",
    "COPY": "Kopieren",
    "LANGUAGE": "Taal",
    "UNIVERSAL_DIVIDEND": "Universeel dividend",
    "UD": "UD",
    "DATE_PATTERN": "DD-MM-YYYY HH:mm",
    "DATE_FILE_PATTERN": "YYYY-MM-DD",
    "DATE_SHORT_PATTERN": "DD-MM-YY",
    "DATE_MONTH_YEAR_PATTERN": "MM-YYYY",
    "EMPTY_PARENTHESIS": "(leeg)",
    "UID": "Pseudoniem",
    "ENABLE": "Geactiveerd",
    "DISABLE": "Gedeactiveerd",
    "RESULTS_LIST": "Resultaten:",
    "RESULTS_COUNT": "{{count}} uitslagen",
    "EXECUTION_TIME": "uitgevoerd in {{duration|formatDurationMs}}",
    "SHOW_VALUES": "Toon waarden openlijk?",
    "POPOVER_ACTIONS_TITLE": "Opties",
    "POPOVER_FILTER_TITLE": "Filters",
    "SHOW_MORE": "Toon meer",
    "SHOW_MORE_COUNT": "(huidig limiet op {{limit}})",
    "POPOVER_SHARE": {
      "TITLE": "Delen",
      "SHARE_ON_TWITTER": "Deel op Twitter",
      "SHARE_ON_FACEBOOK": "Deel op Facebook",
      "SHARE_ON_DIASPORA": "Deel op Diaspora*",
      "SHARE_ON_GOOGLEPLUS": "Deel op Google+"
    }
  },
  "SYSTEM": {
    "PICTURE_CHOOSE_TYPE": "Selecteer bron:",
    "BTN_PICTURE_GALLERY": "Gallerij",
    "BTN_PICTURE_CAMERA": "<b>Camera</b>"
  },
  "MENU": {
    "HOME": "Welkom",
    "WOT": "Register",
    "CURRENCY": "Valuta",
    "ACCOUNT": "Mijn rekening",
    "WALLETS": "Mijn portefeuilles",
    "SETTINGS": "Instellingen",
    "NETWORK": "Netwerk",
    "TRANSACTIONS": "Mijn transacties"
  },
  "ABOUT": {
    "TITLE": "Over",
    "LICENSE": "<b>Vrije</b> software (GNU AGPLv3 licentie).",
    "CODE": "Broncode:",
    "DEVELOPERS": "Ontwikkelaars:",
    "FORUM": "Forum:",
    "DEV_WARNING": "Waarschuwing",
    "DEV_WARNING_MESSAGE": "Deze applicatie is nog in actieve onwikkeling.<br/>Meld ons elk pobleem!",
    "DEV_WARNING_MESSAGE_SHORT": "Deze App is nog instabiel (in ontwikkeling).",
    "REPORT_ISSUE": "Meld een probleem"
  },
  "HOME": {
    "TITLE": "Cesium",
    "WELCOME": "Welkom bij de Cesium Applicatie!",
    "MESSAGE": "Bekijk je {{currency|abbreviate}} portefeilles in real time.",
    "BTN_REGISTRY": "Register",
    "BTN_CURRENCY": "Verken valuta",
    "BTN_ABOUT": "over",
    "BTN_HELP": "Help",
    "BTN_NETWORK": "Netwerkstatus",
    "FREE_SOFTWARE": "Vrije software",
    "FORK_ME": "Kloon mij!",
    "SHOW_LICENSE": "Bekijk de applicatielicentie",
    "REPORT_ISSUE": "Meld een probleem",
    "NOT_YOUR_ACCOUNT_QUESTION" : "Is rekening <b><i class=\"ion-key\"></i> {{pubkey|formatPubkey}}</b> niet van jou?",
    "BTN_CHANGE_ACCOUNT": "Dze rekening ontkoppelen",
    "PEER_CONNECTION_ERROR": "Node <b>{{server}}</b> is onbereikbaar of het adres is ongeldig.<br/><br/>Controleer uw internetverbinding, of verander de node <a class=\"positive\" ng-click=\"doQuickFix('settings')\">in de instellingen</a>.",
    "NETWORK_CONNECTION_ERROR": "Netwerk is niet bereikbaar.<br/><br/>Controleer uw internetverbinding, of selecteer een node handmatig <a class=\"positive\" ng-click=\"doQuickFix('settings')\">in de instellingen</a>.",
    "SHOW_ALL_FEED": "Alles weergeven",
    "READ_MORE": "Lees meer",
    "FEED_SOURCE": "Bron"
  },
  "SETTINGS": {
    "TITLE": "Instellingen",
    "DISPLAY_DIVIDER": "Weergave",
    "STORAGE_DIVIDER": "Opslag",
    "NETWORK_SETTINGS": "Netwerk",
    "PEER": "Duniter knooppunt",
    "PEER_CHANGED_TEMPORARY": "Adres tijdelijk worden gebruikt",
    "PEER_SELECTED_AUTOMATICALLY": "Node automatisch geselecteerd bij opstarten",
    "NETWORK_ANALYZE_TIMEOUT": "Maximale wachttijd (time-out)",
    "NETWORK_ANALYZE_TIMEOUT_HELP": "Maximale wachttijd voor netwerkanalyse",
    "NETWORK_ANALYZE_TIMEOUT_AUTO": "Auto",
    "PERSIST_CACHE": "Bewaar navigatiegegevens (experimenteel)",
    "PERSIST_CACHE_HELP": "Maakt snellere navigatie mogelijk door lokaal ontvangen gegevens te bewaren om ze van sessie tot sessie te gebruiken.",
    "USE_LOCAL_STORAGE": "Lokale opslag inschakelen",
    "USE_LOCAL_STORAGE_HELP": "Laat je instellingen opslaan",
    "WALLETS_SETTINGS": "Mijn portefeuilles",
    "USE_WALLETS_ENCRYPTION": "Lijst beveiligen?",
    "USE_WALLETS_ENCRYPTION_HELP": "Hiermee kun je de lijst van je portefeuilles beveiligen (door encryptie) en wordt er authenticatie vereist om er toegang toe te krijgen.",
    "ENABLE_HELPTIP": "Contextgebonden hulp inschakelen",
    "DISABLE_HELPTIP": "Contextuele hulpballonnen uitschakelen",
    "ENABLE_UI_EFFECTS": "Schakel visuele effecten",
    "ENABLE_UI_EFFECTS_HELP": "Overgang tussen pagina's, animaties van lijsten, etc.",
    "HISTORY_SETTINGS": "Mijn rekening",
    "DISPLAY_UD_HISTORY": "Toon geproduceerde dividenden?",
    "TX_HISTORY_AUTO_REFRESH": "Automatisch vernieuwen",
    "TX_HISTORY_AUTO_REFRESH_HELP": "Vernieuwt het saldo en de transacties automatisch bij elk nieuw blok in het netwerk.",
    "AUTHENTICATION_SETTINGS": "Authentificatie",
    "KEEP_AUTH": "Automatische afmelding",
    "KEEP_AUTH_SHORT": "Afmelding",
    "KEEP_AUTH_HELP": "Bepaalt wanneer de authenticatie uit het geheugen wordt gewist.",
    "KEEP_AUTH_OPTION": {
      "NEVER": "Na elke transactie",
      "SECONDS": "Na {{value}}s van inactiviteit",
      "MINUTE": "Na {{value}} min van inactiviteit",
      "MINUTES": "Na {{value}} min van inactiviteit",
      "HOUR": "Na {{value}} uur van inactiviteit",
      "ALWAYS": "Aan het einde van de sessie"
    },
    "KEYRING_FILE": "Sleutelhangerbestand",
    "KEYRING_FILE_HELP": "Hiermee kunt u zich bij elk opstarten <b>automatisch aanmelden</b> en zelfs <b>authenticeren</b> (alleen als 'Authenticatieverval' is ingesteld op 'aan het einde van de sessie').",
    "REMEMBER_ME": "Onthoud mij",
    "REMEMBER_ME_HELP": "Hiermee kunt u blijven altijd aangesloten (niet aanbevolen).",
    "PLUGINS_SETTINGS": "Uitbreidingen",
    "BTN_RESET": "Herstel standaardinstellingen",
    "EXPERT_MODE": "Geavanceerde modus inschakelen",
    "EXPERT_MODE_HELP": "Toon meer details",
    "BLOCK_VALIDITY_WINDOW": "Onzekerheidsperiode van blokken",
    "BLOCK_VALIDITY_WINDOW_SHORT": "Onzekerheidsperiode",
    "BLOCK_VALIDITY_WINDOW_HELP": "Tijd voordat informatie als gevalideerd wordt beschouwd",
    "BLOCK_VALIDITY_OPTION": {
      "NONE": "Geen vertraging",
      "N": "{{time | formatDuration}} ({{count}} blokken)"
    },
    "POPUP_PEER": {
      "TITLE" : "Duniter Knooppunt",
      "HOST" : "Adres",
      "HOST_HELP": "Aadres: server:poort",
      "USE_SSL" : "Secure?",
      "USE_SSL_HELP" : "SSL-encryptie",
      "BTN_SHOW_LIST" : "Lijst van knooppunten"
    }
  },
  "BLOCKCHAIN": {
    "HASH": "Hachee : {{hash}}",
    "VIEW": {
      "HEADER_TITLE": "Blok #{{number}}-{{hash|formatHash}}",
      "TITLE_CURRENT": "Huidige blok",
      "TITLE": "Blok #{{number|formatInteger}}",
      "COMPUTED_BY": "Berekend door het knooppunt",
      "SHOW_RAW": "Bekijk RAW-bestand",
      "TECHNICAL_DIVIDER": "Technische informatie",
      "VERSION": "Format versie",
      "HASH": "Hash berekend",
      "UNIVERSAL_DIVIDEND_HELP": "Munt gecoproduceerd door elk van de {{membersCount}} ledental",
      "EMPTY": "Er zijn geen gegevens in dit blok",
      "POW_MIN": "Mminimum moeilijkheid",
      "POW_MIN_HELP": "Moeilijkheid opgelegd hash te berekenen",
      "DATA_DIVIDER": "Gegevens",
      "IDENTITIES_COUNT": "Nieuwe identiteiten",
      "JOINERS_COUNT": "Nieuwe leden",
      "ACTIVES_COUNT": "Verlengingen",
      "ACTIVES_COUNT_HELP": "Leden die hun lidmaatschap te vernieuwen",
      "LEAVERS_COUNT": "Verlaters",
      "LEAVERS_COUNT_HELP": "Leden die niet langer wenst certificering",
      "EXCLUDED_COUNT": "Uitgesloten leden",
      "EXCLUDED_COUNT_HELP": "Oud-leden uitgesloten door niet-verlenging of gebrek aan certificeringen",
      "REVOKED_COUNT": "Identiteiten ingetrokken",
      "REVOKED_COUNT_HELP": "Deze rekeningen zullen niet langer leden",
      "TX_COUNT": "Transacties",
      "CERT_COUNT": "Certificeringen",
      "TX_TO_HIMSELF": "Ruil deal",
      "TX_OUTPUT_UNLOCK_CONDITIONS": "Omstandigheden van de introductie",
      "TX_OUTPUT_OPERATOR": {
        "AND": "en",
        "OR": "of"
      },
      "TX_OUTPUT_FUNCTION": {
        "SIG": "<b>handtekening</b> ",
        "XHX": "<b>Wachtwoord</b>, wiens SHA256 =",
        "CSV": "Geblokkeerd",
        "CLTV": "Opgesloten"
      }
    },
    "LOOKUP": {
      "TITLE": "Blokken",
      "NO_BLOCK": "Geen blok",
      "LAST_BLOCKS": "Recente blokken :",
      "BTN_COMPACT": "Compact"
    }
  },
  "CURRENCY": {
    "SELECT": {
      "TITLE": "Valuta's",
      "CURRENCIES": "Bekende valuta's",
      "MEMBERS_COUNT": "{{membersCount}} leden"
    },
    "VIEW": {
      "TITLE": "Valuta",
      "TAB_CURRENCY": "Valuta",
      "TAB_WOT": "Gemeenschap",
      "TAB_NETWORK": "Netwerk",
      "CURRENCY_NAME": "Valuta naam",
      "MEMBERS": "Ledental",
      "MEMBERS_VARIATION": "Variatie since {{duration | formatDuration}}",
      "MONEY_DIVIDER": "Geld",
      "MASS": "Monetaire massa",
      "SHARE": "Aandeel per lid",
      "UD": "Universeel Dividend",
      "C_ACTUAL": "Huidige toename",
      "MEDIAN_TIME": "Blockchain tijd",
      "POW_MIN": "Algemene moeilijkheidsgraad",
      "MONEY_RULES_DIVIDER": "Monetaire regels",
      "C_RULE": "Toename",
      "UD_RULE": "Universeel dividend (formule)",
      "SIG_QTY_RULE": "Benodigd aantal certificaties om lid te worden",
      "SIG_STOCK": "Maximum aantal certificaties te versturen per lid",
      "SIG_PERIOD": "Minimum vertraging tussen 2 certificaties verzonden door één en dezelfde persoon.",
      "SIG_WINDOW": "Maximum vertraging voor een certificatie in behandeling wordt genomen",
      "STEP_MAX": "Maximum afstand tussen elk WoT lid en een nieuw lid.",
      "WOT_RULES_DIVIDER": "Lidmaatschapseisen",
      "XPERCENT":"Minimum percentage schildwachten te bereiken om de afstandsregel te respecteren"
    }
  },
  "NETWORK": {
    "VIEW": {
      "MEDIAN_TIME": "Blockchain tijd",
      "LOADING_PEERS": "Even geduld...",
      "NODE_ADDRESS": "Adres :",
      "ENDPOINTS": {
        "BMAS": "Endpoint (SSL)",
        "BMATOR": "Endpoint TOR",
        "WS2P": "Endpoint WS2P",
        "GVA": "Endpoint GVA",
        "ES_USER_API": "Knoop Cesium+"
      }
    },
    "INFO": {
      "CONNECTING_TO_NETWORK": "Verbinden met het netwerk...",
      "ANALYZING_NETWORK": "Analyseren van het {{currency|abbreviate}} netwerk...",
      "ONLY_SSL_PEERS": "Les noeuds non SSL ont un affichage dégradé, car Cesium fonctionne en mode HTTPS."
    }
  },
  "PEER": {
    "PEERS": "Knopen",
    "SIGNED_ON_BLOCK": "Getekend op blok",
    "MIRROR": "spiegel",
    "CURRENT_BLOCK": "Blok #",
    "VIEW": {
      "TITLE": "Knoop",
      "OWNER": "Maakt deel uit van",
      "SHOW_RAW_PEERING": "Zie netwerkdocument",
      "KNOWN_PEERS": "Bekende knopen :",
      "GENERAL_DIVIDER": "Algemene informatie",
      "ERROR": {
        "LOADING_TOR_NODE_ERROR": "Kan knooppunt niet worden opgehaald. De wachttijd wordt overschreden.",
        "LOADING_NODE_ERROR": "Kan knooppunt niet worden opgehaald"
      }
    }
  },
  "WOT": {
    "SEARCH_HELP": "Zoeken (lid of publieke sleutel)",
    "SEARCH_INIT_PHASE_WARNING": "Tijdens de pre-registratiefase, het zoeken van lopende registraties <b>kan lang</b> zijn. Dank je wel geduld...",
    "REGISTERED_SINCE": "Registratie",
    "REGISTERED_SINCE_BLOCK": "Geregistreerd op blok #",
    "NO_CERTIFICATION": "Geen gevalideerde certificaties",
    "NO_GIVEN_CERTIFICATION": "Geen uitgegeven certificaties",
    "NOT_MEMBER_PARENTHESIS": "(niet-lid)",
    "IDENTITY_REVOKED_PARENTHESIS": "(ingetrokken identiteit)",
    "MEMBER_PENDING_REVOCATION_PARENTHESIS": "(intrekking in behandeling)",
    "EXPIRE_IN": "Verloopt",
    "NOT_WRITTEN_EXPIRE_IN": "Uiterlijke<br/>behandeling",
    "EXPIRED": "Verlopen",
    "PSEUDO": "Pseudoniem",
    "SIGNED_ON_BLOCK": "Uitgegeven op block #{{block}}",
    "WRITTEN_ON_BLOCK": "Geschreven op block #{{block}}",
    "GENERAL_DIVIDER": "Algemene informatie",
    "NOT_MEMBER_ACCOUNT": "Simpele rekening (geen lid)",
    "NOT_MEMBER_ACCOUNT_HELP": "Dit is een eenvoudige rekening, zonder dat er een aanvraag voor lidmaatschap in de wacht wordt gezet.",
    "TECHNICAL_DIVIDER": "Technische informatie",
    "BTN_CERTIFY": "Certificeren",
    "BTN_YES_CERTIFY": "Ja, Certificeren",
    "BTN_SELECT_AND_CERTIFY": "Nieuwe certificatie",
    "ACCOUNT_OPERATIONS": "Operaties op de rekening",
    "VIEW": {
      "POPOVER_SHARE_TITLE": "Identiteit {{title}}"
    },
    "LOOKUP": {
      "TITLE": "Register",
      "NEWCOMERS": "Nieuwe leden:",
      "PENDING": "Aspirant leden:",
      "REGISTERED": "Geregistreerd {{sigDate | formatFromNow}}",
      "MEMBER_FROM": "Lid sinds {{memberDate|medianFromNowShort}}",
      "BTN_NEWCOMERS": "Nieuwste leden",
      "BTN_PENDING": "Registraties in afwachting",
      "SHOW_MORE": "Toon meer",
      "SHOW_MORE_COUNT": "(huidige limiet op {{limit}})",
      "NO_PENDING": "Er zijn geen registraties in afwachting gevonden.",
      "NO_NEWCOMERS": "Er zijn geen nieuwe leden gevonden."
    },
    "MODAL": {
      "TITLE": "Zoeken"
    },
    "CERTIFICATIONS": {
      "TITLE": "{{uid}} - Certificaties",
      "SUMMARY": "Ontvangen certificaties",
      "LIST": "Details van ontvangen certificaties",
      "PENDING_LIST": "Certificaties in afwachting",
      "RECEIVED": "Ontvangen certificaties",
      "RECEIVED_BY": "Certificaties ontvanged door {{uid}}",
      "ERROR": "Ontvangen vertificaties met fout",
      "SENTRY_MEMBER": "Referent lid"
    },
    "GIVEN_CERTIFICATIONS": {
      "TITLE": "{{uid}} - Verzonden certificaties",
      "SUMMARY": "Verzonden certificaties",
      "LIST": "Details van verzonden certificaties",
      "PENDING_LIST": "Certificaties in afwachting",
      "SENT": "Verzonden certificaties",
      "SENT_BY": "Certificaties verzonden door {{uid}}",
      "ERROR": "Verzonden certificaties met fout"
    }
  },
  "LOGIN": {
    "TITLE": "<i class=\"icon ion-locked\"></i> Inloggen",
    "SCRYPT_FORM_HELP": "Voer uw inloggegevens in.<br>Controleer of de openbare sleutel die van uw account is.",
    "PUBKEY_FORM_HELP": "Voer een openbare accountsleutel in:",
    "FILE_FORM_HELP": "Kies het sleutelbestand dat u wilt gebruiken:",
    "SCAN_FORM_HELP": "Scan de QR-code van een portemonnee.",
    "SALT": "Geheime identificatie",
    "SALT_HELP": "Geheime identificatie",
    "SHOW_SALT": "Geheime identificatie weergeven?",
    "PASSWORD": "Wachtwoord",
    "PASSWORD_HELP": "Wachtwoord",
    "PUBKEY_HELP": "Openbare sleutel of bijnaam",
    "NO_ACCOUNT_QUESTION": "Heeft u nog geen rekening?",
    "HAVE_ACCOUNT_QUESTION": "Heeft u al een rekening?",
    "CREATE_ACCOUNT": "Maak een rekening aan...",
    "CREATE_FREE_ACCOUNT": "Maak gratis een account aan",
    "FORGOTTEN_ID": "Wachtwoord vergeten?",
    "ASSOCIATED_PUBKEY": "Openbare sleutel van de sleutelring:",
    "BTN_METHODS": "Andere methoden",
    "BTN_METHODS_DOTS": "Verander van methode...",
    "METHOD_POPOVER_TITLE": "Methoden",
    "MEMORIZE_AUTH_FILE": "Onthoud deze sleutelring voor de duur van de browsersessie",
    "SCRYPT_PARAMETERS": "Parameters (Scrypt):",
    "AUTO_LOGOUT": {
      "TITLE": "Informatie",
      "MESSAGE": "<i class=\"ion-android-time\"></i> U bent <b>automatisch uitgelogd</b> na een periode van inactiviteit.",
      "BTN_RELOGIN": "Opnieuw inloggen",
      "IDLE_WARNING": "U wordt uitgelogd... {{countdown}}"
    },
    "METHOD": {
      "SCRYPT_DEFAULT": "Geheime gebruikersnaam en wachtwoord",
      "SCRYPT_ADVANCED": "Geavanceerde zoutvorming",
      "FILE": "Sleutelbestand",
      "PUBKEY": "Openbare sleutel of bijnaam",
      "SCAN": "Scan een QR-code"
    },
    "SCRYPT": {
      "SIMPLE": "Lichte zoutvorming",
      "DEFAULT": "Standaard zoutvorming",
      "SECURE": "Veilige zoutvorming",
      "HARDEST": "Veiligste zoutvorming",
      "EXTREME": "Extreme zoutvorming",
      "USER": "Aangepaste zoutvorming",
      "N": "N (Loop):",
      "r": "r (RAM):",
      "p": "p (CPU):"
    },
    "FILE": {
      "HELP": "Verwacht bestandsformaat: <b>.yml</b> of <b>.dunikey</b> (type PubSec, WIF of EWIF)."
    },
    "AUTH": {
      "TITLE": "<i class=\"icon ion-locked\"></i> Authenticatie",
      "BTN_AUTH": "Authenticeren",
      "GENERAL_HELP": "Gelieve u te authenticeren:",
      "EXPECTED_UID_HELP": "Gelieve in te loggen op het account <i class=\"ion-person\"></i> {{uid}}:",
      "EXPECTED_PUBKEY_HELP": "Gelieve in te loggen op de portemonnee <br class=\"visible-xs\"/><i class=\"ion-key\"></i> {{pubkey|formatPubkey}}:",
      "SCAN_FORM_HELP": "Scan de QR-code van de <b>privésleutel</b> van de portemonnee."
    }
  },
  "ACCOUNT": {
    "TITLE": "Mijn rekening",
    "BALANCE": "Saldo",
    "LAST_TX": "Recente transacties",
    "BALANCE_ACCOUNT": "Rekeningsaldo",
    "NO_TX": "Geen transacties",
    "SHOW_MORE_TX": "Show more",
    "SHOW_ALL_TX": "Show all",
    "TX_FROM_DATE": "(huidige limiet op {{fromTime|medianFromNowShort}})",
    "PENDING_TX": "Transacties in afwachting",
    "VALIDATING_TX": "Verwerkte, niet-gevalideerde transacties",
    "ERROR_TX": "Niet uitgevoerde transacties",
    "ERROR_TX_SENT": "Verzonden transacties",
    "PENDING_TX_RECEIVED": "In afwachting van transacties",
    "EVENTS": "Gebeurtenissen",
    "OUT_DISTANCED": "Uw huidige certificeringen komen van een te geïsoleerde groep in het <a ng-click=\"showHelpModal('wot')\">Web van Vertrouwen</a> (WoT): de <a ng-click=\"showHelpModal('distance_rule')\">maximale afstandsregel</a> wordt niet nageleefd. <br/> U moet certificeringen krijgen van andere sectoren van de WoT, of wachten tot deze dichter bij elkaar komt.",
    "WAITING_MEMBERSHIP": "Lidmaatschapsverzoek verzonden. In afwachting van validatie.",
    "WAITING_CERTIFICATIONS": "Je hebt {{needCertificationCount}} certificatie(s) nodig om lid te worden",
    "WAITING_CERTIFICATIONS_HELP": "Om uw certificeringen te verkrijgen, vraag alleen leden <b>die u voldoende kennen</b>, zoals vereist door <a ng-click=\"showLicenseModal()\">de munteenheid licentie</a> die u hebt geaccepteerd.<br/> Als u nog niet genoeg leden kent, ga dan naar bijeenkomsten of stel ze voor op <a ng-click=\"openLink($event, $root.settings.userForumUrl)\">het gebruikersforum</a>.",
    "WILL_MISSING_CERTIFICATIONS": "Je heeft binnenkort <b>onvoldoende certificaties</b> (ten minste {{willNeedCertificationCount}} benodigd)",
    "WILL_NEED_RENEW_MEMBERSHIP": "Je lidmaatschap <b>gaat verlopen op {{membershipExpiresIn|formatDurationTo}}</b>. Vergeet niet <a ng-click=\"doQuickFix('renew')\">je lidmaatschap te vernieuwen</a> voor die tijd.",
    "NEED_RENEW_MEMBERSHIP": "U bent niet langer lid van de munteenheid, omdat <b>uw lidmaatschap is verlopen</b>. Vergeet niet om <a ng-click=\"doQuickFix('renew')\">uw lidmaatschap te vernieuwen</a>.",
    "NEED_RENEW_MEMBERSHIP_AFTER_CANCELLED": "U bent niet langer lid van de munteenheid, <b>vanwege een gebrek aan certificeringen</b>. Vergeet niet om <a ng-click=\"doQuickFix('renew')\">uw lidmaatschap te vernieuwen</a>.",
    "NO_WAITING_MEMBERSHIP": "Geen aanvraag voor lidmaatschap in behandeling. Als u <b>lid wilt worden</b>, vergeet dan niet om <a ng-click=\"doQuickFix('membership')\">de aanvraag voor lidmaatschap</a> te verzenden.",
    "CERTIFICATION_COUNT": "Aantal certificaties",
    "CERTIFICATION_COUNT_SHORT": "Certificaties",
    "SIG_STOCK": "Voorraad uit te geven certificaties",
    "BTN_RECEIVE_MONEY": "Ontvangen",
    "BTN_MEMBERSHIP_IN_DOTS": "Lidmaatschap aanvragen...",
    "BTN_MEMBERSHIP_RENEW": "Lidmaatschap verlengen",
    "BTN_MEMBERSHIP_RENEW_DOTS": "Lidmaatschap verlengen...",
    "BTN_MEMBERSHIP_OUT_DOTS": "Lidmaatschap opzeggen...",
    "BTN_SEND_IDENTITY_DOTS": "Identiteit publiceren...",
    "BTN_SECURITY_DOTS": "Rekening en veiligheid...",
    "BTN_SHOW_DETAILS": "Tonen technische informatie",
    "BTN_REVOKE": "Deze identiteit<span class='hidden-xs hidden-sm'> definitief</span> opzeggen...",
    "NEW": {
      "TITLE": "Registratie",
      "SLIDE_1_TITLE": "Selecteer een valuta:",
      "SLIDE_2_TITLE": "Soort rekening:",
      "MEMBER_ACCOUNT": "Persoonlijke rekening (lidmaatschap)",
      "MEMBER_ACCOUNT_HELP": "Als je nog niet als individu geregistreerd bent (één rekening per individu mogelijk).",
      "WALLET_ACCOUNT": "Eenvoudige portefeille",
      "WALLET_ACCOUNT_HELP": "Als je een onderneming, stichting etc. vertegenwoordigd of eenvoudigweg een additionele portefeille nodig hebt. Geen individueel universeel dividend zal door deze rekening gecréeerd worden.",
      "SALT_WARNING": "Kies een beveiligingszin.<br/>Deze heb je nodig voor ieder verbinding met je rekening.<br/><br/><b>Zorg dat je deze zin goed onthoud</b>.<br/>Eenmaal verloren, is er geen mogelijkheid om hem te achterhalen!",
      "PASSWORD_WARNING": "Kies een wachtwoord.<br/>Deze heb je nodig voor ieder verbinding met je rekening.<br/><br/><b>Zorg dat je dit woord goed onthoud</b>.<br/>Eenmaal verloren, is er geen mogelijkheid om hem te achterhalen!",
      "PSEUDO_WARNING": "Kies een pseudoniem.<br/>Het dient om makkelijker gevonden te worden door anderen.<br/><br/>.Gebruik van spaties, komma's en accenten is niet toegestaan.<br/><div class='hidden-xs'><br/>Voorbeeld: <span class='gray'>JulesDeelder, JohanVermeer, etc.</span>",
      "PSEUDO": "Pseudoniem",
      "PSEUDO_HELP": "joe123",
      "SALT_CONFIRM": "Bevestig",
      "SALT_CONFIRM_HELP": "Bevestig de beveiligingszin",
      "PASSWORD_CONFIRM": "Bevestig",
      "PASSWORD_CONFIRM_HELP": "Bevestig het wachtwoord",
      "SLIDE_6_TITLE": "Bevestiging:",
      "COMPUTING_PUBKEY": "Berekening...",
      "LAST_SLIDE_CONGRATULATION": "Bravo! Je hebt alle verplichte velden ingevuld.<br/>Je kunt je <b>rekeningaanvraag verzenden</b>.<br/><br/>Ter informatie, de publieke sleutel hieronder identificeert je toekomstige rekening.<br/>Je kunt deze aan derde partijen communiceren om geld te ontvangen. Zodra je rekening geopend is, kun je de sleutel terugvinden onder <b>{{'ACCOUNT.TITLE'|translate}}</b>.",
      "CONFIRMATION_MEMBER_ACCOUNT": "<b class=\"assertive\">Waarschuwing:</b> je beveiligingszin, wachtwoord en pseudoniem kunnen hierna niet gewijzigd worden.<br/><b>Zorg dat ze goed onthoudt!</b><br/><b>Weet je zeker</b> dat je je persoonlijke rekeningaanvraag wil verzenden?",
      "CONFIRMATION_WALLET_ACCOUNT": "<b class=\"assertive\">Waarschuwing:</b> je wachtwoord en pseudoniem kunnen hierna niet gewijzigd worden.<br/><b>Zorg dat ze goed onthoudt!</b><br/><b>Weet je zeker</b> dat je deze portefeilleaanvraag wil verzenden?",
      "PSEUDO_AVAILABLE": "Deze naam is beschikbaar",
      "PSEUDO_NOT_AVAILABLE": "Deze gebruikersnaam is niet beschikbaar",
      "INFO_LICENSE": "Om de valuta te sluiten, vragen wij u om te lezen en deze licentie te accepteren.",
      "BTN_ACCEPT": "Ik accepteer",
      "BTN_ACCEPT_LICENSE": "Ik ga akkoord met de licentie"
    },
    "POPUP_REGISTER": {
      "TITLE": "Voer een pseudoniem in",
      "HELP": "Een pseudoniem is nodig voor anderen om je te kunnen vinden."
    },
    "SELECT_IDENTITY_MODAL": {
      "TITLE": "Identiteit selecteren",
      "HELP": "Er zijn verschillende <b>identiteiten</b> verzonden voor de openbare sleutel <span class=\"gray\"><i class=\"ion-key\"></i> {{pubkey|formatPubkey}}</span>.<br/>Selecteer de te gebruiken map:"
    },
    "SELECT_WALLET_MODAL": {
      "TITLE": "Portemonnee selecteren"
    },
    "CERTIFICATION_MODAL": {
      "CHECKLIST_TITLE": "Controles vóór certificering",
      "INFOS": "De veiligheid van de munteenheid Ğ1 is gebaseerd op elk lid. Voordat je de identiteit van deze persoon certificeert, moet je enkele controles over haar hebben uitgevoerd. Beantwoord de volgende vragen:",
      "BTN_ALL_CHECK": "Certificeren",
      "CHECKLIST_CONDITIONS_NOT_MET": "De certificering is niet verzonden. De controles lijken onvoldoende. Controleer elk punt opnieuw bij de persoon die moet worden gecertificeerd.",
      "QUESTIONS": {
        "WELL_KNOWN": "<b>Ken je</b> de persoon die je certificeert goed, en ken je ook mensen die haar goed kennen?",
        "REVOCATION": "Heeft ze haar <b>herroepingsdocument</b> gedownload en weet ze waar ze het kan vinden?",
        "CONTACT": "Heb je deze persoon op verschillende manieren <b>gecontacteerd</b> en heeft ze je geantwoord?",
        "DOUBLE_IDENTITY": "De persoon moet <b>één actieve lididentiteit</b> hebben. Heeft ze er <b>een andere</b>?",
        "MASTER_ACCOUNT": "Heeft ze controle over haar rekening, en heeft ze al <b>minstens één overboeking</b> gedaan vanaf haar rekening?",
        "LICENSE": "Heeft ze de <b>licentie begrepen</b>, en gaat ze akkoord met de naleving ervan voor de certificering van andere leden?",
        "CREDENTIALS": "Zijn de geheime identificatie en het wachtwoord van haar rekening <b>lang en complex</b> (wachtwoordzinnen)? Heeft ze begrepen dat de identificatie ook geheim moet blijven? Is ze er <b>zeker van dat ze deze zal onthouden</b> of terugvinden?",
        "PUBLIC_KEY_DIFFERENT": "De <b>openbare sleutel</b> moet <b>identiek</b> zijn aan die welke deze persoon je heeft meegedeeld. Zijn de sleutels <b>verschillend</b>?"
      },
      "REMINDER_TITLE": "Herinnering",
      "SHORT_LICENSE_REMINDER": "Je kunt de persoon eraan herinneren verschillende certificeringsparameters te certificeren:<br/><br/><ul><li> - Elk lid kan maximaal 100 andere identiteiten certificeren.</li><li> - De certificeringen worden met een interval van 5 dagen opgeslagen.</li><li> - Een nieuwe identiteit moet in minder dan 2 maanden minstens 5 certificeringen verzamelen.</li><li> - Een lid moet minstens eenmaal per jaar zijn lidmaatschap vernieuwen.</li><li> - Certificeringen hebben een levensduur van twee jaar.</li></ul>"
    },
    "FILE_NAME": "{{currency}} - Rekeningafschrift {{pubkey|formatPubkey}} {{currentTime|formatDateForFile}}.csv",
    "HEADERS": {
      "TIME": "Datum",
      "AMOUNT": "Bedrag",
      "COMMENT": "Commentaar"
    }
  },
  "TRANSFER": {
    "TITLE": "Overboeken",
    "SUB_TITLE": "Geld overboeken",
    "FROM": "Van",
    "TO": "Aan",
    "AMOUNT": "Bedrag",
    "AMOUNT_HELP": "Bedrag",
    "COMMENT": "Opmerking",
    "COMMENT_HELP": "Opmerking (optioneel)",
    "BTN_SEND": "Verzenden",
    "BTN_ADD_COMMENT": "Opmerking toevoegen",
    "WARN_COMMENT_IS_PUBLIC": "Houd er rekening mee dat <b>reacties openbaar zijn </b> (niet-versleuteld).",
    "MODAL": {
      "TITLE": "Overboeking"
    }
  },
  "ERROR": {
    "POPUP_TITLE": "Error",
    "UNKNOWN_ERROR": "Unknown error",
    "TIMEOUT_REACHED": "Node timeout overschreden ({{timeout|formatDurationMs}}).<br/><br/><small>{{url}}</small>",
    "CRYPTO_UNKNOWN_ERROR": "Your browser is not compatible with cryptographic features.",
    "FIELD_REQUIRED": "This field is required.",
    "FIELD_TOO_SHORT": "Value is too short (min {{minLength]] characters).",
    "FIELD_TOO_SHORT_WITH_LENGTH": "This field value is too short.",
    "FIELD_TOO_LONG": "Value is exceeding max length.",
    "FIELD_TOO_LONG_WITH_LENGTH": "Value is too long (max {{maxLength}} characters).",
    "FIELD_ACCENT": "Commas and accent characters not allowed",
    "FIELD_NOT_NUMBER": "Value is not a number",
    "FIELD_NOT_INT": "Value is not an integer",
    "PASSWORD_NOT_CONFIRMED": "Must match previous password.",
    "SALT_NOT_CONFIRMED": "Must match previous phrase.",
    "SEND_IDENTITY_FAILED": "Error while trying to register.",
    "SEND_CERTIFICATION_FAILED": "Could not certify identity.",
    "NEED_MEMBER_ACCOUNT_TO_CERTIFY": "You could not send certification, because your account is <b>not a member account</b>.",
    "NEED_MEMBER_ACCOUNT_TO_CERTIFY_HAS_SELF": "You could not send certification now, because your are <b>not a member</b> yet.<br/><br/>You still need certification to become a member.",
    "IDENTITY_TO_CERTIFY_HAS_NO_SELF": "This account could not be certified. No registration found, or need to renew.",
    "LOGIN_FAILED": "Error while sign in.",
    "LOAD_IDENTITY_FAILED": "Could not load identity.",
    "LOAD_REQUIREMENTS_FAILED": "Could not load identity requirements.",
    "SEND_MEMBERSHIP_IN_FAILED": "Error while sending registration as member.",
    "SEND_MEMBERSHIP_OUT_FAILED": "Error while sending membership revocation.",
    "REFRESH_WALLET_DATA": "Could not refresh wallet.",
    "GET_CURRENCY_PARAMETER": "Could not get currency parameters.",
    "GET_CURRENCY_FAILED": "Could not load currency.",
    "SEND_TX_FAILED": "Could not send transaction.",
    "ALL_SOURCES_USED": "Please wait the next block computation (All transaction sources has been used).",
    "NOT_ENOUGH_SOURCES": "Not enough changes to send this amount in one time.<br/>Maximum amount: {{amount}} {{unit}}<sub>{{subUnit}}</sub>.",
    "ACCOUNT_CREATION_FAILED": "Error while creating your member account.",
    "RESTORE_WALLET_DATA_ERROR": "Error while reloading settings from local storage",
    "LOAD_WALLET_DATA_ERROR": "Error while loading wallet data.",
    "COPY_CLIPBOARD_FAILED": "Could not copy to clipboard",
    "TAKE_PICTURE_FAILED": "Could not get picture.",
    "SCAN_FAILED": "Could not scan QR code.",
    "SCAN_UNKNOWN_FORMAT": "Code not recognized.",
    "WOT_LOOKUP_FAILED": "Search failed.",
    "LOAD_PEER_DATA_FAILED": "Duniter peer not accessible. Please retry later.",
    "NEED_LOGIN_FIRST": "Please sign in first.",
    "AMOUNT_REQUIRED": "Amount is required.",
    "AMOUNT_NEGATIVE": "Negative amount not allowed.",
    "NOT_ENOUGH_CREDIT": "Not enough credit.",
    "INVALID_NODE_SUMMARY": "Unreachable peer or invalid address",
    "INVALID_USER_ID": "Field 'pseudonym' must not contains spaces or special characters.",
    "INVALID_COMMENT": "Field 'reference' has a bad format.",
    "INVALID_PUBKEY": "Public key has a bad format.",
    "IDENTITY_INVALID_BLOCK_HASH": "This membership application is no longer valid (because it references a block that network peers are cancelled): the person must renew its application for membership <b>before</b> being certified.",
    "IDENTITY_EXPIRED": "This identity has expired: this person must re-apply <b>before</b> being certified.",
    "IDENTITY_SANDBOX_FULL": "Could not register, because peer's sandbox is full.<br/><br/>Please retry later or choose another Duniter peer (in <b>Settings</b>).",
    "WOT_PENDING_INVALID_BLOCK_HASH": "Membership not valid.",
    "WALLET_INVALID_BLOCK_HASH": "Your membership application is no longer valid (because it references a block that network peers are cancelled).<br/>You must <a ng-click=\"doQuickFix('renew')\">renew your application for membership</a> to fix this issue.",
    "WALLET_IDENTITY_EXPIRED": "The publication of your identity <b>has expired</b>.<br/>You must <a ng-click=\"doQuickFix('fixIdentity')\">re-issue your identity</a> to resolve this issue.",
    "WALLET_HAS_NO_SELF": "Your identity must first have been published, and not expired.",
    "IDENTITY_ALREADY_CERTIFY": "You have <b>already certified</b> that identity.<br/><br/>Your certificate is still valid (expires {{expiresIn|formatDuration}}).",
    "IDENTITY_ALREADY_CERTIFY_PENDING": "You have <b>already certified</b> that identity.<br/><br/>Your certification is still pending (Deadline for treatment {{expiresIn|formatDuration}}).",
    "UNABLE_TO_CERTIFY_TITLE": "Unable to certify",
    "LOAD_NEWCOMERS_FAILED": "Unable to load new members.",
    "LOAD_PENDING_FAILED": "Unable to load pending registrations.",
    "ONLY_MEMBER_CAN_EXECUTE_THIS_ACTION": "You must <b>be a member</b> in order to perform this action.",
    "ONLY_SELF_CAN_EXECUTE_THIS_ACTION": "You must have <b>published your identity</b> in order to perform this action.",
    "EXISTING_ACCOUNT": "Je gegevens komen overeen met een bestaande rekening, met de <a ng-click=\"showHelpModal('pubkey')\">publieke sleutel</a>:",
    "EXISTING_ACCOUNT_REQUEST": "Gelieve je gegevens te wijzigen zodat ze met een niet gebruikte rekening overeenkomen."
  },
  "INFO": {
    "POPUP_TITLE": "Informatie",
    "CERTIFICATION_DONE": "Identiteit succesvol getekend",
    "NOT_ENOUGH_CREDIT": "Niet genoeg krediet",
    "TRANSFER_SENT": "Verzoek tot overboeken succesvol verzonden",
    "COPY_TO_CLIPBOARD_DONE": "Kopie geslaagd",
    "MEMBERSHIP_OUT_SENT": "Opzegging lidmaatschap succesvol verzonden",
    "NOT_NEED_MEMBERSHIP": "Je bent al lid.",
    "IDENTITY_WILL_MISSING_CERTIFICATIONS": "Deze identiteit heeft binnenkort onvoldoende certificaties (ten minste {{willNeedCertificationCount}} nodig).",
    "REVOCATION_SENT": "Intrekking succesvol verzonden",
    "REVOCATION_SENT_WAITING_PROCESS": "Intrekking <b>is succesvol verzonden</b>. Het wacht op verwerking.",
    "FEATURE_NOT_AVAILABLE_ON_DEMO": "Functionaliteit niet beschikbaar op deze demonstratiesite.<br/>Om <b>veiligheidsredenen</b> raden we u aan uw kopie van de software te <b>installeren</b>.<br/>Bezoek de website <a href='https://cesium.app'>www.cesium.app</a> voor hulp.",
    "EMPTY_TX_HISTORY": "Aucune operatie à exporteur",
    "LOADING_PENDING_TX": "Even geduld...<br/><small>(Ophalen van hangende operaties)</small>"
  },
  "CONFIRM": {
    "CAN_CONTINUE": "<b>Weet je zeker</b> dat je door wil gaan?",
    "POPUP_TITLE": "<b>Bevestiging</b>",
    "POPUP_WARNING_TITLE": "<b>Waarschuwing</b>",
    "CERTIFY_RULES_TITLE_UID": "Certificeer {{uid}}",
    "CERTIFY_RULES": "<b>Beveiligingswaarschuwing:</b><br/><br/><b class=\"assertive\">Certificeer een rekening niet</b> als je gelooft dat: <ul><li>1.) de aanvrager niet echt is.<li>2.) de aanvrager al een andere gecertificeerde rekening heeft.<li>3.) de aanvrager opzettelijk of door onzorgvuldigheid regel 1 of 2 overtreedt bij het verzenden van certificaten.</ul></small><br/>Weet je zeker dat je deze identieit wilt certificeren?",
    "TRANSFER": "<b>Samenvatting van de overboeking:</b><br/><br/><ul><li> - Van: <b>{{from}}</b></li><li> - Aan: <b>{{to}}</b></li><li> - Bedrag: <b>{{amount}} {{unit}}</b></li><li> - Opmerking: <i>{{comment}}</i></li></ul><br/><b>Weet je zeker dat je deze overboeking wil doen?</b>",
    "MEMBERSHIP_OUT": "<b>Waarschuwing</b>:<br/>Je staat op het punt je lidmaatschap te beëindigen. Dit kan <b>niet ongedaan</b> worden gemaakt.<br/></br/><b>Weet je zeker dat je door wil gaan?</b>",
    "LOGIN_UNUSED_WALLET_TITLE": "Typefout?",
    "LOGIN_UNUSED_WALLET": "Je bent ingelogged op een rekening die <b>inactief</b> lijkt te zijn.<br/><br/>Als deze rekening niet met de jouwe overeenkomt, komt dat waarschijnlijk door een <b>typefout</b> bij het inloggen.<br/><br/><b>Wilt u toch doorgaan met deze rekening?</b>",
    "FIX_IDENTITY": "De pseudoniem <b>{{uid}}</b> zal opnieuw gepubliceerd worden, waarmee de oude verlopen publicatie wordt vervangen.<br/></br/><b>Weet je zeker</b> dat je door wil gaan?",
    "FIX_MEMBERSHIP": "Je verzoek to lidmaatschap zal verstuurd worden.<br/></br/><b>Weet je het zeker?</b>",
    "RENEW_MEMBERSHIP": "Je lidmaatschap zal verlengd worden.<br/></br/><b>Weet je het zeker?</b>",
    "REVOKE_IDENTITY": "<b>Beveiligingswaarschuwing:</b><br/>You will <b>definitely revoke this identity</b>.<br/><br/>The public key and the associated nickname <b>will never be used again</b> (for a member account).<br/></br/><b>Are you sure</b> you want to continue?",
    "REVOKE_IDENTITY_2": "Deze handeling is <b>niet terug te draaien</b>!<br/><br/><b>Weet je zeker</b> dat je door wil gaan?",
    "NOT_NEED_RENEW_MEMBERSHIP": "Je lidmaatschap hoeft niet verlengd te worden (het zal pas verlopen na {{membershipExpiresIn|formatDuration}}).<br/></br/><b>Weet je zeker</b> dat je een verlengingsaanvraag wil versturen?",
    "SAVE_BEFORE_LEAVE": "Wil je <b>je wijzigingen opslaan</b> voor je de pagina verlaat?",
    "SAVE_BEFORE_LEAVE_TITLE": "Wijzigingen niet opgeslagen",
    "LOGOUT": "Weet u zeker dat u wilt uitloggen?",
    "USE_FALLBACK_NODE": "Node <b>{{old}}</b> is onbereikbaar of het adres is ongeldig.<br/><br/>Wilt u tijdelijk de node <b>{{new}}</b> gebruiken?",
    "USE_SYNC_FALLBACK_NODE": "Node <b>{{old}}</b> lijkt niet gesynchroniseerd te zijn.<br/><br/>Wilt u tijdelijk de gesynchroniseerde node <b>{{new}}</b> gebruiken?",
    "ENABLE_EXPERT_MODE_TO_CHANGE_NODE": "<b class=\"assertive\">Waarschuwing:</b> Wil je het knooppunt <b>handmatig wijzigen</b>?<br/><br/>Als je doorgaat:<ul><li> - De <b>expertmodus</b> wordt geactiveerd;</li><li> - Je kunt terugkeren naar automatische knooppuntselectie door eenvoudigweg de <b>expertmodus uit te schakelen</b>.</li></ul>"
  },
  "DOWNLOAD": {
    "POPUP_TITLE": "<b>Intrekkingsdocument</b>",
    "POPUP_REVOKE_MESSAGE": "Om je rekening te beveiligen, download het <b>rekening intrekkingsdocument</b>. Dit heb je nodig om je rekening op te heffen (in het geval van diefstal, een verandering van ID, een ten onrechte gemaakte rekening, etc.).<br/><br/><b>Bewaar deze op een veilige plaats.</b>"
  },
  "HELP": {
    "TITLE": "Online help",
    "JOIN": {
      "SECTION": "Join",
      "SALT": "The protection phrase is very important. It is used to hash you password, which in turn is used to calculate your <span class=\"text-italic\">public account key</span> (its number) and the private key to access it. <b>Please remeber this phrase well</b>, because there is no way to recover it when lost. What's more, it cannot be changed without having to create a new account.<br/><br/>A good protection phrase must be sufficiently long (8 characters at the very least) and as original as possible.",
      "PASSWORD": "The password is very important. Together with the protection phrase, it is use to calculate your account number (public key) and the private key to access it. <b>Please remember it well</b>, because there is no way to recover it when lost. What's more, it cannot be changed without having to create a new account.<br/><br/>A good password is made (ideally) of at least 8 characters, with at least one capital and one number.",
      "PSEUDO": "A pseudonym is used only when joining as <span class=\"text-italic\">member</span>. It is always associated with a wallet (by its <span class=\"text-italic\">public key</span>). It is published on the network so that other users may identify it, certify or send money to the account. A pseudonym must be unique among all members (current and past)."
    },
    "GLOSSARY": {
      "SECTION": "Glossary",
      "PUBKEY_DEF": "Een publieke sleutel identificeert altijd een portemonnee. Het kan een lid identificeren. In Cesium wordt berekend met de geheime ID en wachtwoord.",
      "MEMBER": "Member",
      "MEMBER_DEF": "A member is a real and living human, wishing to participate freely to the monitary community. The member will receive universal dividend, according to the period and amount as defined in the <span class=\"text-italic\">currency parameters</span>.",
      "CURRENCY_RULES": "Currency rules",
      "CURRENCY_RULES_DEF": "The currency rules are defined only once, and for all. They set the parameters under which the currency will perform: universal dividend calculation, the amount of certifications needed to become a member, the maximum amount of certifications a member can send, etc.<br/><br/>The parameters cannot be modified because of the use of a <span class=\"text-italic\">Blockchain</span> which carries and executes these rules, and constantly verifies their correct application. <a href=\"#/app/currency\">See current parameters</a>.",
      "BLOCKCHAIN": "Blockchain",
      "BLOCKCHAIN_DEF": "The Blockchain is a decentralised system which, in case of Duniter, serves to carry and execute the <span class=\"text-italic\">currency rules</span>.<br/><a href=\"http://en.duniter.org/presentation/\" target=\"_blank\">Read more about Duniter</a> and the working of its blockchain.",
      "UNIVERSAL_DIVIDEND_DEF": "The Universal Dividend (UD) is the quantity of money co-created by each member, according to the period and the calculation defined in the <span class=\"text-italic\">currency rules</span>.<br/>Every term, the members receive an equal amount of new money on their account.<br/><br/>The UD undergoes a steady growth, to remain fair under its members (current and future), calculated by an average life expectancy, as demonstrated in the Relative Theory of Money (RTM).<br/><a href=\"http://trm.creationmonetaire.info\" target=\"_system\">Read more about RTM</a> and open money."
    },
    "TIP": {
      "MENU_BTN_CURRENCY": "Menu <b>{{'MENU.CURRENCY'|translate}}</b> allows discovery of <b>currency parameters</b> and its state.",
      "CURRENCY_WOT": "The <b>member count</b> shows the <b>community's weight and evolution</b>.",
      "CURRENCY_MASS": "Shown here is the <b>total amount</b> currently in circulation and its <b>average distribution</b> per member.<br/><br/>This allows to estimate the <b>worth of any amount</b>, in respect to what <b>others own</b> on their account (on average).",
      "CURRENCY_UNIT_RELATIVE": "The unit used here (&ldquo;<b>{{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub></b>&rdquo;) signifies that the amounts in {{currency|capitalize}} have been devided by the <b>Universal Dividend</b> (UD).<br/><br/><small>This relative unit is <b>relevant</b> because it is stable in contrast to the permanently growing monitary mass.</small>",
      "CURRENCY_CHANGE_UNIT": "This button allows to <b>switch the unit</b> to show amounts in <b>{{currency|capitalize}}</b>, undevided by the Universal Dividend (instead of in &ldquo;<b>{{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub></b>&rdquo;).",
      "CURRENCY_CHANGE_UNIT_TO_RELATIVE": "This button allows to <b>switch the unit</b> to show amounts in &ldquo;<b>{{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub></b>&rdquo;, which is relative to the Universal Dividend (the amount co-produced by each member).",
      "CURRENCY_RULES": "The <b>rules</b> of the currency determine its <b>exact and predictible</b> performance.<br/><br/>As a true DNA of the currency these rules make the monetary code <b>transparent and understandable</b>.",
      "NETWORK_BLOCKCHAIN": "All monetary transactions are recoded in a <b>public and tamper proof</b> ledger, generally referred to as the <b>blockchain</b>.",
      "NETWORK_PEERS": "The <b>peers</b> shown here correspond to <b>computers that update and check</b> the blockchain.<br/><br/>The more active peers there are, the more <b>decentralised</b> and therefore trustworhty the currency becomes.",
      "NETWORK_PEERS_BLOCK_NUMBER": "This <b>number</b> indicates the peer's <b>latest validated block</b> (last page written in the ledger).<br/><br/>Green indicates that the block was equally validated by the <b>majority of other peers</b>.",
      "NETWORK_PEERS_PARTICIPATE": "<b>Each member</b>, equiped with a computer with Internet, <b>can participate, adding a peer</b> simply by <b>installing the Duniter software</b> (free/libre and open source). <a href=\"{{installDocUrl}}\" target=\"_system\">Read the installation manual &gt;&gt;</a>.",
      "MENU_BTN_ACCOUNT": "<b>{{'ACCOUNT.TITLE'|translate}}</b> allows access to your account balance and transaction history.",
      "MENU_BTN_ACCOUNT_MEMBER": "Here you can consult your account status, transaction history and your certifications.",
      "WALLET_CERTIFICATIONS": "Click here to reveiw the details of your certifications (given and received).",
      "WALLET_BALANCE": "Your account <b>balance</b> is shown here.",
      "WALLET_BALANCE_RELATIVE": "{{'HELP.TIP.WALLET_BALANCE'|translate}}<br/><br/>The used unit (&ldquo;<b>{{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub></b>&rdquo;) signifies that the amount in {{currency|capitalize}} has been divided by the <b>Universal Dividend</b> (UD) co-created by each member.<br/>At this moment, 1 UD equals {{currentUD}} {{currency|capitalize}}.",
      "WALLET_BALANCE_CHANGE_UNIT": "You can <b>change the unit</b> in which amounts are shown in <b><i class=\"icon ion-android-settings\"></i>&nbsp;{{'MENU.SETTINGS'|translate}}</b>.<br/><br/>For example, to display amounts <b>directly in {{currency|capitalize}}</b> instead of relative amounts.",
      "WALLET_SEND": "Issue a payment in just a few clicks.",
      "WALLET_SEND_NO_MONEY": "Issue a payment in just a few clicks.<br/>(Your balance does not allow this yet)",
      "WALLET_OPTIONS": "Please note that this button allows access to <b>other, less used actions</b>.<br/><br/>Don't forget to take a quick look, when you have a moment!",
      "WALLET_RECEIVED_CERTS": "This shows the list of persons that certified you.",
      "WALLET_CERTIFY": "The button <b>{{'WOT.BTN_SELECT_AND_CERTIFY'|translate}}</b> allows selecting an identity and certifying it.<br/><br/>Only users that are <b>already member</b> may certify others.",
      "WALLET_CERT_STOCK": "Your supply of certifications (to send) is limited to <b>{{sigStock}} certifications</b>.<br/><br/>This supply will replete itself over time, as and when earlier certifications expire.",
      "MENU_BTN_WOT": "The menu <b>{{'MENU.WOT'|translate}}</b> allows searching <b>users</b> of the currency (member or not).",
      "WOT_SEARCH_TEXT_XS": "To search in the registry, type the <b>first letters of a users pseudonym or public key</b>.<br/><br/>The search will start automatically.",
      "WOT_SEARCH_TEXT": "To search in the registry, type the <b>first letters of a users pseudonym or public key</b>.<br/><br/>Then hit <b>Enter</b> to start the search.",
      "WOT_SEARCH_RESULT": "Simply click a user row to view the details sheet.",
      "WOT_VIEW_CERTIFICATIONS": "The row <b>{{'ACCOUNT.CERTIFICATION_COUNT'|translate}}</b> shows how many members members validated this identity.<br/><br/>These certifications testify that the account belongs to <b>a living human</b> and this person has <b>no other member account</b>.",
      "WOT_VIEW_CERTIFICATIONS_COUNT": "There are at least <b>{{sigQty}} certifications</b> needed to become a member and receive the <b>Universal Dividend</b>.",
      "WOT_VIEW_CERTIFICATIONS_CLICK": "Click here to open <b>a list of all certifications</b> given to and by this identity.",
      "WOT_VIEW_CERTIFY": "The button <b>{{'WOT.BTN_CERTIFY'|translate}}</b> allows to add your certification to this identity.",
      "CERTIFY_RULES": "<b>Attention:</b> Only certify <b>real and living persons</b> that do not own any other certified account.<br/><br/>The trust carried by the currency depends on each member's vigilance!",
      "MENU_BTN_SETTINGS": "The <b>{{'MENU.SETTINGS'|translate}}</b> allow you to configure the Cesium application.<br/><br/>For example, you can <b>change the unit</b> in which the currency will be shown.",
      "HEADER_BAR_BTN_PROFILE": "Click here to access your <b>user profile</b>",
      "SETTINGS_CHANGE_UNIT": "You can <b>change the display unit</b> of amounts by clicking here.<br/><br/>- Deactivate the option to show amounts in {{currency|capitalize}}.<br/>- Activate the option for relative amounts in {{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub> (<b>divided</b> by the current Universal Dividend).",
      "END_LOGIN": "This guided visit has <b>ended</b>.<br/><br/>Welcome to the <b>free economy</b>!",
      "END_NOT_LOGIN": "This guided visit has <b>ended</b>.<br/><br/>If you wish to join the currency {{currency|capitalize}}, simply click <b>{{'LOGIN.CREATE_ACCOUNT'|translate}}</b> below."
    }
  }
}
);

$translateProvider.translations("pt-PT", {
  "COMMON": {
    "APP_NAME": "Cesium",
    "APP_VERSION": "v{{version}}",
    "APP_BUILD": "data: {{build}}",
    "PUBKEY": "Chave pública",
    "MEMBER": "Membro",
    "BLOCK": "Bloco",
    "BTN_OK": "OK",
    "BTN_YES": "Sim",
    "BTN_NO": "Não",
    "BTN_SEND": "Enviar",
    "BTN_SEND_MONEY": "Pago",
    "BTN_SEND_MONEY_SHORT": "Pago",
    "BTN_SAVE": "Guardar",
    "BTN_YES_SAVE": "Sim, guardar",
    "BTN_YES_CONTINUE": "Sim, continuar",
    "BTN_SHOW": "Ver",
    "BTN_SHOW_PUBKEY": "Ver a chave",
    "BTN_RELATIVE_UNIT": "Mostrar entradas em DU",
    "BTN_BACK": "Anterior",
    "BTN_NEXT": "Seguinte",
    "BTN_IMPORT": "Importar",
    "BTN_CANCEL": "Cancelar",
    "BTN_CLOSE": "Fechar",
    "BTN_LATER": "Mais tarde",
    "BTN_LOGIN": "Iniciar sessão",
    "BTN_LOGOUT": "Fechar sessão",
    "BTN_ADD_ACCOUNT": "Adicionar conta",
    "BTN_SHARE": "Partilhar",
    "BTN_EDIT": "Modificar",
    "BTN_DELETE": "Apagar",
    "BTN_ADD": "Adicionar",
    "BTN_SEARCH": "Procurar",
    "BTN_REFRESH": "Atualizar",
    "BTN_RETRY": "Recomeçar",
    "BTN_START": "Iniciar",
    "BTN_CONTINUE": "Continuar",
    "BTN_CREATE": "Criar",
    "BTN_UNDERSTOOD": "Entendido",
    "BTN_OPTIONS": "Opções",
    "BTN_HELP_TOUR": "Visita guiada",
    "BTN_HELP_TOUR_SCREEN": "Ajuda nesta tela",
    "BTN_DOWNLOAD": "Descarregar",
    "BTN_DOWNLOAD_ACCOUNT_STATEMENT": "Descarregar histórico de conta",
    "BTN_MODIFY": "Modificar",
    "CHOOSE_FILE": "Arraste o arquivo<br/>ou clique para o selecionar",
    "DAYS": "Dias",
    "NO_ACCOUNT_QUESTION": "Ainda não é membro? Criar uma conta!",
    "SEARCH_NO_RESULT": "Não foi encontrado nenhum resultado",
    "LOADING": "Aguarde por favor...",
    "LOADING_WAIT": "Aguarde por favor...<br/><small>(Cesium está a questionar o nó Duniter)</small>",
    "SEARCHING": "Procurando…",
    "FROM": "De",
    "TO": "Para",
    "COPY": "Copiar",
    "LANGUAGE": "Idioma",
    "UNIVERSAL_DIVIDEND": "Dividendo universal",
    "UD": "DU",
    "DATE_PATTERN": "DD/MM/YYYY HH:mm",
    "DATE_FILE_PATTERN": "YYYY-MM-DD",
    "DATE_SHORT_PATTERN": "DD/MM/YY",
    "DATE_MONTH_YEAR_PATTERN": "MM/YYYY",
    "EMPTY_PARENTHESIS": "(vazio)",
    "UID": "O seu pseudónimo",
    "ENABLE": "Ativado",
    "DISABLE": "Desativado",
    "RESULTS_LIST": "Resultados:",
    "RESULTS_COUNT": "{{count}} resultados",
    "EXECUTION_TIME": "executado em {{duration|formatDurationMs}}",
    "SHOW_VALUES": "Mostrar contra senha",
    "POPOVER_ACTIONS_TITLE": "Opções",
    "POPOVER_FILTER_TITLE": "Filtros",
    "SHOW_MORE": "Mostrar mais",
    "SHOW_MORE_COUNT": "(limite atual {{limit}})",
    "POPOVER_SHARE": {
      "TITLE": "Partilhar",
      "SHARE_ON_TWITTER": "Partilhar em Twitter",
      "SHARE_ON_FACEBOOK": "Partilhar em Facebook",
      "SHARE_ON_DIASPORA": "Partilhar em Diaspora*",
      "SHARE_ON_GOOGLEPLUS": "Partilhar em Google+"
    },
    "FILE": {
      "DATE" : "Data:",
      "TYPE" : "Tipo:",
      "SIZE": "Tamanho:",
      "VALIDATING": "Validando…"
    }
  },
  "SYSTEM": {
    "PICTURE_CHOOSE_TYPE": "Escolher a fonte:",
    "BTN_PICTURE_GALLERY": "Galeria",
    "BTN_PICTURE_CAMERA": "<b>Camera</b>"
  },
  "MENU": {
    "HOME": "Início",
    "WOT": "Diretório",
    "CURRENCY": "Moeda",
    "ACCOUNT": "A minha conta",
    "WALLETS": "A minha carteira",
    "SETTINGS": "Definições",
    "NETWORK": "Rede",
    "TRANSACTIONS": "As minhas transações"
  },
  "ABOUT": {
    "BTN_OPEN_DEV_WINDOW": "Abrir janela de depuração",
    "TITLE": "Acerca de",
    "LICENSE": "Software <b>livre</b> (licença GNU AGPLv3).",
    "LATEST_RELEASE": "Existe uma <b>nova versão</b> de {{'COMMON.APP_NAME' | translate}} (<b>v{{version}}</b>)",
    "PLEASE_UPDATE": "Por favor atualize {{'COMMON.APP_NAME' | translate}} (última versão: <b>v{{version}}</b>)",
    "CODE": "Código fonte:",
    "OFFICIAL_WEB_SITE": "Site oficial:",
    "DEVELOPERS": "Desenvolvido por:",
    "FORUM": "Fórum:",
    "PLEASE_REPORT_ISSUE": "Não se iniba de nos informar sobre anomalias encontradas",
    "REPORT_ISSUE": "Reportar um problema"
  },
  "HOME": {
    "FEED_SOURCE": "Fonte",
    "READ_MORE": "Ler mais",
    "SHOW_ALL_FEED": "Ver tudo",
    "TITLE": "Cesium",
    "WELCOME": "Bem vinda/o à aplicação Cesium!",
    "MESSAGE": "Receba e envie moeda livre {{currency|abbreviate}} facilmente",
    "BTN_CURRENCY": "Explorar a moeda",
    "BTN_ABOUT": "Acerca de",
    "BTN_HELP": "Ajuda",
    "REPORT_ISSUE": "Reportar anomalia",
    "NOT_YOUR_ACCOUNT_QUESTION": "Esta conta não é sua <b><i class=\"ion-key\"></i> {{pubkey|formatPubkey}}</b>?",
    "BTN_CHANGE_ACCOUNT": "Sair desta conta",
    "PEER_CONNECTION_ERROR": "Nó <b>{{server}}</b> indisponível ou endereço inválido.<br/><br/>Teste a sua ligação à Internet, ou nó Duniter <a class=\"positive\" ng-click=\"doQuickFix('settings')\">nas definições</a>.",
    "NETWORK_CONNECTION_ERROR": "Rede inacessível.<br/><br/>Verifique a sua ligação à Internet, ou selecione um nó manualmente <a class=\"positive\" ng-click=\"doQuickFix('settings')\">nas definições</a>."
  },
  "SETTINGS": {
    "TITLE": "Definições",
    "DISPLAY_DIVIDER": "Visualização",
    "STORAGE_DIVIDER": "Armazenamento",
    "NETWORK_SETTINGS": "Rede",
    "PEER": "Nó Duniter",
    "PEER_CHANGED_TEMPORARY": "Endereço utilizado temporariamente",
    "PEER_SELECTED_AUTOMATICALLY": "Nó selecionado automaticamente na inicialização",
    "NETWORK_ANALYZE_TIMEOUT": "Tempo máximo de espera (timeout)",
    "NETWORK_ANALYZE_TIMEOUT_HELP": "Tempo máximo de espera para a análise de rede",
    "NETWORK_ANALYZE_TIMEOUT_AUTO": "Auto",
    "PERSIST_CACHE": "Conservar os dados de navegação (experimental)",
    "PERSIST_CACHE_HELP": "Permite uma navegação mais rápida, manter localmente os dados recebidos, para usar entre sessões.",
    "USE_LOCAL_STORAGE": "Ativar o armazenamento local",
    "USE_LOCAL_STORAGE_HELP": "Permitir manter as suas definições",
    "WALLETS_SETTINGS": "A minha carteira",
    "USE_WALLETS_ENCRYPTION": "Cifrar carteiras",
    "USE_WALLETS_ENCRYPTION_HELP": "Permite proteger as suas carteiras (encriptando), exigida autenticação para aceder.",
    "ENABLE_HELPTIP": "Ativar a ajuda por tópico",
    "ENABLE_UI_EFFECTS": "Ativar efeitos visuais",
    "HISTORY_SETTINGS": "Transações de conta",
    "DISPLAY_UD_HISTORY": "Mostrar os DU criados",
    "TX_HISTORY_AUTO_REFRESH": "Ativar atualização automática",
    "TX_HISTORY_AUTO_REFRESH_HELP": "Atualizar o saldo e as transações automaticamente, com cada novo bloco.",
    "AUTHENTICATION_SETTINGS": "Autenticação",
    "KEEP_AUTH": "Expiração da sessão",
    "KEEP_AUTH_SHORT": "Expiração",
    "KEEP_AUTH_HELP": "Defina quando expira a sessão",
    "KEEP_AUTH_OPTION": {
      "NEVER": "Depois de cada operação",
      "SECONDS": "Depois de {{value}} segundos de inatividade",
      "MINUTE": "Depois de {{value}}min de inatividade",
      "MINUTES": "Depois de {{value}}mins de inatividade",
      "HOUR": "Depois de {{value}}h de inatividade",
      "ALWAYS": "Ao terminar sessão"
    },
    "KEYRING_FILE": "Arquivo de chaves",
    "KEYRING_FILE_HELP": "Permite <b>conectar-se</b> automaticamente em cada início <br/>e inclusive de <b>autenticar-se</b> (apenas se \"Expiração da sessão\" está configurada em modo: \"Ao terminar a sessão\").",
    "REMEMBER_ME": "Lembrar-me",
    "REMEMBER_ME_HELP": "Permite manter-se sempre conectado (não recomendado), conservando localmente a chave pública.",
    "PLUGINS_SETTINGS": "Extensões",
    "BTN_RESET": "Repor valores por defeito",
    "EXPERT_MODE": "Modo avançado",
    "EXPERT_MODE_HELP": "Permite uma visualização mais detalhada",
    "BLOCK_VALIDITY_WINDOW": "Tempo de validação dos blocos",
    "DISABLE_HELPTIP": "Desativar a opção de ajuda contextual",
    "BLOCK_VALIDITY_WINDOW_SHORT": "Tempo de validação",
    "BLOCK_VALIDITY_WINDOW_HELP": "Tempo de espera antes de considerar uma informação como validada",
    "BLOCK_VALIDITY_OPTION": {
      "NONE": "Sem espera",
      "N": "{{time | formatDuration}} ({{count}} bloques)"
    },
    "POPUP_PEER": {
      "TITLE": "Nó Duniter",
      "HOST": "Endereço",
      "HOST_HELP": "Endereço: servidor:porta",
      "USE_SSL": "Conexão segura",
      "USE_SSL_HELP": "Cifrado SSL",
      "BTN_SHOW_LIST": "Lista de nós"
    }
  },
  "BLOCKCHAIN": {
    "HASH": "Hash: {{hash}}",
    "VIEW": {
      "HEADER_TITLE": "Bloco #{{number}}-{{hash|formatHash}}",
      "TITLE_CURRENT": "Bloco atual",
      "TITLE": "Bloco #{{number|formatInteger}}",
      "COMPUTED_BY": "Calculado pelo nó de",
      "SHOW_RAW": "Ver o ficheiro em bruto",
      "TECHNICAL_DIVIDER": "Informações técnicas",
      "VERSION": "Versão do formato",
      "HASH": "Hash calculado",
      "UNIVERSAL_DIVIDEND_HELP": "Moeda co-produzida por cada um dos {{membersCount}} membros",
      "EMPTY": "Nenhum dado neste bloco",
      "POW_MIN": "Dificuldade mínima",
      "POW_MIN_HELP": "Dificuldade imposta pelo cálculo do hash",
      "DATA_DIVIDER": "Dados",
      "IDENTITIES_COUNT": "Novas identidades",
      "JOINERS_COUNT": "Novos membros",
      "ACTIVES_COUNT": "Renovações",
      "ACTIVES_COUNT_HELP": "Membros que renovaram as suas adesões",
      "LEAVERS_COUNT": "Membros de saída",
      "LEAVERS_COUNT_HELP": "Membros de saída que já não querem estar certificados",
      "EXCLUDED_COUNT": "Membros excluídos",
      "EXCLUDED_COUNT_HELP": "Antigos membros excluídos por não renovação ou falta de certificações",
      "REVOKED_COUNT": "Identidades revogadas",
      "REVOKED_COUNT_HELP": "Estas contas não poderão ser membros",
      "TX_COUNT": "Transações",
      "CERT_COUNT": "Certificações",
      "TX_TO_HIMSELF": "Operação de mudança",
      "TX_OUTPUT_UNLOCK_CONDITIONS": "Condições de desbloqueio",
      "TX_OUTPUT_OPERATOR": {
        "AND": "e",
        "OR": "ou"
      },
      "TX_OUTPUT_FUNCTION": {
        "SIG": "<b>Assinatura</b> de ",
        "XHX": "<b>Contra senha</b>, cuyo SHA256 =",
        "CSV": "Bloqueado durante",
        "CLTV": "Bloqueado até"
      }
    },
    "LOOKUP": {
      "TITLE": "Blocos",
      "NO_BLOCK": "Nenhum bloco",
      "LAST_BLOCKS": "Últimos blocos:",
      "BTN_COMPACT": "Compactar"
    }
  },
  "CURRENCY": {
    "VIEW": {
      "TITLE": "Moeda",
      "TAB_CURRENCY": "Moeda",
      "TAB_WOT": "Rede de confiança",
      "TAB_NETWORK": "Rede",
      "TAB_BLOCKS": "Blocos",
      "CURRENCY_SHORT_DESCRIPTION": "{{currency|abbreviate}} é uma <b>moeda livre</b>, originada {{firstBlockTime|formatFromNow}}. Conta atualmente com <b>{{N}} membros</b>, que produzem e recebem um <a ng-click=\"showHelpModal('ud')\">Dividendo Universal</a> (DU) cada {{dt|formatPeriod}}.",
      "NETWORK_RULES_DIVIDER": "Regras da rede",
      "CURRENCY_NAME": "Nome da moeda",
      "MEMBERS": "Quantidade de membros",
      "MEMBERS_VARIATION": "Variação desde o último DU",
      "MONEY_DIVIDER": "Moeda",
      "MASS": "Massa monetária",
      "SHARE": "Massa média por membro",
      "UD": "Dividendo Universal",
      "C_ACTUAL": "Crescimento atual",
      "MEDIAN_TIME": "Hora da cadeia de blocos",
      "POW_MIN": "Nivel mínimo de dificuldade de cálculo",
      "MONEY_RULES_DIVIDER": "Regras da moeda",
      "C_RULE": "Crescimento teórico objetivo",
      "UD_RULE": "Cálculo do dividendo universal",
      "DT_REEVAL": "Período de revalorização do DU",
      "REEVAL_SYMBOL": "revalorização",
      "DT_REEVAL_VALUE": "Todos os <b>{{dtReeval|formatDuration}}</b> ({{dtReeval/86400}} {{'COMMON.DAYS'|translate}})",
      "UD_REEVAL_TIME0": "Data da primeira revalorização",
      "SIG_QTY_RULE": "Certificações requeridas para ser membro",
      "SIG_STOCK": "Máximo de certificações que um membro pode emitir",
      "SIG_PERIOD": "Espera mínima entre 2 certificações sucessivas emitidas pelo mesmo indíviduo",
      "SIG_WINDOW": "Limite para ter em conta uma certificação",
      "SIG_VALIDITY": "Duração de uma certificação tida em conta",
      "MS_WINDOW": "Limite para aprovar uma solicitação de membro",
      "MS_VALIDITY": "Duração de um membro aprovado",
      "STEP_MAX": "Distância máxima entre uma nova candidatura e cada membro referente",
      "WOT_RULES_DIVIDER": "Regras da rede de confiança",
      "SENTRIES": "Certificações necessárias para ser membro referente",
      "SENTRIES_FORMULA": "Fórmula das certificações necessárias para ser membro referente",
      "XPERCENT":"Percentagem mínima necessária de membros referentes respeitando a regra de distância máxima",
     "AVG_GEN_TIME": "Tempo médio entre dois blocos",
      "CURRENT": "Atual",
      "MATH_CEILING": "TETO",
      "DISPLAY_ALL_RULES": "Ver todas as regras?",
      "BTN_SHOW_LICENSE": "Ver a licença",
      "WOT_DIVIDER": "Rede de confiança"
    },
    "LICENSE": {
      "TITLE": "Licença da moeda",
      "BTN_DOWNLOAD": "Descarregar o ficheiro",
      "NO_LICENSE_FILE": "Ficheiro de licença não encontrado."
    }
  },
  "NETWORK": {
    "VIEW": {
      "MEDIAN_TIME": "Hora da cadeia de blocos",
      "LOADING_PEERS": "Carregando nós…",
      "NODE_ADDRESS": "Endereço:",
      "SOFTWARE": "Software:",
      "WARN_PRE_RELEASE": "Pré lançamento (última versão estável: <b>{{version}}</b>)",
      "WARN_NEW_RELEASE": "Versão <b>{{version}}</b> disponivel",
      "WS2PID": "ID:",
      "PRIVATE_ACCESS": "Acesso privado",
      "POW_PREFIX": "Prefixo da prova de trabalho:",
      "ENDPOINTS": {
        "BMAS": "Ligação segura (SSL)",
        "BMATOR": "Ligação rede TOR",
        "WS2P": "Ligação WS2P",
        "ES_USER_API": "Nó de dados Cesium+"
      }
    },
    "INFO": {
      "CONNECTING_TO_NETWORK": "A conectar à rede...",
      "ANALYZING_NETWORK": "A analisar a rede {{currency|abbreviate}}...",
      "ONLY_SSL_PEERS": "A visualização de nós sem SSL está deteriorada porque Cesium funciona em modo HTTPS."
    }
  },
  "PEER": {
    "PEERS": "Nós",
    "SIGNED_ON_BLOCK": "Assinado sobre o bloco",
    "MIRROR": "Espelho",
    "MIRRORS": "Espelhos",
    "MIRROR_PEERS": "Nós espelho",
    "PEER_LIST": "Lista de nós",
    "MEMBERS": "Membro",
    "MEMBER_PEERS": "Nós membro",
    "ALL_PEERS": "Todos os nós",
    "DIFFICULTY": "Dificuldade",
    "API": "API",
    "CURRENT_BLOCK": "Bloco #",
    "POPOVER_FILTER_TITLE": "Filtro",
    "OFFLINE": "Desligado",
    "OFFLINE_PEERS": "Nós desligados",
    "BTN_SHOW_PEER": "Ver nó",
    "VIEW": {
      "TITLE": "Nó",
      "OWNER": "Propriedade de",
      "SHOW_RAW_PEERING": "Ver a ficha do par",
      "SHOW_RAW_CURRENT_BLOCK": "Ver o último bloco (formato bruto)",
      "LAST_BLOCKS": "Blocos recetores",
      "KNOWN_PEERS": "Nós conhecidos:",
      "GENERAL_DIVIDER": "Informação geral",
      "ERROR": {
        "LOADING_TOR_NODE_ERROR": "Não foi possível obter informação do nó usando a rede TOR.",
        "LOADING_NODE_ERROR": "Não foi possível obter informação do nó"
      }
    }
  },
  "WOT": {
    "SEARCH_HELP": "Procurar (Pseudónimo ou chave pública)",
    "SEARCH_INIT_PHASE_WARNING": "Durante a etapa de pré inscrição, o tempo de procura das candidaturas em espera <b>pode demorar</b>. Por favor espere…",
    "REGISTERED_SINCE": "Registou-se em",
    "REGISTERED_SINCE_BLOCK": "Registou-se no bloco #",
    "NO_CERTIFICATION": "Nenhuma certificação validada",
    "NO_GIVEN_CERTIFICATION": "Nenhuma certificação emitida",
    "NOT_MEMBER_PARENTHESIS": "(não é membro)",
    "IDENTITY_REVOKED_PARENTHESIS": "(identidade revogada)",
    "MEMBER_PENDING_REVOCATION_PARENTHESIS": "(revogação em processo)",
    "EXPIRE_IN": "Expira em",
    "NOT_WRITTEN_EXPIRE_IN": "Data limite<br/>de processamento",
    "EXPIRED": "Expirado",
    "PSEUDO": "Pseudónimo",
    "SIGNED_ON_BLOCK": "Emitida no bloco #{{block}}",
    "WRITTEN_ON_BLOCK": "Escrita no bloco #{{block}}",
    "GENERAL_DIVIDER": "Informações gerais",
    "NOT_MEMBER_ACCOUNT": "Conta  de não membro",
    "NOT_MEMBER_ACCOUNT_HELP": "Trata-se de uma carteira simples, sem pedido de membro em espera",
    "TECHNICAL_DIVIDER": "Informações técnicas",
    "BTN_CERTIFY": "Certificar",
    "BTN_YES_CERTIFY": "Sim, certificar",
    "BTN_SELECT_AND_CERTIFY": "Nova certificação",
    "ACCOUNT_OPERATIONS": "Transações de conta",
    "VIEW": {
      "POPOVER_SHARE_TITLE": "Identidade {{title}}"
    },
    "LOOKUP": {
      "TITLE": "Diretório",
      "NEWCOMERS": "Novos membros:",
      "NEWCOMERS_COUNT": "{{count}} membros",
      "PENDING": "Inscrições em espera:",
      "PENDING_COUNT": "{{count}} inscrições em espera",
      "REGISTERED": "Inscreveu-se {{sigDate | formatFromNow}}",
      "MEMBER_FROM": "Membro desde {{memberDate|medianFromNowShort}}",
      "BTN_NEWCOMERS": "Membros recentes",
      "BTN_PENDING": "Candidaturas em espera",
      "SHOW_MORE": "Mostrar mais",
      "SHOW_MORE_COUNT": "(mostrar só {{limit}})",
      "NO_PENDING": "Nenhuma candidatura em espera.",
      "NO_NEWCOMERS": "Sem membros."
    },
    "CONTACTS": {
      "TITLE": "Contactos"
    },
    "MODAL": {
      "TITLE": "Procurar"
    },
    "CERTIFICATIONS": {
      "TITLE": "{{uid}} - Certificações",
      "SUMMARY": "Certificações recebidas",
      "LIST": "Detalhe das certificações recebidas",
      "PENDING_LIST": "Certificações em espera de tratamento",
      "RECEIVED": "Certificações recebidas",
      "RECEIVED_BY": "Certificações recebidas por {{uid}}",
      "ERROR": "Certificações recebidas por engano",
      "SENTRY_MEMBER": "Membro referente"
    },
    "OPERATIONS": {
      "TITLE": "{{uid}} - Transacções"
    },
    "GIVEN_CERTIFICATIONS": {
      "TITLE": "{{uid}} - Certificações emitidas",
      "SUMMARY": "Certificações emitidas",
      "LIST": "Detalhe das certificações emitidas",
      "PENDING_LIST": "Certificações à espera para serem processadas",
      "SENT": "Certificações emitidas",
      "SENT_BY": "Certificações emitidas por {{uid}}",
      "ERROR": "Certificações emitidas por engano"
    }
  },
  "LOGIN": {
    "TITLE": "<i class=\"icon ion-locked\"></i> Conexão",
    "SCRYPT_FORM_HELP": "Introduza as suas credenciais.<br>Lembre-se de comprovar que a chave pública pertence à sua conta.",
    "PUBKEY_FORM_HELP": "Por favor introduza uma chave pública de conta:",
    "FILE_FORM_HELP": "Escolha o arquivo de chaves a usar:",
    "SCAN_FORM_HELP": "Digitalize o código QR de uma carteira.",
    "SALT": "Frase secreta",
    "SALT_HELP": "Frase secreta",
    "SHOW_SALT": "Mostrar a frase secreta",
    "PASSWORD": "Contra senha",
    "PASSWORD_HELP": "Contra senha",
    "PUBKEY_HELP": "Chave pública",
    "NO_ACCOUNT_QUESTION": "Ainda não tem conta? ",
    "HAVE_ACCOUNT_QUESTION": "Já tem conta?",
    "CREATE_ACCOUNT": "Criar uma conta",
    "CREATE_FREE_ACCOUNT": "Criar uma conta grátis",
    "FORGOTTEN_ID": "Esqueceu-se da sua contra senha?",
    "ASSOCIATED_PUBKEY": "Chave pública do arquivo de chaves:",
    "BTN_METHODS": "Outros métodos",
    "BTN_METHODS_DOTS": "Outras vias…",
    "METHOD_POPOVER_TITLE": "Métodos",
    "MEMORIZE_AUTH_FILE": "Memorizar as chaves durante a sessão de navegação",
    "SCRYPT_PARAMETERS": "Definições (Scrypt) :",
    "AUTO_LOGOUT": {
      "TITLE": "Informação",
      "MESSAGE": "<i class=\"ion-android-time\"></i> <b>desconectou-se</b> de forma automática, depois de um período de inatividade prolongada.",
      "BTN_RELOGIN": "Voltar a conectar-me",
      "IDLE_WARNING": "Será desconectado em… {{countdown}}"
    },
    "METHOD": {
      "SCRYPT_DEFAULT": "Standard (por defeito)",
      "SCRYPT_ADVANCED": "Aleatoriamente",
      "FILE": "Arquivo de chaves",
      "PUBKEY": "Chave pública ou Pseudónimo",
      "SCAN": "Digitalizar um código QR"
    },
    "SCRYPT": {
      "SIMPLE": "Simples",
      "DEFAULT": "Predeterminado",
      "SECURE": "Seguro",
      "HARDEST": "Maior segurança",
      "EXTREME": "Segurança Extrema",
      "USER": "Personalizado",
      "N": "N (Loop):",
      "r": "r (RAM):",
      "p": "p (CPU):"
    },
    "FILE": {
      "HELP": "Formato de arquivo esperado: <b>.yml</b> o <b>.dunikey</b> (tipo PubSec, WIF o EWIF)."
    }
  },
  "API": {
    "COMMON": {
        "CONNECTION_ERROR": "Nó <b>{{server}}</b> inacessível ou endereço inválido.<br/><br/>Verifique a sua conexão à Internet, ou contacte a administração do sitio.</a>.",
        "LINK_DOC": "Documentação API",
        "LINK_DOC_HELP": "Documentação para desenvolvedores",
        "LINK_STANDARD_APP": "Versão clássica",
        "LINK_STANDARD_APP_HELP": "Abrir a versão clássica de {{'COMMON.APP_NAME'|translate}}"
    },
    "DOC": {
        "AVAILABLE_PARAMETERS": "Lista de parâmetros disponíveis :",
        "DEMO_CANCELLED": "<i class=\"icon ion-close\"></i> Cancelado pelo usuário",
        "DEMO_DIVIDER": "Testar",
        "DEMO_HELP": "Para testar este serviço, faça clique neste botão. O resultado será mostrado abaixo.",
        "DEMO_RESULT": "Resultado retornado pela chamada :",
        "DEMO_RESULT_PEER": "Endereço do nó utilizado :",
        "DEMO_SUCCEED": "<i class=\"icon ion-checkmark\"></i> Sucesso!",
        "DESCRIPTION_DIVIDER": "Descrição",
        "INTEGRATE_CODE": "Código :",
        "INTEGRATE_DIVIDER": "Integrar",
        "INTEGRATE_PARAMETERS": "Parâmetros",
        "INTEGRATE_RESULT": "Pré-visualização do resultado :",
        "PARAMETERS_DIVIDER": "Parâmetros",
        "TRANSFER": {
            "DESCRIPTION": "A partir de um sítio web (ex: loja online) pode delegar o pagamento em moeda livre com a API de Cesium. Para isso, simplesmente ponha um link no seguinte endereço:",
            "EXAMPLE_BUTTON": "Botão HTML",
            "EXAMPLE_BUTTON_BG_COLOR": "Cor de fundo",
            "EXAMPLE_BUTTON_BG_COLOR_HELP": "Exemplo : #fbc14c, black, lightgrey, rgb(180,180,180)",
            "EXAMPLE_BUTTON_DEFAULT_STYLE": "Estilo personalizado",
            "EXAMPLE_BUTTON_DEFAULT_TEXT": "Pagar em {{currency|currencySymbol}}",
            "EXAMPLE_BUTTON_FONT_COLOR": "Cor do texto",
            "EXAMPLE_BUTTON_FONT_COLOR_HELP": "Exemplo : black, orange, rgb(180,180,180)",
            "EXAMPLE_BUTTON_ICON_CESIUM": "Logo Cesium",
            "EXAMPLE_BUTTON_ICON_DUNITER": "Logo Duniter",
            "EXAMPLE_BUTTON_ICON_G1_BLACK": "Logo Ğ1 (negro)",
            "EXAMPLE_BUTTON_ICON_G1_COLOR": "Logo Ğ1",
            "EXAMPLE_BUTTON_ICON_NONE": "Nenhum",
            "EXAMPLE_BUTTON_TEXT_HELP": "Texto do botão",
            "EXAMPLE_BUTTON_TEXT_ICON": "Icon",
            "EXAMPLE_BUTTON_TEXT_WIDTH": "Largura",
            "EXAMPLE_BUTTON_TEXT_WIDTH_HELP": "Exemplo : 200px, 50%",
            "EXAMPLES_HELP": "Exemplos de integração :",
            "PARAM_AMOUNT": "Quantia",
            "PARAM_AMOUNT_HELP": "Quantia da transação (obrigatório). Valores múltiplos permitidos utilizando um separador (ponto e vírgula, barra vertical ou espaço).",
            "PARAM_CANCEL_URL": "Endereço web de cancelamento",
            "PARAM_CANCEL_URL_HELP": "Endereço web (URL) em caso de anulação do pagamento por parte do usuário. Pode conter as seguintes palavras que serão substituídas pelos seus valores dinamicamente em cada caso: \"{comment}\", \"{amount}\" y \"{pubkey}\".",
            "PARAM_COMMENT": "Conceito (ou comentário)",
            "PARAM_COMMENT_HELP": "Conceito ou comentário. Permitirá por exemplo identificar o pagamento na cadeia de blocos (blockchain).",
            "PARAM_NAME": "Nome (do destinatário ou do seu endereço web)",
            "PARAM_NAME_HELP": "O nome do destinatário, ou do seu endereço web. Pode ser um nome legível (\"Minha Loja online\"), ou um domínio (\"Lojaonline.com\").",
            "PARAM_PREFERRED_NODE": "Endereço do nó preferido",
            "PARAM_PREFERRED_NODE_HELP": "Endereço (URL) do nó Duniter a utilizar preferencialmente (\"g1.domaine.com:443\" ou \"https://g1.domaine.com\").",
            "PARAM_PUBKEY": "Chave pública do destinatário",
            "PARAM_PUBKEY_HELP": "A chave pública do destinatário (obrigatória)",
            "PARAM_REDIRECT_URL": "Endereço web de redirecionamento",
            "PARAM_REDIRECT_URL_HELP": "Endereço web (URL) de redirecionamento, chamada quando o pagamento tenha sido enviado. Pode conter as palavras seguintes, que serão substituídas pelos valores da transação dinamicamente : \"{tx}\", \"{hash}\", \"{comment}\", \"{amount}\", \"{pubkey}\" y \"{node}\".",
            "TITLE": "Pagamentos"
        },
        "URL_DIVIDER": "Endereço de chamada"
    },
    "HOME": {
        "DOC_HEADER": "Serviços disponíveis :",
        "MESSAGE": "Bem vindo/a a <b>documentação da API</b> {{'COMMON.APP_NAME'|translate}}.<br/>Conecte os seus sites web à cadeia de blocos <a href=\"http://duniter.org\" target=\"_system\">Duniter</a> facilmente !",
        "MESSAGE_SHORT": "Conecte os seus sites a <a href=\"http://duniter.org\" target=\"_system\">Duniter</a> facilmente !",
        "TITLE": "Documentação API {{'COMMON.APP_NAME'|translate}}"
    },
    "TRANSFER": {
        "AMOUNT": "Quantia :",
        "AMOUNTS_HELP": "Escolha a quantia :",
        "COMMENT": "Conceito/Comentário da operação :",
        "DEMO": {
            "BAD_CREDENTIALS": "Verifique as suas credenciais.<br/>Em modo de demostração, as credenciais são : {{'API.TRANSFER.DEMO.SALT'|translate}} / {{'API.TRANSFER.DEMO.PASSWORD'|translate}}",
            "HELP": "<b>Modo de demostração</b> : Nenhum pagamento será realmente enviado realmente durante esta simulação.<br/>Utilize as credenciais : <b>{{'API.TRANSFER.DEMO.SALT'|translate}} / {{'API.TRANSFER.DEMO.PASSWORD'|translate}}</b>",
            "PASSWORD": "demo",
            "PUBKEY": "3G28bL6deXQBYpPBpLFuECo46d3kfYMJwst7uhdVBnD1",
            "SALT": "demo"
        },
        "ERROR": {
            "TRANSFER_FAILED": "Erro no pagamento"
        },
        "INFO": {
            "CANCEL_REDIRECTING": "Pagamento cancelado.<br/>Redirecionando para o site do vendedor...",
            "CANCEL_REDIRECTING_WITH_NAME": "Pagamento cancelado.<br/>Redirecionando para <b>{{name}}</b>...",
            "SUCCESS_REDIRECTING": "Pagamento enviado.<br/>Redirecionando para o site do vendedor...",
            "SUCCESS_REDIRECTING_WITH_NAME": "Pagamento enviado.<br/>Redirecionando para <b>{{name}}</b>..."
        },
        "NAME": "Nome :",
        "NODE": "Endereço do nó :",
        "PUBKEY": "Chave pública do destinatário :",
        "SUMMARY": "Resumo do pagamento :",
        "TITLE": "{{'COMMON.APP_NAME'|translate}} - Pagamento online",
        "TITLE_SHORT": "Pagamento online"
    }
  },
  "AUTH": {
    "TITLE": "<i class=\"icon ion-locked\"></i> Autenticação",
    "BTN_AUTH": "Autenticar",
    "GENERAL_HELP": "Por favor, autentique-se:",
    "EXPECTED_UID_HELP": "Por favor inicie sessão na conta de <i class=\"ion-person\"></i> {{uid}}:",
    "EXPECTED_PUBKEY_HELP": "Por favor, autentique-se na carteira <br class=\"visible-xs\"/><i class=\"ion-key\"></i> {{pubkey|formatPubkey}} :",
    "SCAN_FORM_HELP": "Digitalize o código QR da <b>chave privada</b> da carteira."
  },
  "ACCOUNT": {
    "TITLE": "Minha conta",
    "BALANCE": "Saldo",
    "LAST_TX": "Últimas transações validadas",
    "BALANCE_ACCOUNT": "Saldo da conta",
    "NO_TX": "Nenhuma transação",
    "SHOW_MORE_TX": "Mostrar mais",
    "SHOW_ALL_TX": "Mostrar tudo",
    "TX_FROM_DATE": "(mostrar apenas {{fromTime|medianFromNowShort}})",
    "OUT_DISTANCED": "As suas certificações recebidas proveem de um grupo demasiado isolado da <a ng-click=\"showHelpModal('wot')\">Rede de Confiança</a> (RdC) : a <a ng-click=\"showHelpModal('distance_rule')\">regra de distancia máxima</a> não se cumpre.<br/>Deverá obter certificações provenientes de outros sectores da RdC, ou esperar que esta estreite os seus vínculos.",
    "PENDING_TX": "Transações pendentes",
    "VALIDATING_TX": "Transações validadas",
    "ERROR_TX": "Transações não efetuadas",
    "ERROR_TX_SENT": "Transações efetuadas falhadas",
    "PENDING_TX_RECEIVED": "Transações em espera de receção",
    "EVENTS": "Eventos",
    "WAITING_MEMBERSHIP": "Solicitação de membro emitida. Em espera de ser aceite.",
    "WAITING_CERTIFICATIONS": "Deve obter {{needCertificationCount}} certificação(ões) para ser membro.",
    "WAITING_CERTIFICATIONS_HELP": "Para obter as suas certificações, solicite-as unicamente a membros <b>que o conheçam bem (e fisicamente)</b>, como exige <a ng-click=\"showLicenseModal()\">a licença da moeda</a> que você aceitou.<br/>Se não conhece membros suficientes, indique-o no <a ng-click=\"openLink($event, $root.settings.userForumUrl)\">fórum</a> para que se conheçam fisicamente ou para assistir a algum encontro.",
    "WILL_MISSING_CERTIFICATIONS": "Brevemente <b>terá certificações em falta</b> (pelo menos {{willNeedCertificationCount}} são necessárias)",
    "WILL_NEED_RENEW_MEMBERSHIP": "A sua adesão como membro <b>irá expirar {{membershipExpiresIn|formatDurationTo}}</b>. Pense em <a ng-click=\"doQuickFix('renew')\">renovar a sua adesão</a> entretanto.",
    "NEED_RENEW_MEMBERSHIP": "Já não é membro porque a sua adesão <b> expirou</b>. Pense em <a ng-click=\"doQuickFix('renew')\">renovar a sua adesão</a>.",
    "NEED_RENEW_MEMBERSHIP_AFTER_CANCELLED": "já não é membro da moeda, <b>por falta de certificações</b>. Considere <a ng-click=\"doQuickFix('renew')\">renovar a sua adesão</a>.",
    "NO_WAITING_MEMBERSHIP": "Não há adesão membro em espera. Se deseja <b>converter-se em membro</b>, por favor <a ng-click=\"doQuickFix('membership')\">envie a sua adesão como membro</a>.",
    "CERTIFICATION_COUNT": "Certificações recebidas",
    "CERTIFICATION_COUNT_SHORT": "Certificações",
    "SIG_STOCK": "Certificações emitidas",
    "BTN_RECEIVE_MONEY": "Receber",
    "BTN_SELECT_ALTERNATIVES_IDENTITIES": "Mudar de identidade…",
    "BTN_FIX_MEMBERSHIP": "Reenviar candidatura…",
    "BTN_MEMBERSHIP_RENEW": "Renovação de membro",
    "BTN_MEMBERSHIP_RENEW_DOTS": "Renovação de membro…",
    "BTN_MEMBERSHIP_OUT_DOTS": "Cancelar de membro…",
    "BTN_SECURITY_DOTS": "Conta e segurança…",
    "BTN_SHOW_DETAILS": "Publicar a informação técnica",
    "LOCKED_OUTPUTS_POPOVER": {
      "TITLE": "Quantia bloqueada",
      "DESCRIPTION": "Aqui estão as condições para desbloquear esta quantia:",
      "DESCRIPTION_MANY": "Esta transação esta composta em varias partes, cujas condições de desbloqueio são:",
      "LOCKED_AMOUNT": "Condições da quantia:"
    },
    "NEW": {
      "TITLE": "Registar",
      "INTRO_WARNING_TIME": "Criar uma conta em {{name|capitalize}} é muito simples. Contudo, por favor leve o tempo necessário para o fazer de forma correta (gerar e memorizar bem as credenciais, etc.)",
      "INTRO_WARNING_SECURITY": "Assegure-se de que o dispositivo atual (computador, tablet, telefone) <b>é seguro e de confiança</b>.",
      "INTRO_WARNING_SECURITY_HELP": "Anti-vírus, firewall, sessão protegida por contra senha ou PIN, etc.",
      "INTRO_HELP": "Haga clic en <b>{{'COMMON.BTN_START'|translate}}</b> para iniciar a criação da conta. Será guiado passo a passo.",
      "REGISTRATION_NODE": "O seu registo será gravado através do nó Duniter <b>{{server}}</b>, que logo se transmitirá ao resto do sistema da moeda.",
      "REGISTRATION_NODE_HELP": "Se não confia neste nó, <a ng-click=\"doQuickFix('settings')\">altere as definições</a> de Cesium.",
      "SELECT_ACCOUNT_TYPE": "Escolher o tipo de conta a criar:",
      "MEMBER_ACCOUNT": "Conta membro",
      "MEMBER_ACCOUNT_TITLE": "Criar uma conta membro",
      "MEMBER_ACCOUNT_HELP": "Se ainda não é membro (somente é possível criar uma conta menbro por ser humano).",
      "WALLET_ACCOUNT": "Carteira simples",
      "WALLET_ACCOUNT_TITLE": "Criar uma conta simples",
      "WALLET_ACCOUNT_HELP": "Carteira simples para todos os restantes casos, por exemplo se necessita uma conta suplementar para um projeto, coletivo, para fazer testes, etc.<br/>O Dividendo Universal não será produzido para esta conta.",
      "SALT_WARNING": "Escolha a sua frase secreta.<br/>Será solicitada cada vez que se conectar com esta conta.<br/><br/><b>Conserve bem esta frase secreta</b>.<br/>Em caso de perda, ninguém poderá aceder à sua conta!",
      "PASSWORD_WARNING": "Escolha a sua contra senha.<br/>Será solicitada cada vez que se conectar com esta conta.<br/><br/><b>Conserve bem esta contra senha</b>.<br/>Em caso de perda, ninguém poderá aceder à sua conta!",
      "PSEUDO_WARNING": "Escolha o seu pseudónimo.<br/>Serve para que os outros membros possam encontra-lo mais facilmente.<br/><br/>Não deve conter <b>nem espaços nem caracteres acentuados</b>.<div class='hidden-xs'><br/>Exemplo: <span class='gray'>ManuelMatos, CarlosManuel, etc.</span>",
      "PSEUDO": "Pseudónimo",
      "PSEUDO_HELP": "Pseudónimo",
      "SALT_CONFIRM": "Confirmação",
      "SALT_CONFIRM_HELP": "Confirmação da frase secreta",
      "PASSWORD_CONFIRM": "Confirmação",
      "PASSWORD_CONFIRM_HELP": "Confirmação da contra senha",
      "SLIDE_6_TITLE": "Confirmação:",
      "COMPUTING_PUBKEY": "Cálculo em processo…",
      "LAST_SLIDE_CONGRATULATION": "<b>Parabés!</b> Já introduziu todos os dados necessários.<br/><b>Pode solicitar</b> a criação da sua conta.</b><br/><br/>Para sua informação, a chave pública que se mostra mais abaixo identificará a sua futura conta.<br/>Esta poderá ser comunicada a terceiros para receber pagamentos.",
      "CONFIRMATION_MEMBER_ACCOUNT": "<b class=\"assertive\">Advertência:</b> a frase secreta, a contra senha e o seu pseudónimo não poderão ser modificados.<br/><b>Assegure se sempre de memorizá-los!</b><br/><br/><b>Deseja</b> solicitar a inscrição?",
      "CONFIRMATION_WALLET_ACCOUNT": "<b class=\"assertive\">Advertência:</b> a frase secreta, a contra senha e o seu pseudónimo não poderão ser modificados.<br/><b>Assegure se sempre de recordá los!</b><br/><br/><b>Deseja</b> continuar?",
      "CHECKING_PSEUDO": "Verificando…",
      "PSEUDO_AVAILABLE": "Este nome está disponível",
      "PSEUDO_NOT_AVAILABLE": "Este nome de usuário não está disponível",
      "INFO_LICENSE": "Para se juntar à moeda, pedimos lhe que leia e aceite esta licença.",
      "BTN_ACCEPT": "Aceito",
      "BTN_ACCEPT_LICENSE": "Aceito a licença"
    },
    "POPUP_REGISTER": {
      "TITLE": "Escolha o seu pseudónimo",
      "HELP": "Um pseudónimo é obrigatório para ser membro."
    },
    "SELECT_IDENTITY_MODAL": {
      "TITLE": "Seleção de identidade",
      "HELP": "Foram enviadas varias <b>identidades diferentes</b> para a chave pública <span class=\"gray\"><i class=\"ion-key\"></i>{{pubkey | formatPubkey}}</span>.<br/>Por favor, selecione a pasta para usar:"
    },
    "SELECT_WALLET_MODAL": {
      "TITLE": "Seleção de carteira"
    },
    "CERTIFICATION_MODAL": {
      "CHECKLIST_TITLE": "Lista de verificação antes da certificação",
      "INFOS": "A segurança da moeda Ğ1 depende de cada membro. Antes de certificar a identidade dessa pessoa, você deve realizar algumas verificações. Por favor, responda às seguintes perguntas:",
      "BTN_ALL_CHECK": "Certificar",
      "CHECKLIST_CONDITIONS_NOT_MET": "A certificação não foi enviada. As verificações parecem insuficientes. Por favor, verifique novamente cada ponto com a pessoa a ser certificada.",
      "QUESTIONS": {
        "WELL_KNOWN": "<b>Você conhece bem</b> a pessoa que está prestes a certificar? Você conhece outras pessoas que também a conhecem bem?",
        "REVOCATION": "Essa pessoa baixou seu <b>documento de revogação</b> e sabe onde encontrá-lo?",
        "CONTACT": "Você <b>entrou em contato</b> com essa pessoa por vários meios e ela respondeu?",
        "DOUBLE_IDENTITY": "A pessoa deve possuir <b>apenas uma identidade de membro ativa</b>. Você acha que ela possui outra?",
        "MASTER_ACCOUNT": "Essa pessoa possui controle sobre sua conta e já <b>enviou dinheiro de sua conta</b> pelo menos uma vez?",
        "LICENSE": "Essa pessoa <b>entendeu a licença</b> do Duniter e concorda em cumpri-la para futuras certificações?",
        "CREDENTIALS": "A conta foi criada com um <b>ID/senha longos e complexos</b> (frases secretas)? Essa pessoa entende que tanto o ID quanto a senha devem permanecer em segredo? Ela tem certeza de que se lembrará deles ou conseguirá encontrá-los?",
        "PUBLIC_KEY_DIFFERENT": "A <b>chave pública</b> mostrada deve ser <b>idêntica</b> àquela que a pessoa lhe deu. As chaves públicas são <b>diferentes</b>?"
      },
      "REMINDER_TITLE": "Lembrete",
      "SHORT_LICENSE_REMINDER": "Você pode lembrar à pessoa certificada dos parâmetros de certificação:<br/><br/><ul><li> - Cada membro pode certificar no máximo 100 identidades.</li><li> - As certificações são salvas com um intervalo de 5 dias.</li><li> - Uma nova identidade deve reunir pelo menos 5 certificações em menos de 2 meses.</li><li> - Um membro deve renovar sua associação pelo menos uma vez por ano.</li><li> - As certificações têm validade de dois anos.</li></ul>"
    },
    "WALLET_LIST": {
      "IMPORT_MODAL": {
        "HELP": "Para <b>importar carteiras</b>, faça clique para selecionar ou arraste na zona abaixo o arquivo com a lista de carteiras.",
        "NO_NEW_WALLET": "Nenhuma carteira nova",
        "TITLE": "Importar carteiras",
        "WALLET_COUNT": "<b>{{count}}</b> nova{{count > 1 ? 's' : ''}} carteira{{count > 1 ? 's' : ''}}"
      },
      "TITLE": "Minhas carteiras",
      "BTN_NEW": "Adicionar uma carteira",
      "BTN_DOWNLOAD": "Descarregue a lista",
      "BTN_IMPORT_FILE_DOTS": "Importar a partir de ficheiro…",
      "NO_WALLET": "Sem carteira secundaria",
      "BTN_DELETE": "Eliminar una carteira secundaria…",
      "BTN_RENAME": "Renomear a carteira",
      "EXPORT_FILENAME": "carteiras-{{pubkey|formatPubkey}}-{{currency}}.csv",
      "TOTAL_DOTS": "Total : ",
      "EDIT_POPOVER": {
        "TITLE": "Renomear a carteira",
        "HELP": "Escreva o novo nome",
        "NAME_HELP": "Nome da carteira"
      }
    },
    "SECURITY": {
      "KEYFILE": {
        "ERROR": {
            "BAD_CHECKSUM": "Soma de controlo (checksum) incorreta",
            "BAD_PASSWORD": "Frase secreta incorreta"
        },
        "EWIF_FORMAT": "Formato EWIF (Encrypted Wallet Import Format) - v1",
        "EWIF_FORMAT_HELP": "Este formato armazena o seu arquivo de chaves <b>de forma cifrada</b> a partir de uma frase secreta à sua escolha. Também guarda una soma de controlo (checksum) para verificar a integridade do arquivo.<br/><b>Atenção :</b>Assegure se sempre de memorizar a sua frase secreta!",
        "PASSWORD_POPUP": {
            "HELP": "Indique a frase secreta :",
            "PASSWORD_HELP": "Frase secreta",
            "TITLE": "Arquivo de chaves cifrado"
        },
        "PUBSEC_FORMAT": "Formato PubSec",
        "PUBSEC_FORMAT_HELP": "Este formato armazena o seu arquivo de chaves de forma simples. É compatível com Cesium, ğannonce y Duniter.<br/><b>Atenção :</b>O arquivo <b>não está cifrado</b> (a chave privada aparece em claro) ; guarde o em lugar seguro!",
        "WIF_FORMAT": "Formato WIF (Wallet Import Format) - v1",
        "WIF_FORMAT_HELP": "Este formato armazena o seu arquivo de chaves com uma soma de controlo (checksum) para verificar a integridade do arquivo. É compatível com as carteiras em papel (Duniter paper wallet).<br/><b>Atenção :</b>O arquivo <b>não está cifrado</b> (a chave privada aparece em claro) ; guarde o em lugar seguro!"
      },
      "ADD_QUESTION": "Adicionar pergunta personalizada",
      "BTN_CLEAN": "Limpar",
      "BTN_RESET": "Reiniciar",
      "DOWNLOAD_REVOKE": "Guardar um arquivo de revogação",
      "DOWNLOAD_REVOKE_HELP" : "Ter um arquivo de revogação é importante, em caso de perda das credenciais. Permitirá <b>invalidar e retirar a sua conta membro da Rede de Confiança</b>, convertendo a em carteira simples.",
      "RECOVER_ID_SELECT_FILE": "Escolha o <b>arquivo para salvaguardar as suas credenciais</b> a utilizar :",
      "GENERATE_KEYFILE": "Gerar o meu arquivo de chaves…",
      "GENERATE_KEYFILE_HELP": "Gera um arquivo que permitirá autenticar se sem ter que introduzir as credenciais.<br/><b>Cuidado:</b> este arquivo conterá a sua chave secreta; É muito importante conservá-lo em lugar seguro!",
      "KEYFILE_FILENAME": "llavero-{{pubkey|formatPubkey}}-{{currency}}-{{format}}.dunikey",
      "MEMBERSHIP_IN": "Registar como membro…",
      "MEMBERSHIP_IN_HELP": "Permite <b>transformar</b> uma conta de carteira simples <b>numa conta membro</b>, enviando um pedido de membro. Apenas se ainda não possui uma conta membro.",
      "SEND_IDENTITY": "Publicar identidade…",
      "SEND_IDENTITY_HELP": "Permite associar o seu pseudónimo a esta conta, mas <b>sem pedir para ser membro</b>. A validade deste pseudónimo tem um prazo limitado.",
      "HELP_LEVEL": "Escolha <strong> pelo menos {{nb}} perguntas:</strong>",
      "LEVEL": "Nível de segurança",
      "LOW_LEVEL": "Baixo <span class=\"hidden-xs\">(2 perguntas min.)</span>",
      "MEDIUM_LEVEL": "Médio <span class=\"hidden-xs\">(4 perguntas min.)</span>",
      "QUESTION_1": "Qual o nome do seu melhor amigo da adolescência?",
      "QUESTION_2": "Como se chamava o seu primeiro animal de estimação?",
      "QUESTION_3": "Qual o primeiro prato que aprendeu a cozinhar?",
      "QUESTION_4": "Qual foi o primeiro filme que viu no cinema?",
      "QUESTION_5": "Qual foi o destino do seu primeiro voo de avião?",
      "QUESTION_6": "Como se chamava o seu professor(a) na escola primaria?",
      "QUESTION_7": "Qual seria para a si a melhor profissão?",
      "QUESTION_8": "Qual o seu livro infantil preferido?",
      "QUESTION_9": "Qual era o modelo do seu primeiro Veículo?",
      "QUESTION_10": "Qual o seu sobrenome durante a infância?",
      "QUESTION_11": "Qual foi a sua personagem ou ator/atriz preferido/a quando era estudante?",
      "QUESTION_12": "Qual foi o seu cantor ou grupo preferido quando era estudante?",
      "QUESTION_13": "Em que cidade se conheceram os seus pais?",
      "QUESTION_14": "Como se chamava o seu primeiro chefe/a?",
      "QUESTION_15": "Como se chama a rua onde cresceu?",
      "QUESTION_16": "Qual o nome da primeira praia onde tomou banho?",
      "QUESTION_17": "Qual foi o primeiro álbum que comprou?",
      "QUESTION_18": "Qual é a sua equipa desportiva preferida?",
      "QUESTION_19": "Qual foi a profissão do seu avô?",
      "RECOVER_ID": "Recuperar as suas credenciais",
      "REVOCATION_WITH_FILE": "Revogar uma identidade a partir de um ficheiro",
      "REVOCATION_WITH_FILE_DESCRIPTION": "Se perdeu de forma permanente as credenciais da sua conta de membro (ou a segurança da conta foi comprometida), pode usar <b>o arquivo de revogação da conta</b> para forçar a saída da Rede de Confiança.",
      "REVOCATION_WITH_FILE_HELP": "Para <b>revogar permanentemente</b> uma conta de membro, arraste o arquivo de revogação no quadro seguinte ou faça clique no quadro para selecionar um arquivo.",
      "REVOCATION_FILENAME": "revogação-{{uid}}-{{pubkey|formatPubkey}}-{{currency}}.txt",
      "REVOCATION_WALLET": "Revogar esta identidade",
      "SAVE_ID": "Guardar as minhas credenciais",
      "STRONG_LEVEL": "Alto <span class=\"hidden-xs \">(6 perguntas min.)</span>",
      "TITLE": "Conta e segurança",
      "RECOVER_ID_HELP": "Se possui um <b>arquivo de recuperação das suas credenciais</b>, pode recuperá-las respondendo corretamente às perguntas pessoais escolhidas por si.",
      "REVOCATION_WALLET_HELP": "Pedir a revogação da sua identidade acarreta a <b>saída da rede de confiança</b> (definitiva para o seu pseudónimo e a chave pública associada). A conta não produzirá mais o Dividendo Universal.<br/>Poderá continuar a usar carteira simples.",
      "SAVE_ID_HELP": "Criação de um arquivo de recuperação, para <b>recuperar a sua contra senha</b> (e frase secreta) em caso de esquecimento. O arquivo <b>cifra-se</b> com a ajuda das perguntas pessoais escolhidas."
    },
    "FILE_NAME": "{{currency}}_HistoricoDaConta_{{pubkey|formatPubkey}}_{{currentTime|formatDateForFile}}.csv",
    "HEADERS": {
      "TIME": "Data",
      "AMOUNT": "Quantia",
      "COMMENT": "Comentário"
    }
  },
  "TRANSFER": {
    "TITLE": "Transferência",
    "SUB_TITLE": "Fazer uma transferência",
    "FROM": "De",
    "TO": "Para",
    "AMOUNT": "Quantia",
    "AMOUNT_HELP": "Quantia",
    "COMMENT": "Comentário",
    "COMMENT_HELP": "Comentário",
    "BTN_SEND": "Enviar",
    "BTN_ADD_COMMENT": "Acrescentar um comentário",
    "REST": "Resto de conta",
    "REST_TO": "a",
    "WARN_COMMENT_IS_PUBLIC": "Tenha em conta que os <b>comentários são públicos</b> (sem encriptar).",
    "MODAL": {
      "TITLE": "Transferência"
    }
  },
  "ERROR": {
    "ADD_SECONDARY_WALLET_FAILED": "Falha ao adicionar carteira secundária.",
    "COULD_NOT_ADD_EXISTING_WALLET": "A carteira já existe na lista.",
    "COULD_NOT_ADD_MAIN_WALLET": "Esta carteira <b>corresponde à conta principal</b> com que se conecta.<br/>Impossível adicionar como carteira secundária.",
    "ISSUE_524_TX_FAILED": "Falha na transferência.<br/><br/>Uma mensagem foi enviada aos/as desenvolvedores/as para facilitar a resolução do problema. <b>Gratos pela sua ajuda</b>.",
    "LOAD_WALLET_LIST_FAILED": "Falha ao carregar as carteiras secundárias.",
    "ONLY_MEMBER_OR_WAS_MEMBER_CAN_EXECUTE_THIS_ACTION": "Você deve <b>ser membro (ou ter sido membro)</b> para poder efetuar esta ação.",
    "RESTORE_WALLET_LIST_FAILED": "Falha na restauração das carteiras secundarias.",
    "SAVE_WALLET_LIST_FAILED": "Falha ao guardar as carteiras secundarias.",
    "UNKNOWN_WALLET_ID": "Carteira secundaria desconhecida.",
    "UPDATE_WALLET_LIST_FAILED": "Falha na atualização das carteiras secundarias.",
    "UNKNOWN_URI_FORMAT": "Formato URI desconhecido",
    "PUBKEY_INVALID_CHECKSUM": "Chave pública inválida (soma de controlo incorreta).",
    "POPUP_TITLE": "Erro",
    "UNKNOWN_ERROR": "Erro desconhecido",
    "TIMEOUT_REACHED": "Tempo de espera do nó excedido ({{timeout|formatDurationMs}}).<br/><br/><small>{{url}}</small>",
    "CRYPTO_UNKNOWN_ERROR": "O seu navegador parece incompatível com as funcionalidades de criptografia.",
    "DOWNLOAD_KEYFILE_FAILED": "Falha ao gerar o arquivo de chaves.",
    "EQUALS_TO_PSEUDO": "Deve ser diferente do seu pseudónimo.",
    "EQUALS_TO_SALT": "Deve ser diferente da frase secreta.",
    "FIELD_REQUIRED": "Campo obrigatório.",
    "FIELD_TOO_SHORT": "Valor demasiado curto.",
    "FIELD_TOO_SHORT_WITH_LENGTH": "Valor demasiado curto ({{minLength}} caracteres mín)",
    "FIELD_TOO_LONG": "Valor demasiado longo",
    "FIELD_TOO_LONG_WITH_LENGTH": "Valor demasiado longo, ({{maxLength}} carácteres máx)",
    "FIELD_MIN": "Valor mínimo: {{min}}",
    "FIELD_MAX": "Valor máximo: {{max}}",
    "FIELD_ACCENT": "Caracteres acentuados e pontuação não estão autorizados",
    "FIELD_NOT_NUMBER": "Valor numérico esperado",
    "FIELD_NOT_INT": "Valor inteiro esperado",
    "FIELD_NOT_EMAIL": "Correio eletrónico inválido",
    "PASSWORD_NOT_CONFIRMED": "Não coincide com a contra senha anterior.",
    "SALT_NOT_CONFIRMED": "Não corresponde à frase secreta anterior.",
    "SEND_IDENTITY_FAILED": "Erro da inscrição.",
    "SEND_CERTIFICATION_FAILED": "Erro da certificação.",
    "NEED_MEMBER_ACCOUNT_TO_CERTIFY": "Não se pode certificar, porque a sua conta não <b>é de membro</b>.",
    "NEED_MEMBER_ACCOUNT_TO_CERTIFY_HAS_SELF": "Não se pode certificar, porque a sua conta ainda não é de membro.<br/><br/>Ainda faltam certificações para o ser.",
    "IDENTITY_TO_CERTIFY_HAS_NO_SELF": "Esta conta não se pôde certificar. Não foi efetuado o pedido de membro, ou necessita renovação.",
    "LOGIN_FAILED": "Falha durante a autenticação.",
    "LOAD_IDENTITY_FAILED": "Erro ao carregar a identidade.",
    "LOAD_REQUIREMENTS_FAILED": "Erro ao carregar as condições da identidade.",
    "SEND_MEMBERSHIP_IN_FAILED": "Erro na tentativa de entrada na comunidade.",
    "SEND_MEMBERSHIP_OUT_FAILED": "Erro na interrupção de adesão.",
    "REFRESH_WALLET_DATA": "Falha na atualização da carteira.",
    "GET_CURRENCY_PARAMETER": "Falha na recuperação das regras da moeda.",
    "GET_CURRENCY_FAILED": "Carregamento da moeda impossível. Por favor, tente mais tarde.",
    "SEND_TX_FAILED": "Falha na transferência.",
    "ALL_SOURCES_USED": "Por favor, espere o cálculo do bloco seguinte (Todas as suas fontes de moeda foram utilizadas).",
    "NOT_ENOUGH_SOURCES": "Não há disponibilidade para enviar esta quantia numa  transação unica.<br/>Importe máximo: {{amount}} {{unit}}<sub>{{subUnit}}</sub>.",
    "ACCOUNT_CREATION_FAILED": "Falha na criação de conta membro.",
    "RESTORE_WALLET_DATA_ERROR": "Falha ao carregar as definições a partir do armazenamento local",
    "LOAD_WALLET_DATA_ERROR": "Falha ao carregar os dados da carteira.",
    "COPY_CLIPBOARD_FAILED": "Copia do valor impossível.",
    "TAKE_PICTURE_FAILED": "Falha na recuperação da foto.",
    "SCAN_FAILED": "Falha ao digitalizar o Código QR",
    "SCAN_UNKNOWN_FORMAT": "Código não reconhecido.",
    "WOT_LOOKUP_FAILED": "Falha na procura",
    "LOAD_PEER_DATA_FAILED": "Leitura do nó Duniter impossível. Por favor, tente mais tarde.",
    "NEED_LOGIN_FIRST": "Por favor, conecte-se primeiro.",
    "AMOUNT_REQUIRED": "A Quantia é obrigatória.",
    "AMOUNT_NEGATIVE": "Quantia negativa não autorizado.",
    "NOT_ENOUGH_CREDIT": "Crédito insuficiente.",
    "INVALID_NODE_SUMMARY": "Nó não localizado ou endereço inválido.",
    "INVALID_USER_ID": "O pseudónimo não deve conter espaços nem caracteres especiais ou acentuados.",
    "INVALID_COMMENT": "O campo 'referencia’ não deve conter caracteres acentuados.",
    "INVALID_PUBKEY": "A chave pública não tem o formato esperado.",
    "INVALID_PUBKEY_CHECKSUM": "Soma de controlo inválida.",
    "IDENTITY_REVOKED": "Esta identidade <b>foi revogada</b>. Não pode voltar a convertê-la em membro.",
    "IDENTITY_REVOKED_WITH_TIME": "Esta identidade <b>foi revogada {{revocationTime|medianFromNow}}</b> ({{revocationTime|medianDate}}). Não pode voltar a convertê-la em membro.",
    "IDENTITY_PENDING_REVOCATION": "A <b>revogação desta identidade</b> foi solicitada e encontra-se em espera de tratamento. Pelo que, a certificação está desativada.",
    "IDENTITY_INVALID_BLOCK_HASH": "Este pedido de adesão não é valido (porque o bloco foi anulado pelos nós da rede): este individuo/a deve renovar o seu pedido de adesão <b>antes de</b> estar certificado/a.",
    "IDENTITY_EXPIRED": "A publicação desta identidade está caducada: este individuo/a deve realizar um novo pedido de adesão <b>antes de</b> estar certificado/a.",
    "IDENTITY_SANDBOX_FULL": "O nó Duniter utilizado por Cesium já não pode receber mais novas identidades, porque a fila de espera está cheia.<br/><br/>Por favor, tente mais tarde ou mude de nó (no menu <b>Definições</b>).",
    "IDENTITY_NOT_FOUND": "Identidade não encontrada",
    "IDENTITY_TX_FAILED": "Falha ao carregar as transações da identidade",
    "WOT_PENDING_INVALID_BLOCK_HASH": "Adesão não validada.",
    "WALLET_INVALID_BLOCK_HASH": "O seu pedido de adesão já não está validado (porque o bloco foi anulado pelos nós da rede).<br/>Deve <a ng-click=\"doQuickFix('fixMembership')\">enviar um novo pedido</a> para resolver este problema.",
    "WALLET_IDENTITY_EXPIRED": "A publicação da <b>sua identidade caducou</b>.<br/>Deve <a ng-click=\"doQuickFix('fixIdentity')\">publicar outra vez a sua identidade</a> para resolver este problema.",
    "WALLET_REVOKED": "a sua identidade foi <b>revogada</b>: nem o pseudónimo nem a chave pública poderão ser utilizados no futuro por uma conta membro.",
    "WALLET_HAS_NO_SELF": "A sua identidade deve em primeiro lugar estar publicada, e não estar caducada.",
    "AUTH_REQUIRED": "Autenticação requerida.",
    "AUTH_INVALID_PUBKEY": "A chave pública não corresponde à conta conectada",
    "AUTH_INVALID_SCRYPT": "Usuário ou contra senha inválidos.",
    "AUTH_INVALID_FILE": "arquivo de chave inválido.",
    "AUTH_FILE_ERROR": "Não é possível abrir o arquivo da chave",
    "IDENTITY_ALREADY_CERTIFY": "Já <b>está certificada.</b> esta identidade. <br/><br/>Esta certificação contudo é válida (expiration {{expiresIn|formatDurationTo}}).",
    "IDENTITY_ALREADY_CERTIFY_PENDING": "Já <b>está certificada</b> esta identidade.<br/><br/>Esta certificação encontra se em espera de tratamento (Data limite de tratamento {{expiresIn|formatDurationTo}}).",
    "UNABLE_TO_CERTIFY_TITLE": "Certificação impossível",
    "LOAD_NEWCOMERS_FAILED": "Não foi possível carregar os novos membros.",
    "LOAD_PENDING_FAILED": "Não foi possível carregar as inscrições pendentes.",
    "ONLY_MEMBER_CAN_EXECUTE_THIS_ACTION": "Deve <b>ser membro</b> para poder realizar esta ação.",
    "ONLY_SELF_CAN_EXECUTE_THIS_ACTION": "Deve ter <b>publicado a sua identidade</b> para poder realizar esta ação.",
    "GET_BLOCK_FAILED": "Falha na recuperação do bloco",
    "INVALID_BLOCK_HASH": "Bloco não encontrado (hash diferente)",
    "DOWNLOAD_REVOCATION_FAILED": "Deve selecionar um ficheiro de texto",
    "REVOCATION_FAILED": "Falha na revogação.",
    "SALT_OR_PASSWORD_NOT_CONFIRMED": "Frase secreta o contra senha incorretos",
    "RECOVER_ID_FAILED": "Falha na recuperação das credenciais",
    "LOAD_FILE_FAILED": "Falha ao carregar o arquivo",
    "NOT_VALID_REVOCATION_FILE": "Arquivo de revogação inválido (formato de arquivo errado)",
    "NOT_VALID_SAVE_ID_FILE": "Arquivo inválido (formato de arquivo errado)",
    "NOT_VALID_KEY_FILE": "Arquivo inválido (formato de arquivo errado)",
    "EXISTING_ACCOUNT": "As suas credenciais correspondem a uma conta existente, a <a ng-click=\"showHelpModal('pubkey')\">chave pública</a> é:",
    "EXISTING_ACCOUNT_REQUEST": "Por favor, altere as suas credenciais para que coincidam com uma conta sem uso.",
    "GET_LICENSE_FILE_FAILED": "Falha ao obter o arquivo de licença",
    "CHECK_NETWORK_CONNECTION": "Não foi possível conectar a nenhum nó.<br/><br/><b>Comprove a ligação à Internet</b>.",
    "INVALID_FILE_FORMAT": "Formato de arquivo inválido.",
    "SAME_TX_RECIPIENT": "O destinatário deve ser diferente do emissor."
  },
  "INFO": {
    "POPUP_TITLE": "Informação",
    "CERTIFICATION_DONE": "Certificação enviada",
    "NOT_ENOUGH_CREDIT": "Crédito insuficiente",
    "TRANSFER_SENT": "Transferência enviada",
    "COPY_TO_CLIPBOARD_DONE": "Cópia efetuada",
    "MEMBERSHIP_OUT_SENT": "Anulação enviada",
    "NOT_NEED_MEMBERSHIP": "Já é membro.",
    "IDENTITY_WILL_MISSING_CERTIFICATIONS": "Esta identidade vai necessitar certificações brevemente (pelo menos {{willNeedCertificationCount}}).",
    "IDENTITY_NEED_MEMBERSHIP": "Esta identidade não enviou um pedido de adesão para se converter em membro.",
    "HAS_ALTERNATIVE_IDENTITIES": "Hay <b>identidades múltiplas</b> anexas a esta chave pública. <b>Antes de qualquer certificação</b>, <a ng-click=\"doQuickFix('showSelectIdentities')\">verifique outras identidades</a> para escolher a correta ou comunique com o proprietário da conta.",
    "REVOCATION_SENT": "Revogação enviada",
    "REVOCATION_SENT_WAITING_PROCESS": "A <b>revogação desta identidade</b> foi solicitada e aguarda ser processada.",
    "FEATURES_NOT_IMPLEMENTED": "Esta funcionalidade encontra-se em desenvolvimento.<br/><br/>Porque não <b>contribuir com Cesium</b>, para obtê-la mais rápido? ;)",
    "EMPTY_TX_HISTORY": "Nenhuma operação a exportar",
    "LOADING_PENDING_TX": "Aguarde por favor...<br/><small>(A recuperar operações pendentes)</small>"
  },
  "CONFIRM": {
    "CAN_CONTINUE": "<b>Deseja</b> continuar?",
    "EXIT_APP": "Fechar a aplicação?",
    "FULLSCREEN": "Mostrar a aplicação em ecran inteiro?",
    "ISSUE_524_SEND_LOG": "A transação foi recusada devido a uma anomalia conhecida (ticket #524) mas <b>irreplicável</b>.<br/><br/>Para ajudar os/as desenvolvedores/as a corrigir este erro,  <b>aceita o envio dos logs(registos do programa)</b> ?<br/><small>(nenhum dado confidencial será enviado)</small>.",
    "POPUP_TITLE": "<b>Confirmação</b>",
    "POPUP_WARNING_TITLE": "<b>Advertência</b>",
    "POPUP_SECURITY_WARNING_TITLE": "<i class=\"icon ion-alert-circled\"></i> <b>Advertência de segurança</b>",
    "CERTIFY_RULES_TITLE_UID": "Certificar {{uid}}", "CERTIFY_RULES": "<b class=\"assertive\">NO CERTIFICAR</b> a conta pensa-se que:<br/><br/><ul><li>1.) não corresponde a um ser humano <b>físico e vivo</b>.<li>2.) o seu/sua proprietário/a <b>possui outra conta</b> já certificada.<li>3.) o seu/sua proprietário/a não cumpre (voluntariamente ou não) a regra 1 ou 2 (por exemplo certificando contas fantasma ou duplicadas).</ul><br/><b>Deseja</b> contudo certificar esta identidade?",
    "TRANSFER": "<b>Resumo da transferência</b>:<br/><br/><ul><li> - De: {{from}}</li><li> - Para: <b>{{to}}</b></li><li> - Quantia: <b>{{amount}} {{unit}}</b></li><li> - Comentário: <i>{{comment}}</i></li></ul><br/><b>Deseja realizar esta transferência?</b>",
    "TRANSFER_ALL": "<b>Resumo da transferência</b>:<br/><br/><ul><li> - De: {{from}}</li><li> - Para: <b>{{to}}</b></li><li> - Quantia: <b>{{amount}} {{unit}}</b></li><li> - Comentario: <i>{{comment}}</i></li><br/><li> - Resto: <b>{{restAmount}} {{unit}}</b> para <b>{{restTo}}</b></li></ul><br/><b>Deseja realizar esta transferência?</b>",
    "MEMBERSHIP_OUT": "Esta operação é <b>irreversível</b>.<br/></br/>Deseja <b>anular a sua conta membro</b>?",
    "MEMBERSHIP_OUT_2": "Esta operação é <b>irreversível</b>!<br/><br/>Deseja <b>anular a sua candidatura</b> como membro?",
    "LOGIN_UNUSED_WALLET_TITLE": "Erro de introdução de dados?",
    "LOGIN_UNUSED_WALLET": "As credenciais introduzidas correspondem a uma conta que parece <b>inativa</b>.<br/></br/><b>Quer no entanto continuar com esta conta?</b>",
    "FIX_IDENTITY": "O pseudónimo <b>{{uid}}</b> vai ser publicado novamente, em substituição do antigo que caducou.<br/></br/><b>Deseja</b> continuar?",
    "FIX_MEMBERSHIP": "O seu pedido de adesão como membro vai ser enviado novamente.<br/></br/><b>Deseja</b> continuar?",
    "MEMBERSHIP": "Será enviado o seu pedido de adesão como membro.<br/></br/><b>Deseja</b> continuar?",
    "RENEW_MEMBERSHIP": "A sua adesão como membro será renovada.<br/></br/><b>Deseja</b> continuar?",
    "REVOKE_IDENTITY": "Vai <b>revogar definitivamente esta identidade</b>.<br/><br/>A chave pública e pseudónimo associados <b>jamais poderão ser utilizados</b> (para uma conta membro). <br/><br/><b>Deseja</b> revogar definitivamente esta conta?",
    "REVOKE_IDENTITY_2": "Esta operação é <b>irreversível</b>!<br/><br/>Deseja <b>revogar definitivamente</b> esta conta?",
    "NOT_NEED_RENEW_MEMBERSHIP": "O seu estado de membro não necessita ser renovado atualmente (caducará em {{membershipExpiresIn|formatDuration}}).<br/></br/><b>Confirma</b> querer renovar o seu estado de membro?",
    "SAVE_BEFORE_LEAVE": "Deseja <b>guardar as alterações</b> antes de abandonar a página?",
    "SAVE_BEFORE_LEAVE_TITLE": "Alterações não guardadas",
    "LOGOUT": "Deseja desconectar-se?",
    "USE_FALLBACK_NODE": "Nó <b>{{old}}</b> indisponível ou endereço inválido.<br/><br/>Deseja utilizar temporalmente o nó <b>{{new}}</b>?",
    "USE_SYNC_FALLBACK_NODE": "Nó <b>{{old}}</b> parece estar dessincronizado.<br/><br/>Quer usar temporariamente o nó sincronizado <b>{{new}}</b>?",
    "ENABLE_EXPERT_MODE_TO_CHANGE_NODE": "<b class=\"assertive\">Aviso:</b> Queres <b>alterar manualmente</b> o nó Duniter?<br/><br/>Se continuares:<ul><li> - Será ativado o <b>modo perito</b>;</li><li> - Poderás voltar à seleção automática do nó, simplesmente <b>desativando o modo perito</b>.</li></ul>"
  },
  "DOWNLOAD": {
    "POPUP_TITLE": "<b>Revogação do arquivo</b>",
    "POPUP_REVOKE_MESSAGE": "Para proteger a sua conta, descarregue o <b>documento de revogação de conta</b>. Permitirá cancelar a sua conta (em caso de roubo, alteração de identificadores, conta criada incorretamente, etc.).<br/><br/><b>Por favor, guarde-o em lugar seguro.</b>"
  },
  "HELP": {
    "TITLE": "Ajuda em linha",
    "JOIN": {
      "SECTION": "Inscrição",
      "SALT": "A frase secreta é muito importante. Serve para misturar(<span class=\"text-italic\">hash</span>) a contra senha, antes de calcular a <span class=\"text-italic\">chave pública</span> (o número de conta) e a <span class=\"text-italic\">chave privada</span> para aceder a esta.<br/><b>Por favor, memorize a muito bem</b> porque não existe nenhuma forma de a recuperar em caso de perda.<br/>Não pode ser modificada. Deverá criar uma nova conta se a perde ou se esquece.<br/><br/>Uma boa frase secreta deve ser suficientemente larga (pelo menos 8 caracteres) e o mais original possível.",
      "PASSWORD": "A contra senha é muito importante. Junto com a frase secreta, serve para calcular a chave pública (o número de conta), e a chave privada para aceder a ela.<br/><b>Por favor, memorize a muito bem</b> porque não existe nenhuma forma de a recuperar em caso de perda (exceto se tivesse um ficheiro de suporte ou <span class=\"text-italic\">backup</span>.).<br/>Não pode ser modificada. Deverá criar uma nova conta se a perde ou se esquece.<br/><br/>Uma boa contra senha contem pelo menos 8 carateres, com pelo menos una maiúscula y um dígito.",
      "PSEUDO": "O pseudónimo utiliza se somente em caso de inscrição como <span class=\"text-italic\">membro</span>. Está sempre associado a uma carteira (através da su <span class=\"text-italic\">chave pública</span>).<br/>Este é publicado na rede para que os restantes usuários possam identificar, certificar ou enviar dinheiro para conta.<br/>O  pseudónimo deve ser único para cada membro (atuais e antigos)."
    },
    "LOGIN": {
      "SECTION": "Autenticação",
      "PUBKEY": "Chave pública",
      "PUBKEY_DEF": "A chave pública do arquivo de chaves é gerada a partir das credenciais introduzidas (qualquer que sejam), sem estar obrigatoriamente vinculadas ou contrastadas com nenhuma conta já usada. <br/><b>Assegure-se portanto que a chave pública é a mesma com a que se criou originalmente a sua conta</b>. Caso contrário, será auto gerada uma conta vazia que provavelmente nunca foi usada, já que o risco de coincidir com as credenciais de outra conta alheia é muito pequeno.<br/><a href=\"https://es.wikipedia.org/wiki/Criptograf%C3%ADa_de_curva_el%C3%ADptica\" target=\"_ system\">Conheça mais sobre criptografia</a> com chaves públicas.",
      "METHOD": "Métodos de autenticação",
      "METHOD_DEF": "Diversas opções estão disponíveis para conectar as suas contas: <br/> - A conexão <b>com aleatoriedade (standard ou avançada)</b> mistura a sua contra senha com a sua frase secreta, para limitar as possibilidades de ataque<br/> - A conexão <b>usando chave pública</b> Permite entrar sem credenciais, as quais só serão pedidas quando alguma operação o necessite.<br/> - A conexão <b>usando arquivo de chaves</b> lerá a chave pública e privada da conta de um arquivo sem necessitar das suas credenciais. Vários formatos são possíveis."
    },
    "GLOSSARY": {
      "DISTANCE_RULE": "Regra de distancia",
      "DISTANCE_RULE_DEF": "A regra de distancia da Rede de Confiança define <b>uma distancia máxima a respeitar</b> entre uma candidatura e número mínimo de membros referentes (aqueles mais conectados). Esta distancia é calculada utilizando os enlaces de certificação.",
      "WOT": "Rede de Confiança (RdC)",
      "WOT_DEF": "A Rede de Confiança é composta pelo conjunto de membros da moeda, e dos enlaces de certificações que os conectam.",
      "SECTION": "Glossário",
      "PUBKEY_DEF": "Uma chave pública identifica una carteira, que pode estar associada a um membro ou ser uma carteira anónima. Em Cesium calcula se a partir da frase secreta e da contra senha.",
      "MEMBER": "Membro",
      "MEMBER_DEF": "Cada membro é um ser humano físico e vivo, desejoso de participar livremente na comunidade monetária. Compreende um dividendo universal, de acordo com um período e quantia definido nas <span class=\"text-italic\">regras da moeda</span>",
      "CURRENCY_RULES": "Regras da moeda",
      "CURRENCY_RULES_DEF": "As regras da moeda foram definidas uma vez e para sempre. Estabelecem o funcionamento de la moeda: o cálculo do dividendo universal, a quantidade de certificações necessárias para ser membro, a quantidade máxima de certificações que cada membro pode emitir, etc. <a href=\"#/app/currency\">Ver as regras atuais</a>.<br/> Os seus parâmetros não podem alterar-se graças a uma <span class=\"text-italic\">Cadeia de Blocos</span> que suporta, implementa e verifica a boa aplicação destas regras.",
      "BLOCKCHAIN": "Cadeia de blocos (<span class=\"text-italic\">Blockchain</span>)",
      "BLOCKCHAIN_DEF": "A cadeia de blocos descentralizado, que no caso de Duniter, serve para manter e implementar as <span class=\"text-italic\">regras da moeda</span>.<br/><a href=\"http://duniter.org\" target=\"_system\">Mais informação</a> acerca de Duniter e o funcionamento da sua cadeia de blocos.",
      "UNIVERSAL_DIVIDEND_DEF": "O Dividendo Universal (DU) é a quantidade de moeda co-criada por cada membro, dependendo do período e do cálculo definidos nas <span class=\"text-italic\">regras da moeda</span>.<br/>Em cada período, los membros recebem nas suas contas a mesma quantidade de moeda.<br/><br/>O DU cresce regularmente, para ser justo entre cada membro (atualmente e no futuro), é calculado em função da esperança de vida media, como se demonstra na <span class=\"text-italic\">Teoria Relativa de la Moeda</span> (TRM, de Stéphane Laborde).<br/><a href=\"http://trm.creationmonetaire.info\">Mais informação</a> sobre a TRM e as moedas livres."
    },
    "TIP": {
      "MENU_BTN_CURRENCY": "O menu <b>{{'MENU.CURRENCY'|translate}}</b> permite consultar as <b>regras da moeda</b> e o seu estado.",
      "CURRENCY_WOT": "O <b>número de membros</b> mostra o peso da comunidade e permite <b>seguir a sua evolução</b>.",
      "CURRENCY_MASS": "Siga aqui a <b>quantidade total de moeda</b> existente e a sua <b>distribuição média</b> por membro.<br/><br/>Isto permite avaliar a <b>relevância de uma quantia</b>, em relação ao que <b>possuem os demais</b> nas suas contas (em média).",
      "CURRENCY_UNIT_RELATIVE": "A unidade utilizada (&ldquo;<b>{{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub></b>&rdquo;) significa que as quantias em {{currency|capitalize}} foram divididos entre o valor do <b>Dividendo Universal</b> (DU).<br/><br/><small> Esta unidade é relativa <b>pertinente</b>, porque permanece estável, independente da quantidade de moeda que aumenta constantemente.</small>",
      "CURRENCY_CHANGE_UNIT": "Este botão permite <b>alterar a unidade</b>, para visualizar as quantias <b>diretamente em {{currency|capitalize}}</b> (em vez de &ldquo;<b>{{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub></b>&rdquo;).",
      "CURRENCY_CHANGE_UNIT_TO_RELATIVE": "Este botão permite <b>alterar a unidade</b>, para visualizar as quantias em &ldquo;<b>{{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub></b>&rdquo;, será dizer, relativo ao Dividendo Universal (a quantidade co-produzida por cada membro).",
      "CURRENCY_RULES": "As <b>regras</b> da moeda fixam o seu funcionamento <b>exato e previsível</b>.<br/><br/>É o próprio ADN da moeda, que faz que o seu código monetário seja <b>legível e transparente</b>.",
      "MENU_BTN_NETWORK": "O menu <b>{{'MENU.NETWORK'|translate}}</b> permite consultar o estado da rede.",
      "NETWORK_BLOCKCHAIN": "Todas as transações da moeda estão registadas dentro de um grande livro de contabilidade <b>público e infalsificável</b>, conhecido como a <b>cadeia de blocos</b> (<em>BlockChain</em> em inglês).",
      "NETWORK_PEERS": "Os <b>nós</b> visíveis aqui correspondem aos <b>dispositivos de membros que atualizam e validam</b> a cadeia de blocos.<br/><br/>Quanto mais nós houver conectados, mais a moeda terá uma gestão <b>descentralizada</b> e digna de confiança.",
      "NETWORK_PEERS_BLOCK_NUMBER": "Este <b>número</b> (em verde) indica o <b>último bloco validado</b> por este nó (última página escrita na cadeia de blocos).<br/><br/>A cor verde indica que este bloco também foi validado <b>pela maioria dos restantes nós</b>.",
      "NETWORK_PEERS_PARTICIPATE": "<b>Cada membro</b>, equipado com um dispositivo conectado à Internet, <b>pode contribuir adicionando um nó</b>.  Necessita <b>instalar o programa Duniter</b> (livre e gratuito). <a href=\"{{installDocUrl}}\" target=\"_system\">Ver o manual de usuário &gt;&gt;</a>.",
      "MENU_BTN_ACCOUNT": "<b>{{'ACCOUNT.TITLE'|translate}}</b> permite aceder à gestão e ao histórico da sua conta.",
      "MENU_BTN_ACCOUNT_MEMBER": "Consulte aqui o estado da sua conta e a informação sobre as suas certificações.",
      "WALLET_CERTIFICATIONS": "Clique aqui para consultar em detalhe as suas certificações (recebidas e emitidas).",
      "WALLET_RECEIVED_CERTIFICATIONS": " Clique aqui para consultar em detalhe as suas <b> certificações recebidas</b>.",
      "WALLET_GIVEN_CERTIFICATIONS": " Clique aqui para consultar em detalhe as suas certificações <b> certificações emitidas</b>.",
      "WALLET_BALANCE": "Visualize aqui o <b>saldo</b> da sua conta.",
      "WALLET_BALANCE_RELATIVE":
      "{{'HELP.TIP.WALLET_BALANCE'|translate}}<br/><br/>A unidade utilizada (&ldquo;<b>{{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub></b>&rdquo;) significa que a quantia em {{currency|capitalize}} foi dividida entre o <b>Dividendo Universal</b> (DU) co-produzido por cada membro.<br/><br/>Atualmente um DU vale {{currentUD|formatInteger}} {{currency|capitalize}}s.",
      "WALLET_BALANCE_CHANGE_UNIT": "Poderá <b>alterar a unidade</b> de visualização das quantias em <b><i class=\"icon ion-android-settings\"></i>&nbsp;{{'MENU.SETTINGS'|translate}}</b>.<br/><br/>Por exemplo, para visualizar as quantias <b>diretamente em {{currency|capitalize}}</b>, em vez de unidade relativa.",
      "WALLET_PUBKEY": "Esta é a chave pública da sua conta. Pode comunica-la a terceiros para que possa identificar a sua conta de forma simples.",
      "WALLET_SEND": "Realizar um pagamento em alguns cliques",
      "WALLET_SEND_NO_MONEY": "Realizar um pagamento em alguns cliques.<br/>(O seu saldo já não lhe permite)",
      "WALLET_OPTIONS": "Este botão permite aceder às <b>ações de adesão</b> e de segurança.<br/><br/>Não esqueça de dar uma olhadela!",
      "WALLET_RECEIVED_CERTS": "Aqui se exibirá a lista de indivíduos/as que o certificaram.",
      "WALLET_CERTIFY": "O botão <b>{{'WOT.BTN_SELECT_AND_CERTIFY'|translate}}</b> permite selecionar uma identidade e certifica-la.<br/><br/>Apenas os que são <b>membros</b> podem certificar outros seres humanos.",
      "WALLET_CERT_STOCK": "O seu stock de certificações (emitidas) é limitado a <b>{{sigStock}} certificações</b>.<br/><br/>Este stock renova-se com o tempo, à medida que as certificações caducam.",
      "MENU_BTN_TX": "O menu <b>{{'MENU.TRANSACTIONS'|translate}}</b> permite consultar o seu saldo, o histórico de transações e realizar novos pagamentos.",
      "MENU_BTN_WALLETS": "O menu <b>{{'MENU.WALLETS'|translate}}</b> permite adicionar carteiras complementares que você gere.",
      "MENU_BTN_WOT": "O menu <b>{{'MENU.WOT'|translate}}</b> permite procurar <b>usuários</b> da moeda (membro ou nó).",
      "WOT_SEARCH_TEXT_XS": "Para procurar no diretório, escreva as <b>primeiras letras de um pseudónimo</b> (ou de uma chave pública).<br/><br/>A procura começará automaticamente.",
      "WOT_SEARCH_TEXT": "Para procurar no diretório, escreva as <b>primeiras letras de um pseudónimo</b> (ou de uma chave pública). <br/><br/>Em seguida aperte a tecla <b>Enter</b> para iniciar a procura.",
      "WOT_SEARCH_RESULT": "Visualize a ficha detalhada <b>fazendo clique</b> sobre uma linha.",
      "WOT_VIEW_CERTIFICATIONS": "A opção <b>{{'ACCOUNT.CERTIFICATION_COUNT'|translate}}</b> mostra quais membros validaram esta identidade.<br/><br/>Estas certificações atestam que a conta pertence a <b>um ser humano vivo</b> e que não possui <b>nenhuma outra conta membro</b>.",
      "WOT_VIEW_CERTIFICATIONS_COUNT": "Necessita pelo menos <b>{{sigQty}} certificações</b> para ser membro e receber o <b>Dividendo Universal</b>.",
      "WOT_VIEW_CERTIFICATIONS_CLICK": "Um clique aqui permite abrir <b>a lista de todas as certificações</b> da identidade (recebidas e emitidas).",
      "WOT_VIEW_CERTIFY": "O botão <b>{{'WOT.BTN_CERTIFY'|translate}}</b> permite adicionar a sua certificação a esta identidade.",
      "CERTIFY_RULES": "<b>Atenção:</b> Certifique somente <b>seres humanos físicos vivos</b>, que não possuam nenhuma outra conta membro.<br/><br/>A segurança da rede da moeda depende do cuidado de cada individuo/a!",
      "MENU_BTN_SETTINGS": "Em <b>{{'MENU.SETTINGS'|translate}}</b> poderá configurar a aplicação.",
      "HEADER_BAR_BTN_PROFILE": "Faça clique aqui para aceder ao seu <b>perfil</b>",
      "SETTINGS_CHANGE_UNIT": "Poderá <b>alterar a unidade de visualização</b> das quantias fazendo clique aqui.<br/><br/>- Desative a opção para mostrar as quantias em {{currency|capitalize}}.<br/>- Ative para quantias relativas ao {{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub> (as quantidades de quantias serão mostradas <b>divididos</b> entre o Dividendo Universal atual).",
      "END_LOGIN": "A visita guiada <b>terminou</b>!<br/><br/>¡Boa sorte neste novo mundo da <b>economia livre</b> !",
      "END_NOT_LOGIN": "A visita guiada <b>terminou</b>!<br/><br/>Se quer utilizar a moeda {{currency|capitalize}}, tem que fazer clique em <b>{{'LOGIN.CREATE_ACCOUNT'|translate}}</b> mais abaixo."
    }
  }
}
);
}]);
